(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 34406:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 8417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ emotion_cache_browser_esm; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'

;// CONCATENATED MODULE: ./node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset:
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? children[0].children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (createCache);


/***/ }),

/***/ 45042:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (memoize);


/***/ }),

/***/ 91683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ ThemeContext; },
  "a": function() { return /* binding */ ThemeProvider; },
  "w": function() { return /* binding */ withEmotionCache; }
});

// UNUSED EXPORTS: C, E, _, b, c, h, u

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(8417);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@emotion/weak-memoize/dist/emotion-weak-memoize.esm.js
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* harmony default export */ var emotion_weak_memoize_esm = (weakMemoize);

// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 2 modules
var emotion_serialize_browser_esm = __webpack_require__(48137);
// EXTERNAL MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(27278);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js









var emotion_element_6a883da9_browser_esm_hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,emotion_cache_browser_esm/* default */.Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */(0,react.createContext)({});

if (false) {}

var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return (0,esm_extends/* default */.Z)({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */emotion_weak_memoize_esm(function (outerTheme) {
  return emotion_weak_memoize_esm(function (theme) {
    return getTheme(outerTheme, theme);
  });
});
var ThemeProvider = function ThemeProvider(props) {
  var theme = (0,react.useContext)(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/(0,react.createElement)(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = useContext(ThemeContext);
    return /*#__PURE__*/createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_6a883da9_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, useContext(ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_6a883da9_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/createElement(WrappedComponent, newProps));
})));

if (false) {}




/***/ }),

/***/ 70917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "xB": function() { return /* binding */ Global; }
/* harmony export */ });
/* unused harmony exports ClassNames, createElement, css, jsx */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8417);
/* harmony import */ var _emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91683);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70444);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48137);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27278);












var pkg = {
	name: "@emotion/react",
	version: "11.10.5",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": "./macro.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.10.5",
		"@emotion/cache": "^11.10.5",
		"@emotion/serialize": "^1.1.1",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
		"@emotion/utils": "^1.2.0",
		"@emotion/weak-memoize": "^0.3.0",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.18.5",
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.10.5",
		"@emotion/css-prettifier": "1.1.1",
		"@emotion/server": "11.10.0",
		"@emotion/styled": "11.10.5",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": "./macro.js"
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(0,_emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.w)(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_3__/* .serializeStyles */ .O)([styles], undefined, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.T));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_4__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_4__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .insertStyles */ .My)(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_3__/* .serializeStyles */ .O)(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));

if (false) {}

if (false) { var globalKey, globalContext, isTestEnv, isBrowser; }




/***/ }),

/***/ 48137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var emotion_hash_esm = (murmur2);

;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var emotion_unitless_esm = (unitlessKeys);

// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(45042);
;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (emotion_unitless_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = emotion_hash_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 27278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useInsertionEffectAlwaysWithSyncFallback; },
/* harmony export */   "j": function() { return /* binding */ useInsertionEffectWithLayoutFallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback =  useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;




/***/ }),

/***/ 70444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ insertStyles; },
/* harmony export */   "fp": function() { return /* binding */ getRegisteredStyles; },
/* harmony export */   "hC": function() { return /* binding */ registerStyles; }
/* harmony export */ });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 35082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KK": function() { return /* binding */ useFocus; },
/* harmony export */   "NI": function() { return /* binding */ useInteractions; },
/* harmony export */   "Qu": function() { return /* binding */ useDelayGroup; },
/* harmony export */   "XI": function() { return /* binding */ useHover; },
/* harmony export */   "YF": function() { return /* binding */ useFloating; },
/* harmony export */   "bQ": function() { return /* binding */ useDismiss; },
/* harmony export */   "e0": function() { return /* binding */ FloatingDelayGroup; },
/* harmony export */   "qs": function() { return /* binding */ useRole; },
/* harmony export */   "tj": function() { return /* binding */ useDelayGroupContext; }
/* harmony export */ });
/* unused harmony exports FloatingFocusManager, FloatingNode, FloatingOverlay, FloatingPortal, FloatingTree, inner, safePolygon, useClick, useFloatingNodeId, useFloatingParentNodeId, useFloatingPortalNode, useFloatingTree, useId, useInnerOffset, useListNavigation, useTypeahead */
/* harmony import */ var _floating_ui_react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58463);
/* harmony import */ var _floating_ui_react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55863);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);







var index = typeof document !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;

function createPubSub() {
  const map = new Map();
  return {
    emit(event, data) {
      var _map$get;

      (_map$get = map.get(event)) == null ? void 0 : _map$get.forEach(handler => handler(data));
    },

    on(event, listener) {
      map.set(event, [...(map.get(event) || []), listener]);
    },

    off(event, listener) {
      map.set(event, (map.get(event) || []).filter(l => l !== listener));
    }

  };
}

let serverHandoffComplete = false;
let count = 0;

const genId = () => "floating-ui-" + count++;

function useFloatingId() {
  const [id, setId] = react__WEBPACK_IMPORTED_MODULE_0__.useState(() => serverHandoffComplete ? genId() : undefined);
  index(() => {
    if (id == null) {
      setId(genId());
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!serverHandoffComplete) {
      serverHandoffComplete = true;
    }
  }, []);
  return id;
} // `toString()` prevents bundlers from trying to `import { useId } from 'react'`


const useReactId = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))[/*#__PURE__*/'useId'.toString()];
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/useId
 */

const useId = useReactId != null ? useReactId : useFloatingId;

const FloatingNodeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
const FloatingTreeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext$id, _React$useContext;

  return (_React$useContext$id = (_React$useContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) != null ? _React$useContext$id : null;
};
const useFloatingTree = () => react__WEBPACK_IMPORTED_MODULE_0__.useContext(FloatingTreeContext);
/**
 * Registers a node into the floating tree, returning its id.
 */

const useFloatingNodeId = () => {
  const id = useId();
  const tree = useFloatingTree();
  const parentId = useFloatingParentNodeId();
  index(() => {
    const node = {
      id,
      parentId
    };
    tree == null ? void 0 : tree.addNode(node);
    return () => {
      tree == null ? void 0 : tree.removeNode(node);
    };
  }, [tree, id, parentId]);
  return id;
};
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */

const FloatingNode = _ref => {
  let {
    children,
    id
  } = _ref;
  const parentId = useFloatingParentNodeId();
  return /*#__PURE__*/React.createElement(FloatingNodeContext.Provider, {
    value: React.useMemo(() => ({
      id,
      parentId
    }), [id, parentId])
  }, children);
};
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM (i.e. portalled to a common node, rather than their
 * respective parent).
 * @see https://floating-ui.com/docs/FloatingTree
 */

const FloatingTree = _ref2 => {
  let {
    children
  } = _ref2;
  const nodesRef = React.useRef([]);
  const addNode = React.useCallback(node => {
    nodesRef.current = [...nodesRef.current, node];
  }, []);
  const removeNode = React.useCallback(node => {
    nodesRef.current = nodesRef.current.filter(n => n !== node);
  }, []);
  const events = React.useState(() => createPubSub())[0];
  return /*#__PURE__*/React.createElement(FloatingTreeContext.Provider, {
    value: React.useMemo(() => ({
      nodesRef,
      addNode,
      removeNode,
      events
    }), [nodesRef, addNode, removeNode, events])
  }, children);
};

function getDocument(floating) {
  var _floating$ownerDocume;

  return (_floating$ownerDocume = floating == null ? void 0 : floating.ownerDocument) != null ? _floating$ownerDocume : document;
}

function getWindow(value) {
  var _getDocument$defaultV;

  return (_getDocument$defaultV = getDocument(value).defaultView) != null ? _getDocument$defaultV : window;
}

function isElement(value) {
  return value ? value instanceof getWindow(value).Element : false;
}
function isHTMLElement(value) {
  return value ? value instanceof getWindow(value).HTMLElement : false;
}

// `toString()` prevents bundlers from trying to `import { useInsertionEffect } from 'react'`
const useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))[/*#__PURE__*/'useInsertionEffect'.toString()];
function useEvent(callback) {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(() => {
    if (false) {}
  });

  if (useInsertionEffect) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useInsertionEffect(() => {
      ref.current = callback;
    });
  } else {
    ref.current = callback;
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}

function useFloating(_temp) {
  let {
    open = false,
    onOpenChange: unstable_onOpenChange,
    whileElementsMounted,
    placement,
    middleware,
    strategy,
    nodeId
  } = _temp === void 0 ? {} : _temp;
  const [domReference, setDomReference] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const tree = useFloatingTree();
  const domReferenceRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const dataRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef({});
  const events = react__WEBPACK_IMPORTED_MODULE_0__.useState(() => createPubSub())[0];
  const position = (0,_floating_ui_react_dom__WEBPACK_IMPORTED_MODULE_2__/* .useFloating */ .YF)({
    placement,
    middleware,
    strategy,
    whileElementsMounted
  });
  const onOpenChange = useEvent(unstable_onOpenChange);
  const refs = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({ ...position.refs,
    domReference: domReferenceRef
  }), [position.refs]);
  const context = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({ ...position,
    refs,
    dataRef,
    nodeId,
    events,
    open,
    onOpenChange,
    _: {
      domReference
    }
  }), [position, nodeId, events, open, onOpenChange, refs, domReference]);
  index(() => {
    const node = tree == null ? void 0 : tree.nodesRef.current.find(node => node.id === nodeId);

    if (node) {
      node.context = context;
    }
  });
  const {
    reference
  } = position;
  const setReference = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(node => {
    if (isElement(node) || node === null) {
      context.refs.domReference.current = node;
      setDomReference(node);
    }

    reference(node);
  }, [reference, context.refs]);
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({ ...position,
    context,
    refs,
    reference: setReference
  }), [position, refs, context, setReference]);
}

function mergeProps(userProps, propsList, elementKey) {
  const map = new Map();
  return { ...(elementKey === 'floating' && {
      tabIndex: -1
    }),
    ...userProps,
    ...propsList.map(value => value ? value[elementKey] : null).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }

      Object.entries(props).forEach(_ref => {
        let [key, value] = _ref;

        if (key.indexOf('on') === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }

          if (typeof value === 'function') {
            var _map$get;

            (_map$get = map.get(key)) == null ? void 0 : _map$get.push(value);

            acc[key] = function () {
              var _map$get2;

              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.forEach(fn => fn(...args));
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}

const useInteractions = function (propsList) {
  if (propsList === void 0) {
    propsList = [];
  }

  // The dependencies are a dynamic array, so we can't use the linter's
  // suggestion to add it to the deps array.
  const deps = propsList;
  const getReferenceProps = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(userProps => mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
  const getFloatingProps = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(userProps => mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
  const getItemProps = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(userProps => mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
};

function getChildren(nodes, id) {
  var _nodes$filter;

  let allChildren = (_nodes$filter = nodes.filter(node => {
    var _node$context;

    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  })) != null ? _nodes$filter : [];
  let currentChildren = allChildren;

  while (currentChildren.length) {
    var _nodes$filter2;

    currentChildren = (_nodes$filter2 = nodes.filter(node => {
      var _currentChildren;

      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some(n => {
        var _node$context2;

        return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    })) != null ? _nodes$filter2 : [];
    allChildren = allChildren.concat(currentChildren);
  }

  return allChildren;
}

function isPointInPolygon(point, polygon) {
  const [x, y] = point;
  let isInside = false;
  const length = polygon.length;

  for (let i = 0, j = length - 1; i < length; j = i++) {
    const [xi, yi] = polygon[i] || [0, 0];
    const [xj, yj] = polygon[j] || [0, 0];
    const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;

    if (intersect) {
      isInside = !isInside;
    }
  }

  return isInside;
}

function safePolygon(_temp) {
  let {
    restMs = 0,
    buffer = 0.5,
    blockPointerEvents = true,
    debug = null
  } = _temp === void 0 ? {} : _temp;
  let timeoutId;
  let polygonIsDestroyed = false;

  const fn = _ref => {
    let {
      x,
      y,
      placement,
      refs,
      onClose,
      nodeId,
      tree,
      leave = false
    } = _ref;
    return function onPointerMove(event) {
      var _refs$domReference$cu, _refs$floating$curren, _refs$floating$curren2;

      clearTimeout(timeoutId);

      function close() {
        clearTimeout(timeoutId);
        onClose();
      }

      if (event.pointerType && event.pointerType !== 'mouse') {
        return;
      }

      const {
        clientX,
        clientY
      } = event;
      const target = 'composedPath' in event ? event.composedPath()[0] : event.target;
      const targetNode = target; // If the pointer is over the reference, there is no need to run the logic

      if (event.type === 'pointermove' && (_refs$domReference$cu = refs.domReference.current) != null && _refs$domReference$cu.contains(targetNode)) {
        return;
      } // Prevent overlapping floating element from being stuck in an open-close
      // loop: https://github.com/floating-ui/floating-ui/issues/1910


      if (event.type === 'mouseleave' && isElement(event.relatedTarget) && (_refs$floating$curren = refs.floating.current) != null && _refs$floating$curren.contains(event.relatedTarget)) {
        return;
      } // If any nested child is open, abort.


      if (tree && getChildren(tree.nodesRef.current, nodeId).some(_ref2 => {
        let {
          context
        } = _ref2;
        return context == null ? void 0 : context.open;
      })) {
        return;
      } // The cursor landed, so we destroy the polygon logic


      if ((_refs$floating$curren2 = refs.floating.current) != null && _refs$floating$curren2.contains(targetNode) && !leave) {
        polygonIsDestroyed = true;
        return;
      }

      if (!refs.domReference.current || !refs.floating.current || placement == null || x == null || y == null) {
        return;
      }

      const refRect = refs.domReference.current.getBoundingClientRect();
      const rect = refs.floating.current.getBoundingClientRect();
      const side = placement.split('-')[0];
      const cursorLeaveFromRight = x > rect.right - rect.width / 2;
      const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2; // If the pointer is leaving from the opposite side, the "buffer" logic
      // creates a point where the floating element remains open, but should be
      // ignored.
      // A constant of 1 handles floating point rounding errors.

      if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) {
        return close();
      } // Ignore when the cursor is within the rectangular trough between the
      // two elements. Since the triangle is created from the cursor point,
      // which can start beyond the ref element's edge, traversing back and
      // forth from the ref to the floating element can cause it to close. This
      // ensures it always remains open in that case.


      switch (side) {
        case 'top':
          if (clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= refRect.top + 1) {
            return;
          }

          break;

        case 'bottom':
          if (clientX >= rect.left && clientX <= rect.right && clientY >= refRect.bottom - 1 && clientY <= rect.bottom) {
            return;
          }

          break;

        case 'left':
          if (clientX >= rect.left && clientX <= refRect.left + 1 && clientY >= rect.top && clientY <= rect.bottom) {
            return;
          }

          break;

        case 'right':
          if (clientX >= refRect.right - 1 && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom) {
            return;
          }

          break;
      }

      if (polygonIsDestroyed) {
        return close();
      }

      function getPolygon(_ref3) {
        let [x, y] = _ref3;
        const isFloatingWider = rect.width > refRect.width;
        const isFloatingTaller = rect.height > refRect.height;

        switch (side) {
          case 'top':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }

          case 'bottom':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }

          case 'left':
            {
              const cursorPointOne = [x + buffer + 1, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x + buffer + 1, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer, rect.bottom]];
              return [...commonPoints, cursorPointOne, cursorPointTwo];
            }

          case 'right':
            {
              const cursorPointOne = [x - buffer, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x - buffer, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer, rect.bottom]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
        }
      }

      const poly = getPolygon([x, y]);

      if (false) {}

      if (!isPointInPolygon([clientX, clientY], poly)) {
        close();
      } else if (restMs) {
        timeoutId = setTimeout(onClose, restMs);
      }
    };
  };

  fn.__options = {
    blockPointerEvents
  };
  return fn;
}

const DEFAULT_ID = 'floating-ui-root';
const useFloatingPortalNode = function (_temp) {
  let {
    id = DEFAULT_ID,
    enabled = true
  } = _temp === void 0 ? {} : _temp;
  const [portalEl, setPortalEl] = React.useState(null);
  index(() => {
    if (!enabled) {
      return;
    }

    const rootNode = document.getElementById(id);

    if (rootNode) {
      setPortalEl(rootNode);
    } else {
      const newPortalEl = document.createElement('div');
      newPortalEl.id = id;
      setPortalEl(newPortalEl);

      if (!document.body.contains(newPortalEl)) {
        document.body.appendChild(newPortalEl);
      }
    }
  }, [id, enabled]);
  return portalEl;
};
/**
 * Portals your floating element outside of the main app node.
 * @see https://floating-ui.com/docs/FloatingPortal
 */

const FloatingPortal = _ref => {
  let {
    children,
    id = DEFAULT_ID,
    root = null
  } = _ref;
  const portalNode = useFloatingPortalNode({
    id,
    enabled: !root
  });

  if (root) {
    return /*#__PURE__*/createPortal(children, root);
  }

  if (portalNode) {
    return /*#__PURE__*/createPortal(children, portalNode);
  }

  return null;
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

// Avoid Chrome DevTools blue warning
function getPlatform() {
  const uaData = navigator.userAgentData;

  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }

  return navigator.platform;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands) {
    return uaData.brands.map(_ref => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(' ');
  }

  return navigator.userAgent;
}

const identifier = 'data-floating-ui-scroll-lock';
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */

const FloatingOverlay = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function FloatingOverlay(_ref, ref) {
  let {
    lockScroll = false,
    ...rest
  } = _ref;
  index(() => {
    var _window$visualViewpor, _window$visualViewpor2, _window$visualViewpor3, _window$visualViewpor4;

    if (!lockScroll) {
      return;
    }

    const alreadyLocked = document.body.hasAttribute(identifier);

    if (alreadyLocked) {
      return;
    }

    document.body.setAttribute(identifier, ''); // RTL <body> scrollbar

    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth; // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.

    if (!/iP(hone|ad|od)|iOS/.test(getPlatform())) {
      Object.assign(document.body.style, {
        overflow: 'hidden',
        [paddingProp]: scrollbarWidth + "px"
      });
      return () => {
        document.body.removeAttribute(identifier);
        Object.assign(document.body.style, {
          overflow: '',
          [paddingProp]: ''
        });
      };
    } // iOS 12 does not support `visuaViewport`.


    const offsetLeft = (_window$visualViewpor = (_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetLeft) != null ? _window$visualViewpor : 0;
    const offsetTop = (_window$visualViewpor3 = (_window$visualViewpor4 = window.visualViewport) == null ? void 0 : _window$visualViewpor4.offsetTop) != null ? _window$visualViewpor3 : 0;
    const scrollX = window.pageXOffset;
    const scrollY = window.pageYOffset;
    Object.assign(document.body.style, {
      position: 'fixed',
      overflow: 'hidden',
      top: -(scrollY - Math.floor(offsetTop)) + "px",
      left: -(scrollX - Math.floor(offsetLeft)) + "px",
      right: '0',
      [paddingProp]: scrollbarWidth + "px"
    });
    return () => {
      Object.assign(document.body.style, {
        position: '',
        overflow: '',
        top: '',
        left: '',
        right: '',
        [paddingProp]: ''
      });
      document.body.removeAttribute(identifier);
      window.scrollTo(scrollX, scrollY);
    };
  }, [lockScroll]);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, rest, {
    style: {
      position: 'fixed',
      overflow: 'auto',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...rest.style
    }
  }));
})));

/**
 * Find the real active element. Traverses into shadowRoots.
 */
function activeElement(doc) {
  let activeElement = doc.activeElement;

  while (((_activeElement = activeElement) == null ? void 0 : (_activeElement$shadow = _activeElement.shadowRoot) == null ? void 0 : _activeElement$shadow.activeElement) != null) {
    var _activeElement, _activeElement$shadow;

    activeElement = activeElement.shadowRoot.activeElement;
  }

  return activeElement;
}

function getAncestors(nodes, id) {
  var _nodes$find;

  let allAncestors = [];
  let currentParentId = (_nodes$find = nodes.find(node => node.id === id)) == null ? void 0 : _nodes$find.parentId;

  while (currentParentId) {
    const currentNode = nodes.find(node => node.id === currentParentId);
    currentParentId = currentNode == null ? void 0 : currentNode.parentId;

    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }

  return allAncestors;
}

function getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  } // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.


  return event.target;
}

const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled])," + "[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(element) {
  return isHTMLElement(element) && element.matches(TYPEABLE_SELECTOR);
}

function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}

function useLatestRef(value) {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

function focus(el, preventScroll) {
  if (preventScroll === void 0) {
    preventScroll = false;
  }

  // `mousedown` clicks occur before `focus`, so the button will steal the
  // focus unless we wait a frame.
  requestAnimationFrame(() => {
    el == null ? void 0 : el.focus({
      preventScroll
    });
  });
}

const SELECTOR = 'select:not([disabled]),a[href],button:not([disabled]),[tabindex],' + 'iframe,object,embed,area[href],audio[controls],video[controls],' + TYPEABLE_SELECTOR;
const FocusGuard = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function FocusGuard(props, ref) {
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    ref: ref,
    tabIndex: 0,
    style: {
      position: 'fixed',
      opacity: '0',
      pointerEvents: 'none',
      outline: '0'
    }
  }));
})));

/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */
function FloatingFocusManager(_ref) {
  let {
    context: {
      refs,
      nodeId,
      onOpenChange,
      dataRef,
      events
    },
    children,
    order = ['content'],
    endGuard = true,
    initialFocus = 0,
    returnFocus = true,
    modal = true
  } = _ref;
  const orderRef = useLatestRef(order);
  const tree = useFloatingTree();
  const getTabbableElements = React.useCallback(() => {
    return orderRef.current.map(type => {
      if (type === 'reference') {
        return refs.domReference.current;
      }

      if (refs.floating.current && type === 'floating') {
        return refs.floating.current;
      }

      if (type === 'content') {
        var _refs$floating$curren, _refs$floating$curren2;

        return Array.from((_refs$floating$curren = (_refs$floating$curren2 = refs.floating.current) == null ? void 0 : _refs$floating$curren2.querySelectorAll(SELECTOR)) != null ? _refs$floating$curren : []);
      }

      return null;
    }).flat().filter(el => {
      if (el === refs.floating.current || el === refs.domReference.current) {
        return true;
      }

      if (isHTMLElement(el)) {
        var _el$getAttribute;

        const tabIndex = (_el$getAttribute = el.getAttribute('tabindex')) != null ? _el$getAttribute : '0';
        return tabIndex[0].trim() !== '-';
      }
    });
  }, [orderRef, refs]);
  React.useEffect(() => {
    if (!modal) {
      return;
    } // If the floating element has no focusable elements inside it, fallback
    // to focusing the floating element and preventing tab navigation


    const noTabbableContentElements = getTabbableElements().filter(el => el !== refs.floating.current && el !== refs.domReference.current).length === 0;

    function onKeyDown(event) {
      if (event.key === 'Tab') {
        if (noTabbableContentElements) {
          stopEvent(event);
        }

        const els = getTabbableElements();
        const target = getTarget(event);

        if (orderRef.current[0] === 'reference' && target === refs.domReference.current) {
          stopEvent(event);

          if (event.shiftKey) {
            focus(els[els.length - 1]);
          } else {
            focus(els[1]);
          }
        }

        if (orderRef.current[1] === 'floating' && target === refs.floating.current && event.shiftKey) {
          stopEvent(event);
          focus(els[0]);
        }
      }
    }

    const doc = getDocument(refs.floating.current);
    doc.addEventListener('keydown', onKeyDown);
    return () => {
      doc.removeEventListener('keydown', onKeyDown);
    };
  }, [modal, getTabbableElements, orderRef, refs]);
  React.useEffect(() => {
    let isPointerDown = false;

    function onFocusOut(event) {
      var _refs$floating$curren3, _getAncestors;

      const relatedTarget = event.relatedTarget;
      const focusMovedOutsideFloating = !((_refs$floating$curren3 = refs.floating.current) != null && _refs$floating$curren3.contains(relatedTarget));
      const focusMovedOutsideReference = isElement(refs.domReference.current) && !refs.domReference.current.contains(relatedTarget);
      const isChildOpen = tree && getChildren(tree.nodesRef.current, nodeId).length > 0;
      const isParentRelated = tree && event.currentTarget === refs.domReference.current && ((_getAncestors = getAncestors(tree.nodesRef.current, nodeId)) == null ? void 0 : _getAncestors.some(node => {
        var _node$context, _node$context$refs$fl;

        return (_node$context = node.context) == null ? void 0 : (_node$context$refs$fl = _node$context.refs.floating.current) == null ? void 0 : _node$context$refs$fl.contains(relatedTarget);
      }));

      if (focusMovedOutsideFloating && focusMovedOutsideReference && !isChildOpen && !isParentRelated && !isPointerDown) {
        onOpenChange(false);
      }
    }

    function onPointerDown() {
      // In Safari, buttons *lose* focus when pressing them. This causes the
      // reference `focusout` to fire, which closes the floating element.
      isPointerDown = true;
      setTimeout(() => {
        isPointerDown = false;
      });
    }

    const floating = refs.floating.current;
    const reference = refs.domReference.current;

    if (floating && isHTMLElement(reference)) {
      if (!modal) {
        floating.addEventListener('focusout', onFocusOut);
        reference.addEventListener('focusout', onFocusOut);
        reference.addEventListener('pointerdown', onPointerDown);
      }

      let cleanup;

      if (modal) {
        if (orderRef.current.includes('reference')) {
          cleanup = hideOthers([reference, floating]);
        } else {
          cleanup = hideOthers(floating);
        }
      }

      return () => {
        if (!modal) {
          floating.removeEventListener('focusout', onFocusOut);
          reference.removeEventListener('focusout', onFocusOut);
          reference.removeEventListener('pointerdown', onPointerDown);
        }

        cleanup == null ? void 0 : cleanup();
      };
    }
  }, [nodeId, tree, modal, onOpenChange, orderRef, dataRef, getTabbableElements, refs]);
  React.useEffect(() => {
    const floating = refs.floating.current;
    const doc = getDocument(floating);
    let returnFocusValue = returnFocus;
    let preventReturnFocusScroll = false;
    let previouslyFocusedElement = activeElement(doc);

    if (previouslyFocusedElement === doc.body && refs.domReference.current) {
      previouslyFocusedElement = refs.domReference.current;
    }

    if (typeof initialFocus === 'number') {
      var _getTabbableElements$;

      const el = (_getTabbableElements$ = getTabbableElements()[initialFocus]) != null ? _getTabbableElements$ : floating;
      focus(el, el === floating);
    } else if (isHTMLElement(initialFocus.current)) {
      var _initialFocus$current;

      const el = (_initialFocus$current = initialFocus.current) != null ? _initialFocus$current : floating;
      focus(el, el === floating);
    } // Dismissing via outside press should always ignore `returnFocus` to
    // prevent unwanted scrolling.


    function onDismiss(allowReturnFocus) {
      if (allowReturnFocus === void 0) {
        allowReturnFocus = false;
      }

      if (typeof allowReturnFocus === 'object') {
        returnFocusValue = true;
        preventReturnFocusScroll = allowReturnFocus.preventScroll;
      } else {
        returnFocusValue = allowReturnFocus;
      }
    }

    events.on('dismiss', onDismiss);
    return () => {
      events.off('dismiss', onDismiss);

      if (returnFocusValue && isHTMLElement(previouslyFocusedElement)) {
        focus(previouslyFocusedElement, preventReturnFocusScroll);
      }
    };
  }, [getTabbableElements, initialFocus, returnFocus, refs, events]);

  const isTypeableCombobox = () => {
    var _refs$domReference$cu;

    return ((_refs$domReference$cu = refs.domReference.current) == null ? void 0 : _refs$domReference$cu.getAttribute('role')) === 'combobox' && isTypeableElement(refs.domReference.current);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, modal && /*#__PURE__*/React.createElement(FocusGuard, {
    onFocus: event => {
      if (isTypeableCombobox()) {
        return;
      }

      stopEvent(event);
      const els = getTabbableElements();

      if (order[0] === 'reference') {
        focus(els[0]);
      } else {
        focus(els[els.length - 1]);
      }
    }
  }), /*#__PURE__*/React.cloneElement(children, order.includes('floating') ? {
    tabIndex: 0
  } : {}), modal && endGuard && /*#__PURE__*/React.createElement(FocusGuard, {
    onFocus: event => {
      if (isTypeableCombobox()) {
        return;
      }

      stopEvent(event);
      focus(getTabbableElements()[0]);
    }
  }));
}

function usePrevious(value) {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  index(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

function getDelay(value, prop, pointerType) {
  if (pointerType && pointerType !== 'mouse') {
    return 0;
  }

  if (typeof value === 'number') {
    return value;
  }

  return value == null ? void 0 : value[prop];
}

/**
 * Adds hover event listeners that change the open state, like CSS :hover.
 * @see https://floating-ui.com/docs/useHover
 */
const useHover = function (context, _temp) {
  let {
    enabled = true,
    delay = 0,
    handleClose = null,
    mouseOnly = false,
    restMs = 0,
    move = true
  } = _temp === void 0 ? {} : _temp;
  const {
    open,
    onOpenChange,
    dataRef,
    events,
    refs,
    _
  } = context;
  const tree = useFloatingTree();
  const parentId = useFloatingParentNodeId();
  const handleCloseRef = useLatestRef(handleClose);
  const delayRef = useLatestRef(delay);
  const previousOpen = usePrevious(open);
  const pointerTypeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const timeoutRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const handlerRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const restTimeoutRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const blockMouseMoveRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(true);
  const performedPointerEventsMutationRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  const isHoverOpen = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    var _dataRef$current$open;

    const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
    return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
  }, [dataRef]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!enabled) {
      return;
    }

    function onDismiss() {
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      blockMouseMoveRef.current = true;
    }

    events.on('dismiss', onDismiss);
    return () => {
      events.off('dismiss', onDismiss);
    };
  }, [enabled, events, refs]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!enabled || !handleCloseRef.current) {
      return;
    }

    function onLeave() {
      if (isHoverOpen()) {
        onOpenChange(false);
      }
    }

    const html = getDocument(refs.floating.current).documentElement;
    html.addEventListener('mouseleave', onLeave);
    return () => {
      html.removeEventListener('mouseleave', onLeave);
    };
  }, [refs, onOpenChange, enabled, handleCloseRef, dataRef, isHoverOpen]);
  const closeWithDelay = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (runElseBranch) {
    if (runElseBranch === void 0) {
      runElseBranch = true;
    }

    const closeDelay = getDelay(delayRef.current, 'close', pointerTypeRef.current);

    if (closeDelay && !handlerRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => onOpenChange(false), closeDelay);
    } else if (runElseBranch) {
      clearTimeout(timeoutRef.current);
      onOpenChange(false);
    }
  }, [delayRef, onOpenChange]);
  const cleanupPointerMoveHandler = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    if (handlerRef.current) {
      getDocument(refs.floating.current).removeEventListener('pointermove', handlerRef.current);
      handlerRef.current = undefined;
    }
  }, [refs]);
  const clearPointerEvents = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    getDocument(refs.floating.current).body.style.pointerEvents = '';
    performedPointerEventsMutationRef.current = false;
  }, [refs]); // Registering the mouse events on the reference directly to bypass React's
  // delegation system. If the cursor was on a disabled element and then entered
  // the reference (no gap), `mouseenter` doesn't fire in the delegation system.

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!enabled) {
      return;
    }

    function isClickLikeOpenEvent() {
      return dataRef.current.openEvent ? ['click', 'mousedown'].includes(dataRef.current.openEvent.type) : false;
    }

    function onMouseEnter(event) {
      clearTimeout(timeoutRef.current);
      blockMouseMoveRef.current = false;

      if (mouseOnly && pointerTypeRef.current !== 'mouse' || restMs > 0 && getDelay(delayRef.current, 'open') === 0) {
        return;
      }

      dataRef.current.openEvent = event;
      const openDelay = getDelay(delayRef.current, 'open', pointerTypeRef.current);

      if (openDelay) {
        timeoutRef.current = setTimeout(() => {
          onOpenChange(true);
        }, openDelay);
      } else {
        onOpenChange(true);
      }
    }

    function onMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        return;
      }

      const doc = getDocument(refs.floating.current);
      clearTimeout(restTimeoutRef.current);

      if (handleCloseRef.current) {
        clearTimeout(timeoutRef.current);
        handlerRef.current && doc.removeEventListener('pointermove', handlerRef.current);
        handlerRef.current = handleCloseRef.current({ ...context,
          tree,
          x: event.clientX,
          y: event.clientY,

          onClose() {
            clearPointerEvents();
            cleanupPointerMoveHandler();
            closeWithDelay();
          }

        });
        doc.addEventListener('pointermove', handlerRef.current);
        return;
      }

      closeWithDelay();
    } // Ensure the floating element closes after scrolling even if the pointer
    // did not move.
    // https://github.com/floating-ui/floating-ui/discussions/1692


    function onScrollMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        return;
      }

      handleCloseRef.current == null ? void 0 : handleCloseRef.current({ ...context,
        tree,
        x: event.clientX,
        y: event.clientY,
        leave: true,

        onClose() {
          clearPointerEvents();
          cleanupPointerMoveHandler();
          closeWithDelay();
        }

      })(event);
    }

    const floating = refs.floating.current;
    const reference = refs.domReference.current;

    if (isElement(reference)) {
      open && reference.addEventListener('mouseleave', onScrollMouseLeave);
      floating == null ? void 0 : floating.addEventListener('mouseleave', onScrollMouseLeave);
      move && reference.addEventListener('mousemove', onMouseEnter, {
        once: true
      });
      reference.addEventListener('mouseenter', onMouseEnter);
      reference.addEventListener('mouseleave', onMouseLeave);
      return () => {
        open && reference.removeEventListener('mouseleave', onScrollMouseLeave);
        floating == null ? void 0 : floating.removeEventListener('mouseleave', onScrollMouseLeave);
        move && reference.removeEventListener('mousemove', onMouseEnter);
        reference.removeEventListener('mouseenter', onMouseEnter);
        reference.removeEventListener('mouseleave', onMouseLeave);
      };
    }
  }, [// Ensure the effect is re-run when the reference changes.
  // https://github.com/floating-ui/floating-ui/issues/1833
  _.domReference, enabled, context, mouseOnly, restMs, move, closeWithDelay, cleanupPointerMoveHandler, clearPointerEvents, onOpenChange, open, tree, refs, delayRef, handleCloseRef, dataRef]); // Block pointer-events of every element other than the reference and floating
  // while the floating element is open and has a `handleClose` handler. Also
  // handles nested floating elements.
  // https://github.com/floating-ui/floating-ui/issues/1722

  index(() => {
    if (!enabled) {
      return;
    }

    if (open && handleCloseRef.current && handleCloseRef.current.__options.blockPointerEvents && isHoverOpen()) {
      getDocument(refs.floating.current).body.style.pointerEvents = 'none';
      performedPointerEventsMutationRef.current = true;
      const reference = refs.domReference.current;
      const floating = refs.floating.current;

      if (isElement(reference) && floating) {
        var _tree$nodesRef$curren, _tree$nodesRef$curren2;

        const parentFloating = tree == null ? void 0 : (_tree$nodesRef$curren = tree.nodesRef.current.find(node => node.id === parentId)) == null ? void 0 : (_tree$nodesRef$curren2 = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren2.refs.floating.current;

        if (parentFloating) {
          parentFloating.style.pointerEvents = '';
        }

        reference.style.pointerEvents = 'auto';
        floating.style.pointerEvents = 'auto';
        return () => {
          reference.style.pointerEvents = '';
          floating.style.pointerEvents = '';
        };
      }
    }
  }, [enabled, open, parentId, refs, tree, handleCloseRef, dataRef, isHoverOpen]);
  index(() => {
    if (previousOpen && !open) {
      pointerTypeRef.current = undefined;
      cleanupPointerMoveHandler();
      clearPointerEvents();
    }
  });
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    return () => {
      cleanupPointerMoveHandler();
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);

      if (performedPointerEventsMutationRef.current) {
        clearPointerEvents();
      }
    };
  }, [enabled, cleanupPointerMoveHandler, clearPointerEvents]);
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (!enabled) {
      return {};
    }

    function setPointerRef(event) {
      pointerTypeRef.current = event.pointerType;
    }

    return {
      reference: {
        onPointerDown: setPointerRef,
        onPointerEnter: setPointerRef,

        onMouseMove() {
          if (open || restMs === 0) {
            return;
          }

          clearTimeout(restTimeoutRef.current);
          restTimeoutRef.current = setTimeout(() => {
            if (!blockMouseMoveRef.current) {
              onOpenChange(true);
            }
          }, restMs);
        }

      },
      floating: {
        onMouseEnter() {
          clearTimeout(timeoutRef.current);
        },

        onMouseLeave() {
          closeWithDelay(false);
        }

      }
    };
  }, [enabled, restMs, open, onOpenChange, closeWithDelay]);
};

const FloatingDelayGroupContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  delay: 1000,
  initialDelay: 1000,
  currentId: null,
  setCurrentId: () => {},
  setState: () => {}
});
const useDelayGroupContext = () => react__WEBPACK_IMPORTED_MODULE_0__.useContext(FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */

const FloatingDelayGroup = _ref => {
  let {
    children,
    delay
  } = _ref;
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    delay,
    initialDelay: delay,
    currentId: null
  });
  const setCurrentId = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(currentId => {
    setState(state => ({ ...state,
      currentId
    }));
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FloatingDelayGroupContext.Provider, {
    value: react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({ ...state,
      setState,
      setCurrentId
    }), [state, setState, setCurrentId])
  }, children);
};
const useDelayGroup = (_ref2, _ref3) => {
  let {
    open,
    onOpenChange
  } = _ref2;
  let {
    id
  } = _ref3;
  const {
    currentId,
    initialDelay,
    setState
  } = useDelayGroupContext();
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (currentId) {
      setState(state => ({ ...state,
        delay: {
          open: 1,
          close: getDelay(initialDelay, 'close')
        }
      }));

      if (currentId !== id) {
        onOpenChange(false);
      }
    }
  }, [id, onOpenChange, setState, currentId, initialDelay]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!open && currentId === id) {
      onOpenChange(false);
      setState(state => ({ ...state,
        delay: initialDelay,
        currentId: null
      }));
    }
  }, [open, setState, currentId, id, onOpenChange, initialDelay]);
};

function getArgsWithCustomFloatingHeight(args, prop) {
  return { ...args,
    rects: { ...args.rects,
      floating: { ...args.rects.floating,
        height: args.elements.floating[prop]
      }
    }
  };
}

const inner = options => ({
  name: 'inner',
  options,

  async fn(middlewareArguments) {
    const {
      listRef,
      overflowRef,
      onFallbackChange,
      offset: innerOffset = 0,
      index = 0,
      minItemsVisible = 4,
      referenceOverflowThreshold = 0,
      ...detectOverflowOptions
    } = options;
    const {
      rects,
      elements: {
        floating
      }
    } = middlewareArguments;
    const item = listRef.current[index];

    if (false) {}

    if (!item) {
      return {};
    }

    const nextArgs = { ...middlewareArguments,
      ...(await offset(-item.offsetTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(middlewareArguments))
    };
    const overflow = await detectOverflow(getArgsWithCustomFloatingHeight(nextArgs, 'scrollHeight'), detectOverflowOptions);
    const refOverflow = await detectOverflow(nextArgs, { ...detectOverflowOptions,
      elementContext: 'reference'
    });
    const diffY = Math.max(0, overflow.top);
    const nextY = nextArgs.y + diffY;
    const maxHeight = Math.max(0, floating.scrollHeight - diffY - Math.max(0, overflow.bottom));
    floating.style.maxHeight = maxHeight + "px";
    floating.scrollTop = diffY; // There is not enough space, fallback to standard anchored positioning

    if (onFallbackChange) {
      if (floating.offsetHeight < item.offsetHeight * Math.min(minItemsVisible, listRef.current.length - 1) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold) {
        flushSync(() => onFallbackChange(true));
      } else {
        flushSync(() => onFallbackChange(false));
      }
    }

    if (overflowRef) {
      overflowRef.current = await detectOverflow(getArgsWithCustomFloatingHeight({ ...nextArgs,
        y: nextY
      }, 'offsetHeight'), detectOverflowOptions);
    }

    return {
      y: nextY
    };
  }

});
const useInnerOffset = (_ref, _ref2) => {
  let {
    open,
    refs
  } = _ref;
  let {
    enabled = true,
    overflowRef,
    onChange: unstable_onChange
  } = _ref2;
  const onChange = useEvent(unstable_onChange);
  const controlledScrollingRef = React.useRef(false);
  const prevScrollTopRef = React.useRef(null);
  const initialOverflowRef = React.useRef(null);
  React.useEffect(() => {
    if (!enabled) {
      return;
    }

    function onWheel(e) {
      if (e.ctrlKey || !el || overflowRef.current == null) {
        return;
      }

      const dY = e.deltaY;
      const isAtTop = overflowRef.current.top >= -0.5;
      const isAtBottom = overflowRef.current.bottom >= -0.5;
      const remainingScroll = el.scrollHeight - el.clientHeight;
      const sign = dY < 0 ? -1 : 1;
      const method = dY < 0 ? 'max' : 'min';

      if (el.scrollHeight <= el.clientHeight) {
        return;
      }

      if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
        e.preventDefault();
        flushSync(() => {
          onChange(d => d + Math[method](dY, remainingScroll * sign));
        });
      } else if (/firefox/i.test(getUserAgent())) {
        // Needed to propagate scrolling during momentum scrolling phase once
        // it gets limited by the boundary. UX improvement, not critical.
        el.scrollTop += dY;
      }
    }

    const el = refs.floating.current;

    if (open && el) {
      el.addEventListener('wheel', onWheel); // Wait for the position to be ready.

      requestAnimationFrame(() => {
        prevScrollTopRef.current = el.scrollTop;

        if (overflowRef.current != null) {
          initialOverflowRef.current = { ...overflowRef.current
          };
        }
      });
      return () => {
        prevScrollTopRef.current = null;
        initialOverflowRef.current = null;
        el.removeEventListener('wheel', onWheel);
      };
    }
  }, [enabled, open, refs, overflowRef, onChange]);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }

    return {
      floating: {
        onKeyDown() {
          controlledScrollingRef.current = true;
        },

        onWheel() {
          controlledScrollingRef.current = false;
        },

        onPointerMove() {
          controlledScrollingRef.current = false;
        },

        onScroll() {
          const el = refs.floating.current;

          if (!overflowRef.current || !el || !controlledScrollingRef.current) {
            return;
          }

          if (prevScrollTopRef.current !== null) {
            const scrollDiff = el.scrollTop - prevScrollTopRef.current;

            if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) {
              flushSync(() => onChange(d => d + scrollDiff));
            }
          } // [Firefox] Wait for the height change to have been applied.


          requestAnimationFrame(() => {
            prevScrollTopRef.current = el.scrollTop;
          });
        }

      }
    };
  }, [enabled, overflowRef, refs, onChange]);
};

/**
 * Adds relevant screen reader props for a given element `role`.
 * @see https://floating-ui.com/docs/useRole
 */
const useRole = function (_ref, _temp) {
  let {
    open
  } = _ref;
  let {
    enabled = true,
    role = 'dialog'
  } = _temp === void 0 ? {} : _temp;
  const rootId = useId();
  const referenceId = useId();
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    const floatingProps = {
      id: rootId,
      role
    };

    if (!enabled) {
      return {};
    }

    if (role === 'tooltip') {
      return {
        reference: {
          'aria-describedby': open ? rootId : undefined
        },
        floating: floatingProps
      };
    }

    return {
      reference: {
        'aria-expanded': open ? 'true' : 'false',
        'aria-haspopup': role === 'alertdialog' ? 'dialog' : role,
        'aria-controls': open ? rootId : undefined,
        ...(role === 'listbox' && {
          role: 'combobox'
        }),
        ...(role === 'menu' && {
          id: referenceId
        })
      },
      floating: { ...floatingProps,
        ...(role === 'menu' && {
          'aria-labelledby': referenceId
        })
      }
    };
  }, [enabled, role, open, rootId, referenceId]);
};

function isButtonTarget(event) {
  return isHTMLElement(event.target) && event.target.tagName === 'BUTTON';
}

function isSpaceIgnored(element) {
  return isTypeableElement(element);
}

/**
 * Adds click event listeners that change the open state.
 * @see https://floating-ui.com/docs/useClick
 */
const useClick = function (_ref, _temp) {
  let {
    open,
    onOpenChange,
    dataRef,
    refs
  } = _ref;
  let {
    enabled = true,
    event: eventOption = 'click',
    toggle = true,
    ignoreMouse = false,
    keyboardHandlers = true
  } = _temp === void 0 ? {} : _temp;
  const pointerTypeRef = React.useRef();
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }

    return {
      reference: {
        onPointerDown(event) {
          pointerTypeRef.current = event.pointerType;
        },

        onMouseDown(event) {
          // Ignore all buttons except for the "main" button.
          // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
          if (event.button !== 0) {
            return;
          }

          if (pointerTypeRef.current === 'mouse' && ignoreMouse) {
            return;
          }

          if (eventOption === 'click') {
            return;
          }

          if (open) {
            if (toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'mousedown' : true)) {
              onOpenChange(false);
            }
          } else {
            onOpenChange(true);
          }

          dataRef.current.openEvent = event.nativeEvent;
        },

        onClick(event) {
          if (eventOption === 'mousedown' && pointerTypeRef.current) {
            pointerTypeRef.current = undefined;
            return;
          }

          if (pointerTypeRef.current === 'mouse' && ignoreMouse) {
            return;
          }

          if (open) {
            if (toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'click' : true)) {
              onOpenChange(false);
            }
          } else {
            onOpenChange(true);
          }

          dataRef.current.openEvent = event.nativeEvent;
        },

        onKeyDown(event) {
          pointerTypeRef.current = undefined;

          if (!keyboardHandlers) {
            return;
          }

          if (isButtonTarget(event)) {
            return;
          }

          if (event.key === ' ' && !isSpaceIgnored(refs.domReference.current)) {
            // Prvent scrolling
            event.preventDefault();
          }

          if (event.key === 'Enter') {
            if (open) {
              if (toggle) {
                onOpenChange(false);
              }
            } else {
              onOpenChange(true);
            }
          }
        },

        onKeyUp(event) {
          if (!keyboardHandlers) {
            return;
          }

          if (isButtonTarget(event) || isSpaceIgnored(refs.domReference.current)) {
            return;
          }

          if (event.key === ' ') {
            if (open) {
              if (toggle) {
                onOpenChange(false);
              }
            } else {
              onOpenChange(true);
            }
          }
        }

      }
    };
  }, [enabled, dataRef, eventOption, ignoreMouse, keyboardHandlers, refs, toggle, open, onOpenChange]);
};

/**
 * Check whether the event.target is within the provided node. Uses event.composedPath if available for custom element support.
 *
 * @param event The event whose target/composedPath to check
 * @param node The node to check against
 * @returns Whether the event.target/composedPath is within the node.
 */
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }

  if ('composedPath' in event) {
    return event.composedPath().includes(node);
  } // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't


  const e = event;
  return e.target != null && node.contains(e.target);
}

const bubbleHandlerKeys = {
  pointerdown: 'onPointerDown',
  mousedown: 'onMouseDown',
  click: 'onClick'
};
const captureHandlerKeys = {
  pointerdown: 'onPointerDownCapture',
  mousedown: 'onMouseDownCapture',
  click: 'onClickCapture'
};

/**
 * Adds listeners that dismiss (close) the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */
const useDismiss = function (_ref, _temp) {
  let {
    open,
    onOpenChange,
    refs,
    events,
    nodeId
  } = _ref;
  let {
    enabled = true,
    escapeKey = true,
    outsidePress = true,
    outsidePressEvent = 'pointerdown',
    referencePress = false,
    referencePressEvent = 'pointerdown',
    ancestorScroll = false,
    bubbles = true
  } = _temp === void 0 ? {} : _temp;
  const tree = useFloatingTree();
  const nested = useFloatingParentNodeId() != null;
  const insideReactTreeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!open || !enabled) {
      return;
    }

    function onKeyDown(event) {
      if (event.key === 'Escape') {
        if (!bubbles && tree && getChildren(tree.nodesRef.current, nodeId).length > 0) {
          return;
        }

        events.emit('dismiss', {
          preventScroll: false
        });
        onOpenChange(false);
      }
    }

    function onOutsidePress(event) {
      // Given developers can stop the propagation of the synthetic event,
      // we can only be confident with a positive value.
      const insideReactTree = insideReactTreeRef.current;
      insideReactTreeRef.current = false;

      if (insideReactTree) {
        return;
      }

      const target = getTarget(event); // Check if the click occurred on the scrollbar

      if (isElement(target) && refs.floating.current) {
        var _refs$floating$curren;

        const win = (_refs$floating$curren = refs.floating.current.ownerDocument.defaultView) != null ? _refs$floating$curren : window;
        const canScrollX = target.scrollWidth > target.clientWidth;
        const canScrollY = target.scrollHeight > target.clientHeight;
        let xCond = canScrollY && event.offsetX > target.clientWidth; // In some browsers it is possible to change the <body> (or window)
        // scrollbar to the left side, but is very rare and is difficult to
        // check for. Plus, for modal dialogs with backdrops, it is more
        // important that the backdrop is checked but not so much the window.

        if (canScrollY) {
          const isRTL = win.getComputedStyle(target).direction === 'rtl';

          if (isRTL) {
            xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
          }
        }

        if (xCond || canScrollX && event.offsetY > target.clientHeight) {
          return;
        }
      }

      const targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some(node => {
        var _node$context;

        return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.refs.floating.current);
      });

      if (isEventTargetWithin(event, refs.floating.current) || isEventTargetWithin(event, refs.domReference.current) || targetIsInsideChildren) {
        return;
      }

      if (!bubbles && tree && getChildren(tree.nodesRef.current, nodeId).length > 0) {
        return;
      }

      events.emit('dismiss', nested ? {
        preventScroll: true
      } : false);
      onOpenChange(false);
    }

    function onScroll() {
      onOpenChange(false);
    }

    const doc = getDocument(refs.floating.current);
    escapeKey && doc.addEventListener('keydown', onKeyDown);
    outsidePress && doc.addEventListener(outsidePressEvent, onOutsidePress);
    let ancestors = [];

    if (ancestorScroll) {
      if (isElement(refs.domReference.current)) {
        ancestors = (0,_floating_ui_react_dom__WEBPACK_IMPORTED_MODULE_3__/* .getOverflowAncestors */ .Kx)(refs.domReference.current);
      }

      if (isElement(refs.floating.current)) {
        ancestors = ancestors.concat((0,_floating_ui_react_dom__WEBPACK_IMPORTED_MODULE_3__/* .getOverflowAncestors */ .Kx)(refs.floating.current));
      }

      if (!isElement(refs.reference.current) && refs.reference.current && // @ts-expect-error is VirtualElement
      refs.reference.current.contextElement) {
        ancestors = ancestors.concat( // @ts-expect-error is VirtualElement
        (0,_floating_ui_react_dom__WEBPACK_IMPORTED_MODULE_3__/* .getOverflowAncestors */ .Kx)(refs.reference.current.contextElement));
      }
    } // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)


    ancestors = ancestors.filter(ancestor => {
      var _doc$defaultView;

      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach(ancestor => {
      ancestor.addEventListener('scroll', onScroll, {
        passive: true
      });
    });
    return () => {
      escapeKey && doc.removeEventListener('keydown', onKeyDown);
      outsidePress && doc.removeEventListener(outsidePressEvent, onOutsidePress);
      ancestors.forEach(ancestor => {
        ancestor.removeEventListener('scroll', onScroll);
      });
    };
  }, [escapeKey, outsidePress, outsidePressEvent, events, tree, nodeId, open, onOpenChange, ancestorScroll, enabled, bubbles, refs, nested]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (!enabled) {
      return {};
    }

    return {
      reference: {
        [bubbleHandlerKeys[referencePressEvent]]: () => {
          if (referencePress) {
            events.emit('dismiss');
            onOpenChange(false);
          }
        }
      },
      floating: {
        [captureHandlerKeys[outsidePressEvent]]: () => {
          insideReactTreeRef.current = true;
        }
      }
    };
  }, [enabled, events, referencePress, outsidePressEvent, referencePressEvent, onOpenChange]);
};

/**
 * Adds focus event listeners that change the open state, like CSS :focus.
 * @see https://floating-ui.com/docs/useFocus
 */
const useFocus = function (_ref, _temp) {
  let {
    open,
    onOpenChange,
    dataRef,
    refs,
    events
  } = _ref;
  let {
    enabled = true,
    keyboardOnly = true
  } = _temp === void 0 ? {} : _temp;
  const pointerTypeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef('');
  const blockFocusRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  const timeoutRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    var _doc$defaultView;

    if (!enabled) {
      return;
    }

    const doc = getDocument(refs.floating.current);
    const win = (_doc$defaultView = doc.defaultView) != null ? _doc$defaultView : window;

    function onBlur() {
      if (!open && isHTMLElement(refs.domReference.current)) {
        refs.domReference.current.blur();
      }
    }

    win.addEventListener('blur', onBlur);
    return () => {
      win.removeEventListener('blur', onBlur);
    };
  }, [refs, open, enabled]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!enabled) {
      return;
    }

    function onDismiss() {
      blockFocusRef.current = true;
    }

    events.on('dismiss', onDismiss);
    return () => {
      events.off('dismiss', onDismiss);
    };
  }, [events, enabled]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (!enabled) {
      return {};
    }

    return {
      reference: {
        onPointerDown(_ref2) {
          let {
            pointerType
          } = _ref2;
          pointerTypeRef.current = pointerType;
          blockFocusRef.current = !!(pointerType && keyboardOnly);
        },

        onPointerLeave() {
          blockFocusRef.current = false;
        },

        onFocus(event) {
          var _dataRef$current$open, _refs$domReference$cu, _dataRef$current$open2;

          if (blockFocusRef.current) {
            return;
          } // Dismiss with click should ignore the subsequent `focus` trigger, but
          // only if the click originated inside the reference element.


          if (event.type === 'focus' && ((_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type) === 'mousedown' && (_refs$domReference$cu = refs.domReference.current) != null && _refs$domReference$cu.contains((_dataRef$current$open2 = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open2.target)) {
            return;
          }

          dataRef.current.openEvent = event.nativeEvent;
          onOpenChange(true);
        },

        onBlur(event) {
          const target = event.relatedTarget; // Wait for the window blur listener to fire.

          timeoutRef.current = setTimeout(() => {
            var _refs$floating$curren, _refs$domReference$cu2;

            // When focusing the reference element (e.g. regular click), then
            // clicking into the floating element, prevent it from hiding.
            // Note: it must be focusable, e.g. `tabindex="-1"`.
            if ((_refs$floating$curren = refs.floating.current) != null && _refs$floating$curren.contains(target) || (_refs$domReference$cu2 = refs.domReference.current) != null && _refs$domReference$cu2.contains(target)) {
              return;
            }

            blockFocusRef.current = false;
            onOpenChange(false);
          });
        }

      }
    };
  }, [enabled, keyboardOnly, refs, dataRef, onOpenChange]);
};

const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';

function isDifferentRow(index, cols, prevRow) {
  return Math.floor(index / cols) !== prevRow;
}

function isIndexOutOfBounds(listRef, index) {
  return index < 0 || index >= listRef.current.length;
}

function findNonDisabledIndex(listRef, _temp) {
  let {
    startingIndex = -1,
    decrement = false,
    disabledIndices,
    amount = 1
  } = _temp === void 0 ? {} : _temp;
  const list = listRef.current;
  let index = startingIndex;

  do {
    var _list$index, _list$index2;

    index = index + (decrement ? -amount : amount);
  } while (index >= 0 && index <= list.length - 1 && (disabledIndices ? disabledIndices.includes(index) : list[index] == null || ((_list$index = list[index]) == null ? void 0 : _list$index.hasAttribute('disabled')) || ((_list$index2 = list[index]) == null ? void 0 : _list$index2.getAttribute('aria-disabled')) === 'true'));

  return index;
}

function doSwitch(orientation, vertical, horizontal) {
  switch (orientation) {
    case 'vertical':
      return vertical;

    case 'horizontal':
      return horizontal;

    default:
      return vertical || horizontal;
  }
}

function isMainOrientationKey(key, orientation) {
  const vertical = key === ARROW_UP || key === ARROW_DOWN;
  const horizontal = key === ARROW_LEFT || key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal);
}

function isMainOrientationToEndKey(key, orientation, rtl) {
  const vertical = key === ARROW_DOWN;
  const horizontal = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key == ' ' || key === '';
}

function isCrossOrientationOpenKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  const horizontal = key === ARROW_DOWN;
  return doSwitch(orientation, vertical, horizontal);
}

function isCrossOrientationCloseKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_RIGHT : key === ARROW_LEFT;
  const horizontal = key === ARROW_UP;
  return doSwitch(orientation, vertical, horizontal);
}

function getMinIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    disabledIndices
  });
}

function getMaxIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    decrement: true,
    startingIndex: listRef.current.length,
    disabledIndices
  });
}

/**
 * Adds focus-managed indexed navigation via arrow keys to a list of items
 * within the floating element.
 * @see https://floating-ui.com/docs/useListNavigation
 */
const useListNavigation = function (_ref, _temp2) {
  let {
    open,
    onOpenChange,
    refs
  } = _ref;
  let {
    listRef,
    activeIndex,
    onNavigate: unstable_onNavigate = () => {},
    enabled = true,
    selectedIndex = null,
    allowEscape = false,
    loop = false,
    nested = false,
    rtl = false,
    virtual = false,
    focusItemOnOpen = 'auto',
    focusItemOnHover = true,
    openOnArrowKeyDown = true,
    disabledIndices = undefined,
    orientation = 'vertical',
    cols = 1
  } = _temp2 === void 0 ? {
    listRef: {
      current: []
    },
    activeIndex: null,
    onNavigate: () => {}
  } : _temp2;

  if (false) {}

  const parentId = useFloatingParentNodeId();
  const tree = useFloatingTree();
  const previousOpen = usePrevious(open);
  const onNavigate = useEvent(unstable_onNavigate);
  const previousOnNavigate = useEvent(usePrevious(unstable_onNavigate));
  const focusItemOnOpenRef = React.useRef(focusItemOnOpen);
  const indexRef = React.useRef(selectedIndex != null ? selectedIndex : -1);
  const keyRef = React.useRef(null);
  const disabledIndicesRef = useLatestRef(disabledIndices);
  const blockPointerLeaveRef = React.useRef(false);
  const frameRef = React.useRef(-1);
  const [activeId, setActiveId] = React.useState();
  const focusItem = React.useCallback((listRef, indexRef) => {
    // `mousedown` clicks occur before `focus`, so the button will steal the
    // focus unless we wait a frame.
    frameRef.current = requestAnimationFrame(() => {
      if (virtual) {
        var _listRef$current$inde;

        setActiveId((_listRef$current$inde = listRef.current[indexRef.current]) == null ? void 0 : _listRef$current$inde.id);
      } else {
        var _listRef$current$inde2;

        (_listRef$current$inde2 = listRef.current[indexRef.current]) == null ? void 0 : _listRef$current$inde2.focus({
          preventScroll: true
        });
      }
    });
  }, [virtual]); // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
  // element. Also, reset `activeIndex` upon closing the floating element.

  index(() => {
    if (!enabled) {
      return;
    }

    if (!previousOpen && open && focusItemOnOpenRef.current && selectedIndex != null) {
      onNavigate(selectedIndex);
    } // Unset `activeIndex`. Since the user can specify `onNavigate`
    // conditionally (onNavigate: open ? setActiveIndex : setSelectedIndex)
    // we store and call the previous function


    if (previousOpen && !open) {
      cancelAnimationFrame(frameRef.current);
      indexRef.current = -1;
      previousOnNavigate(null);
    }
  }, [open, previousOpen, selectedIndex, listRef, focusItem, enabled, onNavigate, previousOnNavigate]); // Sync `activeIndex` to be the focused item while the floating element is
  // open.

  index(() => {
    if (!enabled) {
      return;
    }

    if (open) {
      if (activeIndex == null) {
        if (selectedIndex != null) {
          return;
        } // Reset while the floating element was open (e.g. the list changed).


        if (previousOpen) {
          indexRef.current = -1;
          focusItem(listRef, indexRef);
        } // Initial sync


        if (!previousOpen && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
          indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinIndex(listRef, disabledIndicesRef.current) : getMaxIndex(listRef, disabledIndicesRef.current);
          onNavigate(indexRef.current);
          focusItem(listRef, indexRef);
        }
      } else if (!isIndexOutOfBounds(listRef, activeIndex)) {
        indexRef.current = activeIndex;
        focusItem(listRef, indexRef);
      }
    }
  }, [open, previousOpen, activeIndex, selectedIndex, nested, listRef, onNavigate, focusItem, enabled, allowEscape, orientation, rtl, virtual, disabledIndicesRef]); // Ensure the parent floating element has focus when a nested child closes
  // to allow arrow key navigation to work after the pointer leaves the child.

  index(() => {
    if (!enabled) {
      return;
    }

    if (!open && previousOpen) {
      var _tree$nodesRef$curren, _tree$nodesRef$curren2;

      const parentFloating = tree == null ? void 0 : (_tree$nodesRef$curren = tree.nodesRef.current.find(node => node.id === parentId)) == null ? void 0 : (_tree$nodesRef$curren2 = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren2.refs.floating.current;

      if (parentFloating && !parentFloating.contains(activeElement(getDocument(parentFloating)))) {
        parentFloating.focus({
          preventScroll: true
        });
      }
    }
  }, [enabled, open, previousOpen, tree, parentId]);
  index(() => {
    keyRef.current = null;
  });
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }

    const disabledIndices = disabledIndicesRef.current;

    function onKeyDown(event) {
      blockPointerLeaveRef.current = true;

      if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl)) {
        stopEvent(event);
        onOpenChange(false);

        if (isHTMLElement(refs.domReference.current)) {
          refs.domReference.current.focus();
        }

        return;
      }

      const currentIndex = indexRef.current;
      const minIndex = getMinIndex(listRef, disabledIndices);
      const maxIndex = getMaxIndex(listRef, disabledIndices);

      if (event.key === 'Home') {
        indexRef.current = minIndex;
        onNavigate(indexRef.current);
      }

      if (event.key === 'End') {
        indexRef.current = maxIndex;
        onNavigate(indexRef.current);
      } // Grid navigation


      if (cols > 1) {
        const prevIndex = indexRef.current;

        if (event.key === ARROW_UP) {
          stopEvent(event);

          if (prevIndex === -1) {
            indexRef.current = maxIndex;
          } else {
            indexRef.current = findNonDisabledIndex(listRef, {
              startingIndex: prevIndex,
              amount: cols,
              decrement: true,
              disabledIndices
            });

            if (loop && (prevIndex - cols < minIndex || indexRef.current < 0)) {
              const col = prevIndex % cols;
              const maxCol = maxIndex % cols;
              const offset = maxIndex - (maxCol - col);

              if (maxCol === col) {
                indexRef.current = maxIndex;
              } else {
                indexRef.current = maxCol > col ? offset : offset - cols;
              }
            }
          }

          if (isIndexOutOfBounds(listRef, indexRef.current)) {
            indexRef.current = prevIndex;
          }

          onNavigate(indexRef.current);
        }

        if (event.key === ARROW_DOWN) {
          stopEvent(event);

          if (prevIndex === -1) {
            indexRef.current = minIndex;
          } else {
            indexRef.current = findNonDisabledIndex(listRef, {
              startingIndex: prevIndex,
              amount: cols,
              disabledIndices
            });

            if (loop && prevIndex + cols > maxIndex) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices
              });
            }
          }

          if (isIndexOutOfBounds(listRef, indexRef.current)) {
            indexRef.current = prevIndex;
          }

          onNavigate(indexRef.current);
        } // Remains on the same row/column


        if (orientation === 'both') {
          const prevRow = Math.floor(prevIndex / cols);

          if (event.key === ARROW_RIGHT) {
            stopEvent(event);

            if (prevIndex % cols !== cols - 1) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex,
                disabledIndices
              });

              if (loop && isDifferentRow(indexRef.current, cols, prevRow)) {
                indexRef.current = findNonDisabledIndex(listRef, {
                  startingIndex: prevIndex - prevIndex % cols - 1,
                  disabledIndices
                });
              }
            } else if (loop) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices
              });
            }

            if (isDifferentRow(indexRef.current, cols, prevRow)) {
              indexRef.current = prevIndex;
            }
          }

          if (event.key === ARROW_LEFT) {
            stopEvent(event);

            if (prevIndex % cols !== 0) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex,
                disabledIndices,
                decrement: true
              });

              if (loop && isDifferentRow(indexRef.current, cols, prevRow)) {
                indexRef.current = findNonDisabledIndex(listRef, {
                  startingIndex: prevIndex + (cols - prevIndex % cols),
                  decrement: true,
                  disabledIndices
                });
              }
            } else if (loop) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices
              });
            }

            if (isDifferentRow(indexRef.current, cols, prevRow)) {
              indexRef.current = prevIndex;
            }
          }

          const lastRow = Math.floor(maxIndex / cols) === prevRow;

          if (isIndexOutOfBounds(listRef, indexRef.current)) {
            if (loop && lastRow) {
              indexRef.current = event.key === ARROW_LEFT ? maxIndex : findNonDisabledIndex(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices
              });
            } else {
              indexRef.current = prevIndex;
            }
          }

          onNavigate(indexRef.current);
          return;
        }
      }

      if (isMainOrientationKey(event.key, orientation)) {
        stopEvent(event); // Reset the index if no item is focused.

        if (open && !virtual && activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
          indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
          onNavigate(indexRef.current);
          return;
        }

        if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
          if (loop) {
            indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              disabledIndices
            });
          } else {
            indexRef.current = Math.min(maxIndex, findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              disabledIndices
            }));
          }
        } else {
          if (loop) {
            indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              decrement: true,
              disabledIndices
            });
          } else {
            indexRef.current = Math.max(minIndex, findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              decrement: true,
              disabledIndices
            }));
          }
        }

        if (isIndexOutOfBounds(listRef, indexRef.current)) {
          onNavigate(null);
        } else {
          onNavigate(indexRef.current);
        }
      }
    }

    return {
      reference: { ...(virtual && open && activeIndex != null && {
          'aria-activedescendant': activeId
        }),

        onKeyDown(event) {
          blockPointerLeaveRef.current = true;

          if (virtual && open) {
            return onKeyDown(event);
          }

          const isNavigationKey = event.key.indexOf('Arrow') === 0 || event.key === 'Enter' || event.key === ' ' || event.key === '';

          if (isNavigationKey) {
            keyRef.current = event.key;
          }

          if (nested) {
            if (isCrossOrientationOpenKey(event.key, orientation, rtl)) {
              stopEvent(event);

              if (open) {
                indexRef.current = getMinIndex(listRef, disabledIndices);
                onNavigate(indexRef.current);
              } else {
                onOpenChange(true);
              }
            }

            return;
          }

          if (isMainOrientationKey(event.key, orientation)) {
            if (selectedIndex != null) {
              indexRef.current = selectedIndex;
            }

            stopEvent(event);

            if (!open && openOnArrowKeyDown) {
              onOpenChange(true);
            } else {
              onKeyDown(event);
            }

            if (open) {
              onNavigate(indexRef.current);
            }
          }
        }

      },
      floating: {
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        ...(virtual && activeIndex != null && {
          'aria-activedescendant': activeId
        }),
        onKeyDown,

        onPointerMove() {
          blockPointerLeaveRef.current = false;
        }

      },
      item: {
        onFocus(_ref2) {
          let {
            currentTarget
          } = _ref2;
          const index = listRef.current.indexOf(currentTarget);

          if (index !== -1) {
            onNavigate(index);
          }
        },

        onClick: _ref3 => {
          let {
            currentTarget
          } = _ref3;
          return currentTarget.focus({
            preventScroll: true
          });
        },
        // Safari
        ...(focusItemOnHover && {
          onMouseMove(_ref4) {
            let {
              currentTarget
            } = _ref4;
            const target = currentTarget;

            if (target) {
              const index = listRef.current.indexOf(target);

              if (index !== -1) {
                onNavigate(index);
              }
            }
          },

          onPointerLeave() {
            if (!blockPointerLeaveRef.current) {
              indexRef.current = -1;
              focusItem(listRef, indexRef);
              onNavigate(null);

              if (!virtual) {
                requestAnimationFrame(() => {
                  var _refs$floating$curren;

                  (_refs$floating$curren = refs.floating.current) == null ? void 0 : _refs$floating$curren.focus({
                    preventScroll: true
                  });
                });
              }
            }
          }

        })
      }
    };
  }, [activeId, disabledIndicesRef, listRef, enabled, orientation, rtl, virtual, open, activeIndex, nested, selectedIndex, openOnArrowKeyDown, focusItemOnHover, allowEscape, cols, loop, refs, focusItem, onNavigate, onOpenChange]);
};

/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */
const useTypeahead = function (_ref, _temp) {
  var _ref2;

  let {
    open,
    dataRef
  } = _ref;
  let {
    listRef,
    activeIndex,
    onMatch: unstable_onMatch = () => {},
    enabled = true,
    findMatch = null,
    resetMs = 1000,
    ignoreKeys = [],
    selectedIndex = null
  } = _temp === void 0 ? {
    listRef: {
      current: []
    },
    activeIndex: null
  } : _temp;
  const timeoutIdRef = React.useRef();
  const stringRef = React.useRef('');
  const prevIndexRef = React.useRef((_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1);
  const matchIndexRef = React.useRef(null);
  const onMatch = useEvent(unstable_onMatch);
  const findMatchRef = useLatestRef(findMatch);
  const ignoreKeysRef = useLatestRef(ignoreKeys);
  index(() => {
    if (open) {
      clearTimeout(timeoutIdRef.current);
      matchIndexRef.current = null;
      stringRef.current = '';
    }
  }, [open]);
  index(() => {
    // Sync arrow key navigation but not typeahead navigation
    if (open && stringRef.current === '') {
      var _ref3;

      prevIndexRef.current = (_ref3 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref3 : -1;
    }
  }, [open, selectedIndex, activeIndex]);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }

    function onKeyDown(event) {
      // Correctly scope nested non-portalled floating elements. Since the nested
      // floating element is inside of the another, we find the closest role
      // that indicates the floating element scope.
      const target = getTarget(event.nativeEvent);

      if (isElement(target) && (activeElement(getDocument(target)) !== event.currentTarget ? target.closest('[role="dialog"],[role="menu"],[role="listbox"],[role="tree"],[role="grid"]') !== event.currentTarget : false)) {
        return;
      }

      if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
        dataRef.current.typing = true;

        if (event.key === ' ') {
          stopEvent(event);
        }
      }

      const listContent = listRef.current;

      if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key
      event.key.length !== 1 || // Modifier key
      event.ctrlKey || event.metaKey || event.altKey) {
        return;
      } // Bail out if the list contains a word like "llama" or "aaron". TODO:
      // allow it in this case, too.


      const allowRapidSuccessionOfFirstLetter = listContent.every(text => {
        var _text$, _text$2;

        return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
      }); // Allows the user to cycle through items that start with the same letter
      // in rapid succession

      if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
        stringRef.current = '';
        prevIndexRef.current = matchIndexRef.current;
      }

      stringRef.current += event.key;
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = setTimeout(() => {
        stringRef.current = '';
        prevIndexRef.current = matchIndexRef.current;
        dataRef.current.typing = false;
      }, resetMs);
      const prevIndex = prevIndexRef.current;
      const orderedList = [...listContent.slice((prevIndex != null ? prevIndex : 0) + 1), ...listContent.slice(0, (prevIndex != null ? prevIndex : 0) + 1)];
      const str = findMatchRef.current ? findMatchRef.current(orderedList, stringRef.current) : orderedList.find(text => (text == null ? void 0 : text.toLocaleLowerCase().indexOf(stringRef.current.toLocaleLowerCase())) === 0);
      const index = str ? listContent.indexOf(str) : -1;

      if (index !== -1) {
        onMatch(index);
        matchIndexRef.current = index;
      }
    }

    return {
      reference: {
        onKeyDown
      },
      floating: {
        onKeyDown
      }
    };
  }, [enabled, dataRef, listRef, resetMs, ignoreKeysRef, findMatchRef, onMatch]);
};




/***/ }),

/***/ 58463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YF": function() { return /* binding */ useFloating; },
/* harmony export */   "x7": function() { return /* binding */ arrow; }
/* harmony export */ });
/* harmony import */ var _floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88301);
/* harmony import */ var _floating_ui_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55863);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);






/**
 * Positions an inner element of the floating element such that it is centered
 * to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => {
  const {
    element,
    padding
  } = options;
  function isRef(value) {
    return Object.prototype.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(args) {
      if (isRef(element)) {
        if (element.current != null) {
          return (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .arrow */ .x7)({
            element: element.current,
            padding
          }).fn(args);
        }
        return {};
      } else if (element) {
        return (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .arrow */ .x7)({
          element,
          padding
        }).fn(args);
      }
      return {};
    }
  };
};

var index = typeof document !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length, i, keys;
  if (a && b && typeof a == 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}

function useLatestRef(value) {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    x: null,
    y: null,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = react__WEBPACK_IMPORTED_MODULE_0__.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const referenceRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const floatingRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const dataRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(data);
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const [reference, _setReference] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const [floating, _setFloating] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const setReference = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(node => {
    if (referenceRef.current !== node) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(node => {
    if (floatingRef.current !== node) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const update = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_3__/* .computePosition */ .oo)(referenceRef.current, floatingRef.current, {
      middleware: latestMiddleware,
      placement,
      strategy
    }).then(data => {
      const fullData = {
        ...data,
        isPositioned: true
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        react_dom__WEBPACK_IMPORTED_MODULE_1__.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (reference && floating) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(reference, floating, update);
      } else {
        update();
      }
    }
  }, [reference, floating, update, whileElementsMountedRef]);
  const refs = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    reference,
    floating
  }), [reference, floating]);
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    reference: setReference,
    floating: setFloating
  }), [data, update, refs, elements, setReference, setFloating]);
}




/***/ }),

/***/ 56057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ ChevronIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function ChevronIcon(props) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", __spreadValues({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}


//# sourceMappingURL=ChevronIcon.js.map


/***/ }),

/***/ 49834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ ActionIcon; }
});

// UNUSED EXPORTS: _ActionIcon

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/ActionIcon/ActionIcon.styles.js


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const sizes = {
  xs: 18,
  sm: 22,
  md: 28,
  lg: 34,
  xl: 44
};
function getVariantStyles({ variant, theme, color, gradient }) {
  const colors = theme.fn.variant({ color, variant, gradient });
  if (variant === "gradient") {
    return {
      border: 0,
      backgroundImage: colors.background,
      color: colors.color,
      "&:hover": theme.fn.hover({
        backgroundSize: "200%"
      })
    };
  }
  return __spreadValues({
    border: `1px solid ${colors.border}`,
    backgroundColor: colors.background,
    color: colors.color
  }, theme.fn.hover({
    backgroundColor: colors.hover
  }));
}
var useStyles = (0,create_styles/* createStyles */.k)((theme, { color, size, radius, variant, gradient }) => ({
  root: __spreadProps(__spreadValues({}, getVariantStyles({ variant, theme, color, gradient })), {
    position: "relative",
    height: theme.fn.size({ size, sizes }),
    minHeight: theme.fn.size({ size, sizes }),
    width: theme.fn.size({ size, sizes }),
    minWidth: theme.fn.size({ size, sizes }),
    borderRadius: theme.fn.radius(radius),
    padding: 0,
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:active": theme.activeStyles,
    "&:disabled, &[data-disabled]": {
      color: theme.colors.gray[theme.colorScheme === "dark" ? 6 : 4],
      cursor: "not-allowed",
      backgroundColor: variant === "transparent" ? void 0 : theme.fn.themeColor("gray", theme.colorScheme === "dark" ? 8 : 1),
      borderColor: variant === "transparent" ? void 0 : theme.fn.themeColor("gray", theme.colorScheme === "dark" ? 8 : 1),
      backgroundImage: "none",
      pointerEvents: "none",
      "&:active": {
        transform: "none"
      }
    },
    "&[data-loading]": {
      pointerEvents: "none",
      "&::before": {
        content: '""',
        position: "absolute",
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
        backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[7], 0.5) : "rgba(255, 255, 255, .5)",
        borderRadius: theme.fn.radius(radius),
        cursor: "not-allowed"
      }
    }
  })
}));

/* harmony default export */ var ActionIcon_styles = (useStyles);

//# sourceMappingURL=ActionIcon.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Loader/Loader.js + 3 modules
var Loader = __webpack_require__(20966);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.js + 1 modules
var UnstyledButton = __webpack_require__(34736);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/ActionIcon/ActionIcon.js







var ActionIcon_defProp = Object.defineProperty;
var ActionIcon_getOwnPropSymbols = Object.getOwnPropertySymbols;
var ActionIcon_hasOwnProp = Object.prototype.hasOwnProperty;
var ActionIcon_propIsEnum = Object.prototype.propertyIsEnumerable;
var ActionIcon_defNormalProp = (obj, key, value) => key in obj ? ActionIcon_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var ActionIcon_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (ActionIcon_hasOwnProp.call(b, prop))
      ActionIcon_defNormalProp(a, prop, b[prop]);
  if (ActionIcon_getOwnPropSymbols)
    for (var prop of ActionIcon_getOwnPropSymbols(b)) {
      if (ActionIcon_propIsEnum.call(b, prop))
        ActionIcon_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (ActionIcon_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && ActionIcon_getOwnPropSymbols)
    for (var prop of ActionIcon_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && ActionIcon_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  color: "gray",
  size: "md",
  variant: "subtle",
  loading: false
};
const _ActionIcon = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("ActionIcon", defaultProps, props), {
    className,
    color,
    children,
    radius,
    size,
    variant,
    gradient,
    disabled,
    loaderProps,
    loading,
    unstyled
  } = _a, others = __objRest(_a, [
    "className",
    "color",
    "children",
    "radius",
    "size",
    "variant",
    "gradient",
    "disabled",
    "loaderProps",
    "loading",
    "unstyled"
  ]);
  const { classes, cx, theme } = ActionIcon_styles({ size, radius, color, variant, gradient }, { name: "ActionIcon", unstyled });
  const colors = theme.fn.variant({ color, variant });
  const loader = /* @__PURE__ */ react.createElement(Loader/* Loader */.a, ActionIcon_spreadValues({
    color: colors.color,
    size: theme.fn.size({ size, sizes: sizes }) - 12
  }, loaderProps));
  return /* @__PURE__ */ react.createElement(UnstyledButton/* UnstyledButton */.k, ActionIcon_spreadValues({
    className: cx(classes.root, className),
    ref,
    disabled,
    "data-disabled": disabled || void 0,
    "data-loading": loading || void 0,
    unstyled
  }, others), loading ? loader : children);
});
_ActionIcon.displayName = "@mantine/core/ActionIcon";
const ActionIcon = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_ActionIcon);


//# sourceMappingURL=ActionIcon.js.map


/***/ }),

/***/ 82846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Affix; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3594);
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64761);
/* harmony import */ var _mantine_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97818);
/* harmony import */ var _Portal_OptionalPortal_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83143);
/* harmony import */ var _Box_Box_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7414);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  position: { bottom: 0, right: 0 },
  zIndex: (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultZIndex */ .w)("modal"),
  withinPortal: true
};
const Affix = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => {
  const _a = (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_2__/* .useComponentDefaultProps */ .N4)("Affix", defaultProps, props), { target, position, zIndex, sx, withinPortal } = _a, others = __objRest(_a, ["target", "position", "zIndex", "sx", "withinPortal"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Portal_OptionalPortal_js__WEBPACK_IMPORTED_MODULE_3__/* .OptionalPortal */ .q, {
    withinPortal,
    target
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Box_Box_js__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, __spreadValues({
    sx: [__spreadValues({ position: "fixed", zIndex }, position), ...(0,_mantine_utils__WEBPACK_IMPORTED_MODULE_5__/* .packSx */ .R)(sx)],
    ref
  }, others)));
});
Affix.displayName = "@mantine/core/Affix";


//# sourceMappingURL=Affix.js.map


/***/ }),

/***/ 99985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ Avatar; }
});

// UNUSED EXPORTS: _Avatar

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Avatar/AvatarPlaceholderIcon.js


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function AvatarPlaceholderIcon(props) {
  return /* @__PURE__ */ react.createElement("svg", __spreadProps(__spreadValues({}, props), {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /* @__PURE__ */ react.createElement("path", {
    d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}


//# sourceMappingURL=AvatarPlaceholderIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Avatar/AvatarGroup/AvatarGroup.context.js


var AvatarGroup_context_defProp = Object.defineProperty;
var AvatarGroup_context_defProps = Object.defineProperties;
var AvatarGroup_context_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var AvatarGroup_context_getOwnPropSymbols = Object.getOwnPropertySymbols;
var AvatarGroup_context_hasOwnProp = Object.prototype.hasOwnProperty;
var AvatarGroup_context_propIsEnum = Object.prototype.propertyIsEnumerable;
var AvatarGroup_context_defNormalProp = (obj, key, value) => key in obj ? AvatarGroup_context_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var AvatarGroup_context_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (AvatarGroup_context_hasOwnProp.call(b, prop))
      AvatarGroup_context_defNormalProp(a, prop, b[prop]);
  if (AvatarGroup_context_getOwnPropSymbols)
    for (var prop of AvatarGroup_context_getOwnPropSymbols(b)) {
      if (AvatarGroup_context_propIsEnum.call(b, prop))
        AvatarGroup_context_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var AvatarGroup_context_spreadProps = (a, b) => AvatarGroup_context_defProps(a, AvatarGroup_context_getOwnPropDescs(b));
const AvatarGroupContext = (0,react.createContext)(null);
function AvatarGroupProvider({ spacing, children }) {
  return /* @__PURE__ */ react.createElement(AvatarGroupContext.Provider, {
    value: { spacing }
  }, children);
}
function useAvatarGroupContext() {
  const ctx = (0,react.useContext)(AvatarGroupContext);
  if (ctx) {
    return AvatarGroup_context_spreadProps(AvatarGroup_context_spreadValues({}, ctx), { withinGroup: true });
  }
  return { spacing: null, withinGroup: false };
}


//# sourceMappingURL=AvatarGroup.context.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Avatar/AvatarGroup/AvatarGroup.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { spacing }) => ({
  root: {
    display: "flex",
    paddingLeft: theme.fn.size({ size: spacing, sizes: theme.spacing })
  }
}));

/* harmony default export */ var AvatarGroup_styles = (useStyles);
//# sourceMappingURL=AvatarGroup.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Avatar/AvatarGroup/AvatarGroup.js






var AvatarGroup_defProp = Object.defineProperty;
var AvatarGroup_getOwnPropSymbols = Object.getOwnPropertySymbols;
var AvatarGroup_hasOwnProp = Object.prototype.hasOwnProperty;
var AvatarGroup_propIsEnum = Object.prototype.propertyIsEnumerable;
var AvatarGroup_defNormalProp = (obj, key, value) => key in obj ? AvatarGroup_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var AvatarGroup_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (AvatarGroup_hasOwnProp.call(b, prop))
      AvatarGroup_defNormalProp(a, prop, b[prop]);
  if (AvatarGroup_getOwnPropSymbols)
    for (var prop of AvatarGroup_getOwnPropSymbols(b)) {
      if (AvatarGroup_propIsEnum.call(b, prop))
        AvatarGroup_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (AvatarGroup_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && AvatarGroup_getOwnPropSymbols)
    for (var prop of AvatarGroup_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && AvatarGroup_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {};
const AvatarGroup = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("AvatarGroup", defaultProps, props), {
    children,
    spacing = "sm",
    unstyled,
    className
  } = _a, others = __objRest(_a, [
    "children",
    "spacing",
    "unstyled",
    "className"
  ]);
  const { classes, cx } = AvatarGroup_styles({ spacing }, { name: "AvatarGroup", unstyled });
  return /* @__PURE__ */ react.createElement(AvatarGroupProvider, {
    spacing
  }, /* @__PURE__ */ react.createElement(Box/* Box */.x, AvatarGroup_spreadValues({
    ref,
    className: cx(classes.root, className)
  }, others), children));
});
AvatarGroup.displayName = "@mantine/core/AvatarGroup";


//# sourceMappingURL=AvatarGroup.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Avatar/Avatar.styles.js


var Avatar_styles_defProp = Object.defineProperty;
var Avatar_styles_defProps = Object.defineProperties;
var Avatar_styles_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Avatar_styles_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Avatar_styles_hasOwnProp = Object.prototype.hasOwnProperty;
var Avatar_styles_propIsEnum = Object.prototype.propertyIsEnumerable;
var Avatar_styles_defNormalProp = (obj, key, value) => key in obj ? Avatar_styles_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Avatar_styles_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Avatar_styles_hasOwnProp.call(b, prop))
      Avatar_styles_defNormalProp(a, prop, b[prop]);
  if (Avatar_styles_getOwnPropSymbols)
    for (var prop of Avatar_styles_getOwnPropSymbols(b)) {
      if (Avatar_styles_propIsEnum.call(b, prop))
        Avatar_styles_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Avatar_styles_spreadProps = (a, b) => Avatar_styles_defProps(a, Avatar_styles_getOwnPropDescs(b));
const sizes = {
  xs: 16,
  sm: 26,
  md: 38,
  lg: 56,
  xl: 84
};
function getGroupStyles({ withinGroup, spacing, theme }) {
  if (!withinGroup) {
    return null;
  }
  return {
    marginLeft: -theme.fn.size({ size: spacing, sizes: theme.spacing }),
    backgroundColor: `${theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white}`,
    border: `2px solid ${theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white}`
  };
}
var Avatar_styles_useStyles = (0,create_styles/* createStyles */.k)((theme, { size, radius, color, withinGroup, spacing, variant, gradient }) => {
  const colors = theme.fn.variant({ variant, color, gradient });
  return {
    root: Avatar_styles_spreadValues(Avatar_styles_spreadProps(Avatar_styles_spreadValues({}, theme.fn.focusStyles()), {
      WebkitTapHighlightColor: "transparent",
      boxSizing: "border-box",
      position: "relative",
      display: "block",
      userSelect: "none",
      overflow: "hidden",
      width: theme.fn.size({ size, sizes }),
      minWidth: theme.fn.size({ size, sizes }),
      height: theme.fn.size({ size, sizes }),
      borderRadius: theme.fn.radius(radius),
      textDecoration: "none",
      border: 0,
      backgroundColor: "transparent",
      padding: 0
    }), getGroupStyles({ withinGroup, spacing, theme })),
    image: {
      objectFit: "cover",
      width: "100%",
      height: "100%",
      display: "block"
    },
    placeholder: Avatar_styles_spreadProps(Avatar_styles_spreadValues({}, theme.fn.fontStyles()), {
      fontSize: theme.fn.size({ size, sizes }) / 2.5,
      color: colors.color,
      fontWeight: 700,
      backgroundColor: colors.background,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      userSelect: "none",
      backgroundImage: variant === "gradient" ? colors.background : void 0,
      border: `${variant === "gradient" ? 0 : 1}px solid ${colors.border}`,
      borderRadius: theme.fn.radius(radius)
    }),
    placeholderIcon: {
      width: "70%",
      height: "70%",
      color: colors.color
    }
  };
});

/* harmony default export */ var Avatar_styles = (Avatar_styles_useStyles);

//# sourceMappingURL=Avatar.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Avatar/Avatar.js









var Avatar_defProp = Object.defineProperty;
var Avatar_defProps = Object.defineProperties;
var Avatar_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Avatar_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Avatar_hasOwnProp = Object.prototype.hasOwnProperty;
var Avatar_propIsEnum = Object.prototype.propertyIsEnumerable;
var Avatar_defNormalProp = (obj, key, value) => key in obj ? Avatar_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Avatar_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Avatar_hasOwnProp.call(b, prop))
      Avatar_defNormalProp(a, prop, b[prop]);
  if (Avatar_getOwnPropSymbols)
    for (var prop of Avatar_getOwnPropSymbols(b)) {
      if (Avatar_propIsEnum.call(b, prop))
        Avatar_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Avatar_spreadProps = (a, b) => Avatar_defProps(a, Avatar_getOwnPropDescs(b));
var Avatar_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Avatar_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Avatar_getOwnPropSymbols)
    for (var prop of Avatar_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Avatar_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Avatar_defaultProps = {
  size: "md",
  color: "gray",
  variant: "light"
};
const _Avatar = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Avatar", Avatar_defaultProps, props), {
    className,
    size,
    src,
    alt,
    radius,
    children,
    color,
    variant,
    gradient,
    classNames,
    styles,
    imageProps,
    unstyled
  } = _a, others = Avatar_objRest(_a, [
    "className",
    "size",
    "src",
    "alt",
    "radius",
    "children",
    "color",
    "variant",
    "gradient",
    "classNames",
    "styles",
    "imageProps",
    "unstyled"
  ]);
  const ctx = useAvatarGroupContext();
  const [error, setError] = (0,react.useState)(!src);
  const { classes, cx } = Avatar_styles({ color, radius, size, withinGroup: ctx.withinGroup, spacing: ctx.spacing, variant, gradient }, { classNames, styles, unstyled, name: "Avatar" });
  (0,react.useEffect)(() => {
    !src ? setError(true) : setError(false);
  }, [src]);
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, Avatar_spreadValues({
    component: "div",
    className: cx(classes.root, className),
    ref
  }, others), error ? /* @__PURE__ */ react.createElement("div", {
    className: classes.placeholder,
    title: alt
  }, children || /* @__PURE__ */ react.createElement(AvatarPlaceholderIcon, {
    className: classes.placeholderIcon
  })) : /* @__PURE__ */ react.createElement("img", Avatar_spreadProps(Avatar_spreadValues({}, imageProps), {
    className: classes.image,
    src,
    alt,
    onError: () => setError(true)
  })));
});
_Avatar.displayName = "@mantine/core/Avatar";
_Avatar.Group = AvatarGroup;
const Avatar = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_Avatar);


//# sourceMappingURL=Avatar.js.map


/***/ }),

/***/ 17789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ Badge; }
});

// UNUSED EXPORTS: _Badge

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Badge/Badge.styles.js


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const sizes = {
  xs: { fontSize: 9, height: 16 },
  sm: { fontSize: 10, height: 18 },
  md: { fontSize: 11, height: 20 },
  lg: { fontSize: 13, height: 26 },
  xl: { fontSize: 16, height: 32 }
};
const dotSizes = {
  xs: 4,
  sm: 4,
  md: 6,
  lg: 8,
  xl: 10
};
function getVariantStyles({ theme, variant, color, size, gradient }) {
  if (variant === "dot") {
    const dotSize = theme.fn.size({ size, sizes: dotSizes });
    return {
      backgroundColor: "transparent",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
      border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[3]}`,
      paddingLeft: theme.fn.size({ size, sizes: theme.spacing }) / 1.5 - dotSize / 2,
      "&::before": {
        content: '""',
        display: "block",
        width: dotSize,
        height: dotSize,
        borderRadius: dotSize,
        backgroundColor: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 4 : theme.fn.primaryShade("light"), true),
        marginRight: dotSize
      }
    };
  }
  const colors = theme.fn.variant({ color, variant, gradient });
  return {
    background: colors.background,
    color: colors.color,
    border: `${variant === "gradient" ? 0 : 1}px solid ${colors.border}`
  };
}
var useStyles = (0,create_styles/* createStyles */.k)((theme, { color, size, radius, gradient, fullWidth, variant }) => {
  const { fontSize, height } = size in sizes ? sizes[size] : sizes.md;
  return {
    leftSection: {
      marginRight: `calc(${theme.spacing.xs}px / 2)`
    },
    rightSection: {
      marginLeft: `calc(${theme.spacing.xs}px / 2)`
    },
    inner: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    root: __spreadValues(__spreadProps(__spreadValues(__spreadValues({}, theme.fn.focusStyles()), theme.fn.fontStyles()), {
      fontSize,
      height,
      WebkitTapHighlightColor: "transparent",
      lineHeight: `${height - 2}px`,
      textDecoration: "none",
      padding: `0 ${theme.fn.size({ size, sizes: theme.spacing }) / 1.5}px`,
      boxSizing: "border-box",
      display: fullWidth ? "flex" : "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: fullWidth ? "100%" : "auto",
      textTransform: "uppercase",
      borderRadius: theme.fn.radius(radius),
      fontWeight: 700,
      letterSpacing: 0.25,
      cursor: "inherit",
      textOverflow: "ellipsis",
      overflow: "hidden"
    }), getVariantStyles({ theme, variant, color, size, gradient }))
  };
});

/* harmony default export */ var Badge_styles = (useStyles);
//# sourceMappingURL=Badge.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Badge/Badge.js






var Badge_defProp = Object.defineProperty;
var Badge_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Badge_hasOwnProp = Object.prototype.hasOwnProperty;
var Badge_propIsEnum = Object.prototype.propertyIsEnumerable;
var Badge_defNormalProp = (obj, key, value) => key in obj ? Badge_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Badge_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Badge_hasOwnProp.call(b, prop))
      Badge_defNormalProp(a, prop, b[prop]);
  if (Badge_getOwnPropSymbols)
    for (var prop of Badge_getOwnPropSymbols(b)) {
      if (Badge_propIsEnum.call(b, prop))
        Badge_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Badge_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Badge_getOwnPropSymbols)
    for (var prop of Badge_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Badge_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  variant: "light",
  size: "md",
  radius: "xl"
};
const _Badge = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Badge", defaultProps, props), {
    className,
    color,
    variant,
    fullWidth,
    children,
    size,
    leftSection,
    rightSection,
    radius,
    gradient,
    classNames,
    styles,
    unstyled
  } = _a, others = __objRest(_a, [
    "className",
    "color",
    "variant",
    "fullWidth",
    "children",
    "size",
    "leftSection",
    "rightSection",
    "radius",
    "gradient",
    "classNames",
    "styles",
    "unstyled"
  ]);
  const { classes, cx } = Badge_styles({
    size,
    fullWidth,
    color,
    radius,
    variant,
    gradient
  }, { classNames, styles, name: "Badge", unstyled });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, Badge_spreadValues({
    className: cx(classes.root, className),
    ref
  }, others), leftSection && /* @__PURE__ */ react.createElement("span", {
    className: classes.leftSection
  }, leftSection), /* @__PURE__ */ react.createElement("span", {
    className: classes.inner
  }, children), rightSection && /* @__PURE__ */ react.createElement("span", {
    className: classes.rightSection
  }, rightSection));
});
_Badge.displayName = "@mantine/core/Badge";
const Badge = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_Badge);


//# sourceMappingURL=Badge.js.map


/***/ }),

/***/ 7414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ Box; }
});

// UNUSED EXPORTS: _Box

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/style-system-props/extract-system-styles/extract-system-styles.js
var extract_system_styles = __webpack_require__(12756);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/use-css.js + 3 modules
var use_css = __webpack_require__(55138);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Box/style-system-props/get-responsive-value/get-responsive-value.js
function getSortedKeys(value, theme) {
  const sorted = Object.keys(value).filter((breakpoint) => breakpoint !== "base").sort((a, b) => theme.fn.size({ size: a, sizes: theme.breakpoints }) - theme.fn.size({ size: b, sizes: theme.breakpoints }));
  return "base" in value ? ["base", ...sorted] : sorted;
}
function getResponsiveValue({ value, theme, getValue, property }) {
  if (value == null) {
    return void 0;
  }
  if (typeof value === "object") {
    const result = getSortedKeys(value, theme).reduce((acc, breakpointKey) => {
      if (breakpointKey === "base" && value.base !== void 0) {
        const baseValue = getValue(value.base, theme);
        if (Array.isArray(property)) {
          property.forEach((prop) => {
            acc[prop] = baseValue;
          });
          return acc;
        }
        acc[property] = baseValue;
        return acc;
      }
      const breakpointValue = getValue(value[breakpointKey], theme);
      if (Array.isArray(property)) {
        acc[theme.fn.largerThan(breakpointKey)] = {};
        property.forEach((prop) => {
          acc[theme.fn.largerThan(breakpointKey)][prop] = breakpointValue;
        });
        return acc;
      }
      acc[theme.fn.largerThan(breakpointKey)] = {
        [property]: breakpointValue
      };
      return acc;
    }, {});
    return result;
  }
  const cssValue = getValue(value, theme);
  if (Array.isArray(property)) {
    return property.reduce((acc, prop) => {
      acc[prop] = cssValue;
      return acc;
    }, {});
  }
  return { [property]: cssValue };
}


//# sourceMappingURL=get-responsive-value.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Box/style-system-props/value-getters/get-color-value.js
function getColorValue(color, theme) {
  if (color === "dimmed") {
    return theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6];
  }
  return theme.fn.variant({ variant: "filled", color, primaryFallback: false }).background;
}


//# sourceMappingURL=get-color-value.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Box/style-system-props/value-getters/get-default-value.js
function getDefaultValue(value) {
  return value;
}


//# sourceMappingURL=get-default-value.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Box/style-system-props/value-getters/get-font-size-value.js
function getFontSizeValue(size, theme) {
  return theme.fn.size({ size, sizes: theme.fontSizes });
}


//# sourceMappingURL=get-font-size-value.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Box/style-system-props/value-getters/get-spacing-value.js
const NEGATIVE_VALUES = ["-xs", "-sm", "-md", "-lg", "-xl"];
function getSpacingValue(size, theme) {
  if (NEGATIVE_VALUES.includes(size)) {
    return theme.fn.size({ size: size.replace("-", ""), sizes: theme.spacing }) * -1;
  }
  return theme.fn.size({ size, sizes: theme.spacing });
}


//# sourceMappingURL=get-spacing-value.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Box/style-system-props/value-getters/value-getters.js





const valueGetters = {
  color: getColorValue,
  default: getDefaultValue,
  fontSize: getFontSizeValue,
  spacing: getSpacingValue
};


//# sourceMappingURL=value-getters.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Box/style-system-props/system-props/system-props.js
const SYSTEM_PROPS = {
  m: { type: "spacing", property: "margin" },
  mt: { type: "spacing", property: "marginTop" },
  mb: { type: "spacing", property: "marginBottom" },
  ml: { type: "spacing", property: "marginLeft" },
  mr: { type: "spacing", property: "marginRight" },
  mx: { type: "spacing", property: ["marginRight", "marginLeft"] },
  my: { type: "spacing", property: ["marginTop", "marginBottom"] },
  p: { type: "spacing", property: "padding" },
  pt: { type: "spacing", property: "paddingTop" },
  pb: { type: "spacing", property: "paddingBottom" },
  pl: { type: "spacing", property: "paddingLeft" },
  pr: { type: "spacing", property: "paddingRight" },
  px: { type: "spacing", property: ["paddingRight", "paddingLeft"] },
  py: { type: "spacing", property: ["paddingTop", "paddingBottom"] },
  bg: { type: "color", property: "background" },
  c: { type: "color", property: "color" },
  opacity: { type: "default", property: "opacity" },
  ff: { type: "default", property: "fontFamily" },
  fz: { type: "fontSize", property: "fontSize" },
  fw: { type: "default", property: "fontWeight" },
  lts: { type: "default", property: "letterSpacing" },
  ta: { type: "default", property: "textAlign" },
  lh: { type: "default", property: "lineHeight" },
  fs: { type: "default", property: "fontStyle" },
  tt: { type: "default", property: "textTransform" },
  td: { type: "default", property: "textDecoration" },
  w: { type: "spacing", property: "width" },
  miw: { type: "spacing", property: "minWidth" },
  maw: { type: "spacing", property: "maxWidth" },
  h: { type: "spacing", property: "height" },
  mih: { type: "spacing", property: "minHeight" },
  mah: { type: "spacing", property: "maxHeight" },
  bgsz: { type: "default", property: "background-size" },
  bgp: { type: "default", property: "background-position" },
  bgr: { type: "default", property: "background-repeat" },
  bga: { type: "default", property: "background-attachment" },
  pos: { type: "default", property: "position" },
  top: { type: "default", property: "top" },
  left: { type: "default", property: "left" },
  bottom: { type: "default", property: "bottom" },
  right: { type: "default", property: "right" },
  inset: { type: "default", property: "inset" },
  display: { type: "default", property: "display" }
};


//# sourceMappingURL=system-props.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Box/style-system-props/get-system-styles/get-system-styles.js




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function getSystemStyles(systemStyles, theme, systemProps = SYSTEM_PROPS) {
  const styles = Object.keys(systemProps).reduce((acc, systemProp) => {
    if (systemProp in systemStyles && systemStyles[systemProp] !== void 0) {
      acc.push(getResponsiveValue({
        value: systemStyles[systemProp],
        getValue: valueGetters[systemProps[systemProp].type],
        property: systemProps[systemProp].property,
        theme
      }));
    }
    return acc;
  }, []);
  return styles.reduce((acc, stylesPartial) => {
    Object.keys(stylesPartial).forEach((property) => {
      if (typeof stylesPartial[property] === "object" && stylesPartial[property] !== null) {
        if (!(property in acc)) {
          acc[property] = stylesPartial[property];
        } else {
          acc[property] = __spreadValues(__spreadValues({}, acc[property]), stylesPartial[property]);
        }
      } else {
        acc[property] = stylesPartial[property];
      }
    });
    return acc;
  }, {});
}


//# sourceMappingURL=get-system-styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Box/use-sx/use-sx.js



function extractSx(sx, theme) {
  return typeof sx === "function" ? sx(theme) : sx;
}
function useSx(sx, systemProps, className) {
  const theme = (0,MantineProvider/* useMantineTheme */.rZ)();
  const { css, cx } = (0,use_css/* useCss */.Z)();
  if (Array.isArray(sx)) {
    return cx(className, css(getSystemStyles(systemProps, theme)), sx.map((partial) => css(extractSx(partial, theme))));
  }
  return cx(className, css(extractSx(sx, theme)), css(getSystemStyles(systemProps, theme)));
}


//# sourceMappingURL=use-sx.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Box/Box.js





var Box_defProp = Object.defineProperty;
var Box_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Box_hasOwnProp = Object.prototype.hasOwnProperty;
var Box_propIsEnum = Object.prototype.propertyIsEnumerable;
var Box_defNormalProp = (obj, key, value) => key in obj ? Box_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Box_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Box_hasOwnProp.call(b, prop))
      Box_defNormalProp(a, prop, b[prop]);
  if (Box_getOwnPropSymbols)
    for (var prop of Box_getOwnPropSymbols(b)) {
      if (Box_propIsEnum.call(b, prop))
        Box_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Box_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Box_getOwnPropSymbols)
    for (var prop of Box_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Box_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const _Box = (0,react.forwardRef)((_a, ref) => {
  var _b = _a, { className, component, style, sx } = _b, others = __objRest(_b, ["className", "component", "style", "sx"]);
  const { systemStyles, rest } = (0,extract_system_styles/* extractSystemStyles */.x)(others);
  const Element = component || "div";
  return /* @__PURE__ */ react.createElement(Element, Box_spreadValues({
    ref,
    className: useSx(sx, systemStyles, className),
    style
  }, rest));
});
_Box.displayName = "@mantine/core/Box";
const Box = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_Box);


//# sourceMappingURL=Box.js.map


/***/ }),

/***/ 12756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ extractSystemStyles; }
/* harmony export */ });
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66896);


var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function extractSystemStyles(others) {
  const _a = others, {
    m,
    mx,
    my,
    mt,
    mb,
    ml,
    mr,
    p,
    px,
    py,
    pt,
    pb,
    pl,
    pr,
    bg,
    c,
    opacity,
    ff,
    fz,
    fw,
    lts,
    ta,
    lh,
    fs,
    tt,
    td,
    w,
    miw,
    maw,
    h,
    mih,
    mah,
    bgsz,
    bgp,
    bgr,
    bga,
    pos,
    top,
    left,
    bottom,
    right,
    inset,
    display
  } = _a, rest = __objRest(_a, [
    "m",
    "mx",
    "my",
    "mt",
    "mb",
    "ml",
    "mr",
    "p",
    "px",
    "py",
    "pt",
    "pb",
    "pl",
    "pr",
    "bg",
    "c",
    "opacity",
    "ff",
    "fz",
    "fw",
    "lts",
    "ta",
    "lh",
    "fs",
    "tt",
    "td",
    "w",
    "miw",
    "maw",
    "h",
    "mih",
    "mah",
    "bgsz",
    "bgp",
    "bgr",
    "bga",
    "pos",
    "top",
    "left",
    "bottom",
    "right",
    "inset",
    "display"
  ]);
  const systemStyles = (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_0__/* .filterProps */ .L)({
    m,
    mx,
    my,
    mt,
    mb,
    ml,
    mr,
    p,
    px,
    py,
    pt,
    pb,
    pl,
    pr,
    bg,
    c,
    opacity,
    ff,
    fz,
    fw,
    lts,
    ta,
    lh,
    fs,
    tt,
    td,
    w,
    miw,
    maw,
    h,
    mih,
    mah,
    bgsz,
    bgp,
    bgr,
    bga,
    pos,
    top,
    left,
    bottom,
    right,
    inset,
    display
  });
  return { systemStyles, rest };
}


//# sourceMappingURL=extract-system-styles.js.map


/***/ }),

/***/ 67841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// UNUSED EXPORTS: _Button

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Button/ButtonGroup/ButtonGroup.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((_theme, { orientation, buttonBorderWidth }) => ({
  root: {
    display: "flex",
    flexDirection: orientation === "vertical" ? "column" : "row",
    "& [data-button]": {
      "&:first-of-type": {
        borderBottomRightRadius: 0,
        [orientation === "vertical" ? "borderBottomLeftRadius" : "borderTopRightRadius"]: 0,
        [orientation === "vertical" ? "borderBottomWidth" : "borderRightWidth"]: buttonBorderWidth / 2
      },
      "&:last-of-type": {
        borderTopLeftRadius: 0,
        [orientation === "vertical" ? "borderTopRightRadius" : "borderBottomLeftRadius"]: 0,
        [orientation === "vertical" ? "borderTopWidth" : "borderLeftWidth"]: buttonBorderWidth / 2
      },
      "&:not(:first-of-type):not(:last-of-type)": {
        borderRadius: 0,
        [orientation === "vertical" ? "borderTopWidth" : "borderLeftWidth"]: buttonBorderWidth / 2,
        [orientation === "vertical" ? "borderBottomWidth" : "borderRightWidth"]: buttonBorderWidth / 2
      },
      "& + [data-button]": {
        [orientation === "vertical" ? "marginTop" : "marginLeft"]: -buttonBorderWidth,
        "@media (min-resolution: 192dpi)": {
          [orientation === "vertical" ? "marginTop" : "marginLeft"]: 0
        }
      }
    }
  }
}));

/* harmony default export */ var ButtonGroup_styles = (useStyles);
//# sourceMappingURL=ButtonGroup.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Button/ButtonGroup/ButtonGroup.js





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  orientation: "horizontal",
  buttonBorderWidth: 1
};
const ButtonGroup = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("ButtonGroup", defaultProps, props), { className, orientation, buttonBorderWidth, unstyled } = _a, others = __objRest(_a, ["className", "orientation", "buttonBorderWidth", "unstyled"]);
  const { classes, cx } = ButtonGroup_styles({ orientation, buttonBorderWidth }, { name: "ButtonGroup", unstyled });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.root, className),
    ref
  }, others));
});
ButtonGroup.displayName = "@mantine/core/ButtonGroup";


//# sourceMappingURL=ButtonGroup.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Input/Input.styles.js
var Input_styles = __webpack_require__(35227);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Button/Button.styles.js



var Button_styles_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Button_styles_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Button_styles_hasOwnProp = Object.prototype.hasOwnProperty;
var Button_styles_propIsEnum = Object.prototype.propertyIsEnumerable;
var Button_styles_defNormalProp = (obj, key, value) => key in obj ? Button_styles_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Button_styles_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Button_styles_hasOwnProp.call(b, prop))
      Button_styles_defNormalProp(a, prop, b[prop]);
  if (Button_styles_getOwnPropSymbols)
    for (var prop of Button_styles_getOwnPropSymbols(b)) {
      if (Button_styles_propIsEnum.call(b, prop))
        Button_styles_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const sizes = {
  xs: { height: Input_styles/* sizes.xs */.J.xs, paddingLeft: 14, paddingRight: 14 },
  sm: { height: Input_styles/* sizes.sm */.J.sm, paddingLeft: 18, paddingRight: 18 },
  md: { height: Input_styles/* sizes.md */.J.md, paddingLeft: 22, paddingRight: 22 },
  lg: { height: Input_styles/* sizes.lg */.J.lg, paddingLeft: 26, paddingRight: 26 },
  xl: { height: Input_styles/* sizes.xl */.J.xl, paddingLeft: 32, paddingRight: 32 },
  "compact-xs": { height: 22, paddingLeft: 7, paddingRight: 7 },
  "compact-sm": { height: 26, paddingLeft: 8, paddingRight: 8 },
  "compact-md": { height: 30, paddingLeft: 10, paddingRight: 10 },
  "compact-lg": { height: 34, paddingLeft: 12, paddingRight: 12 },
  "compact-xl": { height: 40, paddingLeft: 14, paddingRight: 14 }
};
function getSizeStyles({ compact, size, withLeftIcon, withRightIcon }) {
  if (compact) {
    return sizes[`compact-${size}`];
  }
  const _sizes = sizes[size];
  return __spreadProps(Button_styles_spreadValues({}, _sizes), {
    paddingLeft: withLeftIcon ? _sizes.paddingLeft / 1.5 : _sizes.paddingLeft,
    paddingRight: withRightIcon ? _sizes.paddingRight / 1.5 : _sizes.paddingRight
  });
}
const getWidthStyles = (fullWidth) => ({
  display: fullWidth ? "block" : "inline-block",
  width: fullWidth ? "100%" : "auto"
});
function getVariantStyles({ variant, theme, color, gradient }) {
  const colors = theme.fn.variant({ color, variant, gradient });
  if (variant === "gradient") {
    return {
      border: 0,
      backgroundImage: colors.background,
      color: colors.color,
      "&:hover": theme.fn.hover({
        backgroundSize: "200%"
      })
    };
  }
  return Button_styles_spreadValues({
    border: `1px solid ${colors.border}`,
    backgroundColor: colors.background,
    color: colors.color
  }, theme.fn.hover({
    backgroundColor: colors.hover
  }));
}
var Button_styles_useStyles = (0,create_styles/* createStyles */.k)((theme, {
  color,
  size,
  radius,
  fullWidth,
  compact,
  gradient,
  variant,
  withLeftIcon,
  withRightIcon
}) => ({
  root: __spreadProps(Button_styles_spreadValues(__spreadProps(Button_styles_spreadValues(Button_styles_spreadValues(Button_styles_spreadValues(Button_styles_spreadValues({}, getSizeStyles({ compact, size, withLeftIcon, withRightIcon })), theme.fn.fontStyles()), theme.fn.focusStyles()), getWidthStyles(fullWidth)), {
    borderRadius: theme.fn.radius(radius),
    fontWeight: 600,
    position: "relative",
    lineHeight: 1,
    fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
    userSelect: "none",
    cursor: "pointer"
  }), getVariantStyles({ variant, theme, color, gradient })), {
    "&:active": theme.activeStyles,
    "&:disabled, &[data-disabled]": {
      borderColor: "transparent",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
      color: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[5],
      cursor: "not-allowed",
      backgroundImage: "none",
      pointerEvents: "none",
      "&:active": {
        transform: "none"
      }
    },
    "&[data-loading]": {
      pointerEvents: "none",
      "&::before": {
        content: '""',
        position: "absolute",
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
        backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[7], 0.5) : "rgba(255, 255, 255, .5)",
        borderRadius: theme.fn.radius(radius),
        cursor: "not-allowed"
      }
    }
  }),
  icon: {
    display: "flex",
    alignItems: "center"
  },
  leftIcon: {
    marginRight: 10
  },
  rightIcon: {
    marginLeft: 10
  },
  centerLoader: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    opacity: 0.5
  },
  inner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    overflow: "visible"
  },
  label: {
    whiteSpace: "nowrap",
    height: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center"
  }
}));

/* harmony default export */ var Button_styles = (Button_styles_useStyles);

//# sourceMappingURL=Button.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Loader/Loader.js + 3 modules
var Loader = __webpack_require__(20966);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.js + 1 modules
var UnstyledButton = __webpack_require__(34736);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Button/Button.js








var Button_defProp = Object.defineProperty;
var Button_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Button_hasOwnProp = Object.prototype.hasOwnProperty;
var Button_propIsEnum = Object.prototype.propertyIsEnumerable;
var Button_defNormalProp = (obj, key, value) => key in obj ? Button_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Button_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Button_hasOwnProp.call(b, prop))
      Button_defNormalProp(a, prop, b[prop]);
  if (Button_getOwnPropSymbols)
    for (var prop of Button_getOwnPropSymbols(b)) {
      if (Button_propIsEnum.call(b, prop))
        Button_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Button_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Button_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Button_getOwnPropSymbols)
    for (var prop of Button_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Button_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Button_defaultProps = {
  size: "sm",
  type: "button",
  variant: "filled",
  loaderPosition: "left"
};
const _Button = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Button", Button_defaultProps, props), {
    className,
    size,
    color,
    type,
    disabled,
    children,
    leftIcon,
    rightIcon,
    fullWidth,
    variant,
    radius,
    uppercase,
    compact,
    loading,
    loaderPosition,
    loaderProps,
    gradient,
    classNames,
    styles,
    unstyled
  } = _a, others = Button_objRest(_a, [
    "className",
    "size",
    "color",
    "type",
    "disabled",
    "children",
    "leftIcon",
    "rightIcon",
    "fullWidth",
    "variant",
    "radius",
    "uppercase",
    "compact",
    "loading",
    "loaderPosition",
    "loaderProps",
    "gradient",
    "classNames",
    "styles",
    "unstyled"
  ]);
  const { classes, cx, theme } = Button_styles({
    radius,
    color,
    size,
    fullWidth,
    compact,
    gradient,
    variant,
    withLeftIcon: !!leftIcon,
    withRightIcon: !!rightIcon
  }, { name: "Button", unstyled, classNames, styles });
  const colors = theme.fn.variant({ color, variant });
  const loader = /* @__PURE__ */ react.createElement(Loader/* Loader */.a, Button_spreadValues({
    color: colors.color,
    size: theme.fn.size({ size, sizes: sizes }).height / 2
  }, loaderProps));
  return /* @__PURE__ */ react.createElement(UnstyledButton/* UnstyledButton */.k, Button_spreadValues({
    className: cx(classes.root, className),
    type,
    disabled,
    "data-button": true,
    "data-disabled": disabled || void 0,
    "data-loading": loading || void 0,
    ref,
    unstyled
  }, others), /* @__PURE__ */ react.createElement("div", {
    className: classes.inner
  }, (leftIcon || loading && loaderPosition === "left") && /* @__PURE__ */ react.createElement("span", {
    className: cx(classes.icon, classes.leftIcon)
  }, loading && loaderPosition === "left" ? loader : leftIcon), loading && loaderPosition === "center" && /* @__PURE__ */ react.createElement("span", {
    className: classes.centerLoader
  }, loader), /* @__PURE__ */ react.createElement("span", {
    className: classes.label,
    style: { textTransform: uppercase ? "uppercase" : void 0 }
  }, children), (rightIcon || loading && loaderPosition === "right") && /* @__PURE__ */ react.createElement("span", {
    className: cx(classes.icon, classes.rightIcon)
  }, loading && loaderPosition === "right" ? loader : rightIcon)));
});
_Button.displayName = "@mantine/core/Button";
_Button.Group = ButtonGroup;
const Button = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_Button);


//# sourceMappingURL=Button.js.map


/***/ }),

/***/ 21017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card; }
});

// UNUSED EXPORTS: _Card

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(82623);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/Card.context.js


const CardContext = (0,react.createContext)({ padding: 0 });
const CardProvider = CardContext.Provider;
const useCardPadding = () => (0,react.useContext)(CardContext).padding;


//# sourceMappingURL=Card.context.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/CardSection/CardSection.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { padding, withBorder, inheritPadding }) => {
  const spacing = theme.fn.size({ size: padding, sizes: theme.spacing });
  const offset = -1 * spacing;
  const borderColor = theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3];
  return {
    cardSection: {
      display: "block",
      marginLeft: offset,
      marginRight: offset,
      paddingLeft: inheritPadding ? spacing : void 0,
      paddingRight: inheritPadding ? spacing : void 0,
      borderTop: withBorder && `1px solid ${borderColor}`,
      borderBottom: withBorder && `1px solid ${borderColor}`,
      "& + &": {
        borderTop: 0
      },
      "&[data-first]": {
        marginTop: offset,
        borderTop: 0,
        borderBottom: withBorder && `1px solid ${borderColor}`
      },
      "&[data-last]": {
        marginBottom: offset,
        borderBottom: 0
      }
    }
  };
});

/* harmony default export */ var CardSection_styles = (useStyles);
//# sourceMappingURL=CardSection.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/CardSection/CardSection.js







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  withBorder: false,
  inheritPadding: false
};
const _CardSection = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("CardSection", defaultProps, props), { className, withBorder, inheritPadding, unstyled } = _a, others = __objRest(_a, ["className", "withBorder", "inheritPadding", "unstyled"]);
  const { classes, cx } = CardSection_styles({ padding: useCardPadding(), withBorder, inheritPadding }, { name: "Card", unstyled });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.cardSection, className),
    ref
  }, others));
});
_CardSection.displayName = "@mantine/core/CardSection";
const CardSection = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_CardSection);


//# sourceMappingURL=CardSection.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/Card.styles.js


var Card_styles_useStyles = (0,create_styles/* createStyles */.k)((theme) => ({
  root: {
    position: "relative",
    overflow: "hidden",
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
  }
}));

/* harmony default export */ var Card_styles = (Card_styles_useStyles);
//# sourceMappingURL=Card.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/Card.js








var Card_defProp = Object.defineProperty;
var Card_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Card_hasOwnProp = Object.prototype.hasOwnProperty;
var Card_propIsEnum = Object.prototype.propertyIsEnumerable;
var Card_defNormalProp = (obj, key, value) => key in obj ? Card_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Card_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Card_hasOwnProp.call(b, prop))
      Card_defNormalProp(a, prop, b[prop]);
  if (Card_getOwnPropSymbols)
    for (var prop of Card_getOwnPropSymbols(b)) {
      if (Card_propIsEnum.call(b, prop))
        Card_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Card_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Card_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Card_getOwnPropSymbols)
    for (var prop of Card_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Card_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Card_defaultProps = {
  p: "md"
};
const _Card = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Card", Card_defaultProps, props), { className, p, radius, children, unstyled } = _a, others = Card_objRest(_a, ["className", "p", "radius", "children", "unstyled"]);
  const { classes, cx } = Card_styles(null, { name: "Card", unstyled });
  const _children = react.Children.toArray(children);
  const content = _children.map((child, index) => {
    if (typeof child === "object" && child && "type" in child && child.type === CardSection) {
      return (0,react.cloneElement)(child, {
        padding: p,
        "data-first": index === 0 || void 0,
        "data-last": index === _children.length - 1 || void 0
      });
    }
    return child;
  });
  return /* @__PURE__ */ react.createElement(CardProvider, {
    value: { padding: p }
  }, /* @__PURE__ */ react.createElement(Paper/* Paper */.X, Card_spreadValues({
    className: cx(classes.root, className),
    radius,
    p,
    ref
  }, others), content));
});
_Card.Section = CardSection;
_Card.displayName = "@mantine/core/Card";
const Card = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_Card);


//# sourceMappingURL=Card.js.map


/***/ }),

/***/ 80971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ CloseButton; }
});

// UNUSED EXPORTS: _CloseButton

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/ActionIcon/ActionIcon.js + 1 modules
var ActionIcon = __webpack_require__(49834);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/CloseButton/CloseIcon.js


var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function CloseIcon(props) {
  return /* @__PURE__ */ react.createElement("svg", __spreadValues({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ react.createElement("path", {
    d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
CloseIcon.displayName = "@mantine/core/CloseIcon";


//# sourceMappingURL=CloseIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/CloseButton/CloseButton.js






var CloseButton_defProp = Object.defineProperty;
var CloseButton_getOwnPropSymbols = Object.getOwnPropertySymbols;
var CloseButton_hasOwnProp = Object.prototype.hasOwnProperty;
var CloseButton_propIsEnum = Object.prototype.propertyIsEnumerable;
var CloseButton_defNormalProp = (obj, key, value) => key in obj ? CloseButton_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var CloseButton_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (CloseButton_hasOwnProp.call(b, prop))
      CloseButton_defNormalProp(a, prop, b[prop]);
  if (CloseButton_getOwnPropSymbols)
    for (var prop of CloseButton_getOwnPropSymbols(b)) {
      if (CloseButton_propIsEnum.call(b, prop))
        CloseButton_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (CloseButton_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && CloseButton_getOwnPropSymbols)
    for (var prop of CloseButton_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && CloseButton_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const iconSizes = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
  xl: 24
};
const defaultProps = {
  size: "md"
};
const _CloseButton = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("CloseButton", defaultProps, props), {
    iconSize,
    size = "md"
  } = _a, others = __objRest(_a, [
    "iconSize",
    "size"
  ]);
  const theme = (0,MantineProvider/* useMantineTheme */.rZ)();
  const _iconSize = iconSize || theme.fn.size({ size, sizes: iconSizes });
  return /* @__PURE__ */ react.createElement(ActionIcon/* ActionIcon */.A, CloseButton_spreadValues({
    size,
    ref
  }, others), /* @__PURE__ */ react.createElement(CloseIcon, {
    width: _iconSize,
    height: _iconSize
  }));
});
_CloseButton.displayName = "@mantine/core/CloseButton";
const CloseButton = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_CloseButton);


//# sourceMappingURL=CloseButton.js.map


/***/ }),

/***/ 31003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ Collapse; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-reduced-motion/use-reduced-motion.js
var use_reduced_motion = __webpack_require__(73678);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-did-update/use-did-update.js
var use_did_update = __webpack_require__(37048);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-merged-ref/use-merged-ref.js
var use_merged_ref = __webpack_require__(80665);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Collapse/use-collapse.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function getAutoHeightDuration(height) {
  if (!height || typeof height === "string") {
    return 0;
  }
  const constant = height / 36;
  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function getElementHeight(el) {
  return (el == null ? void 0 : el.current) ? el.current.scrollHeight : "auto";
}
const raf = typeof window !== "undefined" && window.requestAnimationFrame;
function useCollapse({
  transitionDuration,
  transitionTimingFunction = "ease",
  onTransitionEnd = () => {
  },
  opened
}) {
  const el = (0,react.useRef)(null);
  const collapsedHeight = "0px";
  const collapsedStyles = {
    display: "none",
    height: "0px",
    overflow: "hidden"
  };
  const [styles, setStylesRaw] = (0,react.useState)(opened ? {} : collapsedStyles);
  const setStyles = (newStyles) => {
    (0,react_dom.flushSync)(() => setStylesRaw(newStyles));
  };
  const mergeStyles = (newStyles) => {
    setStyles((oldStyles) => __spreadValues(__spreadValues({}, oldStyles), newStyles));
  };
  function getTransitionStyles(height) {
    const _duration = transitionDuration || getAutoHeightDuration(height);
    return {
      transition: `height ${_duration}ms ${transitionTimingFunction}`
    };
  }
  (0,use_did_update/* useDidUpdate */.l)(() => {
    if (opened) {
      raf(() => {
        mergeStyles({ willChange: "height", display: "block", overflow: "hidden" });
        raf(() => {
          const height = getElementHeight(el);
          mergeStyles(__spreadProps(__spreadValues({}, getTransitionStyles(height)), { height }));
        });
      });
    } else {
      raf(() => {
        const height = getElementHeight(el);
        mergeStyles(__spreadProps(__spreadValues({}, getTransitionStyles(height)), { willChange: "height", height }));
        raf(() => mergeStyles({ height: collapsedHeight, overflow: "hidden" }));
      });
    }
  }, [opened]);
  const handleTransitionEnd = (e) => {
    if (e.target !== el.current || e.propertyName !== "height") {
      return;
    }
    if (opened) {
      const height = getElementHeight(el);
      if (height === styles.height) {
        setStyles({});
      } else {
        mergeStyles({ height });
      }
      onTransitionEnd();
    } else if (styles.height === collapsedHeight) {
      setStyles(collapsedStyles);
      onTransitionEnd();
    }
  };
  function getCollapseProps(_a = {}) {
    var _b = _a, { style = {}, refKey = "ref" } = _b, rest = __objRest(_b, ["style", "refKey"]);
    const theirRef = rest[refKey];
    return __spreadProps(__spreadValues({
      "aria-hidden": !opened
    }, rest), {
      [refKey]: (0,use_merged_ref/* mergeRefs */.l)(el, theirRef),
      onTransitionEnd: handleTransitionEnd,
      style: __spreadValues(__spreadValues({ boxSizing: "border-box" }, style), styles)
    });
  }
  return getCollapseProps;
}


//# sourceMappingURL=use-collapse.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/style-system-props/extract-system-styles/extract-system-styles.js
var extract_system_styles = __webpack_require__(12756);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Collapse/Collapse.js







var Collapse_defProp = Object.defineProperty;
var Collapse_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Collapse_hasOwnProp = Object.prototype.hasOwnProperty;
var Collapse_propIsEnum = Object.prototype.propertyIsEnumerable;
var Collapse_defNormalProp = (obj, key, value) => key in obj ? Collapse_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Collapse_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Collapse_hasOwnProp.call(b, prop))
      Collapse_defNormalProp(a, prop, b[prop]);
  if (Collapse_getOwnPropSymbols)
    for (var prop of Collapse_getOwnPropSymbols(b)) {
      if (Collapse_propIsEnum.call(b, prop))
        Collapse_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Collapse_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Collapse_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Collapse_getOwnPropSymbols)
    for (var prop of Collapse_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Collapse_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  transitionDuration: 200,
  transitionTimingFunction: "ease",
  animateOpacity: true
};
const Collapse = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Collapse", defaultProps, props), {
    children,
    in: opened,
    transitionDuration,
    transitionTimingFunction,
    style,
    onTransitionEnd,
    animateOpacity
  } = _a, others = Collapse_objRest(_a, [
    "children",
    "in",
    "transitionDuration",
    "transitionTimingFunction",
    "style",
    "onTransitionEnd",
    "animateOpacity"
  ]);
  const theme = (0,MantineProvider/* useMantineTheme */.rZ)();
  const shouldReduceMotion = (0,use_reduced_motion/* useReducedMotion */.J)();
  const reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
  const duration = reduceMotion ? 0 : transitionDuration;
  const { systemStyles, rest } = (0,extract_system_styles/* extractSystemStyles */.x)(others);
  const getCollapseProps = useCollapse({
    opened,
    transitionDuration: duration,
    transitionTimingFunction,
    onTransitionEnd
  });
  if (duration === 0) {
    return opened ? /* @__PURE__ */ react.createElement(Box/* Box */.x, Collapse_spreadValues({}, rest), children) : null;
  }
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, Collapse_spreadValues({}, getCollapseProps(Collapse_spreadValues(Collapse_spreadValues({ style, ref }, rest), systemStyles))), /* @__PURE__ */ react.createElement("div", {
    style: {
      opacity: opened || !animateOpacity ? 1 : 0,
      transition: animateOpacity ? `opacity ${duration}ms ${transitionTimingFunction}` : "none"
    }
  }, children));
});
Collapse.displayName = "@mantine/core/Collapse";


//# sourceMappingURL=Collapse.js.map


/***/ }),

/***/ 72445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ Container; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Container/Container.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { fluid, size, sizes }) => ({
  root: {
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    maxWidth: fluid ? "100%" : theme.fn.size({ size, sizes }),
    marginLeft: "auto",
    marginRight: "auto"
  }
}));

/* harmony default export */ var Container_styles = (useStyles);
//# sourceMappingURL=Container.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Container/Container.js





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  sizes: {
    xs: 540,
    sm: 720,
    md: 960,
    lg: 1140,
    xl: 1320
  }
};
const Container = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Container", defaultProps, props), { className, fluid, size, unstyled, sizes } = _a, others = __objRest(_a, ["className", "fluid", "size", "unstyled", "sizes"]);
  const { classes, cx } = Container_styles({ fluid, size, sizes }, { unstyled, name: "Container" });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.root, className),
    ref
  }, others));
});
Container.displayName = "@mantine/core/Container";


//# sourceMappingURL=Container.js.map


/***/ }),

/***/ 54777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ Divider; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Divider/Divider.styles.js


const sizes = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5
};
function getColor(theme, color) {
  const themeColor = theme.fn.variant({ variant: "outline", color }).border;
  return typeof color === "string" && (color in theme.colors || color.split(".")[0] in theme.colors) ? themeColor : color === void 0 ? theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4] : color;
}
var useStyles = (0,create_styles/* createStyles */.k)((theme, { size, variant, color }) => ({
  root: {},
  withLabel: {
    borderTop: "0 !important"
  },
  left: {
    "&::before": {
      display: "none"
    }
  },
  right: {
    "&::after": {
      display: "none"
    }
  },
  label: {
    display: "flex",
    alignItems: "center",
    "&::before": {
      content: '""',
      flex: 1,
      height: 1,
      borderTop: `${theme.fn.size({ size, sizes })}px ${variant} ${getColor(theme, color)}`,
      marginRight: theme.spacing.xs
    },
    "&::after": {
      content: '""',
      flex: 1,
      borderTop: `${theme.fn.size({ size, sizes })}px ${variant} ${getColor(theme, color)}`,
      marginLeft: theme.spacing.xs
    }
  },
  labelDefaultStyles: {
    color: color === "dark" ? theme.colors.dark[1] : theme.fn.themeColor(color, theme.colorScheme === "dark" ? 5 : theme.fn.primaryShade(), false)
  },
  horizontal: {
    border: 0,
    borderTopWidth: theme.fn.size({ size, sizes }),
    borderTopColor: getColor(theme, color),
    borderTopStyle: variant,
    margin: 0
  },
  vertical: {
    border: 0,
    alignSelf: "stretch",
    height: "auto",
    borderLeftWidth: theme.fn.size({ size, sizes }),
    borderLeftColor: getColor(theme, color),
    borderLeftStyle: variant
  }
}));

/* harmony default export */ var Divider_styles = (useStyles);
//# sourceMappingURL=Divider.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Divider/Divider.js






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  orientation: "horizontal",
  size: "xs",
  labelPosition: "left",
  variant: "solid"
};
const Divider = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Divider", defaultProps, props), {
    className,
    color,
    orientation,
    size,
    label,
    labelPosition,
    labelProps,
    variant,
    styles,
    classNames,
    unstyled
  } = _a, others = __objRest(_a, [
    "className",
    "color",
    "orientation",
    "size",
    "label",
    "labelPosition",
    "labelProps",
    "variant",
    "styles",
    "classNames",
    "unstyled"
  ]);
  const { classes, cx } = Divider_styles({ color, size, variant }, { classNames, styles, unstyled, name: "Divider" });
  const vertical = orientation === "vertical";
  const horizontal = orientation === "horizontal";
  const withLabel = !!label && horizontal;
  const useLabelDefaultStyles = !(labelProps == null ? void 0 : labelProps.color);
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    ref,
    className: cx(classes.root, {
      [classes.vertical]: vertical,
      [classes.horizontal]: horizontal,
      [classes.withLabel]: withLabel
    }, className),
    role: "separator"
  }, others), withLabel && /* @__PURE__ */ react.createElement(Text/* Text */.x, __spreadProps(__spreadValues({}, labelProps), {
    size: (labelProps == null ? void 0 : labelProps.size) || "xs",
    sx: { marginTop: 2 },
    className: cx(classes.label, classes[labelPosition], {
      [classes.labelDefaultStyles]: useLabelDefaultStyles
    })
  }), label));
});
Divider.displayName = "@mantine/core/Divider";


//# sourceMappingURL=Divider.js.map


/***/ }),

/***/ 63468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ FloatingArrow; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Floating/FloatingArrow/get-arrow-position-styles.js
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function horizontalSide(placement, arrowY, arrowOffset, arrowPosition) {
  if (placement === "center" || arrowPosition === "center") {
    return { top: arrowY };
  }
  if (placement === "end") {
    return { bottom: arrowOffset };
  }
  if (placement === "start") {
    return { top: arrowOffset };
  }
  return {};
}
function verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir) {
  if (placement === "center" || arrowPosition === "center") {
    return { left: arrowX };
  }
  if (placement === "end") {
    return { [dir === "ltr" ? "right" : "left"]: arrowOffset };
  }
  if (placement === "start") {
    return { [dir === "ltr" ? "left" : "right"]: arrowOffset };
  }
  return {};
}
const radiusByFloatingSide = {
  bottom: "borderTopLeftRadius",
  left: "borderTopRightRadius",
  right: "borderBottomLeftRadius",
  top: "borderBottomRightRadius"
};
function getArrowPositionStyles({
  position,
  withBorder,
  arrowSize,
  arrowOffset,
  arrowRadius,
  arrowPosition,
  arrowX,
  arrowY,
  dir
}) {
  const [side, placement = "center"] = position.split("-");
  const baseStyles = {
    width: arrowSize,
    height: arrowSize,
    transform: "rotate(45deg)",
    position: "absolute",
    [radiusByFloatingSide[side]]: arrowRadius
  };
  const arrowPlacement = withBorder ? -arrowSize / 2 - 1 : -arrowSize / 2;
  if (side === "left") {
    return __spreadProps(__spreadValues(__spreadValues({}, baseStyles), horizontalSide(placement, arrowY, arrowOffset, arrowPosition)), {
      right: arrowPlacement,
      borderLeft: 0,
      borderBottom: 0
    });
  }
  if (side === "right") {
    return __spreadProps(__spreadValues(__spreadValues({}, baseStyles), horizontalSide(placement, arrowY, arrowOffset, arrowPosition)), {
      left: arrowPlacement,
      borderRight: 0,
      borderTop: 0
    });
  }
  if (side === "top") {
    return __spreadProps(__spreadValues(__spreadValues({}, baseStyles), verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir)), {
      bottom: arrowPlacement,
      borderTop: 0,
      borderLeft: 0
    });
  }
  if (side === "bottom") {
    return __spreadProps(__spreadValues(__spreadValues({}, baseStyles), verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir)), {
      top: arrowPlacement,
      borderBottom: 0,
      borderRight: 0
    });
  }
  return {};
}


//# sourceMappingURL=get-arrow-position-styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Floating/FloatingArrow/FloatingArrow.js




var FloatingArrow_defProp = Object.defineProperty;
var FloatingArrow_defProps = Object.defineProperties;
var FloatingArrow_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var FloatingArrow_getOwnPropSymbols = Object.getOwnPropertySymbols;
var FloatingArrow_hasOwnProp = Object.prototype.hasOwnProperty;
var FloatingArrow_propIsEnum = Object.prototype.propertyIsEnumerable;
var FloatingArrow_defNormalProp = (obj, key, value) => key in obj ? FloatingArrow_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var FloatingArrow_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (FloatingArrow_hasOwnProp.call(b, prop))
      FloatingArrow_defNormalProp(a, prop, b[prop]);
  if (FloatingArrow_getOwnPropSymbols)
    for (var prop of FloatingArrow_getOwnPropSymbols(b)) {
      if (FloatingArrow_propIsEnum.call(b, prop))
        FloatingArrow_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var FloatingArrow_spreadProps = (a, b) => FloatingArrow_defProps(a, FloatingArrow_getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (FloatingArrow_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && FloatingArrow_getOwnPropSymbols)
    for (var prop of FloatingArrow_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && FloatingArrow_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const FloatingArrow = (0,react.forwardRef)((_a, ref) => {
  var _b = _a, {
    withBorder,
    position,
    arrowSize,
    arrowOffset,
    arrowRadius,
    arrowPosition,
    visible,
    arrowX,
    arrowY
  } = _b, others = __objRest(_b, [
    "withBorder",
    "position",
    "arrowSize",
    "arrowOffset",
    "arrowRadius",
    "arrowPosition",
    "visible",
    "arrowX",
    "arrowY"
  ]);
  const theme = (0,MantineProvider/* useMantineTheme */.rZ)();
  if (!visible) {
    return null;
  }
  return /* @__PURE__ */ react.createElement("div", FloatingArrow_spreadProps(FloatingArrow_spreadValues({}, others), {
    ref,
    style: getArrowPositionStyles({
      withBorder,
      position,
      arrowSize,
      arrowOffset,
      arrowRadius,
      arrowPosition,
      dir: theme.dir,
      arrowX,
      arrowY
    })
  }));
});
FloatingArrow.displayName = "@mantine/core/FloatingArrow";


//# sourceMappingURL=FloatingArrow.js.map


/***/ }),

/***/ 14870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getFloatingPosition; }
/* harmony export */ });
function getFloatingPosition(dir, position) {
  if (dir === "rtl" && (position.includes("right") || position.includes("left"))) {
    const [side, placement] = position.split("-");
    const flippedPosition = side === "right" ? "left" : "right";
    return placement === void 0 ? flippedPosition : `${flippedPosition}-${placement}`;
  }
  return position;
}


//# sourceMappingURL=get-floating-position.js.map


/***/ }),

/***/ 27347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useDelayedHover; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useDelayedHover({ open, close, openDelay, closeDelay }) {
  const openTimeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(-1);
  const closeTimeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(-1);
  const clearTimeouts = () => {
    window.clearTimeout(openTimeout.current);
    window.clearTimeout(closeTimeout.current);
  };
  const openDropdown = () => {
    clearTimeouts();
    if (openDelay === 0) {
      open();
    } else {
      openTimeout.current = window.setTimeout(open, openDelay);
    }
  };
  const closeDropdown = () => {
    clearTimeouts();
    if (closeDelay === 0) {
      close();
    } else {
      closeTimeout.current = window.setTimeout(close, closeDelay);
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => clearTimeouts, []);
  return { openDropdown, closeDropdown };
}


//# sourceMappingURL=use-delayed-hover.js.map


/***/ }),

/***/ 30212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useFloatingAutoUpdate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _floating_ui_react_dom_interactions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55863);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37048);




function useFloatingAutoUpdate({ opened, floating, positionDependencies }) {
  const [delayedUpdate, setDelayedUpdate] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (floating.refs.reference.current && floating.refs.floating.current) {
      return (0,_floating_ui_react_dom_interactions__WEBPACK_IMPORTED_MODULE_1__/* .autoUpdate */ .Me)(floating.refs.reference.current, floating.refs.floating.current, floating.update);
    }
    return void 0;
  }, [floating.refs.reference, floating.refs.floating, opened, delayedUpdate]);
  (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useDidUpdate */ .l)(() => {
    floating.update();
  }, positionDependencies);
  (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useDidUpdate */ .l)(() => {
    setDelayedUpdate((c) => c + 1);
  }, [opened]);
}


//# sourceMappingURL=use-floating-auto-update.js.map


/***/ }),

/***/ 49467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ Col; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.context.js
var Grid_context = __webpack_require__(49644);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/default-theme.js + 1 modules
var default_theme = __webpack_require__(37447);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Grid/Col/Col.styles.js


var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const getColumnFlexBasis = (colSpan, columns) => {
  if (colSpan === "content") {
    return "auto";
  }
  if (colSpan === "auto") {
    return "0px";
  }
  return colSpan ? `${100 / (columns / colSpan)}%` : void 0;
};
const getColumnMaxWidth = (colSpan, columns, grow) => {
  if (grow || colSpan === "auto" || colSpan === "content") {
    return "unset";
  }
  return getColumnFlexBasis(colSpan, columns);
};
const getColumnFlexGrow = (colSpan, grow) => {
  if (!colSpan) {
    return void 0;
  }
  return colSpan === "auto" || grow ? 1 : 0;
};
const getColumnOffset = (offset, columns) => offset === 0 ? 0 : offset ? `${100 / (columns / offset)}%` : void 0;
const getGutterSize = (gutter, theme) => typeof gutter !== "undefined" ? theme.fn.size({ size: gutter, sizes: theme.spacing }) / 2 : void 0;
function getBreakpointsStyles({
  sizes,
  offsets,
  orders,
  theme,
  columns,
  gutters,
  grow
}) {
  return default_theme/* MANTINE_SIZES.reduce */.j1.reduce((acc, size) => {
    acc[`@media (min-width: ${theme.breakpoints[size]}px)`] = {
      order: orders[size],
      flexBasis: getColumnFlexBasis(sizes[size], columns),
      padding: getGutterSize(gutters[size], theme),
      flexShrink: 0,
      width: sizes[size] === "content" ? "auto" : void 0,
      maxWidth: getColumnMaxWidth(sizes[size], columns, grow),
      marginLeft: getColumnOffset(offsets[size], columns),
      flexGrow: getColumnFlexGrow(sizes[size], grow)
    };
    return acc;
  }, {});
}
var useStyles = (0,create_styles/* createStyles */.k)((theme, {
  gutter,
  gutterXs,
  gutterSm,
  gutterMd,
  gutterLg,
  gutterXl,
  grow,
  offset,
  offsetXs,
  offsetSm,
  offsetMd,
  offsetLg,
  offsetXl,
  columns,
  span,
  xs,
  sm,
  md,
  lg,
  xl,
  order,
  orderXs,
  orderSm,
  orderMd,
  orderLg,
  orderXl
}) => ({
  col: __spreadValues({
    boxSizing: "border-box",
    flexGrow: getColumnFlexGrow(span, grow),
    order,
    padding: getGutterSize(gutter, theme),
    marginLeft: getColumnOffset(offset, columns),
    flexBasis: getColumnFlexBasis(span, columns),
    flexShrink: 0,
    width: span === "content" ? "auto" : void 0,
    maxWidth: getColumnMaxWidth(span, columns, grow)
  }, getBreakpointsStyles({
    sizes: { xs, sm, md, lg, xl },
    offsets: { xs: offsetXs, sm: offsetSm, md: offsetMd, lg: offsetLg, xl: offsetXl },
    orders: { xs: orderXs, sm: orderSm, md: orderMd, lg: orderLg, xl: orderXl },
    gutters: { xs: gutterXs, sm: gutterSm, md: gutterMd, lg: gutterLg, xl: gutterXl },
    theme,
    columns,
    grow
  }))
}));

/* harmony default export */ var Col_styles = (useStyles);
//# sourceMappingURL=Col.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Grid/Col/Col.js






var Col_defProp = Object.defineProperty;
var Col_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Col_hasOwnProp = Object.prototype.hasOwnProperty;
var Col_propIsEnum = Object.prototype.propertyIsEnumerable;
var Col_defNormalProp = (obj, key, value) => key in obj ? Col_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Col_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Col_hasOwnProp.call(b, prop))
      Col_defNormalProp(a, prop, b[prop]);
  if (Col_getOwnPropSymbols)
    for (var prop of Col_getOwnPropSymbols(b)) {
      if (Col_propIsEnum.call(b, prop))
        Col_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Col_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Col_getOwnPropSymbols)
    for (var prop of Col_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Col_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {};
function isValidSpan(span) {
  if (span === "auto" || span === "content") {
    return true;
  }
  return typeof span === "number" && span > 0 && span % 1 === 0;
}
const Col = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("GridCol", defaultProps, props), {
    children,
    span,
    offset,
    offsetXs,
    offsetSm,
    offsetMd,
    offsetLg,
    offsetXl,
    xs,
    sm,
    md,
    lg,
    xl,
    order,
    orderXs,
    orderSm,
    orderMd,
    orderLg,
    orderXl,
    className,
    id,
    unstyled
  } = _a, others = __objRest(_a, [
    "children",
    "span",
    "offset",
    "offsetXs",
    "offsetSm",
    "offsetMd",
    "offsetLg",
    "offsetXl",
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "order",
    "orderXs",
    "orderSm",
    "orderMd",
    "orderLg",
    "orderXl",
    "className",
    "id",
    "unstyled"
  ]);
  const ctx = (0,Grid_context/* useGridContext */.n)();
  const colSpan = span || ctx.columns;
  const { classes, cx } = Col_styles({
    gutter: ctx.gutter,
    gutterXs: ctx.gutterXs,
    gutterSm: ctx.gutterSm,
    gutterMd: ctx.gutterMd,
    gutterLg: ctx.gutterLg,
    gutterXl: ctx.gutterXl,
    offset,
    offsetXs,
    offsetSm,
    offsetMd,
    offsetLg,
    offsetXl,
    xs,
    sm,
    md,
    lg,
    xl,
    order,
    orderXs,
    orderSm,
    orderMd,
    orderLg,
    orderXl,
    grow: ctx.grow,
    columns: ctx.columns,
    span: colSpan
  }, { unstyled, name: "Grid" });
  if (!isValidSpan(colSpan) || colSpan > ctx.columns) {
    return null;
  }
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, Col_spreadValues({
    className: cx(classes.col, className),
    ref
  }, others), children);
});
Col.displayName = "@mantine/core/Col";


//# sourceMappingURL=Col.js.map


/***/ }),

/***/ 49644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ GridProvider; },
/* harmony export */   "n": function() { return /* binding */ useGridContext; }
/* harmony export */ });
/* harmony import */ var _mantine_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68216);


const [GridProvider, useGridContext] = (0,_mantine_utils__WEBPACK_IMPORTED_MODULE_0__/* .createSafeContext */ .R)("Grid component was not found in tree");


//# sourceMappingURL=Grid.context.js.map


/***/ }),

/***/ 62679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ Grid; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Col/Col.js + 1 modules
var Col = __webpack_require__(49467);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.context.js
var Grid_context = __webpack_require__(49644);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/default-theme.js + 1 modules
var default_theme = __webpack_require__(37447);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.styles.js


var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function getGutterStyles(gutters, theme) {
  return default_theme/* MANTINE_SIZES.reduce */.j1.reduce((acc, size) => {
    if (typeof gutters[size] !== "undefined") {
      acc[`@media (min-width: ${theme.breakpoints[size]}px)`] = {
        margin: -theme.fn.size({ size: gutters[size], sizes: theme.spacing }) / 2
      };
    }
    return acc;
  }, {});
}
var useStyles = (0,create_styles/* createStyles */.k)((theme, { justify, align, gutter, gutterXs, gutterSm, gutterMd, gutterLg, gutterXl }) => ({
  root: __spreadValues({
    margin: -theme.fn.size({ size: gutter, sizes: theme.spacing }) / 2,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: justify,
    alignItems: align
  }, getGutterStyles({ xs: gutterXs, sm: gutterSm, md: gutterMd, lg: gutterLg, xl: gutterXl }, theme))
}));

/* harmony default export */ var Grid_styles = (useStyles);
//# sourceMappingURL=Grid.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js







var Grid_defProp = Object.defineProperty;
var Grid_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Grid_hasOwnProp = Object.prototype.hasOwnProperty;
var Grid_propIsEnum = Object.prototype.propertyIsEnumerable;
var Grid_defNormalProp = (obj, key, value) => key in obj ? Grid_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Grid_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Grid_hasOwnProp.call(b, prop))
      Grid_defNormalProp(a, prop, b[prop]);
  if (Grid_getOwnPropSymbols)
    for (var prop of Grid_getOwnPropSymbols(b)) {
      if (Grid_propIsEnum.call(b, prop))
        Grid_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Grid_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Grid_getOwnPropSymbols)
    for (var prop of Grid_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Grid_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  gutter: "md",
  justify: "flex-start",
  align: "stretch",
  columns: 12
};
const Grid = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Grid", defaultProps, props), {
    gutter,
    gutterXs,
    gutterSm,
    gutterMd,
    gutterLg,
    gutterXl,
    children,
    grow,
    justify,
    align,
    columns,
    className,
    id,
    unstyled
  } = _a, others = __objRest(_a, [
    "gutter",
    "gutterXs",
    "gutterSm",
    "gutterMd",
    "gutterLg",
    "gutterXl",
    "children",
    "grow",
    "justify",
    "align",
    "columns",
    "className",
    "id",
    "unstyled"
  ]);
  const { classes, cx } = Grid_styles({ gutter, justify, align, gutterXs, gutterSm, gutterMd, gutterLg, gutterXl }, { unstyled, name: "Grid" });
  return /* @__PURE__ */ react.createElement(Grid_context/* GridProvider */.k, {
    value: { gutter, gutterXs, gutterSm, gutterMd, gutterLg, gutterXl, grow, columns }
  }, /* @__PURE__ */ react.createElement(Box/* Box */.x, Grid_spreadValues({
    className: cx(classes.root, className),
    ref
  }, others), children));
});
Grid.Col = Col/* Col */.J;
Grid.displayName = "@mantine/core/Grid";


//# sourceMappingURL=Grid.js.map


/***/ }),

/***/ 66137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Group; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Group/filter-falsy-children/filter-falsy-children.js


function filterFalsyChildren(children) {
  return react.Children.toArray(children).filter(Boolean);
}


//# sourceMappingURL=filter-falsy-children.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Group/Group.styles.js


const GROUP_POSITIONS = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
  apart: "space-between"
};
var useStyles = (0,create_styles/* createStyles */.k)((theme, { spacing, position, noWrap, grow, align, count }) => ({
  root: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    alignItems: align || "center",
    flexWrap: noWrap ? "nowrap" : "wrap",
    justifyContent: GROUP_POSITIONS[position],
    gap: theme.fn.size({ size: spacing, sizes: theme.spacing }),
    "& > *": {
      boxSizing: "border-box",
      maxWidth: grow ? `calc(${100 / count}% - ${theme.fn.size({ size: spacing, sizes: theme.spacing }) - theme.fn.size({ size: spacing, sizes: theme.spacing }) / count}px)` : void 0,
      flexGrow: grow ? 1 : 0
    }
  }
}));

/* harmony default export */ var Group_styles = (useStyles);

//# sourceMappingURL=Group.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Group/Group.js






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  position: "left",
  spacing: "md"
};
const Group = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Group", defaultProps, props), { className, position, align, children, noWrap, grow, spacing, unstyled } = _a, others = __objRest(_a, ["className", "position", "align", "children", "noWrap", "grow", "spacing", "unstyled"]);
  const filteredChildren = filterFalsyChildren(children);
  const { classes, cx } = Group_styles({
    align,
    grow,
    noWrap,
    spacing,
    position,
    count: filteredChildren.length
  }, { unstyled, name: "Group" });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.root, className),
    ref
  }, others), filteredChildren);
});
Group.displayName = "@mantine/core/Group";


//# sourceMappingURL=Group.js.map


/***/ }),

/***/ 36155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Indicator; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/utils/get-default-z-index/get-default-z-index.js
var get_default_z_index = __webpack_require__(3594);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Indicator/Indicator.styles.js


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const processingAnimation = (color) => (0,emotion_react_browser_esm/* keyframes */.F4)({
  from: {
    boxShadow: `0 0 0.5px 0 ${color}`,
    opacity: 0.6
  },
  to: {
    boxShadow: `0 0 0.5px 4.4px ${color}`,
    opacity: 0
  }
});
function getPositionStyles(_position, offset = 0) {
  const styles = {};
  const [position, placement] = _position.split("-");
  let translateX = "";
  let translateY = "";
  if (position === "top") {
    styles.top = offset;
    translateY = "-50%";
  }
  if (position === "middle") {
    styles.top = "50%";
    translateY = "-50%";
  }
  if (position === "bottom") {
    styles.bottom = offset;
    translateY = "50%";
  }
  if (placement === "start") {
    styles.left = offset;
    translateX = "-50%";
  }
  if (placement === "center") {
    styles.left = "50%";
    translateX = "-50%";
  }
  if (placement === "end") {
    styles.right = offset;
    translateX = "50%";
  }
  styles.transform = `translate(${translateX}, ${translateY})`;
  return styles;
}
var useStyles = (0,create_styles/* createStyles */.k)((theme, {
  radius,
  size,
  color,
  position,
  offset,
  inline,
  withBorder,
  withLabel,
  zIndex
}) => {
  const { background } = theme.fn.variant({
    variant: "filled",
    primaryFallback: false,
    color: color || theme.primaryColor
  });
  return {
    root: {
      position: "relative",
      display: inline ? "inline-block" : "block"
    },
    indicator: __spreadProps(__spreadValues({}, getPositionStyles(position, offset)), {
      zIndex,
      position: "absolute",
      [withLabel ? "minWidth" : "width"]: size,
      height: size,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: theme.fontSizes.xs,
      paddingLeft: withLabel ? `calc(${theme.spacing.xs}px / 2)` : 0,
      paddingRight: withLabel ? `calc(${theme.spacing.xs}px / 2)` : 0,
      borderRadius: theme.fn.size({ size: radius, sizes: theme.radius }),
      backgroundColor: theme.fn.variant({
        variant: "filled",
        primaryFallback: false,
        color: color || theme.primaryColor
      }).background,
      border: withBorder ? `2px solid ${theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white}` : void 0,
      color: theme.white,
      whiteSpace: "nowrap"
    }),
    processing: {
      animation: `${processingAnimation(background)} 1000ms linear infinite`
    },
    common: __spreadProps(__spreadValues({}, getPositionStyles(position, offset)), {
      position: "absolute",
      [withLabel ? "minWidth" : "width"]: size,
      height: size,
      borderRadius: theme.fn.size({ size: radius, sizes: theme.radius })
    })
  };
});

/* harmony default export */ var Indicator_styles = (useStyles);
//# sourceMappingURL=Indicator.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-previous/use-previous.js


function usePrevious(value) {
  const ref = (0,react.useRef)();
  (0,react.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}


//# sourceMappingURL=use-previous.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Indicator/Machine/MachineNumber.styles.js


const currentScrollDownKeyframes = (0,emotion_react_browser_esm/* keyframes */.F4)({
  from: {
    transform: "translateY(-60%)",
    opacity: 0
  },
  to: {
    transform: "translateY(0%)",
    opacity: 1
  }
});
const currentScrollUpKeyframes = (0,emotion_react_browser_esm/* keyframes */.F4)({
  from: {
    transform: "translateY(60%)",
    opacity: 0
  },
  to: {
    transform: "translateY(0%)",
    opacity: 1
  }
});
const oldNumberScrollUpKeyframes = (0,emotion_react_browser_esm/* keyframes */.F4)({
  from: {
    transform: "translateY(0%)",
    opacity: 1
  },
  to: {
    transform: "translateY(-60%)",
    opacity: 0
  }
});
const oldNumberScrollDownKeyframes = (0,emotion_react_browser_esm/* keyframes */.F4)({
  from: {
    transform: "translateY(0%)",
    opacity: 1
  },
  to: {
    transform: "translateY(60%)",
    opacity: 0
  }
});
var MachineNumber_styles_useStyles = (0,create_styles/* createStyles */.k)(() => ({
  baseNumber: {
    height: 18,
    width: "0.6em",
    maxWidth: "0.6em",
    position: "relative",
    display: "inline-block"
  },
  oldNumberTop: {
    transform: "translateY(-100%);"
  },
  oldNumberBottom: {
    transform: "translateY(100%);"
  },
  oldNumber: {
    display: "inline-block",
    opacity: 0,
    position: "absolute",
    left: 0,
    right: 0
  },
  currentNumberTop: {
    transform: "translateY(0%);"
  },
  currentNumber: {
    display: "inline-block",
    opacity: 1,
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  currentNumberScrollDown: {
    animation: `${currentScrollDownKeyframes} .2s cubic-bezier(0,0,.2, 1)`,
    animationIterationCount: 1
  },
  currentNumberScrollUp: {
    animation: `${currentScrollUpKeyframes} .2s cubic-bezier(0,0,.2, 1)`,
    animationIterationCount: 1
  },
  oldNumberScrollUp: {
    animation: `${oldNumberScrollUpKeyframes} .2s cubic-bezier(0,0,.2, 1)`,
    animationIterationCount: 1
  },
  oldNumberScrollDown: {
    animation: `${oldNumberScrollDownKeyframes} .2s cubic-bezier(0,0,.2, 1)`,
    animationIterationCount: 1
  }
}));

/* harmony default export */ var MachineNumber_styles = (MachineNumber_styles_useStyles);
//# sourceMappingURL=MachineNumber.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Indicator/Machine/MachineNumber.js




const MachineNumber = (0,react.forwardRef)((props, ref) => {
  const [oldNumber, setOldNumber] = (0,react.useState)(props.value);
  const [newNumber, setNewNumber] = (0,react.useState)(props.value);
  const [scrollAnimationDirection, setScrollAnimationDirection] = (0,react.useState)("up");
  const [isActive, setIsActive] = (0,react.useState)(false);
  const prevValueRef = usePrevious(props.value);
  const scrollByDir = (dir) => {
    setIsActive(true);
    setScrollAnimationDirection(dir);
    setTimeout(() => {
      setIsActive(false);
    }, 180);
  };
  const scroll = () => {
    const { newOriginalNumber, oldOriginalNumber } = props;
    if (newOriginalNumber == null || oldOriginalNumber == null) {
      return;
    }
    if (newOriginalNumber > oldOriginalNumber) {
      scrollByDir("up");
    } else if (newOriginalNumber < oldOriginalNumber) {
      scrollByDir("down");
    }
  };
  (0,react.useEffect)(() => {
    setOldNumber(prevValueRef);
    setNewNumber(props.value);
    scroll();
  }, [props.value, prevValueRef]);
  const { classes, cx } = MachineNumber_styles(null, { name: "MachineNumber" });
  const newNumberScrollAnimationClass = (0,react.useMemo)(() => isActive ? scrollAnimationDirection === "up" ? classes.currentNumberScrollUp : classes.currentNumberScrollDown : null, [isActive, scrollAnimationDirection]);
  const oldNumberScrollAnimationClass = (0,react.useMemo)(() => isActive ? scrollAnimationDirection === "up" ? classes.oldNumberScrollUp : classes.oldNumberScrollDown : null, [isActive, scrollAnimationDirection]);
  return /* @__PURE__ */ react.createElement("span", {
    ref,
    className: classes.baseNumber
  }, oldNumber && /* @__PURE__ */ react.createElement("span", {
    className: cx(classes.oldNumber, classes.currentNumberTop, oldNumberScrollAnimationClass)
  }, oldNumber) || null, /* @__PURE__ */ react.createElement("span", null, /* @__PURE__ */ react.createElement("span", {
    className: cx(classes.currentNumber, newNumberScrollAnimationClass)
  }, newNumber)), oldNumber && /* @__PURE__ */ react.createElement("span", {
    className: cx(classes.oldNumber, classes.oldNumberBottom, oldNumberScrollAnimationClass)
  }, oldNumber) || null);
});


//# sourceMappingURL=MachineNumber.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Indicator/Machine/Machine.styles.js


var Machine_styles_useStyles = (0,create_styles/* createStyles */.k)(() => ({
  base: {
    display: "flex",
    alignItems: "center",
    overflow: "hidden"
  }
}));

/* harmony default export */ var Machine_styles = (Machine_styles_useStyles);
//# sourceMappingURL=Machine.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Indicator/Machine/Machine.js





const Machine = (0,react.forwardRef)(({ value = 0, max }, ref) => {
  const [oldValue, setOldValue] = (0,react.useState)();
  const [newValue, setNewValue] = (0,react.useState)();
  const prevValueRef = usePrevious(value);
  (0,react.useEffect)(() => {
    if (typeof value === "string") {
      setOldValue(void 0);
      setNewValue(void 0);
    } else if (typeof prevValueRef === "string") {
      setOldValue(void 0);
      setNewValue(value);
    } else {
      setOldValue(prevValueRef);
      setNewValue(value);
    }
  }, [value, prevValueRef]);
  const numbers = (0,react.useMemo)(() => {
    if (typeof value === "string") {
      return [];
    }
    if (value < 1) {
      return [0];
    }
    const result = [];
    let currentValue = value;
    if (typeof max === "number") {
      currentValue = Math.min(max, currentValue);
    }
    while (currentValue >= 1) {
      result.push(currentValue % 10);
      currentValue /= 10;
      currentValue = Math.floor(currentValue);
    }
    result.reverse();
    return result;
  }, [value, max]);
  const { classes } = Machine_styles(null, { name: "machine" });
  return typeof value === "string" ? /* @__PURE__ */ react.createElement("span", {
    ref
  }, value) : /* @__PURE__ */ react.createElement("span", {
    ref,
    className: classes.base
  }, numbers.map((number, i) => /* @__PURE__ */ react.createElement(MachineNumber, {
    key: numbers.length - i - 1,
    value: number,
    oldOriginalNumber: oldValue,
    newOriginalNumber: newValue
  })), typeof max === "number" && value > max && /* @__PURE__ */ react.createElement("span", null, "+"));
});


//# sourceMappingURL=Machine.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Indicator/Indicator.js






var Indicator_defProp = Object.defineProperty;
var Indicator_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Indicator_hasOwnProp = Object.prototype.hasOwnProperty;
var Indicator_propIsEnum = Object.prototype.propertyIsEnumerable;
var Indicator_defNormalProp = (obj, key, value) => key in obj ? Indicator_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Indicator_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Indicator_hasOwnProp.call(b, prop))
      Indicator_defNormalProp(a, prop, b[prop]);
  if (Indicator_getOwnPropSymbols)
    for (var prop of Indicator_getOwnPropSymbols(b)) {
      if (Indicator_propIsEnum.call(b, prop))
        Indicator_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Indicator_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Indicator_getOwnPropSymbols)
    for (var prop of Indicator_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Indicator_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  position: "top-end",
  offset: 0,
  inline: false,
  withBorder: false,
  disabled: false,
  showZero: true,
  processing: false,
  dot: true,
  size: 10,
  overflowCount: 99,
  radius: 1e3,
  zIndex: (0,get_default_z_index/* getDefaultZIndex */.w)("app")
};
const Indicator = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Indicator", defaultProps, props), {
    children,
    position,
    offset,
    size,
    radius,
    inline,
    withBorder,
    className,
    color,
    dot,
    styles,
    label,
    overflowCount,
    showZero,
    classNames,
    disabled,
    zIndex,
    unstyled,
    processing
  } = _a, others = __objRest(_a, [
    "children",
    "position",
    "offset",
    "size",
    "radius",
    "inline",
    "withBorder",
    "className",
    "color",
    "dot",
    "styles",
    "label",
    "overflowCount",
    "showZero",
    "classNames",
    "disabled",
    "zIndex",
    "unstyled",
    "processing"
  ]);
  const { classes, cx } = Indicator_styles({ position, offset, size, radius, inline, color, withBorder, zIndex, withLabel: !!label }, { name: "Indicator", classNames, styles, unstyled });
  const renderLabel = (0,react.useMemo)(() => {
    if (typeof label === "number") {
      return /* @__PURE__ */ react.createElement(Machine, {
        value: label,
        max: overflowCount
      });
    }
    return label;
  }, [label, overflowCount]);
  const isShowIndicator = (0,react.useMemo)(() => !disabled && (dot || label != null && !(label <= 0 && !showZero)), [disabled, label, showZero]);
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, Indicator_spreadValues({
    ref,
    className: cx(classes.root, className)
  }, others), isShowIndicator && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("div", {
    className: cx(classes.indicator, classes.common)
  }, renderLabel), processing && /* @__PURE__ */ react.createElement("div", {
    className: cx(classes.processing, classes.common)
  })), children);
});
Indicator.displayName = "@mantine/core/Indicator";


//# sourceMappingURL=Indicator.js.map


/***/ }),

/***/ 94151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ Input; }
});

// UNUSED EXPORTS: _Input

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Input/InputLabel/InputLabel.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { size }) => ({
  label: {
    display: "inline-block",
    fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
    fontWeight: 500,
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[9],
    wordBreak: "break-word",
    cursor: "default",
    WebkitTapHighlightColor: "transparent"
  },
  required: {
    color: theme.fn.variant({ variant: "filled", color: "red" }).background
  }
}));

/* harmony default export */ var InputLabel_styles = (useStyles);
//# sourceMappingURL=InputLabel.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Input/InputLabel/InputLabel.js





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  labelElement: "label",
  size: "sm"
};
const InputLabel = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("InputLabel", defaultProps, props), {
    labelElement,
    children,
    required,
    size,
    classNames,
    styles,
    unstyled,
    className,
    htmlFor,
    __staticSelector
  } = _a, others = __objRest(_a, [
    "labelElement",
    "children",
    "required",
    "size",
    "classNames",
    "styles",
    "unstyled",
    "className",
    "htmlFor",
    "__staticSelector"
  ]);
  const { classes, cx } = InputLabel_styles({ size }, { name: ["InputWrapper", __staticSelector], classNames, styles, unstyled });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    component: labelElement,
    ref,
    className: cx(classes.label, className),
    htmlFor: labelElement === "label" ? htmlFor : void 0
  }, others), children, required && /* @__PURE__ */ react.createElement("span", {
    className: classes.required,
    "aria-hidden": true
  }, " *"));
});
InputLabel.displayName = "@mantine/core/InputLabel";


//# sourceMappingURL=InputLabel.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Input/InputError/InputError.styles.js


var InputError_styles_useStyles = (0,create_styles/* createStyles */.k)((theme, { size }) => ({
  error: {
    wordBreak: "break-word",
    color: theme.fn.variant({ variant: "filled", color: "red" }).background,
    fontSize: theme.fn.size({ size, sizes: theme.fontSizes }) - 2,
    lineHeight: 1.2,
    display: "block"
  }
}));

/* harmony default export */ var InputError_styles = (InputError_styles_useStyles);
//# sourceMappingURL=InputError.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Input/InputError/InputError.js





var InputError_defProp = Object.defineProperty;
var InputError_getOwnPropSymbols = Object.getOwnPropertySymbols;
var InputError_hasOwnProp = Object.prototype.hasOwnProperty;
var InputError_propIsEnum = Object.prototype.propertyIsEnumerable;
var InputError_defNormalProp = (obj, key, value) => key in obj ? InputError_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var InputError_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (InputError_hasOwnProp.call(b, prop))
      InputError_defNormalProp(a, prop, b[prop]);
  if (InputError_getOwnPropSymbols)
    for (var prop of InputError_getOwnPropSymbols(b)) {
      if (InputError_propIsEnum.call(b, prop))
        InputError_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var InputError_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (InputError_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && InputError_getOwnPropSymbols)
    for (var prop of InputError_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && InputError_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InputError_defaultProps = {
  size: "sm"
};
const InputError = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("InputError", InputError_defaultProps, props), { children, className, classNames, styles, unstyled, size, __staticSelector } = _a, others = InputError_objRest(_a, ["children", "className", "classNames", "styles", "unstyled", "size", "__staticSelector"]);
  const { classes, cx } = InputError_styles({ size }, { name: ["InputWrapper", __staticSelector], classNames, styles, unstyled });
  return /* @__PURE__ */ react.createElement(Text/* Text */.x, InputError_spreadValues({
    className: cx(classes.error, className),
    ref
  }, others), children);
});
InputError.displayName = "@mantine/core/InputError";


//# sourceMappingURL=InputError.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Input/InputDescription/InputDescription.styles.js


var InputDescription_styles_useStyles = (0,create_styles/* createStyles */.k)((theme, { size }) => ({
  description: {
    wordBreak: "break-word",
    color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
    fontSize: theme.fn.size({ size, sizes: theme.fontSizes }) - 2,
    lineHeight: 1.2,
    display: "block"
  }
}));

/* harmony default export */ var InputDescription_styles = (InputDescription_styles_useStyles);
//# sourceMappingURL=InputDescription.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Input/InputDescription/InputDescription.js





var InputDescription_defProp = Object.defineProperty;
var InputDescription_getOwnPropSymbols = Object.getOwnPropertySymbols;
var InputDescription_hasOwnProp = Object.prototype.hasOwnProperty;
var InputDescription_propIsEnum = Object.prototype.propertyIsEnumerable;
var InputDescription_defNormalProp = (obj, key, value) => key in obj ? InputDescription_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var InputDescription_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (InputDescription_hasOwnProp.call(b, prop))
      InputDescription_defNormalProp(a, prop, b[prop]);
  if (InputDescription_getOwnPropSymbols)
    for (var prop of InputDescription_getOwnPropSymbols(b)) {
      if (InputDescription_propIsEnum.call(b, prop))
        InputDescription_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var InputDescription_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (InputDescription_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && InputDescription_getOwnPropSymbols)
    for (var prop of InputDescription_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && InputDescription_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InputDescription_defaultProps = {
  size: "sm"
};
const InputDescription = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("InputDescription", InputDescription_defaultProps, props), { children, className, classNames, styles, unstyled, size, __staticSelector } = _a, others = InputDescription_objRest(_a, ["children", "className", "classNames", "styles", "unstyled", "size", "__staticSelector"]);
  const { classes, cx } = InputDescription_styles({ size }, { name: ["InputWrapper", __staticSelector], classNames, styles, unstyled });
  return /* @__PURE__ */ react.createElement(Text/* Text */.x, InputDescription_spreadValues({
    color: "dimmed",
    className: cx(classes.description, className),
    ref,
    unstyled
  }, others), children);
});
InputDescription.displayName = "@mantine/core/InputDescription";


//# sourceMappingURL=InputDescription.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Input/InputWrapper.context.js


const InputWrapperContext = (0,react.createContext)({
  offsetBottom: false,
  offsetTop: false,
  describedBy: void 0
});
const InputWrapperProvider = InputWrapperContext.Provider;
const useInputWrapperContext = () => (0,react.useContext)(InputWrapperContext);


//# sourceMappingURL=InputWrapper.context.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Input/InputWrapper/get-input-offsets.js
function getInputOffsets(inputWrapperOrder, { hasDescription, hasError }) {
  const inputIndex = inputWrapperOrder.findIndex((part) => part === "input");
  const aboveInput = inputWrapperOrder[inputIndex - 1];
  const belowInput = inputWrapperOrder[inputIndex + 1];
  const offsetTop = hasDescription && aboveInput === "description" || hasError && aboveInput === "error";
  const offsetBottom = hasDescription && belowInput === "description" || hasError && belowInput === "error";
  return { offsetBottom, offsetTop };
}


//# sourceMappingURL=get-input-offsets.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Input/InputWrapper/InputWrapper.styles.js


var InputWrapper_styles_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var InputWrapper_styles_getOwnPropSymbols = Object.getOwnPropertySymbols;
var InputWrapper_styles_hasOwnProp = Object.prototype.hasOwnProperty;
var InputWrapper_styles_propIsEnum = Object.prototype.propertyIsEnumerable;
var InputWrapper_styles_defNormalProp = (obj, key, value) => key in obj ? InputWrapper_styles_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var InputWrapper_styles_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (InputWrapper_styles_hasOwnProp.call(b, prop))
      InputWrapper_styles_defNormalProp(a, prop, b[prop]);
  if (InputWrapper_styles_getOwnPropSymbols)
    for (var prop of InputWrapper_styles_getOwnPropSymbols(b)) {
      if (InputWrapper_styles_propIsEnum.call(b, prop))
        InputWrapper_styles_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var InputWrapper_styles_useStyles = (0,create_styles/* createStyles */.k)((theme) => ({
  root: __spreadProps(InputWrapper_styles_spreadValues({}, theme.fn.fontStyles()), {
    lineHeight: theme.lineHeight
  })
}));

/* harmony default export */ var InputWrapper_styles = (InputWrapper_styles_useStyles);
//# sourceMappingURL=InputWrapper.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Input/InputWrapper/InputWrapper.js










var InputWrapper_defProp = Object.defineProperty;
var InputWrapper_defProps = Object.defineProperties;
var InputWrapper_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var InputWrapper_getOwnPropSymbols = Object.getOwnPropertySymbols;
var InputWrapper_hasOwnProp = Object.prototype.hasOwnProperty;
var InputWrapper_propIsEnum = Object.prototype.propertyIsEnumerable;
var InputWrapper_defNormalProp = (obj, key, value) => key in obj ? InputWrapper_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var InputWrapper_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (InputWrapper_hasOwnProp.call(b, prop))
      InputWrapper_defNormalProp(a, prop, b[prop]);
  if (InputWrapper_getOwnPropSymbols)
    for (var prop of InputWrapper_getOwnPropSymbols(b)) {
      if (InputWrapper_propIsEnum.call(b, prop))
        InputWrapper_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var InputWrapper_spreadProps = (a, b) => InputWrapper_defProps(a, InputWrapper_getOwnPropDescs(b));
var InputWrapper_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (InputWrapper_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && InputWrapper_getOwnPropSymbols)
    for (var prop of InputWrapper_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && InputWrapper_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InputWrapper_defaultProps = {
  labelElement: "label",
  size: "sm",
  inputContainer: (children) => children,
  inputWrapperOrder: ["label", "description", "input", "error"]
};
const InputWrapper = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("InputWrapper", InputWrapper_defaultProps, props), {
    className,
    label,
    children,
    required,
    id,
    error,
    description,
    labelElement,
    labelProps,
    descriptionProps,
    errorProps,
    classNames,
    styles,
    size,
    inputContainer,
    __staticSelector,
    unstyled,
    inputWrapperOrder,
    withAsterisk
  } = _a, others = InputWrapper_objRest(_a, [
    "className",
    "label",
    "children",
    "required",
    "id",
    "error",
    "description",
    "labelElement",
    "labelProps",
    "descriptionProps",
    "errorProps",
    "classNames",
    "styles",
    "size",
    "inputContainer",
    "__staticSelector",
    "unstyled",
    "inputWrapperOrder",
    "withAsterisk"
  ]);
  const { classes, cx } = InputWrapper_styles(null, {
    classNames,
    styles,
    name: ["InputWrapper", __staticSelector],
    unstyled
  });
  const sharedProps = {
    classNames,
    styles,
    unstyled,
    size,
    __staticSelector
  };
  const isRequired = typeof withAsterisk === "boolean" ? withAsterisk : required;
  const errorId = id ? `${id}-error` : errorProps == null ? void 0 : errorProps.id;
  const descriptionId = id ? `${id}-description` : descriptionProps == null ? void 0 : descriptionProps.id;
  const hasError = !!error && typeof error !== "boolean";
  const _describedBy = `${hasError ? errorId : ""} ${description ? descriptionId : ""}`;
  const describedBy = _describedBy.trim().length > 0 ? _describedBy.trim() : void 0;
  const _label = label && /* @__PURE__ */ react.createElement(InputLabel, InputWrapper_spreadValues(InputWrapper_spreadValues({
    key: "label",
    labelElement,
    id: id ? `${id}-label` : void 0,
    htmlFor: id,
    required: isRequired
  }, sharedProps), labelProps), label);
  const _description = description && /* @__PURE__ */ react.createElement(InputDescription, InputWrapper_spreadProps(InputWrapper_spreadValues(InputWrapper_spreadValues({
    key: "description"
  }, descriptionProps), sharedProps), {
    size: (descriptionProps == null ? void 0 : descriptionProps.size) || sharedProps.size,
    id: (descriptionProps == null ? void 0 : descriptionProps.id) || descriptionId
  }), description);
  const _input = /* @__PURE__ */ react.createElement(react.Fragment, {
    key: "input"
  }, inputContainer(children));
  const _error = typeof error !== "boolean" && error && /* @__PURE__ */ react.createElement(InputError, InputWrapper_spreadProps(InputWrapper_spreadValues(InputWrapper_spreadValues({}, errorProps), sharedProps), {
    size: (errorProps == null ? void 0 : errorProps.size) || sharedProps.size,
    key: "error",
    id: (errorProps == null ? void 0 : errorProps.id) || errorId
  }), error);
  const content = inputWrapperOrder.map((part) => {
    switch (part) {
      case "label":
        return _label;
      case "input":
        return _input;
      case "description":
        return _description;
      case "error":
        return _error;
      default:
        return null;
    }
  });
  return /* @__PURE__ */ react.createElement(InputWrapperProvider, {
    value: InputWrapper_spreadValues({
      describedBy
    }, getInputOffsets(inputWrapperOrder, {
      hasDescription: !!_description,
      hasError: !!_error
    }))
  }, /* @__PURE__ */ react.createElement(Box/* Box */.x, InputWrapper_spreadValues({
    className: cx(classes.root, className),
    ref
  }, others), content));
});
InputWrapper.displayName = "@mantine/core/InputWrapper";


//# sourceMappingURL=InputWrapper.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/pack-sx/pack-sx.js
var pack_sx = __webpack_require__(97818);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Input/InputPlaceholder/InputPlaceholder.js





var InputPlaceholder_defProp = Object.defineProperty;
var InputPlaceholder_getOwnPropSymbols = Object.getOwnPropertySymbols;
var InputPlaceholder_hasOwnProp = Object.prototype.hasOwnProperty;
var InputPlaceholder_propIsEnum = Object.prototype.propertyIsEnumerable;
var InputPlaceholder_defNormalProp = (obj, key, value) => key in obj ? InputPlaceholder_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var InputPlaceholder_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (InputPlaceholder_hasOwnProp.call(b, prop))
      InputPlaceholder_defNormalProp(a, prop, b[prop]);
  if (InputPlaceholder_getOwnPropSymbols)
    for (var prop of InputPlaceholder_getOwnPropSymbols(b)) {
      if (InputPlaceholder_propIsEnum.call(b, prop))
        InputPlaceholder_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var InputPlaceholder_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (InputPlaceholder_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && InputPlaceholder_getOwnPropSymbols)
    for (var prop of InputPlaceholder_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && InputPlaceholder_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InputPlaceholder_defaultProps = {};
const InputPlaceholder = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("InputPlaceholder", InputPlaceholder_defaultProps, props), { sx } = _a, others = InputPlaceholder_objRest(_a, ["sx"]);
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, InputPlaceholder_spreadValues({
    component: "span",
    sx: [(theme) => theme.fn.placeholderStyles(), ...(0,pack_sx/* packSx */.R)(sx)],
    ref
  }, others));
});
InputPlaceholder.displayName = "@mantine/core/InputPlaceholder";


//# sourceMappingURL=InputPlaceholder.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Input/Input.styles.js
var Input_styles = __webpack_require__(35227);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/style-system-props/extract-system-styles/extract-system-styles.js
var extract_system_styles = __webpack_require__(12756);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Input/Input.js













var Input_defProp = Object.defineProperty;
var Input_defProps = Object.defineProperties;
var Input_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Input_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Input_hasOwnProp = Object.prototype.hasOwnProperty;
var Input_propIsEnum = Object.prototype.propertyIsEnumerable;
var Input_defNormalProp = (obj, key, value) => key in obj ? Input_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Input_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Input_hasOwnProp.call(b, prop))
      Input_defNormalProp(a, prop, b[prop]);
  if (Input_getOwnPropSymbols)
    for (var prop of Input_getOwnPropSymbols(b)) {
      if (Input_propIsEnum.call(b, prop))
        Input_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Input_spreadProps = (a, b) => Input_defProps(a, Input_getOwnPropDescs(b));
var Input_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Input_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Input_getOwnPropSymbols)
    for (var prop of Input_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Input_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Input_defaultProps = {
  rightSectionWidth: 36,
  size: "sm",
  variant: "default"
};
const _Input = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Input", Input_defaultProps, props), {
    className,
    invalid,
    required,
    disabled,
    variant,
    icon,
    style,
    rightSectionWidth,
    iconWidth,
    rightSection,
    rightSectionProps,
    radius,
    size,
    wrapperProps,
    classNames,
    styles,
    __staticSelector,
    multiline,
    sx,
    unstyled,
    pointer
  } = _a, others = Input_objRest(_a, [
    "className",
    "invalid",
    "required",
    "disabled",
    "variant",
    "icon",
    "style",
    "rightSectionWidth",
    "iconWidth",
    "rightSection",
    "rightSectionProps",
    "radius",
    "size",
    "wrapperProps",
    "classNames",
    "styles",
    "__staticSelector",
    "multiline",
    "sx",
    "unstyled",
    "pointer"
  ]);
  const { offsetBottom, offsetTop, describedBy } = useInputWrapperContext();
  const { classes, cx } = (0,Input_styles/* default */.Z)({
    radius,
    size,
    multiline,
    variant,
    invalid,
    rightSectionWidth,
    iconWidth,
    withRightSection: !!rightSection,
    offsetBottom,
    offsetTop,
    pointer
  }, { classNames, styles, name: ["Input", __staticSelector], unstyled });
  const { systemStyles, rest } = (0,extract_system_styles/* extractSystemStyles */.x)(others);
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, Input_spreadValues(Input_spreadValues({
    className: cx(classes.wrapper, className),
    sx,
    style
  }, systemStyles), wrapperProps), icon && /* @__PURE__ */ react.createElement("div", {
    className: classes.icon
  }, icon), /* @__PURE__ */ react.createElement(Box/* Box */.x, Input_spreadProps(Input_spreadValues({
    component: "input"
  }, rest), {
    ref,
    required,
    "aria-invalid": invalid,
    "aria-describedby": describedBy,
    disabled,
    className: cx(classes[`${variant}Variant`], classes.input, {
      [classes.withIcon]: icon,
      [classes.invalid]: invalid,
      [classes.disabled]: disabled
    })
  })), rightSection && /* @__PURE__ */ react.createElement("div", Input_spreadProps(Input_spreadValues({}, rightSectionProps), {
    className: classes.rightSection
  }), rightSection));
});
_Input.displayName = "@mantine/core/Input";
_Input.Wrapper = InputWrapper;
_Input.Label = InputLabel;
_Input.Description = InputDescription;
_Input.Error = InputError;
_Input.Placeholder = InputPlaceholder;
const Input = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_Input);


//# sourceMappingURL=Input.js.map


/***/ }),

/***/ 35227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ sizes; }
/* harmony export */ });
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56817);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const sizes = {
  xs: 30,
  sm: 36,
  md: 42,
  lg: 50,
  xl: 60
};
function getVariantStyles({ theme, variant }) {
  if (variant === "default") {
    return {
      border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]}`,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
      transition: "border-color 100ms ease",
      "&:focus, &:focus-within": theme.focusRingStyles.inputStyles(theme)
    };
  }
  if (variant === "filled") {
    return {
      border: "1px solid transparent",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1],
      "&:focus, &:focus-within": theme.focusRingStyles.inputStyles(theme)
    };
  }
  return {
    borderWidth: 0,
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    backgroundColor: "transparent",
    minHeight: 28,
    outline: 0,
    "&:focus, &:focus-within": {
      outline: "none",
      borderColor: "transparent"
    },
    "&:disabled": {
      backgroundColor: "transparent",
      "&:focus, &:focus-within": {
        outline: "none",
        borderColor: "transparent"
      }
    }
  };
}
var useStyles = (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_0__/* .createStyles */ .k)((theme, {
  size,
  multiline,
  radius,
  variant,
  invalid,
  rightSectionWidth,
  withRightSection,
  iconWidth,
  offsetBottom,
  offsetTop,
  pointer
}) => {
  const invalidColor = theme.fn.variant({ variant: "filled", color: "red" }).background;
  const sizeStyles = variant === "default" || variant === "filled" ? {
    minHeight: theme.fn.size({ size, sizes }),
    paddingLeft: theme.fn.size({ size, sizes }) / 3,
    paddingRight: withRightSection ? rightSectionWidth : theme.fn.size({ size, sizes }) / 3,
    borderRadius: theme.fn.radius(radius)
  } : null;
  return {
    wrapper: {
      position: "relative",
      marginTop: offsetTop ? `calc(${theme.spacing.xs}px / 2)` : void 0,
      marginBottom: offsetBottom ? `calc(${theme.spacing.xs}px / 2)` : void 0
    },
    input: __spreadValues(__spreadProps(__spreadValues(__spreadProps(__spreadValues({}, theme.fn.fontStyles()), {
      height: multiline ? variant === "unstyled" ? void 0 : "auto" : theme.fn.size({ size, sizes }),
      WebkitTapHighlightColor: "transparent",
      lineHeight: multiline ? theme.lineHeight : `${theme.fn.size({ size, sizes }) - 2}px`,
      appearance: "none",
      resize: "none",
      boxSizing: "border-box",
      fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
      width: "100%",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      display: "block",
      textAlign: "left",
      cursor: pointer ? "pointer" : void 0
    }), sizeStyles), {
      "&:disabled": {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[1],
        color: theme.colors.dark[2],
        opacity: 0.6,
        cursor: "not-allowed",
        "&::placeholder": {
          color: theme.colors.dark[2]
        }
      },
      "&::placeholder": __spreadProps(__spreadValues({}, theme.fn.placeholderStyles()), {
        opacity: 1
      }),
      "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button, &::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration": {
        appearance: "none"
      },
      "&[type=number]": {
        MozAppearance: "textfield"
      }
    }), getVariantStyles({ theme, variant })),
    withIcon: {
      paddingLeft: typeof iconWidth === "number" ? iconWidth : theme.fn.size({ size, sizes })
    },
    invalid: {
      color: invalidColor,
      borderColor: invalidColor,
      "&::placeholder": {
        opacity: 1,
        color: invalidColor
      }
    },
    disabled: {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[1],
      color: theme.colors.dark[2],
      opacity: 0.6,
      cursor: "not-allowed",
      "&::placeholder": {
        color: theme.colors.dark[2]
      }
    },
    icon: {
      pointerEvents: "none",
      position: "absolute",
      zIndex: 1,
      left: 0,
      top: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: typeof iconWidth === "number" ? iconWidth : theme.fn.size({ size, sizes }),
      color: invalid ? theme.colors.red[theme.colorScheme === "dark" ? 6 : 7] : theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[5]
    },
    rightSection: {
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: rightSectionWidth
    }
  };
});

/* harmony default export */ __webpack_exports__["Z"] = (useStyles);

//# sourceMappingURL=Input.styles.js.map


/***/ }),

/***/ 66261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useInputProps; }
/* harmony export */ });
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64761);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36289);
/* harmony import */ var _Box_style_system_props_extract_system_styles_extract_system_styles_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12756);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function useInputProps(component, defaultProps, props) {
  const _a = (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_0__/* .useComponentDefaultProps */ .N4)(component, defaultProps, props), {
    label,
    description,
    error,
    required,
    classNames,
    styles,
    className,
    unstyled,
    __staticSelector,
    sx,
    errorProps,
    labelProps,
    descriptionProps,
    wrapperProps,
    id,
    size,
    style,
    inputContainer,
    inputWrapperOrder,
    withAsterisk
  } = _a, others = __objRest(_a, [
    "label",
    "description",
    "error",
    "required",
    "classNames",
    "styles",
    "className",
    "unstyled",
    "__staticSelector",
    "sx",
    "errorProps",
    "labelProps",
    "descriptionProps",
    "wrapperProps",
    "id",
    "size",
    "style",
    "inputContainer",
    "inputWrapperOrder",
    "withAsterisk"
  ]);
  const uid = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useId */ .M)(id);
  const { systemStyles, rest } = (0,_Box_style_system_props_extract_system_styles_extract_system_styles_js__WEBPACK_IMPORTED_MODULE_2__/* .extractSystemStyles */ .x)(others);
  return __spreadProps(__spreadValues({}, rest), {
    classNames,
    styles,
    unstyled,
    wrapperProps: __spreadValues(__spreadValues({
      label,
      description,
      error,
      required,
      classNames,
      className,
      __staticSelector,
      sx,
      errorProps,
      labelProps,
      descriptionProps,
      unstyled,
      styles,
      id: uid,
      size,
      style,
      inputContainer,
      inputWrapperOrder,
      withAsterisk
    }, wrapperProps), systemStyles),
    inputProps: {
      required,
      classNames,
      styles,
      unstyled,
      id: uid,
      size,
      __staticSelector,
      invalid: !!error
    }
  });
}


//# sourceMappingURL=use-input-props.js.map


/***/ }),

/***/ 8949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ List; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-safe-context/create-safe-context.js
var create_safe_context = __webpack_require__(68216);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/List/List.context.js


const [ListProvider, useListContext] = (0,create_safe_context/* createSafeContext */.R)("List component was not found in tree");


//# sourceMappingURL=List.context.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/List/ListItem/ListItem.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { spacing, center }, getRef) => ({
  itemWrapper: {
    ref: getRef("itemWrapper"),
    display: "inline-flex",
    flexDirection: "column",
    whiteSpace: "normal"
  },
  item: {
    whiteSpace: "nowrap",
    lineHeight: center ? 1 : theme.lineHeight,
    "&:not(:first-of-type)": {
      marginTop: theme.fn.size({ size: spacing, sizes: theme.spacing })
    }
  },
  withIcon: {
    listStyle: "none",
    [`& .${getRef("itemWrapper")}`]: {
      display: "inline-flex",
      alignItems: center ? "center" : "flex-start",
      flexDirection: "row"
    }
  },
  itemIcon: {
    display: "inline-block",
    verticalAlign: "middle",
    marginRight: theme.spacing.sm
  }
}));

/* harmony default export */ var ListItem_styles = (useStyles);
//# sourceMappingURL=ListItem.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/List/ListItem/ListItem.js






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {};
const ListItem = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("ListItem", defaultProps, props), { className, children, icon } = _a, others = __objRest(_a, ["className", "children", "icon"]);
  const {
    icon: ctxIcon,
    spacing,
    center,
    listStyleType,
    size,
    withPadding,
    classNames,
    styles,
    unstyled
  } = useListContext();
  const _icon = icon || ctxIcon;
  const { classes, cx } = ListItem_styles({ withPadding, size, listStyleType, center, spacing }, { classNames, styles, unstyled, name: "List" });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    component: "li",
    className: cx(classes.item, { [classes.withIcon]: _icon }, className),
    ref
  }, others), /* @__PURE__ */ react.createElement("div", {
    className: classes.itemWrapper
  }, _icon && /* @__PURE__ */ react.createElement("span", {
    className: classes.itemIcon
  }, _icon), /* @__PURE__ */ react.createElement("span", null, children)));
});
ListItem.displayName = "@mantine/core/ListItem";


//# sourceMappingURL=ListItem.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/List/List.styles.js


var List_styles_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var List_styles_getOwnPropSymbols = Object.getOwnPropertySymbols;
var List_styles_hasOwnProp = Object.prototype.hasOwnProperty;
var List_styles_propIsEnum = Object.prototype.propertyIsEnumerable;
var List_styles_defNormalProp = (obj, key, value) => key in obj ? List_styles_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var List_styles_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (List_styles_hasOwnProp.call(b, prop))
      List_styles_defNormalProp(a, prop, b[prop]);
  if (List_styles_getOwnPropSymbols)
    for (var prop of List_styles_getOwnPropSymbols(b)) {
      if (List_styles_propIsEnum.call(b, prop))
        List_styles_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var List_styles_useStyles = (0,create_styles/* createStyles */.k)((theme, { withPadding, size, listStyleType }) => ({
  root: __spreadProps(List_styles_spreadValues({}, theme.fn.fontStyles()), {
    listStyleType,
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
    lineHeight: theme.lineHeight,
    margin: 0,
    paddingLeft: withPadding ? theme.spacing.xl : 0,
    listStylePosition: "inside"
  })
}));

/* harmony default export */ var List_styles = (List_styles_useStyles);
//# sourceMappingURL=List.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/List/List.js







var List_defProp = Object.defineProperty;
var List_getOwnPropSymbols = Object.getOwnPropertySymbols;
var List_hasOwnProp = Object.prototype.hasOwnProperty;
var List_propIsEnum = Object.prototype.propertyIsEnumerable;
var List_defNormalProp = (obj, key, value) => key in obj ? List_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var List_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (List_hasOwnProp.call(b, prop))
      List_defNormalProp(a, prop, b[prop]);
  if (List_getOwnPropSymbols)
    for (var prop of List_getOwnPropSymbols(b)) {
      if (List_propIsEnum.call(b, prop))
        List_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var List_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (List_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && List_getOwnPropSymbols)
    for (var prop of List_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && List_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const List_defaultProps = {
  type: "unordered",
  size: "md",
  spacing: 0
};
const List = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("List", List_defaultProps, props), {
    children,
    type,
    size,
    listStyleType,
    withPadding,
    center,
    spacing,
    icon,
    className,
    styles,
    classNames,
    unstyled
  } = _a, others = List_objRest(_a, [
    "children",
    "type",
    "size",
    "listStyleType",
    "withPadding",
    "center",
    "spacing",
    "icon",
    "className",
    "styles",
    "classNames",
    "unstyled"
  ]);
  const { classes, cx } = List_styles({ withPadding, size, listStyleType, center, spacing }, { classNames, styles, name: "List", unstyled });
  return /* @__PURE__ */ react.createElement(ListProvider, {
    value: {
      spacing,
      center,
      icon,
      listStyleType,
      size,
      withPadding,
      classNames,
      styles,
      unstyled
    }
  }, /* @__PURE__ */ react.createElement(Box/* Box */.x, List_spreadValues({
    component: type === "unordered" ? "ul" : "ol",
    className: cx(classes.root, className),
    ref
  }, others), children));
});
List.Item = ListItem;
List.displayName = "@mantine/core/List";


//# sourceMappingURL=List.js.map


/***/ }),

/***/ 20966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ Loader; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Loader/loaders/Bars.js


var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function Bars(_a) {
  var _b = _a, { size, color } = _b, others = __objRest(_b, ["size", "color"]);
  return /* @__PURE__ */ react.createElement("svg", __spreadValues({
    viewBox: "0 0 135 140",
    xmlns: "http://www.w3.org/2000/svg",
    fill: color,
    width: `${size}px`
  }, others), /* @__PURE__ */ react.createElement("rect", {
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ react.createElement("animate", {
    attributeName: "height",
    begin: "0.5s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ react.createElement("animate", {
    attributeName: "y",
    begin: "0.5s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ react.createElement("rect", {
    x: "30",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ react.createElement("animate", {
    attributeName: "height",
    begin: "0.25s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ react.createElement("animate", {
    attributeName: "y",
    begin: "0.25s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ react.createElement("rect", {
    x: "60",
    width: "15",
    height: "140",
    rx: "6"
  }, /* @__PURE__ */ react.createElement("animate", {
    attributeName: "height",
    begin: "0s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ react.createElement("animate", {
    attributeName: "y",
    begin: "0s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ react.createElement("rect", {
    x: "90",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ react.createElement("animate", {
    attributeName: "height",
    begin: "0.25s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ react.createElement("animate", {
    attributeName: "y",
    begin: "0.25s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ react.createElement("rect", {
    x: "120",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ react.createElement("animate", {
    attributeName: "height",
    begin: "0.5s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ react.createElement("animate", {
    attributeName: "y",
    begin: "0.5s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
}


//# sourceMappingURL=Bars.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Loader/loaders/Oval.js


var Oval_defProp = Object.defineProperty;
var Oval_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Oval_hasOwnProp = Object.prototype.hasOwnProperty;
var Oval_propIsEnum = Object.prototype.propertyIsEnumerable;
var Oval_defNormalProp = (obj, key, value) => key in obj ? Oval_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Oval_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Oval_hasOwnProp.call(b, prop))
      Oval_defNormalProp(a, prop, b[prop]);
  if (Oval_getOwnPropSymbols)
    for (var prop of Oval_getOwnPropSymbols(b)) {
      if (Oval_propIsEnum.call(b, prop))
        Oval_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Oval_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Oval_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Oval_getOwnPropSymbols)
    for (var prop of Oval_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Oval_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function Oval(_a) {
  var _b = _a, { size, color } = _b, others = Oval_objRest(_b, ["size", "color"]);
  return /* @__PURE__ */ react.createElement("svg", Oval_spreadValues({
    width: `${size}px`,
    height: `${size}px`,
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: color
  }, others), /* @__PURE__ */ react.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ react.createElement("g", {
    transform: "translate(2.5 2.5)",
    strokeWidth: "5"
  }, /* @__PURE__ */ react.createElement("circle", {
    strokeOpacity: ".5",
    cx: "16",
    cy: "16",
    r: "16"
  }), /* @__PURE__ */ react.createElement("path", {
    d: "M32 16c0-9.94-8.06-16-16-16"
  }, /* @__PURE__ */ react.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 16 16",
    to: "360 16 16",
    dur: "1s",
    repeatCount: "indefinite"
  })))));
}


//# sourceMappingURL=Oval.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Loader/loaders/Dots.js


var Dots_defProp = Object.defineProperty;
var Dots_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Dots_hasOwnProp = Object.prototype.hasOwnProperty;
var Dots_propIsEnum = Object.prototype.propertyIsEnumerable;
var Dots_defNormalProp = (obj, key, value) => key in obj ? Dots_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Dots_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Dots_hasOwnProp.call(b, prop))
      Dots_defNormalProp(a, prop, b[prop]);
  if (Dots_getOwnPropSymbols)
    for (var prop of Dots_getOwnPropSymbols(b)) {
      if (Dots_propIsEnum.call(b, prop))
        Dots_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Dots_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Dots_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Dots_getOwnPropSymbols)
    for (var prop of Dots_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Dots_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function Dots(_a) {
  var _b = _a, { size, color } = _b, others = Dots_objRest(_b, ["size", "color"]);
  return /* @__PURE__ */ react.createElement("svg", Dots_spreadValues({
    width: `${size}px`,
    height: `${size / 4}px`,
    viewBox: "0 0 120 30",
    xmlns: "http://www.w3.org/2000/svg",
    fill: color
  }, others), /* @__PURE__ */ react.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }, /* @__PURE__ */ react.createElement("animate", {
    attributeName: "r",
    from: "15",
    to: "15",
    begin: "0s",
    dur: "0.8s",
    values: "15;9;15",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ react.createElement("animate", {
    attributeName: "fill-opacity",
    from: "1",
    to: "1",
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ react.createElement("circle", {
    cx: "60",
    cy: "15",
    r: "9",
    fillOpacity: "0.3"
  }, /* @__PURE__ */ react.createElement("animate", {
    attributeName: "r",
    from: "9",
    to: "9",
    begin: "0s",
    dur: "0.8s",
    values: "9;15;9",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ react.createElement("animate", {
    attributeName: "fill-opacity",
    from: "0.5",
    to: "0.5",
    begin: "0s",
    dur: "0.8s",
    values: ".5;1;.5",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ react.createElement("circle", {
    cx: "105",
    cy: "15",
    r: "15"
  }, /* @__PURE__ */ react.createElement("animate", {
    attributeName: "r",
    from: "15",
    to: "15",
    begin: "0s",
    dur: "0.8s",
    values: "15;9;15",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ react.createElement("animate", {
    attributeName: "fill-opacity",
    from: "1",
    to: "1",
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
}


//# sourceMappingURL=Dots.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Loader/Loader.js







var Loader_defProp = Object.defineProperty;
var Loader_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Loader_hasOwnProp = Object.prototype.hasOwnProperty;
var Loader_propIsEnum = Object.prototype.propertyIsEnumerable;
var Loader_defNormalProp = (obj, key, value) => key in obj ? Loader_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Loader_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Loader_hasOwnProp.call(b, prop))
      Loader_defNormalProp(a, prop, b[prop]);
  if (Loader_getOwnPropSymbols)
    for (var prop of Loader_getOwnPropSymbols(b)) {
      if (Loader_propIsEnum.call(b, prop))
        Loader_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Loader_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Loader_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Loader_getOwnPropSymbols)
    for (var prop of Loader_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Loader_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LOADERS = {
  bars: Bars,
  oval: Oval,
  dots: Dots
};
const sizes = {
  xs: 18,
  sm: 22,
  md: 36,
  lg: 44,
  xl: 58
};
const defaultProps = {
  size: "md"
};
function Loader(props) {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Loader", defaultProps, props), { size, color, variant } = _a, others = Loader_objRest(_a, ["size", "color", "variant"]);
  const theme = (0,MantineProvider/* useMantineTheme */.rZ)();
  const defaultLoader = variant in LOADERS ? variant : theme.loader;
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, Loader_spreadValues({
    role: "presentation",
    component: LOADERS[defaultLoader] || LOADERS.bars,
    size: theme.fn.size({ size, sizes }),
    color: theme.fn.variant({
      variant: "filled",
      primaryFallback: false,
      color: color || theme.primaryColor
    }).background
  }, others));
}
Loader.displayName = "@mantine/core/Loader";


//# sourceMappingURL=Loader.js.map


/***/ }),

/***/ 18540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ MediaQuery; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/MediaQuery/MediaQuery.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { smallerThan, largerThan, query, styles }) => {
  const media = {};
  const minWidth = theme.fn.size({ size: largerThan, sizes: theme.breakpoints });
  const maxWidth = theme.fn.size({ size: smallerThan, sizes: theme.breakpoints });
  const _styles = typeof styles === "function" ? styles(theme) : styles;
  if (largerThan !== void 0 && smallerThan !== void 0) {
    media[`@media (min-width: ${minWidth}px) and (max-width: ${maxWidth - 1}px)`] = _styles;
  } else {
    if (largerThan !== void 0) {
      media[`@media (min-width: ${theme.fn.size({ size: largerThan, sizes: theme.breakpoints })}px)`] = _styles;
    }
    if (smallerThan !== void 0) {
      media[`@media (max-width: ${theme.fn.size({ size: smallerThan, sizes: theme.breakpoints }) - 1}px)`] = _styles;
    }
  }
  if (query) {
    media[`@media ${query}`] = _styles;
  }
  return { media };
});

/* harmony default export */ var MediaQuery_styles = (useStyles);
//# sourceMappingURL=MediaQuery.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/MediaQuery/MediaQuery.js




function MediaQuery(props) {
  var _a;
  const { children, smallerThan, largerThan, query, styles, className } = (0,MantineProvider/* useComponentDefaultProps */.N4)("MediaQuery", {}, props);
  const { classes, cx } = MediaQuery_styles({ smallerThan, largerThan, query, styles }, { name: "MediaQuery" });
  const child = react.Children.only(children);
  if (typeof child === "object" && child !== null && "props" in child) {
    return react.cloneElement(child, {
      className: cx(classes.media, (_a = child.props) == null ? void 0 : _a.className, className)
    });
  }
  return child;
}
MediaQuery.displayName = "@mantine/core/MediaQuery";


//# sourceMappingURL=MediaQuery.js.map


/***/ }),

/***/ 38090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-id/use-id.js
var use_id = __webpack_require__(36289);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-focus-trap/use-focus-trap.js + 3 modules
var use_focus_trap = __webpack_require__(95909);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-merged-ref/use-merged-ref.js
var use_merged_ref = __webpack_require__(80665);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-scroll-lock/use-scroll-lock.js + 5 modules
var use_scroll_lock = __webpack_require__(83317);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-focus-return/use-focus-return.js
var use_focus_return = __webpack_require__(96362);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-window-event/use-window-event.js
var use_window_event = __webpack_require__(84137);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/utils/get-default-z-index/get-default-z-index.js
var get_default_z_index = __webpack_require__(3594);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Modal/Modal.styles.js


var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const sizes = {
  xs: 320,
  sm: 380,
  md: 440,
  lg: 620,
  xl: 780
};
function getFullScreenStyles(fullScreen) {
  if (!fullScreen) {
    return {};
  }
  return {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    maxHeight: "100vh",
    overflowY: "auto"
  };
}
var useStyles = (0,create_styles/* createStyles */.k)((theme, { overflow, size, centered, zIndex, fullScreen }) => ({
  close: {},
  overlay: {
    display: fullScreen ? "none" : void 0
  },
  root: {
    position: "fixed",
    zIndex,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  inner: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: "auto",
    padding: fullScreen ? 0 : `${theme.spacing.xl * 2}px ${theme.spacing.md}px`,
    display: "flex",
    justifyContent: "center",
    alignItems: centered ? "center" : "flex-start"
  },
  title: {
    marginRight: theme.spacing.md,
    textOverflow: "ellipsis",
    display: "block",
    wordBreak: "break-word"
  },
  modal: __spreadValues({
    position: "relative",
    width: fullScreen ? "100vw" : theme.fn.size({ sizes, size }),
    borderRadius: fullScreen ? 0 : void 0,
    outline: 0,
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
    marginTop: centered ? "auto" : void 0,
    marginBottom: centered ? "auto" : void 0,
    zIndex: 1
  }, getFullScreenStyles(fullScreen)),
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing.md,
    marginRight: -9
  },
  body: {
    maxHeight: overflow === "inside" ? "calc(100vh - 185px)" : null,
    overflowY: overflow === "inside" ? "auto" : null,
    wordBreak: "break-word"
  }
}));

/* harmony default export */ var Modal_styles = (useStyles);
//# sourceMappingURL=Modal.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Portal/OptionalPortal.js
var OptionalPortal = __webpack_require__(83143);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Transition/GroupedTransition.js
var GroupedTransition = __webpack_require__(75933);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Overlay/Overlay.js + 1 modules
var Overlay = __webpack_require__(17577);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(82623);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/CloseButton/CloseButton.js + 1 modules
var CloseButton = __webpack_require__(80971);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Modal/Modal.js












var Modal_defProp = Object.defineProperty;
var Modal_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Modal_hasOwnProp = Object.prototype.hasOwnProperty;
var Modal_propIsEnum = Object.prototype.propertyIsEnumerable;
var Modal_defNormalProp = (obj, key, value) => key in obj ? Modal_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Modal_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Modal_hasOwnProp.call(b, prop))
      Modal_defNormalProp(a, prop, b[prop]);
  if (Modal_getOwnPropSymbols)
    for (var prop of Modal_getOwnPropSymbols(b)) {
      if (Modal_propIsEnum.call(b, prop))
        Modal_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Modal_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Modal_getOwnPropSymbols)
    for (var prop of Modal_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Modal_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  size: "md",
  transitionDuration: 250,
  overflow: "outside",
  padding: "lg",
  shadow: "lg",
  closeOnClickOutside: true,
  closeOnEscape: true,
  trapFocus: true,
  withCloseButton: true,
  withinPortal: true,
  lockScroll: true,
  withFocusReturn: true,
  overlayBlur: 0,
  zIndex: (0,get_default_z_index/* getDefaultZIndex */.w)("modal"),
  exitTransitionDuration: 0
};
function Modal(props) {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Modal", defaultProps, props), {
    className,
    opened,
    title,
    onClose,
    children,
    withCloseButton,
    overlayOpacity,
    size,
    transitionDuration,
    exitTransitionDuration,
    closeButtonLabel,
    overlayColor,
    overflow,
    transition,
    padding,
    shadow,
    radius,
    id,
    classNames,
    styles,
    closeOnClickOutside,
    trapFocus,
    closeOnEscape,
    centered,
    target,
    withinPortal,
    zIndex,
    overlayBlur,
    transitionTimingFunction,
    fullScreen,
    unstyled,
    lockScroll: shouldLockScroll,
    withFocusReturn
  } = _a, others = __objRest(_a, [
    "className",
    "opened",
    "title",
    "onClose",
    "children",
    "withCloseButton",
    "overlayOpacity",
    "size",
    "transitionDuration",
    "exitTransitionDuration",
    "closeButtonLabel",
    "overlayColor",
    "overflow",
    "transition",
    "padding",
    "shadow",
    "radius",
    "id",
    "classNames",
    "styles",
    "closeOnClickOutside",
    "trapFocus",
    "closeOnEscape",
    "centered",
    "target",
    "withinPortal",
    "zIndex",
    "overlayBlur",
    "transitionTimingFunction",
    "fullScreen",
    "unstyled",
    "lockScroll",
    "withFocusReturn"
  ]);
  const baseId = (0,use_id/* useId */.M)(id);
  const titleId = `${baseId}-title`;
  const bodyId = `${baseId}-body`;
  const { classes, cx, theme } = Modal_styles({ size, overflow, centered, zIndex, fullScreen }, { unstyled, classNames, styles, name: "Modal" });
  const focusTrapRef = (0,use_focus_trap/* useFocusTrap */.P)(trapFocus && opened);
  const overlayRef = (0,react.useRef)(null);
  const mergedRef = (0,use_merged_ref/* useMergedRef */.Y)(focusTrapRef, overlayRef);
  const _overlayOpacity = typeof overlayOpacity === "number" ? overlayOpacity : theme.colorScheme === "dark" ? 0.85 : 0.75;
  (0,use_scroll_lock/* useScrollLock */.P)(shouldLockScroll && opened);
  const closeOnEscapePress = (event) => {
    if (!trapFocus && event.key === "Escape" && closeOnEscape) {
      onClose();
    }
  };
  (0,react.useEffect)(() => {
    if (!trapFocus) {
      window.addEventListener("keydown", closeOnEscapePress);
      return () => window.removeEventListener("keydown", closeOnEscapePress);
    }
    return void 0;
  }, [trapFocus]);
  (0,use_focus_return/* useFocusReturn */.u)({ opened, shouldReturnFocus: trapFocus && withFocusReturn });
  const clickTarget = (0,react.useRef)(null);
  (0,use_window_event/* useWindowEvent */.s)("mousedown", (e) => {
    clickTarget.current = e.target;
  });
  const handleOutsideClick = () => {
    if (clickTarget.current === overlayRef.current) {
      closeOnClickOutside && onClose();
    }
  };
  return /* @__PURE__ */ react.createElement(OptionalPortal/* OptionalPortal */.q, {
    withinPortal,
    target
  }, /* @__PURE__ */ react.createElement(GroupedTransition/* GroupedTransition */.p, {
    mounted: opened,
    duration: transitionDuration,
    exitDuration: exitTransitionDuration,
    timingFunction: transitionTimingFunction,
    transitions: {
      modal: {
        duration: transitionDuration,
        transition: transition || (fullScreen ? "fade" : "pop")
      },
      overlay: {
        duration: transitionDuration / 2,
        transition: "fade",
        timingFunction: "ease"
      }
    }
  }, (transitionStyles) => /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Box/* Box */.x, Modal_spreadValues({
    id: baseId,
    className: cx(classes.root, className)
  }, others), /* @__PURE__ */ react.createElement("div", {
    style: transitionStyles.overlay
  }, /* @__PURE__ */ react.createElement(Overlay/* Overlay */.a, {
    className: classes.overlay,
    sx: { position: "fixed" },
    zIndex: 0,
    blur: overlayBlur,
    color: overlayColor || (theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.black),
    opacity: _overlayOpacity,
    unstyled
  })), /* @__PURE__ */ react.createElement("div", {
    role: "presentation",
    className: classes.inner,
    onClick: handleOutsideClick,
    onKeyDown: (event) => {
      var _a2;
      const shouldTrigger = ((_a2 = event.target) == null ? void 0 : _a2.getAttribute("data-mantine-stop-propagation")) !== "true";
      shouldTrigger && event.key === "Escape" && closeOnEscape && onClose();
    },
    ref: mergedRef
  }, /* @__PURE__ */ react.createElement(Paper/* Paper */.X, {
    className: classes.modal,
    shadow,
    p: padding,
    radius,
    role: "dialog",
    "aria-labelledby": titleId,
    "aria-describedby": bodyId,
    "aria-modal": true,
    tabIndex: -1,
    style: transitionStyles.modal,
    unstyled,
    onClick: (event) => event.stopPropagation()
  }, (title || withCloseButton) && /* @__PURE__ */ react.createElement("div", {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(Text/* Text */.x, {
    id: titleId,
    className: classes.title
  }, title), withCloseButton && /* @__PURE__ */ react.createElement(CloseButton/* CloseButton */.P, {
    iconSize: 16,
    onClick: onClose,
    "aria-label": closeButtonLabel,
    className: classes.close
  })), /* @__PURE__ */ react.createElement("div", {
    id: bodyId,
    className: classes.body
  }, children)))))));
}
Modal.displayName = "@mantine/core/Modal";


//# sourceMappingURL=Modal.js.map


/***/ }),

/***/ 92470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ NavLink; }
});

// UNUSED EXPORTS: _NavLink

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-uncontrolled/use-uncontrolled.js
var use_uncontrolled = __webpack_require__(15851);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/NavLink/NavLink.styles.js


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var useStyles = (0,create_styles/* createStyles */.k)((theme, { color, variant, noWrap, childrenOffset, alignIcon }) => {
  const colors = theme.fn.variant({ variant, color });
  return {
    root: __spreadProps(__spreadValues({
      display: "flex",
      alignItems: "center",
      width: "100%",
      padding: `8px ${theme.spacing.sm}px`,
      userSelect: "none"
    }, theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0]
    })), {
      "&[data-active]": __spreadValues({
        backgroundColor: colors.background,
        color: colors.color
      }, theme.fn.hover({ backgroundColor: colors.hover })),
      "&[data-disabled]": {
        opacity: 0.4,
        pointerEvents: "none"
      }
    }),
    icon: {
      marginRight: theme.spacing.sm,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      alignSelf: alignIcon === "center" ? "center" : "flex-start",
      paddingTop: alignIcon === "center" ? void 0 : 4
    },
    rightSection: {
      marginLeft: theme.spacing.sm,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      transition: `transform 150ms ${theme.transitionTimingFunction}`,
      "&[data-rotate]": {
        transform: "rotate(90deg)"
      }
    },
    body: {
      flex: 1,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: noWrap ? "nowrap" : void 0
    },
    label: {},
    description: {
      display: "block",
      "&[data-active]": {
        color: "inherit"
      }
    },
    children: {
      paddingLeft: theme.fn.size({ size: childrenOffset, sizes: theme.spacing })
    }
  };
});

/* harmony default export */ var NavLink_styles = (useStyles);
//# sourceMappingURL=NavLink.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.js + 1 modules
var UnstyledButton = __webpack_require__(34736);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Accordion/ChevronIcon.js
var ChevronIcon = __webpack_require__(56057);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(31003);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/NavLink/NavLink.js










var NavLink_defProp = Object.defineProperty;
var NavLink_getOwnPropSymbols = Object.getOwnPropertySymbols;
var NavLink_hasOwnProp = Object.prototype.hasOwnProperty;
var NavLink_propIsEnum = Object.prototype.propertyIsEnumerable;
var NavLink_defNormalProp = (obj, key, value) => key in obj ? NavLink_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var NavLink_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (NavLink_hasOwnProp.call(b, prop))
      NavLink_defNormalProp(a, prop, b[prop]);
  if (NavLink_getOwnPropSymbols)
    for (var prop of NavLink_getOwnPropSymbols(b)) {
      if (NavLink_propIsEnum.call(b, prop))
        NavLink_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (NavLink_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && NavLink_getOwnPropSymbols)
    for (var prop of NavLink_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && NavLink_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  variant: "light",
  childrenOffset: "lg"
};
const _NavLink = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("NavLink", defaultProps, props), {
    label,
    description,
    icon,
    rightSection,
    className,
    classNames,
    styles,
    unstyled,
    active,
    color,
    variant,
    noWrap,
    children,
    opened,
    defaultOpened,
    onChange,
    disableRightSectionRotation,
    childrenOffset,
    disabled,
    onClick
  } = _a, others = __objRest(_a, [
    "label",
    "description",
    "icon",
    "rightSection",
    "className",
    "classNames",
    "styles",
    "unstyled",
    "active",
    "color",
    "variant",
    "noWrap",
    "children",
    "opened",
    "defaultOpened",
    "onChange",
    "disableRightSectionRotation",
    "childrenOffset",
    "disabled",
    "onClick"
  ]);
  const { classes, cx } = NavLink_styles({ color, variant, noWrap, childrenOffset, alignIcon: description ? "top" : "center" }, { name: "NavLink", classNames, styles, unstyled });
  const [_opened, setOpened] = (0,use_uncontrolled/* useUncontrolled */.C)({
    value: opened,
    defaultValue: defaultOpened,
    finalValue: false,
    onChange
  });
  const withChildren = !!children;
  const handleClick = (event) => {
    if (withChildren) {
      event.preventDefault();
      onClick == null ? void 0 : onClick(event);
      setOpened(!_opened);
    } else {
      onClick == null ? void 0 : onClick(event);
    }
  };
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(UnstyledButton/* UnstyledButton */.k, NavLink_spreadValues({
    ref,
    className: cx(classes.root, className),
    "data-active": active || void 0,
    onClick: handleClick,
    unstyled,
    "data-expanded": _opened || void 0,
    "data-disabled": disabled || void 0,
    disabled
  }, others), icon && /* @__PURE__ */ react.createElement("span", {
    className: classes.icon
  }, icon), /* @__PURE__ */ react.createElement("span", {
    className: classes.body
  }, /* @__PURE__ */ react.createElement(Text/* Text */.x, {
    component: "span",
    size: "sm",
    className: classes.label
  }, label), /* @__PURE__ */ react.createElement(Text/* Text */.x, {
    component: "span",
    color: "dimmed",
    size: "xs",
    "data-active": active || void 0,
    className: classes.description
  }, description)), (withChildren || rightSection) && /* @__PURE__ */ react.createElement("span", {
    className: classes.rightSection,
    "data-rotate": _opened && !disableRightSectionRotation || void 0
  }, withChildren ? rightSection || /* @__PURE__ */ react.createElement(ChevronIcon/* ChevronIcon */.D, {
    width: 14,
    height: 14,
    style: { transform: "rotate(-90deg)" }
  }) : rightSection)), /* @__PURE__ */ react.createElement(Collapse/* Collapse */.U, {
    in: _opened
  }, /* @__PURE__ */ react.createElement("div", {
    className: classes.children
  }, children)));
});
_NavLink.displayName = "@mantine/core/NavLink";
const NavLink = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_NavLink);


//# sourceMappingURL=NavLink.js.map


/***/ }),

/***/ 14127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ NumberInput; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/utils/clamp/clamp.js
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}


//# sourceMappingURL=clamp.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/utils/assign-ref/assign-ref.js
var assign_ref = __webpack_require__(83979);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-merged-ref/use-merged-ref.js
var use_merged_ref = __webpack_require__(80665);
;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-os/use-os.js
function getOS() {
  const { userAgent } = window.navigator;
  const macosPlatforms = /(Macintosh)|(MacIntel)|(MacPPC)|(Mac68K)/i;
  const windowsPlatforms = /(Win32)|(Win64)|(Windows)|(WinCE)/i;
  const iosPlatforms = /(iPhone)|(iPad)|(iPod)/i;
  if (macosPlatforms.test(userAgent)) {
    return "macos";
  }
  if (iosPlatforms.test(userAgent)) {
    return "ios";
  }
  if (windowsPlatforms.test(userAgent)) {
    return "windows";
  }
  if (/Android/i.test(userAgent)) {
    return "android";
  }
  if (/Linux/i.test(userAgent)) {
    return "linux";
  }
  return "undetermined";
}
function useOs() {
  if (typeof window !== "undefined") {
    return getOS();
  }
  return "undetermined";
}


//# sourceMappingURL=use-os.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/NumberInput/get-input-mode/get-input-mode.js
const getInputMode = (step, precision, os) => {
  if (Number.isInteger(step) && step >= 0 && precision === 0)
    return "numeric";
  if (!Number.isInteger(step) && step >= 0 && precision !== 0)
    return "decimal";
  if (Number.isInteger(step) && step < 0 && precision === 0) {
    if (os === "ios")
      return "text";
    return "decimal";
  }
  if (!Number.isInteger(step) && step < 0 && precision !== 0) {
    if (os === "ios")
      return "text";
    return "decimal";
  }
  return "numeric";
};


//# sourceMappingURL=get-input-mode.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/NumberInput/Chevron.js


function Chevron({ direction, size }) {
  return /* @__PURE__ */ react.createElement("svg", {
    style: { transform: direction === "up" ? "rotate(180deg)" : void 0 },
    width: size,
    height: size,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ react.createElement("path", {
    d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}


//# sourceMappingURL=Chevron.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/NumberInput/NumberInput.styles.js


const CONTROL_SIZES = {
  xs: 20,
  sm: 24,
  md: 30,
  lg: 34,
  xl: 36
};
var useStyles = (0,create_styles/* createStyles */.k)((theme, { radius, size }) => ({
  rightSection: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100% - 2px)",
    margin: 1,
    marginRight: 1,
    overflow: "hidden",
    borderTopRightRadius: theme.fn.radius(radius),
    borderBottomRightRadius: theme.fn.radius(radius)
  },
  control: {
    margin: 0,
    position: "relative",
    flex: "0 0 50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    width: theme.fn.size({ size, sizes: CONTROL_SIZES }),
    padding: 0,
    WebkitTapHighlightColor: "transparent",
    borderBottom: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]}`,
    borderLeft: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]}`,
    borderTop: 0,
    borderRight: 0,
    backgroundColor: "transparent",
    marginRight: 1,
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    "&:not(:disabled):hover": {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
    },
    "&:disabled": {
      color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4]
    }
  },
  controlUp: {},
  controlDown: {
    borderBottom: 0
  }
}));

/* harmony default export */ var NumberInput_styles = (useStyles);

//# sourceMappingURL=NumberInput.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/TextInput/TextInput.js
var TextInput = __webpack_require__(80061);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/NumberInput/NumberInput.js








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultFormatter = (value) => value || "";
const defaultParser = (num) => {
  if (num === "-") {
    return num;
  }
  let tempNum = num;
  if (tempNum[0] === ".") {
    tempNum = `0${num}`;
  }
  const parsedNum = parseFloat(tempNum);
  if (Number.isNaN(parsedNum)) {
    return void 0;
  }
  return num;
};
const CHEVRON_SIZES = {
  xs: 10,
  sm: 14,
  md: 16,
  lg: 18,
  xl: 20
};
const defaultProps = {
  step: 1,
  hideControls: false,
  size: "sm",
  precision: 0,
  noClampOnBlur: false,
  removeTrailingZeros: false,
  formatter: defaultFormatter,
  parser: defaultParser,
  type: "text"
};
const NumberInput = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("NumberInput", defaultProps, props), {
    readOnly,
    disabled,
    value,
    onChange,
    decimalSeparator,
    min,
    max,
    startValue,
    step,
    stepHoldInterval,
    stepHoldDelay,
    onBlur,
    onFocus,
    onKeyDown,
    onKeyUp,
    hideControls,
    radius,
    variant,
    precision,
    removeTrailingZeros,
    defaultValue,
    noClampOnBlur,
    handlersRef,
    classNames,
    styles,
    size,
    rightSection,
    rightSectionWidth,
    formatter,
    parser,
    inputMode,
    unstyled,
    type
  } = _a, others = __objRest(_a, [
    "readOnly",
    "disabled",
    "value",
    "onChange",
    "decimalSeparator",
    "min",
    "max",
    "startValue",
    "step",
    "stepHoldInterval",
    "stepHoldDelay",
    "onBlur",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "hideControls",
    "radius",
    "variant",
    "precision",
    "removeTrailingZeros",
    "defaultValue",
    "noClampOnBlur",
    "handlersRef",
    "classNames",
    "styles",
    "size",
    "rightSection",
    "rightSectionWidth",
    "formatter",
    "parser",
    "inputMode",
    "unstyled",
    "type"
  ]);
  const { classes, cx, theme } = NumberInput_styles({ radius, size }, { classNames, styles, unstyled, name: "NumberInput" });
  const parsePrecision = (val) => {
    if (val === void 0)
      return void 0;
    let result = val.toFixed(precision);
    if (removeTrailingZeros && precision > 0) {
      result = result.replace(new RegExp(`[0]{0,${precision}}$`), "");
      if (result.endsWith(".") || result.endsWith(decimalSeparator)) {
        result = result.slice(0, -1);
      }
    }
    return result;
  };
  const [focused, setFocused] = (0,react.useState)(false);
  const [_value, setValue] = (0,react.useState)(typeof value === "number" ? value : typeof defaultValue === "number" ? defaultValue : void 0);
  const finalValue = typeof value === "number" ? value : _value;
  const [tempValue, setTempValue] = (0,react.useState)(typeof finalValue === "number" ? parsePrecision(finalValue) : "");
  const inputRef = (0,react.useRef)();
  const handleValueChange = (val) => {
    if (val !== _value && !Number.isNaN(val)) {
      typeof onChange === "function" && onChange(val);
      setValue(val);
    }
  };
  const formatNum = (val = "") => {
    let parsedStr = typeof val === "number" ? String(val) : val;
    if (decimalSeparator) {
      parsedStr = parsedStr.replace(/\./g, decimalSeparator);
    }
    return formatter(parsedStr);
  };
  const parseNum = (val) => {
    let num = val;
    if (decimalSeparator) {
      num = num.replace(new RegExp(`\\${decimalSeparator}`, "g"), ".");
    }
    return parser(num);
  };
  const _min = typeof min === "number" ? min : -Infinity;
  const _max = typeof max === "number" ? max : Infinity;
  const incrementRef = (0,react.useRef)();
  incrementRef.current = () => {
    var _a2, _b, _c;
    if (_value === void 0) {
      handleValueChange((_a2 = startValue != null ? startValue : min) != null ? _a2 : 0);
      setTempValue((_c = (_b = parsePrecision(startValue)) != null ? _b : parsePrecision(min)) != null ? _c : "0");
    } else {
      const result = parsePrecision(clamp(_value + step, _min, _max));
      handleValueChange(parseFloat(result));
      setTempValue(result);
    }
  };
  const decrementRef = (0,react.useRef)();
  decrementRef.current = () => {
    var _a2, _b, _c;
    if (_value === void 0) {
      handleValueChange((_a2 = startValue != null ? startValue : min) != null ? _a2 : 0);
      setTempValue((_c = (_b = parsePrecision(startValue)) != null ? _b : parsePrecision(min)) != null ? _c : "0");
    } else {
      const result = parsePrecision(clamp(_value - step, _min, _max));
      handleValueChange(parseFloat(result));
      setTempValue(result);
    }
  };
  (0,assign_ref/* assignRef */.k)(handlersRef, { increment: incrementRef.current, decrement: decrementRef.current });
  (0,react.useEffect)(() => {
    if (typeof value === "number" && !focused) {
      setValue(value);
      setTempValue(parsePrecision(value));
    }
    if (defaultValue === void 0 && value === void 0 && !focused) {
      setValue(value);
      setTempValue("");
    }
  }, [value, precision]);
  const shouldUseStepInterval = stepHoldDelay !== void 0 && stepHoldInterval !== void 0;
  const onStepTimeoutRef = (0,react.useRef)(null);
  const stepCountRef = (0,react.useRef)(0);
  const onStepDone = () => {
    if (onStepTimeoutRef.current) {
      window.clearTimeout(onStepTimeoutRef.current);
    }
    onStepTimeoutRef.current = null;
    stepCountRef.current = 0;
  };
  const onStepHandleChange = (isIncrement) => {
    if (isIncrement) {
      incrementRef.current();
    } else {
      decrementRef.current();
    }
    stepCountRef.current += 1;
  };
  const onStepLoop = (isIncrement) => {
    onStepHandleChange(isIncrement);
    if (shouldUseStepInterval) {
      const interval = typeof stepHoldInterval === "number" ? stepHoldInterval : stepHoldInterval(stepCountRef.current);
      onStepTimeoutRef.current = window.setTimeout(() => onStepLoop(isIncrement), interval);
    }
  };
  const onStep = (event, isIncrement) => {
    event.preventDefault();
    inputRef.current.focus();
    onStepHandleChange(isIncrement);
    if (shouldUseStepInterval) {
      onStepTimeoutRef.current = window.setTimeout(() => onStepLoop(isIncrement), stepHoldDelay);
    }
  };
  (0,react.useEffect)(() => {
    onStepDone();
    return onStepDone;
  }, []);
  const controls = /* @__PURE__ */ react.createElement("div", {
    className: classes.rightSection
  }, /* @__PURE__ */ react.createElement("button", {
    type: "button",
    tabIndex: -1,
    "aria-hidden": true,
    disabled: finalValue >= max,
    className: cx(classes.control, classes.controlUp),
    onPointerDown: (event) => {
      onStep(event, true);
    },
    onPointerUp: onStepDone,
    onPointerLeave: onStepDone
  }, /* @__PURE__ */ react.createElement(Chevron, {
    size: theme.fn.size({ size, sizes: CHEVRON_SIZES }),
    direction: "up"
  })), /* @__PURE__ */ react.createElement("button", {
    type: "button",
    tabIndex: -1,
    "aria-hidden": true,
    disabled: finalValue <= min,
    className: cx(classes.control, classes.controlDown),
    onPointerDown: (event) => {
      onStep(event, false);
    },
    onPointerUp: onStepDone,
    onPointerLeave: onStepDone
  }, /* @__PURE__ */ react.createElement(Chevron, {
    size: theme.fn.size({ size, sizes: CHEVRON_SIZES }),
    direction: "down"
  })));
  const handleChange = (event) => {
    const evt = event.nativeEvent;
    if (evt.isComposing) {
      return;
    }
    const val = event.target.value;
    const parsed = parseNum(val);
    setTempValue(parsed);
    if (val === "" || val === "-") {
      handleValueChange(void 0);
    } else {
      val.trim() !== "" && !Number.isNaN(parsed) && handleValueChange(parseFloat(parsed));
    }
  };
  const handleBlur = (event) => {
    var _a2;
    if (event.target.value === "") {
      setTempValue("");
      handleValueChange(void 0);
    } else {
      let newNumber = event.target.value;
      if (newNumber[0] === `${decimalSeparator}` || newNumber[0] === ".") {
        newNumber = `0${newNumber}`;
      }
      const parsedVal = parseNum(newNumber);
      const val = clamp(parseFloat(parsedVal), _min, _max);
      if (!Number.isNaN(val)) {
        if (!noClampOnBlur) {
          setTempValue(parsePrecision(val));
          handleValueChange(parseFloat(parsePrecision(val)));
        }
      } else {
        setTempValue((_a2 = parsePrecision(finalValue)) != null ? _a2 : "");
      }
    }
    setFocused(false);
    typeof onBlur === "function" && onBlur(event);
  };
  const handleFocus = (event) => {
    setFocused(true);
    typeof onFocus === "function" && onFocus(event);
  };
  const handleKeyDown = (event) => {
    typeof onKeyDown === "function" && onKeyDown(event);
    if (event.repeat && shouldUseStepInterval && (event.key === "ArrowUp" || event.key === "ArrowDown")) {
      event.preventDefault();
      return;
    }
    if (!readOnly) {
      if (event.key === "ArrowUp") {
        onStep(event, true);
      } else if (event.key === "ArrowDown") {
        onStep(event, false);
      }
    }
  };
  const handleKeyUp = (event) => {
    typeof onKeyUp === "function" && onKeyUp(event);
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      onStepDone();
    }
  };
  return /* @__PURE__ */ react.createElement(TextInput/* TextInput */.o, __spreadProps(__spreadValues({}, others), {
    type,
    variant,
    value: formatNum(tempValue),
    disabled,
    readOnly,
    ref: (0,use_merged_ref/* useMergedRef */.Y)(inputRef, ref),
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    rightSection: rightSection || (disabled || readOnly || hideControls || variant === "unstyled" ? null : controls),
    rightSectionWidth: rightSectionWidth || theme.fn.size({ size, sizes: CONTROL_SIZES }) + 1,
    radius,
    max,
    min,
    step,
    size,
    styles,
    classNames,
    inputMode: inputMode || getInputMode(step, precision, useOs()),
    __staticSelector: "NumberInput",
    unstyled
  }));
});
NumberInput.displayName = "@mantine/core/NumberInput";


//# sourceMappingURL=NumberInput.js.map


/***/ }),

/***/ 17577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ Overlay; }
});

// UNUSED EXPORTS: _Overlay

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/utils/get-default-z-index/get-default-z-index.js
var get_default_z_index = __webpack_require__(3594);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/pack-sx/pack-sx.js
var pack_sx = __webpack_require__(97818);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Overlay/Overlay.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { zIndex }) => ({
  root: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex
  }
}));

/* harmony default export */ var Overlay_styles = (useStyles);
//# sourceMappingURL=Overlay.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Overlay/Overlay.js






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  opacity: 0.6,
  color: "#fff",
  zIndex: (0,get_default_z_index/* getDefaultZIndex */.w)("modal"),
  radius: 0,
  blur: 0
};
const _Overlay = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Overlay", defaultProps, props), { opacity, blur, color, gradient, zIndex, radius, sx, unstyled, className } = _a, others = __objRest(_a, ["opacity", "blur", "color", "gradient", "zIndex", "radius", "sx", "unstyled", "className"]);
  const { classes, cx } = Overlay_styles({ zIndex }, { name: "Overlay", unstyled });
  const background = gradient ? { backgroundImage: gradient } : { backgroundColor: color };
  const innerOverlay = (otherProps) => /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    ref,
    className: cx(classes.root, className),
    sx: [
      (theme) => __spreadProps(__spreadValues({}, background), {
        opacity,
        borderRadius: theme.fn.size({ size: radius, sizes: theme.radius })
      }),
      ...(0,pack_sx/* packSx */.R)(sx)
    ]
  }, otherProps));
  if (blur) {
    return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
      className: cx(classes.root, className),
      sx: [{ backdropFilter: `blur(${blur}px)` }, ...(0,pack_sx/* packSx */.R)(sx)]
    }, others), innerOverlay());
  }
  return innerOverlay(others);
});
_Overlay.displayName = "@mantine/core/Overlay";
const Overlay = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_Overlay);


//# sourceMappingURL=Overlay.js.map


/***/ }),

/***/ 82623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ Paper; }
});

// UNUSED EXPORTS: _Paper

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Paper/Paper.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { radius, shadow, withBorder }) => ({
  root: {
    outline: 0,
    WebkitTapHighlightColor: "transparent",
    display: "block",
    textDecoration: "none",
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
    boxSizing: "border-box",
    borderRadius: theme.fn.radius(radius),
    boxShadow: theme.shadows[shadow] || shadow || "none",
    border: withBorder ? `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]}` : void 0
  }
}));

/* harmony default export */ var Paper_styles = (useStyles);
//# sourceMappingURL=Paper.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Paper/Paper.js






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {};
const _Paper = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Paper", defaultProps, props), { className, children, radius, withBorder, shadow, unstyled } = _a, others = __objRest(_a, ["className", "children", "radius", "withBorder", "shadow", "unstyled"]);
  const { classes, cx } = Paper_styles({ radius, shadow, withBorder }, { name: "Paper", unstyled });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.root, className),
    ref
  }, others), children);
});
_Paper.displayName = "@mantine/core/Paper";
const Paper = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_Paper);


//# sourceMappingURL=Paper.js.map


/***/ }),

/***/ 25944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ Popover; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-id/use-id.js
var use_id = __webpack_require__(36289);
;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-click-outside/use-click-outside.js


const DEFAULT_EVENTS = ["mousedown", "touchstart"];
function useClickOutside(handler, events, nodes) {
  const ref = (0,react.useRef)();
  (0,react.useEffect)(() => {
    const listener = (event) => {
      const { target } = event != null ? event : {};
      if (Array.isArray(nodes)) {
        const shouldIgnore = (target == null ? void 0 : target.hasAttribute("data-ignore-outside-clicks")) || !document.body.contains(target) && target.tagName !== "HTML";
        const shouldTrigger = nodes.every((node) => !!node && !event.composedPath().includes(node));
        shouldTrigger && !shouldIgnore && handler();
      } else if (ref.current && !ref.current.contains(target)) {
        handler();
      }
    };
    (events || DEFAULT_EVENTS).forEach((fn) => document.addEventListener(fn, listener));
    return () => {
      (events || DEFAULT_EVENTS).forEach((fn) => document.removeEventListener(fn, listener));
    };
  }, [ref, handler, nodes]);
  return ref;
}


//# sourceMappingURL=use-click-outside.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/utils/get-default-z-index/get-default-z-index.js
var get_default_z_index = __webpack_require__(3594);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-uncontrolled/use-uncontrolled.js
var use_uncontrolled = __webpack_require__(15851);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-did-update/use-did-update.js
var use_did_update = __webpack_require__(37048);
// EXTERNAL MODULE: ./node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
var floating_ui_core_browser_min = __webpack_require__(88301);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.esm.js
var floating_ui_react_dom_esm = __webpack_require__(58463);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom-interactions/dist/floating-ui.react-dom-interactions.esm.js
var floating_ui_react_dom_interactions_esm = __webpack_require__(35082);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Floating/use-floating-auto-update.js
var use_floating_auto_update = __webpack_require__(30212);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Popover/use-popover.js




function getPopoverMiddlewares(options) {
  const middlewares = [(0,floating_ui_core_browser_min/* offset */.cv)(options.offset)];
  if (options.middlewares.shift) {
    middlewares.push((0,floating_ui_core_browser_min/* shift */.uY)({ limiter: (0,floating_ui_core_browser_min/* limitShift */.dr)() }));
  }
  if (options.middlewares.flip) {
    middlewares.push((0,floating_ui_core_browser_min/* flip */.RR)());
  }
  if (options.middlewares.inline) {
    middlewares.push((0,floating_ui_core_browser_min/* inline */.Qo)());
  }
  middlewares.push((0,floating_ui_react_dom_esm/* arrow */.x7)({ element: options.arrowRef, padding: options.arrowOffset }));
  return middlewares;
}
function usePopover(options) {
  const [_opened, setOpened] = (0,use_uncontrolled/* useUncontrolled */.C)({
    value: options.opened,
    defaultValue: options.defaultOpened,
    finalValue: false,
    onChange: options.onChange
  });
  const onClose = () => {
    var _a;
    (_a = options.onClose) == null ? void 0 : _a.call(options);
    setOpened(false);
  };
  const onToggle = () => {
    var _a, _b;
    if (_opened) {
      (_a = options.onClose) == null ? void 0 : _a.call(options);
      setOpened(false);
    } else {
      (_b = options.onOpen) == null ? void 0 : _b.call(options);
      setOpened(true);
    }
  };
  const floating = (0,floating_ui_react_dom_interactions_esm/* useFloating */.YF)({
    placement: options.position,
    middleware: [
      ...getPopoverMiddlewares(options),
      ...options.width === "target" ? [
        (0,floating_ui_core_browser_min/* size */.dp)({
          apply({ rects }) {
            var _a, _b;
            Object.assign((_b = (_a = floating.refs.floating.current) == null ? void 0 : _a.style) != null ? _b : {}, {
              width: `${rects.reference.width}px`
            });
          }
        })
      ] : []
    ]
  });
  (0,use_floating_auto_update/* useFloatingAutoUpdate */.L)({
    opened: options.opened,
    positionDependencies: options.positionDependencies,
    floating
  });
  (0,use_did_update/* useDidUpdate */.l)(() => {
    var _a;
    (_a = options.onPositionChange) == null ? void 0 : _a.call(options, floating.placement);
  }, [floating.placement]);
  return {
    floating,
    controlled: typeof options.opened === "boolean",
    opened: _opened,
    onClose,
    onToggle
  };
}


//# sourceMappingURL=use-popover.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-safe-context/create-safe-context.js
var create_safe_context = __webpack_require__(68216);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Popover/Popover.errors.js
const POPOVER_ERRORS = {
  context: "Popover component was not found in the tree",
  children: "Popover.Target component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported"
};


//# sourceMappingURL=Popover.errors.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Popover/Popover.context.js



const [PopoverContextProvider, usePopoverContext] = (0,create_safe_context/* createSafeContext */.R)(POPOVER_ERRORS.context);


//# sourceMappingURL=Popover.context.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-merged-ref/use-merged-ref.js
var use_merged_ref = __webpack_require__(80665);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/is-element/is-element.js
var is_element = __webpack_require__(24241);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Popover/PopoverTarget/PopoverTarget.js







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  refProp: "ref",
  popupType: "dialog"
};
const PopoverTarget = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("PopoverTarget", defaultProps, props), { children, refProp, popupType } = _a, others = __objRest(_a, ["children", "refProp", "popupType"]);
  if (!(0,is_element/* isElement */.k)(children)) {
    throw new Error(POPOVER_ERRORS.children);
  }
  const forwardedProps = others;
  const ctx = usePopoverContext();
  const targetRef = (0,use_merged_ref/* useMergedRef */.Y)(ctx.reference, children.ref, ref);
  const accessibleProps = ctx.withRoles ? {
    "aria-haspopup": popupType,
    "aria-expanded": ctx.opened,
    "aria-controls": ctx.getDropdownId(),
    id: ctx.getTargetId()
  } : {};
  return (0,react.cloneElement)(children, __spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({}, forwardedProps), accessibleProps), ctx.targetProps), {
    className: (0,clsx_m/* default */.Z)(ctx.targetProps.className, forwardedProps.className, children.props.className),
    [refProp]: targetRef
  }), !ctx.controlled ? { onClick: ctx.onToggle } : null));
});
PopoverTarget.displayName = "@mantine/core/PopoverTarget";


//# sourceMappingURL=PopoverTarget.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/utils/esm/noop/noop.js
const noop = () => {
};


//# sourceMappingURL=noop.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/utils/esm/close-on-escape/close-on-escape.js


function closeOnEscape(callback, options = { active: true }) {
  if (typeof callback !== "function" || !options.active) {
    return options.onKeyDown || noop;
  }
  return (event) => {
    var _a;
    if (event.key === "Escape") {
      callback(event);
      (_a = options.onTrigger) == null ? void 0 : _a.call(options);
    }
  };
}


//# sourceMappingURL=close-on-escape.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-focus-return/use-focus-return.js
var use_focus_return = __webpack_require__(96362);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Popover/PopoverDropdown/PopoverDropdown.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { radius, shadow }) => ({
  dropdown: {
    position: "absolute",
    backgroundColor: theme.white,
    background: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
    border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2]}`,
    padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
    boxShadow: theme.shadows[shadow] || shadow || "none",
    borderRadius: theme.fn.radius(radius),
    "&:focus": {
      outline: 0
    }
  },
  arrow: {
    backgroundColor: "inherit",
    border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2]}`,
    zIndex: 1
  }
}));

/* harmony default export */ var PopoverDropdown_styles = (useStyles);
//# sourceMappingURL=PopoverDropdown.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Portal/OptionalPortal.js
var OptionalPortal = __webpack_require__(83143);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Transition/Transition.js
var Transition = __webpack_require__(97688);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-focus-trap/use-focus-trap.js + 3 modules
var use_focus_trap = __webpack_require__(95909);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/FocusTrap/FocusTrap.js




function FocusTrap({
  children,
  active = true,
  refProp = "ref"
}) {
  const focusTrapRef = (0,use_focus_trap/* useFocusTrap */.P)(active);
  const ref = (0,use_merged_ref/* useMergedRef */.Y)(focusTrapRef, children == null ? void 0 : children.ref);
  if (!(0,is_element/* isElement */.k)(children)) {
    return children;
  }
  return (0,react.cloneElement)(children, { [refProp]: ref });
}
FocusTrap.displayName = "@mantine/core/FocusTrap";


//# sourceMappingURL=FocusTrap.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Floating/FloatingArrow/FloatingArrow.js + 1 modules
var FloatingArrow = __webpack_require__(63468);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Popover/PopoverDropdown/PopoverDropdown.js












var PopoverDropdown_defProp = Object.defineProperty;
var PopoverDropdown_defProps = Object.defineProperties;
var PopoverDropdown_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var PopoverDropdown_getOwnPropSymbols = Object.getOwnPropertySymbols;
var PopoverDropdown_hasOwnProp = Object.prototype.hasOwnProperty;
var PopoverDropdown_propIsEnum = Object.prototype.propertyIsEnumerable;
var PopoverDropdown_defNormalProp = (obj, key, value) => key in obj ? PopoverDropdown_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var PopoverDropdown_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (PopoverDropdown_hasOwnProp.call(b, prop))
      PopoverDropdown_defNormalProp(a, prop, b[prop]);
  if (PopoverDropdown_getOwnPropSymbols)
    for (var prop of PopoverDropdown_getOwnPropSymbols(b)) {
      if (PopoverDropdown_propIsEnum.call(b, prop))
        PopoverDropdown_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var PopoverDropdown_spreadProps = (a, b) => PopoverDropdown_defProps(a, PopoverDropdown_getOwnPropDescs(b));
var PopoverDropdown_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (PopoverDropdown_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && PopoverDropdown_getOwnPropSymbols)
    for (var prop of PopoverDropdown_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && PopoverDropdown_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PopoverDropdown_defaultProps = {};
function PopoverDropdown(props) {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("PopoverDropdown", PopoverDropdown_defaultProps, props), { style, className, children, onKeyDownCapture } = _a, others = PopoverDropdown_objRest(_a, ["style", "className", "children", "onKeyDownCapture"]);
  const ctx = usePopoverContext();
  const { classes, cx } = PopoverDropdown_styles({ radius: ctx.radius, shadow: ctx.shadow }, {
    name: ctx.__staticSelector,
    classNames: ctx.classNames,
    styles: ctx.styles,
    unstyled: ctx.unstyled
  });
  const returnFocus = (0,use_focus_return/* useFocusReturn */.u)({
    opened: ctx.opened,
    shouldReturnFocus: ctx.returnFocus
  });
  const accessibleProps = ctx.withRoles ? {
    "aria-labelledby": ctx.getTargetId(),
    id: ctx.getDropdownId(),
    role: "dialog"
  } : {};
  if (ctx.disabled) {
    return null;
  }
  return /* @__PURE__ */ react.createElement(OptionalPortal/* OptionalPortal */.q, {
    withinPortal: ctx.withinPortal
  }, /* @__PURE__ */ react.createElement(Transition/* Transition */.u, {
    mounted: ctx.opened,
    transition: ctx.transition,
    duration: ctx.transitionDuration,
    exitDuration: typeof ctx.exitTransitionDuration === "number" ? ctx.exitTransitionDuration : ctx.transitionDuration
  }, (transitionStyles) => {
    var _a2, _b;
    return /* @__PURE__ */ react.createElement(FocusTrap, {
      active: ctx.trapFocus
    }, /* @__PURE__ */ react.createElement(Box/* Box */.x, PopoverDropdown_spreadValues(PopoverDropdown_spreadProps(PopoverDropdown_spreadValues({}, accessibleProps), {
      tabIndex: -1,
      key: ctx.placement,
      ref: ctx.floating,
      style: PopoverDropdown_spreadProps(PopoverDropdown_spreadValues(PopoverDropdown_spreadValues({}, style), transitionStyles), {
        zIndex: ctx.zIndex,
        top: (_a2 = ctx.y) != null ? _a2 : 0,
        left: (_b = ctx.x) != null ? _b : 0,
        width: ctx.width === "target" ? void 0 : ctx.width
      }),
      className: cx(classes.dropdown, className),
      onKeyDownCapture: closeOnEscape(ctx.onClose, {
        active: ctx.closeOnEscape,
        onTrigger: returnFocus,
        onKeyDown: onKeyDownCapture
      }),
      "data-position": ctx.placement
    }), others), children, /* @__PURE__ */ react.createElement(FloatingArrow/* FloatingArrow */.Y, {
      ref: ctx.arrowRef,
      arrowX: ctx.arrowX,
      arrowY: ctx.arrowY,
      visible: ctx.withArrow,
      withBorder: true,
      position: ctx.placement,
      arrowSize: ctx.arrowSize,
      arrowRadius: ctx.arrowRadius,
      arrowOffset: ctx.arrowOffset,
      arrowPosition: ctx.arrowPosition,
      className: classes.arrow
    })));
  }));
}
PopoverDropdown.displayName = "@mantine/core/PopoverDropdown";


//# sourceMappingURL=PopoverDropdown.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Floating/get-floating-position/get-floating-position.js
var get_floating_position = __webpack_require__(14870);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Popover/Popover.js









var Popover_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Popover_hasOwnProp = Object.prototype.hasOwnProperty;
var Popover_propIsEnum = Object.prototype.propertyIsEnumerable;
var Popover_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Popover_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Popover_getOwnPropSymbols)
    for (var prop of Popover_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Popover_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Popover_defaultProps = {
  position: "bottom",
  offset: 8,
  positionDependencies: [],
  transition: "fade",
  transitionDuration: 150,
  middlewares: { flip: true, shift: true, inline: false },
  arrowSize: 7,
  arrowOffset: 5,
  arrowRadius: 0,
  arrowPosition: "side",
  closeOnClickOutside: true,
  withinPortal: false,
  closeOnEscape: true,
  trapFocus: false,
  withRoles: true,
  returnFocus: false,
  clickOutsideEvents: ["mousedown", "touchstart"],
  zIndex: (0,get_default_z_index/* getDefaultZIndex */.w)("popover"),
  __staticSelector: "Popover",
  width: "max-content"
};
function Popover(props) {
  var _b, _c, _d, _e, _f, _g;
  const arrowRef = (0,react.useRef)(null);
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Popover", Popover_defaultProps, props), {
    children,
    position,
    offset,
    onPositionChange,
    positionDependencies,
    opened,
    transition,
    transitionDuration,
    width,
    middlewares,
    withArrow,
    arrowSize,
    arrowOffset,
    arrowRadius,
    arrowPosition,
    unstyled,
    classNames,
    styles,
    closeOnClickOutside,
    withinPortal,
    closeOnEscape,
    clickOutsideEvents,
    trapFocus,
    onClose,
    onOpen,
    onChange,
    zIndex,
    radius,
    shadow,
    id,
    defaultOpened,
    exitTransitionDuration,
    __staticSelector,
    withRoles,
    disabled,
    returnFocus
  } = _a, others = Popover_objRest(_a, [
    "children",
    "position",
    "offset",
    "onPositionChange",
    "positionDependencies",
    "opened",
    "transition",
    "transitionDuration",
    "width",
    "middlewares",
    "withArrow",
    "arrowSize",
    "arrowOffset",
    "arrowRadius",
    "arrowPosition",
    "unstyled",
    "classNames",
    "styles",
    "closeOnClickOutside",
    "withinPortal",
    "closeOnEscape",
    "clickOutsideEvents",
    "trapFocus",
    "onClose",
    "onOpen",
    "onChange",
    "zIndex",
    "radius",
    "shadow",
    "id",
    "defaultOpened",
    "exitTransitionDuration",
    "__staticSelector",
    "withRoles",
    "disabled",
    "returnFocus"
  ]);
  const [targetNode, setTargetNode] = (0,react.useState)(null);
  const [dropdownNode, setDropdownNode] = (0,react.useState)(null);
  const uid = (0,use_id/* useId */.M)(id);
  const theme = (0,MantineProvider/* useMantineTheme */.rZ)();
  const popover = usePopover({
    middlewares,
    width,
    position: (0,get_floating_position/* getFloatingPosition */._)(theme.dir, position),
    offset: offset + (withArrow ? arrowSize / 2 : 0),
    arrowRef,
    arrowOffset,
    onPositionChange,
    positionDependencies,
    opened,
    defaultOpened,
    onChange,
    onOpen,
    onClose
  });
  useClickOutside(() => closeOnClickOutside && popover.onClose(), clickOutsideEvents, [
    targetNode,
    dropdownNode
  ]);
  const reference = (0,react.useCallback)((node) => {
    setTargetNode(node);
    popover.floating.reference(node);
  }, [popover.floating.reference]);
  const floating = (0,react.useCallback)((node) => {
    setDropdownNode(node);
    popover.floating.floating(node);
  }, [popover.floating.floating]);
  return /* @__PURE__ */ react.createElement(PopoverContextProvider, {
    value: {
      returnFocus,
      disabled,
      controlled: popover.controlled,
      reference,
      floating,
      x: popover.floating.x,
      y: popover.floating.y,
      arrowX: (_d = (_c = (_b = popover.floating) == null ? void 0 : _b.middlewareData) == null ? void 0 : _c.arrow) == null ? void 0 : _d.x,
      arrowY: (_g = (_f = (_e = popover.floating) == null ? void 0 : _e.middlewareData) == null ? void 0 : _f.arrow) == null ? void 0 : _g.y,
      opened: popover.opened,
      arrowRef,
      transition,
      transitionDuration,
      exitTransitionDuration,
      width,
      withArrow,
      arrowSize,
      arrowOffset,
      arrowRadius,
      arrowPosition,
      placement: popover.floating.placement,
      trapFocus,
      withinPortal,
      zIndex,
      radius,
      shadow,
      closeOnEscape,
      onClose: popover.onClose,
      onToggle: popover.onToggle,
      getTargetId: () => `${uid}-target`,
      getDropdownId: () => `${uid}-dropdown`,
      withRoles,
      targetProps: others,
      __staticSelector,
      classNames,
      styles,
      unstyled
    }
  }, children);
}
Popover.Target = PopoverTarget;
Popover.Dropdown = PopoverDropdown;
Popover.displayName = "@mantine/core/Popover";


//# sourceMappingURL=Popover.js.map


/***/ }),

/***/ 83143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ OptionalPortal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Portal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40254);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function OptionalPortal(_a) {
  var _b = _a, { withinPortal = true, children } = _b, others = __objRest(_b, ["withinPortal", "children"]);
  if (withinPortal) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Portal_js__WEBPACK_IMPORTED_MODULE_1__/* .Portal */ .h, __spreadValues({}, others), children);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
}
OptionalPortal.displayName = "@mantine/core/OptionalPortal";


//# sourceMappingURL=OptionalPortal.js.map


/***/ }),

/***/ 40254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Portal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10129);
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64761);





function Portal(props) {
  const { children, target, className } = (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_2__/* .useComponentDefaultProps */ .N4)("Portal", {}, props);
  const theme = (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_2__/* .useMantineTheme */ .rZ)();
  const [mounted, setMounted] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useIsomorphicEffect */ .Y)(() => {
    setMounted(true);
    ref.current = !target ? document.createElement("div") : typeof target === "string" ? document.querySelector(target) : target;
    if (!target) {
      document.body.appendChild(ref.current);
    }
    return () => {
      !target && document.body.removeChild(ref.current);
    };
  }, [target]);
  if (!mounted) {
    return null;
  }
  return (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)(/* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className,
    dir: theme.dir
  }, children), ref.current);
}
Portal.displayName = "@mantine/core/Portal";


//# sourceMappingURL=Portal.js.map


/***/ }),

/***/ 73723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ ScrollArea; }
});

// UNUSED EXPORTS: _ScrollArea

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-compose-refs/dist/index.module.js



/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react.useCallback)($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-slot/dist/index.module.js







/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = react.Children.toArray(children);
    const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if (react.Children.count(newElement) > 1) return react.Children.only(null);
                return /*#__PURE__*/ (0,react.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0,react.createElement)($5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0,react.isValidElement)(newElement) ? /*#__PURE__*/ (0,react.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0,react.createElement)($5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0,react.isValidElement)(children)) return /*#__PURE__*/ (0,react.cloneElement)(children, {
        ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref)
    });
    return react.Children.count(children) > 1 ? react.Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0,react.isValidElement)(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $5e63c961fc1ce211$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($5e63c961fc1ce211$export$8c6ed5c666ac1360));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-primitive/dist/index.module.js









const $8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'h2',
    'h3',
    'img',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        (0,react.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0,react.createElement)(Comp, (0,esm_extends/* default */.Z)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) $4q5Fq$flushSync(()=>target.dispatchEvent(event)
    );
}
/* -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($8927f6f2acc4f386$export$250ffa63cdc0d034));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-use-layout-effect/dist/index.module.js



/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? react.useLayoutEffect : ()=>{};





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-presence/dist/index.module.js










function $fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0,react.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}


const $921a889cee6df7e8$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = $921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === 'function' ? children({
        present: presence.isPresent
    }) : react.Children.only(children);
    const ref = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(presence.ref, child.ref);
    const forceMount = typeof children === 'function';
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0,react.cloneElement)(child, {
        ref: ref
    }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = 'Presence';
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0,react.useState)();
    const stylesRef = (0,react.useRef)({});
    const prevPresentRef = (0,react.useRef)(present);
    const prevAnimationNameRef = (0,react.useRef)('none');
    const initialState = present ? 'mounted' : 'unmounted';
    const [state, send] = $fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: 'unmounted',
            ANIMATION_OUT: 'unmountSuspended'
        },
        unmountSuspended: {
            MOUNT: 'mounted',
            ANIMATION_END: 'unmounted'
        },
        unmounted: {
            MOUNT: 'mounted'
        }
    });
    (0,react.useEffect)(()=>{
        const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
    }, [
        state
    ]);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send('MOUNT');
            else if (currentAnimationName === 'none' || (styles === null || styles === void 0 ? void 0 : styles.display) === 'none') // If there is no exit animation or the element is hidden, animations won't run
            // so we unmount instantly
            send('UNMOUNT');
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send('ANIMATION_OUT');
                else send('UNMOUNT');
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // With React 18 concurrency this update is applied
                // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0,react_dom.flushSync)(()=>send('ANIMATION_END')
                );
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) // if animation occurred, store its name as the previous animation.
                prevAnimationNameRef.current = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener('animationstart', handleAnimationStart);
            node1.addEventListener('animationcancel', handleAnimationEnd);
            node1.addEventListener('animationend', handleAnimationEnd);
            return ()=>{
                node1.removeEventListener('animationstart', handleAnimationStart);
                node1.removeEventListener('animationcancel', handleAnimationEnd);
                node1.removeEventListener('animationend', handleAnimationEnd);
            };
        } else // Transition to the unmounted state if the node is removed prematurely.
        // We avoid doing so during cleanup as the node may change but still exist.
        send('ANIMATION_END');
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            'mounted',
            'unmountSuspended'
        ].includes(state),
        ref: (0,react.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || 'none';
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-context/dist/index.module.js



function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ $3bkAK$createContext(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = $3bkAK$useMemo(()=>context
        , Object.values(context));
        return /*#__PURE__*/ $3bkAK$createElement(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = $3bkAK$useContext(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + 'Provider';
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0,react.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0,react.useMemo)(()=>context
            , Object.values(context));
            return /*#__PURE__*/ (0,react.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0,react.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + 'Provider';
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0,react.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0,react.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                })
            , [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            })
        );
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0,react.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                })
            , [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js



/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0,react.useRef)(callback);
    (0,react.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0,react.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }
    , []);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-direction/dist/index.module.js



const $f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0,react.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $f631663db3294ace$export$c760c09fdd558351 = (props)=>{
    const { dir: dir , children: children  } = props;
    return /*#__PURE__*/ $7Gjcd$createElement($f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $f631663db3294ace$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0,react.useContext)($f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || 'ltr';
}
const $f631663db3294ace$export$2881499e37b75b9a = (/* unused pure expression or super */ null && ($f631663db3294ace$export$c760c09fdd558351));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/number/dist/index.module.js
function $ae6933e535247d3d$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/primitive/dist/index.module.js
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-scroll-area/dist/index.module.js
























function $6c2e24571c90391f$export$3e6543de14f8614f(initialState, machine) {
    return (0,react.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}


/* -------------------------------------------------------------------------------------------------
 * ScrollArea
 * -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$SCROLL_AREA_NAME = 'ScrollArea';
const [$57acba87d6e25586$var$createScrollAreaContext, $57acba87d6e25586$export$488468afe3a6f2b1] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($57acba87d6e25586$var$SCROLL_AREA_NAME);
const [$57acba87d6e25586$var$ScrollAreaProvider, $57acba87d6e25586$var$useScrollAreaContext] = $57acba87d6e25586$var$createScrollAreaContext($57acba87d6e25586$var$SCROLL_AREA_NAME);
const $57acba87d6e25586$export$ccf8d8d7bbf3c2cc = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea , type: type = 'hover' , dir: dir , scrollHideDelay: scrollHideDelay = 600 , ...scrollAreaProps } = props;
    const [scrollArea, setScrollArea] = (0,react.useState)(null);
    const [viewport, setViewport] = (0,react.useState)(null);
    const [content, setContent] = (0,react.useState)(null);
    const [scrollbarX, setScrollbarX] = (0,react.useState)(null);
    const [scrollbarY, setScrollbarY] = (0,react.useState)(null);
    const [cornerWidth, setCornerWidth] = (0,react.useState)(0);
    const [cornerHeight, setCornerHeight] = (0,react.useState)(0);
    const [scrollbarXEnabled, setScrollbarXEnabled] = (0,react.useState)(false);
    const [scrollbarYEnabled, setScrollbarYEnabled] = (0,react.useState)(false);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setScrollArea(node)
    );
    const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
    return /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollAreaProvider, {
        scope: __scopeScrollArea,
        type: type,
        dir: direction,
        scrollHideDelay: scrollHideDelay,
        scrollArea: scrollArea,
        viewport: viewport,
        onViewportChange: setViewport,
        content: content,
        onContentChange: setContent,
        scrollbarX: scrollbarX,
        onScrollbarXChange: setScrollbarX,
        scrollbarXEnabled: scrollbarXEnabled,
        onScrollbarXEnabledChange: setScrollbarXEnabled,
        scrollbarY: scrollbarY,
        onScrollbarYChange: setScrollbarY,
        scrollbarYEnabled: scrollbarYEnabled,
        onScrollbarYEnabledChange: setScrollbarYEnabled,
        onCornerWidthChange: setCornerWidth,
        onCornerHeightChange: setCornerHeight
    }, /*#__PURE__*/ (0,react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({
        dir: direction
    }, scrollAreaProps, {
        ref: composedRefs,
        style: {
            position: 'relative',
            // Pass corner sizes as CSS vars to reduce re-renders of context consumers
            ['--radix-scroll-area-corner-width']: cornerWidth + 'px',
            ['--radix-scroll-area-corner-height']: cornerHeight + 'px',
            ...props.style
        }
    })));
});
/*#__PURE__*/ Object.assign($57acba87d6e25586$export$ccf8d8d7bbf3c2cc, {
    displayName: $57acba87d6e25586$var$SCROLL_AREA_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaViewport
 * -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$VIEWPORT_NAME = 'ScrollAreaViewport';
const $57acba87d6e25586$export$a21cbf9f11fca853 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea , children: children , ...viewportProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$VIEWPORT_NAME, __scopeScrollArea);
    const ref = (0,react.useRef)(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onViewportChange);
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, /*#__PURE__*/ (0,react.createElement)("style", {
        dangerouslySetInnerHTML: {
            __html: `[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}`
        }
    }), /*#__PURE__*/ (0,react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({
        "data-radix-scroll-area-viewport": ""
    }, viewportProps, {
        ref: composedRefs,
        style: {
            /**
       * We don't support `visible` because the intention is to have at least one scrollbar
       * if this component is used and `visible` will behave like `auto` in that case
       * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
       *
       * We don't handle `auto` because the intention is for the native implementation
       * to be hidden if using this component. We just want to ensure the node is scrollable
       * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
       * the browser from having to work out whether to render native scrollbars or not,
       * we tell it to with the intention of hiding them in CSS.
       */ overflowX: context.scrollbarXEnabled ? 'scroll' : 'hidden',
            overflowY: context.scrollbarYEnabled ? 'scroll' : 'hidden',
            ...props.style
        }
    }), /*#__PURE__*/ (0,react.createElement)("div", {
        ref: context.onContentChange,
        style: {
            minWidth: '100%',
            display: 'table'
        }
    }, children)));
});
/*#__PURE__*/ Object.assign($57acba87d6e25586$export$a21cbf9f11fca853, {
    displayName: $57acba87d6e25586$var$VIEWPORT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaScrollbar
 * -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$SCROLLBAR_NAME = 'ScrollAreaScrollbar';
const $57acba87d6e25586$export$2fabd85d0eba3c57 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const { onScrollbarXEnabledChange: onScrollbarXEnabledChange , onScrollbarYEnabledChange: onScrollbarYEnabledChange  } = context;
    const isHorizontal = props.orientation === 'horizontal';
    (0,react.useEffect)(()=>{
        isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
        return ()=>{
            isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
        };
    }, [
        isHorizontal,
        onScrollbarXEnabledChange,
        onScrollbarYEnabledChange
    ]);
    return context.type === 'hover' ? /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarHover, (0,esm_extends/* default */.Z)({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === 'scroll' ? /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarScroll, (0,esm_extends/* default */.Z)({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === 'auto' ? /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarAuto, (0,esm_extends/* default */.Z)({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === 'always' ? /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarVisible, (0,esm_extends/* default */.Z)({}, scrollbarProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($57acba87d6e25586$export$2fabd85d0eba3c57, {
    displayName: $57acba87d6e25586$var$SCROLLBAR_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$ScrollAreaScrollbarHover = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [visible, setVisible] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const scrollArea = context.scrollArea;
        let hideTimer = 0;
        if (scrollArea) {
            const handlePointerEnter = ()=>{
                window.clearTimeout(hideTimer);
                setVisible(true);
            };
            const handlePointerLeave = ()=>{
                hideTimer = window.setTimeout(()=>setVisible(false)
                , context.scrollHideDelay);
            };
            scrollArea.addEventListener('pointerenter', handlePointerEnter);
            scrollArea.addEventListener('pointerleave', handlePointerLeave);
            return ()=>{
                window.clearTimeout(hideTimer);
                scrollArea.removeEventListener('pointerenter', handlePointerEnter);
                scrollArea.removeEventListener('pointerleave', handlePointerLeave);
            };
        }
    }, [
        context.scrollArea,
        context.scrollHideDelay
    ]);
    return /*#__PURE__*/ (0,react.createElement)($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || visible
    }, /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarAuto, (0,esm_extends/* default */.Z)({
        "data-state": visible ? 'visible' : 'hidden'
    }, scrollbarProps, {
        ref: forwardedRef
    })));
});
const $57acba87d6e25586$var$ScrollAreaScrollbarScroll = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const isHorizontal = props.orientation === 'horizontal';
    const debounceScrollEnd = $57acba87d6e25586$var$useDebounceCallback(()=>send('SCROLL_END')
    , 100);
    const [state, send] = $6c2e24571c90391f$export$3e6543de14f8614f('hidden', {
        hidden: {
            SCROLL: 'scrolling'
        },
        scrolling: {
            SCROLL_END: 'idle',
            POINTER_ENTER: 'interacting'
        },
        interacting: {
            SCROLL: 'interacting',
            POINTER_LEAVE: 'idle'
        },
        idle: {
            HIDE: 'hidden',
            SCROLL: 'scrolling',
            POINTER_ENTER: 'interacting'
        }
    });
    (0,react.useEffect)(()=>{
        if (state === 'idle') {
            const hideTimer = window.setTimeout(()=>send('HIDE')
            , context.scrollHideDelay);
            return ()=>window.clearTimeout(hideTimer)
            ;
        }
    }, [
        state,
        context.scrollHideDelay,
        send
    ]);
    (0,react.useEffect)(()=>{
        const viewport = context.viewport;
        const scrollDirection = isHorizontal ? 'scrollLeft' : 'scrollTop';
        if (viewport) {
            let prevScrollPos = viewport[scrollDirection];
            const handleScroll = ()=>{
                const scrollPos = viewport[scrollDirection];
                const hasScrollInDirectionChanged = prevScrollPos !== scrollPos;
                if (hasScrollInDirectionChanged) {
                    send('SCROLL');
                    debounceScrollEnd();
                }
                prevScrollPos = scrollPos;
            };
            viewport.addEventListener('scroll', handleScroll);
            return ()=>viewport.removeEventListener('scroll', handleScroll)
            ;
        }
    }, [
        context.viewport,
        isHorizontal,
        send,
        debounceScrollEnd
    ]);
    return /*#__PURE__*/ (0,react.createElement)($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || state !== 'hidden'
    }, /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarVisible, (0,esm_extends/* default */.Z)({
        "data-state": state === 'hidden' ? 'hidden' : 'visible'
    }, scrollbarProps, {
        ref: forwardedRef,
        onPointerEnter: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerEnter, ()=>send('POINTER_ENTER')
        ),
        onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerLeave, ()=>send('POINTER_LEAVE')
        )
    })));
});
const $57acba87d6e25586$var$ScrollAreaScrollbarAuto = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const { forceMount: forceMount , ...scrollbarProps } = props;
    const [visible, setVisible] = (0,react.useState)(false);
    const isHorizontal = props.orientation === 'horizontal';
    const handleResize = $57acba87d6e25586$var$useDebounceCallback(()=>{
        if (context.viewport) {
            const isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
            const isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
            setVisible(isHorizontal ? isOverflowX : isOverflowY);
        }
    }, 10);
    $57acba87d6e25586$var$useResizeObserver(context.viewport, handleResize);
    $57acba87d6e25586$var$useResizeObserver(context.content, handleResize);
    return /*#__PURE__*/ (0,react.createElement)($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || visible
    }, /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarVisible, (0,esm_extends/* default */.Z)({
        "data-state": visible ? 'visible' : 'hidden'
    }, scrollbarProps, {
        ref: forwardedRef
    })));
});
/* -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$ScrollAreaScrollbarVisible = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { orientation: orientation = 'vertical' , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const thumbRef = (0,react.useRef)(null);
    const pointerOffsetRef = (0,react.useRef)(0);
    const [sizes, setSizes] = (0,react.useState)({
        content: 0,
        viewport: 0,
        scrollbar: {
            size: 0,
            paddingStart: 0,
            paddingEnd: 0
        }
    });
    const thumbRatio = $57acba87d6e25586$var$getThumbRatio(sizes.viewport, sizes.content);
    const commonProps = {
        ...scrollbarProps,
        sizes: sizes,
        onSizesChange: setSizes,
        hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
        onThumbChange: (thumb)=>thumbRef.current = thumb
        ,
        onThumbPointerUp: ()=>pointerOffsetRef.current = 0
        ,
        onThumbPointerDown: (pointerPos)=>pointerOffsetRef.current = pointerPos
    };
    function getScrollPosition(pointerPos, dir) {
        return $57acba87d6e25586$var$getScrollPositionFromPointer(pointerPos, pointerOffsetRef.current, sizes, dir);
    }
    if (orientation === 'horizontal') return /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarX, (0,esm_extends/* default */.Z)({}, commonProps, {
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollLeft;
                const offset = $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes, context.dir);
                thumbRef.current.style.transform = `translate3d(${offset}px, 0, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollLeft = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollLeft = getScrollPosition(pointerPos, context.dir);
        }
    }));
    if (orientation === 'vertical') return /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarY, (0,esm_extends/* default */.Z)({}, commonProps, {
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollTop;
                const offset = $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes);
                thumbRef.current.style.transform = `translate3d(0, ${offset}px, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollTop = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollTop = getScrollPosition(pointerPos);
        }
    }));
    return null;
});
/* -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$ScrollAreaScrollbarX = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { sizes: sizes , onSizesChange: onSizesChange , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [computedStyle, setComputedStyle] = (0,react.useState)();
    const ref = (0,react.useRef)(null);
    const composeRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onScrollbarXChange);
    (0,react.useEffect)(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarImpl, (0,esm_extends/* default */.Z)({
        "data-orientation": "horizontal"
    }, scrollbarProps, {
        ref: composeRefs,
        sizes: sizes,
        style: {
            bottom: 0,
            left: context.dir === 'rtl' ? 'var(--radix-scroll-area-corner-width)' : 0,
            right: context.dir === 'ltr' ? 'var(--radix-scroll-area-corner-width)' : 0,
            ['--radix-scroll-area-thumb-width']: $57acba87d6e25586$var$getThumbSize(sizes) + 'px',
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.x)
        ,
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.x)
        ,
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollLeft + event.deltaX;
                props.onWheelScroll(scrollPos); // prevent window scroll when wheeling on scrollbar
                if ($57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollWidth,
                viewport: context.viewport.offsetWidth,
                scrollbar: {
                    size: ref.current.clientWidth,
                    paddingStart: $57acba87d6e25586$var$toInt(computedStyle.paddingLeft),
                    paddingEnd: $57acba87d6e25586$var$toInt(computedStyle.paddingRight)
                }
            });
        }
    }));
});
const $57acba87d6e25586$var$ScrollAreaScrollbarY = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { sizes: sizes , onSizesChange: onSizesChange , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [computedStyle, setComputedStyle] = (0,react.useState)();
    const ref = (0,react.useRef)(null);
    const composeRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onScrollbarYChange);
    (0,react.useEffect)(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarImpl, (0,esm_extends/* default */.Z)({
        "data-orientation": "vertical"
    }, scrollbarProps, {
        ref: composeRefs,
        sizes: sizes,
        style: {
            top: 0,
            right: context.dir === 'ltr' ? 0 : undefined,
            left: context.dir === 'rtl' ? 0 : undefined,
            bottom: 'var(--radix-scroll-area-corner-height)',
            ['--radix-scroll-area-thumb-height']: $57acba87d6e25586$var$getThumbSize(sizes) + 'px',
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.y)
        ,
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.y)
        ,
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollTop + event.deltaY;
                props.onWheelScroll(scrollPos); // prevent window scroll when wheeling on scrollbar
                if ($57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollHeight,
                viewport: context.viewport.offsetHeight,
                scrollbar: {
                    size: ref.current.clientHeight,
                    paddingStart: $57acba87d6e25586$var$toInt(computedStyle.paddingTop),
                    paddingEnd: $57acba87d6e25586$var$toInt(computedStyle.paddingBottom)
                }
            });
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const [$57acba87d6e25586$var$ScrollbarProvider, $57acba87d6e25586$var$useScrollbarContext] = $57acba87d6e25586$var$createScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME);
const $57acba87d6e25586$var$ScrollAreaScrollbarImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea , sizes: sizes , hasThumb: hasThumb , onThumbChange: onThumbChange , onThumbPointerUp: onThumbPointerUp , onThumbPointerDown: onThumbPointerDown , onThumbPositionChange: onThumbPositionChange , onDragScroll: onDragScroll , onWheelScroll: onWheelScroll , onResize: onResize , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, __scopeScrollArea);
    const [scrollbar, setScrollbar] = (0,react.useState)(null);
    const composeRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setScrollbar(node)
    );
    const rectRef = (0,react.useRef)(null);
    const prevWebkitUserSelectRef = (0,react.useRef)('');
    const viewport = context.viewport;
    const maxScrollPos = sizes.content - sizes.viewport;
    const handleWheelScroll = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onWheelScroll);
    const handleThumbPositionChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onThumbPositionChange);
    const handleResize = $57acba87d6e25586$var$useDebounceCallback(onResize, 10);
    function handleDragScroll(event) {
        if (rectRef.current) {
            const x = event.clientX - rectRef.current.left;
            const y = event.clientY - rectRef.current.top;
            onDragScroll({
                x: x,
                y: y
            });
        }
    }
    /**
   * We bind wheel event imperatively so we can switch off passive
   * mode for document wheel event to allow it to be prevented
   */ (0,react.useEffect)(()=>{
        const handleWheel = (event)=>{
            const element = event.target;
            const isScrollbarWheel = scrollbar === null || scrollbar === void 0 ? void 0 : scrollbar.contains(element);
            if (isScrollbarWheel) handleWheelScroll(event, maxScrollPos);
        };
        document.addEventListener('wheel', handleWheel, {
            passive: false
        });
        return ()=>document.removeEventListener('wheel', handleWheel, {
                passive: false
            })
        ;
    }, [
        viewport,
        scrollbar,
        maxScrollPos,
        handleWheelScroll
    ]);
    /**
   * Update thumb position on sizes change
   */ (0,react.useEffect)(handleThumbPositionChange, [
        sizes,
        handleThumbPositionChange
    ]);
    $57acba87d6e25586$var$useResizeObserver(scrollbar, handleResize);
    $57acba87d6e25586$var$useResizeObserver(context.content, handleResize);
    return /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollbarProvider, {
        scope: __scopeScrollArea,
        scrollbar: scrollbar,
        hasThumb: hasThumb,
        onThumbChange: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onThumbChange),
        onThumbPointerUp: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onThumbPointerUp),
        onThumbPositionChange: handleThumbPositionChange,
        onThumbPointerDown: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onThumbPointerDown)
    }, /*#__PURE__*/ (0,react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({}, scrollbarProps, {
        ref: composeRefs,
        style: {
            position: 'absolute',
            ...scrollbarProps.style
        },
        onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, (event)=>{
            const mainPointer = 0;
            if (event.button === mainPointer) {
                const element = event.target;
                element.setPointerCapture(event.pointerId);
                rectRef.current = scrollbar.getBoundingClientRect(); // pointer capture doesn't prevent text selection in Safari
                // so we remove text selection manually when scrolling
                prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect;
                document.body.style.webkitUserSelect = 'none';
                handleDragScroll(event);
            }
        }),
        onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, handleDragScroll),
        onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, (event)=>{
            const element = event.target;
            if (element.hasPointerCapture(event.pointerId)) element.releasePointerCapture(event.pointerId);
            document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current;
            rectRef.current = null;
        })
    })));
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaThumb
 * -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$THUMB_NAME = 'ScrollAreaThumb';
const $57acba87d6e25586$export$9fba1154677d7cd2 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , ...thumbProps } = props;
    const scrollbarContext = $57acba87d6e25586$var$useScrollbarContext($57acba87d6e25586$var$THUMB_NAME, props.__scopeScrollArea);
    return /*#__PURE__*/ (0,react.createElement)($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || scrollbarContext.hasThumb
    }, /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollAreaThumbImpl, (0,esm_extends/* default */.Z)({
        ref: forwardedRef
    }, thumbProps)));
});
const $57acba87d6e25586$var$ScrollAreaThumbImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea , style: style , ...thumbProps } = props;
    const scrollAreaContext = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$THUMB_NAME, __scopeScrollArea);
    const scrollbarContext = $57acba87d6e25586$var$useScrollbarContext($57acba87d6e25586$var$THUMB_NAME, __scopeScrollArea);
    const { onThumbPositionChange: onThumbPositionChange  } = scrollbarContext;
    const composedRef = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>scrollbarContext.onThumbChange(node)
    );
    const removeUnlinkedScrollListenerRef = (0,react.useRef)();
    const debounceScrollEnd = $57acba87d6e25586$var$useDebounceCallback(()=>{
        if (removeUnlinkedScrollListenerRef.current) {
            removeUnlinkedScrollListenerRef.current();
            removeUnlinkedScrollListenerRef.current = undefined;
        }
    }, 100);
    (0,react.useEffect)(()=>{
        const viewport = scrollAreaContext.viewport;
        if (viewport) {
            /**
       * We only bind to native scroll event so we know when scroll starts and ends.
       * When scroll starts we start a requestAnimationFrame loop that checks for
       * changes to scroll position. That rAF loop triggers our thumb position change
       * when relevant to avoid scroll-linked effects. We cancel the loop when scroll ends.
       * https://developer.mozilla.org/en-US/docs/Mozilla/Performance/Scroll-linked_effects
       */ const handleScroll = ()=>{
                debounceScrollEnd();
                if (!removeUnlinkedScrollListenerRef.current) {
                    const listener = $57acba87d6e25586$var$addUnlinkedScrollListener(viewport, onThumbPositionChange);
                    removeUnlinkedScrollListenerRef.current = listener;
                    onThumbPositionChange();
                }
            };
            onThumbPositionChange();
            viewport.addEventListener('scroll', handleScroll);
            return ()=>viewport.removeEventListener('scroll', handleScroll)
            ;
        }
    }, [
        scrollAreaContext.viewport,
        debounceScrollEnd,
        onThumbPositionChange
    ]);
    return /*#__PURE__*/ (0,react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({
        "data-state": scrollbarContext.hasThumb ? 'visible' : 'hidden'
    }, thumbProps, {
        ref: composedRef,
        style: {
            width: 'var(--radix-scroll-area-thumb-width)',
            height: 'var(--radix-scroll-area-thumb-height)',
            ...style
        },
        onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownCapture, (event)=>{
            const thumb = event.target;
            const thumbRect = thumb.getBoundingClientRect();
            const x = event.clientX - thumbRect.left;
            const y = event.clientY - thumbRect.top;
            scrollbarContext.onThumbPointerDown({
                x: x,
                y: y
            });
        }),
        onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, scrollbarContext.onThumbPointerUp)
    }));
});
/*#__PURE__*/ Object.assign($57acba87d6e25586$export$9fba1154677d7cd2, {
    displayName: $57acba87d6e25586$var$THUMB_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaCorner
 * -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$CORNER_NAME = 'ScrollAreaCorner';
const $57acba87d6e25586$export$56969d565df7cc4b = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$CORNER_NAME, props.__scopeScrollArea);
    const hasBothScrollbarsVisible = Boolean(context.scrollbarX && context.scrollbarY);
    const hasCorner = context.type !== 'scroll' && hasBothScrollbarsVisible;
    return hasCorner ? /*#__PURE__*/ (0,react.createElement)($57acba87d6e25586$var$ScrollAreaCornerImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($57acba87d6e25586$export$56969d565df7cc4b, {
    displayName: $57acba87d6e25586$var$CORNER_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$ScrollAreaCornerImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea , ...cornerProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$CORNER_NAME, __scopeScrollArea);
    const [width1, setWidth] = (0,react.useState)(0);
    const [height1, setHeight] = (0,react.useState)(0);
    const hasSize = Boolean(width1 && height1);
    $57acba87d6e25586$var$useResizeObserver(context.scrollbarX, ()=>{
        var _context$scrollbarX;
        const height = ((_context$scrollbarX = context.scrollbarX) === null || _context$scrollbarX === void 0 ? void 0 : _context$scrollbarX.offsetHeight) || 0;
        context.onCornerHeightChange(height);
        setHeight(height);
    });
    $57acba87d6e25586$var$useResizeObserver(context.scrollbarY, ()=>{
        var _context$scrollbarY;
        const width = ((_context$scrollbarY = context.scrollbarY) === null || _context$scrollbarY === void 0 ? void 0 : _context$scrollbarY.offsetWidth) || 0;
        context.onCornerWidthChange(width);
        setWidth(width);
    });
    return hasSize ? /*#__PURE__*/ (0,react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({}, cornerProps, {
        ref: forwardedRef,
        style: {
            width: width1,
            height: height1,
            position: 'absolute',
            right: context.dir === 'ltr' ? 0 : undefined,
            left: context.dir === 'rtl' ? 0 : undefined,
            bottom: 0,
            ...props.style
        }
    })) : null;
});
/* -----------------------------------------------------------------------------------------------*/ function $57acba87d6e25586$var$toInt(value) {
    return value ? parseInt(value, 10) : 0;
}
function $57acba87d6e25586$var$getThumbRatio(viewportSize, contentSize) {
    const ratio = viewportSize / contentSize;
    return isNaN(ratio) ? 0 : ratio;
}
function $57acba87d6e25586$var$getThumbSize(sizes) {
    const ratio = $57acba87d6e25586$var$getThumbRatio(sizes.viewport, sizes.content);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio; // minimum of 18 matches macOS minimum
    return Math.max(thumbSize, 18);
}
function $57acba87d6e25586$var$getScrollPositionFromPointer(pointerPos, pointerOffset, sizes, dir = 'ltr') {
    const thumbSizePx = $57acba87d6e25586$var$getThumbSize(sizes);
    const thumbCenter = thumbSizePx / 2;
    const offset = pointerOffset || thumbCenter;
    const thumbOffsetFromEnd = thumbSizePx - offset;
    const minPointerPos = sizes.scrollbar.paddingStart + offset;
    const maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
    const maxScrollPos = sizes.content - sizes.viewport;
    const scrollRange = dir === 'ltr' ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const interpolate = $57acba87d6e25586$var$linearScale([
        minPointerPos,
        maxPointerPos
    ], scrollRange);
    return interpolate(pointerPos);
}
function $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes, dir = 'ltr') {
    const thumbSizePx = $57acba87d6e25586$var$getThumbSize(sizes);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const scrollbar = sizes.scrollbar.size - scrollbarPadding;
    const maxScrollPos = sizes.content - sizes.viewport;
    const maxThumbPos = scrollbar - thumbSizePx;
    const scrollClampRange = dir === 'ltr' ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const scrollWithoutMomentum = $ae6933e535247d3d$export$7d15b64cf5a3a4c4(scrollPos, scrollClampRange);
    const interpolate = $57acba87d6e25586$var$linearScale([
        0,
        maxScrollPos
    ], [
        0,
        maxThumbPos
    ]);
    return interpolate(scrollWithoutMomentum);
} // https://github.com/tmcw-up-for-adoption/simple-linear-scale/blob/master/index.js
function $57acba87d6e25586$var$linearScale(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        const ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}
function $57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
    return scrollPos > 0 && scrollPos < maxScrollPos;
} // Custom scroll handler to avoid scroll-linked effects
// https://developer.mozilla.org/en-US/docs/Mozilla/Performance/Scroll-linked_effects
const $57acba87d6e25586$var$addUnlinkedScrollListener = (node, handler = ()=>{})=>{
    let prevPosition = {
        left: node.scrollLeft,
        top: node.scrollTop
    };
    let rAF = 0;
    (function loop() {
        const position = {
            left: node.scrollLeft,
            top: node.scrollTop
        };
        const isHorizontalScroll = prevPosition.left !== position.left;
        const isVerticalScroll = prevPosition.top !== position.top;
        if (isHorizontalScroll || isVerticalScroll) handler();
        prevPosition = position;
        rAF = window.requestAnimationFrame(loop);
    })();
    return ()=>window.cancelAnimationFrame(rAF)
    ;
};
function $57acba87d6e25586$var$useDebounceCallback(callback, delay) {
    const handleCallback = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback);
    const debounceTimerRef = (0,react.useRef)(0);
    (0,react.useEffect)(()=>()=>window.clearTimeout(debounceTimerRef.current)
    , []);
    return (0,react.useCallback)(()=>{
        window.clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = window.setTimeout(handleCallback, delay);
    }, [
        handleCallback,
        delay
    ]);
}
function $57acba87d6e25586$var$useResizeObserver(element, onResize) {
    const handleResize = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onResize);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        let rAF = 0;
        if (element) {
            /**
       * Resize Observer will throw an often benign error that says `ResizeObserver loop
       * completed with undelivered notifications`. This means that ResizeObserver was not
       * able to deliver all observations within a single animation frame, so we use
       * `requestAnimationFrame` to ensure we don't deliver unnecessary observations.
       * Further reading: https://github.com/WICG/resize-observer/issues/38
       */ const resizeObserver = new ResizeObserver(()=>{
                cancelAnimationFrame(rAF);
                rAF = window.requestAnimationFrame(handleResize);
            });
            resizeObserver.observe(element);
            return ()=>{
                window.cancelAnimationFrame(rAF);
                resizeObserver.unobserve(element);
            };
        }
    }, [
        element,
        handleResize
    ]);
}
/* -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$export$be92b6f5f03c0fe9 = $57acba87d6e25586$export$ccf8d8d7bbf3c2cc;
const $57acba87d6e25586$export$d5c6c08dc2d3ca7 = $57acba87d6e25586$export$a21cbf9f11fca853;
const $57acba87d6e25586$export$9a4e88b92edfce6b = $57acba87d6e25586$export$2fabd85d0eba3c57;
const $57acba87d6e25586$export$6521433ed15a34db = $57acba87d6e25586$export$9fba1154677d7cd2;
const $57acba87d6e25586$export$ac61190d9fc311a9 = $57acba87d6e25586$export$56969d565df7cc4b;





//# sourceMappingURL=index.module.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/pack-sx/pack-sx.js
var pack_sx = __webpack_require__(97818);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/ScrollArea/ScrollArea.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { scrollbarSize, offsetScrollbars, scrollbarHovered, hidden }, getRef) => ({
  root: {
    overflow: "hidden"
  },
  viewport: {
    width: "100%",
    height: "100%",
    paddingRight: offsetScrollbars ? scrollbarSize : void 0,
    paddingBottom: offsetScrollbars ? scrollbarSize : void 0
  },
  scrollbar: {
    display: hidden ? "none" : "flex",
    userSelect: "none",
    touchAction: "none",
    boxSizing: "border-box",
    padding: scrollbarSize / 5,
    transition: "background-color 150ms ease, opacity 150ms ease",
    "&:hover": {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0],
      [`& .${getRef("thumb")}`]: {
        backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.white, 0.5) : theme.fn.rgba(theme.black, 0.5)
      }
    },
    '&[data-orientation="vertical"]': {
      width: scrollbarSize
    },
    '&[data-orientation="horizontal"]': {
      flexDirection: "column",
      height: scrollbarSize
    },
    '&[data-state="hidden"]': {
      display: "none",
      opacity: 0
    }
  },
  thumb: {
    ref: getRef("thumb"),
    flex: 1,
    backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.white, 0.4) : theme.fn.rgba(theme.black, 0.4),
    borderRadius: scrollbarSize,
    position: "relative",
    transition: "background-color 150ms ease",
    display: hidden ? "none" : void 0,
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      height: "100%",
      minWidth: 44,
      minHeight: 44
    }
  },
  corner: {
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],
    transition: "opacity 150ms ease",
    opacity: scrollbarHovered ? 1 : 0,
    display: hidden ? "none" : void 0
  }
}));

/* harmony default export */ var ScrollArea_styles = (useStyles);
//# sourceMappingURL=ScrollArea.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/ScrollArea/ScrollArea.js







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  scrollbarSize: 12,
  scrollHideDelay: 1e3,
  type: "hover",
  offsetScrollbars: false
};
const _ScrollArea = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("ScrollArea", defaultProps, props), {
    children,
    className,
    classNames,
    styles,
    scrollbarSize,
    scrollHideDelay,
    type,
    dir,
    offsetScrollbars,
    viewportRef,
    onScrollPositionChange,
    unstyled,
    viewportProps
  } = _a, others = __objRest(_a, [
    "children",
    "className",
    "classNames",
    "styles",
    "scrollbarSize",
    "scrollHideDelay",
    "type",
    "dir",
    "offsetScrollbars",
    "viewportRef",
    "onScrollPositionChange",
    "unstyled",
    "viewportProps"
  ]);
  const [scrollbarHovered, setScrollbarHovered] = (0,react.useState)(false);
  const theme = (0,MantineProvider/* useMantineTheme */.rZ)();
  const { classes, cx } = ScrollArea_styles({ scrollbarSize, offsetScrollbars, scrollbarHovered, hidden: type === "never" }, { name: "ScrollArea", classNames, styles, unstyled });
  return /* @__PURE__ */ react.createElement($57acba87d6e25586$export$be92b6f5f03c0fe9, {
    type: type === "never" ? "always" : type,
    scrollHideDelay,
    dir: dir || theme.dir,
    ref,
    asChild: true
  }, /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.root, className)
  }, others), /* @__PURE__ */ react.createElement($57acba87d6e25586$export$d5c6c08dc2d3ca7, __spreadProps(__spreadValues({}, viewportProps), {
    className: classes.viewport,
    ref: viewportRef,
    onScroll: typeof onScrollPositionChange === "function" ? ({ currentTarget }) => onScrollPositionChange({
      x: currentTarget.scrollLeft,
      y: currentTarget.scrollTop
    }) : void 0
  }), children), /* @__PURE__ */ react.createElement($57acba87d6e25586$export$9a4e88b92edfce6b, {
    orientation: "horizontal",
    className: classes.scrollbar,
    forceMount: true,
    onMouseEnter: () => setScrollbarHovered(true),
    onMouseLeave: () => setScrollbarHovered(false)
  }, /* @__PURE__ */ react.createElement($57acba87d6e25586$export$6521433ed15a34db, {
    className: classes.thumb
  })), /* @__PURE__ */ react.createElement($57acba87d6e25586$export$9a4e88b92edfce6b, {
    orientation: "vertical",
    className: classes.scrollbar,
    forceMount: true,
    onMouseEnter: () => setScrollbarHovered(true),
    onMouseLeave: () => setScrollbarHovered(false)
  }, /* @__PURE__ */ react.createElement($57acba87d6e25586$export$6521433ed15a34db, {
    className: classes.thumb
  })), /* @__PURE__ */ react.createElement($57acba87d6e25586$export$ac61190d9fc311a9, {
    className: classes.corner
  })));
});
const ScrollAreaAutosize = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("ScrollAreaAutosize", defaultProps, props), {
    maxHeight,
    children,
    classNames,
    styles,
    scrollbarSize,
    scrollHideDelay,
    type,
    dir,
    offsetScrollbars,
    viewportRef,
    onScrollPositionChange,
    unstyled,
    sx
  } = _a, others = __objRest(_a, [
    "maxHeight",
    "children",
    "classNames",
    "styles",
    "scrollbarSize",
    "scrollHideDelay",
    "type",
    "dir",
    "offsetScrollbars",
    "viewportRef",
    "onScrollPositionChange",
    "unstyled",
    "sx"
  ]);
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadProps(__spreadValues({}, others), {
    ref,
    sx: [{ display: "flex", maxHeight }, ...(0,pack_sx/* packSx */.R)(sx)]
  }), /* @__PURE__ */ react.createElement(Box/* Box */.x, {
    sx: { display: "flex", flexDirection: "column", flex: 1 }
  }, /* @__PURE__ */ react.createElement(_ScrollArea, {
    classNames,
    styles,
    scrollHideDelay,
    scrollbarSize,
    type,
    dir,
    offsetScrollbars,
    viewportRef,
    onScrollPositionChange,
    unstyled
  }, children)));
});
ScrollAreaAutosize.displayName = "@mantine/core/ScrollAreaAutosize";
_ScrollArea.displayName = "@mantine/core/ScrollArea";
_ScrollArea.Autosize = ScrollAreaAutosize;
const ScrollArea = _ScrollArea;


//# sourceMappingURL=ScrollArea.js.map


/***/ }),

/***/ 97564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ Stack; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Stack/Stack.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { spacing, align, justify }) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: align,
    justifyContent: justify,
    gap: theme.fn.size({ size: spacing, sizes: theme.spacing })
  }
}));

/* harmony default export */ var Stack_styles = (useStyles);
//# sourceMappingURL=Stack.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Stack/Stack.js





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  spacing: "md",
  align: "stretch",
  justify: "top"
};
const Stack = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Stack", defaultProps, props), { spacing, className, align, justify, unstyled } = _a, others = __objRest(_a, ["spacing", "className", "align", "justify", "unstyled"]);
  const { classes, cx } = Stack_styles({ spacing, align, justify }, { name: "Stack", unstyled });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.root, className),
    ref
  }, others));
});
Stack.displayName = "@mantine/core/Stack";


//# sourceMappingURL=Stack.js.map


/***/ }),

/***/ 95117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ Text; }
});

// UNUSED EXPORTS: _Text

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Text/Text.styles.js


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function getTextDecoration({
  underline,
  strikethrough
}) {
  const styles = [];
  if (underline) {
    styles.push("underline");
  }
  if (strikethrough) {
    styles.push("line-through");
  }
  return styles.length > 0 ? styles.join(" ") : "none";
}
function getTextColor({ theme, color, variant }) {
  if (color === "dimmed") {
    return theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6];
  }
  return typeof color === "string" && (color in theme.colors || color.split(".")[0] in theme.colors) ? theme.fn.variant({ variant: "filled", color }).background : variant === "link" ? theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 4 : 7] : color || "inherit";
}
function getLineClamp(lineClamp) {
  if (typeof lineClamp === "number") {
    return {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: lineClamp,
      WebkitBoxOrient: "vertical"
    };
  }
  return null;
}
function getTruncate(truncate) {
  if (truncate) {
    return {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    };
  }
  return null;
}
var useStyles = (0,create_styles/* createStyles */.k)((theme, {
  color,
  variant,
  size,
  lineClamp,
  truncate,
  inline,
  inherit,
  underline,
  gradient,
  weight,
  transform,
  align,
  strikethrough,
  italic
}) => {
  const colors = theme.fn.variant({ variant: "gradient", gradient });
  return {
    root: __spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, theme.fn.fontStyles()), theme.fn.focusStyles()), getLineClamp(lineClamp)), getTruncate(truncate)), {
      color: getTextColor({ color, theme, variant }),
      fontFamily: inherit ? "inherit" : theme.fontFamily,
      fontSize: inherit || size === void 0 ? "inherit" : theme.fn.size({ size, sizes: theme.fontSizes }),
      lineHeight: inherit ? "inherit" : inline ? 1 : theme.lineHeight,
      textDecoration: getTextDecoration({ underline, strikethrough }),
      WebkitTapHighlightColor: "transparent",
      fontWeight: inherit ? "inherit" : weight,
      textTransform: transform,
      textAlign: align,
      fontStyle: italic ? "italic" : void 0
    }), theme.fn.hover(variant === "link" && underline === void 0 ? {
      textDecoration: "underline"
    } : void 0)),
    gradient: {
      backgroundImage: colors.background,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent"
    }
  };
});

/* harmony default export */ var Text_styles = (useStyles);
//# sourceMappingURL=Text.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Text/Text.js






var Text_defProp = Object.defineProperty;
var Text_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Text_hasOwnProp = Object.prototype.hasOwnProperty;
var Text_propIsEnum = Object.prototype.propertyIsEnumerable;
var Text_defNormalProp = (obj, key, value) => key in obj ? Text_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Text_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Text_hasOwnProp.call(b, prop))
      Text_defNormalProp(a, prop, b[prop]);
  if (Text_getOwnPropSymbols)
    for (var prop of Text_getOwnPropSymbols(b)) {
      if (Text_propIsEnum.call(b, prop))
        Text_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Text_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Text_getOwnPropSymbols)
    for (var prop of Text_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Text_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  variant: "text"
};
const _Text = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Text", defaultProps, props), {
    className,
    size,
    weight,
    transform,
    color,
    align,
    variant,
    lineClamp,
    truncate,
    gradient,
    inline,
    inherit,
    underline,
    strikethrough,
    italic,
    classNames,
    styles,
    unstyled,
    span
  } = _a, others = __objRest(_a, [
    "className",
    "size",
    "weight",
    "transform",
    "color",
    "align",
    "variant",
    "lineClamp",
    "truncate",
    "gradient",
    "inline",
    "inherit",
    "underline",
    "strikethrough",
    "italic",
    "classNames",
    "styles",
    "unstyled",
    "span"
  ]);
  const { classes, cx } = Text_styles({
    variant,
    color,
    size,
    lineClamp,
    truncate,
    inline,
    inherit,
    underline,
    strikethrough,
    italic,
    weight,
    transform,
    align,
    gradient
  }, { unstyled, name: "Text" });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, Text_spreadValues({
    ref,
    className: cx(classes.root, { [classes.gradient]: variant === "gradient" }, className),
    component: span ? "span" : "div"
  }, others));
});
_Text.displayName = "@mantine/core/Text";
const Text = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_Text);


//# sourceMappingURL=Text.js.map


/***/ }),

/***/ 80061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Input_use_input_props_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66261);
/* harmony import */ var _Input_Input_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94151);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  type: "text",
  size: "sm",
  __staticSelector: "TextInput"
};
const TextInput = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => {
  const _a = (0,_Input_use_input_props_js__WEBPACK_IMPORTED_MODULE_1__/* .useInputProps */ .k)("TextInput", defaultProps, props), { inputProps, wrapperProps } = _a, others = __objRest(_a, ["inputProps", "wrapperProps"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Input_Input_js__WEBPACK_IMPORTED_MODULE_2__/* .Input.Wrapper */ .I.Wrapper, __spreadValues({}, wrapperProps), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Input_Input_js__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .I, __spreadProps(__spreadValues(__spreadValues({}, inputProps), others), {
    ref
  })));
});
TextInput.displayName = "@mantine/core/TextInput";


//# sourceMappingURL=TextInput.js.map


/***/ }),

/***/ 19236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Title/Title.styles.js


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function getFontSize(size, element, theme) {
  if (typeof size !== "undefined") {
    return size in theme.headings.sizes ? theme.headings.sizes[size].fontSize : size;
  }
  return theme.headings.sizes[element].fontSize;
}
function getLineHeight(size, element, theme) {
  if (typeof size !== "undefined" && size in theme.headings.sizes) {
    return theme.headings.sizes[size].lineHeight;
  }
  return theme.headings.sizes[element].lineHeight;
}
var useStyles = (0,create_styles/* createStyles */.k)((theme, { element, weight, size, inline }) => ({
  root: __spreadProps(__spreadValues({}, theme.fn.fontStyles()), {
    fontFamily: theme.headings.fontFamily,
    fontWeight: weight || theme.headings.sizes[element].fontWeight || theme.headings.fontWeight,
    fontSize: getFontSize(size, element, theme),
    lineHeight: inline ? 1 : getLineHeight(size, element, theme),
    margin: 0
  })
}));

/* harmony default export */ var Title_styles = (useStyles);
//# sourceMappingURL=Title.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Title/Title.js





var Title_defProp = Object.defineProperty;
var Title_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Title_hasOwnProp = Object.prototype.hasOwnProperty;
var Title_propIsEnum = Object.prototype.propertyIsEnumerable;
var Title_defNormalProp = (obj, key, value) => key in obj ? Title_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Title_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Title_hasOwnProp.call(b, prop))
      Title_defNormalProp(a, prop, b[prop]);
  if (Title_getOwnPropSymbols)
    for (var prop of Title_getOwnPropSymbols(b)) {
      if (Title_propIsEnum.call(b, prop))
        Title_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Title_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Title_getOwnPropSymbols)
    for (var prop of Title_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Title_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  order: 1
};
const Title = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Title", defaultProps, props), { className, order, children, unstyled, size, weight, inline } = _a, others = __objRest(_a, ["className", "order", "children", "unstyled", "size", "weight", "inline"]);
  const { classes, cx } = Title_styles({ element: `h${order}`, weight, size, inline }, { name: "Title", unstyled });
  if (![1, 2, 3, 4, 5, 6].includes(order)) {
    return null;
  }
  return /* @__PURE__ */ react.createElement(Text/* Text */.x, Title_spreadValues({
    component: `h${order}`,
    ref,
    className: cx(classes.root, className)
  }, others), children);
});
Title.displayName = "@mantine/core/Title";


//# sourceMappingURL=Title.js.map


/***/ }),

/***/ 88393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Tooltip; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/is-element/is-element.js
var is_element = __webpack_require__(24241);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-merged-ref/use-merged-ref.js
var use_merged_ref = __webpack_require__(80665);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/utils/get-default-z-index/get-default-z-index.js
var get_default_z_index = __webpack_require__(3594);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom-interactions/dist/floating-ui.react-dom-interactions.esm.js
var floating_ui_react_dom_interactions_esm = __webpack_require__(35082);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Tooltip/TooltipGroup/TooltipGroup.context.js


const TooltipGroupContext = (0,react.createContext)(false);
const TooltipGroupProvider = TooltipGroupContext.Provider;
const useTooltipGroupContext = () => (0,react.useContext)(TooltipGroupContext);


//# sourceMappingURL=TooltipGroup.context.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Tooltip/TooltipGroup/TooltipGroup.js




function TooltipGroup({ children, openDelay = 0, closeDelay = 0 }) {
  return /* @__PURE__ */ react.createElement(TooltipGroupProvider, {
    value: true
  }, /* @__PURE__ */ react.createElement(floating_ui_react_dom_interactions_esm/* FloatingDelayGroup */.e0, {
    delay: { open: openDelay, close: closeDelay }
  }, children));
}
TooltipGroup.displayName = "@mantine/core/TooltipGroup";


//# sourceMappingURL=TooltipGroup.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Tooltip/Tooltip.styles.js


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function getColors(theme, color) {
  if (!color) {
    return {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[9],
      color: theme.white
    };
  }
  const colors = theme.fn.variant({ variant: "filled", color, primaryFallback: false });
  return {
    backgroundColor: colors.background,
    color: colors.color
  };
}
var useStyles = (0,create_styles/* createStyles */.k)((theme, { color, radius, width, multiline }) => ({
  tooltip: __spreadProps(__spreadValues(__spreadValues({}, theme.fn.fontStyles()), getColors(theme, color)), {
    lineHeight: theme.lineHeight,
    fontSize: theme.fontSizes.sm,
    borderRadius: theme.fn.radius(radius),
    padding: `calc(${theme.spacing.xs}px / 2) ${theme.spacing.xs}px`,
    position: "absolute",
    whiteSpace: multiline ? "unset" : "nowrap",
    pointerEvents: "none",
    width
  }),
  arrow: {
    backgroundColor: "inherit",
    border: 0,
    zIndex: 1
  }
}));

/* harmony default export */ var Tooltip_styles = (useStyles);
//# sourceMappingURL=Tooltip.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Tooltip/Tooltip.errors.js
const TOOLTIP_ERRORS = {
  children: "Tooltip component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported"
};


//# sourceMappingURL=Tooltip.errors.js.map

// EXTERNAL MODULE: ./node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
var floating_ui_core_browser_min = __webpack_require__(88301);
// EXTERNAL MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs
var floating_ui_dom_browser_min = __webpack_require__(55863);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Tooltip/TooltipFloating/use-floating-tooltip.js



function useFloatingTooltip({
  offset,
  position
}) {
  const [opened, setOpened] = (0,react.useState)(false);
  const boundaryRef = (0,react.useRef)();
  const { x, y, reference, floating, refs, update, placement } = (0,floating_ui_react_dom_interactions_esm/* useFloating */.YF)({
    placement: position,
    middleware: [
      (0,floating_ui_core_browser_min/* shift */.uY)({
        crossAxis: true,
        padding: 5,
        rootBoundary: "document"
      })
    ]
  });
  const horizontalOffset = placement.includes("right") ? offset : position.includes("left") ? offset * -1 : 0;
  const verticalOffset = placement.includes("bottom") ? offset : position.includes("top") ? offset * -1 : 0;
  const handleMouseMove = (0,react.useCallback)(({ clientX, clientY }) => {
    reference({
      getBoundingClientRect() {
        return {
          width: 0,
          height: 0,
          x: clientX,
          y: clientY,
          left: clientX + horizontalOffset,
          top: clientY + verticalOffset,
          right: clientX,
          bottom: clientY
        };
      }
    });
  }, [reference]);
  (0,react.useEffect)(() => {
    if (refs.floating.current) {
      const boundary = boundaryRef.current;
      boundary.addEventListener("mousemove", handleMouseMove);
      const parents = (0,floating_ui_dom_browser_min/* getOverflowAncestors */.Kx)(refs.floating.current);
      parents.forEach((parent) => {
        parent.addEventListener("scroll", update);
      });
      return () => {
        boundary.removeEventListener("mousemove", handleMouseMove);
        parents.forEach((parent) => {
          parent.removeEventListener("scroll", update);
        });
      };
    }
    return void 0;
  }, [reference, refs.floating, update, handleMouseMove, opened]);
  return { handleMouseMove, x, y, opened, setOpened, boundaryRef, floating };
}


//# sourceMappingURL=use-floating-tooltip.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Portal/OptionalPortal.js
var OptionalPortal = __webpack_require__(83143);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Tooltip/TooltipFloating/TooltipFloating.js










var TooltipFloating_defProp = Object.defineProperty;
var TooltipFloating_defProps = Object.defineProperties;
var TooltipFloating_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var TooltipFloating_getOwnPropSymbols = Object.getOwnPropertySymbols;
var TooltipFloating_hasOwnProp = Object.prototype.hasOwnProperty;
var TooltipFloating_propIsEnum = Object.prototype.propertyIsEnumerable;
var TooltipFloating_defNormalProp = (obj, key, value) => key in obj ? TooltipFloating_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var TooltipFloating_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (TooltipFloating_hasOwnProp.call(b, prop))
      TooltipFloating_defNormalProp(a, prop, b[prop]);
  if (TooltipFloating_getOwnPropSymbols)
    for (var prop of TooltipFloating_getOwnPropSymbols(b)) {
      if (TooltipFloating_propIsEnum.call(b, prop))
        TooltipFloating_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var TooltipFloating_spreadProps = (a, b) => TooltipFloating_defProps(a, TooltipFloating_getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (TooltipFloating_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && TooltipFloating_getOwnPropSymbols)
    for (var prop of TooltipFloating_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && TooltipFloating_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  refProp: "ref",
  withinPortal: true,
  offset: 10,
  position: "right",
  zIndex: (0,get_default_z_index/* getDefaultZIndex */.w)("popover")
};
function TooltipFloating(props) {
  var _b;
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("TooltipFloating", defaultProps, props), {
    children,
    refProp,
    withinPortal,
    style,
    className,
    classNames,
    styles,
    unstyled,
    radius,
    color,
    label,
    offset,
    position,
    multiline,
    width,
    zIndex,
    disabled
  } = _a, others = __objRest(_a, [
    "children",
    "refProp",
    "withinPortal",
    "style",
    "className",
    "classNames",
    "styles",
    "unstyled",
    "radius",
    "color",
    "label",
    "offset",
    "position",
    "multiline",
    "width",
    "zIndex",
    "disabled"
  ]);
  const { handleMouseMove, x, y, opened, boundaryRef, floating, setOpened } = useFloatingTooltip({
    offset,
    position
  });
  const { classes, cx } = Tooltip_styles({ radius, color, multiline, width }, { name: "TooltipFloating", classNames, styles, unstyled });
  if (!(0,is_element/* isElement */.k)(children)) {
    throw new Error(TOOLTIP_ERRORS.children);
  }
  const targetRef = (0,use_merged_ref/* useMergedRef */.Y)(boundaryRef, children.ref);
  const onMouseEnter = (event) => {
    var _a2, _b2;
    (_b2 = (_a2 = children.props).onMouseEnter) == null ? void 0 : _b2.call(_a2, event);
    handleMouseMove(event);
    setOpened(true);
  };
  const onMouseLeave = (event) => {
    var _a2, _b2;
    (_b2 = (_a2 = children.props).onMouseLeave) == null ? void 0 : _b2.call(_a2, event);
    setOpened(false);
  };
  if (disabled) {
    return /* @__PURE__ */ react.createElement(react.Fragment, null, children);
  }
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(OptionalPortal/* OptionalPortal */.q, {
    withinPortal
  }, /* @__PURE__ */ react.createElement(Box/* Box */.x, TooltipFloating_spreadProps(TooltipFloating_spreadValues({}, others), {
    ref: floating,
    className: cx(classes.tooltip, className),
    style: TooltipFloating_spreadProps(TooltipFloating_spreadValues({}, style), {
      zIndex,
      display: opened ? "block" : "none",
      top: y != null ? y : "",
      left: (_b = Math.round(x)) != null ? _b : ""
    })
  }), label)), (0,react.cloneElement)(children, TooltipFloating_spreadProps(TooltipFloating_spreadValues({}, children.props), {
    [refProp]: targetRef,
    onMouseEnter,
    onMouseLeave
  })));
}
TooltipFloating.displayName = "@mantine/core/TooltipFloating";


//# sourceMappingURL=TooltipFloating.js.map

// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.esm.js
var floating_ui_react_dom_esm = __webpack_require__(58463);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-id/use-id.js
var use_id = __webpack_require__(36289);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-did-update/use-did-update.js
var use_did_update = __webpack_require__(37048);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Floating/use-floating-auto-update.js
var use_floating_auto_update = __webpack_require__(30212);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Tooltip/use-tooltip.js






function useTooltip(settings) {
  const [uncontrolledOpened, setUncontrolledOpened] = (0,react.useState)(false);
  const controlled = typeof settings.opened === "boolean";
  const opened = controlled ? settings.opened : uncontrolledOpened;
  const withinGroup = useTooltipGroupContext();
  const uid = (0,use_id/* useId */.M)();
  const { delay: groupDelay, currentId, setCurrentId } = (0,floating_ui_react_dom_interactions_esm/* useDelayGroupContext */.tj)();
  const onChange = (0,react.useCallback)((_opened) => {
    setUncontrolledOpened(_opened);
    if (_opened) {
      setCurrentId(uid);
    }
  }, [setCurrentId, uid]);
  const {
    x,
    y,
    reference,
    floating,
    context,
    refs,
    update,
    placement,
    middlewareData: { arrow: { x: arrowX, y: arrowY } = {} }
  } = (0,floating_ui_react_dom_interactions_esm/* useFloating */.YF)({
    placement: settings.position,
    open: opened,
    onOpenChange: onChange,
    middleware: [
      (0,floating_ui_core_browser_min/* offset */.cv)(settings.offset),
      (0,floating_ui_core_browser_min/* shift */.uY)({ padding: 8 }),
      (0,floating_ui_core_browser_min/* flip */.RR)(),
      (0,floating_ui_react_dom_esm/* arrow */.x7)({ element: settings.arrowRef, padding: settings.arrowOffset }),
      ...settings.inline ? [(0,floating_ui_core_browser_min/* inline */.Qo)()] : []
    ]
  });
  const { getReferenceProps, getFloatingProps } = (0,floating_ui_react_dom_interactions_esm/* useInteractions */.NI)([
    (0,floating_ui_react_dom_interactions_esm/* useHover */.XI)(context, {
      enabled: settings.events.hover,
      delay: withinGroup ? groupDelay : { open: settings.openDelay, close: settings.closeDelay },
      mouseOnly: !settings.events.touch
    }),
    (0,floating_ui_react_dom_interactions_esm/* useFocus */.KK)(context, { enabled: settings.events.focus, keyboardOnly: true }),
    (0,floating_ui_react_dom_interactions_esm/* useRole */.qs)(context, { role: "tooltip" }),
    (0,floating_ui_react_dom_interactions_esm/* useDismiss */.bQ)(context, { enabled: typeof settings.opened === void 0 }),
    (0,floating_ui_react_dom_interactions_esm/* useDelayGroup */.Qu)(context, { id: uid })
  ]);
  (0,use_floating_auto_update/* useFloatingAutoUpdate */.L)({
    opened,
    positionDependencies: settings.positionDependencies,
    floating: { refs, update }
  });
  (0,use_did_update/* useDidUpdate */.l)(() => {
    var _a;
    (_a = settings.onPositionChange) == null ? void 0 : _a.call(settings, placement);
  }, [placement]);
  const isGroupPhase = opened && currentId && currentId !== uid;
  return {
    x,
    y,
    arrowX,
    arrowY,
    reference,
    floating,
    getFloatingProps,
    getReferenceProps,
    isGroupPhase,
    opened,
    placement
  };
}


//# sourceMappingURL=use-tooltip.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Floating/get-floating-position/get-floating-position.js
var get_floating_position = __webpack_require__(14870);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Transition/Transition.js
var Transition = __webpack_require__(97688);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Floating/FloatingArrow/FloatingArrow.js + 1 modules
var FloatingArrow = __webpack_require__(63468);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Tooltip/Tooltip.js















var Tooltip_defProp = Object.defineProperty;
var Tooltip_defProps = Object.defineProperties;
var Tooltip_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Tooltip_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Tooltip_hasOwnProp = Object.prototype.hasOwnProperty;
var Tooltip_propIsEnum = Object.prototype.propertyIsEnumerable;
var Tooltip_defNormalProp = (obj, key, value) => key in obj ? Tooltip_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Tooltip_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Tooltip_hasOwnProp.call(b, prop))
      Tooltip_defNormalProp(a, prop, b[prop]);
  if (Tooltip_getOwnPropSymbols)
    for (var prop of Tooltip_getOwnPropSymbols(b)) {
      if (Tooltip_propIsEnum.call(b, prop))
        Tooltip_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Tooltip_spreadProps = (a, b) => Tooltip_defProps(a, Tooltip_getOwnPropDescs(b));
var Tooltip_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Tooltip_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Tooltip_getOwnPropSymbols)
    for (var prop of Tooltip_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Tooltip_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Tooltip_defaultProps = {
  position: "top",
  refProp: "ref",
  withinPortal: false,
  inline: false,
  arrowSize: 4,
  arrowOffset: 5,
  arrowRadius: 0,
  arrowPosition: "side",
  offset: 5,
  transition: "fade",
  transitionDuration: 100,
  width: "auto",
  events: { hover: true, focus: false, touch: false },
  zIndex: (0,get_default_z_index/* getDefaultZIndex */.w)("popover"),
  positionDependencies: []
};
const _Tooltip = (0,react.forwardRef)((props, ref) => {
  const arrowRef = (0,react.useRef)(null);
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Tooltip", Tooltip_defaultProps, props), {
    children,
    position,
    refProp,
    label,
    openDelay,
    closeDelay,
    onPositionChange,
    opened,
    withinPortal,
    radius,
    color,
    classNames,
    styles,
    unstyled,
    style,
    className,
    withArrow,
    arrowSize,
    arrowOffset,
    arrowRadius,
    arrowPosition,
    offset,
    transition,
    transitionDuration,
    multiline,
    width,
    events,
    zIndex,
    disabled,
    positionDependencies,
    onClick,
    onMouseEnter,
    onMouseLeave,
    inline
  } = _a, others = Tooltip_objRest(_a, [
    "children",
    "position",
    "refProp",
    "label",
    "openDelay",
    "closeDelay",
    "onPositionChange",
    "opened",
    "withinPortal",
    "radius",
    "color",
    "classNames",
    "styles",
    "unstyled",
    "style",
    "className",
    "withArrow",
    "arrowSize",
    "arrowOffset",
    "arrowRadius",
    "arrowPosition",
    "offset",
    "transition",
    "transitionDuration",
    "multiline",
    "width",
    "events",
    "zIndex",
    "disabled",
    "positionDependencies",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "inline"
  ]);
  const { classes, cx, theme } = Tooltip_styles({ radius, color, width, multiline }, { name: "Tooltip", classNames, styles, unstyled });
  const tooltip = useTooltip({
    position: (0,get_floating_position/* getFloatingPosition */._)(theme.dir, position),
    closeDelay,
    openDelay,
    onPositionChange,
    opened,
    events,
    arrowRef,
    arrowOffset,
    offset: offset + (withArrow ? arrowSize / 2 : 0),
    positionDependencies: [...positionDependencies, children],
    inline
  });
  if (!(0,is_element/* isElement */.k)(children)) {
    throw new Error(TOOLTIP_ERRORS.children);
  }
  const targetRef = (0,use_merged_ref/* useMergedRef */.Y)(tooltip.reference, children.ref, ref);
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(OptionalPortal/* OptionalPortal */.q, {
    withinPortal
  }, /* @__PURE__ */ react.createElement(Transition/* Transition */.u, {
    mounted: !disabled && tooltip.opened,
    transition,
    duration: tooltip.isGroupPhase ? 10 : transitionDuration
  }, (transitionStyles) => {
    var _a2, _b;
    return /* @__PURE__ */ react.createElement(Box/* Box */.x, Tooltip_spreadValues(Tooltip_spreadValues({}, others), tooltip.getFloatingProps({
      ref: tooltip.floating,
      className: classes.tooltip,
      style: Tooltip_spreadProps(Tooltip_spreadValues(Tooltip_spreadValues({}, style), transitionStyles), {
        zIndex,
        top: (_a2 = tooltip.y) != null ? _a2 : 0,
        left: (_b = tooltip.x) != null ? _b : 0
      })
    })), label, /* @__PURE__ */ react.createElement(FloatingArrow/* FloatingArrow */.Y, {
      ref: arrowRef,
      arrowX: tooltip.arrowX,
      arrowY: tooltip.arrowY,
      visible: withArrow,
      withBorder: false,
      position: tooltip.placement,
      arrowSize,
      arrowOffset,
      arrowRadius,
      arrowPosition,
      className: classes.arrow
    }));
  })), (0,react.cloneElement)(children, tooltip.getReferenceProps(Tooltip_spreadValues({
    onClick,
    onMouseEnter,
    onMouseLeave,
    onMouseMove: props.onMouseMove,
    onPointerDown: props.onPointerDown,
    onPointerEnter: props.onPointerEnter,
    [refProp]: targetRef,
    className: cx(className, children.props.className)
  }, children.props))));
});
_Tooltip.Group = TooltipGroup;
_Tooltip.Floating = TooltipFloating;
_Tooltip.displayName = "@mantine/core/Tooltip";
const Tooltip = _Tooltip;


//# sourceMappingURL=Tooltip.js.map


/***/ }),

/***/ 75933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ GroupedTransition; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _get_transition_styles_get_transition_styles_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72974);
/* harmony import */ var _use_transition_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59068);




function GroupedTransition({
  transitions,
  duration = 250,
  exitDuration = duration,
  mounted,
  children,
  timingFunction,
  onExit,
  onEntered,
  onEnter,
  onExited
}) {
  const { transitionDuration, transitionStatus, transitionTimingFunction } = (0,_use_transition_js__WEBPACK_IMPORTED_MODULE_1__/* .useTransition */ .Y)({
    mounted,
    duration,
    exitDuration,
    timingFunction,
    onExit,
    onEntered,
    onEnter,
    onExited
  });
  if (transitionDuration === 0) {
    return mounted ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children({})) : null;
  }
  if (transitionStatus === "exited") {
    return null;
  }
  const transitionsStyles = Object.keys(transitions).reduce((acc, transition) => {
    acc[transition] = (0,_get_transition_styles_get_transition_styles_js__WEBPACK_IMPORTED_MODULE_2__/* .getTransitionStyles */ .B)({
      duration: transitions[transition].duration,
      transition: transitions[transition].transition,
      timingFunction: transitions[transition].timingFunction || transitionTimingFunction,
      state: transitionStatus
    });
    return acc;
  }, {});
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children(transitionsStyles));
}
GroupedTransition.displayName = "@mantine/core/GroupedTransition";


//# sourceMappingURL=GroupedTransition.js.map


/***/ }),

/***/ 97688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Transition; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _get_transition_styles_get_transition_styles_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72974);
/* harmony import */ var _use_transition_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59068);




function Transition({
  transition,
  duration = 250,
  exitDuration = duration,
  mounted,
  children,
  timingFunction,
  onExit,
  onEntered,
  onEnter,
  onExited
}) {
  const { transitionDuration, transitionStatus, transitionTimingFunction } = (0,_use_transition_js__WEBPACK_IMPORTED_MODULE_1__/* .useTransition */ .Y)({
    mounted,
    exitDuration,
    duration,
    timingFunction,
    onExit,
    onEntered,
    onEnter,
    onExited
  });
  if (transitionDuration === 0) {
    return mounted ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children({})) : null;
  }
  return transitionStatus === "exited" ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children((0,_get_transition_styles_get_transition_styles_js__WEBPACK_IMPORTED_MODULE_2__/* .getTransitionStyles */ .B)({
    transition,
    duration: transitionDuration,
    state: transitionStatus,
    timingFunction: transitionTimingFunction
  })));
}
Transition.displayName = "@mantine/core/Transition";


//# sourceMappingURL=Transition.js.map


/***/ }),

/***/ 72974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ getTransitionStyles; }
});

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Transition/transitions.js
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const popIn = {
  in: { opacity: 1, transform: "scale(1)" },
  out: { opacity: 0, transform: "scale(.9) translateY(10px)" },
  transitionProperty: "transform, opacity"
};
const transitions = {
  fade: {
    in: { opacity: 1 },
    out: { opacity: 0 },
    transitionProperty: "opacity"
  },
  scale: {
    in: { opacity: 1, transform: "scale(1)" },
    out: { opacity: 0, transform: "scale(0)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "scale-y": {
    in: { opacity: 1, transform: "scaleY(1)" },
    out: { opacity: 0, transform: "scaleY(0)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "scale-x": {
    in: { opacity: 1, transform: "scaleX(1)" },
    out: { opacity: 0, transform: "scaleX(0)" },
    common: { transformOrigin: "left" },
    transitionProperty: "transform, opacity"
  },
  "skew-up": {
    in: { opacity: 1, transform: "translateY(0) skew(0deg, 0deg)" },
    out: { opacity: 0, transform: "translateY(-20px) skew(-10deg, -5deg)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "skew-down": {
    in: { opacity: 1, transform: "translateY(0) skew(0deg, 0deg)" },
    out: { opacity: 0, transform: "translateY(20px) skew(-10deg, -5deg)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "rotate-left": {
    in: { opacity: 1, transform: "translateY(0) rotate(0deg)" },
    out: { opacity: 0, transform: "translateY(20px) rotate(-5deg)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "rotate-right": {
    in: { opacity: 1, transform: "translateY(0) rotate(0deg)" },
    out: { opacity: 0, transform: "translateY(20px) rotate(5deg)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "slide-down": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(-100%)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "slide-up": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(100%)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "slide-left": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(100%)" },
    common: { transformOrigin: "left" },
    transitionProperty: "transform, opacity"
  },
  "slide-right": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(-100%)" },
    common: { transformOrigin: "right" },
    transitionProperty: "transform, opacity"
  },
  pop: __spreadProps(__spreadValues({}, popIn), {
    common: { transformOrigin: "center center" }
  }),
  "pop-bottom-left": __spreadProps(__spreadValues({}, popIn), {
    common: { transformOrigin: "bottom left" }
  }),
  "pop-bottom-right": __spreadProps(__spreadValues({}, popIn), {
    common: { transformOrigin: "bottom right" }
  }),
  "pop-top-left": __spreadProps(__spreadValues({}, popIn), {
    common: { transformOrigin: "top left" }
  }),
  "pop-top-right": __spreadProps(__spreadValues({}, popIn), {
    common: { transformOrigin: "top right" }
  })
};


//# sourceMappingURL=transitions.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Transition/get-transition-styles/get-transition-styles.js


var get_transition_styles_defProp = Object.defineProperty;
var get_transition_styles_getOwnPropSymbols = Object.getOwnPropertySymbols;
var get_transition_styles_hasOwnProp = Object.prototype.hasOwnProperty;
var get_transition_styles_propIsEnum = Object.prototype.propertyIsEnumerable;
var get_transition_styles_defNormalProp = (obj, key, value) => key in obj ? get_transition_styles_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var get_transition_styles_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (get_transition_styles_hasOwnProp.call(b, prop))
      get_transition_styles_defNormalProp(a, prop, b[prop]);
  if (get_transition_styles_getOwnPropSymbols)
    for (var prop of get_transition_styles_getOwnPropSymbols(b)) {
      if (get_transition_styles_propIsEnum.call(b, prop))
        get_transition_styles_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const transitionStatuses = {
  entering: "in",
  entered: "in",
  exiting: "out",
  exited: "out",
  "pre-exiting": "out",
  "pre-entering": "out"
};
function getTransitionStyles({
  transition,
  state,
  duration,
  timingFunction
}) {
  const shared = {
    transitionDuration: `${duration}ms`,
    transitionTimingFunction: timingFunction
  };
  if (typeof transition === "string") {
    if (!(transition in transitions)) {
      return null;
    }
    return get_transition_styles_spreadValues(get_transition_styles_spreadValues(get_transition_styles_spreadValues({
      transitionProperty: transitions[transition].transitionProperty
    }, shared), transitions[transition].common), transitions[transition][transitionStatuses[state]]);
  }
  return get_transition_styles_spreadValues(get_transition_styles_spreadValues(get_transition_styles_spreadValues({
    transitionProperty: transition.transitionProperty
  }, shared), transition.common), transition[transitionStatuses[state]]);
}


//# sourceMappingURL=get-transition-styles.js.map


/***/ }),

/***/ 59068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useTransition; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73678);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37048);
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64761);




function useTransition({
  duration,
  exitDuration,
  timingFunction,
  mounted,
  onEnter,
  onExit,
  onEntered,
  onExited
}) {
  const theme = (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_1__/* .useMantineTheme */ .rZ)();
  const shouldReduceMotion = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useReducedMotion */ .J)();
  const reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
  const [transitionStatus, setStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(mounted ? "entered" : "exited");
  let transitionDuration = reduceMotion ? 0 : duration;
  const timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(-1);
  const handleStateChange = (shouldMount) => {
    const preHandler = shouldMount ? onEnter : onExit;
    const handler = shouldMount ? onEntered : onExited;
    setStatus(shouldMount ? "pre-entering" : "pre-exiting");
    window.clearTimeout(timeoutRef.current);
    transitionDuration = reduceMotion ? 0 : shouldMount ? duration : exitDuration;
    if (transitionDuration === 0) {
      typeof preHandler === "function" && preHandler();
      typeof handler === "function" && handler();
      setStatus(shouldMount ? "entered" : "exited");
    } else {
      const preStateTimeout = window.setTimeout(() => {
        typeof preHandler === "function" && preHandler();
        setStatus(shouldMount ? "entering" : "exiting");
      }, 10);
      timeoutRef.current = window.setTimeout(() => {
        window.clearTimeout(preStateTimeout);
        typeof handler === "function" && handler();
        setStatus(shouldMount ? "entered" : "exited");
      }, transitionDuration);
    }
  };
  (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useDidUpdate */ .l)(() => {
    handleStateChange(mounted);
  }, [mounted]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => window.clearTimeout(timeoutRef.current), []);
  return {
    transitionDuration,
    transitionStatus,
    transitionTimingFunction: timingFunction || theme.transitionTimingFunction
  };
}


//# sourceMappingURL=use-transition.js.map


/***/ }),

/***/ 34736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ UnstyledButton; }
});

// UNUSED EXPORTS: _UnstyledButton

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.styles.js


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var useStyles = (0,create_styles/* createStyles */.k)((theme) => ({
  root: __spreadProps(__spreadValues(__spreadValues({}, theme.fn.focusStyles()), theme.fn.fontStyles()), {
    cursor: "pointer",
    border: 0,
    padding: 0,
    appearance: "none",
    fontSize: theme.fontSizes.md,
    backgroundColor: "transparent",
    textAlign: "left",
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    textDecoration: "none",
    boxSizing: "border-box"
  })
}));

/* harmony default export */ var UnstyledButton_styles = (useStyles);
//# sourceMappingURL=UnstyledButton.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.js






var UnstyledButton_defProp = Object.defineProperty;
var UnstyledButton_getOwnPropSymbols = Object.getOwnPropertySymbols;
var UnstyledButton_hasOwnProp = Object.prototype.hasOwnProperty;
var UnstyledButton_propIsEnum = Object.prototype.propertyIsEnumerable;
var UnstyledButton_defNormalProp = (obj, key, value) => key in obj ? UnstyledButton_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var UnstyledButton_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (UnstyledButton_hasOwnProp.call(b, prop))
      UnstyledButton_defNormalProp(a, prop, b[prop]);
  if (UnstyledButton_getOwnPropSymbols)
    for (var prop of UnstyledButton_getOwnPropSymbols(b)) {
      if (UnstyledButton_propIsEnum.call(b, prop))
        UnstyledButton_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (UnstyledButton_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && UnstyledButton_getOwnPropSymbols)
    for (var prop of UnstyledButton_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && UnstyledButton_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const _UnstyledButton = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("UnstyledButton", {}, props), {
    className,
    component = "button",
    unstyled
  } = _a, others = __objRest(_a, [
    "className",
    "component",
    "unstyled"
  ]);
  const { classes, cx } = UnstyledButton_styles(null, { name: "UnstyledButton", unstyled });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, UnstyledButton_spreadValues({
    component,
    ref,
    className: cx(classes.root, className),
    type: component === "button" ? "button" : void 0
  }, others));
});
_UnstyledButton.displayName = "@mantine/core/UnstyledButton";
const UnstyledButton = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_UnstyledButton);


//# sourceMappingURL=UnstyledButton.js.map


/***/ }),

/***/ 98903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ useForm; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(64063);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/filter-errors/filter-errors.js
function filterErrors(errors) {
  if (errors === null || typeof errors !== "object") {
    return {};
  }
  return Object.keys(errors).reduce((acc, key) => {
    const errorValue = errors[key];
    if (errorValue !== void 0 && errorValue !== null && errorValue !== false) {
      acc[key] = errorValue;
    }
    return acc;
  }, {});
}


//# sourceMappingURL=filter-errors.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/clear-list-state/clear-list-state.js
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function clearListState(field, state) {
  if (state === null || typeof state !== "object") {
    return {};
  }
  const clone = __spreadValues({}, state);
  Object.keys(state).forEach((errorKey) => {
    if (errorKey.includes(`${String(field)}.`)) {
      delete clone[errorKey];
    }
  });
  return clone;
}


//# sourceMappingURL=clear-list-state.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/form-index.js
const FORM_INDEX = "__MANTINE_FORM_INDEX__";


//# sourceMappingURL=form-index.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/validate/should-validate-on-change.js


function shouldValidateOnChange(path, validateInputOnChange) {
  if (!validateInputOnChange) {
    return false;
  }
  if (typeof validateInputOnChange === "boolean") {
    return validateInputOnChange;
  }
  if (Array.isArray(validateInputOnChange)) {
    return validateInputOnChange.includes(path.replace(/[.][0-9]/g, `.${FORM_INDEX}`));
  }
  return false;
}


//# sourceMappingURL=should-validate-on-change.js.map

;// CONCATENATED MODULE: ./node_modules/klona/dist/index.mjs
function klona(x) {
	if (typeof x !== 'object') return x;

	var k, tmp, str=Object.prototype.toString.call(x);

	if (str === '[object Object]') {
		if (x.constructor !== Object && typeof x.constructor === 'function') {
			tmp = new x.constructor();
			for (k in x) {
				if (x.hasOwnProperty(k) && tmp[k] !== x[k]) {
					tmp[k] = klona(x[k]);
				}
			}
		} else {
			tmp = {}; // null
			for (k in x) {
				if (k === '__proto__') {
					Object.defineProperty(tmp, k, {
						value: klona(x[k]),
						configurable: true,
						enumerable: true,
						writable: true,
					});
				} else {
					tmp[k] = klona(x[k]);
				}
			}
		}
		return tmp;
	}

	if (str === '[object Array]') {
		k = x.length;
		for (tmp=Array(k); k--;) {
			tmp[k] = klona(x[k]);
		}
		return tmp;
	}

	if (str === '[object Set]') {
		tmp = new Set;
		x.forEach(function (val) {
			tmp.add(klona(val));
		});
		return tmp;
	}

	if (str === '[object Map]') {
		tmp = new Map;
		x.forEach(function (val, key) {
			tmp.set(klona(key), klona(val));
		});
		return tmp;
	}

	if (str === '[object Date]') {
		return new Date(+x);
	}

	if (str === '[object RegExp]') {
		tmp = new RegExp(x.source, x.flags);
		tmp.lastIndex = x.lastIndex;
		return tmp;
	}

	if (str === '[object DataView]') {
		return new x.constructor( klona(x.buffer) );
	}

	if (str === '[object ArrayBuffer]') {
		return x.slice(0);
	}

	// ArrayBuffer.isView(x)
	// ~> `new` bcuz `Buffer.slice` => ref
	if (str.slice(-6) === 'Array]') {
		return new x.constructor(x);
	}

	return x;
}

;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/paths/get-splitted-path.js
function getSplittedPath(path) {
  if (typeof path !== "string") {
    return [];
  }
  return path.split(".");
}


//# sourceMappingURL=get-splitted-path.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/paths/set-path.js



function setPath(path, value, values) {
  const splittedPath = getSplittedPath(path);
  if (splittedPath.length === 0) {
    return values;
  }
  const cloned = klona(values);
  if (splittedPath.length === 1) {
    cloned[splittedPath[0]] = value;
    return cloned;
  }
  let val = cloned[splittedPath[0]];
  for (let i = 1; i < splittedPath.length - 1; i += 1) {
    if (val === void 0) {
      return cloned;
    }
    val = val[splittedPath[i]];
  }
  val[splittedPath[splittedPath.length - 1]] = value;
  return cloned;
}


//# sourceMappingURL=set-path.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/paths/get-path.js


function getPath(path, values) {
  const splittedPath = getSplittedPath(path);
  if (splittedPath.length === 0 || typeof values !== "object" || values === null) {
    return void 0;
  }
  let value = values[splittedPath[0]];
  for (let i = 1; i < splittedPath.length; i += 1) {
    if (value === void 0) {
      break;
    }
    value = value[splittedPath[i]];
  }
  return value;
}


//# sourceMappingURL=get-path.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/validate/validate-values.js



function getValidationResults(errors) {
  const filteredErrors = filterErrors(errors);
  return { hasErrors: Object.keys(filteredErrors).length > 0, errors: filteredErrors };
}
function validateRulesRecord(rules, values, path = "", errors = {}) {
  if (typeof rules !== "object" || rules === null) {
    return errors;
  }
  return Object.keys(rules).reduce((acc, ruleKey) => {
    const rule = rules[ruleKey];
    const rulePath = `${path === "" ? "" : `${path}.`}${ruleKey}`;
    const value = getPath(rulePath, values);
    let arrayValidation = false;
    if (typeof rule === "function") {
      acc[rulePath] = rule(value, values, rulePath);
    }
    if (typeof rule === "object" && Array.isArray(value)) {
      arrayValidation = true;
      value.forEach((_item, index) => validateRulesRecord(rule, values, `${rulePath}.${index}`, acc));
    }
    if (typeof rule === "object" && typeof value === "object" && value !== null) {
      if (!arrayValidation) {
        validateRulesRecord(rule, values, rulePath, acc);
      }
    }
    return acc;
  }, errors);
}
function validateValues(validate, values) {
  if (typeof validate === "function") {
    return getValidationResults(validate(values));
  }
  return getValidationResults(validateRulesRecord(validate, values));
}


//# sourceMappingURL=validate-values.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/validate/validate-field-value.js


function validateFieldValue(path, rules, values) {
  if (typeof path !== "string") {
    return { hasError: false, error: null };
  }
  const results = validateValues(rules, values);
  const pathInError = Object.keys(results.errors).find((errorKey) => path.split(".").every((pathPart, i) => pathPart === errorKey.split(".")[i]));
  return { hasError: !!pathInError, error: pathInError ? results.errors[pathInError] : null };
}


//# sourceMappingURL=validate-field-value.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/paths/reorder-path.js



function reorderPath(path, { from, to }, values) {
  const currentValue = getPath(path, values);
  if (!Array.isArray(currentValue)) {
    return values;
  }
  const cloned = [...currentValue];
  const item = currentValue[from];
  cloned.splice(from, 1);
  cloned.splice(to, 0, item);
  return setPath(path, cloned, values);
}


//# sourceMappingURL=reorder-path.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/paths/remove-path.js



function removePath(path, index, values) {
  const currentValue = getPath(path, values);
  if (!Array.isArray(currentValue)) {
    return values;
  }
  return setPath(path, currentValue.filter((_, itemIndex) => itemIndex !== index), values);
}


//# sourceMappingURL=remove-path.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/paths/insert-path.js



function insertPath(path, value, index, values) {
  const currentValue = getPath(path, values);
  if (!Array.isArray(currentValue)) {
    return values;
  }
  const cloned = [...currentValue];
  cloned.splice(typeof index === "number" ? index : cloned.length, 0, value);
  return setPath(path, cloned, values);
}


//# sourceMappingURL=insert-path.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/get-status/get-status.js
function getStatus(status, path) {
  const paths = Object.keys(status);
  if (typeof path === "string") {
    const nestedPaths = paths.filter((statusPath) => statusPath.includes(`${path}.`));
    return status[path] || nestedPaths.some((statusPath) => status[statusPath]) || false;
  }
  return paths.some((statusPath) => status[statusPath]);
}


//# sourceMappingURL=get-status.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/get-input-on-change/get-input-on-change.js
function getInputOnChange(setValue) {
  return (val) => {
    if (!val) {
      setValue(val);
    } else if (typeof val === "function") {
      setValue(val);
    } else if (typeof val === "object" && "nativeEvent" in val) {
      const { currentTarget } = val;
      if (currentTarget instanceof HTMLInputElement) {
        if (currentTarget.type === "checkbox") {
          setValue(currentTarget.checked);
        } else {
          setValue(currentTarget.value);
        }
      } else if (currentTarget instanceof HTMLTextAreaElement || currentTarget instanceof HTMLSelectElement) {
        setValue(currentTarget.value);
      }
    } else {
      setValue(val);
    }
  };
}


//# sourceMappingURL=get-input-on-change.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/form/esm/use-form.js















var use_form_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var use_form_getOwnPropSymbols = Object.getOwnPropertySymbols;
var use_form_hasOwnProp = Object.prototype.hasOwnProperty;
var use_form_propIsEnum = Object.prototype.propertyIsEnumerable;
var use_form_defNormalProp = (obj, key, value) => key in obj ? use_form_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var use_form_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (use_form_hasOwnProp.call(b, prop))
      use_form_defNormalProp(a, prop, b[prop]);
  if (use_form_getOwnPropSymbols)
    for (var prop of use_form_getOwnPropSymbols(b)) {
      if (use_form_propIsEnum.call(b, prop))
        use_form_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function useForm({
  initialValues = {},
  initialErrors = {},
  initialDirty = {},
  initialTouched = {},
  clearInputErrorOnChange = true,
  validateInputOnChange = false,
  validateInputOnBlur = false,
  transformValues = (values) => values,
  validate: rules
} = {}) {
  const [touched, setTouched] = (0,react.useState)(initialTouched);
  const [dirty, setDirty] = (0,react.useState)(initialDirty);
  const [values, _setValues] = (0,react.useState)(initialValues);
  const [errors, _setErrors] = (0,react.useState)(filterErrors(initialErrors));
  const _dirtyValues = (0,react.useRef)(initialValues);
  const _setDirtyValues = (_values) => {
    _dirtyValues.current = _values;
  };
  const resetTouched = (0,react.useCallback)(() => setTouched({}), []);
  const resetDirty = (_values) => {
    _setDirtyValues(_values || values);
    setDirty({});
  };
  const setErrors = (0,react.useCallback)((errs) => _setErrors((current) => filterErrors(typeof errs === "function" ? errs(current) : errs)), []);
  const clearErrors = (0,react.useCallback)(() => _setErrors({}), []);
  const reset = (0,react.useCallback)(() => {
    _setValues(initialValues);
    clearErrors();
    resetDirty(initialValues);
    resetTouched();
  }, []);
  const setFieldError = (0,react.useCallback)((path, error) => setErrors((current) => __spreadProps(use_form_spreadValues({}, current), { [path]: error })), []);
  const clearFieldError = (0,react.useCallback)((path) => setErrors((current) => {
    if (typeof path !== "string") {
      return current;
    }
    const clone = use_form_spreadValues({}, current);
    delete clone[path];
    return clone;
  }), []);
  const clearFieldDirty = (0,react.useCallback)((path) => setDirty((current) => {
    if (typeof path !== "string") {
      return current;
    }
    const result = clearListState(path, current);
    delete result[path];
    return result;
  }), []);
  const setFieldValue = (0,react.useCallback)((path, value) => {
    const shouldValidate = shouldValidateOnChange(path, validateInputOnChange);
    clearFieldDirty(path);
    setTouched((currentTouched) => __spreadProps(use_form_spreadValues({}, currentTouched), { [path]: true }));
    _setValues((current) => {
      const result = setPath(path, value, current);
      if (shouldValidate) {
        const validationResults = validateFieldValue(path, rules, result);
        validationResults.hasError ? setFieldError(path, validationResults.error) : clearFieldError(path);
      }
      return result;
    });
    !shouldValidate && clearInputErrorOnChange && setFieldError(path, null);
  }, []);
  const setValues = (0,react.useCallback)((payload) => {
    _setValues((currentValues) => {
      const valuesPartial = typeof payload === "function" ? payload(currentValues) : payload;
      return use_form_spreadValues(use_form_spreadValues({}, currentValues), valuesPartial);
    });
    clearInputErrorOnChange && clearErrors();
  }, []);
  const reorderListItem = (0,react.useCallback)((path, payload) => {
    clearFieldDirty(path);
    _setValues((current) => reorderPath(path, payload, current));
  }, []);
  const removeListItem = (0,react.useCallback)((path, index) => {
    clearFieldDirty(path);
    _setValues((current) => removePath(path, index, current));
    _setErrors((errs) => clearListState(path, errs));
  }, []);
  const insertListItem = (0,react.useCallback)((path, item, index) => {
    clearFieldDirty(path);
    _setValues((current) => insertPath(path, item, index, current));
  }, []);
  const validate = (0,react.useCallback)(() => {
    const results = validateValues(rules, values);
    _setErrors(results.errors);
    return results;
  }, [values, rules]);
  const validateField = (0,react.useCallback)((path) => {
    const results = validateFieldValue(path, rules, values);
    results.hasError ? setFieldError(path, results.error) : clearFieldError(path);
    return results;
  }, [values, rules]);
  const getInputProps = (path, { type = "input", withError = type === "input", withFocus = true } = {}) => {
    const onChange = getInputOnChange((value) => setFieldValue(path, value));
    const payload = { onChange };
    if (withError) {
      payload.error = errors[path];
    }
    if (type === "checkbox") {
      payload.checked = getPath(path, values);
    } else {
      payload.value = getPath(path, values);
    }
    if (withFocus) {
      payload.onFocus = () => setTouched((current) => __spreadProps(use_form_spreadValues({}, current), { [path]: true }));
      payload.onBlur = () => {
        if (shouldValidateOnChange(path, validateInputOnBlur)) {
          const validationResults = validateFieldValue(path, rules, values);
          validationResults.hasError ? setFieldError(path, validationResults.error) : clearFieldError(path);
        }
      };
    }
    return payload;
  };
  const onSubmit = (handleSubmit, handleValidationFailure) => (event) => {
    event == null ? void 0 : event.preventDefault();
    const results = validate();
    if (results.hasErrors) {
      handleValidationFailure == null ? void 0 : handleValidationFailure(results.errors, values, event);
    } else {
      handleSubmit(transformValues(values), event);
    }
  };
  const onReset = (0,react.useCallback)((event) => {
    event.preventDefault();
    reset();
  }, []);
  const isDirty = (path) => {
    const isOverridden = Object.keys(dirty).length > 0;
    if (isOverridden) {
      return getStatus(dirty, path);
    }
    if (path) {
      const sliceOfValues = getPath(path, values);
      const sliceOfInitialValues = getPath(path, _dirtyValues.current);
      return !fast_deep_equal_default()(sliceOfValues, sliceOfInitialValues);
    }
    return !fast_deep_equal_default()(values, _dirtyValues.current);
  };
  const isTouched = (0,react.useCallback)((path) => getStatus(touched, path), [touched]);
  const isValid = (0,react.useCallback)((path) => path ? !validateFieldValue(path, rules, values).hasError : !validateValues(rules, values).hasErrors, [values, rules]);
  return {
    values,
    errors,
    setValues,
    setErrors,
    setFieldValue,
    setFieldError,
    clearFieldError,
    clearErrors,
    reset,
    validate,
    validateField,
    reorderListItem,
    removeListItem,
    insertListItem,
    getInputProps,
    onSubmit,
    onReset,
    isDirty,
    isTouched,
    setTouched,
    setDirty,
    resetTouched,
    resetDirty,
    isValid
  };
}


//# sourceMappingURL=use-form.js.map


/***/ }),

/***/ 37048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ useDidUpdate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useDidUpdate(fn, dependencies) {
  const mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
    mounted.current = false;
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (mounted.current) {
      return fn();
    }
    mounted.current = true;
    return void 0;
  }, dependencies);
}


//# sourceMappingURL=use-did-update.js.map


/***/ }),

/***/ 96362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useFocusReturn; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_did_update_use_did_update_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37048);



function useFocusReturn({ opened, shouldReturnFocus = true }) {
  const lastActiveElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const returnFocus = () => {
    var _a;
    if (lastActiveElement.current && "focus" in lastActiveElement.current && typeof lastActiveElement.current.focus === "function") {
      (_a = lastActiveElement.current) == null ? void 0 : _a.focus({ preventScroll: true });
    }
  };
  (0,_use_did_update_use_did_update_js__WEBPACK_IMPORTED_MODULE_1__/* .useDidUpdate */ .l)(() => {
    let timeout = -1;
    const clearFocusTimeout = (event) => {
      if (event.key === "Tab") {
        window.clearTimeout(timeout);
      }
    };
    document.addEventListener("keydown", clearFocusTimeout);
    if (opened) {
      lastActiveElement.current = document.activeElement;
    } else if (shouldReturnFocus) {
      timeout = window.setTimeout(returnFocus, 10);
    }
    return () => {
      window.clearTimeout(timeout);
      document.removeEventListener("keydown", clearFocusTimeout);
    };
  }, [opened, shouldReturnFocus]);
  return returnFocus;
}


//# sourceMappingURL=use-focus-return.js.map


/***/ }),

/***/ 95909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ useFocusTrap; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-focus-trap/tabbable.js
const TABBABLE_NODES = /input|select|textarea|button|object/;
const FOCUS_SELECTOR = "a, input, select, textarea, button, object, [tabindex]";
function tabbable_hidden(element) {
  if (false) {}
  return element.style.display === "none";
}
function visible(element) {
  const isHidden = element.getAttribute("aria-hidden") || element.getAttribute("hidden") || element.getAttribute("type") === "hidden";
  if (isHidden) {
    return false;
  }
  let parentElement = element;
  while (parentElement) {
    if (parentElement === document.body || parentElement.nodeType === 11) {
      break;
    }
    if (tabbable_hidden(parentElement)) {
      return false;
    }
    parentElement = parentElement.parentNode;
  }
  return true;
}
function getElementTabIndex(element) {
  let tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) {
    tabIndex = void 0;
  }
  return parseInt(tabIndex, 10);
}
function focusable(element) {
  const nodeName = element.nodeName.toLowerCase();
  const isTabIndexNotNaN = !Number.isNaN(getElementTabIndex(element));
  const res = TABBABLE_NODES.test(nodeName) && !element.disabled || (element instanceof HTMLAnchorElement ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}
function tabbable(element) {
  const tabIndex = getElementTabIndex(element);
  const isTabIndexNaN = Number.isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}
function findTabbableDescendants(element) {
  return Array.from(element.querySelectorAll(FOCUS_SELECTOR)).filter(tabbable);
}


//# sourceMappingURL=tabbable.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-focus-trap/scope-tab.js


function scopeTab(node, event) {
  const tabbable = findTabbableDescendants(node);
  if (!tabbable.length) {
    event.preventDefault();
    return;
  }
  const finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  const root = node.getRootNode();
  const leavingFinalTabbable = finalTabbable === root.activeElement || node === root.activeElement;
  if (!leavingFinalTabbable) {
    return;
  }
  event.preventDefault();
  const target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  if (target) {
    target.focus();
  }
}


//# sourceMappingURL=scope-tab.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-focus-trap/create-aria-hider.js
function createAriaHider(containerNode, selector = "body > :not(script)") {
  const rootNodes = Array.from(document.querySelectorAll(selector)).map((node) => {
    var _a;
    if (((_a = node == null ? void 0 : node.shadowRoot) == null ? void 0 : _a.contains(containerNode)) || node.contains(containerNode)) {
      return void 0;
    }
    const ariaHidden = node.getAttribute("aria-hidden");
    if (ariaHidden === null || ariaHidden === "false") {
      node.setAttribute("aria-hidden", "true");
    }
    return { node, ariaHidden };
  });
  return () => {
    rootNodes.forEach((item) => {
      if (!item) {
        return;
      }
      if (item.ariaHidden === null) {
        item.node.removeAttribute("aria-hidden");
      } else {
        item.node.setAttribute("aria-hidden", item.ariaHidden);
      }
    });
  };
}


//# sourceMappingURL=create-aria-hider.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-focus-trap/use-focus-trap.js





function useFocusTrap(active = true) {
  const ref = (0,react.useRef)();
  const restoreAria = (0,react.useRef)(null);
  const setRef = (0,react.useCallback)((node) => {
    if (!active) {
      return;
    }
    if (node === null) {
      return;
    }
    restoreAria.current = createAriaHider(node);
    if (ref.current === node) {
      return;
    }
    if (node) {
      const processNode = () => {
        let focusElement = node.querySelector("[data-autofocus]");
        if (!focusElement) {
          const children = Array.from(node.querySelectorAll(FOCUS_SELECTOR));
          focusElement = children.find(tabbable) || children.find(focusable) || null;
          if (!focusElement && focusable(node))
            focusElement = node;
        }
        if (focusElement) {
          focusElement.focus({ preventScroll: true });
        } else if (false) {}
      };
      setTimeout(() => {
        if (node.getRootNode()) {
          processNode();
        } else if (false) {}
      });
      ref.current = node;
    } else {
      ref.current = null;
    }
  }, [active]);
  (0,react.useEffect)(() => {
    if (!active) {
      return void 0;
    }
    const handleKeyDown = (event) => {
      if (event.key === "Tab" && ref.current) {
        scopeTab(ref.current, event);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      if (restoreAria.current) {
        restoreAria.current();
      }
    };
  }, [active]);
  return setRef;
}


//# sourceMappingURL=use-focus-trap.js.map


/***/ }),

/***/ 36289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_isomorphic_effect_use_isomorphic_effect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10129);



const randomId = () => `mantine-${Math.random().toString(36).slice(2, 11)}`;
const useReactId = react__WEBPACK_IMPORTED_MODULE_0__["useId".toString()] || (() => void 0);
function useClientId() {
  const [uuid, setUuid] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
  (0,_use_isomorphic_effect_use_isomorphic_effect_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsomorphicEffect */ .Y)(() => {
    setUuid(randomId());
  }, []);
  return uuid;
}
function getReactId() {
  const id = useReactId();
  return id ? `mantine-${id.replace(/:/g, "")}` : "";
}
function useId(staticId) {
  return typeof staticId === "string" ? staticId : getReactId() || useClientId();
}


//# sourceMappingURL=use-id.js.map


/***/ }),

/***/ 10129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useIsomorphicEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


const useIsomorphicEffect = typeof document !== "undefined" ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;


//# sourceMappingURL=use-isomorphic-effect.js.map


/***/ }),

/***/ 34065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function attachMediaListener(query, callback) {
  try {
    query.addEventListener("change", callback);
    return () => query.removeEventListener("change", callback);
  } catch (e) {
    query.addListener(callback);
    return () => query.removeListener(callback);
  }
}
function getInitialValue(query, initialValue) {
  if (typeof initialValue === "boolean") {
    return initialValue;
  }
  if (typeof window !== "undefined" && "matchMedia" in window) {
    return window.matchMedia(query).matches;
  }
  return false;
}
function useMediaQuery(query, initialValue, { getInitialValueInEffect } = {
  getInitialValueInEffect: true
}) {
  const [matches, setMatches] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getInitialValueInEffect ? initialValue : getInitialValue(query, initialValue));
  const queryRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if ("matchMedia" in window) {
      queryRef.current = window.matchMedia(query);
      setMatches(queryRef.current.matches);
      return attachMediaListener(queryRef.current, (event) => setMatches(event.matches));
    }
    return void 0;
  }, [query]);
  return matches;
}


//# sourceMappingURL=use-media-query.js.map


/***/ }),

/***/ 80665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useMergedRef; },
/* harmony export */   "l": function() { return /* binding */ mergeRefs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_assign_ref_assign_ref_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83979);



function mergeRefs(...refs) {
  return (node) => {
    refs.forEach((ref) => (0,_utils_assign_ref_assign_ref_js__WEBPACK_IMPORTED_MODULE_1__/* .assignRef */ .k)(ref, node));
  };
}
function useMergedRef(...refs) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(mergeRefs(...refs), refs);
}


//# sourceMappingURL=use-merged-ref.js.map


/***/ }),

/***/ 73678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useReducedMotion; }
/* harmony export */ });
/* harmony import */ var _use_media_query_use_media_query_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34065);


function useReducedMotion(initialValue, options) {
  return (0,_use_media_query_use_media_query_js__WEBPACK_IMPORTED_MODULE_0__/* .useMediaQuery */ .a)("(prefers-reduced-motion: reduce)", initialValue, options);
}


//# sourceMappingURL=use-reduced-motion.js.map


/***/ }),

/***/ 12185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useElementSize; }
/* harmony export */ });
/* unused harmony export useResizeObserver */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


const defaultState = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
function useResizeObserver() {
  const frameID = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const [rect, setRect] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultState);
  const observer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => typeof window !== "undefined" ? new ResizeObserver((entries) => {
    const entry = entries[0];
    if (entry) {
      cancelAnimationFrame(frameID.current);
      frameID.current = requestAnimationFrame(() => {
        if (ref.current) {
          setRect(entry.contentRect);
        }
      });
    }
  }) : null, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
      if (frameID.current) {
        cancelAnimationFrame(frameID.current);
      }
    };
  }, [ref.current]);
  return [ref, rect];
}
function useElementSize() {
  const [ref, { width, height }] = useResizeObserver();
  return { ref, width, height };
}


//# sourceMappingURL=use-resize-observer.js.map


/***/ }),

/***/ 83317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ useScrollLock; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-scroll-lock/utils/get-scroll-width.js
function getScrollWidth() {
  if (typeof window === "undefined" || typeof document === "undefined")
    return 0;
  const paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  return paddingRight + scrollbarWidth;
}


//# sourceMappingURL=get-scroll-width.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-scroll-lock/utils/get-lock-styles.js


const getLockStyles = ({ disableBodyPadding }) => {
  const scrollWidth = disableBodyPadding ? null : getScrollWidth();
  const styles = `body {
        --removed-scroll-width: ${scrollWidth}px;
        touch-action: none;
        overflow: hidden !important;
        position: relative !important;
        ${scrollWidth ? "padding-right: var(--removed-scroll-width) !important;" : ""}
        `;
  return styles;
};


//# sourceMappingURL=get-lock-styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-scroll-lock/utils/inject-style-tag.js
function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}


//# sourceMappingURL=inject-style-tag.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-scroll-lock/utils/insert-style-tag.js
function insertStyleTag(tag) {
  const head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}


//# sourceMappingURL=insert-style-tag.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-scroll-lock/utils/make-style-tag.js
function makeStyleTag() {
  const tag = document.createElement("style");
  tag.type = "text/css";
  tag.setAttribute("mantine-scroll-lock", "");
  return tag;
}


//# sourceMappingURL=make-style-tag.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-scroll-lock/use-scroll-lock.js






function useScrollLock(lock, options = {
  disableBodyPadding: false
}) {
  const [scrollLocked, setScrollLocked] = (0,react.useState)(lock || false);
  const scrollTop = (0,react.useRef)(0);
  const { disableBodyPadding } = options;
  const stylesheet = (0,react.useRef)(null);
  const lockScroll = () => {
    scrollTop.current = window.scrollY;
    const styles = getLockStyles({ disableBodyPadding });
    const sheet = makeStyleTag();
    injectStyles(sheet, styles);
    insertStyleTag(sheet);
    stylesheet.current = sheet;
  };
  const unlockScroll = () => {
    if (!(stylesheet == null ? void 0 : stylesheet.current))
      return;
    stylesheet.current.parentNode.removeChild(stylesheet.current);
    stylesheet.current = null;
  };
  (0,react.useEffect)(() => {
    if (scrollLocked) {
      lockScroll();
    } else {
      unlockScroll();
    }
    return unlockScroll;
  }, [scrollLocked]);
  (0,react.useEffect)(() => {
    if (lock !== void 0) {
      setScrollLocked(lock);
    }
  }, [lock]);
  (0,react.useEffect)(() => {
    if (lock === void 0 && typeof window !== "undefined") {
      window.document.body.style.overflow === "hidden" && setScrollLocked(true);
    }
  }, [setScrollLocked]);
  return [scrollLocked, setScrollLocked];
}


//# sourceMappingURL=use-scroll-lock.js.map


/***/ }),

/***/ 73946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useSetState; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function useSetState(initialState) {
  const [state, _setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState);
  const setState = (statePartial) => _setState((current) => __spreadValues(__spreadValues({}, current), typeof statePartial === "function" ? statePartial(current) : statePartial));
  return [state, setState];
}


//# sourceMappingURL=use-set-state.js.map


/***/ }),

/***/ 15851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useUncontrolled; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useUncontrolled({
  value,
  defaultValue,
  finalValue,
  onChange = () => {
  }
}) {
  const [uncontrolledValue, setUncontrolledValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValue !== void 0 ? defaultValue : finalValue);
  const handleUncontrolledChange = (val) => {
    setUncontrolledValue(val);
    onChange == null ? void 0 : onChange(val);
  };
  if (value !== void 0) {
    return [value, onChange, true];
  }
  return [uncontrolledValue, handleUncontrolledChange, false];
}


//# sourceMappingURL=use-uncontrolled.js.map


/***/ }),

/***/ 84137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useWindowEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useWindowEvent(type, listener, options) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    window.addEventListener(type, listener, options);
    return () => window.removeEventListener(type, listener, options);
  }, [type, listener]);
}


//# sourceMappingURL=use-window-event.js.map


/***/ }),

/***/ 72128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useWindowScroll; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_window_event_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84137);



function getScrollPosition() {
  return typeof window !== "undefined" ? { x: window.pageXOffset, y: window.pageYOffset } : { x: 0, y: 0 };
}
function scrollTo({ x, y }) {
  if (typeof window !== "undefined") {
    const scrollOptions = { behavior: "smooth" };
    if (typeof x === "number") {
      scrollOptions.left = x;
    }
    if (typeof y === "number") {
      scrollOptions.top = y;
    }
    window.scrollTo(scrollOptions);
  }
}
function useWindowScroll() {
  const [position, setPosition] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({ x: 0, y: 0 });
  (0,_use_window_event_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useWindowEvent */ .s)("scroll", () => setPosition(getScrollPosition()));
  (0,_use_window_event_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useWindowEvent */ .s)("resize", () => setPosition(getScrollPosition()));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setPosition(getScrollPosition());
  }, []);
  return [position, scrollTo];
}


//# sourceMappingURL=use-window-scroll.js.map


/***/ }),

/***/ 83979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ assignRef; }
/* harmony export */ });
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (typeof ref === "object" && ref !== null && "current" in ref) {
    ref.current = value;
  }
}


//# sourceMappingURL=assign-ref.js.map


/***/ }),

/***/ 89058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ randomId; }
/* harmony export */ });
function randomId() {
  return `mantine-${Math.random().toString(36).slice(2, 11)}`;
}


//# sourceMappingURL=random-id.js.map


/***/ }),

/***/ 33575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c0": function() { return /* binding */ showNotification; },
  "Gy": function() { return /* binding */ useNotificationsEvents; }
});

// UNUSED EXPORTS: cleanNotifications, cleanNotificationsQueue, createEvent, hideNotification, updateNotification

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@mantine/utils/esm/create-use-external-events/create-use-external-events.js


function dispatchEvent(type, detail) {
  window.dispatchEvent(new CustomEvent(type, { detail }));
}
const useIsomorphicEffect = typeof window !== "undefined" ? react.useLayoutEffect : react.useEffect;
function createUseExternalEvents(prefix) {
  function _useExternalEvents(events) {
    const handlers = Object.keys(events).reduce((acc, eventKey) => {
      acc[`${prefix}:${eventKey}`] = (event) => events[eventKey](event.detail);
      return acc;
    }, {});
    useIsomorphicEffect(() => {
      Object.keys(handlers).forEach((eventKey) => {
        window.removeEventListener(eventKey, handlers[eventKey]);
        window.addEventListener(eventKey, handlers[eventKey]);
      });
      return () => Object.keys(handlers).forEach((eventKey) => {
        window.removeEventListener(eventKey, handlers[eventKey]);
      });
    }, [handlers]);
  }
  function createEvent(event) {
    return (...payload) => dispatchEvent(`${prefix}:${String(event)}`, payload[0]);
  }
  return [_useExternalEvents, createEvent];
}


//# sourceMappingURL=create-use-external-events.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/notifications/esm/events.js


const [useNotificationsEvents, createEvent] = createUseExternalEvents("mantine-notifications");
const showNotification = createEvent("show");
const hideNotification = createEvent("hide");
const cleanNotifications = createEvent("clean");
const cleanNotificationsQueue = createEvent("cleanQueue");
const updateNotification = createEvent("update");


//# sourceMappingURL=events.js.map


/***/ }),

/***/ 64761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Me": function() { return /* binding */ MantineProvider; },
  "N4": function() { return /* binding */ useComponentDefaultProps; },
  "T1": function() { return /* binding */ useMantineEmotionCache; },
  "O2": function() { return /* binding */ useMantineProviderStyles; },
  "rZ": function() { return /* binding */ useMantineTheme; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(91683);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/default-theme.js + 1 modules
var default_theme = __webpack_require__(37447);
;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/GlobalStyles.js



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function GlobalStyles({ theme }) {
  return /* @__PURE__ */ react.createElement(emotion_react_browser_esm/* Global */.xB, {
    styles: {
      "*, *::before, *::after": {
        boxSizing: "border-box"
      },
      html: {
        colorScheme: theme.colorScheme === "dark" ? "dark" : "light"
      },
      body: __spreadProps(__spreadValues({}, theme.fn.fontStyles()), {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
        lineHeight: theme.lineHeight,
        fontSize: theme.fontSizes.md,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale"
      })
    }
  });
}


//# sourceMappingURL=GlobalStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/MantineCssVariables.js



function assignSizeVariables(variables, sizes, name) {
  Object.keys(sizes).forEach((size) => {
    variables[`--mantine-${name}-${size}`] = typeof sizes[size] === "number" ? `${sizes[size]}px` : sizes[size];
  });
}
function MantineCssVariables({ theme }) {
  const variables = {
    "--mantine-color-white": theme.white,
    "--mantine-color-black": theme.black,
    "--mantine-transition-timing-function": theme.transitionTimingFunction,
    "--mantine-line-height": `${theme.lineHeight}`,
    "--mantine-font-family": theme.fontFamily,
    "--mantine-font-family-monospace": theme.fontFamilyMonospace,
    "--mantine-font-family-headings": theme.headings.fontFamily,
    "--mantine-heading-font-weight": `${theme.headings.fontWeight}`
  };
  assignSizeVariables(variables, theme.shadows, "shadow");
  assignSizeVariables(variables, theme.fontSizes, "font-size");
  assignSizeVariables(variables, theme.radius, "radius");
  assignSizeVariables(variables, theme.spacing, "spacing");
  Object.keys(theme.colors).forEach((color) => {
    theme.colors[color].forEach((shade, index) => {
      variables[`--mantine-color-${color}-${index}`] = shade;
    });
  });
  const headings = theme.headings.sizes;
  Object.keys(headings).forEach((heading) => {
    variables[`--mantine-${heading}-font-size`] = `${headings[heading].fontSize}px`;
    variables[`--mantine-${heading}-line-height`] = `${headings[heading].lineHeight}`;
  });
  return /* @__PURE__ */ react.createElement(emotion_react_browser_esm/* Global */.xB, {
    styles: {
      ":root": variables
    }
  });
}


//# sourceMappingURL=MantineCssVariables.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/functions/attach-functions.js + 19 modules
var attach_functions = __webpack_require__(3734);
;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/utils/merge-theme/merge-theme.js


var merge_theme_defProp = Object.defineProperty;
var merge_theme_defProps = Object.defineProperties;
var merge_theme_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var merge_theme_getOwnPropSymbols = Object.getOwnPropertySymbols;
var merge_theme_hasOwnProp = Object.prototype.hasOwnProperty;
var merge_theme_propIsEnum = Object.prototype.propertyIsEnumerable;
var merge_theme_defNormalProp = (obj, key, value) => key in obj ? merge_theme_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var merge_theme_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (merge_theme_hasOwnProp.call(b, prop))
      merge_theme_defNormalProp(a, prop, b[prop]);
  if (merge_theme_getOwnPropSymbols)
    for (var prop of merge_theme_getOwnPropSymbols(b)) {
      if (merge_theme_propIsEnum.call(b, prop))
        merge_theme_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var merge_theme_spreadProps = (a, b) => merge_theme_defProps(a, merge_theme_getOwnPropDescs(b));
function mergeTheme(currentTheme, themeOverride) {
  if (!themeOverride) {
    return currentTheme;
  }
  const result = Object.keys(currentTheme).reduce((acc, key) => {
    if (key === "headings" && themeOverride.headings) {
      const sizes = themeOverride.headings.sizes ? Object.keys(currentTheme.headings.sizes).reduce((headingsAcc, h) => {
        headingsAcc[h] = merge_theme_spreadValues(merge_theme_spreadValues({}, currentTheme.headings.sizes[h]), themeOverride.headings.sizes[h]);
        return headingsAcc;
      }, {}) : currentTheme.headings.sizes;
      return merge_theme_spreadProps(merge_theme_spreadValues({}, acc), {
        headings: merge_theme_spreadProps(merge_theme_spreadValues(merge_theme_spreadValues({}, currentTheme.headings), themeOverride.headings), {
          sizes
        })
      });
    }
    acc[key] = typeof themeOverride[key] === "object" ? merge_theme_spreadValues(merge_theme_spreadValues({}, currentTheme[key]), themeOverride[key]) : typeof themeOverride[key] === "number" || typeof themeOverride[key] === "boolean" || typeof themeOverride[key] === "function" ? themeOverride[key] : themeOverride[key] || currentTheme[key];
    return acc;
  }, {});
  if (!(result.primaryColor in result.colors)) {
    throw new Error("MantineProvider: Invalid theme.primaryColor, it accepts only key of theme.colors, learn more \u2013 https://mantine.dev/theming/colors/#primary-color");
  }
  return result;
}
function mergeThemeWithFunctions(currentTheme, themeOverride) {
  return (0,attach_functions/* attachFunctions */.P)(mergeTheme(currentTheme, themeOverride));
}


//# sourceMappingURL=merge-theme.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/utils/filter-props/filter-props.js
var filter_props = __webpack_require__(66896);
;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/NormalizeCSS.js



const styles = {
  html: {
    fontFamily: "sans-serif",
    lineHeight: "1.15",
    textSizeAdjust: "100%"
  },
  body: {
    margin: 0
  },
  "article, aside, footer, header, nav, section, figcaption, figure, main": {
    display: "block"
  },
  h1: {
    fontSize: "2em"
  },
  hr: {
    boxSizing: "content-box",
    height: 0,
    overflow: "visible"
  },
  pre: {
    fontFamily: "monospace, monospace",
    fontSize: "1em"
  },
  a: {
    background: "transparent",
    textDecorationSkip: "objects"
  },
  "a:active, a:hover": {
    outlineWidth: 0
  },
  "abbr[title]": {
    borderBottom: "none",
    textDecoration: "underline"
  },
  "b, strong": {
    fontWeight: "bolder"
  },
  "code, kbp, samp": {
    fontFamily: "monospace, monospace",
    fontSize: "1em"
  },
  dfn: {
    fontStyle: "italic"
  },
  mark: {
    backgroundColor: "#ff0",
    color: "#000"
  },
  small: {
    fontSize: "80%"
  },
  "sub, sup": {
    fontSize: "75%",
    lineHeight: 0,
    position: "relative",
    verticalAlign: "baseline"
  },
  sup: {
    top: "-0.5em"
  },
  sub: {
    bottom: "-0.25em"
  },
  "audio, video": {
    display: "inline-block"
  },
  "audio:not([controls])": {
    display: "none",
    height: 0
  },
  img: {
    borderStyle: "none",
    verticalAlign: "middle"
  },
  "svg:not(:root)": {
    overflow: "hidden"
  },
  "button, input, optgroup, select, textarea": {
    fontFamily: "sans-serif",
    fontSize: "100%",
    lineHeight: "1.15",
    margin: 0
  },
  "button, input": {
    overflow: "visible"
  },
  "button, select": {
    textTransform: "none"
  },
  "button, [type=reset], [type=submit]": {
    WebkitAppearance: "button"
  },
  "button::-moz-focus-inner, [type=button]::-moz-focus-inner, [type=reset]::-moz-focus-inner, [type=submit]::-moz-focus-inner": {
    borderStyle: "none",
    padding: 0
  },
  "button:-moz-focusring, [type=button]:-moz-focusring, [type=reset]:-moz-focusring, [type=submit]:-moz-focusring": {
    outline: "1px dotted ButtonText"
  },
  legend: {
    boxSizing: "border-box",
    color: "inherit",
    display: "table",
    maxWidth: "100%",
    padding: 0,
    whiteSpace: "normal"
  },
  progress: {
    display: "inline-block",
    verticalAlign: "baseline"
  },
  textarea: {
    overflow: "auto"
  },
  "[type=checkbox], [type=radio]": {
    boxSizing: "border-box",
    padding: 0
  },
  "[type=number]::-webkit-inner-spin-button, [type=number]::-webkit-outer-spin-button": {
    height: "auto"
  },
  "[type=search]": {
    appearance: "none"
  },
  "[type=search]::-webkit-search-cancel-button, [type=search]::-webkit-search-decoration": {
    appearance: "none"
  },
  "::-webkit-file-upload-button": {
    appearance: "button",
    font: "inherit"
  },
  "details, menu": {
    display: "block"
  },
  summary: {
    display: "list-item"
  },
  canvas: {
    display: "inline-block"
  },
  template: {
    display: "none"
  },
  "[hidden]": {
    display: "none"
  }
};
function NormalizeCSS() {
  return /* @__PURE__ */ react.createElement(emotion_react_browser_esm/* Global */.xB, {
    styles
  });
}


//# sourceMappingURL=NormalizeCSS.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js









var MantineProvider_defProp = Object.defineProperty;
var MantineProvider_getOwnPropSymbols = Object.getOwnPropertySymbols;
var MantineProvider_hasOwnProp = Object.prototype.hasOwnProperty;
var MantineProvider_propIsEnum = Object.prototype.propertyIsEnumerable;
var MantineProvider_defNormalProp = (obj, key, value) => key in obj ? MantineProvider_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var MantineProvider_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (MantineProvider_hasOwnProp.call(b, prop))
      MantineProvider_defNormalProp(a, prop, b[prop]);
  if (MantineProvider_getOwnPropSymbols)
    for (var prop of MantineProvider_getOwnPropSymbols(b)) {
      if (MantineProvider_propIsEnum.call(b, prop))
        MantineProvider_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const MantineProviderContext = (0,react.createContext)({
  theme: default_theme/* DEFAULT_THEME */.t0
});
function useMantineTheme() {
  var _a;
  return ((_a = (0,react.useContext)(MantineProviderContext)) == null ? void 0 : _a.theme) || default_theme/* DEFAULT_THEME */.t0;
}
function useMantineProviderStyles(component) {
  const theme = useMantineTheme();
  const getStyles = (name) => {
    var _a, _b;
    return {
      styles: ((_a = theme.components[name]) == null ? void 0 : _a.styles) || {},
      classNames: ((_b = theme.components[name]) == null ? void 0 : _b.classNames) || {}
    };
  };
  if (Array.isArray(component)) {
    return component.map(getStyles);
  }
  return [getStyles(component)];
}
function useMantineEmotionCache() {
  var _a;
  return (_a = (0,react.useContext)(MantineProviderContext)) == null ? void 0 : _a.emotionCache;
}
function useComponentDefaultProps(component, defaultProps, props) {
  var _a;
  const theme = useMantineTheme();
  const contextPropsPayload = (_a = theme.components[component]) == null ? void 0 : _a.defaultProps;
  const contextProps = typeof contextPropsPayload === "function" ? contextPropsPayload(theme) : contextPropsPayload;
  return MantineProvider_spreadValues(MantineProvider_spreadValues(MantineProvider_spreadValues({}, defaultProps), contextProps), (0,filter_props/* filterProps */.L)(props));
}
function MantineProvider({
  theme,
  emotionCache,
  withNormalizeCSS = false,
  withGlobalStyles = false,
  withCSSVariables = false,
  inherit = false,
  children
}) {
  const ctx = (0,react.useContext)(MantineProviderContext);
  const mergedTheme = mergeThemeWithFunctions(default_theme/* DEFAULT_THEME */.t0, inherit ? MantineProvider_spreadValues(MantineProvider_spreadValues({}, ctx.theme), theme) : theme);
  return /* @__PURE__ */ react.createElement(emotion_element_6a883da9_browser_esm.a, {
    theme: mergedTheme
  }, /* @__PURE__ */ react.createElement(MantineProviderContext.Provider, {
    value: { theme: mergedTheme, emotionCache }
  }, withNormalizeCSS && /* @__PURE__ */ react.createElement(NormalizeCSS, null), withGlobalStyles && /* @__PURE__ */ react.createElement(GlobalStyles, {
    theme: mergedTheme
  }), withCSSVariables && /* @__PURE__ */ react.createElement(MantineCssVariables, {
    theme: mergedTheme
  }), typeof mergedTheme.globalStyles === "function" && /* @__PURE__ */ react.createElement(emotion_react_browser_esm/* Global */.xB, {
    styles: mergedTheme.globalStyles(mergedTheme)
  }), children));
}
MantineProvider.displayName = "@mantine/core/MantineProvider";


//# sourceMappingURL=MantineProvider.js.map


/***/ }),

/***/ 37447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t0": function() { return /* binding */ DEFAULT_THEME; },
  "j1": function() { return /* binding */ MANTINE_SIZES; }
});

// UNUSED EXPORTS: MANTINE_COLORS, _DEFAULT_THEME

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/default-colors.js
const DEFAULT_COLORS = {
  dark: [
    "#C1C2C5",
    "#A6A7AB",
    "#909296",
    "#5c5f66",
    "#373A40",
    "#2C2E33",
    "#25262b",
    "#1A1B1E",
    "#141517",
    "#101113"
  ],
  gray: [
    "#f8f9fa",
    "#f1f3f5",
    "#e9ecef",
    "#dee2e6",
    "#ced4da",
    "#adb5bd",
    "#868e96",
    "#495057",
    "#343a40",
    "#212529"
  ],
  red: [
    "#fff5f5",
    "#ffe3e3",
    "#ffc9c9",
    "#ffa8a8",
    "#ff8787",
    "#ff6b6b",
    "#fa5252",
    "#f03e3e",
    "#e03131",
    "#c92a2a"
  ],
  pink: [
    "#fff0f6",
    "#ffdeeb",
    "#fcc2d7",
    "#faa2c1",
    "#f783ac",
    "#f06595",
    "#e64980",
    "#d6336c",
    "#c2255c",
    "#a61e4d"
  ],
  grape: [
    "#f8f0fc",
    "#f3d9fa",
    "#eebefa",
    "#e599f7",
    "#da77f2",
    "#cc5de8",
    "#be4bdb",
    "#ae3ec9",
    "#9c36b5",
    "#862e9c"
  ],
  violet: [
    "#f3f0ff",
    "#e5dbff",
    "#d0bfff",
    "#b197fc",
    "#9775fa",
    "#845ef7",
    "#7950f2",
    "#7048e8",
    "#6741d9",
    "#5f3dc4"
  ],
  indigo: [
    "#edf2ff",
    "#dbe4ff",
    "#bac8ff",
    "#91a7ff",
    "#748ffc",
    "#5c7cfa",
    "#4c6ef5",
    "#4263eb",
    "#3b5bdb",
    "#364fc7"
  ],
  blue: [
    "#e7f5ff",
    "#d0ebff",
    "#a5d8ff",
    "#74c0fc",
    "#4dabf7",
    "#339af0",
    "#228be6",
    "#1c7ed6",
    "#1971c2",
    "#1864ab"
  ],
  cyan: [
    "#e3fafc",
    "#c5f6fa",
    "#99e9f2",
    "#66d9e8",
    "#3bc9db",
    "#22b8cf",
    "#15aabf",
    "#1098ad",
    "#0c8599",
    "#0b7285"
  ],
  teal: [
    "#e6fcf5",
    "#c3fae8",
    "#96f2d7",
    "#63e6be",
    "#38d9a9",
    "#20c997",
    "#12b886",
    "#0ca678",
    "#099268",
    "#087f5b"
  ],
  green: [
    "#ebfbee",
    "#d3f9d8",
    "#b2f2bb",
    "#8ce99a",
    "#69db7c",
    "#51cf66",
    "#40c057",
    "#37b24d",
    "#2f9e44",
    "#2b8a3e"
  ],
  lime: [
    "#f4fce3",
    "#e9fac8",
    "#d8f5a2",
    "#c0eb75",
    "#a9e34b",
    "#94d82d",
    "#82c91e",
    "#74b816",
    "#66a80f",
    "#5c940d"
  ],
  yellow: [
    "#fff9db",
    "#fff3bf",
    "#ffec99",
    "#ffe066",
    "#ffd43b",
    "#fcc419",
    "#fab005",
    "#f59f00",
    "#f08c00",
    "#e67700"
  ],
  orange: [
    "#fff4e6",
    "#ffe8cc",
    "#ffd8a8",
    "#ffc078",
    "#ffa94d",
    "#ff922b",
    "#fd7e14",
    "#f76707",
    "#e8590c",
    "#d9480f"
  ]
};


//# sourceMappingURL=default-colors.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/functions/attach-functions.js + 19 modules
var attach_functions = __webpack_require__(3734);
;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/default-theme.js



const MANTINE_COLORS = Object.keys(DEFAULT_COLORS);
const MANTINE_SIZES = ["xs", "sm", "md", "lg", "xl"];
const _DEFAULT_THEME = {
  dir: "ltr",
  primaryShade: {
    light: 6,
    dark: 8
  },
  focusRing: "auto",
  loader: "oval",
  dateFormat: "MMMM D, YYYY",
  colorScheme: "light",
  white: "#fff",
  black: "#000",
  defaultRadius: "sm",
  transitionTimingFunction: "ease",
  colors: DEFAULT_COLORS,
  lineHeight: 1.55,
  fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
  fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
  primaryColor: "blue",
  respectReducedMotion: true,
  cursorType: "default",
  defaultGradient: {
    from: "indigo",
    to: "cyan",
    deg: 45
  },
  shadows: {
    xs: "0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1)",
    sm: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 10px 15px -5px, rgba(0, 0, 0, 0.04) 0px 7px 7px -5px",
    md: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
    lg: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 28px 23px -7px, rgba(0, 0, 0, 0.04) 0px 12px 12px -7px",
    xl: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 36px 28px -7px, rgba(0, 0, 0, 0.04) 0px 17px 17px -7px"
  },
  fontSizes: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20
  },
  radius: {
    xs: 2,
    sm: 4,
    md: 8,
    lg: 16,
    xl: 32
  },
  spacing: {
    xs: 10,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 24
  },
  breakpoints: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1400
  },
  headings: {
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
    fontWeight: 700,
    sizes: {
      h1: { fontSize: 34, lineHeight: 1.3, fontWeight: void 0 },
      h2: { fontSize: 26, lineHeight: 1.35, fontWeight: void 0 },
      h3: { fontSize: 22, lineHeight: 1.4, fontWeight: void 0 },
      h4: { fontSize: 18, lineHeight: 1.45, fontWeight: void 0 },
      h5: { fontSize: 16, lineHeight: 1.5, fontWeight: void 0 },
      h6: { fontSize: 14, lineHeight: 1.5, fontWeight: void 0 }
    }
  },
  other: {},
  components: {},
  activeStyles: { transform: "translateY(1px)" },
  datesLocale: "en",
  globalStyles: void 0,
  focusRingStyles: {
    styles: (theme) => ({
      outlineOffset: 2,
      outline: `2px solid ${theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 7 : 5]}`
    }),
    resetStyles: () => ({ outline: "none" }),
    inputStyles: (theme) => ({
      outline: "none",
      borderColor: theme.colors[theme.primaryColor][typeof theme.primaryShade === "object" ? theme.primaryShade[theme.colorScheme] : theme.primaryShade]
    })
  }
};
const DEFAULT_THEME = (0,attach_functions/* attachFunctions */.P)(_DEFAULT_THEME);


//# sourceMappingURL=default-theme.js.map


/***/ }),

/***/ 3734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ attachFunctions; }
});

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/font-styles/font-styles.js
function fontStyles(theme) {
  return () => ({ fontFamily: theme.fontFamily || "sans-serif" });
}


//# sourceMappingURL=font-styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/focus-styles/focus-styles.js
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function focusStyles(theme) {
  return (selector) => ({
    WebkitTapHighlightColor: "transparent",
    [selector || "&:focus"]: __spreadValues({}, theme.focusRing === "always" || theme.focusRing === "auto" ? theme.focusRingStyles.styles(theme) : theme.focusRingStyles.resetStyles(theme)),
    [selector ? selector.replace(":focus", ":focus:not(:focus-visible)") : "&:focus:not(:focus-visible)"]: __spreadValues({}, theme.focusRing === "auto" || theme.focusRing === "never" ? theme.focusRingStyles.resetStyles(theme) : null)
  });
}


//# sourceMappingURL=focus-styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/primary-shade/primary-shade.js
function primaryShade(theme) {
  return (colorScheme) => {
    if (typeof theme.primaryShade === "number") {
      return theme.primaryShade;
    }
    return theme.primaryShade[colorScheme || theme.colorScheme];
  };
}


//# sourceMappingURL=primary-shade.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/theme-color/theme-color.js


function themeColor(theme) {
  const getPrimaryShade = primaryShade(theme);
  return (color, shade, primaryFallback = true, useSplittedShade = true) => {
    if (typeof color === "string" && color.includes(".")) {
      const [splitterColor, _splittedShade] = color.split(".");
      const splittedShade = parseInt(_splittedShade, 10);
      if (splitterColor in theme.colors && splittedShade >= 0 && splittedShade < 10) {
        return theme.colors[splitterColor][typeof shade === "number" && !useSplittedShade ? shade : splittedShade];
      }
    }
    const _shade = typeof shade === "number" ? shade : getPrimaryShade();
    return color in theme.colors ? theme.colors[color][_shade] : primaryFallback ? theme.colors[theme.primaryColor][_shade] : color;
  };
}


//# sourceMappingURL=theme-color.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/gradient/get-gradient-color-stops/get-gradient-color-stops.js
function getGradientColorStops(colors) {
  let stops = "";
  for (let i = 1; i < colors.length - 1; i += 1) {
    stops += `${colors[i]} ${i / (colors.length - 1) * 100}%, `;
  }
  return `${colors[0]} 0%, ${stops}${colors[colors.length - 1]} 100%`;
}


//# sourceMappingURL=get-gradient-color-stops.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/gradient/gradient.js




function linearGradient(deg, ...colors) {
  return `linear-gradient(${deg}deg, ${getGradientColorStops(colors)})`;
}
function radialGradient(...colors) {
  return `radial-gradient(circle, ${getGradientColorStops(colors)})`;
}
function gradient(theme) {
  const getThemeColor = themeColor(theme);
  const getPrimaryShade = primaryShade(theme);
  return (payload) => {
    const merged = {
      from: (payload == null ? void 0 : payload.from) || theme.defaultGradient.from,
      to: (payload == null ? void 0 : payload.to) || theme.defaultGradient.to,
      deg: (payload == null ? void 0 : payload.deg) || theme.defaultGradient.deg
    };
    return `linear-gradient(${merged.deg}deg, ${getThemeColor(merged.from, getPrimaryShade(), false)} 0%, ${getThemeColor(merged.to, getPrimaryShade(), false)} 100%)`;
  };
}


//# sourceMappingURL=gradient.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/size/size.js
function size(props) {
  if (typeof props.size === "number") {
    return props.size;
  }
  const computedSize = props.sizes[props.size];
  return computedSize !== void 0 ? computedSize : props.size || props.sizes.md;
}


//# sourceMappingURL=size.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/breakpoints/breakpoints.js


function largerThan(theme) {
  return (breakpoint) => `@media (min-width: ${size({ size: breakpoint, sizes: theme.breakpoints })}px)`;
}
function smallerThan(theme) {
  return (breakpoint) => `@media (max-width: ${size({ size: breakpoint, sizes: theme.breakpoints }) - 1}px)`;
}


//# sourceMappingURL=breakpoints.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/utils/to-rgba/to-rgba.js
function isHexColor(hex) {
  const HEX_REGEXP = /^#?([0-9A-F]{3}){1,2}$/i;
  return HEX_REGEXP.test(hex);
}
function hexToRgba(color) {
  let hexString = color.replace("#", "");
  if (hexString.length === 3) {
    const shorthandHex = hexString.split("");
    hexString = [
      shorthandHex[0],
      shorthandHex[0],
      shorthandHex[1],
      shorthandHex[1],
      shorthandHex[2],
      shorthandHex[2]
    ].join("");
  }
  const parsed = parseInt(hexString, 16);
  const r = parsed >> 16 & 255;
  const g = parsed >> 8 & 255;
  const b = parsed & 255;
  return {
    r,
    g,
    b,
    a: 1
  };
}
function rgbStringToRgba(color) {
  const [r, g, b, a] = color.replace(/[^0-9,.]/g, "").split(",").map(Number);
  return { r, g, b, a: a || 1 };
}
function toRgba(color) {
  if (isHexColor(color)) {
    return hexToRgba(color);
  }
  if (color.startsWith("rgb")) {
    return rgbStringToRgba(color);
  }
  return {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  };
}


//# sourceMappingURL=to-rgba.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/rgba/rgba.js


function rgba(color, alpha) {
  if (typeof color !== "string" || alpha > 1 || alpha < 0) {
    return "rgba(0, 0, 0, 1)";
  }
  const { r, g, b } = toRgba(color);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}


//# sourceMappingURL=rgba.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/cover/cover.js
function cover(offset = 0) {
  return {
    position: "absolute",
    top: offset,
    right: offset,
    left: offset,
    bottom: offset
  };
}


//# sourceMappingURL=cover.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/darken/darken.js


function darken(color, alpha) {
  const { r, g, b, a } = toRgba(color);
  const f = 1 - alpha;
  const dark = (input) => Math.round(input * f);
  return `rgba(${dark(r)}, ${dark(g)}, ${dark(b)}, ${a})`;
}


//# sourceMappingURL=darken.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/lighten/lighten.js


function lighten(color, alpha) {
  const { r, g, b, a } = toRgba(color);
  const light = (input) => Math.round(input + (255 - input) * alpha);
  return `rgba(${light(r)}, ${light(g)}, ${light(b)}, ${a})`;
}


//# sourceMappingURL=lighten.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/radius/radius.js
function radius(theme) {
  return (size) => {
    if (typeof size === "number") {
      return size;
    }
    const defaultRadius = typeof theme.defaultRadius === "number" ? theme.defaultRadius : theme.radius[theme.defaultRadius] || theme.defaultRadius;
    return theme.radius[size] || size || defaultRadius;
  };
}


//# sourceMappingURL=radius.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/variant/variant.js





function getColorIndexInfo(color, theme) {
  if (typeof color === "string" && color.includes(".")) {
    const [splittedColor, _splittedShade] = color.split(".");
    const splittedShade = parseInt(_splittedShade, 10);
    if (splittedColor in theme.colors && splittedShade >= 0 && splittedShade < 10) {
      return { isSplittedColor: true, key: splittedColor, shade: splittedShade };
    }
  }
  return { isSplittedColor: false };
}
function variant(theme) {
  const getThemeColor = themeColor(theme);
  const getPrimaryShade = primaryShade(theme);
  const getGradient = gradient(theme);
  return ({ variant: variant2, color, gradient: gradient2, primaryFallback }) => {
    const colorInfo = getColorIndexInfo(color, theme);
    switch (variant2) {
      case "light": {
        return {
          border: "transparent",
          background: rgba(getThemeColor(color, theme.colorScheme === "dark" ? 8 : 0, primaryFallback, false), theme.colorScheme === "dark" ? 0.2 : 1),
          color: color === "dark" ? theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.dark[9] : getThemeColor(color, theme.colorScheme === "dark" ? 2 : getPrimaryShade("light")),
          hover: rgba(getThemeColor(color, theme.colorScheme === "dark" ? 7 : 1, primaryFallback, false), theme.colorScheme === "dark" ? 0.25 : 0.65)
        };
      }
      case "subtle": {
        return {
          border: "transparent",
          background: "transparent",
          color: color === "dark" ? theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.dark[9] : getThemeColor(color, theme.colorScheme === "dark" ? 2 : getPrimaryShade("light")),
          hover: rgba(getThemeColor(color, theme.colorScheme === "dark" ? 8 : 0, primaryFallback, false), theme.colorScheme === "dark" ? 0.2 : 1)
        };
      }
      case "outline": {
        return {
          border: getThemeColor(color, theme.colorScheme === "dark" ? 5 : getPrimaryShade("light")),
          background: "transparent",
          color: getThemeColor(color, theme.colorScheme === "dark" ? 5 : getPrimaryShade("light")),
          hover: theme.colorScheme === "dark" ? rgba(getThemeColor(color, 5, primaryFallback, false), 0.05) : rgba(getThemeColor(color, 0, primaryFallback, false), 0.35)
        };
      }
      case "default": {
        return {
          border: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
          background: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
          color: theme.colorScheme === "dark" ? theme.white : theme.black,
          hover: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
        };
      }
      case "white": {
        return {
          border: "transparent",
          background: theme.white,
          color: getThemeColor(color, getPrimaryShade()),
          hover: null
        };
      }
      case "transparent": {
        return {
          border: "transparent",
          color: color === "dark" ? theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.dark[9] : getThemeColor(color, theme.colorScheme === "dark" ? 2 : getPrimaryShade("light")),
          background: "transparent",
          hover: null
        };
      }
      case "gradient": {
        return {
          background: getGradient(gradient2),
          color: theme.white,
          border: "transparent",
          hover: null
        };
      }
      default: {
        const _primaryShade = getPrimaryShade();
        const _shade = colorInfo.isSplittedColor ? colorInfo.shade : _primaryShade;
        const _color = colorInfo.isSplittedColor ? colorInfo.key : color;
        return {
          border: "transparent",
          background: getThemeColor(_color, _shade, primaryFallback),
          color: theme.white,
          hover: getThemeColor(_color, _shade === 9 ? 8 : _shade + 1)
        };
      }
    }
  };
}


//# sourceMappingURL=variant.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/primary-color/primary-color.js


function primaryColor(theme) {
  return (colorScheme) => {
    const shade = primaryShade(theme)(colorScheme);
    return theme.colors[theme.primaryColor][shade];
  };
}


//# sourceMappingURL=primary-color.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/hover/hover.js
function hover(hoverStyle) {
  return {
    "@media (hover: hover)": {
      "&:hover": hoverStyle
    },
    "@media (hover: none)": {
      "&:active": hoverStyle
    }
  };
}


//# sourceMappingURL=hover.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/placeholder-styles/placeholder-styles.js
function placeholderStyles(theme) {
  return () => ({
    userSelect: "none",
    color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
  });
}


//# sourceMappingURL=placeholder-styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/fns/index.js

















const fns = {
  fontStyles: fontStyles,
  themeColor: themeColor,
  focusStyles: focusStyles,
  linearGradient: linearGradient,
  radialGradient: radialGradient,
  smallerThan: smallerThan,
  largerThan: largerThan,
  rgba: rgba,
  size: size,
  cover: cover,
  darken: darken,
  lighten: lighten,
  radius: radius,
  variant: variant,
  primaryShade: primaryShade,
  hover: hover,
  gradient: gradient,
  primaryColor: primaryColor,
  placeholderStyles: placeholderStyles
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/theme/functions/attach-functions.js


var attach_functions_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var attach_functions_getOwnPropSymbols = Object.getOwnPropertySymbols;
var attach_functions_hasOwnProp = Object.prototype.hasOwnProperty;
var attach_functions_propIsEnum = Object.prototype.propertyIsEnumerable;
var attach_functions_defNormalProp = (obj, key, value) => key in obj ? attach_functions_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var attach_functions_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (attach_functions_hasOwnProp.call(b, prop))
      attach_functions_defNormalProp(a, prop, b[prop]);
  if (attach_functions_getOwnPropSymbols)
    for (var prop of attach_functions_getOwnPropSymbols(b)) {
      if (attach_functions_propIsEnum.call(b, prop))
        attach_functions_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function attachFunctions(themeBase) {
  return __spreadProps(attach_functions_spreadValues({}, themeBase), {
    fn: {
      fontStyles: fns.fontStyles(themeBase),
      themeColor: fns.themeColor(themeBase),
      focusStyles: fns.focusStyles(themeBase),
      largerThan: fns.largerThan(themeBase),
      smallerThan: fns.smallerThan(themeBase),
      radialGradient: fns.radialGradient,
      linearGradient: fns.linearGradient,
      gradient: fns.gradient(themeBase),
      rgba: fns.rgba,
      size: fns.size,
      cover: fns.cover,
      lighten: fns.lighten,
      darken: fns.darken,
      primaryShade: fns.primaryShade(themeBase),
      radius: fns.radius(themeBase),
      variant: fns.variant(themeBase),
      hover: fns.hover,
      primaryColor: fns.primaryColor(themeBase),
      placeholderStyles: fns.placeholderStyles(themeBase)
    }
  });
}


//# sourceMappingURL=attach-functions.js.map


/***/ }),

/***/ 66896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ filterProps; }
/* harmony export */ });
function filterProps(props) {
  return Object.keys(props).reduce((acc, key) => {
    if (props[key] !== void 0) {
      acc[key] = props[key];
    }
    return acc;
  }, {});
}


//# sourceMappingURL=filter-props.js.map


/***/ }),

/***/ 3594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ getDefaultZIndex; }
/* harmony export */ });
const elevations = {
  app: 100,
  modal: 200,
  popover: 300,
  overlay: 400,
  max: 9999
};
function getDefaultZIndex(level) {
  return elevations[level];
}


//# sourceMappingURL=get-default-z-index.js.map


/***/ }),

/***/ 56817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ createStyles; }
});

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/use-css.js + 3 modules
var use_css = __webpack_require__(55138);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/tss/utils/merge-class-names/merge-class-names.js
function mergeClassNames({
  cx,
  classes,
  context,
  classNames,
  name,
  cache
}) {
  const contextClassNames = context.reduce((acc, item) => {
    Object.keys(item.classNames).forEach((key) => {
      if (typeof acc[key] !== "string") {
        acc[key] = `${item.classNames[key]}`;
      } else {
        acc[key] = `${acc[key]} ${item.classNames[key]}`;
      }
    });
    return acc;
  }, {});
  return Object.keys(classes).reduce((acc, className) => {
    acc[className] = cx(classes[className], contextClassNames[className], classNames != null && classNames[className], Array.isArray(name) ? name.filter(Boolean).map((part) => `${(cache == null ? void 0 : cache.key) || "mantine"}-${part}-${className}`).join(" ") : name ? `${(cache == null ? void 0 : cache.key) || "mantine"}-${name}-${className}` : null);
    return acc;
  }, {});
}


//# sourceMappingURL=merge-class-names.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function createRef(refName) {
  return `__mantine-ref-${refName || ""}`;
}
function getStyles(styles, theme, params) {
  const extractStyles = (stylesPartial) => typeof stylesPartial === "function" ? stylesPartial(theme, params || {}) : stylesPartial || {};
  if (Array.isArray(styles)) {
    return styles.map((item) => extractStyles(item.styles)).reduce((acc, item) => {
      Object.keys(item).forEach((key) => {
        if (!acc[key]) {
          acc[key] = __spreadValues({}, item[key]);
        } else {
          acc[key] = __spreadValues(__spreadValues({}, acc[key]), item[key]);
        }
      });
      return acc;
    }, {});
  }
  return extractStyles(styles);
}
function createStyles(input) {
  const getCssObject = typeof input === "function" ? input : () => input;
  function useStyles(params, options) {
    const theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    const context = (0,MantineProvider/* useMantineProviderStyles */.O2)(options == null ? void 0 : options.name);
    const cache = (0,MantineProvider/* useMantineEmotionCache */.T1)();
    const { css, cx } = (0,use_css/* useCss */.Z)();
    const cssObject = getCssObject(theme, params, createRef);
    const componentStyles = getStyles(options == null ? void 0 : options.styles, theme, params);
    const providerStyles = getStyles(context, theme, params);
    const classes = Object.fromEntries(Object.keys(cssObject).map((key) => {
      const mergedStyles = cx({ [css(cssObject[key])]: !(options == null ? void 0 : options.unstyled) }, css(providerStyles[key]), css(componentStyles[key]));
      return [key, mergedStyles];
    }));
    return {
      classes: mergeClassNames({
        cx,
        classes,
        context,
        classNames: options == null ? void 0 : options.classNames,
        name: options == null ? void 0 : options.name,
        cache
      }),
      cx,
      theme
    };
  }
  return useStyles;
}


//# sourceMappingURL=create-styles.js.map


/***/ }),

/***/ 55138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCss; }
});

// UNUSED EXPORTS: cssFactory

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 2 modules
var emotion_serialize_browser_esm = __webpack_require__(48137);
// EXTERNAL MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(70444);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/tss/utils/use-guaranteed-memo/use-guaranteed-memo.js


function useGuaranteedMemo(fn, deps) {
  const ref = (0,react.useRef)();
  if (!ref.current || deps.length !== ref.current.prevDeps.length || ref.current.prevDeps.map((v, i) => v === deps[i]).indexOf(false) >= 0) {
    ref.current = {
      v: fn(),
      prevDeps: [...deps]
    };
  }
  return ref.current.v;
}


//# sourceMappingURL=use-guaranteed-memo.js.map

// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(8417);
;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/tss/default-emotion-cache.js


const defaultMantineEmotionCache = (0,emotion_cache_browser_esm/* default */.Z)({ key: "mantine", prepend: true });


//# sourceMappingURL=default-emotion-cache.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/tss/use-emotion-cache.js



function useEmotionCache() {
  const cache = (0,MantineProvider/* useMantineEmotionCache */.T1)();
  return cache || defaultMantineEmotionCache;
}


//# sourceMappingURL=use-emotion-cache.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/styles/esm/tss/use-css.js






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const refPropertyName = "ref";
function getRef(args) {
  let ref;
  if (args.length !== 1) {
    return { args, ref };
  }
  const [arg] = args;
  if (!(arg instanceof Object)) {
    return { args, ref };
  }
  if (!(refPropertyName in arg)) {
    return { args, ref };
  }
  ref = arg[refPropertyName];
  const argCopy = __spreadValues({}, arg);
  delete argCopy[refPropertyName];
  return { args: [argCopy], ref };
}
const { cssFactory } = (() => {
  function merge(registered, css, className) {
    const registeredStyles = [];
    const rawClassName = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) {
      return className;
    }
    return rawClassName + css(registeredStyles);
  }
  function _cssFactory(params) {
    const { cache } = params;
    const css = (...styles) => {
      const { ref, args } = getRef(styles);
      const serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(args, cache.registered);
      (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, false);
      return `${cache.key}-${serialized.name}${ref === void 0 ? "" : ` ${ref}`}`;
    };
    const cx = (...args) => merge(cache.registered, css, (0,clsx_m/* default */.Z)(args));
    return { css, cx };
  }
  return { cssFactory: _cssFactory };
})();
function useCss() {
  const cache = useEmotionCache();
  return useGuaranteedMemo(() => cssFactory({ cache }), [cache]);
}


//# sourceMappingURL=use-css.js.map


/***/ }),

/***/ 69328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ createEventHandler; }
/* harmony export */ });
function createEventHandler(parentEventHandler, eventHandler) {
  return (event) => {
    parentEventHandler == null ? void 0 : parentEventHandler(event);
    eventHandler == null ? void 0 : eventHandler(event);
  };
}


//# sourceMappingURL=create-event-handler.js.map


/***/ }),

/***/ 48427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ createPolymorphicComponent; }
/* harmony export */ });
function createPolymorphicComponent(component) {
  return component;
}


//# sourceMappingURL=create-polymorphic-component.js.map


/***/ }),

/***/ 68216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ createSafeContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function createSafeContext(errorMessage) {
  const Context = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
  const useSafeContext = () => {
    const ctx = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context);
    if (ctx === null) {
      throw new Error(errorMessage);
    }
    return ctx;
  };
  const Provider = ({ children, value }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context.Provider, {
    value
  }, children);
  return [Provider, useSafeContext];
}


//# sourceMappingURL=create-safe-context.js.map


/***/ }),

/***/ 16650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ createScopedKeydownHandler; }
/* harmony export */ });
/* harmony import */ var _find_element_ancestor_find_element_ancestor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38523);


function getPreviousIndex(current, elements, loop) {
  for (let i = current - 1; i >= 0; i -= 1) {
    if (!elements[i].disabled) {
      return i;
    }
  }
  if (loop) {
    for (let i = elements.length - 1; i > -1; i -= 1) {
      if (!elements[i].disabled) {
        return i;
      }
    }
  }
  return current;
}
function getNextIndex(current, elements, loop) {
  for (let i = current + 1; i < elements.length; i += 1) {
    if (!elements[i].disabled) {
      return i;
    }
  }
  if (loop) {
    for (let i = 0; i < elements.length; i += 1) {
      if (!elements[i].disabled) {
        return i;
      }
    }
  }
  return current;
}
function onSameLevel(target, sibling, parentSelector) {
  return (0,_find_element_ancestor_find_element_ancestor_js__WEBPACK_IMPORTED_MODULE_0__/* .findElementAncestor */ .p)(target, parentSelector) === (0,_find_element_ancestor_find_element_ancestor_js__WEBPACK_IMPORTED_MODULE_0__/* .findElementAncestor */ .p)(sibling, parentSelector);
}
function createScopedKeydownHandler({
  parentSelector,
  siblingSelector,
  onKeyDown,
  loop = true,
  activateOnFocus = false,
  dir = "rtl",
  orientation
}) {
  return (event) => {
    var _a;
    onKeyDown == null ? void 0 : onKeyDown(event);
    const elements = Array.from(((_a = (0,_find_element_ancestor_find_element_ancestor_js__WEBPACK_IMPORTED_MODULE_0__/* .findElementAncestor */ .p)(event.currentTarget, parentSelector)) == null ? void 0 : _a.querySelectorAll(siblingSelector)) || []).filter((node) => onSameLevel(event.currentTarget, node, parentSelector));
    const current = elements.findIndex((el) => event.currentTarget === el);
    const _nextIndex = getNextIndex(current, elements, loop);
    const _previousIndex = getPreviousIndex(current, elements, loop);
    const nextIndex = dir === "rtl" ? _previousIndex : _nextIndex;
    const previousIndex = dir === "rtl" ? _nextIndex : _previousIndex;
    switch (event.key) {
      case "ArrowRight": {
        if (orientation === "horizontal") {
          event.stopPropagation();
          event.preventDefault();
          elements[nextIndex].focus();
          activateOnFocus && elements[nextIndex].click();
        }
        break;
      }
      case "ArrowLeft": {
        if (orientation === "horizontal") {
          event.stopPropagation();
          event.preventDefault();
          elements[previousIndex].focus();
          activateOnFocus && elements[previousIndex].click();
        }
        break;
      }
      case "ArrowUp": {
        if (orientation === "vertical") {
          event.stopPropagation();
          event.preventDefault();
          elements[_previousIndex].focus();
          activateOnFocus && elements[_previousIndex].click();
        }
        break;
      }
      case "ArrowDown": {
        if (orientation === "vertical") {
          event.stopPropagation();
          event.preventDefault();
          elements[_nextIndex].focus();
          activateOnFocus && elements[_nextIndex].click();
        }
        break;
      }
      case "Home": {
        event.stopPropagation();
        event.preventDefault();
        !elements[0].disabled && elements[0].focus();
        break;
      }
      case "End": {
        event.stopPropagation();
        event.preventDefault();
        const last = elements.length - 1;
        !elements[last].disabled && elements[last].focus();
        break;
      }
    }
  };
}


//# sourceMappingURL=create-scoped-keydown-handler.js.map


/***/ }),

/***/ 38523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ findElementAncestor; }
/* harmony export */ });
function findElementAncestor(element, selector) {
  let _element = element;
  while ((_element = _element.parentElement) && !_element.matches(selector))
    ;
  return _element;
}


//# sourceMappingURL=find-element-ancestor.js.map


/***/ }),

/***/ 24241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ isElement; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function isElement(value) {
  if (Array.isArray(value) || value === null) {
    return false;
  }
  if (typeof value === "object") {
    if (value.type === react__WEBPACK_IMPORTED_MODULE_0__.Fragment) {
      return false;
    }
    return true;
  }
  return false;
}


//# sourceMappingURL=is-element.js.map


/***/ }),

/***/ 97818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ packSx; }
/* harmony export */ });
function packSx(sx) {
  return Array.isArray(sx) ? sx : [sx];
}


//# sourceMappingURL=pack-sx.js.map


/***/ }),

/***/ 45609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.Z = function AiFillBank (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 1024 1024"},"child":[{"tag":"path","attr":{"d":"M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z"}}]})(props);
};


/***/ }),

/***/ 92613:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.s = function AiFillFacebook (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 1024 1024"},"child":[{"tag":"path","attr":{"d":"M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z"}}]})(props);
};


/***/ }),

/***/ 11574:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.t = function AiFillInstagram (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 1024 1024"},"child":[{"tag":"path","attr":{"d":"M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 0 1-47.9 47.9z"}}]})(props);
};


/***/ }),

/***/ 50081:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.U = function AiFillMail (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 1024 1024"},"child":[{"tag":"path","attr":{"d":"M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-80.8 108.9L531.7 514.4c-7.8 6.1-18.7 6.1-26.5 0L189.6 268.9A7.2 7.2 0 0 1 194 256h648.8a7.2 7.2 0 0 1 4.4 12.9z"}}]})(props);
};


/***/ }),

/***/ 95627:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.J = function AiFillWallet (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 1024 1024"},"child":[{"tag":"path","attr":{"d":"M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 464H528V448h320v128zm-268-64a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"}}]})(props);
};


/***/ }),

/***/ 9217:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.b = function AiFillYoutube (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 1024 1024"},"child":[{"tag":"path","attr":{"d":"M941.3 296.1a112.3 112.3 0 0 0-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0 0 82.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z"}}]})(props);
};


/***/ }),

/***/ 56009:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.V = function AiOutlineDelete (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 1024 1024"},"child":[{"tag":"path","attr":{"d":"M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"}}]})(props);
};


/***/ }),

/***/ 56570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.H = function BsFillPersonFill (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 16 16","fill":"currentColor"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 100-6 3 3 0 000 6z","clipRule":"evenodd"}}]})(props);
};


/***/ }),

/***/ 60783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.w = function FaHandHoldingUsd (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"}}]})(props);
};


/***/ }),

/***/ 87088:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.b = function FiAlertCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"circle","attr":{"cx":"12","cy":"12","r":"10"}},{"tag":"line","attr":{"x1":"12","y1":"8","x2":"12","y2":"12"}},{"tag":"line","attr":{"x1":"12","y1":"16","x2":"12.01","y2":"16"}}]})(props);
};


/***/ }),

/***/ 38750:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.v = function FiBell (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"}},{"tag":"path","attr":{"d":"M13.73 21a2 2 0 0 1-3.46 0"}}]})(props);
};


/***/ }),

/***/ 137:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.U = function FiCheck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"polyline","attr":{"points":"20 6 9 17 4 12"}}]})(props);
};


/***/ }),

/***/ 40703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.e = function FiMinus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"line","attr":{"x1":"5","y1":"12","x2":"19","y2":"12"}}]})(props);
};


/***/ }),

/***/ 24752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.O = function FiPlus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"line","attr":{"x1":"12","y1":"5","x2":"12","y2":"19"}},{"tag":"line","attr":{"x1":"5","y1":"12","x2":"19","y2":"12"}}]})(props);
};


/***/ }),

/***/ 29707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.q = function FiX (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"line","attr":{"x1":"18","y1":"6","x2":"6","y2":"18"}},{"tag":"line","attr":{"x1":"6","y1":"6","x2":"18","y2":"18"}}]})(props);
};


/***/ }),

/***/ 15787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/refactoringui/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var computedSize = props.size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;

    var attr = props.attr,
        title = props.title,
        svgProps = __rest(props, ["attr", "title"]);

    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/index.js




/***/ }),

/***/ 67444:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.G = function RiDeleteBin6Line (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"none","d":"M0 0h24v24H0z"}},{"tag":"path","attr":{"d":"M7 4V2h10v2h5v2h-2v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6H2V4h5zM6 6v14h12V6H6zm3 3h2v8H9V9zm4 0h2v8h-2V9z"}}]}]})(props);
};


/***/ }),

/***/ 67578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.C = function RiShoppingBag2Line (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"none","d":"M0 0h24v24H0z"}},{"tag":"path","attr":{"d":"M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1zm-1-2V4H5v16h14zM9 6v2a3 3 0 0 0 6 0V6h2v2A5 5 0 0 1 7 8V6h2z"}}]}]})(props);
};


/***/ }),

/***/ 72545:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.x = function RiShoppingBag3Fill (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"none","d":"M0 0h24v24H0z"}},{"tag":"path","attr":{"d":"M6.5 2h11a1 1 0 0 1 .8.4L21 6v15a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6l2.7-3.6a1 1 0 0 1 .8-.4zm12 4L17 4H7L5.5 6h13zM9 10H7v2a5 5 0 0 0 10 0v-2h-2v2a3 3 0 0 1-6 0v-2z"}}]}]})(props);
};


/***/ }),

/***/ 79361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 79742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 48764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__(79742)
const ieee754 = __webpack_require__(80645)
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

const K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ 86010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
}


/***/ }),

/***/ 99960:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */
var ElementType;
(function (ElementType) {
    /** Type for the root element of a document */
    ElementType["Root"] = "root";
    /** Type for Text */
    ElementType["Text"] = "text";
    /** Type for <? ... ?> */
    ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */
    ElementType["Comment"] = "comment";
    /** Type for <script> tags */
    ElementType["Script"] = "script";
    /** Type for <style> tags */
    ElementType["Style"] = "style";
    /** Type for Any tag */
    ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */
    ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */
    ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === ElementType.Tag ||
        elem.type === ElementType.Script ||
        elem.type === ElementType.Style);
}
exports.isTag = isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */
exports.Root = ElementType.Root;
/** Type for Text */
exports.Text = ElementType.Text;
/** Type for <? ... ?> */
exports.Directive = ElementType.Directive;
/** Type for <!-- ... --> */
exports.Comment = ElementType.Comment;
/** Type for <script> tags */
exports.Script = ElementType.Script;
/** Type for <style> tags */
exports.Style = ElementType.Style;
/** Type for Any tag */
exports.Tag = ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */
exports.CDATA = ElementType.CDATA;
/** Type for <!doctype ...> */
exports.Doctype = ElementType.Doctype;


/***/ }),

/***/ 27856:
/***/ (function(module) {

/*! @license DOMPurify 2.4.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.3/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  0;
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }
  /* Add properties to a lookup table */

  function addToSet(set, array, transformCaseFunc) {
    transformCaseFunc = transformCaseFunc ? transformCaseFunc : stringToLowerCase;

    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;

    while (l--) {
      var element = array[l];

      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);

        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }
  /* Shallow clone an object */

  function clone(object) {
    var newObject = create(null);
    var property;

    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }
  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */

  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);

      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.

  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']); // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.

  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };
  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */


  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    } // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.


    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';

    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };
    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */


    DOMPurify.version = '2.4.3';
    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */

    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }

    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.

    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');

      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);

    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};

    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};
    /**
     * Expose whether this browser supports running the full DOMPurify.
     */

    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        TMPLIT_EXPR$1 = TMPLIT_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
    /* Allowed attribute names */

    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */

    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

    var FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

    var FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */

    var ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */

    var ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */

    var ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */

    var SAFE_FOR_TEMPLATES = false;
    /* Decide if document with <html>... should be returned */

    var WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */

    var SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */

    var FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */

    var RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */

    var RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */

    var RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */

    var SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */

    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */

    var KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */

    var IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */

    var USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */

    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
    /* Tags that are safe for data: URIs */

    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
    /* Attributes safe for values like "javascript:" */

    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */

    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */

    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
    /* Parsing of strict XHTML documents */

    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;
    /* Keep a reference to config to pass to hooks */

    var CONFIG = null;
    /* Ideally, do not touch anything below this line */

    /* ______________________________________________ */

    var formElement = document.createElement('form');

    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity


    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }
      /* Shield configuration object from tampering */


      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }
      /* Shield configuration object from prototype pollution */


      cfg = clone(cfg);
      PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
      /* Set configuration parameters */

      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

      RETURN_DOM = cfg.RETURN_DOM || false; // Default false

      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

      FORCE_BODY = cfg.FORCE_BODY || false; // Default false

      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

      IN_PLACE = cfg.IN_PLACE || false; // Default false

      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }
      /* Parse profile info */


      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];

        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }
      /* Merge configuration parameters */


      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }
      /* Add #text in case KEEP_CONTENT is set to true */


      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }
      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }
      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      } // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.


      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.

    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */

    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */

    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.

      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        } // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.


        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        } // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.


        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        } // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points


        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        } // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.


        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        } // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace


        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      } // For XHTML and XML documents that support custom namespaces


      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      } // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.


      return false;
    };
    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */


    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });

      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };
    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */


    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };
    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */


    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */

      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }
      /* Use createHTMLDocument in case DOMParser is not available */


      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);

        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {// Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }
      /* Work on whole document or just its body */


      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */


    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };
    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */


    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };
    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */


    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };
    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */


    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };
    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */


    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeElements', currentNode, null);
      /* Check if element is clobbered or can clobber */


      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Check if tagname contains Unicode */


      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Now let's check the element's type and name */


      var tagName = transformCaseFunc(currentNode.nodeName);
      /* Execute a hook if present */

      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });
      /* Detect mXSS attempts abusing namespace confusion */


      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Mitigate a problem with templates inside select */


      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Remove element if anything forbids its presence */


      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements */


        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);

        return true;
      }
      /* Check whether element has a valid namespace */


      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }

      if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Sanitize element content to be template-safe */


      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');

        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };
    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity


    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }
      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */


      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */

      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (!value) ; else {
        return false;
      }

      return true;
    };
    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */


    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName.indexOf('-') > 0;
    };
    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */


    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;
      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;
      /* Go backwards over all attributes; safely remove bad ones */

      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);
        /* Execute a hook if present */

        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */

        if (hookEvent.forceKeepAttr) {
          continue;
        }
        /* Remove attribute */


        _removeAttribute(name, currentNode);
        /* Did the hooks approve of the attribute? */


        if (!hookEvent.keepAttr) {
          continue;
        }
        /* Work around a security issue in jQuery 3.0 */


        if (regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);

          continue;
        }
        /* Sanitize attribute content to be template-safe */


        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }
        /* Is `value` valid for this attribute? */


        var lcTag = transformCaseFunc(currentNode.nodeName);

        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }
        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */


        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }
        /* Handle attributes that require Trusted Types */


        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                value = trustedTypesPolicy.createHTML(value);
                break;

              case 'TrustedScriptURL':
                value = trustedTypesPolicy.createScriptURL(value);
                break;
            }
          }
        }
        /* Handle invalid data-* attribute set by try-catching it */


        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeAttributes', currentNode, null);
    };
    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */


    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;

      var shadowIterator = _createIterator(fragment);
      /* Execute a hook if present */


      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */


        if (_sanitizeElements(shadowNode)) {
          continue;
        }
        /* Deep shadow DOM detected */


        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(shadowNode);
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };
    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity


    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */

      IS_EMPTY_INPUT = !dirty;

      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }
      /* Stringify, in case dirty is an object */


      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();

          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }
      /* Check we can run. Otherwise fall back or ignore */


      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }
      /* Assign config vars */


      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }
      /* Clean up removed elements */


      DOMPurify.removed = [];
      /* Check if dirty is correctly typed for IN_PLACE */

      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);

          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);

        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }
        /* Initialize the document to work on */


        body = _initDocument(dirty);
        /* Check we have a DOM node from the data */

        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }
      /* Remove first element node (ours) if FORCE_BODY is set */


      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }
      /* Get node iterator */


      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
      /* Now start iterating over the created document */


      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }
        /* Sanitize tags and elements */


        if (_sanitizeElements(currentNode)) {
          continue;
        }
        /* Shadow DOM detected, sanitize it */


        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;
      /* If we sanitized `dirty` in-place, return it. */

      if (IN_PLACE) {
        return dirty;
      }
      /* Return sanitized string or DOM */


      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (ALLOWED_ATTR.shadowroot) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
      /* Serialize doctype if allowed */

      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }
      /* Sanitize final string template-safe */


      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */


    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);

      SET_CONFIG = true;
    };
    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */


    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };
    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */


    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };
    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */


    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };
    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */


    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };
    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */


    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };
    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */


    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ 64063:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(59864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 60885:
/***/ (function(__unused_webpack_module, exports) {

/**
 * SVG elements are case-sensitive.
 *
 * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#svg_elements_a_to_z}
 */
exports.CASE_SENSITIVE_TAG_NAMES = [
  'animateMotion',
  'animateTransform',
  'clipPath',
  'feBlend',
  'feColorMatrix',
  'feComponentTransfer',
  'feComposite',
  'feConvolveMatrix',
  'feDiffuseLighting',
  'feDisplacementMap',
  'feDropShadow',
  'feFlood',
  'feFuncA',
  'feFuncB',
  'feFuncG',
  'feFuncR',
  'feGaussainBlur',
  'feImage',
  'feMerge',
  'feMergeNode',
  'feMorphology',
  'feOffset',
  'fePointLight',
  'feSpecularLighting',
  'feSpotLight',
  'feTile',
  'feTurbulence',
  'foreignObject',
  'linearGradient',
  'radialGradient',
  'textPath'
];


/***/ }),

/***/ 38276:
/***/ (function(module) {

// constants
var HTML = 'html';
var HEAD = 'head';
var BODY = 'body';
var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
// match-all-characters in case of newlines (DOTALL)
var HEAD_TAG_REGEX = /<head[^]*>/i;
var BODY_TAG_REGEX = /<body[^]*>/i;

// falls back to `parseFromString` if `createHTMLDocument` cannot be used
var parseFromDocument = function () {
  throw new Error(
    'This browser does not support `document.implementation.createHTMLDocument`'
  );
};

var parseFromString = function () {
  throw new Error(
    'This browser does not support `DOMParser.prototype.parseFromString`'
  );
};

var DOMParser = typeof window === 'object' && window.DOMParser;

/**
 * DOMParser (performance: slow).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */
if (typeof DOMParser === 'function') {
  var domParser = new DOMParser();
  var mimeType = 'text/html';

  /**
   * Creates an HTML document using `DOMParser.parseFromString`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */
  parseFromString = function (html, tagName) {
    if (tagName) {
      html = '<' + tagName + '>' + html + '</' + tagName + '>';
    }

    return domParser.parseFromString(html, mimeType);
  };

  parseFromDocument = parseFromString;
}

/**
 * DOMImplementation (performance: fair).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */
if (typeof document === 'object' && document.implementation) {
  var doc = document.implementation.createHTMLDocument();

  /**
   * Use HTML document created by `document.implementation.createHTMLDocument`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */
  parseFromDocument = function (html, tagName) {
    if (tagName) {
      var element = doc.documentElement.querySelector(tagName);
      element.innerHTML = html;
      return doc;
    }

    doc.documentElement.innerHTML = html;
    return doc;
  };
}

/**
 * Template (performance: fast).
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
 */
var template =
  typeof document === 'object' ? document.createElement('template') : {};

var parseFromTemplate;

if (template.content) {
  /**
   * Uses a template element (content fragment) to parse HTML.
   *
   * @param  {string} html - The HTML string.
   * @return {NodeList}
   */
  parseFromTemplate = function (html) {
    template.innerHTML = html;
    return template.content.childNodes;
  };
}

/**
 * Parses HTML string to DOM nodes.
 *
 * @param  {string}   html - HTML markup.
 * @return {NodeList}
 */
function domparser(html) {
  var firstTagName;
  var match = html.match(FIRST_TAG_REGEX);

  if (match && match[1]) {
    firstTagName = match[1].toLowerCase();
  }

  var doc;
  var element;
  var elements;

  switch (firstTagName) {
    case HTML:
      doc = parseFromString(html);

      // the created document may come with filler head/body elements,
      // so make sure to remove them if they don't actually exist
      if (!HEAD_TAG_REGEX.test(html)) {
        element = doc.querySelector(HEAD);
        if (element) {
          element.parentNode.removeChild(element);
        }
      }

      if (!BODY_TAG_REGEX.test(html)) {
        element = doc.querySelector(BODY);
        if (element) {
          element.parentNode.removeChild(element);
        }
      }

      return doc.querySelectorAll(HTML);

    case HEAD:
    case BODY:
      doc = parseFromDocument(html);
      elements = doc.querySelectorAll(firstTagName);

      // if there's a sibling element, then return both elements
      if (BODY_TAG_REGEX.test(html) && HEAD_TAG_REGEX.test(html)) {
        return elements[0].parentNode.childNodes;
      }
      return elements;

    // low-level tag or text
    default:
      if (parseFromTemplate) {
        return parseFromTemplate(html);
      }
      element = parseFromDocument(html, BODY).querySelector(BODY);
      return element.childNodes;
  }
}

module.exports = domparser;


/***/ }),

/***/ 14152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var domparser = __webpack_require__(38276);
var utilities = __webpack_require__(1507);

var formatDOM = utilities.formatDOM;

var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>

/**
 * Parses HTML string to DOM nodes in browser.
 *
 * @param  {string} html  - HTML markup.
 * @return {DomElement[]} - DOM elements.
 */
function HTMLDOMParser(html) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (html === '') {
    return [];
  }

  // match directive
  var match = html.match(DIRECTIVE_REGEX);
  var directive;

  if (match && match[1]) {
    directive = match[1];
  }

  return formatDOM(domparser(html), null, directive);
}

module.exports = HTMLDOMParser;


/***/ }),

/***/ 1507:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var domhandler = __webpack_require__(44584);
var constants = __webpack_require__(60885);

var CASE_SENSITIVE_TAG_NAMES = constants.CASE_SENSITIVE_TAG_NAMES;

var Comment = domhandler.Comment;
var Element = domhandler.Element;
var ProcessingInstruction = domhandler.ProcessingInstruction;
var Text = domhandler.Text;

var caseSensitiveTagNamesMap = {};
var tagName;

for (var i = 0, len = CASE_SENSITIVE_TAG_NAMES.length; i < len; i++) {
  tagName = CASE_SENSITIVE_TAG_NAMES[i];
  caseSensitiveTagNamesMap[tagName.toLowerCase()] = tagName;
}

/**
 * Gets case-sensitive tag name.
 *
 * @param {string} tagName - Tag name in lowercase.
 * @returns {string|undefined} - Case-sensitive tag name.
 */
function getCaseSensitiveTagName(tagName) {
  return caseSensitiveTagNamesMap[tagName];
}

/**
 * Formats DOM attributes to a hash map.
 *
 * @param {NamedNodeMap} attributes - List of attributes.
 * @returns {object} - Map of attribute name to value.
 */
function formatAttributes(attributes) {
  var result = {};
  var attribute;
  // `NamedNodeMap` is array-like
  for (var i = 0, len = attributes.length; i < len; i++) {
    attribute = attributes[i];
    result[attribute.name] = attribute.value;
  }
  return result;
}

/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param {string} tagName - Lowercase tag name.
 * @returns {string} - Formatted tag name.
 */
function formatTagName(tagName) {
  tagName = tagName.toLowerCase();
  var caseSensitiveTagName = getCaseSensitiveTagName(tagName);
  if (caseSensitiveTagName) {
    return caseSensitiveTagName;
  }
  return tagName;
}

/**
 * Transforms DOM nodes to `domhandler` nodes.
 *
 * @param {NodeList} nodes - DOM nodes.
 * @param {Element|null} [parent=null] - Parent node.
 * @param {string} [directive] - Directive.
 * @returns {Array<Comment|Element|ProcessingInstruction|Text>}
 */
function formatDOM(nodes, parent, directive) {
  parent = parent || null;
  var result = [];

  for (var index = 0, len = nodes.length; index < len; index++) {
    var node = nodes[index];
    var current;

    // set the node data given the type
    switch (node.nodeType) {
      case 1:
        // script, style, or tag
        current = new Element(
          formatTagName(node.nodeName),
          formatAttributes(node.attributes)
        );
        current.children = formatDOM(node.childNodes, current);
        break;

      case 3:
        current = new Text(node.nodeValue);
        break;

      case 8:
        current = new Comment(node.nodeValue);
        break;

      default:
        continue;
    }

    // set previous node next
    var prev = result[index - 1] || null;
    if (prev) {
      prev.next = current;
    }

    // set properties for current node
    current.parent = parent;
    current.prev = prev;
    current.next = null;

    result.push(current);
  }

  if (directive) {
    current = new ProcessingInstruction(
      directive.substring(0, directive.indexOf(' ')).toLowerCase(),
      directive
    );
    current.next = result[0] || null;
    current.parent = parent;
    result.unshift(current);

    if (result[1]) {
      result[1].prev = result[0];
    }
  }

  return result;
}

exports.formatAttributes = formatAttributes;
exports.formatDOM = formatDOM;


/***/ }),

/***/ 44584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DomHandler = void 0;
var domelementtype_1 = __webpack_require__(99960);
var node_js_1 = __webpack_require__(21642);
__exportStar(__webpack_require__(21642), exports);
// Default options
var defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false,
};
var DomHandler = /** @class */ (function () {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */
    function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */
        this.dom = [];
        /** The root element for the DOM */
        this.root = new node_js_1.Document(this.dom);
        /** Indicated whether parsing has been completed. */
        this.done = false;
        /** Stack of open tags. */
        this.tagStack = [this.root];
        /** A data node that is still being written to. */
        this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */
        this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function (parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function () {
        this.dom = [];
        this.root = new node_js_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function () {
        if (this.done)
            return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function (error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function () {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
            this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function (name, attribs) {
        var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
        var element = new node_js_1.Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function (data) {
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) {
                lastNode.endIndex = this.parser.endIndex;
            }
        }
        else {
            var node = new node_js_1.Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function (data) {
        if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new node_js_1.Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function () {
        var text = new node_js_1.Text("");
        var node = new node_js_1.CDATA([text]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function (name, data) {
        var node = new node_js_1.ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function (error) {
        if (typeof this.callback === "function") {
            this.callback(error, this.dom);
        }
        else if (error) {
            throw error;
        }
    };
    DomHandler.prototype.addNode = function (node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
            node.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
            node.endIndex = this.parser.endIndex;
        }
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}());
exports.DomHandler = DomHandler;
exports["default"] = DomHandler;


/***/ }),

/***/ 21642:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cloneNode = exports.hasChildren = exports.isDocument = exports.isDirective = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = exports.Element = exports.Document = exports.CDATA = exports.NodeWithChildren = exports.ProcessingInstruction = exports.Comment = exports.Text = exports.DataNode = exports.Node = void 0;
var domelementtype_1 = __webpack_require__(99960);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
var Node = /** @class */ (function () {
    function Node() {
        /** Parent of the node */
        this.parent = null;
        /** Previous sibling */
        this.prev = null;
        /** Next sibling */
        this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
        this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
        this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.parent;
        },
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.prev;
        },
        set: function (prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.next;
        },
        set: function (next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */
    Node.prototype.cloneNode = function (recursive) {
        if (recursive === void 0) { recursive = false; }
        return cloneNode(this, recursive);
    };
    return Node;
}());
exports.Node = Node;
/**
 * A node that contains some data.
 */
var DataNode = /** @class */ (function (_super) {
    __extends(DataNode, _super);
    /**
     * @param data The content of the data node
     */
    function DataNode(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.data;
        },
        set: function (data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}(Node));
exports.DataNode = DataNode;
/**
 * Text within the document.
 */
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Text;
        return _this;
    }
    Object.defineProperty(Text.prototype, "nodeType", {
        get: function () {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    return Text;
}(DataNode));
exports.Text = Text;
/**
 * Comments within the document.
 */
var Comment = /** @class */ (function (_super) {
    __extends(Comment, _super);
    function Comment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Comment;
        return _this;
    }
    Object.defineProperty(Comment.prototype, "nodeType", {
        get: function () {
            return 8;
        },
        enumerable: false,
        configurable: true
    });
    return Comment;
}(DataNode));
exports.Comment = Comment;
/**
 * Processing instructions, including doc types.
 */
var ProcessingInstruction = /** @class */ (function (_super) {
    __extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, data) || this;
        _this.name = name;
        _this.type = domelementtype_1.ElementType.Directive;
        return _this;
    }
    Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return ProcessingInstruction;
}(DataNode));
exports.ProcessingInstruction = ProcessingInstruction;
/**
 * A `Node` that can have children.
 */
var NodeWithChildren = /** @class */ (function (_super) {
    __extends(NodeWithChildren, _super);
    /**
     * @param children Children of the node. Only certain node types can have children.
     */
    function NodeWithChildren(children) {
        var _this = _super.call(this) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function () {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */
        get: function () {
            return this.children.length > 0
                ? this.children[this.children.length - 1]
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.children;
        },
        set: function (children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}(Node));
exports.NodeWithChildren = NodeWithChildren;
var CDATA = /** @class */ (function (_super) {
    __extends(CDATA, _super);
    function CDATA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.CDATA;
        return _this;
    }
    Object.defineProperty(CDATA.prototype, "nodeType", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    return CDATA;
}(NodeWithChildren));
exports.CDATA = CDATA;
/**
 * The root node of the document.
 */
var Document = /** @class */ (function (_super) {
    __extends(Document, _super);
    function Document() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Root;
        return _this;
    }
    Object.defineProperty(Document.prototype, "nodeType", {
        get: function () {
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    return Document;
}(NodeWithChildren));
exports.Document = Document;
/**
 * An element within the DOM.
 */
var Element = /** @class */ (function (_super) {
    __extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */
    function Element(name, attribs, children, type) {
        if (children === void 0) { children = []; }
        if (type === void 0) { type = name === "script"
            ? domelementtype_1.ElementType.Script
            : name === "style"
                ? domelementtype_1.ElementType.Style
                : domelementtype_1.ElementType.Tag; }
        var _this = _super.call(this, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        _this.type = type;
        return _this;
    }
    Object.defineProperty(Element.prototype, "nodeType", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.name;
        },
        set: function (name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function () {
            var _this = this;
            return Object.keys(this.attribs).map(function (name) {
                var _a, _b;
                return ({
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}(NodeWithChildren));
exports.Element = Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
function isTag(node) {
    return (0, domelementtype_1.isTag)(node);
}
exports.isTag = isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
function isCDATA(node) {
    return node.type === domelementtype_1.ElementType.CDATA;
}
exports.isCDATA = isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
function isText(node) {
    return node.type === domelementtype_1.ElementType.Text;
}
exports.isText = isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
function isComment(node) {
    return node.type === domelementtype_1.ElementType.Comment;
}
exports.isComment = isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDirective(node) {
    return node.type === domelementtype_1.ElementType.Directive;
}
exports.isDirective = isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDocument(node) {
    return node.type === domelementtype_1.ElementType.Root;
}
exports.isDocument = isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
exports.hasChildren = hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function cloneNode(node, recursive) {
    if (recursive === void 0) { recursive = false; }
    var result;
    if (isText(node)) {
        result = new Text(node.data);
    }
    else if (isComment(node)) {
        result = new Comment(node.data);
    }
    else if (isTag(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_1 = new Element(node.name, __assign({}, node.attribs), children);
        children.forEach(function (child) { return (child.parent = clone_1); });
        if (node.namespace != null) {
            clone_1.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
            clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
        }
        if (node["x-attribsPrefix"]) {
            clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
        }
        result = clone_1;
    }
    else if (isCDATA(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_2 = new CDATA(children);
        children.forEach(function (child) { return (child.parent = clone_2); });
        result = clone_2;
    }
    else if (isDocument(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_3 = new Document(children);
        children.forEach(function (child) { return (child.parent = clone_3); });
        if (node["x-mode"]) {
            clone_3["x-mode"] = node["x-mode"];
        }
        result = clone_3;
    }
    else if (isDirective(node)) {
        var instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    }
    else {
        throw new Error("Not implemented yet: ".concat(node.type));
    }
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
    }
    return result;
}
exports.cloneNode = cloneNode;
function cloneChildren(childs) {
    var children = childs.map(function (child) { return cloneNode(child, true); });
    for (var i = 1; i < children.length; i++) {
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}


/***/ }),

/***/ 30488:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var domhandler = __webpack_require__(87384);
var htmlToDOM = __webpack_require__(14152);

var attributesToProps = __webpack_require__(50484);
var domToReact = __webpack_require__(53670);

// support backwards compatibility for ES Module
htmlToDOM =
  /* istanbul ignore next */
  typeof htmlToDOM.default === 'function' ? htmlToDOM.default : htmlToDOM;

var domParserOptions = { lowerCaseAttributeNames: false };

/**
 * Converts HTML string to React elements.
 *
 * @param {string} html - HTML string.
 * @param {object} [options] - Parser options.
 * @param {object} [options.htmlparser2] - htmlparser2 options.
 * @param {object} [options.library] - Library for React, Preact, etc.
 * @param {Function} [options.replace] - Replace method.
 * @returns {JSX.Element|JSX.Element[]|string} - React element(s), empty array, or string.
 */
function HTMLReactParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (html === '') {
    return [];
  }
  options = options || {};
  return domToReact(
    htmlToDOM(html, options.htmlparser2 || domParserOptions),
    options
  );
}

HTMLReactParser.domToReact = domToReact;
HTMLReactParser.htmlToDOM = htmlToDOM;
HTMLReactParser.attributesToProps = attributesToProps;

// domhandler
HTMLReactParser.Comment = domhandler.Comment;
HTMLReactParser.Element = domhandler.Element;
HTMLReactParser.ProcessingInstruction = domhandler.ProcessingInstruction;
HTMLReactParser.Text = domhandler.Text;

// support CommonJS and ES Modules
module.exports = HTMLReactParser;
module.exports["default"] = HTMLReactParser;


/***/ }),

/***/ 50484:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var reactProperty = __webpack_require__(25726);
var utilities = __webpack_require__(74606);

/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param {object} [attributes={}] - HTML/SVG DOM attributes.
 * @param {string} [nodeName] - DOM node name.
 * @returns - React props.
 */
module.exports = function attributesToProps(attributes, nodeName) {
  attributes = attributes || {};

  var valueOnlyInputs = {
    reset: true,
    submit: true
  };

  var attributeName;
  var attributeNameLowerCased;
  var attributeValue;
  var propName;
  var propertyInfo;
  var props = {};
  var inputIsValueOnly = attributes.type && valueOnlyInputs[attributes.type];

  for (attributeName in attributes) {
    attributeValue = attributes[attributeName];

    // ARIA (aria-*) or custom data (data-*) attribute
    if (reactProperty.isCustomAttribute(attributeName)) {
      props[attributeName] = attributeValue;
      continue;
    }

    // convert HTML/SVG attribute to React prop
    attributeNameLowerCased = attributeName.toLowerCase();
    propName = getPropName(attributeNameLowerCased);

    if (propName) {
      propertyInfo = reactProperty.getPropertyInfo(propName);

      // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
      // https://reactjs.org/docs/uncontrolled-components.html
      if (
        (propName === 'checked' || propName === 'value') &&
        nodeName !== 'option' &&
        !inputIsValueOnly
      ) {
        propName = getPropName('default' + attributeNameLowerCased);
      }

      props[propName] = attributeValue;

      switch (propertyInfo && propertyInfo.type) {
        case reactProperty.BOOLEAN:
          props[propName] = true;
          break;
        case reactProperty.OVERLOADED_BOOLEAN:
          if (attributeValue === '') {
            props[propName] = true;
          }
          break;
      }
      continue;
    }

    // preserve custom attribute if React >=16
    if (utilities.PRESERVE_CUSTOM_ATTRIBUTES) {
      props[attributeName] = attributeValue;
    }
  }

  // transform inline style to object
  utilities.setStyleProp(attributes.style, props);

  return props;
};

/**
 * Gets prop name from lowercased attribute name.
 *
 * @param {string} attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */
function getPropName(attributeName) {
  return reactProperty.possibleStandardNames[attributeName];
}


/***/ }),

/***/ 53670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(67294);
var attributesToProps = __webpack_require__(50484);
var utilities = __webpack_require__(74606);

var setStyleProp = utilities.setStyleProp;
var canTextBeChildOfNode = utilities.canTextBeChildOfNode;

/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param {DomElement[]} nodes - DOM nodes.
 * @param {object} [options={}] - Options.
 * @param {Function} [options.replace] - Replacer.
 * @param {object} [options.library] - Library (React, Preact, etc.).
 * @returns - String or JSX element(s).
 */
function domToReact(nodes, options) {
  options = options || {};

  var library = options.library || React;
  var cloneElement = library.cloneElement;
  var createElement = library.createElement;
  var isValidElement = library.isValidElement;

  var result = [];
  var node;
  var isWhitespace;
  var hasReplace = typeof options.replace === 'function';
  var replaceElement;
  var props;
  var children;
  var trim = options.trim;

  for (var i = 0, len = nodes.length; i < len; i++) {
    node = nodes[i];

    // replace with custom React element (if present)
    if (hasReplace) {
      replaceElement = options.replace(node);

      if (isValidElement(replaceElement)) {
        // set "key" prop for sibling elements
        // https://fb.me/react-warning-keys
        if (len > 1) {
          replaceElement = cloneElement(replaceElement, {
            key: replaceElement.key || i
          });
        }
        result.push(replaceElement);
        continue;
      }
    }

    if (node.type === 'text') {
      isWhitespace = !node.data.trim().length;

      if (isWhitespace && node.parent && !canTextBeChildOfNode(node.parent)) {
        // We have a whitespace node that can't be nested in its parent
        // so skip it
        continue;
      }

      if (trim && isWhitespace) {
        // Trim is enabled and we have a whitespace node
        // so skip it
        continue;
      }

      // We have a text node that's not whitespace and it can be nested
      // in its parent so add it to the results
      result.push(node.data);
      continue;
    }

    props = node.attribs;
    if (skipAttributesToProps(node)) {
      setStyleProp(props.style, props);
    } else if (props) {
      props = attributesToProps(props, node.name);
    }

    children = null;

    switch (node.type) {
      case 'script':
      case 'style':
        // prevent text in <script> or <style> from being escaped
        // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
        if (node.children[0]) {
          props.dangerouslySetInnerHTML = {
            __html: node.children[0].data
          };
        }
        break;

      case 'tag':
        // setting textarea value in children is an antipattern in React
        // https://reactjs.org/docs/forms.html#the-textarea-tag
        if (node.name === 'textarea' && node.children[0]) {
          props.defaultValue = node.children[0].data;
        } else if (node.children && node.children.length) {
          // continue recursion of creating React elements (if applicable)
          children = domToReact(node.children, options);
        }
        break;

      // skip all other cases (e.g., comment)
      default:
        continue;
    }

    // set "key" prop for sibling elements
    // https://fb.me/react-warning-keys
    if (len > 1) {
      props.key = i;
    }

    result.push(createElement(node.name, props, children));
  }

  return result.length === 1 ? result[0] : result;
}

/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param {DomElement} node
 * @returns - Whether node attributes should be converted to props.
 */
function skipAttributesToProps(node) {
  return (
    utilities.PRESERVE_CUSTOM_ATTRIBUTES &&
    node.type === 'tag' &&
    utilities.isCustomComponent(node.name, node.attribs)
  );
}

module.exports = domToReact;


/***/ }),

/***/ 74606:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(67294);
var styleToJS = (__webpack_require__(41476)["default"]);

/**
 * Swap key with value in an object.
 *
 * @param {object} obj - The object.
 * @param {Function} [override] - The override method.
 * @returns - The inverted object.
 */
function invertObject(obj, override) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('First argument must be an object');
  }

  var key;
  var value;
  var isOverridePresent = typeof override === 'function';
  var overrides = {};
  var result = {};

  for (key in obj) {
    value = obj[key];

    if (isOverridePresent) {
      overrides = override(key, value);
      if (overrides && overrides.length === 2) {
        result[overrides[0]] = overrides[1];
        continue;
      }
    }

    if (typeof value === 'string') {
      result[value] = key;
    }
  }

  return result;
}

/**
 * Check if a given tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param {string} tagName - The name of the html tag.
 * @param {object} props - The props being passed to the element.
 * @returns - Whether tag is custom component.
 */
function isCustomComponent(tagName, props) {
  if (tagName.indexOf('-') === -1) {
    return props && typeof props.is === 'string';
  }

  switch (tagName) {
    // These are reserved SVG and MathML elements.
    // We don't mind this whitelist too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return false;
    default:
      return true;
  }
}

var styleToJSOptions = { reactCompat: true };

/**
 * Sets style prop.
 *
 * @param {null|undefined|string} style
 * @param {object} props
 */
function setStyleProp(style, props) {
  if (style === null || style === undefined) {
    return;
  }
  try {
    props.style = styleToJS(style, styleToJSOptions);
  } catch (err) {
    props.style = {};
  }
}

/**
 * @constant {boolean}
 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
 */
var PRESERVE_CUSTOM_ATTRIBUTES = React.version.split('.')[0] >= 16;

// Taken from
// https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
var elementsWithNoTextChildren = new Set([
  'tr',
  'tbody',
  'thead',
  'tfoot',
  'colgroup',
  'table',
  'head',
  'html',
  'frameset'
]);

/**
 * Checks if the given node can contain text nodes
 *
 * @param {DomElement} node - Node.
 * @returns - Whether node can contain text nodes.
 */
function canTextBeChildOfNode(node) {
  return !elementsWithNoTextChildren.has(node.name);
}

module.exports = {
  PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
  invertObject: invertObject,
  isCustomComponent: isCustomComponent,
  setStyleProp: setStyleProp,
  canTextBeChildOfNode: canTextBeChildOfNode,
  elementsWithNoTextChildren: elementsWithNoTextChildren
};


/***/ }),

/***/ 87384:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DomHandler = void 0;
var domelementtype_1 = __webpack_require__(99960);
var node_js_1 = __webpack_require__(5079);
__exportStar(__webpack_require__(5079), exports);
// Default options
var defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false,
};
var DomHandler = /** @class */ (function () {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */
    function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */
        this.dom = [];
        /** The root element for the DOM */
        this.root = new node_js_1.Document(this.dom);
        /** Indicated whether parsing has been completed. */
        this.done = false;
        /** Stack of open tags. */
        this.tagStack = [this.root];
        /** A data node that is still being written to. */
        this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */
        this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function (parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function () {
        this.dom = [];
        this.root = new node_js_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function () {
        if (this.done)
            return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function (error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function () {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
            this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function (name, attribs) {
        var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
        var element = new node_js_1.Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function (data) {
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) {
                lastNode.endIndex = this.parser.endIndex;
            }
        }
        else {
            var node = new node_js_1.Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function (data) {
        if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new node_js_1.Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function () {
        var text = new node_js_1.Text("");
        var node = new node_js_1.CDATA([text]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function (name, data) {
        var node = new node_js_1.ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function (error) {
        if (typeof this.callback === "function") {
            this.callback(error, this.dom);
        }
        else if (error) {
            throw error;
        }
    };
    DomHandler.prototype.addNode = function (node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
            node.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
            node.endIndex = this.parser.endIndex;
        }
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}());
exports.DomHandler = DomHandler;
exports["default"] = DomHandler;


/***/ }),

/***/ 5079:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cloneNode = exports.hasChildren = exports.isDocument = exports.isDirective = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = exports.Element = exports.Document = exports.CDATA = exports.NodeWithChildren = exports.ProcessingInstruction = exports.Comment = exports.Text = exports.DataNode = exports.Node = void 0;
var domelementtype_1 = __webpack_require__(99960);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
var Node = /** @class */ (function () {
    function Node() {
        /** Parent of the node */
        this.parent = null;
        /** Previous sibling */
        this.prev = null;
        /** Next sibling */
        this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
        this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
        this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.parent;
        },
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.prev;
        },
        set: function (prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.next;
        },
        set: function (next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */
    Node.prototype.cloneNode = function (recursive) {
        if (recursive === void 0) { recursive = false; }
        return cloneNode(this, recursive);
    };
    return Node;
}());
exports.Node = Node;
/**
 * A node that contains some data.
 */
var DataNode = /** @class */ (function (_super) {
    __extends(DataNode, _super);
    /**
     * @param data The content of the data node
     */
    function DataNode(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.data;
        },
        set: function (data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}(Node));
exports.DataNode = DataNode;
/**
 * Text within the document.
 */
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Text;
        return _this;
    }
    Object.defineProperty(Text.prototype, "nodeType", {
        get: function () {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    return Text;
}(DataNode));
exports.Text = Text;
/**
 * Comments within the document.
 */
var Comment = /** @class */ (function (_super) {
    __extends(Comment, _super);
    function Comment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Comment;
        return _this;
    }
    Object.defineProperty(Comment.prototype, "nodeType", {
        get: function () {
            return 8;
        },
        enumerable: false,
        configurable: true
    });
    return Comment;
}(DataNode));
exports.Comment = Comment;
/**
 * Processing instructions, including doc types.
 */
var ProcessingInstruction = /** @class */ (function (_super) {
    __extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, data) || this;
        _this.name = name;
        _this.type = domelementtype_1.ElementType.Directive;
        return _this;
    }
    Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return ProcessingInstruction;
}(DataNode));
exports.ProcessingInstruction = ProcessingInstruction;
/**
 * A `Node` that can have children.
 */
var NodeWithChildren = /** @class */ (function (_super) {
    __extends(NodeWithChildren, _super);
    /**
     * @param children Children of the node. Only certain node types can have children.
     */
    function NodeWithChildren(children) {
        var _this = _super.call(this) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function () {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */
        get: function () {
            return this.children.length > 0
                ? this.children[this.children.length - 1]
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.children;
        },
        set: function (children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}(Node));
exports.NodeWithChildren = NodeWithChildren;
var CDATA = /** @class */ (function (_super) {
    __extends(CDATA, _super);
    function CDATA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.CDATA;
        return _this;
    }
    Object.defineProperty(CDATA.prototype, "nodeType", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    return CDATA;
}(NodeWithChildren));
exports.CDATA = CDATA;
/**
 * The root node of the document.
 */
var Document = /** @class */ (function (_super) {
    __extends(Document, _super);
    function Document() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Root;
        return _this;
    }
    Object.defineProperty(Document.prototype, "nodeType", {
        get: function () {
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    return Document;
}(NodeWithChildren));
exports.Document = Document;
/**
 * An element within the DOM.
 */
var Element = /** @class */ (function (_super) {
    __extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */
    function Element(name, attribs, children, type) {
        if (children === void 0) { children = []; }
        if (type === void 0) { type = name === "script"
            ? domelementtype_1.ElementType.Script
            : name === "style"
                ? domelementtype_1.ElementType.Style
                : domelementtype_1.ElementType.Tag; }
        var _this = _super.call(this, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        _this.type = type;
        return _this;
    }
    Object.defineProperty(Element.prototype, "nodeType", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.name;
        },
        set: function (name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function () {
            var _this = this;
            return Object.keys(this.attribs).map(function (name) {
                var _a, _b;
                return ({
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}(NodeWithChildren));
exports.Element = Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
function isTag(node) {
    return (0, domelementtype_1.isTag)(node);
}
exports.isTag = isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
function isCDATA(node) {
    return node.type === domelementtype_1.ElementType.CDATA;
}
exports.isCDATA = isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
function isText(node) {
    return node.type === domelementtype_1.ElementType.Text;
}
exports.isText = isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
function isComment(node) {
    return node.type === domelementtype_1.ElementType.Comment;
}
exports.isComment = isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDirective(node) {
    return node.type === domelementtype_1.ElementType.Directive;
}
exports.isDirective = isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDocument(node) {
    return node.type === domelementtype_1.ElementType.Root;
}
exports.isDocument = isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
exports.hasChildren = hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function cloneNode(node, recursive) {
    if (recursive === void 0) { recursive = false; }
    var result;
    if (isText(node)) {
        result = new Text(node.data);
    }
    else if (isComment(node)) {
        result = new Comment(node.data);
    }
    else if (isTag(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_1 = new Element(node.name, __assign({}, node.attribs), children);
        children.forEach(function (child) { return (child.parent = clone_1); });
        if (node.namespace != null) {
            clone_1.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
            clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
        }
        if (node["x-attribsPrefix"]) {
            clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
        }
        result = clone_1;
    }
    else if (isCDATA(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_2 = new CDATA(children);
        children.forEach(function (child) { return (child.parent = clone_2); });
        result = clone_2;
    }
    else if (isDocument(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_3 = new Document(children);
        children.forEach(function (child) { return (child.parent = clone_3); });
        if (node["x-mode"]) {
            clone_3["x-mode"] = node["x-mode"];
        }
        result = clone_3;
    }
    else if (isDirective(node)) {
        var instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    }
    else {
        throw new Error("Not implemented yet: ".concat(node.type));
    }
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
    }
    return result;
}
exports.cloneNode = cloneNode;
function cloneChildren(childs) {
    var children = childs.map(function (child) { return cloneNode(child, true); });
    for (var i = 1; i < children.length; i++) {
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}


/***/ }),

/***/ 80645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 18139:
/***/ (function(module) {

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
module.exports = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  var errorsList = [];

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) {
      errorsList.push(err);
    } else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}


/***/ }),

/***/ 29238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = window.DOMPurify || (window.DOMPurify = (__webpack_require__(27856)["default"]) || __webpack_require__(27856));

/***/ }),

/***/ 2962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PB": function() { return /* binding */ NextSeo; },
/* harmony export */   "lX": function() { return /* binding */ DefaultSeo; }
/* harmony export */ });
/* unused harmony exports ArticleJsonLd, BrandJsonLd, BreadcrumbJsonLd, CarouselJsonLd, CollectionPageJsonLd, CorporateContactJsonLd, CourseJsonLd, DatasetJsonLd, EventJsonLd, FAQPageJsonLd, HowToJsonLd, ImageJsonLd, JobPostingJsonLd, LocalBusinessJsonLd, LogoJsonLd, NewsArticleJsonLd, OrganizationJsonLd, ProductJsonLd, ProfilePageJsonLd, QAPageJsonLd, RecipeJsonLd, SiteLinksSearchBoxJsonLd, SocialProfileJsonLd, SoftwareAppJsonLd, VideoGameJsonLd, VideoJsonLd, WebPageJsonLd */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);



function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded$x = ["keyOverride"];
var defaults = {
  templateTitle: '',
  noindex: false,
  nofollow: false,
  defaultOpenGraphImageWidth: 0,
  defaultOpenGraphImageHeight: 0,
  defaultOpenGraphVideoWidth: 0,
  defaultOpenGraphVideoHeight: 0
};
var buildOpenGraphMediaTags = function buildOpenGraphMediaTags(mediaType, media, _temp) {
  if (media === void 0) {
    media = [];
  }
  var _ref = _temp === void 0 ? {} : _temp,
    defaultWidth = _ref.defaultWidth,
    defaultHeight = _ref.defaultHeight;
  return media.reduce(function (tags, medium, index) {
    tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "og:" + mediaType + ":0" + index,
      property: "og:" + mediaType,
      content: medium.url
    }));
    if (medium.alt) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":alt0" + index,
        property: "og:" + mediaType + ":alt",
        content: medium.alt
      }));
    }
    if (medium.secureUrl) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":secure_url0" + index,
        property: "og:" + mediaType + ":secure_url",
        content: medium.secureUrl.toString()
      }));
    }
    if (medium.type) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":type0" + index,
        property: "og:" + mediaType + ":type",
        content: medium.type.toString()
      }));
    }
    if (medium.width) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":width0" + index,
        property: "og:" + mediaType + ":width",
        content: medium.width.toString()
      }));
    } else if (defaultWidth) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":width0" + index,
        property: "og:" + mediaType + ":width",
        content: defaultWidth.toString()
      }));
    }
    if (medium.height) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":height" + index,
        property: "og:" + mediaType + ":height",
        content: medium.height.toString()
      }));
    } else if (defaultHeight) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":height" + index,
        property: "og:" + mediaType + ":height",
        content: defaultHeight.toString()
      }));
    }
    return tags;
  }, []);
};
var buildTags = function buildTags(config) {
  var _config$openGraph, _config$openGraph3, _config$additionalLin;
  var tagsToRender = [];
  if (config.titleTemplate) {
    defaults.templateTitle = config.titleTemplate;
  }
  var updatedTitle = '';
  if (config.title) {
    updatedTitle = config.title;
    if (defaults.templateTitle) {
      updatedTitle = defaults.templateTitle.replace(/%s/g, function () {
        return updatedTitle;
      });
    }
  } else if (config.defaultTitle) {
    updatedTitle = config.defaultTitle;
  }
  if (updatedTitle) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
      key: "title"
    }, updatedTitle));
  }
  var noindex = config.noindex || defaults.noindex || config.dangerouslySetAllPagesToNoIndex;
  var nofollow = config.nofollow || defaults.nofollow || config.dangerouslySetAllPagesToNoFollow;
  var robotsParams = '';
  if (config.robotsProps) {
    var _config$robotsProps = config.robotsProps,
      nosnippet = _config$robotsProps.nosnippet,
      maxSnippet = _config$robotsProps.maxSnippet,
      maxImagePreview = _config$robotsProps.maxImagePreview,
      maxVideoPreview = _config$robotsProps.maxVideoPreview,
      noarchive = _config$robotsProps.noarchive,
      noimageindex = _config$robotsProps.noimageindex,
      notranslate = _config$robotsProps.notranslate,
      unavailableAfter = _config$robotsProps.unavailableAfter;
    robotsParams = "" + (nosnippet ? ',nosnippet' : '') + (maxSnippet ? ",max-snippet:" + maxSnippet : '') + (maxImagePreview ? ",max-image-preview:" + maxImagePreview : '') + (noarchive ? ',noarchive' : '') + (unavailableAfter ? ",unavailable_after:" + unavailableAfter : '') + (noimageindex ? ',noimageindex' : '') + (maxVideoPreview ? ",max-video-preview:" + maxVideoPreview : '') + (notranslate ? ',notranslate' : '');
  }
  if (noindex || nofollow) {
    if (config.dangerouslySetAllPagesToNoIndex) {
      defaults.noindex = true;
    }
    if (config.dangerouslySetAllPagesToNoFollow) {
      defaults.nofollow = true;
    }
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "robots",
      name: "robots",
      content: (noindex ? 'noindex' : 'index') + "," + (nofollow ? 'nofollow' : 'follow') + robotsParams
    }));
  } else {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "robots",
      name: "robots",
      content: "index,follow" + robotsParams
    }));
  }
  if (config.description) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "description",
      name: "description",
      content: config.description
    }));
  }
  if (config.themeColor) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "theme-color",
      name: "theme-color",
      content: config.themeColor
    }));
  }
  if (config.mobileAlternate) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("link", {
      rel: "alternate",
      key: "mobileAlternate",
      media: config.mobileAlternate.media,
      href: config.mobileAlternate.href
    }));
  }
  if (config.languageAlternates && config.languageAlternates.length > 0) {
    config.languageAlternates.forEach(function (languageAlternate) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("link", {
        rel: "alternate",
        key: "languageAlternate-" + languageAlternate.hrefLang,
        hrefLang: languageAlternate.hrefLang,
        href: languageAlternate.href
      }));
    });
  }
  if (config.twitter) {
    if (config.twitter.cardType) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "twitter:card",
        name: "twitter:card",
        content: config.twitter.cardType
      }));
    }
    if (config.twitter.site) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "twitter:site",
        name: "twitter:site",
        content: config.twitter.site
      }));
    }
    if (config.twitter.handle) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "twitter:creator",
        name: "twitter:creator",
        content: config.twitter.handle
      }));
    }
  }
  if (config.facebook) {
    if (config.facebook.appId) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "fb:app_id",
        property: "fb:app_id",
        content: config.facebook.appId
      }));
    }
  }
  if ((_config$openGraph = config.openGraph) != null && _config$openGraph.title || updatedTitle) {
    var _config$openGraph2;
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "og:title",
      property: "og:title",
      content: ((_config$openGraph2 = config.openGraph) == null ? void 0 : _config$openGraph2.title) || updatedTitle
    }));
  }
  if ((_config$openGraph3 = config.openGraph) != null && _config$openGraph3.description || config.description) {
    var _config$openGraph4;
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "og:description",
      property: "og:description",
      content: ((_config$openGraph4 = config.openGraph) == null ? void 0 : _config$openGraph4.description) || config.description
    }));
  }
  if (config.openGraph) {
    if (config.openGraph.url || config.canonical) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:url",
        property: "og:url",
        content: config.openGraph.url || config.canonical
      }));
    }
    if (config.openGraph.type) {
      var type = config.openGraph.type.toLowerCase();
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:type",
        property: "og:type",
        content: type
      }));
      if (type === 'profile' && config.openGraph.profile) {
        if (config.openGraph.profile.firstName) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "profile:first_name",
            property: "profile:first_name",
            content: config.openGraph.profile.firstName
          }));
        }
        if (config.openGraph.profile.lastName) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "profile:last_name",
            property: "profile:last_name",
            content: config.openGraph.profile.lastName
          }));
        }
        if (config.openGraph.profile.username) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "profile:username",
            property: "profile:username",
            content: config.openGraph.profile.username
          }));
        }
        if (config.openGraph.profile.gender) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "profile:gender",
            property: "profile:gender",
            content: config.openGraph.profile.gender
          }));
        }
      } else if (type === 'book' && config.openGraph.book) {
        if (config.openGraph.book.authors && config.openGraph.book.authors.length) {
          config.openGraph.book.authors.forEach(function (author, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "book:author:0" + index,
              property: "book:author",
              content: author
            }));
          });
        }
        if (config.openGraph.book.isbn) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "book:isbn",
            property: "book:isbn",
            content: config.openGraph.book.isbn
          }));
        }
        if (config.openGraph.book.releaseDate) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "book:release_date",
            property: "book:release_date",
            content: config.openGraph.book.releaseDate
          }));
        }
        if (config.openGraph.book.tags && config.openGraph.book.tags.length) {
          config.openGraph.book.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "book:tag:0" + index,
              property: "book:tag",
              content: tag
            }));
          });
        }
      } else if (type === 'article' && config.openGraph.article) {
        if (config.openGraph.article.publishedTime) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "article:published_time",
            property: "article:published_time",
            content: config.openGraph.article.publishedTime
          }));
        }
        if (config.openGraph.article.modifiedTime) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "article:modified_time",
            property: "article:modified_time",
            content: config.openGraph.article.modifiedTime
          }));
        }
        if (config.openGraph.article.expirationTime) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "article:expiration_time",
            property: "article:expiration_time",
            content: config.openGraph.article.expirationTime
          }));
        }
        if (config.openGraph.article.authors && config.openGraph.article.authors.length) {
          config.openGraph.article.authors.forEach(function (author, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "article:author:0" + index,
              property: "article:author",
              content: author
            }));
          });
        }
        if (config.openGraph.article.section) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "article:section",
            property: "article:section",
            content: config.openGraph.article.section
          }));
        }
        if (config.openGraph.article.tags && config.openGraph.article.tags.length) {
          config.openGraph.article.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "article:tag:0" + index,
              property: "article:tag",
              content: tag
            }));
          });
        }
      } else if ((type === 'video.movie' || type === 'video.episode' || type === 'video.tv_show' || type === 'video.other') && config.openGraph.video) {
        if (config.openGraph.video.actors && config.openGraph.video.actors.length) {
          config.openGraph.video.actors.forEach(function (actor, index) {
            if (actor.profile) {
              tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
                key: "video:actor:0" + index,
                property: "video:actor",
                content: actor.profile
              }));
            }
            if (actor.role) {
              tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
                key: "video:actor:role:0" + index,
                property: "video:actor:role",
                content: actor.role
              }));
            }
          });
        }
        if (config.openGraph.video.directors && config.openGraph.video.directors.length) {
          config.openGraph.video.directors.forEach(function (director, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "video:director:0" + index,
              property: "video:director",
              content: director
            }));
          });
        }
        if (config.openGraph.video.writers && config.openGraph.video.writers.length) {
          config.openGraph.video.writers.forEach(function (writer, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "video:writer:0" + index,
              property: "video:writer",
              content: writer
            }));
          });
        }
        if (config.openGraph.video.duration) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "video:duration",
            property: "video:duration",
            content: config.openGraph.video.duration.toString()
          }));
        }
        if (config.openGraph.video.releaseDate) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "video:release_date",
            property: "video:release_date",
            content: config.openGraph.video.releaseDate
          }));
        }
        if (config.openGraph.video.tags && config.openGraph.video.tags.length) {
          config.openGraph.video.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "video:tag:0" + index,
              property: "video:tag",
              content: tag
            }));
          });
        }
        if (config.openGraph.video.series) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "video:series",
            property: "video:series",
            content: config.openGraph.video.series
          }));
        }
      }
    }
    // images
    if (config.defaultOpenGraphImageWidth) {
      defaults.defaultOpenGraphImageWidth = config.defaultOpenGraphImageWidth;
    }
    if (config.defaultOpenGraphImageHeight) {
      defaults.defaultOpenGraphImageHeight = config.defaultOpenGraphImageHeight;
    }
    if (config.openGraph.images && config.openGraph.images.length) {
      tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags('image', config.openGraph.images, {
        defaultWidth: defaults.defaultOpenGraphImageWidth,
        defaultHeight: defaults.defaultOpenGraphImageHeight
      }));
    }
    // videos
    if (config.defaultOpenGraphVideoWidth) {
      defaults.defaultOpenGraphVideoWidth = config.defaultOpenGraphVideoWidth;
    }
    if (config.defaultOpenGraphVideoHeight) {
      defaults.defaultOpenGraphVideoHeight = config.defaultOpenGraphVideoHeight;
    }
    if (config.openGraph.videos && config.openGraph.videos.length) {
      tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags('video', config.openGraph.videos, {
        defaultWidth: defaults.defaultOpenGraphVideoWidth,
        defaultHeight: defaults.defaultOpenGraphVideoHeight
      }));
    }
    // audio
    if (config.openGraph.audio) {
      tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags('audio', config.openGraph.audio));
    }
    if (config.openGraph.locale) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:locale",
        property: "og:locale",
        content: config.openGraph.locale
      }));
    }
    if (config.openGraph.siteName || config.openGraph.site_name) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:site_name",
        property: "og:site_name",
        content: config.openGraph.siteName || config.openGraph.site_name
      }));
    }
  }
  if (config.canonical) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("link", {
      rel: "canonical",
      href: config.canonical,
      key: "canonical"
    }));
  }
  if (config.additionalMetaTags && config.additionalMetaTags.length > 0) {
    config.additionalMetaTags.forEach(function (_ref2) {
      var _ref3, _ref4;
      var keyOverride = _ref2.keyOverride,
        tag = _objectWithoutPropertiesLoose(_ref2, _excluded$x);
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", _extends({
        key: "meta:" + ((_ref3 = (_ref4 = keyOverride != null ? keyOverride : tag.name) != null ? _ref4 : tag.property) != null ? _ref3 : tag.httpEquiv)
      }, tag)));
    });
  }
  if ((_config$additionalLin = config.additionalLinkTags) != null && _config$additionalLin.length) {
    config.additionalLinkTags.forEach(function (tag) {
      var _tag$keyOverride;
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("link", _extends({
        key: "link" + ((_tag$keyOverride = tag.keyOverride) != null ? _tag$keyOverride : tag.href) + tag.rel
      }, tag)));
    });
  }
  return tagsToRender;
};

var WithHead = function WithHead(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_head__WEBPACK_IMPORTED_MODULE_1___default()), null, buildTags(props));
};

var DefaultSeo = function DefaultSeo(_ref) {
  var title = _ref.title,
    titleTemplate = _ref.titleTemplate,
    defaultTitle = _ref.defaultTitle,
    themeColor = _ref.themeColor,
    _ref$dangerouslySetAl = _ref.dangerouslySetAllPagesToNoIndex,
    dangerouslySetAllPagesToNoIndex = _ref$dangerouslySetAl === void 0 ? false : _ref$dangerouslySetAl,
    _ref$dangerouslySetAl2 = _ref.dangerouslySetAllPagesToNoFollow,
    dangerouslySetAllPagesToNoFollow = _ref$dangerouslySetAl2 === void 0 ? false : _ref$dangerouslySetAl2,
    description = _ref.description,
    canonical = _ref.canonical,
    facebook = _ref.facebook,
    openGraph = _ref.openGraph,
    additionalMetaTags = _ref.additionalMetaTags,
    twitter = _ref.twitter,
    defaultOpenGraphImageWidth = _ref.defaultOpenGraphImageWidth,
    defaultOpenGraphImageHeight = _ref.defaultOpenGraphImageHeight,
    defaultOpenGraphVideoWidth = _ref.defaultOpenGraphVideoWidth,
    defaultOpenGraphVideoHeight = _ref.defaultOpenGraphVideoHeight,
    mobileAlternate = _ref.mobileAlternate,
    languageAlternates = _ref.languageAlternates,
    additionalLinkTags = _ref.additionalLinkTags,
    robotsProps = _ref.robotsProps;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(WithHead, {
    title: title,
    titleTemplate: titleTemplate,
    defaultTitle: defaultTitle,
    themeColor: themeColor,
    dangerouslySetAllPagesToNoIndex: dangerouslySetAllPagesToNoIndex,
    dangerouslySetAllPagesToNoFollow: dangerouslySetAllPagesToNoFollow,
    description: description,
    canonical: canonical,
    facebook: facebook,
    openGraph: openGraph,
    additionalMetaTags: additionalMetaTags,
    twitter: twitter,
    defaultOpenGraphImageWidth: defaultOpenGraphImageWidth,
    defaultOpenGraphImageHeight: defaultOpenGraphImageHeight,
    defaultOpenGraphVideoWidth: defaultOpenGraphVideoWidth,
    defaultOpenGraphVideoHeight: defaultOpenGraphVideoHeight,
    mobileAlternate: mobileAlternate,
    languageAlternates: languageAlternates,
    additionalLinkTags: additionalLinkTags,
    robotsProps: robotsProps
  });
};

var NextSeo = function NextSeo(_ref) {
  var title = _ref.title,
    themeColor = _ref.themeColor,
    _ref$noindex = _ref.noindex,
    noindex = _ref$noindex === void 0 ? false : _ref$noindex,
    nofollow = _ref.nofollow,
    robotsProps = _ref.robotsProps,
    description = _ref.description,
    canonical = _ref.canonical,
    openGraph = _ref.openGraph,
    facebook = _ref.facebook,
    twitter = _ref.twitter,
    additionalMetaTags = _ref.additionalMetaTags,
    titleTemplate = _ref.titleTemplate,
    defaultTitle = _ref.defaultTitle,
    mobileAlternate = _ref.mobileAlternate,
    languageAlternates = _ref.languageAlternates,
    additionalLinkTags = _ref.additionalLinkTags,
    _ref$useAppDir = _ref.useAppDir,
    useAppDir = _ref$useAppDir === void 0 ? false : _ref$useAppDir;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, useAppDir ? buildTags({
    title: title,
    themeColor: themeColor,
    noindex: noindex,
    nofollow: nofollow,
    robotsProps: robotsProps,
    description: description,
    canonical: canonical,
    facebook: facebook,
    openGraph: openGraph,
    additionalMetaTags: additionalMetaTags,
    twitter: twitter,
    titleTemplate: titleTemplate,
    defaultTitle: defaultTitle,
    mobileAlternate: mobileAlternate,
    languageAlternates: languageAlternates,
    additionalLinkTags: additionalLinkTags
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(WithHead, {
    title: title,
    themeColor: themeColor,
    noindex: noindex,
    nofollow: nofollow,
    robotsProps: robotsProps,
    description: description,
    canonical: canonical,
    facebook: facebook,
    openGraph: openGraph,
    additionalMetaTags: additionalMetaTags,
    twitter: twitter,
    titleTemplate: titleTemplate,
    defaultTitle: defaultTitle,
    mobileAlternate: mobileAlternate,
    languageAlternates: languageAlternates,
    additionalLinkTags: additionalLinkTags
  }));
};

var toJson = function toJson(type, jsonld) {
  var data = jsonld;
  if (Array.isArray(data) && data.length === 1) {
    data = _extends({}, jsonld[0]);
  }
  var jsonLdObject = Array.isArray(data) ? data.map(function (item) {
    return formatObjectForSchema(type, item);
  }) : formatObjectForSchema(type, data);
  return {
    __html: JSON.stringify(jsonLdObject, safeJsonLdReplacer)
  };
};
var formatObjectForSchema = function formatObjectForSchema(type, jsonld) {
  var _jsonld$id = jsonld.id,
    id = _jsonld$id === void 0 ? undefined : _jsonld$id;
  var updated = _extends({}, id ? {
    '@id': jsonld.id
  } : {}, jsonld);
  delete updated.id;
  return _extends({
    '@context': 'https://schema.org',
    '@type': type
  }, updated);
};
var ESCAPE_ENTITIES = Object.freeze({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&apos;'
});
var ESCAPE_REGEX = new RegExp("[" + Object.keys(ESCAPE_ENTITIES).join('') + "]", 'g');
var ESCAPE_REPLACER = function ESCAPE_REPLACER(t) {
  return ESCAPE_ENTITIES[t];
};
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */
var safeJsonLdReplacer = function () {
  // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
  // Solution from https://stackoverflow.com/a/5499821/864313
  return function (_, value) {
    switch (typeof value) {
      case 'object':
        // Omit null values.
        if (value === null) {
          return undefined;
        }
        return value;
      // JSON.stringify will recursively call replacer.
      case 'number':
      case 'boolean':
      case 'bigint':
        return value;
      // These values are not risky.
      case 'string':
        return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);
      default:
        {
          // JSON.stringify will remove this element.
          return undefined;
        }
    }
  };
}();

var _excluded$w = (/* unused pure expression or super */ null && (["type", "keyOverride", "scriptKey", "scriptId", "dataArray", "useAppDir"]));
function JsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Thing' : _ref$type,
    keyOverride = _ref.keyOverride,
    scriptKey = _ref.scriptKey,
    _ref$scriptId = _ref.scriptId,
    scriptId = _ref$scriptId === void 0 ? undefined : _ref$scriptId,
    dataArray = _ref.dataArray,
    _ref$useAppDir = _ref.useAppDir,
    useAppDir = _ref$useAppDir === void 0 ? false : _ref$useAppDir,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$w);
  var JsonLdScript = function JsonLdScript() {
    return /*#__PURE__*/React.createElement("script", {
      type: "application/ld+json",
      id: scriptId,
      "data-testid": scriptId,
      dangerouslySetInnerHTML: toJson(type, dataArray === undefined ? _extends({}, rest) : dataArray),
      key: "jsonld-" + scriptKey + (keyOverride ? "-" + keyOverride : '')
    });
  };
  if (useAppDir) {
    return /*#__PURE__*/React.createElement(JsonLdScript, null);
  }
  return /*#__PURE__*/React.createElement(Head, null, JsonLdScript());
}

/**
 * Generate author information
 * @param author
 * @returns
 */
function generateAuthorInfo(author) {
  if (typeof author === 'string') {
    return {
      '@type': 'Person',
      name: author
    };
  } else if (!!author.name) {
    var _author$type;
    return {
      '@type': (_author$type = author == null ? void 0 : author.type) != null ? _author$type : 'Person',
      name: author.name,
      url: author == null ? void 0 : author.url
    };
  }
  return;
}
function setAuthor(author) {
  if (Array.isArray(author)) {
    return author.map(function (item) {
      return generateAuthorInfo(item);
    }).filter(function (item) {
      return !!item;
    });
  } else if (author) {
    return generateAuthorInfo(author);
  }
  return;
}

function setImage(image) {
  if (image) {
    return {
      '@type': 'ImageObject',
      url: image
    };
  }
  return undefined;
}

function setPublisher(publisherName, publisherLogo) {
  if (!publisherName) {
    return undefined;
  }
  return {
    '@type': 'Organization',
    name: publisherName,
    logo: setImage(publisherLogo)
  };
}

function setReviewRating(rating) {
  if (rating) {
    return _extends({}, rating, {
      '@type': 'Rating'
    });
  }
  return undefined;
}

var _excluded$v = (/* unused pure expression or super */ null && (["reviewRating", "author", "publisher"]));
function setReviews(reviews) {
  function mapReview(_ref) {
    var reviewRating = _ref.reviewRating,
      author = _ref.author,
      publisher = _ref.publisher,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$v);
    return _extends({}, rest, {
      '@type': 'Review'
    }, author && {
      author: setAuthor(author)
    }, reviewRating && {
      reviewRating: setReviewRating(reviewRating)
    }, publisher && {
      publisher: setPublisher(publisher.name)
    });
  }
  if (Array.isArray(reviews)) {
    return reviews.map(mapReview);
  } else if (reviews) {
    return mapReview(reviews);
  }
  return undefined;
}

function setNutrition(calories) {
  if (calories) {
    return {
      '@type': 'NutritionInformation',
      calories: calories + " calories"
    };
  }
  return undefined;
}

function setAggregateRating(aggregateRating) {
  if (aggregateRating) {
    return {
      '@type': 'AggregateRating',
      ratingCount: aggregateRating.ratingCount,
      reviewCount: aggregateRating.reviewCount,
      bestRating: aggregateRating.bestRating,
      ratingValue: aggregateRating.ratingValue
    };
  }
  return undefined;
}

function setClip(clips) {
  function mapClip(clip) {
    return _extends({}, clip, {
      '@type': 'Clip'
    });
  }
  if (Array.isArray(clips)) {
    return clips.map(mapClip);
  } else if (clips) {
    return mapClip(clips);
  }
  return undefined;
}

function setInteractionStatistic(watchCount) {
  if (watchCount) {
    return {
      '@type': 'InteractionCounter',
      interactionType: 'https://schema.org/WatchAction',
      userInteractionCount: watchCount
    };
  }
  return undefined;
}

function setBroadcastEvent(publication) {
  function mapBroadcastEvent(publication) {
    return _extends({}, publication, {
      '@type': 'BroadcastEvent'
    });
  }
  if (publication) {
    if (Array.isArray(publication)) {
      return publication.map(mapBroadcastEvent);
    }
    return mapBroadcastEvent(publication);
  }
  return undefined;
}

var _excluded$u = (/* unused pure expression or super */ null && (["thumbnailUrls", "hasPart", "watchCount", "publication"]));
function setVideo(video, setContext) {
  if (setContext === void 0) {
    setContext = false;
  }
  function mapVideo(_ref, context) {
    var thumbnailUrls = _ref.thumbnailUrls,
      hasPart = _ref.hasPart,
      watchCount = _ref.watchCount,
      publication = _ref.publication,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$u);
    return _extends({}, rest, {
      '@type': 'VideoObject'
    }, context && {
      '@context': 'https://schema.org'
    }, {
      thumbnailUrl: thumbnailUrls,
      hasPart: setClip(hasPart),
      interactionStatistic: setInteractionStatistic(watchCount),
      publication: setBroadcastEvent(publication)
    });
  }
  if (video) {
    return mapVideo(video, setContext);
  }
  return undefined;
}

function setInstruction(instruction) {
  if (instruction) {
    return _extends({}, instruction, {
      '@type': 'HowToStep'
    });
  }
  return undefined;
}

var _excluded$t = (/* unused pure expression or super */ null && (["type", "keyOverride", "ofType", "data"])),
  _excluded2$1 = (/* unused pure expression or super */ null && (["authorName", "images", "yields", "category", "calories", "aggregateRating", "video", "ingredients", "instructions", "cuisine"]));
function CarouselJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Carousel' : _ref$type,
    keyOverride = _ref.keyOverride,
    ofType = _ref.ofType,
    data = _ref.data,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$t);
  function generateList(data, ofType) {
    switch (ofType) {
      case 'default':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            url: item.url
          };
        });
      case 'course':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: {
              '@context': 'https://schema.org',
              '@type': 'Course',
              url: item.url,
              name: item.courseName,
              description: item.description,
              provider: {
                '@type': 'Organization',
                name: item.providerName,
                sameAs: item.providerUrl
              }
            }
          };
        });
      case 'movie':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: {
              '@context': 'https://schema.org',
              '@type': 'Movie',
              name: item.name,
              url: item.url,
              image: item.image,
              dateCreated: item.dateCreated,
              director: item.director ? Array.isArray(item.director) ? item.director.map(function (director) {
                return {
                  '@type': 'Person',
                  name: director.name
                };
              }) : {
                '@type': 'Person',
                name: item.director.name
              } : undefined,
              review: setReviews(item.review)
            }
          };
        });
      case 'recipe':
        return data.map(function (_ref2, index) {
          var authorName = _ref2.authorName,
            images = _ref2.images,
            yields = _ref2.yields,
            category = _ref2.category,
            calories = _ref2.calories,
            aggregateRating = _ref2.aggregateRating,
            video = _ref2.video,
            ingredients = _ref2.ingredients,
            instructions = _ref2.instructions,
            cuisine = _ref2.cuisine,
            rest = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: _extends({
              '@context': 'https://schema.org',
              '@type': 'Recipe'
            }, rest, {
              author: setAuthor(authorName),
              image: images,
              recipeYield: yields,
              recipeCategory: category,
              recipeCuisine: cuisine,
              nutrition: setNutrition(calories),
              aggregateRating: setAggregateRating(aggregateRating),
              video: setVideo(video),
              recipeIngredient: ingredients,
              recipeInstructions: instructions.map(setInstruction)
            })
          };
        });
    }
  }
  var jsonLdData = _extends({
    '@type': 'ItemList',
    itemListElement: generateList(data, ofType)
  }, rest);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, jsonLdData, {
    scriptKey: "Carousel"
  }));
}

var _excluded$s = (/* unused pure expression or super */ null && (["type", "keyOverride", "url", "title", "images", "section", "dateCreated", "datePublished", "dateModified", "authorName", "authorType", "publisherName", "publisherLogo", "body", "isAccessibleForFree"]));
function NewsArticleJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'NewsArticle' : _ref$type,
    keyOverride = _ref.keyOverride,
    url = _ref.url,
    title = _ref.title,
    images = _ref.images,
    section = _ref.section,
    dateCreated = _ref.dateCreated,
    datePublished = _ref.datePublished,
    dateModified = _ref.dateModified,
    authorName = _ref.authorName,
    publisherName = _ref.publisherName,
    publisherLogo = _ref.publisherLogo,
    body = _ref.body,
    isAccessibleForFree = _ref.isAccessibleForFree,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$s);
  var data = _extends({}, rest, {
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url
    },
    headline: title,
    image: images,
    articleSection: section,
    dateCreated: dateCreated || datePublished,
    datePublished: datePublished,
    dateModified: dateModified || datePublished,
    author: setAuthor(authorName),
    publisher: setPublisher(publisherName, publisherLogo),
    articleBody: body,
    isAccessibleForFree: isAccessibleForFree
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "NewsArticle"
  }));
}

var _excluded$r = (/* unused pure expression or super */ null && (["type", "keyOverride", "baseSalary", "hiringOrganization", "applicantLocationRequirements", "experienceRequirements", "jobLocation"]));
function JobPostingJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'JobPosting' : _ref$type,
    keyOverride = _ref.keyOverride,
    baseSalary = _ref.baseSalary,
    hiringOrganization = _ref.hiringOrganization,
    applicantLocationRequirements = _ref.applicantLocationRequirements,
    experienceRequirements = _ref.experienceRequirements,
    jobLocation = _ref.jobLocation,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$r);
  function setBaseSalary(baseSalary) {
    if (baseSalary) {
      return {
        '@type': 'MonetaryAmount',
        currency: baseSalary.currency,
        value: _extends({
          '@type': 'QuantitativeValue',
          unitText: baseSalary.unitText
        }, Array.isArray(baseSalary.value) ? {
          minValue: baseSalary.value[0],
          maxValue: baseSalary.value[1]
        } : {
          value: baseSalary.value
        })
      };
    }
    return undefined;
  }
  function setHiringOrganization(org) {
    return {
      '@type': 'Organization',
      name: org.name,
      sameAs: org.sameAs,
      logo: org.logo
    };
  }
  function setJobLocation(location) {
    if (location) {
      return {
        '@type': 'Place',
        address: {
          '@type': 'PostalAddress',
          addressCountry: location.addressCountry,
          addressLocality: location.addressLocality,
          addressRegion: location.addressRegion,
          postalCode: location.postalCode,
          streetAddress: location.streetAddress
        }
      };
    }
    return undefined;
  }
  function setApplicantLocationRequirements(requirements) {
    if (requirements) {
      return {
        '@type': 'Country',
        name: requirements
      };
    }
    return undefined;
  }
  function setOccupationalExperienceRequirements(requirements) {
    if (requirements) {
      return {
        '@type': requirements['@type'] ? requirements['@type'] : 'OccupationalExperienceRequirements',
        monthsOfExperience: requirements.minimumMonthsOfExperience
      };
    }
    return undefined;
  }
  function setEducationalOccupationalCredential(requirements) {
    if (requirements) {
      return {
        '@type': requirements['@type'] ? requirements['@type'] : 'EducationalOccupationalCredential',
        credentialCategory: requirements.credentialCategory
      };
    }
    return undefined;
  }
  var data = _extends({}, rest, {
    baseSalary: setBaseSalary(baseSalary),
    hiringOrganization: setHiringOrganization(hiringOrganization),
    jobLocation: setJobLocation(jobLocation),
    applicantLocationRequirements: setApplicantLocationRequirements(applicantLocationRequirements),
    experienceRequirements: setOccupationalExperienceRequirements(experienceRequirements == null ? void 0 : experienceRequirements.occupational),
    educationRequirements: setEducationalOccupationalCredential(experienceRequirements == null ? void 0 : experienceRequirements.educational),
    experienceInPlaceOfEducation: experienceRequirements == null ? void 0 : experienceRequirements.experienceInPlaceOfEducation
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "JobPosting"
  }));
}

function setAddress(address) {
  if (!address) return undefined;
  if (!Array.isArray(address)) return toPostalAddress(address);
  // If array of one address, replace with single address
  if (address.length === 1) return toPostalAddress(address[0]);
  // If array, return mapped array of PostalAddresses
  return address.map(toPostalAddress);
}
function toPostalAddress(address) {
  if (typeof address === 'string') return address;
  return _extends({
    '@type': 'PostalAddress'
  }, address);
}

function setGeo(geo) {
  if (geo) {
    return _extends({}, geo, {
      '@type': 'GeoCoordinates'
    });
  }
  return undefined;
}

function setAction(action) {
  if (action) {
    return {
      '@type': action.actionType,
      name: action.actionName,
      target: action.target
    };
  }
  return undefined;
}

function setGeoCircle(geoCircle) {
  if (geoCircle) {
    return {
      '@type': 'GeoCircle',
      geoMidpoint: {
        '@type': 'GeoCoordinates',
        latitude: geoCircle.geoMidpoint.latitude,
        longitude: geoCircle.geoMidpoint.longitude
      },
      geoRadius: geoCircle.geoRadius
    };
  }
  return undefined;
}

function setOffer(offer) {
  function setPriceSpecification(priceSpecification) {
    if (priceSpecification) {
      return {
        '@type': priceSpecification.type,
        priceCurrency: priceSpecification.priceCurrency,
        price: priceSpecification.price
      };
    }
    return undefined;
  }
  function setItemOffered(itemOffered) {
    if (itemOffered) {
      return _extends({}, itemOffered, {
        '@type': 'Service'
      });
    }
    return undefined;
  }
  if (offer) {
    return _extends({}, offer, {
      '@type': 'Offer',
      priceSpecification: setPriceSpecification(offer.priceSpecification),
      itemOffered: setItemOffered(offer.itemOffered)
    });
  }
  return undefined;
}

function setOpeningHours(openingHours) {
  if (openingHours) {
    return _extends({}, openingHours, {
      '@type': 'OpeningHoursSpecification'
    });
  }
  return undefined;
}

var _excluded$q = (/* unused pure expression or super */ null && (["type", "keyOverride", "address", "geo", "rating", "review", "action", "areaServed", "makesOffer", "openingHours", "images"]));
function LocalBusinessJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'LocalBusiness' : _ref$type,
    keyOverride = _ref.keyOverride,
    address = _ref.address,
    geo = _ref.geo,
    rating = _ref.rating,
    review = _ref.review,
    action = _ref.action,
    areaServed = _ref.areaServed,
    makesOffer = _ref.makesOffer,
    openingHours = _ref.openingHours,
    images = _ref.images,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$q);
  var data = _extends({}, rest, {
    image: images,
    address: setAddress(address),
    geo: setGeo(geo),
    aggregateRating: setAggregateRating(rating),
    review: setReviews(review),
    potentialAction: setAction(action),
    areaServed: areaServed && areaServed.map(setGeoCircle),
    makesOffer: makesOffer == null ? void 0 : makesOffer.map(setOffer),
    openingHoursSpecification: Array.isArray(openingHours) ? openingHours.map(setOpeningHours) : setOpeningHours(openingHours)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "LocalBusiness"
  }));
}

var _excluded$p = (/* unused pure expression or super */ null && (["type", "keyOverride", "mainEntity"])),
  _excluded2 = (/* unused pure expression or super */ null && (["upvoteCount"]));
function QAPageJsonLd(_ref) {
  var _mainEntity$author, _mainEntity$acceptedA, _mainEntity$acceptedA2;
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'QAPage' : _ref$type,
    keyOverride = _ref.keyOverride,
    mainEntity = _ref.mainEntity,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$p);
  var data = _extends({}, rest, {
    mainEntity: _extends({}, mainEntity, {
      '@type': 'Question',
      author: setAuthor((_mainEntity$author = mainEntity.author) == null ? void 0 : _mainEntity$author.name)
    }, mainEntity.acceptedAnswer && {
      acceptedAnswer: _extends({}, mainEntity.acceptedAnswer, {
        '@type': 'Answer',
        author: setAuthor((_mainEntity$acceptedA = mainEntity.acceptedAnswer) == null ? void 0 : (_mainEntity$acceptedA2 = _mainEntity$acceptedA.author) == null ? void 0 : _mainEntity$acceptedA2.name)
      })
    }, mainEntity.suggestedAnswer && {
      suggestedAnswer: mainEntity.suggestedAnswer.map(function (_ref2) {
        var _rest$author;
        var upvoteCount = _ref2.upvoteCount,
          rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
        return _extends({}, rest, {
          '@type': 'Answer',
          upvoteCount: upvoteCount || 0,
          author: setAuthor((_rest$author = rest.author) == null ? void 0 : _rest$author.name)
        });
      })
    })
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "QAPage"
  }));
}

function setItemListElements(items) {
  if (items && items.length) {
    return items.map(function (item) {
      return {
        '@type': 'ListItem',
        position: item.position,
        item: {
          '@id': item.item,
          name: item.name
        }
      };
    });
  }
  return undefined;
}

var _excluded$o = (/* unused pure expression or super */ null && (["type", "keyOverride", "breadcrumb"]));
function ProfilePageJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'ProfilePage' : _ref$type,
    keyOverride = _ref.keyOverride,
    breadcrumb = _ref.breadcrumb,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$o);
  var data = _extends({}, rest, {
    breadcrumb: Array.isArray(breadcrumb) ? {
      '@type': 'BreadcrumbList',
      itemListElement: setItemListElements(breadcrumb)
    } : breadcrumb
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "ProfilePage"
  }));
}

var _excluded$n = (/* unused pure expression or super */ null && (["type", "keyOverride", "potentialActions"]));
function SiteLinksSearchBoxJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'WebSite' : _ref$type,
    keyOverride = _ref.keyOverride,
    potentialActions = _ref.potentialActions,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$n);
  function setPotentialAction(action) {
    if (action) {
      var target = action.target,
        queryInput = action.queryInput;
      return {
        '@type': 'SearchAction',
        target: target + "={" + queryInput + "}",
        'query-input': "required name=" + queryInput
      };
    }
    return undefined;
  }
  var data = _extends({}, rest, {
    potentialAction: potentialActions.map(setPotentialAction)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "jsonld-siteLinksSearchBox"
  }));
}

var _excluded$m = (/* unused pure expression or super */ null && (["type", "keyOverride", "authorName", "images", "yields", "category", "cuisine", "calories", "aggregateRating", "video", "ingredients", "instructions"]));
function RecipeJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Recipe' : _ref$type,
    keyOverride = _ref.keyOverride,
    authorName = _ref.authorName,
    images = _ref.images,
    yields = _ref.yields,
    category = _ref.category,
    cuisine = _ref.cuisine,
    calories = _ref.calories,
    aggregateRating = _ref.aggregateRating,
    video = _ref.video,
    ingredients = _ref.ingredients,
    instructions = _ref.instructions,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$m);
  var data = _extends({}, rest, {
    author: setAuthor(authorName),
    image: images,
    recipeYield: yields,
    recipeCategory: category,
    recipeCuisine: cuisine,
    nutrition: setNutrition(calories),
    aggregateRating: setAggregateRating(aggregateRating),
    video: setVideo(video),
    recipeIngredient: ingredients,
    recipeInstructions: instructions ? instructions.map(setInstruction) : undefined
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "recipe"
  }));
}

function setLocation(location) {
  if (!location) {
    return undefined;
  }
  if (typeof location === 'string') {
    return location;
  }
  if ('url' in location) {
    return setVirtualLocation(location);
  } else {
    return setPlace(location);
  }
}
function setVirtualLocation(location) {
  return _extends({}, location, {
    '@type': 'VirtualLocation'
  });
}
function setPlace(location) {
  return _extends({}, location, {
    address: setAddress(location.address),
    '@type': 'Place'
  });
}

var _excluded$l = (/* unused pure expression or super */ null && (["type"]));
function setPerformer(performer) {
  if (performer) {
    var type = performer.type,
      restPerformer = _objectWithoutPropertiesLoose(performer, _excluded$l);
    return _extends({}, restPerformer, {
      '@type': type || 'PerformingGroup'
    });
  }
  return undefined;
}

var _excluded$k = (/* unused pure expression or super */ null && (["seller"]));
function setOffers(offers) {
  function mapOffer(_ref) {
    var seller = _ref.seller,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$k);
    return _extends({}, rest, {
      '@type': 'Offer'
    }, seller && {
      seller: {
        '@type': 'Organization',
        name: seller.name
      }
    });
  }
  if (Array.isArray(offers)) {
    return offers.map(mapOffer);
  } else if (offers) {
    return mapOffer(offers);
  }
  return undefined;
}

function setAggregateOffer(aggregateOffer) {
  if (aggregateOffer) {
    return {
      '@type': 'AggregateOffer',
      priceCurrency: aggregateOffer.priceCurrency,
      highPrice: aggregateOffer.highPrice,
      lowPrice: aggregateOffer.lowPrice,
      offerCount: aggregateOffer.offerCount,
      offers: setOffers(aggregateOffer.offers)
    };
  }
  return undefined;
}

var _excluded$j = (/* unused pure expression or super */ null && (["type"]));
function setOrganizer(organizer) {
  if (organizer) {
    var type = organizer.type,
      restOrganizer = _objectWithoutPropertiesLoose(organizer, _excluded$j);
    return _extends({}, restOrganizer, {
      '@type': type || 'Person'
    });
  }
  return undefined;
}

var _excluded$i = (/* unused pure expression or super */ null && (["type", "keyOverride", "location", "images", "offers", "aggregateOffer", "performers", "organizer", "eventStatus", "eventAttendanceMode"]));
function EventJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Event' : _ref$type,
    keyOverride = _ref.keyOverride,
    location = _ref.location,
    images = _ref.images,
    offers = _ref.offers,
    aggregateOffer = _ref.aggregateOffer,
    performers = _ref.performers,
    organizer = _ref.organizer,
    eventStatus = _ref.eventStatus,
    eventAttendanceMode = _ref.eventAttendanceMode,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$i);
  var data = _extends({}, rest, {
    location: setLocation(location),
    image: images,
    offers: offers ? setOffers(offers) : setAggregateOffer(aggregateOffer),
    performer: Array.isArray(performers) ? performers.map(setPerformer) : setPerformer(performers),
    organizer: Array.isArray(organizer) ? organizer.map(setOrganizer) : setOrganizer(organizer),
    eventStatus: eventStatus ? "https://schema.org/" + eventStatus : undefined,
    eventAttendanceMode: eventAttendanceMode ? "https://schema.org/" + eventAttendanceMode : undefined
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Event"
  }));
}

function setContactPoint(contactPoint) {
  if (contactPoint) {
    return _extends({}, contactPoint, {
      '@type': 'ContactPoint'
    });
  }
  return undefined;
}

var _excluded$h = (/* unused pure expression or super */ null && (["type", "keyOverride", "contactPoint"]));
function CorporateContactJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Organization' : _ref$type,
    keyOverride = _ref.keyOverride,
    contactPoint = _ref.contactPoint,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$h);
  var data = _extends({}, rest, {
    contactPoint: contactPoint.map(setContactPoint)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "CorporateContact"
  }));
}

function setCreativeWork(creativeWork) {
  if (creativeWork) {
    return _extends({}, creativeWork, {
      '@type': 'CreativeWork'
    });
  }
  return undefined;
}

var _excluded$g = (/* unused pure expression or super */ null && (["type", "keyOverride", "hasPart"]));
function CollectionPageJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'CollectionPage' : _ref$type,
    keyOverride = _ref.keyOverride,
    hasPart = _ref.hasPart,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$g);
  var data = _extends({}, rest, {
    hasPart: hasPart.map(setCreativeWork)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "CollectionPage"
  }));
}

function setManufacturer(manufacturer) {
  if (manufacturer && (manufacturer.manufacturerName || manufacturer.manufacturerLogo)) {
    return {
      '@type': 'Organization',
      name: manufacturer.manufacturerName,
      logo: setImage(manufacturer.manufacturerLogo)
    };
  }
  return undefined;
}

function setBrand(brand) {
  if (brand) {
    return {
      '@type': 'Brand',
      name: brand
    };
  }
  return undefined;
}

var _excluded$f = (/* unused pure expression or super */ null && (["type", "keyOverride", "images", "brand", "reviews", "aggregateRating", "manufacturerLogo", "manufacturerName", "offers", "aggregateOffer", "productName"]));
function ProductJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Product' : _ref$type,
    keyOverride = _ref.keyOverride,
    images = _ref.images,
    brand = _ref.brand,
    reviews = _ref.reviews,
    aggregateRating = _ref.aggregateRating,
    manufacturerLogo = _ref.manufacturerLogo,
    manufacturerName = _ref.manufacturerName,
    offers = _ref.offers,
    aggregateOffer = _ref.aggregateOffer,
    productName = _ref.productName,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$f);
  var data = _extends({}, rest, {
    image: images,
    brand: setBrand(brand),
    review: setReviews(reviews),
    aggregateRating: setAggregateRating(aggregateRating),
    manufacturer: setManufacturer({
      manufacturerLogo: manufacturerLogo,
      manufacturerName: manufacturerName
    }),
    offers: offers ? setOffers(offers) : setAggregateOffer(aggregateOffer),
    name: productName
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Product"
  }));
}

var _excluded$e = (/* unused pure expression or super */ null && (["type", "keyOverride", "priceCurrency", "price", "aggregateRating", "review"]));
function SoftwareAppJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'SoftwareApplication' : _ref$type,
    keyOverride = _ref.keyOverride,
    priceCurrency = _ref.priceCurrency,
    price = _ref.price,
    aggregateRating = _ref.aggregateRating,
    review = _ref.review,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$e);
  var data = _extends({}, rest, {
    offers: {
      '@type': 'Offer',
      price: price,
      priceCurrency: priceCurrency
    },
    aggregateRating: setAggregateRating(aggregateRating),
    review: setReviews(review)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "SoftwareApp"
  }));
}

var _excluded$d = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function VideoJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Video' : _ref$type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$d);
  var data = setVideo(rest, true);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Video"
  }));
}

function setProducer(producer) {
  if (producer) {
    return {
      '@type': 'Organization',
      sameAs: producer.url,
      name: producer.name
    };
  }
  return undefined;
}

function setProvider(provider) {
  if (provider) {
    return {
      '@type': provider.type || 'Organization',
      name: provider.name,
      sameAs: provider.url
    };
  }
  return undefined;
}

var _excluded$c = (/* unused pure expression or super */ null && (["type", "keyOverride", "aggregateRating", "trailer", "reviews", "image", "authorName", "provider", "producerName", "producerUrl", "offers", "operatingSystemName", "platformName", "translatorName", "languageName", "genreName", "publisherName"]));
function VideoGameJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'VideoGame' : _ref$type,
    keyOverride = _ref.keyOverride,
    aggregateRating = _ref.aggregateRating,
    trailer = _ref.trailer,
    reviews = _ref.reviews,
    image = _ref.image,
    authorName = _ref.authorName,
    provider = _ref.provider,
    producerName = _ref.producerName,
    producerUrl = _ref.producerUrl,
    offers = _ref.offers,
    operatingSystemName = _ref.operatingSystemName,
    platformName = _ref.platformName,
    translatorName = _ref.translatorName,
    languageName = _ref.languageName,
    genreName = _ref.genreName,
    publisherName = _ref.publisherName,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$c);
  var data = _extends({}, rest, {
    aggregateRating: setAggregateRating(aggregateRating),
    trailer: setVideo(trailer),
    review: setReviews(reviews),
    image: setImage(image),
    author: setAuthor(authorName),
    provider: setProvider(provider),
    producer: setProducer({
      name: producerName,
      url: producerUrl
    }),
    offers: setOffers(offers),
    operatingSystem: operatingSystemName,
    gamePlatform: platformName,
    translator: translatorName,
    inLanguage: languageName,
    genre: genreName,
    publisher: publisherName
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "VideoGame"
  }));
}

function setContactPoints(contactPoint) {
  if (contactPoint && contactPoint.length) {
    return contactPoint.map(function (contactPoint) {
      return _extends({
        '@type': 'ContactPoint'
      }, contactPoint);
    });
  }
  return undefined;
}

var _excluded$b = (/* unused pure expression or super */ null && (["type", "keyOverride", "address", "contactPoints", "contactPoint"]));
function OrganizationJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Organization' : _ref$type,
    keyOverride = _ref.keyOverride,
    address = _ref.address,
    contactPoints = _ref.contactPoints,
    contactPoint = _ref.contactPoint,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  var data = _extends({}, rest, {
    address: setAddress(address),
    contactPoint: setContactPoints(contactPoint || contactPoints)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "organization"
  }));
}

function setQuestions(questions) {
  if (questions && questions.length) {
    return questions.map(function (question) {
      return {
        '@type': 'Question',
        name: question.questionName,
        acceptedAnswer: {
          '@type': 'Answer',
          text: question.acceptedAnswerText
        }
      };
    });
  }
  return undefined;
}

var _excluded$a = (/* unused pure expression or super */ null && (["type", "keyOverride", "mainEntity"]));
function FAQPageJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'FAQPage' : _ref$type,
    keyOverride = _ref.keyOverride,
    mainEntity = _ref.mainEntity,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  var data = _extends({}, rest, {
    mainEntity: setQuestions(mainEntity)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "faq-page"
  }));
}

var _excluded$9 = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function LogoJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Organization' : _ref$type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "Logo"
  }));
}

var _excluded$8 = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function DatasetJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Dataset' : _ref$type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "dataset"
  }));
}

var _excluded$7 = (/* unused pure expression or super */ null && (["type", "keyOverride", "courseName", "provider"]));
function CourseJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Course' : _ref$type,
    keyOverride = _ref.keyOverride,
    courseName = _ref.courseName,
    provider = _ref.provider,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var data = _extends({
    name: courseName
  }, rest, {
    provider: setProvider(provider)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "course"
  }));
}

var _excluded$6 = (/* unused pure expression or super */ null && (["type", "keyOverride", "itemListElements"]));
function BreadCrumbJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'BreadcrumbList' : _ref$type,
    keyOverride = _ref.keyOverride,
    itemListElements = _ref.itemListElements,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var data = _extends({}, rest, {
    itemListElement: setItemListElements(itemListElements)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "breadcrumb"
  }));
}

var _excluded$5 = (/* unused pure expression or super */ null && (["type", "id", "keyOverride", "aggregateRating"]));
function BrandJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Brand' : _ref$type,
    id = _ref.id,
    keyOverride = _ref.keyOverride,
    aggregateRating = _ref.aggregateRating,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var data = _extends({
    aggregateRating: setAggregateRating(aggregateRating),
    '@id': id
  }, rest);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "brand"
  }));
}

var _excluded$4 = (/* unused pure expression or super */ null && (["type", "keyOverride", "url", "title", "images", "datePublished", "dateModified", "authorName", "publisherName", "publisherLogo", "description", "isAccessibleForFree"]));
function ArticleJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Article' : _ref$type,
    keyOverride = _ref.keyOverride,
    url = _ref.url,
    title = _ref.title,
    images = _ref.images,
    datePublished = _ref.datePublished,
    dateModified = _ref.dateModified,
    authorName = _ref.authorName,
    _ref$publisherName = _ref.publisherName,
    publisherName = _ref$publisherName === void 0 ? undefined : _ref$publisherName,
    _ref$publisherLogo = _ref.publisherLogo,
    publisherLogo = _ref$publisherLogo === void 0 ? undefined : _ref$publisherLogo,
    description = _ref.description,
    isAccessibleForFree = _ref.isAccessibleForFree,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var data = _extends({
    datePublished: datePublished,
    description: description,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url
    },
    headline: title,
    image: images,
    dateModified: dateModified || datePublished,
    author: setAuthor(authorName),
    publisher: setPublisher(publisherName, publisherLogo),
    isAccessibleForFree: isAccessibleForFree
  }, rest);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "article"
  }));
}

function setReviewedBy(reviewedBy) {
  if (reviewedBy) {
    return _extends({
      '@type': (reviewedBy == null ? void 0 : reviewedBy.type) || 'Organization'
    }, reviewedBy);
  }
  return undefined;
}

var _excluded$3 = (/* unused pure expression or super */ null && (["keyOverride", "reviewedBy"]));
function WebPageJsonLd(_ref) {
  var keyOverride = _ref.keyOverride,
    reviewedBy = _ref.reviewedBy,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  var data = _extends({}, rest, {
    reviewedBy: setReviewedBy(reviewedBy)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    keyOverride: keyOverride
  }, data, {
    type: "WebPage",
    scriptKey: "WebPage"
  }));
}

var _excluded$2 = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function SocialProfileJsonLd(_ref) {
  var type = _ref.type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "social"
  }));
}

function setCost(cost) {
  if (cost) {
    return _extends({}, cost, {
      '@type': 'MonetaryAmount'
    });
  }
  return undefined;
}

function setSupply(supply) {
  if (supply) {
    return supply.map(function (supplyItem) {
      return {
        '@type': 'HowToSupply',
        name: supplyItem
      };
    });
  }
  return undefined;
}

function setTool(tool) {
  if (tool) {
    return tool.map(function (toolItem) {
      return {
        '@type': 'HowToTool',
        name: toolItem
      };
    });
  }
  return undefined;
}

function setStep(step) {
  if (step) {
    return step.map(function (stepElement) {
      var itemListElement = stepElement.itemListElement,
        image = stepElement.image;
      var currentListElements = itemListElement == null ? void 0 : itemListElement.map(function (_ref) {
        var type = _ref.type,
          text = _ref.text;
        return {
          '@type': type,
          text: text
        };
      });
      return _extends({}, stepElement, {
        '@type': 'HowToStep',
        itemListElement: currentListElements,
        image: setImage(image)
      });
    });
  }
  return undefined;
}

var _excluded$1 = (/* unused pure expression or super */ null && (["type", "keyOverride", "image", "estimatedCost", "supply", "tool", "step"]));
function howToJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'HowTo' : _ref$type,
    keyOverride = _ref.keyOverride,
    image = _ref.image,
    estimatedCost = _ref.estimatedCost,
    supply = _ref.supply,
    tool = _ref.tool,
    step = _ref.step,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var data = _extends({}, rest, {
    image: setImage(image),
    estimatedCost: setCost(estimatedCost),
    supply: setSupply(supply),
    tool: setTool(tool),
    step: setStep(step)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "howTo"
  }));
}

var _excluded = (/* unused pure expression or super */ null && (["keyOverride", "images"]));
function ImageJsonLd(_ref) {
  var keyOverride = _ref.keyOverride,
    images = _ref.images,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({}, rest, {
    type: "ImageObject",
    keyOverride: keyOverride,
    dataArray: images,
    scriptKey: "image"
  }));
}




/***/ }),

/***/ 59266:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(77017);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13476:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo.eb887c2b.png","height":1643,"width":4347,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAIVBMVEUGhU4Kg00Jg000ckd2UjwOgUwAjVHRKi0AjVFhXD/CMS+NZn2nAAAAC3RSTlM5CzArWWpEThxofJjDQTAAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAeSURBVAiZY2DjZGZgYGBiZmDnYmIAsRhYWDkYQQAABAwAQyNbafYAAAAASUVORK5CYII="});

/***/ }),

/***/ 36203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bt": function() { return /* binding */ asyncGet; },
/* harmony export */   "C3": function() { return /* binding */ asyncPostList; },
/* harmony export */   "NE": function() { return /* binding */ asyncGetList; },
/* harmony export */   "Xz": function() { return /* binding */ asyncSearchList; },
/* harmony export */   "op": function() { return /* binding */ asyncPost; },
/* harmony export */   "p9": function() { return /* binding */ asyncGetItem; },
/* harmony export */   "vo": function() { return /* binding */ asyncDeleteList; }
/* harmony export */ });
/* unused harmony exports clearCookie, asyncGetListShared, processImageUrl */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _setup_axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42580);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54521);




// import qs from "qs";
// import queryString from "query-string";
// import fetch from "isomorphic-unfetch";

function getCookie(cname) {
    if (false) {}
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == " "){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            var v = c.substring(name.length, c.length);
            return v;
        }
    }
    return "";
}
function setCookie(cname, cvalue, exdays) {
    if (false) {}
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function clearCookie() {
    return _clearCookie.apply(this, arguments);
}
function _clearCookie() {
    _clearCookie = _async_to_generator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("".concat("https://api.flexzen.app", "/api/updateprofile?access_token=").concat("flex.public.token"), {
                        method: "post",
                        credentials: "omit",
                        headers: {
                            "content-type": "application/json; charset=utf-8",
                            "Access-Control-Allow-Credentials": true,
                            Accept: "application/json"
                        }
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    // return _axios.post(
    //   `${process.env.server_url_report}/api/updateprofile?access_token=${process.env.public_token}`,
    //   {
    //     withCredentials: false,
    //     headers: {
    //       withCredentials: false,
    //       Accept: "application/json",
    //       Cache: "no-cache",
    //       "Content-Type": "application/x-www-form-urlencoded",
    //       Cookie: `uid=""; AAAAAAAAAAAA=abc`,
    //       Authorization: `uid=""`,
    //     },
    //   }
    // );
    // return axios({
    //   method: "POST",
    //   url: `${process.env.server_url_report}/api/updateprofile?access_token=${process.env.public_token}`,
    //   headers: {
    //     Cookie: `uid=""`,
    //   },
    // });
    }));
    return _clearCookie.apply(this, arguments);
}
function asyncGetList(_) {
    return _asyncGetList.apply(this, arguments);
}
function _asyncGetList() {
    _asyncGetList = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var _access_token, access_token, collection_name, _options, options, signal, id_app, url, appendedURL, res, _uid, errorMessage;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _access_token = param.access_token, access_token = _access_token === void 0 ? "flex.public.token" : _access_token, collection_name = param.collection_name, _options = param.options, options = _options === void 0 ? {} : _options, signal = param.signal;
                    if (collection_name) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    id_app = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getIdApp */ .Qg)(collection_name, options);
                    url = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .prepareURL */ .Zw)(collection_name, id_app, access_token);
                    appendedURL = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .appendOptionsToURL */ .$o)(url, options);
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return (0,_setup_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                        method: "GET",
                        url: appendedURL,
                        signal: signal,
                        headers: {
                            uid: getCookie("uid")
                        }
                    });
                case 9:
                    res = _ctx.sent;
                    _uid = getCookie("uid");
                    if (!_uid) {
                        if (!_uid) {
                            _uid = res.headers.get("uid");
                        }
                        if (_uid) {
                            setCookie("uid", _uid, 1);
                        }
                    }
                    return _ctx.abrupt("return", res.data);
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](6);
                    errorMessage = (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) || _ctx.t0.error || _ctx.t0;
                    if (errorMessage) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                    } else if (_ctx.t0.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    // console.log(error.request);
                    } else {
                    // Something happened in setting up the request that triggered an Error
                    // console.log("Error", error.message);
                    }
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                15
            ]
        ]);
    }));
    return _asyncGetList.apply(this, arguments);
}
function asyncPost(_) {
    return _asyncPost.apply(this, arguments);
}
function _asyncPost() {
    _asyncPost = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var url, data, method, options, res, _uid;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    url = param.url, data = param.data, method = param.method, options = param.options;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return (0,_setup_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                        method: method.toLowerCase(),
                        url: url,
                        data: data,
                        headers: {
                            uid: getCookie("uid")
                        }
                    });
                case 4:
                    res = _ctx.sent;
                    if (!(res.ok || res.status === 200)) {
                        _ctx.next = 9;
                        break;
                    }
                    _uid = getCookie("uid");
                    if (!_uid) {
                        if (!_uid) {
                            _uid = res.headers.get("uid");
                        }
                        if (_uid) {
                            setCookie("uid", _uid, 1);
                        }
                    }
                    return _ctx.abrupt("return", res.data);
                case 9:
                    throw new Error({
                        message: "Something went wrong"
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", _ctx.t0.data.error);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                12
            ]
        ]);
    }));
    return _asyncPost.apply(this, arguments);
}
// export async function asyncPost({ url, data, method, options }) {
//   return await fetch(url, {
//     method,
//     body: JSON.stringify(data),
//     headers: {
//       "Content-type": "application/json; charset=UTF-8",
//     },
//   });
// }
function asyncSearchList(_) {
    return _asyncSearchList.apply(this, arguments);
}
function _asyncSearchList() {
    _asyncSearchList = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var _access_token, access_token, collection_name, options, url, body;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _access_token = param.access_token, access_token = _access_token === void 0 ? "flex.public.token" : _access_token, collection_name = param.collection_name, options = param.options;
                    url = "".concat("https://api.flexzen.app", "/api/search/").concat("615fa1791fc31763c7253668", "/").concat(collection_name, "?access_token=").concat(access_token, "&trustkey=").concat("APP.FKJSHHHH908KJF");
                    body = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, options);
                    if (options.condition) body.q = body.condition;
                    delete body.condition;
                    if (!options.count) body.page = body.page || 1;
                    else {
                        delete body.fields;
                        delete body.notfields;
                        delete body.page;
                        body.count = 1;
                    }
                    delete body.query_string;
                    delete body.buildUrl;
                    delete body.log;
                    delete body.cache_local;
                    delete body.cache;
                    _ctx.next = 13;
                    return asyncPost({
                        url: url,
                        data: body,
                        method: "post"
                    });
                case 13:
                    return _ctx.abrupt("return", _ctx.sent);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _asyncSearchList.apply(this, arguments);
}
function asyncPostList(_) {
    return _asyncPostList.apply(this, arguments);
}
function _asyncPostList() {
    _asyncPostList = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var _access_token, access_token, collection_name, data, options, id_app, url, method;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _access_token = param.access_token, access_token = _access_token === void 0 ? "flex.public.token" : _access_token, collection_name = param.collection_name, data = param.data, options = param.options;
                    if (collection_name) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    id_app = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getIdApp */ .Qg)(collection_name, options);
                    url = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .prepareURL */ .Zw)(collection_name, id_app, access_token);
                    method = "POST";
                    if (data === null || data === void 0 ? void 0 : data._id) {
                        method = "PUT";
                        url = "".concat(url, "/").concat(data._id);
                    }
                    _ctx.next = 9;
                    return asyncPost({
                        url: url,
                        data: data,
                        method: method,
                        options: options
                    });
                case 9:
                    return _ctx.abrupt("return", _ctx.sent);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _asyncPostList.apply(this, arguments);
}
function asyncGet(url, signal) {
    return _asyncGet.apply(this, arguments);
}
function _asyncGet() {
    _asyncGet = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url, signal) {
        var res, _uid;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_setup_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                        method: "GET",
                        url: url,
                        signal: signal,
                        headers: {
                            uid: getCookie("uid")
                        }
                    });
                case 2:
                    res = _ctx.sent;
                    _uid = getCookie("uid");
                    if (!_uid) {
                        if (!_uid) {
                            _uid = res.headers.get("uid");
                        }
                        if (_uid) {
                            setCookie("uid", _uid, 1);
                        }
                    }
                    return _ctx.abrupt("return", res.data);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _asyncGet.apply(this, arguments);
}
function asyncGetListShared(_) {
    return _asyncGetListShared.apply(this, arguments);
}
function _asyncGetListShared() {
    _asyncGetListShared = _async_to_generator(regeneratorRuntime.mark(function _callee(param) {
        var _access_token, access_token, collection_name, _options, options, url, rs;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _access_token = param.access_token, access_token = _access_token === void 0 ? "flex.public.token" : _access_token, collection_name = param.collection_name, _options = param.options, options = _options === void 0 ? {} : _options;
                    if (collection_name) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    url = "".concat("https://api.flexzen.app", "/api/").concat(collection_name, "/shared?page=").concat(options.page || 1, "&access_token=").concat(access_token);
                    if (options.sort) url = "".concat(url, "&sort=").concat(JSON.stringify(options.sort));
                    if (options.condition && Object.keys(options.condition).length > 0) url = "".concat(url, "&q=").concat(JSON.stringify(options.condition));
                    if (options.limit) url = "".concat(url, "&limit=").concat(options.limit);
                    if (options.fields) url = "".concat(url, "&fields=").concat(options.fields);
                    if (options.notfields) url = "".concat(url, "&notfields=").concat(options.notfields);
                    if (options.count) url = "".concat(url, "&count=1");
                    if (options.log) {
                        options.log("fetch: ".concat(url));
                    }
                    _ctx.next = 13;
                    return asyncGet(url);
                case 13:
                    rs = _ctx.sent;
                    return _ctx.abrupt("return", rs);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    // let appendedURL = appendOptionsToURL(url, options);
    // return await asyncGet(appendedURL);
    }));
    return _asyncGetListShared.apply(this, arguments);
}
function asyncGetItem(_) {
    return _asyncGetItem.apply(this, arguments);
}
function _asyncGetItem() {
    _asyncGetItem = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var _access_token, access_token, collection_name, _options, options, signal, data;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _access_token = param.access_token, access_token = _access_token === void 0 ? "flex.public.token" : _access_token, collection_name = param.collection_name, _options = param.options, options = _options === void 0 ? {} : _options, signal = param.signal;
                    _ctx.next = 3;
                    return asyncGetList({
                        access_token: access_token,
                        collection_name: collection_name,
                        options: options,
                        signal: signal
                    });
                case 3:
                    data = _ctx.sent;
                    if (!((data === null || data === void 0 ? void 0 : data.length) === 0)) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", {});
                case 6:
                    if ((data === null || data === void 0 ? void 0 : data.length) > 1) {
                        console.error("Received more than 1 ".concat(collection_name, " where it should receive 1 only"));
                    }
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data[0]);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _asyncGetItem.apply(this, arguments);
}
function processImageUrl(imageUrl) {
    if (imageUrl == null) return "";
    if ((imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.indexOf("http")) < 0) return imageUrl;
    return "/api/imageproxy?url=".concat(encodeURIComponent(imageUrl));
}
function asyncDeleteList(_) {
    return _asyncDeleteList.apply(this, arguments);
} // async function deleteRequest(
 //   url,
 //   headers,
 //   callback,
 //   options = { stringifyData: true }
 // ) {
 //   let trustkey = process.env.trustkey;
 //   if (trustkey) {
 //     if (url.indexOf("?") < 0) {
 //       url = url + "?trustkey=" + trustkey;
 //     } else {
 //       url = url + "&trustkey=" + trustkey;
 //     }
 //   }
 //   let _headers = {};
 //   if (headers) {
 //     if (Array.isArray(headers)) {
 //       headers.forEach((h) => {
 //         _headers[h.name] = h.value;
 //       });
 //     } else {
 //       _headers = Object.assign(_headers, headers);
 //     }
 //   }
 //   try {
 //     const res = await fetch(url, { method: "DELETE" });
 //     return res.json();
 //   } catch (error) {
 //     console.error(error);
 //     throw new Error(error);
 //   }
 // }
 // ------
 // https://gist.github.com/odewahn/5a5eeb23279eed6a80d7798fdb47fe91
 // export function makeRequest(url, options = {}) {
 //   return new Promise((resolve, reject) => {
 //     fetch(url, options)
 //       .then(handleResponse)
 //       .then((response) => JSON.parse(response))
 //       .then((json) => resolve(json))
 //       .catch((error) => {
 //         try {
 //           reject(JSON.parse(error));
 //         } catch (e) {
 //           reject(error);
 //         }
 //       });
 //   });
 // }
 // export function handleResponse(response) {
 //   return response.json().then((json) => {
 //     // Modify response to include status ok, success, and status text
 //     let modifiedJson = {
 //       success: response.ok,
 //       status: response.status,
 //       statusText: response.statusText ? response.statusText : json.error || "",
 //       response: json,
 //     };
 //     // If request failed, reject and return modified json string as error
 //     if (!modifiedJson.success)
 //       return Promise.reject(JSON.stringify(modifiedJson));
 //     // If successful, continue by returning modified json string
 //     return JSON.stringify(modifiedJson);
 //   });
 // }
 // // sample usage
 // //    makeRequest(/oauth/token, options)
 // //      .then((data) => console.log(data)) // do something great with data
 // //      .catch(error => console.log(error)) // do something useful with error
function _asyncDeleteList() {
    _asyncDeleteList = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var access_token, collection_name, _id, options, signal, id_app, url, res;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    access_token = param.access_token, collection_name = param.collection_name, _id = param._id, options = param.options, signal = param.signal;
                    id_app = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getIdApp */ .Qg)(collection_name, options);
                    url = "".concat("https://api.flexzen.app", "/api").concat(id_app ? "/".concat(id_app) : "", "/").concat(collection_name, "/").concat(_id);
                    url = "".concat(url, "?access_token=").concat(access_token);
                    _ctx.next = 6;
                    return (0,_setup_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                        method: "DELETE",
                        url: url,
                        signal: signal
                    });
                case 6:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _asyncDeleteList.apply(this, arguments);
}


/***/ }),

/***/ 54521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$o": function() { return /* binding */ appendOptionsToURL; },
/* harmony export */   "Qg": function() { return /* binding */ getIdApp; },
/* harmony export */   "Zw": function() { return /* binding */ prepareURL; }
/* harmony export */ });
var list_not_require_id_app_default = [
    "user",
    "users",
    "notification",
    "message",
    "listinfo",
    "moduleinfo",
    "reportinfo",
    "tableinfo",
    "labelinfo",
    "trangthai",
    "app",
    "sysgroup",
    "sysconfig",
    "schedule",
    "templatestore",
    "tinhthanh",
    "quanhuyen",
    "xaphuong",
    "token",
    "importexceltemplate",
    "exportexceltemplate",
    "ecomcategories",
    "ecomproductbrands",
    "ecomproduct_orgins",
    "ecomproductbrand_banners",
    "ecomproductproperties",
    "ecomproductoptions",
    "ecomproductbrand_categories",
    "ecomproductlines", 
];
function getIdApp(collection_name, options) {
    var id_app;
    if (list_not_require_id_app_default.includes(collection_name)) {
        id_app = "";
    } else {
        id_app = (options === null || options === void 0 ? void 0 : options.id_app) || "615fa1791fc31763c7253668";
    }
    return id_app;
}
function prepareURL(collection_name, id_app, access_token) {
    if (!collection_name) return;
    var _id_app = id_app ? "/".concat(id_app) : "";
    return "".concat("https://api.flexzen.app", "/api").concat(_id_app, "/").concat(collection_name, "?access_token=").concat(access_token, "&trustkey=").concat("APP.FKJSHHHH908KJF");
}
function appendOptionsToURL(url, param) {
    var page = param.page, sort = param.sort, condition = param.condition, fields = param.fields, limit = param.limit, notfields = param.notfields, count = param.count;
    if (!url) return;
    var appendedURL;
    var _page = 1;
    if (page) _page = page;
    appendedURL = "&page=".concat(_page);
    if (sort) appendedURL = "".concat(appendedURL, "&sort=").concat(JSON.stringify(sort));
    if (condition && Object.keys(condition).length > 0) appendedURL = "".concat(appendedURL, "&q=").concat(JSON.stringify(condition));
    if (fields) appendedURL = "".concat(appendedURL, "&fields=").concat(fields);
    if (limit) appendedURL = "".concat(appendedURL, "&limit=").concat(limit);
    if (notfields) appendedURL = "".concat(appendedURL, "&notfields=").concat(notfields);
    if (count) appendedURL = "".concat(appendedURL, "&count=1");
    return url + appendedURL;
}


/***/ }),

/***/ 78055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jr": function() { return /* binding */ useFetchProductLine; },
/* harmony export */   "k0": function() { return /* binding */ useFetchAppInfo; }
/* harmony export */ });
/* unused harmony exports fetchAppInfo, fetProductLines */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67848);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36203);




var DEFAULT_STALE_TIME = 60000; // 1min
var fetchAppInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var url;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    url = "".concat("https://api.flexzen.app", "/api/app/").concat("615fa1791fc31763c7253668", "?access_token=").concat("flex.public.token");
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGet */ .Bt)(url);
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchAppInfo() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchAppInfo = function(param) {
    var _options = param.options, options = _options === void 0 ? {} : _options;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)([
        "appInfo"
    ], function() {
        return fetchAppInfo({
            options: options
        });
    }, {
        staleTime: DEFAULT_STALE_TIME
    });
};
var fetProductLines = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        collection_name: "ecomproductlines",
                        options: {
                            page: 1,
                            limit: 100,
                            condition: {
                                ma_nganh_hang: "CAFE"
                            }
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetProductLines() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchProductLine = function() {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)([
        "ecomproductlines"
    ], function() {
        return fetProductLines();
    }, {
        staleTime: DEFAULT_STALE_TIME
    });
};


/***/ }),

/***/ 46233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rj": function() { return /* binding */ useFetchCategories; },
/* harmony export */   "y1": function() { return /* binding */ useFetchCategory; }
/* harmony export */ });
/* unused harmony exports fetchCategory, fetchCategories, useFetchCategoryHighlight */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67848);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36203);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76296);







// import initialCategories from "./initialData/categories.json";
var DEFAULT_STALE_TIME = 1000 * 60 * 60; // 1 hour
// const DEFAULT_STALE_TIME = 1000; // 5 sec
var fetchCategory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetItem */ .p9)({
                        collection_name: "ecomcategories_cty",
                        options: {
                            condition: {
                                ma_nganh_hang: "CAFE",
                                slug: slug,
                                id_app: "615fa1791fc31763c7253668"
                            }
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchCategory(slug) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchCategory = function(slug) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .categoryKeys.detail */ .Ku.detail(slug), function() {
        return fetchCategory(slug);
    }, {
        staleTime: DEFAULT_STALE_TIME,
        enabled: !!slug
    });
};
/* -------------------------------------------------------------------------- */ var fetchCategories = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var options, _args = arguments;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    return _ctx.abrupt("return", (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        collection_name: "ecomcategories_cty",
                        options: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, options), {
                            condition: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                                //danh_muc_me: { $nin: ["VIETTHIEN"] },
                                ma_nganh_hang: "CAFE"
                            }, (options === null || options === void 0 ? void 0 : options.condition) || {})
                        })
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchCategories() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchCategories = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .categoryKeys.list */ .Ku.list(options), function() {
        return fetchCategories(options);
    }, {
        enabled: Boolean(options)
    });
};
// const queryClient = useQueryClient();
var useFetchCategoryHighlight = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return useQuery(categoryKeys.list(_object_spread({
        highlight: true
    }, options)), function() {
        return fetchCategories(_object_spread({
            condition: {
                highlight: true
            }
        }, options));
    }, {
        staleTime: DEFAULT_STALE_TIME
    });
};


/***/ }),

/***/ 31670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ postContact; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36203);



// submitting contact
var postContact = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(inputValues) {
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncPostList */ .C3)({
                        collection_name: "ecomcontactus",
                        data: inputValues
                    });
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 6:
                    _ctx.prev = 6;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("Error postContact", _ctx.t0);
                    return _ctx.abrupt("return", _ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                6
            ]
        ]);
    }));
    return function postContact(inputValues) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 4088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lp": function() { return /* binding */ useFetchEcompages; },
/* harmony export */   "VM": function() { return /* binding */ useFetchEcompage; }
/* harmony export */ });
/* unused harmony exports fetchEcompage, fetchEcompages */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67848);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85945);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36203);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76296);







var DEFAULT_STALE_TIME = 60000; // 1min
var fetchEcompage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        var locale, _args = arguments;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locale = _args.length > 1 && _args[1] !== void 0 ? _args[1] : "vi";
                    return _ctx.abrupt("return", (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetItem */ .p9)({
                        collection_name: "news",
                        options: {
                            shared: true,
                            condition: {
                                slug: slug,
                                ngon_ngu: locale
                            }
                        }
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchEcompage(slug) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchEcompage = function(slug) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "vi";
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .ecompagesKeys.detail */ .xs.detail(slug, locale), function() {
        return fetchEcompage(slug, locale);
    }, {
        staleTime: DEFAULT_STALE_TIME
    });
};
/* -------------------------------------------------------------------------- */ var fetchEcompages = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var options, _args = arguments;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    return _ctx.abrupt("return", (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        collection_name: "news",
                        options: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            page: 1,
                            limit: 100
                        }, options), {
                            condition: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                                isnews: false,
                                ngon_ngu: "vi",
                                shared: true
                            }, (options === null || options === void 0 ? void 0 : options.condition) || {})
                        })
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchEcompages() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchEcompages = function(options) {
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQueryClient */ .NL)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .ecompagesKeys.list */ .xs.list(options), function() {
        return fetchEcompages(options);
    }, {
        enabled: !!options,
        staleTime: DEFAULT_STALE_TIME,
        onSuccess: function(ecompages) {
            ecompages.map(function(ecompage) {
                return queryClient.setQueriesData(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .ecompagesKeys.detail */ .xs.detail(ecompage === null || ecompage === void 0 ? void 0 : ecompage.slug), ecompage);
            });
        }
    });
}; /* -------------------------------------------------------------------------- */  // export const fetchNewsArticlesCount = async (options = {}) => {
 //   const data = await asyncGetList({
 //     collection_name: "news",
 //     options: {
 //       ...options,
 //       count: true,
 //       condition: {
 //         ngon_ngu: "vi",
 //         isnews: true,
 //         shared: true,
 //         loai_tin_tuc: { $in: ["Tin tức Zengroup", "Tin tức thị trường"] },
 //         ...(options?.condition || {}),
 //       },
 //     },
 //   });
 //   return data?.rows_number || 0;
 // };
 // export const useFetchNewsArticlesCount = (options) => {
 //   return useQuery(
 //     newsKeys.count(options || {}),
 //     () => fetchNewsArticlesCount(options),
 //     {
 //       enabled: !!options,
 //       staleTime: DEFAULT_STALE_TIME,
 //     }
 //   );
 // };


/***/ }),

/***/ 37677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useFetchOrder; }
/* harmony export */ });
/* unused harmony export fetchOrder */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _hooks_useUserInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15170);
/* harmony import */ var _setup_cartProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27104);
/* harmony import */ var _setup_flexbiz_api_provider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34733);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67848);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36203);








var fetchOrder = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var userInfo, data;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    userInfo = param.userInfo;
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_5__/* .asyncGetItem */ .p9)({
                        access_token: userInfo.token,
                        collection_name: "so1",
                        options: {
                            condition: {
                                trang_thai: "LCT",
                                user_created: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email
                            }
                        }
                    });
                case 3:
                    data = _ctx.sent;
                    if (data) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", []);
                case 6:
                    if (!(data && data.length <= 1)) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", data);
                case 8:
                    return _ctx.abrupt("return", data);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchOrder(_) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchOrder = function() {
    var userInfo = (0,_setup_flexbiz_api_provider__WEBPACK_IMPORTED_MODULE_3__/* .useApiContext */ .Q)().userInfo;
    var isLogin = (0,_hooks_useUserInfo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().isLogin;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), info = ref[0], setInfo = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (isLogin !== false && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.token)) {
            setInfo({
                token: userInfo.token,
                email: userInfo.email
            });
        } else {
            setInfo({
                token: _setup_cartProvider__WEBPACK_IMPORTED_MODULE_2__/* .config.public_token */ .vc.public_token,
                email: "public"
            });
        }
    }, [
        userInfo,
        isLogin
    ]);
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQuery */ .a)([
        "so1",
        info
    ], function() {
        return fetchOrder({
            userInfo: info
        });
    }, {
        // staleTime: process.env.DEFAULT_STALE_TIME,
        enabled: !!(info === null || info === void 0 ? void 0 : info.token)
    });
};


/***/ }),

/***/ 79122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ postSubscribe; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36203);



// submitting contact
var postSubscribe = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(inputValues) {
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncPostList */ .C3)({
                        collection_name: "ecomsubscribed",
                        data: inputValues
                    });
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 6:
                    _ctx.prev = 6;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("Error postContact", _ctx.t0);
                    return _ctx.abrupt("return", _ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                6
            ]
        ]);
    }));
    return function postSubscribe(inputValues) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 76296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vM": function() { return /* reexport */ queryKeys_cartKeys; },
  "Ku": function() { return /* reexport */ queryKeys_categoryKeys; },
  "bT": function() { return /* reexport */ queryKeys_dmchietkhauKeys; },
  "xs": function() { return /* reexport */ ecompagesKeys; },
  "w3": function() { return /* reexport */ queryKeys_newsKeys; },
  "YN": function() { return /* reexport */ queryKeys_productKeys; },
  "BX": function() { return /* reexport */ wishlistKeys/* default */.Z; }
});

;// CONCATENATED MODULE: ./apis/queryKeys/cartKeys.js
// import { flattenObj } from "@/utils/lodash";
// const sort = {
//   date_updated: -1,
// };
var cartKeys = {
    all: [
        {
            scope: "cart"
        }
    ],
    // count: (options) => [
    //   {
    //     scope: "cart",
    //     type: "count",
    //     ...flattenObj(options || {}),
    //   },
    // ],
    // list: (options) => [
    //   {
    //     scope: "cart",
    //     type: "list",
    //     sort,
    //     ...flattenObj(options || {}),
    //   },
    // ],
    // first: () => [
    //   {
    //     scope: "cart",
    //     type: "list",
    //     sort,
    //   },
    // ],
    detail: function(userToken) {
        return [
            {
                scope: "cart",
                type: "detail",
                token: userToken
            }
        ];
    }
};
/* harmony default export */ var queryKeys_cartKeys = (cartKeys);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./utils/lodash.js
var lodash = __webpack_require__(59926);
;// CONCATENATED MODULE: ./apis/queryKeys/categoryKeys.js


var categoryKeys = {
    all: [
        {
            scope: "ecomcategories_cty",
            limit: 200
        }
    ],
    count: function(options) {
        return [
            (0,_object_spread/* default */.Z)({
                scope: "ecomcategories_cty",
                type: "count"
            }, (0,lodash/* flattenObj */.nO)(options || {})), 
        ];
    },
    list: function(options) {
        return [
            (0,_object_spread/* default */.Z)({
                scope: "ecomcategories_cty",
                type: "list"
            }, (0,lodash/* flattenObj */.nO)(options || {})), 
        ];
    },
    detail: function(slug) {
        return [
            {
                scope: "ecomcategories_cty",
                type: "detail",
                slug: slug
            }
        ];
    },
    detailLv1: function(id) {
        return [
            {
                scope: "ecomcategories_cty",
                type: "detail",
                id: id
            }
        ];
    },
    detailLv2: function(slug) {
        return [
            {
                scope: "ecomcategories_cty",
                type: "detail",
                slug: slug
            }
        ];
    }
};
/* harmony default export */ var queryKeys_categoryKeys = (categoryKeys);

;// CONCATENATED MODULE: ./apis/queryKeys/dmchietkhauKeys.js
var dmchietkhauKeys = {
    all: function() {
        return [
            {
                scope: "dmchietkhau",
                type: "all"
            }, 
        ];
    },
    list: function(ma_vt) {
        return [
            {
                scope: "dmchietkhau",
                type: "list",
                ma_vt: ma_vt
            }, 
        ];
    },
    detail: function(ma_tt) {
        return [
            {
                scope: "dmchietkhau",
                type: "detail",
                ma_tt: ma_tt
            }
        ];
    }
};
/* harmony default export */ var queryKeys_dmchietkhauKeys = (dmchietkhauKeys);

;// CONCATENATED MODULE: ./apis/queryKeys/ecompagesKeys.js


var sort = {
    date_created: -1
};
var newsKeys = {
    all: [
        {
            scope: "ecompages",
            limit: 100,
            sort: sort
        }
    ],
    count: function(options) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "vi";
        return [
            (0,_object_spread/* default */.Z)({
                scope: "ecompages",
                type: "count",
                locale: locale
            }, (0,lodash/* flattenObj */.nO)(options || {})), 
        ];
    },
    list: function(options) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "vi";
        return [
            (0,_object_spread/* default */.Z)({
                scope: "ecompages",
                type: "list",
                sort: sort,
                locale: locale
            }, (0,lodash/* flattenObj */.nO)(options || {})), 
        ];
    },
    detail: function(_id) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "vi";
        return [
            {
                scope: "ecompages",
                type: "detail",
                _id: _id,
                locale: locale
            }
        ];
    }
};
/* harmony default export */ var ecompagesKeys = (newsKeys);

;// CONCATENATED MODULE: ./apis/queryKeys/newsKeys.js


var newsKeys_sort = {
    date_created: -1
};
// export const INITIAL_LOADING_NEWS_OPTIONS = {
//   limit: process.env.NEWS_LOADING_LIMIT,
//   condition: {
//     ngon_ngu: "vi",
//   },
// };
var newsKeys_newsKeys = {
    all: [
        {
            scope: "newsArticles",
            limit: 100,
            sort: newsKeys_sort
        }
    ],
    count: function(options) {
        return [
            (0,_object_spread/* default */.Z)({
                scope: "newsArticles",
                type: "count",
                ngon_ngu: "vi"
            }, (0,lodash/* flattenObj */.nO)(options || {})), 
        ];
    },
    list: function(options) {
        return [
            (0,_object_spread/* default */.Z)({
                scope: "newsArticles",
                type: "list",
                sort: newsKeys_sort
            }, (0,lodash/* flattenObj */.nO)(options || {})), 
        ];
    },
    first: function() {
        return [
            {
                scope: "newsArticles",
                type: "list",
                sort: newsKeys_sort
            }, 
        ];
    },
    detail: function(slug) {
        return [
            {
                scope: "newsArticles",
                type: "detail",
                slug: slug
            }
        ];
    }
};
/* harmony default export */ var queryKeys_newsKeys = (newsKeys_newsKeys);

;// CONCATENATED MODULE: ./apis/queryKeys/productKeys.js


var productKeys_sort = {
    date_created: -1
};
var productKeys = {
    all: [
        {
            scope: "dmvt",
            limit: 20,
            sort: productKeys_sort
        }
    ],
    count: function(options) {
        return [
            (0,_object_spread/* default */.Z)({
                scope: "dmvt",
                type: "count"
            }, (0,lodash/* flattenObj */.nO)((options === null || options === void 0 ? void 0 : options.condition) || {})), 
        ];
    },
    list: function(options) {
        return [
            (0,_object_spread/* default */.Z)({
                scope: "dmvt",
                type: "list"
            }, (0,lodash/* flattenObj */.nO)((0,_object_spread/* default */.Z)({
                sort: productKeys_sort
            }, options || {}))), 
        ];
    },
    homeList: function(ma_danh_muc_cty) {
        return [
            {
                scope: "dmvt",
                type: "bestsellers",
                ma_danh_muc_cty: ma_danh_muc_cty
            }, 
        ];
    },
    detail: function(ma_vt) {
        return [
            {
                scope: "dmvt",
                type: "detail",
                ma_vt: ma_vt
            }
        ];
    }
};
/* harmony default export */ var queryKeys_productKeys = (productKeys);

// EXTERNAL MODULE: ./apis/queryKeys/wishlistKeys.js
var wishlistKeys = __webpack_require__(55918);
;// CONCATENATED MODULE: ./apis/queryKeys/index.js









/***/ }),

/***/ 55918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);
/* harmony import */ var _utils_lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59926);


var sort = {
    date_updated: -1
};
var wishListKeys = {
    all: [
        {
            scope: "ecomwishlist",
            limit: 100,
            sort: sort
        }
    ],
    count: function(options) {
        return [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                scope: "ecomwishlist",
                type: "count"
            }, (0,_utils_lodash__WEBPACK_IMPORTED_MODULE_1__/* .flattenObj */ .nO)(options || {})), 
        ];
    },
    list: function(options) {
        return [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                scope: "ecomwishlist",
                type: "list",
                sort: sort
            }, (0,_utils_lodash__WEBPACK_IMPORTED_MODULE_1__/* .flattenObj */ .nO)(options || {})), 
        ];
    },
    detail: function(ma_vt) {
        return [
            {
                scope: "ecomwishlist",
                type: "detail",
                ma_vt: ma_vt
            }
        ];
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (wishListKeys);


/***/ }),

/***/ 6559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72445);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);






function Container(_param) {
    var children = _param.children, _fluid = _param.fluid, fluid = _fluid === void 0 ? false : _fluid, style = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "fluid"
    ]);
    if (fluid) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            size: 1440
        }, style), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        size: "xl"
    }, style), {
        children: children
    }));
};


/***/ }),

/***/ 3195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 2 modules
var Group = __webpack_require__(66137);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Input/Input.js + 11 modules
var Input = __webpack_require__(94151);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/TextInput/TextInput.js
var TextInput = __webpack_require__(80061);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(62679);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/List/List.js + 4 modules
var List = __webpack_require__(8949);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Divider/Divider.js + 1 modules
var Divider = __webpack_require__(54777);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ai/AiFillBank.js
var AiFillBank = __webpack_require__(45609);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ai/AiFillFacebook.js
var AiFillFacebook = __webpack_require__(92613);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ai/AiFillInstagram.js
var AiFillInstagram = __webpack_require__(11574);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ai/AiFillMail.js
var AiFillMail = __webpack_require__(50081);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ai/AiFillWallet.js
var AiFillWallet = __webpack_require__(95627);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ai/AiFillYoutube.js
var AiFillYoutube = __webpack_require__(9217);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaHandHoldingUsd.js
var FaHandHoldingUsd = __webpack_require__(60783);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mantine/form/esm/use-form.js + 15 modules
var use_form = __webpack_require__(98903);
// EXTERNAL MODULE: ./apis/queryFunctions/appInfo.js
var queryFunctions_appInfo = __webpack_require__(78055);
// EXTERNAL MODULE: ./apis/queryFunctions/ecompagesFunctions.js
var ecompagesFunctions = __webpack_require__(4088);
// EXTERNAL MODULE: ./apis/queryFunctions/subscribe.js
var subscribe = __webpack_require__(79122);
// EXTERNAL MODULE: ./hooks/useTrans.js + 2 modules
var useTrans = __webpack_require__(26679);
// EXTERNAL MODULE: ./setup/mantine-provider/notifications.js
var notifications = __webpack_require__(97744);
// EXTERNAL MODULE: ./utils/sanitizeDOMData.js + 1 modules
var sanitizeDOMData = __webpack_require__(2559);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/footer/subscribe_bg.jpg
/* harmony default export */ var subscribe_bg = ({"src":"/_next/static/media/subscribe_bg.69a9851b.jpg","height":161,"width":1348,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAABAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAZEAEAAgMAAAAAAAAAAAAAAAAAAQIDNXL/xAAVAQEBAAAAAAAAAAAAAAAAAAADBf/EABYRAQEBAAAAAAAAAAAAAAAAAAABMf/aAAwDAQACEQMRAD8Ah4ddbuQEKYWv/9k="});
// EXTERNAL MODULE: ./public/logo.png
var logo = __webpack_require__(13476);
// EXTERNAL MODULE: ./common/Layout/Container/Container.js
var Container = __webpack_require__(6559);
;// CONCATENATED MODULE: ./common/Layout/Footer/content.json
var content_namespaceObject = {};
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./common/Layout/Footer/styles.js


var useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        container: {
            display: "flex",
            flexDirection: "column",
            background: "#efefef",
            width: "100%"
        },
        logoWrapper: // width: "122px",
        (0,_define_property/* default */.Z)({
            position: "relative",
            aspectRatio: "2",
            height: "50px",
            marginBottom: "10px"
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            height: "40px"
        }),
        // Subscribe
        subscribe: {
            position: "relative",
            minWidth: "100%",
            // aspectRatio: "8.3",
            height: 161
        },
        bgSubscribe: {
            overflow: "hidden",
            minWidth: "100%",
            // aspectRatio: "8.37",
            height: 161,
            opacity: "0.4",
            display: "block",
            position: "absolute",
            left: 0,
            top: 0
        },
        subscribeContent: {
            position: "relative",
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        },
        // Info
        info: {
            display: "flex",
            flexDirection: "column",
            minWidth: "100%",
            background: "#1D2128",
            color: "#DEE1E6"
        },
        infoBody: {
            width: "100%",
            padding: "30px 0 20px"
        },
        // logoWrapper: {
        //   position: "relative",
        //   aspectRatio: "3.05",
        //   height: "50px",
        //   width: "152px",
        //   marginBottom: "10px",
        // },
        infoText: {
            transition: "0.3s",
            "&:hover": {
                color: theme.colors.main[5]
            }
        },
        infoText1: {
            "&::-moz-selection": {
                /* Code for Firefox */ background: "#000"
            },
            "&::selection": {
                background: "#000"
            }
        },
        contactItem: {
            display: "flex",
            alignItems: "center"
        },
        emailItem: {
            display: "flex",
            flexDirection: "column",
            paddingLeft: "10px"
        },
        infoBottom: {
            padding: "20px 0 25px",
            color: "#999999",
            fontWeight: "400",
            fontSize: 14
        }
    };
});
/* harmony default export */ var styles = (useStyles);

;// CONCATENATED MODULE: ./common/Layout/Footer/index.js





// import Link from "next/link";










// import Image from "next/image";
// import logo from "public/logo_white.png";












function Footer() {
    var ref, ref1;
    var trans = (0,useTrans/* default */.Z)();
    var classes = styles().classes;
    var locale = (0,router.useRouter)().locale;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    // const menu = content[locale].menu;
    var ref2 = (0,queryFunctions_appInfo/* useFetchAppInfo */.k0)({}), appInfo = ref2.data;
    var ref3 = (0,queryFunctions_appInfo/* useFetchProductLine */.jr)(), productLines = ref3.data;
    var ref4 = (0,ecompagesFunctions/* useFetchEcompages */.Lp)({
        sort: {
            sst: 1
        },
        limit: 5,
        condition: {
            ngon_ngu: locale,
            loai_tin_tuc: "Hướng dẫn",
            shared: true
        }
    }), huongDan = ref4.data;
    var ref5 = (0,ecompagesFunctions/* useFetchEcompages */.Lp)({
        sort: {
            sst: 1
        },
        limit: 20,
        condition: {
            ngon_ngu: locale,
            loai_tin_tuc: "Ch\xednh s\xe1ch kh\xe1ch h\xe0ng cafe",
            shared: true
        }
    }), cskh = ref5.data;
    // const cskhClone = cskh?.filter((x) => x?.slug.includes("cafe"));
    var linkPttt = cskh === null || cskh === void 0 ? void 0 : cskh.filter(function(x) {
        return x === null || x === void 0 ? void 0 : x.summary;
    })[0];
    var ref6 = (0,ecompagesFunctions/* useFetchEcompage */.VM)("trang-lien-he-viet-thien", locale), lienHe = ref6.data;
    var form = (0,use_form/* useForm */.c)({
        initialValues: {
            email: ""
        },
        validate: {
            email: function(value) {
                return value.length > 0 ? null : true;
            }
        }
    });
    var contactMutation = (0,useMutation/* useMutation */.D)(subscribe/* postSubscribe */.L, {
        onSuccess: function(rs) {
            if (rs._id) {
                (0,notifications/* appAlert */.t)({
                    type: "success",
                    message: trans === null || trans === void 0 ? void 0 : trans.subscribe.alertSuccess
                });
            } else {
                (0,notifications/* appAlert */.t)({
                    message: trans === null || trans === void 0 ? void 0 : trans.subscribe.alertFailed
                });
            }
            form.reset();
        }
    });
    var handleSubmit = function() {
        contactMutation.mutate((0,_object_spread/* default */.Z)({}, form.values));
    };
    var pathname = (0,router.useRouter)().pathname;
    var isLandingPage = pathname === "/ca-phe-danh-cho-quan" || pathname.startsWith("/ca-phe-danh-cho-quan/");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.container,
        children: [
            !isLandingPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.subscribe,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.bgSubscribe,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: subscribe_bg,
                            alt: "bg subscribe",
                            layout: "fill"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.subscribeContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                order: 4,
                                mb: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    weight: "normal",
                                    color: theme.colors.dark[9],
                                    sx: {
                                        letterSpacing: 2.5,
                                        "@media (max-width: 48em)": {
                                            fontSize: "1.2rem"
                                        }
                                    },
                                    align: "center",
                                    children: trans === null || trans === void 0 ? void 0 : trans.subscribe.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                onSubmit: form.onSubmit(handleSubmit),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                    spacing: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input.Wrapper */.I.Wrapper, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, (0,_object_spread/* default */.Z)({
                                                placeholder: trans === null || trans === void 0 ? void 0 : trans.subscribe.placeholder,
                                                radius: "md",
                                                styles: {
                                                    input: {
                                                        borderEndEndRadius: 0,
                                                        borderTopRightRadius: 0
                                                    }
                                                }
                                            }, form.getInputProps("email")))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            type: "submit",
                                            color: "dark",
                                            radius: "md",
                                            styles: {
                                                root: {
                                                    borderTopLeftRadius: 0,
                                                    borderEndStartRadius: 0
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                weight: "normal",
                                                children: trans === null || trans === void 0 ? void 0 : trans.subscribe.button
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.info,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    sx: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.infoBody,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid.Col */.r.Col, {
                                        xs: 12,
                                        sm: 6,
                                        md: 3,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.logoWrapper,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    scroll: false,
                                                    href: "/",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: classes.logo,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: logo/* default */.Z,
                                                                alt: "ZeMor coffee",
                                                                priority: true,
                                                                // layout="responsive"
                                                                width: 130,
                                                                height: 50,
                                                                objectFit: "contain"
                                                            })
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitle, {
                                                children: locale === "vi" ? appInfo === null || appInfo === void 0 ? void 0 : appInfo.name : appInfo === null || appInfo === void 0 ? void 0 : appInfo.name_en
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoText, {
                                                className: classes.infoText1,
                                                children: [
                                                    trans === null || trans === void 0 ? void 0 : trans.footer.addressLabel,
                                                    ":",
                                                    " ",
                                                    locale === "vi" ? appInfo === null || appInfo === void 0 ? void 0 : appInfo.address : appInfo === null || appInfo === void 0 ? void 0 : appInfo.address_en
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                style: {
                                                    position: "relative",
                                                    aspectRatio: "2.64",
                                                    width: "70%"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "http://online.gov.vn/Home/WebDetails/105657",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            alt: "",
                                                            src: "http://online.gov.vn/Content/EndUser/LogoCCDVSaleNoti/logoSaleNoti.png",
                                                            layout: "fill"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid.Col */.r.Col, {
                                        xs: 12,
                                        sm: 6,
                                        md: 3,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitle, {
                                                children: trans === null || trans === void 0 ? void 0 : trans.footer.customerPolicy
                                            }),
                                            cskh && cskh.map(function(item, k) {
                                                var ref;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)((link_default()), {
                                                    scroll: false,
                                                    href: "/chinh-sach/".concat(item === null || item === void 0 ? void 0 : item.slug),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                                                            className: classes.infoText,
                                                            children: item === null || item === void 0 ? void 0 : (ref = item.title) === null || ref === void 0 ? void 0 : ref.split("cafe")
                                                        })
                                                    })
                                                }, k);
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            Boolean(huongDan === null || huongDan === void 0 ? void 0 : huongDan.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitle, {
                                                children: "Hướng dẫn"
                                            }),
                                            huongDan && Boolean(huongDan === null || huongDan === void 0 ? void 0 : huongDan.length) && (huongDan === null || huongDan === void 0 ? void 0 : huongDan.map(function(item, k) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)((link_default()), {
                                                    scroll: false,
                                                    href: "/huong-dan/".concat(item === null || item === void 0 ? void 0 : item.slug),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                                                            className: classes.infoText,
                                                            children: item === null || item === void 0 ? void 0 : item.title
                                                        })
                                                    })
                                                }, k);
                                            }))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid.Col */.r.Col, {
                                        xs: 12,
                                        sm: 6,
                                        md: 3,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitle, {
                                                children: trans === null || trans === void 0 ? void 0 : trans.footer.contactInfo
                                            }),
                                            lienHe === null || lienHe === void 0 ? void 0 : (ref = lienHe.add_on_data) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(InfoText, {
                                                    className: classes.infoText1,
                                                    children: "".concat(item === null || item === void 0 ? void 0 : item.title, ": ").concat(item === null || item === void 0 ? void 0 : item.summary)
                                                }, index);
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                                                className: classes.infoText1,
                                                children: (productLines === null || productLines === void 0 ? void 0 : productLines.length) > 0 ? "Hotline: ".concat((ref1 = productLines[0]) === null || ref1 === void 0 ? void 0 : ref1.phone) : ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classes.contactItem,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                                                        className: classes.infoText1,
                                                        children: "Email:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: classes.emailItem,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                                                                className: classes.infoText1,
                                                                children: (appInfo === null || appInfo === void 0 ? void 0 : appInfo.email) ? "".concat(appInfo.email) : ""
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                                                                className: classes.infoText1,
                                                                children: "cskh@vietthien.com"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid.Col */.r.Col, {
                                        xs: 12,
                                        sm: 6,
                                        md: 3,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitle, {
                                                children: trans === null || trans === void 0 ? void 0 : trans.footer.followUs
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                                style: {
                                                    fontSize: 24
                                                },
                                                children: [
                                                    (productLines === null || productLines === void 0 ? void 0 : productLines.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        scroll: false,
                                                        href: productLines[0].facebook,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            "aria-label": "Facebook",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AiFillFacebook/* AiFillFacebook */.s, {})
                                                        })
                                                    }),
                                                    (appInfo === null || appInfo === void 0 ? void 0 : appInfo.instagram) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        scroll: false,
                                                        href: appInfo === null || appInfo === void 0 ? void 0 : appInfo.instagram,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            "aria-label": "Instagram",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AiFillInstagram/* AiFillInstagram */.t, {})
                                                        })
                                                    }),
                                                    (appInfo === null || appInfo === void 0 ? void 0 : appInfo.youtube) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        scroll: false,
                                                        href: appInfo === null || appInfo === void 0 ? void 0 : appInfo.youtube,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            "aria-label": "Youtube",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AiFillYoutube/* AiFillYoutube */.b, {})
                                                        })
                                                    }),
                                                    (appInfo === null || appInfo === void 0 ? void 0 : appInfo.email) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        scroll: false,
                                                        href: "mailto:".concat(appInfo === null || appInfo === void 0 ? void 0 : appInfo.email),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            "aria-label": "Email",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AiFillMail/* AiFillMail */.U, {})
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitle, {
                                                children: trans === null || trans === void 0 ? void 0 : trans.footer.payments
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* List */.a, {
                                                spacing: "xs",
                                                size: "sm",
                                                center: true,
                                                sx: {
                                                    color: "#fff"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaHandHoldingUsd/* FaHandHoldingUsd */.w, {}),
                                                        children: trans === null || trans === void 0 ? void 0 : trans.footer.cod
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AiFillBank/* AiFillBank */.Z, {}),
                                                        children: trans === null || trans === void 0 ? void 0 : trans.footer.bankTransfer
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AiFillWallet/* AiFillWallet */.J, {}),
                                                        children: trans === null || trans === void 0 ? void 0 : trans.footer.wallet
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                            my: "sm"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                            mb: "sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                                    children: trans === null || trans === void 0 ? void 0 : trans.footer.info1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                                    children: trans === null || trans === void 0 ? void 0 : trans.footer.info2
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
function InfoTitle(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
        size: "sm",
        transform: "uppercase",
        weight: "500",
        mb: 12,
        children: children
    });
}
function InfoText(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
        size: "sm",
        weight: "normal",
        mb: 4,
        className: className,
        children: children
    });
}


/***/ }),

/***/ 28964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/localStorage.js
var localStorage = __webpack_require__(44061);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Affix/Affix.js
var Affix = __webpack_require__(82846);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Overlay/Overlay.js + 1 modules
var Overlay = __webpack_require__(17577);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-resize-observer/use-resize-observer.js
var use_resize_observer = __webpack_require__(12185);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-window-scroll/use-window-scroll.js
var use_window_scroll = __webpack_require__(72128);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/scroll_to_top.png
/* harmony default export */ var scroll_to_top = ({"src":"/_next/static/media/scroll_to_top.81075441.png","height":256,"width":256,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEVIwn5Jwn9/1KVpzZZIwn9MaXFJwn9PxINOw4K/2t0nAAAACXRSTlP8tP7+KgDwKyuuugrDAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAMUlEQVQImUXKUQoAIAzD0HTrqvc/sQiCf4EXxkrkwQGIEXSDCF3V5Ieg6tKbF2MR7TkXMwCkgaSaLgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./common/components/ScrollToTop.js







function ScrollToTop() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_window_scroll/* useWindowScroll */.b)(), 2), scroll = ref[0], scrollTo = ref[1];
    return scroll.y > 400 ? // <div
    //   style={{
    //     position: "fixed",
    //     bottom: "74px",
    //     right: "24px",
    //     padding: "10px",
    //     cursor: "pointer",
    //     // width: "20px",
    //     // height: "20px",
    //   }}
    //   onClick={() => scrollTo({ y: 0 })}
    // >
    //   <Image src={top} alt="top" width={40} height={40} />
    //   {/* <FiNavigation2 color="blue" size={"30px"} /> */}
    // </div>
    /*#__PURE__*/ (0,jsx_runtime.jsx)(Affix/* Affix */.D, {
        position: {
            bottom: "74px",
            right: "24px"
        },
        zIndex: 100,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: function() {
                return scrollTo({
                    y: 0
                });
            },
            style: {
                cursor: "pointer"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: scroll_to_top,
                alt: "top",
                width: 40,
                height: 40
            })
        })
    }) : null;
};

// EXTERNAL MODULE: ./common/Layout/Footer/index.js + 3 modules
var Footer = __webpack_require__(3195);
// EXTERNAL MODULE: ./apis/queryFunctions/categoryFunctions.js
var categoryFunctions = __webpack_require__(46233);
// EXTERNAL MODULE: ./hooks/useAuth.js
var useAuth = __webpack_require__(35985);
// EXTERNAL MODULE: ./hooks/useTrans.js + 2 modules
var useTrans = __webpack_require__(26679);
// EXTERNAL MODULE: ./hooks/useUserInfo.js
var useUserInfo = __webpack_require__(15170);
// EXTERNAL MODULE: ./setup/cartProvider/index.js + 2 modules
var cartProvider = __webpack_require__(27104);
// EXTERNAL MODULE: ./setup/locale-provider/index.js
var locale_provider = __webpack_require__(59963);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(62679);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Burger/Burger.styles.js


const sizes = {
  xs: 12,
  sm: 18,
  md: 24,
  lg: 34,
  xl: 42
};
var useStyles = (0,create_styles/* createStyles */.k)((theme, { size, color, transitionDuration }) => {
  const sizeValue = theme.fn.size({ size, sizes });
  const _color = color || (theme.colorScheme === "dark" ? theme.white : theme.black);
  return {
    root: {
      borderRadius: theme.radius.sm,
      width: `calc(${sizeValue}px + ${theme.spacing.xs}px)`,
      height: `calc(${sizeValue}px + ${theme.spacing.xs}px)`,
      padding: `calc(${theme.spacing.xs}px / 2)`,
      cursor: "pointer"
    },
    burger: {
      position: "relative",
      userSelect: "none",
      boxSizing: "border-box",
      "&, &::before, &::after": {
        display: "block",
        width: sizeValue,
        height: Math.ceil(sizeValue / 12),
        backgroundColor: _color,
        outline: "1px solid transparent",
        transitionProperty: "background-color, transform",
        transitionDuration: `${transitionDuration}ms`,
        "@media (prefers-reduced-motion)": {
          transitionDuration: theme.respectReducedMotion ? "0ms" : void 0
        }
      },
      "&::before, &::after": {
        position: "absolute",
        content: '""',
        left: 0
      },
      "&::before": {
        top: sizeValue / 3 * -1
      },
      "&::after": {
        top: sizeValue / 3
      },
      "&[data-opened]": {
        backgroundColor: "transparent",
        "&::before": {
          transform: `translateY(${sizeValue / 3}px) rotate(45deg)`
        },
        "&::after": {
          transform: `translateY(-${sizeValue / 3}px) rotate(-45deg)`
        }
      }
    }
  };
});

/* harmony default export */ var Burger_styles = (useStyles);
//# sourceMappingURL=Burger.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.js + 1 modules
var UnstyledButton = __webpack_require__(34736);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Burger/Burger.js





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  size: "md",
  transitionDuration: 300
};
const Burger = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Burger", defaultProps, props), { className, opened, color, size, classNames, styles, transitionDuration } = _a, others = __objRest(_a, ["className", "opened", "color", "size", "classNames", "styles", "transitionDuration"]);
  const { classes, cx } = Burger_styles({ color, size, transitionDuration }, { classNames, styles, name: "Burger" });
  return /* @__PURE__ */ react.createElement(UnstyledButton/* UnstyledButton */.k, __spreadValues({
    className: cx(classes.root, className),
    ref
  }, others), /* @__PURE__ */ react.createElement("div", {
    "data-opened": opened || void 0,
    className: classes.burger
  }));
});
Burger.displayName = "@mantine/core/Burger";


//# sourceMappingURL=Burger.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
;// CONCATENATED MODULE: ./node_modules/@mantine/utils/esm/use-hovered/use-hovered.js


function useHovered() {
  const [hovered, setHovered] = (0,react.useState)(-1);
  const resetHovered = () => setHovered(-1);
  return [hovered, { setHovered, resetHovered }];
}


//# sourceMappingURL=use-hovered.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/find-element-ancestor/find-element-ancestor.js
var find_element_ancestor = __webpack_require__(38523);
;// CONCATENATED MODULE: ./node_modules/@mantine/utils/esm/get-context-item-index/get-context-item-index.js


function getContextItemIndex(elementSelector, parentSelector, node) {
  var _a;
  if (!node) {
    return null;
  }
  return Array.from(((_a = (0,find_element_ancestor/* findElementAncestor */.p)(node, parentSelector)) == null ? void 0 : _a.querySelectorAll(elementSelector)) || []).findIndex((element) => element === node);
}


//# sourceMappingURL=get-context-item-index.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-uncontrolled/use-uncontrolled.js
var use_uncontrolled = __webpack_require__(15851);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-did-update/use-did-update.js
var use_did_update = __webpack_require__(37048);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-safe-context/create-safe-context.js
var create_safe_context = __webpack_require__(68216);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/Menu.errors.js
const MENU_ERRORS = {
  context: "Menu component was not found in the tree",
  children: "Menu.Target component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported"
};


//# sourceMappingURL=Menu.errors.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/Menu.context.js



const [MenuContextProvider, useMenuContext] = (0,create_safe_context/* createSafeContext */.R)(MENU_ERRORS.context);


//# sourceMappingURL=Menu.context.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuDivider/MenuDivider.styles.js


var MenuDivider_styles_useStyles = (0,create_styles/* createStyles */.k)((theme) => ({
  divider: {
    margin: `calc(${theme.spacing.xs}px / 2) -5px`,
    borderTop: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2]}`
  }
}));

/* harmony default export */ var MenuDivider_styles = (MenuDivider_styles_useStyles);
//# sourceMappingURL=MenuDivider.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuDivider/MenuDivider.js






var MenuDivider_defProp = Object.defineProperty;
var MenuDivider_getOwnPropSymbols = Object.getOwnPropertySymbols;
var MenuDivider_hasOwnProp = Object.prototype.hasOwnProperty;
var MenuDivider_propIsEnum = Object.prototype.propertyIsEnumerable;
var MenuDivider_defNormalProp = (obj, key, value) => key in obj ? MenuDivider_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var MenuDivider_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (MenuDivider_hasOwnProp.call(b, prop))
      MenuDivider_defNormalProp(a, prop, b[prop]);
  if (MenuDivider_getOwnPropSymbols)
    for (var prop of MenuDivider_getOwnPropSymbols(b)) {
      if (MenuDivider_propIsEnum.call(b, prop))
        MenuDivider_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var MenuDivider_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (MenuDivider_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && MenuDivider_getOwnPropSymbols)
    for (var prop of MenuDivider_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && MenuDivider_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MenuDivider_defaultProps = {};
const MenuDivider = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("MenuDivider", MenuDivider_defaultProps, props), { children, className } = _a, others = MenuDivider_objRest(_a, ["children", "className"]);
  const { classNames, styles, unstyled } = useMenuContext();
  const { classes, cx } = MenuDivider_styles(null, { name: "Menu", classNames, styles, unstyled });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, MenuDivider_spreadValues({
    className: cx(classes.divider, className),
    ref
  }, others));
});
MenuDivider.displayName = "@mantine/core/MenuDivider";


//# sourceMappingURL=MenuDivider.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-event-handler/create-event-handler.js
var create_event_handler = __webpack_require__(69328);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Popover/Popover.js + 10 modules
var Popover = __webpack_require__(25944);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuDropdown/MenuDropdown.js






var MenuDropdown_defProp = Object.defineProperty;
var MenuDropdown_getOwnPropSymbols = Object.getOwnPropertySymbols;
var MenuDropdown_hasOwnProp = Object.prototype.hasOwnProperty;
var MenuDropdown_propIsEnum = Object.prototype.propertyIsEnumerable;
var MenuDropdown_defNormalProp = (obj, key, value) => key in obj ? MenuDropdown_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var MenuDropdown_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (MenuDropdown_hasOwnProp.call(b, prop))
      MenuDropdown_defNormalProp(a, prop, b[prop]);
  if (MenuDropdown_getOwnPropSymbols)
    for (var prop of MenuDropdown_getOwnPropSymbols(b)) {
      if (MenuDropdown_propIsEnum.call(b, prop))
        MenuDropdown_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var MenuDropdown_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (MenuDropdown_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && MenuDropdown_getOwnPropSymbols)
    for (var prop of MenuDropdown_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && MenuDropdown_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MenuDropdown_defaultProps = {};
function MenuDropdown(props) {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("MenuDropdown", MenuDropdown_defaultProps, props), { children, onMouseEnter, onMouseLeave } = _a, others = MenuDropdown_objRest(_a, ["children", "onMouseEnter", "onMouseLeave"]);
  const wrapperRef = (0,react.useRef)();
  const ctx = useMenuContext();
  const handleKeyDown = (event) => {
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault();
      wrapperRef.current.querySelectorAll("[data-menu-item]")[0].focus();
    }
  };
  const handleMouseEnter = (0,create_event_handler/* createEventHandler */.x)(onMouseEnter, () => ctx.trigger === "hover" && ctx.openDropdown());
  const handleMouseLeave = (0,create_event_handler/* createEventHandler */.x)(onMouseLeave, () => ctx.trigger === "hover" && ctx.closeDropdown());
  return /* @__PURE__ */ react.createElement(Popover/* Popover.Dropdown */.J.Dropdown, MenuDropdown_spreadValues({
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    role: "menu",
    "aria-orientation": "vertical"
  }, others), /* @__PURE__ */ react.createElement("div", {
    tabIndex: -1,
    "data-menu-dropdown": true,
    "data-autofocus": true,
    onKeyDown: handleKeyDown,
    ref: wrapperRef,
    style: { outline: 0 }
  }, children));
}
MenuDropdown.displayName = "@mantine/core/MenuDropdown";


//# sourceMappingURL=MenuDropdown.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-scoped-keydown-handler/create-scoped-keydown-handler.js
var create_scoped_keydown_handler = __webpack_require__(16650);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-merged-ref/use-merged-ref.js
var use_merged_ref = __webpack_require__(80665);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuItem/MenuItem.styles.js


var MenuItem_styles_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var MenuItem_styles_getOwnPropSymbols = Object.getOwnPropertySymbols;
var MenuItem_styles_hasOwnProp = Object.prototype.hasOwnProperty;
var MenuItem_styles_propIsEnum = Object.prototype.propertyIsEnumerable;
var MenuItem_styles_defNormalProp = (obj, key, value) => key in obj ? MenuItem_styles_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var MenuItem_styles_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (MenuItem_styles_hasOwnProp.call(b, prop))
      MenuItem_styles_defNormalProp(a, prop, b[prop]);
  if (MenuItem_styles_getOwnPropSymbols)
    for (var prop of MenuItem_styles_getOwnPropSymbols(b)) {
      if (MenuItem_styles_propIsEnum.call(b, prop))
        MenuItem_styles_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var MenuItem_styles_useStyles = (0,create_styles/* createStyles */.k)((theme, { color, radius }) => ({
  item: __spreadProps(MenuItem_styles_spreadValues({}, theme.fn.fontStyles()), {
    WebkitTapHighlightColor: "transparent",
    fontSize: theme.fontSizes.sm,
    border: 0,
    backgroundColor: "transparent",
    outline: 0,
    width: "100%",
    textAlign: "left",
    textDecoration: "none",
    boxSizing: "border-box",
    padding: `${theme.spacing.xs}px ${theme.spacing.sm}px`,
    cursor: "pointer",
    borderRadius: theme.fn.radius(radius),
    color: color ? theme.fn.variant({ variant: "filled", primaryFallback: false, color }).background : theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    display: "flex",
    alignItems: "center",
    "&:disabled": {
      color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5],
      pointerEvents: "none",
      userSelect: "none"
    },
    "&[data-hovered]": {
      backgroundColor: color ? theme.fn.variant({ variant: "light", color }).background : theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[3], 0.35) : theme.colors.gray[1]
    }
  }),
  itemLabel: {
    flex: 1
  },
  itemIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: theme.spacing.xs
  },
  itemRightSection: {}
}));

/* harmony default export */ var MenuItem_styles = (MenuItem_styles_useStyles);
//# sourceMappingURL=MenuItem.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuItem/MenuItem.js








var MenuItem_defProp = Object.defineProperty;
var MenuItem_defProps = Object.defineProperties;
var MenuItem_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var MenuItem_getOwnPropSymbols = Object.getOwnPropertySymbols;
var MenuItem_hasOwnProp = Object.prototype.hasOwnProperty;
var MenuItem_propIsEnum = Object.prototype.propertyIsEnumerable;
var MenuItem_defNormalProp = (obj, key, value) => key in obj ? MenuItem_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var MenuItem_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (MenuItem_hasOwnProp.call(b, prop))
      MenuItem_defNormalProp(a, prop, b[prop]);
  if (MenuItem_getOwnPropSymbols)
    for (var prop of MenuItem_getOwnPropSymbols(b)) {
      if (MenuItem_propIsEnum.call(b, prop))
        MenuItem_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var MenuItem_spreadProps = (a, b) => MenuItem_defProps(a, MenuItem_getOwnPropDescs(b));
var MenuItem_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (MenuItem_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && MenuItem_getOwnPropSymbols)
    for (var prop of MenuItem_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && MenuItem_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MenuItem_defaultProps = {};
const _MenuItem = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("MenuItem", MenuItem_defaultProps, props), { children, className, color, closeMenuOnClick, icon, rightSection } = _a, others = MenuItem_objRest(_a, ["children", "className", "color", "closeMenuOnClick", "icon", "rightSection"]);
  const ctx = useMenuContext();
  const { classes, cx, theme } = MenuItem_styles({ radius: ctx.radius, color }, { name: "Menu", classNames: ctx.classNames, styles: ctx.styles, unstyled: ctx.unstyled });
  const itemRef = (0,react.useRef)();
  const itemIndex = ctx.getItemIndex(itemRef.current);
  const _others = others;
  const handleMouseLeave = (0,create_event_handler/* createEventHandler */.x)(_others.onMouseLeave, () => ctx.setHovered(-1));
  const handleMouseEnter = (0,create_event_handler/* createEventHandler */.x)(_others.onMouseEnter, () => ctx.setHovered(ctx.getItemIndex(itemRef.current)));
  const handleClick = (0,create_event_handler/* createEventHandler */.x)(_others.onClick, () => {
    if (typeof closeMenuOnClick === "boolean") {
      closeMenuOnClick && ctx.closeDropdownImmediately();
    } else {
      ctx.closeOnItemClick && ctx.closeDropdownImmediately();
    }
  });
  const handleFocus = (0,create_event_handler/* createEventHandler */.x)(_others.onFocus, () => ctx.setHovered(ctx.getItemIndex(itemRef.current)));
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, MenuItem_spreadProps(MenuItem_spreadValues({
    component: "button",
    type: "button"
  }, others), {
    tabIndex: -1,
    onFocus: handleFocus,
    className: cx(classes.item, className),
    ref: (0,use_merged_ref/* useMergedRef */.Y)(itemRef, ref),
    role: "menuitem",
    "data-menu-item": true,
    "data-hovered": ctx.hovered === itemIndex ? true : void 0,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleClick,
    onKeyDown: (0,create_scoped_keydown_handler/* createScopedKeydownHandler */.R)({
      siblingSelector: "[data-menu-item]",
      parentSelector: "[data-menu-dropdown]",
      activateOnFocus: false,
      loop: ctx.loop,
      dir: theme.dir,
      orientation: "vertical",
      onKeyDown: _others.onKeydown
    })
  }), icon && /* @__PURE__ */ react.createElement("div", {
    className: classes.itemIcon
  }, icon), children && /* @__PURE__ */ react.createElement("div", {
    className: classes.itemLabel
  }, children), rightSection && /* @__PURE__ */ react.createElement("div", {
    className: classes.itemRightSection
  }, rightSection));
});
_MenuItem.displayName = "@mantine/core/MenuItem";
const MenuItem = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_MenuItem);


//# sourceMappingURL=MenuItem.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuLabel/MenuLabel.styles.js


var MenuLabel_styles_useStyles = (0,create_styles/* createStyles */.k)((theme) => ({
  label: {
    color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
    fontWeight: 500,
    fontSize: theme.fontSizes.xs,
    padding: `calc(${theme.spacing.xs}px / 2) ${theme.spacing.sm}px`,
    cursor: "default"
  }
}));

/* harmony default export */ var MenuLabel_styles = (MenuLabel_styles_useStyles);
//# sourceMappingURL=MenuLabel.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuLabel/MenuLabel.js






var MenuLabel_defProp = Object.defineProperty;
var MenuLabel_getOwnPropSymbols = Object.getOwnPropertySymbols;
var MenuLabel_hasOwnProp = Object.prototype.hasOwnProperty;
var MenuLabel_propIsEnum = Object.prototype.propertyIsEnumerable;
var MenuLabel_defNormalProp = (obj, key, value) => key in obj ? MenuLabel_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var MenuLabel_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (MenuLabel_hasOwnProp.call(b, prop))
      MenuLabel_defNormalProp(a, prop, b[prop]);
  if (MenuLabel_getOwnPropSymbols)
    for (var prop of MenuLabel_getOwnPropSymbols(b)) {
      if (MenuLabel_propIsEnum.call(b, prop))
        MenuLabel_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var MenuLabel_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (MenuLabel_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && MenuLabel_getOwnPropSymbols)
    for (var prop of MenuLabel_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && MenuLabel_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MenuLabel_defaultProps = {};
const MenuLabel = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("MenuLabel", MenuLabel_defaultProps, props), { children, className } = _a, others = MenuLabel_objRest(_a, ["children", "className"]);
  const { classNames, styles, unstyled } = useMenuContext();
  const { classes, cx } = MenuLabel_styles(null, { name: "Menu", classNames, styles, unstyled });
  return /* @__PURE__ */ react.createElement(Text/* Text */.x, MenuLabel_spreadValues({
    className: cx(classes.label, className),
    ref
  }, others), children);
});
MenuLabel.displayName = "@mantine/core/MenuLabel";


//# sourceMappingURL=MenuLabel.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/is-element/is-element.js
var is_element = __webpack_require__(24241);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuTarget/MenuTarget.js







var MenuTarget_defProp = Object.defineProperty;
var MenuTarget_getOwnPropSymbols = Object.getOwnPropertySymbols;
var MenuTarget_hasOwnProp = Object.prototype.hasOwnProperty;
var MenuTarget_propIsEnum = Object.prototype.propertyIsEnumerable;
var MenuTarget_defNormalProp = (obj, key, value) => key in obj ? MenuTarget_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var MenuTarget_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (MenuTarget_hasOwnProp.call(b, prop))
      MenuTarget_defNormalProp(a, prop, b[prop]);
  if (MenuTarget_getOwnPropSymbols)
    for (var prop of MenuTarget_getOwnPropSymbols(b)) {
      if (MenuTarget_propIsEnum.call(b, prop))
        MenuTarget_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var MenuTarget_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (MenuTarget_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && MenuTarget_getOwnPropSymbols)
    for (var prop of MenuTarget_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && MenuTarget_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MenuTarget_defaultProps = {
  refProp: "ref"
};
const MenuTarget = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("MenuTarget", MenuTarget_defaultProps, props), { children, refProp } = _a, others = MenuTarget_objRest(_a, ["children", "refProp"]);
  if (!(0,is_element/* isElement */.k)(children)) {
    throw new Error(MENU_ERRORS.children);
  }
  const ctx = useMenuContext();
  const onClick = (0,create_event_handler/* createEventHandler */.x)(children.props.onClick, () => ctx.trigger === "click" && ctx.toggleDropdown());
  const onMouseEnter = (0,create_event_handler/* createEventHandler */.x)(children.props.onMouseEnter, () => ctx.trigger === "hover" && ctx.openDropdown());
  const onMouseLeave = (0,create_event_handler/* createEventHandler */.x)(children.props.onMouseLeave, () => ctx.trigger === "hover" && ctx.closeDropdown());
  return /* @__PURE__ */ react.createElement(Popover/* Popover.Target */.J.Target, MenuTarget_spreadValues({
    refProp,
    popupType: "menu",
    ref
  }, others), (0,react.cloneElement)(children, {
    onClick,
    onMouseEnter,
    onMouseLeave,
    "data-expanded": ctx.opened ? true : void 0
  }));
});
MenuTarget.displayName = "@mantine/core/MenuTarget";


//# sourceMappingURL=MenuTarget.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/Menu.styles.js


var Menu_styles_useStyles = (0,create_styles/* createStyles */.k)({
  dropdown: { padding: 4 }
});

/* harmony default export */ var Menu_styles = (Menu_styles_useStyles);
//# sourceMappingURL=Menu.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Floating/use-delayed-hover.js
var use_delayed_hover = __webpack_require__(27347);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/Menu.js














var Menu_defProp = Object.defineProperty;
var Menu_defProps = Object.defineProperties;
var Menu_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Menu_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Menu_hasOwnProp = Object.prototype.hasOwnProperty;
var Menu_propIsEnum = Object.prototype.propertyIsEnumerable;
var Menu_defNormalProp = (obj, key, value) => key in obj ? Menu_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Menu_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Menu_hasOwnProp.call(b, prop))
      Menu_defNormalProp(a, prop, b[prop]);
  if (Menu_getOwnPropSymbols)
    for (var prop of Menu_getOwnPropSymbols(b)) {
      if (Menu_propIsEnum.call(b, prop))
        Menu_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Menu_spreadProps = (a, b) => Menu_defProps(a, Menu_getOwnPropDescs(b));
var Menu_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Menu_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Menu_getOwnPropSymbols)
    for (var prop of Menu_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Menu_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Menu_defaultProps = {
  closeOnItemClick: true,
  loop: true,
  trigger: "click",
  openDelay: 0,
  closeDelay: 100
};
function Menu(props) {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Menu", Menu_defaultProps, props), {
    children,
    onOpen,
    onClose,
    opened,
    defaultOpened,
    onChange,
    closeOnItemClick,
    loop,
    closeOnEscape,
    trigger,
    openDelay,
    closeDelay,
    classNames,
    styles,
    unstyled,
    radius
  } = _a, others = Menu_objRest(_a, [
    "children",
    "onOpen",
    "onClose",
    "opened",
    "defaultOpened",
    "onChange",
    "closeOnItemClick",
    "loop",
    "closeOnEscape",
    "trigger",
    "openDelay",
    "closeDelay",
    "classNames",
    "styles",
    "unstyled",
    "radius"
  ]);
  const { classes, cx } = Menu_styles();
  const [hovered, { setHovered, resetHovered }] = useHovered();
  const [_opened, setOpened] = (0,use_uncontrolled/* useUncontrolled */.C)({
    value: opened,
    defaultValue: defaultOpened,
    finalValue: false,
    onChange
  });
  const close = () => {
    setOpened(false);
    _opened && (onClose == null ? void 0 : onClose());
  };
  const open = () => {
    setOpened(true);
    !_opened && (onOpen == null ? void 0 : onOpen());
  };
  const toggleDropdown = () => _opened ? close() : open();
  const { openDropdown, closeDropdown } = (0,use_delayed_hover/* useDelayedHover */.U)({ open, close, closeDelay, openDelay });
  const getItemIndex = (node) => getContextItemIndex("[data-menu-item]", "[data-menu-dropdown]", node);
  (0,use_did_update/* useDidUpdate */.l)(() => {
    resetHovered();
  }, [_opened]);
  return /* @__PURE__ */ react.createElement(MenuContextProvider, {
    value: {
      opened: _opened,
      toggleDropdown,
      getItemIndex,
      hovered,
      setHovered,
      closeOnItemClick,
      closeDropdown: trigger === "click" ? close : closeDropdown,
      openDropdown: trigger === "click" ? open : openDropdown,
      closeDropdownImmediately: close,
      loop,
      trigger,
      radius,
      classNames,
      styles,
      unstyled
    }
  }, /* @__PURE__ */ react.createElement(Popover/* Popover */.J, Menu_spreadProps(Menu_spreadValues({}, others), {
    radius,
    opened: _opened,
    onChange: setOpened,
    defaultOpened,
    trapFocus: trigger === "click",
    closeOnEscape: closeOnEscape && trigger === "click",
    __staticSelector: "Menu",
    classNames: Menu_spreadProps(Menu_spreadValues({}, classNames), { dropdown: cx(classes.dropdown, classNames == null ? void 0 : classNames.dropdown) }),
    styles,
    unstyled,
    onClose: close,
    onOpen: open
  }), children));
}
Menu.displayName = "@mantine/core/Menu";
Menu.Item = MenuItem;
Menu.Label = MenuLabel;
Menu.Dropdown = MenuDropdown;
Menu.Target = MenuTarget;
Menu.Divider = MenuDivider;


//# sourceMappingURL=Menu.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Indicator/Indicator.js + 6 modules
var Indicator = __webpack_require__(36155);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 2 modules
var Group = __webpack_require__(66137);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Avatar/Avatar.js + 5 modules
var Avatar = __webpack_require__(99985);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Modal/Modal.js + 1 modules
var Modal = __webpack_require__(38090);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/bs/BsFillPersonFill.js
var BsFillPersonFill = __webpack_require__(56570);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ri/RiShoppingBag2Line.js
var RiShoppingBag2Line = __webpack_require__(67578);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ri/RiShoppingBag3Fill.js
var RiShoppingBag3Fill = __webpack_require__(72545);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./public/logo.png
var logo = __webpack_require__(13476);
;// CONCATENATED MODULE: ./public/LandingPage/logoVT.png
/* harmony default export */ var logoVT = ({"src":"/_next/static/media/logoVT.efc7c8b4.png","height":90,"width":198,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAKlBMVEX///////9MaXH////////+/v7////////////+/v7////+/v7///////96e/iHAAAADnRSTlMqwgCOcc3kXRYVowtDsMY9dRsAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAnSURBVAiZBcGJAQAgCAOxawHx3X9dE87FqbGhE5UW0aka05gXgf0BCosAhxT9ST0AAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./utils/appendImageUrlFromAPI.js
var appendImageUrlFromAPI = __webpack_require__(22312);
// EXTERNAL MODULE: ./common/Layout/Container/Container.js
var Container = __webpack_require__(6559);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-id/use-id.js
var use_id = __webpack_require__(36289);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-focus-trap/use-focus-trap.js + 3 modules
var use_focus_trap = __webpack_require__(95909);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-scroll-lock/use-scroll-lock.js + 5 modules
var use_scroll_lock = __webpack_require__(83317);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-focus-return/use-focus-return.js
var use_focus_return = __webpack_require__(96362);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/utils/get-default-z-index/get-default-z-index.js
var get_default_z_index = __webpack_require__(3594);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Drawer/Drawer.styles.js


var Drawer_styles_defProp = Object.defineProperty;
var Drawer_styles_defProps = Object.defineProperties;
var Drawer_styles_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Drawer_styles_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Drawer_styles_hasOwnProp = Object.prototype.hasOwnProperty;
var Drawer_styles_propIsEnum = Object.prototype.propertyIsEnumerable;
var Drawer_styles_defNormalProp = (obj, key, value) => key in obj ? Drawer_styles_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Drawer_styles_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Drawer_styles_hasOwnProp.call(b, prop))
      Drawer_styles_defNormalProp(a, prop, b[prop]);
  if (Drawer_styles_getOwnPropSymbols)
    for (var prop of Drawer_styles_getOwnPropSymbols(b)) {
      if (Drawer_styles_propIsEnum.call(b, prop))
        Drawer_styles_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Drawer_styles_spreadProps = (a, b) => Drawer_styles_defProps(a, Drawer_styles_getOwnPropDescs(b));
const Drawer_styles_sizes = {
  xs: 180,
  sm: 240,
  md: 320,
  lg: 360,
  xl: 500,
  full: "100%"
};
function getPositionStyles({
  position,
  size,
  theme
}) {
  switch (position) {
    case "top":
      return { top: 0, left: 0, right: 0, height: theme.fn.size({ size, sizes: Drawer_styles_sizes }) };
    case "bottom":
      return { bottom: 0, left: 0, right: 0, height: theme.fn.size({ size, sizes: Drawer_styles_sizes }) };
    case "right":
      return { bottom: 0, top: 0, right: 0, width: theme.fn.size({ size, sizes: Drawer_styles_sizes }) };
    case "left":
      return { bottom: 0, top: 0, left: 0, width: theme.fn.size({ size, sizes: Drawer_styles_sizes }) };
    default:
      return null;
  }
}
var Drawer_styles_useStyles = (0,create_styles/* createStyles */.k)((theme, { position, size, zIndex, withOverlay }) => ({
  closeButton: {},
  overlay: {},
  body: {},
  root: {
    position: "fixed",
    zIndex,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: withOverlay === false ? "none" : void 0
  },
  drawer: Drawer_styles_spreadProps(Drawer_styles_spreadValues({}, getPositionStyles({ position, size, theme })), {
    maxWidth: "100%",
    maxHeight: "100vh",
    position: "fixed",
    outline: 0,
    zIndex: 1,
    pointerEvents: withOverlay === false ? "auto" : void 0
  }),
  title: {
    marginRight: theme.spacing.md,
    textOverflow: "ellipsis",
    display: "block",
    wordBreak: "break-word"
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing.md
  }
}));

/* harmony default export */ var Drawer_styles = (Drawer_styles_useStyles);
//# sourceMappingURL=Drawer.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Portal/OptionalPortal.js
var OptionalPortal = __webpack_require__(83143);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Transition/GroupedTransition.js
var GroupedTransition = __webpack_require__(75933);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(82623);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/CloseButton/CloseButton.js + 1 modules
var CloseButton = __webpack_require__(80971);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Drawer/Drawer.js












var Drawer_defProp = Object.defineProperty;
var Drawer_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Drawer_hasOwnProp = Object.prototype.hasOwnProperty;
var Drawer_propIsEnum = Object.prototype.propertyIsEnumerable;
var Drawer_defNormalProp = (obj, key, value) => key in obj ? Drawer_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Drawer_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Drawer_hasOwnProp.call(b, prop))
      Drawer_defNormalProp(a, prop, b[prop]);
  if (Drawer_getOwnPropSymbols)
    for (var prop of Drawer_getOwnPropSymbols(b)) {
      if (Drawer_propIsEnum.call(b, prop))
        Drawer_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Drawer_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Drawer_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Drawer_getOwnPropSymbols)
    for (var prop of Drawer_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Drawer_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const transitions = {
  top: "slide-down",
  bottom: "slide-up",
  left: "slide-right",
  right: "slide-left"
};
const rtlTransitions = {
  top: "slide-down",
  bottom: "slide-up",
  right: "slide-right",
  left: "slide-left"
};
const Drawer_defaultProps = {
  position: "left",
  size: "md",
  transitionDuration: 250,
  transitionTimingFunction: "ease",
  zIndex: (0,get_default_z_index/* getDefaultZIndex */.w)("modal"),
  shadow: "md",
  padding: 0,
  lockScroll: true,
  closeOnClickOutside: true,
  closeOnEscape: true,
  trapFocus: true,
  withOverlay: true,
  withCloseButton: true,
  withinPortal: true,
  withFocusReturn: true,
  overlayBlur: 0
};
function Drawer(props) {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Drawer", Drawer_defaultProps, props), {
    className,
    opened,
    onClose,
    position,
    size,
    trapFocus,
    lockScroll,
    closeOnClickOutside,
    closeOnEscape,
    transition,
    transitionDuration,
    transitionTimingFunction,
    zIndex,
    overlayColor,
    overlayOpacity,
    children,
    withOverlay,
    shadow,
    id,
    padding,
    title,
    withCloseButton,
    closeButtonLabel,
    classNames,
    styles,
    target,
    withinPortal,
    overlayBlur,
    unstyled,
    withFocusReturn
  } = _a, others = Drawer_objRest(_a, [
    "className",
    "opened",
    "onClose",
    "position",
    "size",
    "trapFocus",
    "lockScroll",
    "closeOnClickOutside",
    "closeOnEscape",
    "transition",
    "transitionDuration",
    "transitionTimingFunction",
    "zIndex",
    "overlayColor",
    "overlayOpacity",
    "children",
    "withOverlay",
    "shadow",
    "id",
    "padding",
    "title",
    "withCloseButton",
    "closeButtonLabel",
    "classNames",
    "styles",
    "target",
    "withinPortal",
    "overlayBlur",
    "unstyled",
    "withFocusReturn"
  ]);
  const baseId = (0,use_id/* useId */.M)(id);
  const titleId = `${baseId}-title`;
  const bodyId = `${baseId}-body`;
  const { classes, cx, theme } = Drawer_styles({ size, position, zIndex, withOverlay }, { classNames, styles, unstyled, name: "Drawer" });
  const focusTrapRef = (0,use_focus_trap/* useFocusTrap */.P)(trapFocus && opened);
  const [, _lockScroll] = (0,use_scroll_lock/* useScrollLock */.P)();
  const drawerTransition = transition || (theme.dir === "rtl" ? rtlTransitions : transitions)[position];
  const _overlayOpacity = typeof overlayOpacity === "number" ? overlayOpacity : theme.colorScheme === "dark" ? 0.85 : 0.75;
  const _closeOnEscape = (event) => {
    if (event.key === "Escape" && closeOnEscape) {
      onClose();
    }
  };
  (0,react.useEffect)(() => {
    if (!trapFocus) {
      window.addEventListener("keydown", _closeOnEscape);
      return () => window.removeEventListener("keydown", _closeOnEscape);
    }
    return void 0;
  }, [trapFocus]);
  (0,use_focus_return/* useFocusReturn */.u)({ opened, shouldReturnFocus: trapFocus && withFocusReturn });
  return /* @__PURE__ */ react.createElement(OptionalPortal/* OptionalPortal */.q, {
    withinPortal,
    target
  }, /* @__PURE__ */ react.createElement(GroupedTransition/* GroupedTransition */.p, {
    onExited: () => _lockScroll(false),
    onEntered: () => _lockScroll(lockScroll && true),
    mounted: opened,
    duration: transitionDuration,
    timingFunction: transitionTimingFunction,
    transitions: {
      overlay: { duration: transitionDuration / 2, transition: "fade", timingFunction: "ease" },
      drawer: {
        duration: transitionDuration,
        transition: drawerTransition,
        timingFunction: transitionTimingFunction
      }
    }
  }, (transitionStyles) => /* @__PURE__ */ react.createElement(Box/* Box */.x, Drawer_spreadValues({
    className: cx(classes.root, className),
    role: "dialog",
    "aria-modal": true,
    "aria-labelledby": titleId,
    "aria-describedby": bodyId
  }, others), /* @__PURE__ */ react.createElement(Paper/* Paper */.X, {
    className: cx(classes.drawer, className),
    ref: focusTrapRef,
    style: transitionStyles.drawer,
    radius: 0,
    tabIndex: -1,
    onKeyDownCapture: (event) => {
      var _a2;
      const shouldTrigger = ((_a2 = event.target) == null ? void 0 : _a2.getAttribute("data-mantine-stop-propagation")) !== "true";
      shouldTrigger && event.key === "Escape" && closeOnEscape && onClose();
    },
    shadow,
    p: padding,
    unstyled
  }, (title || withCloseButton) && /* @__PURE__ */ react.createElement("div", {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(Text/* Text */.x, {
    id: titleId,
    className: classes.title,
    unstyled
  }, title), withCloseButton && /* @__PURE__ */ react.createElement(CloseButton/* CloseButton */.P, {
    iconSize: 16,
    onClick: onClose,
    "aria-label": closeButtonLabel,
    className: classes.closeButton,
    unstyled
  })), /* @__PURE__ */ react.createElement("div", {
    id: bodyId,
    className: classes.body
  }, children)), withOverlay && /* @__PURE__ */ react.createElement("div", {
    style: transitionStyles.overlay
  }, /* @__PURE__ */ react.createElement(Overlay/* Overlay */.a, {
    unstyled,
    blur: overlayBlur,
    onMouseDown: () => closeOnClickOutside && onClose(),
    className: classes.overlay,
    opacity: _overlayOpacity,
    zIndex: 0,
    color: overlayColor || (theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.black)
  })))));
}
Drawer.displayName = "@mantine/core/Drawer";


//# sourceMappingURL=Drawer.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/NavLink/NavLink.js + 1 modules
var NavLink = __webpack_require__(92470);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/TextInput/TextInput.js
var TextInput = __webpack_require__(80061);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Divider/Divider.js + 1 modules
var Divider = __webpack_require__(54777);
;// CONCATENATED MODULE: ./public/flag_en.png
/* harmony default export */ var flag_en = ({"src":"/_next/static/media/flag_en.314e492f.png","height":640,"width":1280,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAJFBMVEXZeIrMSWKUTXKdWXqYe5udkK2hgJ7MXXWmlbA0Z54vT4rjiJfXFSlCAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJklEQVQImQXBhwEAIAgDsA6Q9f+/Jogee19CdSQgCCCvhHxrT8cHCkQAkUmutJwAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/flag_vn.png
/* harmony default export */ var flag_vn = ({"src":"/_next/static/media/flag_vn.8604ef65.png","height":1707,"width":2560,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAACVBMVEXaJR3dNBvzswpQc6ueAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGElEQVQImWNgQAKMjFCaiQnKYmJClocDAAGeAA0VSKgCAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./common/Layout/Header/components/Language.js








var Language_useStyles = (0,create_styles/* createStyles */.k)(function() {
    return {
        language: {
            display: "flex"
        },
        languageItem: {
            marginRight: "5px",
            cursor: "pointer",
            width: 27,
            height: 18
        },
        languageNotActive: {
            filter: "grayscale(100%)"
        }
    };
});
function Language() {
    var classes = Language_useStyles().classes;
    var ref = (0,router.useRouter)(), locale = ref.locale, // pathname,
    asPath = ref.asPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.language,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                scroll: false,
                href: asPath,
                locale: "vi",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.languageItem + " " + "".concat(locale !== "vi" ? classes.languageNotActive : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: flag_vn,
                            alt: "Ng\xf4n ngữ Việt",
                            width: 27,
                            height: 18,
                            objectFit: "cover"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                scroll: false,
                href: asPath,
                locale: "en",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.languageItem + " " + "".concat(locale !== "en" ? classes.languageNotActive : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: flag_en,
                            alt: "English",
                            width: 27,
                            height: 18,
                            objectFit: "cover"
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./common/Layout/Header/components/DrawerMenu.js
/* eslint-disable jsx-a11y/anchor-is-valid */ 












// import Language from "./Language";
function DrawerMenu(param) {
    var opened = param.opened, setOpened = param.setOpened;
    var getLabel = (0,locale_provider/* useLocalContext */.u)().getLabel;
    var trans = (0,useTrans/* default */.Z)();
    var ref = (0,useUserInfo/* default */.Z)(), userInfo = ref.userInfo, isLogin = ref.isLogin;
    var logout = (0,useAuth/* default */.Z)().logout;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var asPath = (0,router.useRouter)().asPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer, {
        opened: opened,
        onClose: function() {
            return setOpened(false);
        },
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            scroll: false,
            href: "/",
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    onClick: function() {
                        return setOpened(false);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: logo/* default */.Z,
                        alt: "logo",
                        width: 64,
                        height: 40
                    })
                })
            })
        }),
        padding: "sm",
        size: "md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* NavLink */.O, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                    size: "sm",
                    placeholder: getLabel("T\xecm kiếm...")
                })
            }),
            isLogin && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavLink/* NavLink */.O, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            size: "md",
                            children: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name
                        }),
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                            src: (0,appendImageUrlFromAPI/* default */.Z)({
                                src: userInfo === null || userInfo === void 0 ? void 0 : userInfo.picture
                            }),
                            alt: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
                            radius: "xl",
                            size: "sm"
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* NavLink */.O, {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    scroll: false,
                                    href: "/user-profile/my-profile",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            size: "md",
                                            transform: "uppercase",
                                            color: asPath === "/user-profile/my-profile" ? theme.colors.second[3] : theme.colors.second[0],
                                            onClick: function() {
                                                return setOpened(false);
                                            },
                                            children: getLabel("Hồ sơ")
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* NavLink */.O, {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    scroll: false,
                                    href: "/user-profile/address-book",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            size: "md",
                                            transform: "uppercase",
                                            color: asPath === "/user-profile/address-book" ? theme.colors.second[3] : theme.colors.second[0],
                                            onClick: function() {
                                                return setOpened(false);
                                            },
                                            children: getLabel("Sổ địa chỉ")
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* NavLink */.O, {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    scroll: false,
                                    href: "/user-profile/purchased-return",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            size: "md",
                                            transform: "uppercase",
                                            color: asPath === "/user-profile/purchased-return" ? theme.colors.second[3] : theme.colors.second[0],
                                            onClick: function() {
                                                return setOpened(false);
                                            },
                                            children: getLabel("Đơn h\xe0ng")
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* NavLink */.O, {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    scroll: false,
                                    href: "/user-profile/liked-product",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            size: "md",
                                            transform: "uppercase",
                                            color: asPath === "/user-profile/liked-product" ? theme.colors.second[3] : theme.colors.second[0],
                                            onClick: function() {
                                                return setOpened(false);
                                            },
                                            children: getLabel("Sản phẩm y\xeau th\xedch")
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* NavLink */.O, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    scroll: false,
                    href: "/gioi-thieu",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            size: "md",
                            transform: "uppercase",
                            // color={theme.colors.second[0]}
                            onClick: function() {
                                return setOpened(false);
                            },
                            color: asPath === "/gioi-thieu" ? theme.colors.second[3] : theme.colors.second[0],
                            children: trans === null || trans === void 0 ? void 0 : trans.menu.about.title
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* NavLink */.O, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    scroll: false,
                    href: "/mua-hang/san-pham?sort=newest",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            size: "md",
                            transform: "uppercase",
                            color: asPath.search("mua-hang") >= 0 && asPath.search("promotion") < 0 ? theme.colors.second[3] : theme.colors.second[0],
                            onClick: function() {
                                return setOpened(false);
                            },
                            children: trans === null || trans === void 0 ? void 0 : trans.menu.products.title
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* NavLink */.O, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    scroll: false,
                    href: "/mua-hang/san-pham?filterBy=promotion",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            size: "md",
                            transform: "uppercase",
                            color: asPath.search("promotion") >= 0 ? theme.colors.second[3] : theme.colors.second[0],
                            onClick: function() {
                                return setOpened(false);
                            },
                            children: trans === null || trans === void 0 ? void 0 : trans.menu.promotion.title
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* NavLink */.O, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    scroll: false,
                    href: "/tin-tuc",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            size: "md",
                            transform: "uppercase",
                            color: asPath === "/tin-tuc" ? theme.colors.second[3] : theme.colors.second[0],
                            onClick: function() {
                                return setOpened(false);
                            },
                            children: trans === null || trans === void 0 ? void 0 : trans.menu.news.title
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* NavLink */.O, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    scroll: false,
                    href: "/lien-he",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            size: "md",
                            transform: "uppercase",
                            color: asPath === "/lien-he" ? theme.colors.second[3] : theme.colors.second[0],
                            onClick: function() {
                                return setOpened(false);
                            },
                            children: trans === null || trans === void 0 ? void 0 : trans.menu.contact.title
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* NavLink */.O, {
                label: isLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    onClick: function() {
                        return logout(userInfo === null || userInfo === void 0 ? void 0 : userInfo.token);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        size: "md",
                        transform: "uppercase",
                        color: theme.colors.second[0],
                        children: trans === null || trans === void 0 ? void 0 : trans.profile.manager.logout
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                    display: "flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                scroll: false,
                                href: "/dang-nhap",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        size: "md",
                                        transform: "uppercase",
                                        color: theme.colors.second[0],
                                        onClick: function() {
                                            return setOpened(false);
                                        },
                                        children: trans === null || trans === void 0 ? void 0 : trans.profile.manager.login
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            mx: "xs",
                            children: "/"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                scroll: false,
                                href: "/dang-ky",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        size: "md",
                                        transform: "uppercase",
                                        color: theme.colors.second[0],
                                        onClick: function() {
                                            return setOpened(false);
                                        },
                                        children: trans === null || trans === void 0 ? void 0 : trans.profile.manager.register
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* NavLink */.O, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Language, {})
            })
        ]
    });
}; //  <NavLink
 //       label={
 //         <Link scroll={false} href="/cua-hang" passHref>
 //           <a>
 //             <Text
 //               size="md"
 //               transform="uppercase"
 //               color={
 //                 asPath === "/cua-hang"
 //                   ? theme.colors.second[3]
 //                   : theme.colors.second[0]
 //               }
 //               onClick={() => setOpened(false)}
 //             >
 //               {/* {trans?.menu.promotion.title} */}
 //               {trans?.menu.store.title}
 //             </Text>
 //           </a>
 //         </Link>
 //       }
 //     />

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/ScrollArea/ScrollArea.js + 12 modules
var ScrollArea = __webpack_require__(73723);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(97564);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Badge/Badge.js + 1 modules
var Badge = __webpack_require__(17789);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Tooltip/Tooltip.js + 7 modules
var Tooltip = __webpack_require__(88393);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/ActionIcon/ActionIcon.js + 1 modules
var ActionIcon = __webpack_require__(49834);
// EXTERNAL MODULE: ./pages/cart/components/QuantityChange/index.js
var QuantityChange = __webpack_require__(22343);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ri/RiDeleteBin6Line.js
var RiDeleteBin6Line = __webpack_require__(67444);
;// CONCATENATED MODULE: ./common/Layout/Header/components/ItemCart.js
// import { getColorCode } from "@/utils/colorMapping";












var ItemCart_useStyles = (0,create_styles/* createStyles */.k)(function() {
    return {
        imageWrapper: {
            position: "relative",
            aspectRatio: "1",
            width: "100%"
        }
    };
});
function ItemCart(param) {
    var item = param.item;
    var ref, ref1, ref2, ref3, ref4;
    var classes = ItemCart_useStyles().classes;
    var trans = (0,useTrans/* default */.Z)();
    var context = (0,cartProvider/* useCartContext */.iQ)();
    var locale = (0,router.useRouter)().locale;
    var deleteCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(product) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return context === null || context === void 0 ? void 0 : context.deleteCart(product);
                    case 3:
                        _ctx.next = 8;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log(_ctx.t0);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function deleteCart(product) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                xs: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: 5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.imageWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: (0,appendImageUrlFromAPI/* default */.Z)({
                                    src: item.picture_tt || item.picture,
                                    size: "l"
                                }),
                                alt: "a",
                                layout: "fill"
                            })
                        }),
                        !(item === null || item === void 0 ? void 0 : item.ton) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                            color: "teal",
                            size: "xs",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                weight: "normal",
                                children: trans.miniCart.statusStock
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                xs: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: 5,
                    children: [
                        (item === null || item === void 0 ? void 0 : item.tien_ck) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                            size: "xs",
                            fullWidth: true,
                            sx: {
                                width: "fit-content"
                            },
                            color: "red",
                            children: "Khuyến m\xe3i"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            size: "xs",
                            weight: "700",
                            lineClamp: 3,
                            children: locale === "vi" ? item === null || item === void 0 ? void 0 : item.ten_vt : item === null || item === void 0 ? void 0 : item.ten_vt_eng
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                    color: "dark",
                                    children: [
                                        "VND ",
                                        ((item === null || item === void 0 ? void 0 : item.tien) / (item === null || item === void 0 ? void 0 : item.sl_xuat)).toLocaleString()
                                    ]
                                }),
                                (item === null || item === void 0 ? void 0 : item.tien_ck) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    strikethrough: true,
                                    children: item === null || item === void 0 ? void 0 : item.gia_ban_le.toLocaleString()
                                })
                            ]
                        }),
                        (item === null || item === void 0 ? void 0 : item.thuoc_tinh) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            children: [
                                (item === null || item === void 0 ? void 0 : (ref = item.thuoc_tinh) === null || ref === void 0 ? void 0 : ref.gia_tri_bien_the_2) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                    children: [
                                        "K\xedch thước: ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: item === null || item === void 0 ? void 0 : (ref1 = item.thuoc_tinh) === null || ref1 === void 0 ? void 0 : ref1.gia_tri_bien_the_2
                                        })
                                    ]
                                }),
                                (item === null || item === void 0 ? void 0 : (ref2 = item.thuoc_tinh) === null || ref2 === void 0 ? void 0 : ref2.gia_tri_bien_the_1) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                    label: item === null || item === void 0 ? void 0 : (ref3 = item.thuoc_tinh) === null || ref3 === void 0 ? void 0 : ref3.gia_tri_bien_the_1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                            mr: 4,
                                            children: [
                                                "M\xe0u sắc: ",
                                                item === null || item === void 0 ? void 0 : (ref4 = item.thuoc_tinh) === null || ref4 === void 0 ? void 0 : ref4.gia_tri_bien_the_1
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                    xs: 8,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityChange/* QuantityInput */.F, {
                                        item: item
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                    xs: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
                                        style: {
                                            cursor: "pointer"
                                        },
                                        onClick: function() {
                                            return deleteCart(item);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RiDeleteBin6Line/* RiDeleteBin6Line */.G, {})
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./common/Layout/Header/components/MiniCart.js







var MiniCart_useStyles = (0,create_styles/* createStyles */.k)(function() {
    return {
        cartBody: {
            padding: "22px 0"
        }
    };
});
function MiniCart(param) {
    var onClose = param.onClose;
    var ref, ref1, ref2, ref3, ref4;
    var classes = MiniCart_useStyles().classes;
    var trans = (0,useTrans/* default */.Z)();
    var context = (0,cartProvider/* useCartContext */.iQ)();
    // console.log("cart", context);
    var push = (0,router.useRouter)().push;
    var submitOrder = function() {
        onClose();
        context.createOrder({
            trang_thai: "LCT"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.cartBody,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                size: "sm",
                children: [
                    trans.miniCart.titleA,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                        children: [
                            " ",
                            (context === null || context === void 0 ? void 0 : (ref = context.cart) === null || ref === void 0 ? void 0 : ref.length) || 0,
                            " "
                        ]
                    }),
                    trans.miniCart.titleB
                ]
            }),
            (context === null || context === void 0 ? void 0 : (ref1 = context.cart) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                        my: "sm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollArea/* ScrollArea */.x, {
                        style: {
                            height: 300
                        },
                        offsetScrollbars: true,
                        children: context === null || context === void 0 ? void 0 : (ref2 = context.cart) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCart, {
                                        item: item
                                    }, item._id),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                                        my: "sm"
                                    })
                                ]
                            }, item._id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                        my: "sm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                        position: "apart",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                color: "black",
                                size: "md",
                                weight: "500",
                                children: trans.miniCart.labelTotal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                color: "black",
                                size: "md",
                                weight: "500",
                                children: [
                                    "VND ",
                                    context === null || context === void 0 ? void 0 : (ref3 = context.infoOrder) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.tempPrice) === null || ref4 === void 0 ? void 0 : ref4.toLocaleString()
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                        my: "sm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                        position: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                variant: "outline",
                                color: "dark",
                                uppercase: true,
                                sx: {
                                    fontWeight: "normal",
                                    minWidth: 125
                                },
                                onClick: function() {
                                    onClose();
                                    return push("/cart");
                                },
                                children: trans.miniCart.btnCart
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                color: "teal",
                                uppercase: true,
                                sx: {
                                    fontWeight: "normal"
                                },
                                onClick: submitOrder,
                                children: trans.miniCart.btnPay
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./common/Layout/Header/components/SearchBar.js






function SearchBar() {
    var trans = (0,useTrans/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), searchTerms = ref[0], setSearchTerms = ref[1];
    var ref1 = (0,router.useRouter)(), push = ref1.push, query = ref1.query;
    var handleUpdate = function(e) {
        setSearchTerms(e.target.value);
    };
    react.useEffect(function() {
        setSearchTerms("");
    }, [
        query
    ]);
    var checkKeyPress = function(e) {
        var keyCode = e.keyCode;
        if (keyCode === 13) {
            push("/mua-hang/tim-kiem?keyword=".concat(searchTerms));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
        size: "xs",
        value: searchTerms,
        onChange: handleUpdate,
        onKeyDown: checkKeyPress,
        placeholder: trans === null || trans === void 0 ? void 0 : trans.menu.search.title
    });
};

;// CONCATENATED MODULE: ./common/Layout/Header/styles.js


var styles_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    var _obj, _obj1;
    return {
        container: {
            width: "100%",
            // borderBottom: "1px solid #000",
            boxShadow: "0 0 10px rgb(0 0 0 / 10%)",
            // background: "#fff",
            color: "#666",
            fontSize: "12px",
            lineHeight: "24px",
            // fontWeight: "400",
            position: "relative",
            zIndex: 10
        },
        rightSideL: (0,_define_property/* default */.Z)({
            display: "flex",
            justifyContent: "flex-end",
            gap: 10
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            display: "none"
        }),
        wrapperL: (0,_define_property/* default */.Z)({
            display: "flex",
            // flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#118049",
            height: "80px"
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            height: "50px",
            // backgroundColor: "pink",
            display: "none"
        }),
        wrapper: (0,_define_property/* default */.Z)({
            display: "flex",
            // flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#fff",
            height: "100px"
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            height: "50px"
        }),
        burgerWrapperL: (0,_define_property/* default */.Z)({
            display: "none"
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            display: "flex",
            gap: 10
        }),
        burgerWrapper: (0,_define_property/* default */.Z)({
            display: "none"
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            display: "block"
        }),
        logoWrapperL: (_obj = {
            position: "relative",
            aspectRatio: "1.6",
            height: "80px",
            transition: "1s"
        }, // width: "122px",
        (0,_define_property/* default */.Z)(_obj, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            height: "40px"
        }), (0,_define_property/* default */.Z)(_obj, "&:hover", {
            filter: "brightness(140%)"
        }), _obj),
        logoWrapper: (_obj1 = {
            position: "relative",
            aspectRatio: "1.6",
            height: "100px",
            transition: "1s"
        }, // width: "122px",
        (0,_define_property/* default */.Z)(_obj1, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            height: "40px"
        }), (0,_define_property/* default */.Z)(_obj1, "&:hover", {
            filter: "brightness(140%)"
        }), _obj1),
        authWrapper: (0,_define_property/* default */.Z)({
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            display: "none"
        }),
        cartWrapper: (0,_define_property/* default */.Z)({
            display: "none"
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            display: "flex"
        }),
        rightSide: (0,_define_property/* default */.Z)({
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center"
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            display: "none"
        }),
        mainMenu: (0,_define_property/* default */.Z)({
            display: "flex",
            flexWrap: "wrap"
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            display: "none"
        }),
        menuItemL: {
            padding: "8px 0",
            // marginRight: 20,
            fontSize: 14,
            textTransform: "uppercase",
            color: "#fff",
            transition: "0.3s",
            "&:hover": {
                color: theme.colors.second[3]
            }
        },
        menuItem: {
            padding: "8px 0",
            // marginRight: 20,
            fontSize: 14,
            textTransform: "uppercase",
            color: theme.colors.second[0],
            transition: "0.3s",
            "&:hover": {
                color: theme.colors.second[3]
            }
        },
        optionsWrapper: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
        },
        // subMenu
        subMenu: {
            position: "absolute",
            zIndex: 9990,
            bottom: "0",
            left: "0",
            background: "#fff",
            width: "100%",
            aspectRatio: "6",
            // padding: "15px 0",
            color: theme.colors.second[1],
            // display: "none",
            // opacity: 0,
            transition: "0.3s",
            transform: "translate(0, -10%)"
        },
        subMenuItem: {
            transition: "0.3s",
            color: theme.colors.second[0],
            "&:hover": {
                color: "#EBBC1D"
            }
        },
        verticalDivider: {
            display: "inline-flex",
            margin: "2px 8px 0",
            borderLeft: "1px solid #ccc",
            height: "20px"
        },
        authItem: {
            color: "#000",
            cursor: "pointer",
            "&:hover": {
                color: "#EBBC1D"
            }
        }
    };
});
/* harmony default export */ var styles = (styles_useStyles);

// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./pages/ca-phe-danh-cho-quan/components/contact/contact.js
var contact = __webpack_require__(13656);
;// CONCATENATED MODULE: ./common/Layout/Header/index.js
/* eslint-disable react/no-array-index-key */ /* eslint-disable jsx-a11y/anchor-is-valid */ 




























function Header() {
    var ref;
    var ref1 = (0,useUserInfo/* default */.Z)(), userInfo = ref1.userInfo, isLogin = ref1.isLogin;
    var trans = (0,useTrans/* default */.Z)();
    var context = (0,cartProvider/* useCartContext */.iQ)();
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), openCart = ref2[0], setOpenCart = ref2[1];
    var pathname = (0,router.useRouter)().pathname;
    var isLandingPage = pathname === "/ca-phe-danh-cho-quan" || pathname.startsWith("/ca-phe-danh-cho-quan/");
    var ref3 = (0,react.useState)(false), modalOpened = ref3[0], setModalOpened = ref3[1];
    var logout = (0,useAuth/* default */.Z)().logout;
    var classes = styles().classes;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var getLabel = (0,locale_provider/* useLocalContext */.u)().getLabel;
    var ref4 = (0,categoryFunctions/* useFetchCategories */.rj)({
        condition: {}
    }), categories = ref4.data;
    var ref5 = (0,categoryFunctions/* useFetchCategories */.rj)({
        condition: {}
    }), subcategories = ref5.data;
    var locale = (0,router.useRouter)().locale;
    var menuRef = react.useRef();
    // const { hovered: hoveredMainMenu, ref: mainMenuRef } = useHover();
    // const { hovered: hoveredSubMenu, ref: subMenuRef } = useHover();
    // const [dataSubMenu, setDataMenu] = React.useState(false);
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), opened = ref6[0], setOpened = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState(/*#__PURE__*/ (0,jsx_runtime.jsx)(RiShoppingBag2Line/* RiShoppingBag2Line */.C, {})), 2), iconCart = ref7[0], setIconCart = ref7[1];
    // const handleMouseOver = (data) => {
    //   // setShowMenu(true);
    //   if (!data) return setDataMenu(false);
    //   setDataMenu(data);
    // };
    // const handleMouseOut = () => {
    //   // setShowMenu(false);
    // };
    // React.useEffect(() => {
    //   if ((hoveredMainMenu || hoveredSubMenu) && dataSubMenu) {
    //     setOverlay(true);
    //   } else {
    //     setOverlay(false);
    //   }
    // }, [hoveredMainMenu, hoveredSubMenu, dataSubMenu, subMenuRef, setOverlay]);
    react.useEffect(function() {
        if (openCart) {
            setIconCart(/*#__PURE__*/ (0,jsx_runtime.jsx)(RiShoppingBag3Fill/* RiShoppingBag3Fill */.x, {}));
        } else {
            setIconCart(/*#__PURE__*/ (0,jsx_runtime.jsx)(RiShoppingBag2Line/* RiShoppingBag2Line */.C, {}));
        }
    }, [
        openCart
    ]);
    var isTablet = (0,useWindowSize/* default */.Z)().isTablet;
    // console.log("open", modalOpened);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.container,
        style: {
            backgroundColor: isLandingPage ? "#118049" : "#fff"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                fluid: isLandingPage ? true : false,
                style: {
                    position: "relative",
                    zIndex: 9999,
                    background: isLandingPage ? "#118049" : "#fff",
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        // display: "flex",
                        // alignItems: "center",
                        // justifyContent: "space-between",
                        // width: "100%",
                        height: "100%"
                    },
                    children: isLandingPage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                        align: "center",
                        justify: "space-between",
                        sx: {
                            height: "100%",
                            width: "100%"
                        },
                        gutter: 0,
                        grow: true,
                        bg: "#118049",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                xs: 12,
                                md: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                    sx: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.logoWrapperL,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                scroll: false,
                                                href: "/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: logoVT,
                                                        alt: "Viet Thien",
                                                        priority: true,
                                                        layout: "responsive",
                                                        objectFit: "contain",
                                                        width: 80,
                                                        height: 50
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.burgerWrapperL,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    onClick: function() {
                                                        return window.location.href = "tel:19003258";
                                                    },
                                                    style: {
                                                        cursor: "pointer",
                                                        padding: "3px 20px",
                                                        background: "linear-gradient(to top,rgb(171, 32, 32), #8b0000)",
                                                        color: "white",
                                                        border: "none",
                                                        borderRadius: "5px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 7
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/LandingPage/phoneContact.png",
                                                            width: 30,
                                                            height: 30
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                background: "linear-gradient(to bottom, #ffcc00, #ff9900)",
                                                                WebkitBackgroundClip: "text",
                                                                WebkitTextFillColor: "transparent",
                                                                display: "inline-block",
                                                                fontWeight: 900,
                                                                fontSize: 18,
                                                                fontStyle: "italic"
                                                            },
                                                            children: "19003258"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Burger, {
                                                    opened: opened,
                                                    onClick: function() {
                                                        return setOpened(function(o) {
                                                            return !o;
                                                        });
                                                    },
                                                    p: 0
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                xs: 1,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(classes.mainMenu, " ").concat(classes.wrapperL),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            scroll: false,
                                            href: "/ca-phe-danh-cho-quan",
                                            id: "main-menu-item",
                                            ref: menuRef,
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.menuItemL,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        size: "lg",
                                                        weight: "bold",
                                                        children: trans === null || trans === void 0 ? void 0 : trans.menu.cafe.title
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            scroll: false,
                                            href: "/tra-danh-cho-quan",
                                            id: "main-menu-item",
                                            ref: menuRef,
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.menuItemL,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        size: "lg",
                                                        weight: "bold",
                                                        children: trans === null || trans === void 0 ? void 0 : trans.menu.tea.title
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            scroll: false,
                                            href: "/nuoc-giai-khat-danh-cho-quan",
                                            id: "main-menu-item",
                                            ref: menuRef,
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.menuItemL,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        size: "lg",
                                                        weight: "bold",
                                                        children: trans === null || trans === void 0 ? void 0 : trans.menu.drink.title
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            scroll: false,
                                            href: "/nong-san-danh-cho-quan",
                                            id: "main-menu-item",
                                            ref: menuRef,
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.menuItemL,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        size: "lg",
                                                        weight: "bold",
                                                        children: trans === null || trans === void 0 ? void 0 : trans.menu.agri.title
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                xs: 5,
                                md: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.rightSideL,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            onClick: function() {
                                                return window.location.href = "tel:19003258";
                                            },
                                            style: {
                                                cursor: "pointer",
                                                padding: "5px 20px",
                                                background: "linear-gradient(to top,rgb(171, 32, 32), #8b0000)",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "5px",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 7
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/LandingPage/phoneContact.png",
                                                    width: 30,
                                                    height: 30
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        background: "linear-gradient(to bottom, #ffcc00, #ff9900)",
                                                        WebkitBackgroundClip: "text",
                                                        WebkitTextFillColor: "transparent",
                                                        display: "inline-block",
                                                        fontWeight: 900,
                                                        fontSize: 18,
                                                        fontStyle: "italic"
                                                    },
                                                    children: "19003258"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function() {
                                                return setModalOpened(true);
                                            },
                                            style: {
                                                cursor: "pointer",
                                                padding: "5px 20px",
                                                background: "linear-gradient(to top,rgb(171, 32, 32), #8b0000)",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "5px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    background: "linear-gradient(to bottom, #ffcc00, #ff9900)",
                                                    WebkitBackgroundClip: "text",
                                                    WebkitTextFillColor: "transparent",
                                                    display: "inline-block",
                                                    fontWeight: 900,
                                                    fontSize: 18,
                                                    fontStyle: "italic"
                                                },
                                                children: "LI\xcaN H\xcạ NGAY"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                        align: "center",
                        justify: "space-between",
                        sx: {
                            height: "100%",
                            width: "100%"
                        },
                        gutter: 0,
                        grow: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                xs: 12,
                                md: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                    sx: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.burgerWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Burger, {
                                                opened: opened,
                                                onClick: function() {
                                                    return setOpened(function(o) {
                                                        return !o;
                                                    });
                                                },
                                                p: 0
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.logoWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                scroll: false,
                                                href: "/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: logo/* default */.Z,
                                                        alt: "ZeMor Coffee",
                                                        priority: true,
                                                        layout: "responsive",
                                                        objectFit: "contain",
                                                        width: 80,
                                                        height: 50
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                xs: 1,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(classes.mainMenu, " ").concat(classes.wrapper),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            scroll: false,
                                            href: "/gioi-thieu",
                                            id: "main-menu-item",
                                            ref: menuRef,
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.menuItem,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        size: "lg",
                                                        weight: "bold",
                                                        children: trans === null || trans === void 0 ? void 0 : trans.menu.about.title
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu, {
                                            trigger: "hover",
                                            openDelay: 100,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Target, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            scroll: false,
                                                            href: "/mua-hang/san-pham?sort=newest",
                                                            id: "main-menu-item",
                                                            ref: menuRef,
                                                            style: {
                                                                display: "flex",
                                                                alignItems: "center"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: classes.menuItem,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                        size: "lg",
                                                                        weight: "bold",
                                                                        children: trans === null || trans === void 0 ? void 0 : trans.menu.products.title
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Dropdown, {
                                                    children: Boolean(categories) && categories.filter(function(category) {
                                                        return !category.danh_muc_me;
                                                    }).map(function(category, i) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: i < 20 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Item, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu, {
                                                                    trigger: "hover",
                                                                    openDelay: 100,
                                                                    position: "right-start",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Target, {
                                                                            sx: {
                                                                                width: "100%"
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                    href: "/danh-muc-san-pham/".concat(category === null || category === void 0 ? void 0 : category.slug, "?sort=all"),
                                                                                    passHref: true,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Item, {
                                                                                            closeMenuOnClick: true,
                                                                                            children: locale === "vi" ? category === null || category === void 0 ? void 0 : category.ten_danh_muc : category === null || category === void 0 ? void 0 : category.ten_danh_muc_eng
                                                                                        })
                                                                                    })
                                                                                }, i)
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Dropdown, {
                                                                            children: Boolean(subcategories) && subcategories.filter(function(el) {
                                                                                return el.danh_muc_me == category.ma_danh_muc;
                                                                            }).map(function(subcategory, i) {
                                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                        href: "/danh-muc-san-pham/".concat(category === null || category === void 0 ? void 0 : category.slug, "?sort=").concat(subcategory === null || subcategory === void 0 ? void 0 : subcategory.ma_danh_muc),
                                                                                        passHref: true,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Item, {
                                                                                                closeMenuOnClick: true,
                                                                                                children: locale === "vi" ? subcategory === null || subcategory === void 0 ? void 0 : subcategory.ten_danh_muc : subcategory === null || subcategory === void 0 ? void 0 : subcategory.ten_danh_muc_eng
                                                                                            })
                                                                                        })
                                                                                    }, i)
                                                                                });
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        });
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            scroll: false,
                                            href: "/mua-hang/san-pham?filterBy=promotion",
                                            id: "main-menu-item",
                                            ref: menuRef,
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.menuItem,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        size: "lg",
                                                        weight: "bold",
                                                        children: trans === null || trans === void 0 ? void 0 : trans.menu.promotion.title
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu, {
                                            trigger: "hover",
                                            openDelay: 100,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Target, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            scroll: false,
                                                            href: "/tin-tuc",
                                                            id: "main-menu-item",
                                                            ref: menuRef,
                                                            style: {
                                                                display: "flex",
                                                                alignItems: "center"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: classes.menuItem,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                        size: "lg",
                                                                        weight: "bold",
                                                                        children: trans === null || trans === void 0 ? void 0 : trans.menu.news.title
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu.Dropdown, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/tin-tuc",
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Item, {
                                                                    closeMenuOnClick: true,
                                                                    children: locale === "vi" ? "Tin Tức" : "News"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/tin-tuc",
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Item, {
                                                                    closeMenuOnClick: true,
                                                                    children: locale === "vi" ? "T\xe0i Liệu" : "Documents"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            scroll: false,
                                            href: "/lien-he",
                                            id: "main-menu-item",
                                            ref: menuRef,
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.menuItem,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        size: "lg",
                                                        weight: "bold",
                                                        children: trans === null || trans === void 0 ? void 0 : trans.menu.contact.title
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                xs: 5,
                                md: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.rightSide,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.optionsWrapper,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* Popover */.J, {
                                                width: 340,
                                                position: "bottom",
                                                withArrow: true,
                                                shadow: "md",
                                                arrowOffset: 50,
                                                styles: {
                                                    arrow: {
                                                        left: "auto !important",
                                                        right: "15px"
                                                    },
                                                    dropdown: {
                                                        left: "auto !important",
                                                        right: 20
                                                    }
                                                },
                                                onOpen: function() {
                                                    return setIconCart(/*#__PURE__*/ (0,jsx_runtime.jsx)(RiShoppingBag3Fill/* RiShoppingBag3Fill */.x, {}));
                                                },
                                                onClose: function() {
                                                    return setIconCart(/*#__PURE__*/ (0,jsx_runtime.jsx)(RiShoppingBag2Line/* RiShoppingBag2Line */.C, {}));
                                                },
                                                onChange: setOpenCart,
                                                opened: openCart,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Target */.J.Target, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                            sx: {
                                                                fontSize: "20px",
                                                                margin: "10px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                cursor: "pointer"
                                                            },
                                                            onClick: function() {
                                                                return setOpenCart(function(o) {
                                                                    return !o;
                                                                });
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Indicator/* Indicator */.z, {
                                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                    color: "#fff",
                                                                    children: (context === null || context === void 0 ? void 0 : (ref = context.cart) === null || ref === void 0 ? void 0 : ref.length) || 0
                                                                }),
                                                                size: 20,
                                                                radius: "50%",
                                                                color: theme.colors.main[0],
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: iconCart
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Dropdown */.J.Dropdown, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCart, {
                                                            onClose: function() {
                                                                return setOpenCart(false);
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Language, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.authWrapper,
                                                children: isLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu, {
                                                        shadow: "md",
                                                        width: 200,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Target, {
                                                                children: userInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                                                    sx: {
                                                                        cursor: "pointer"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                                                                            src: (0,appendImageUrlFromAPI/* default */.Z)({
                                                                                src: userInfo === null || userInfo === void 0 ? void 0 : userInfo.picture
                                                                            }),
                                                                            alt: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
                                                                            radius: "xl",
                                                                            size: "sm"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            style: {
                                                                                display: "flex",
                                                                                flex: 1,
                                                                                alignItems: "center"
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                                size: "sm",
                                                                                weight: "500",
                                                                                children: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu.Dropdown, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Label, {
                                                                        children: trans.profile.manager.title
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        scroll: false,
                                                                        href: "/user-profile/my-profile",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Item, {
                                                                                children: trans.profile.manager.info
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        scroll: false,
                                                                        href: "/user-profile/address-book",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Item, {
                                                                                children: trans.profile.manager.address
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        scroll: false,
                                                                        href: "/user-profile/purchased-return",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Item, {
                                                                                children: trans.profile.manager.purchase
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        scroll: false,
                                                                        href: "/user-profile/liked-product",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Item, {
                                                                                children: trans.profile.manager.liked
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Divider, {}),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Label, {
                                                                        children: trans.profile.manager.adjust
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Item, {
                                                                        onClick: function() {
                                                                            return logout(userInfo === null || userInfo === void 0 ? void 0 : userInfo.token);
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: trans.profile.manager.logout
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/dang-nhap",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BsFillPersonFill/* BsFillPersonFill */.H, {
                                                                size: 20
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerMenu, {
                opened: opened,
                setOpened: setOpened
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
                opened: modalOpened,
                onClose: function() {
                    return setModalOpened(false);
                },
                // padding={0}
                size: "50%",
                overlayProps: {
                    color: "rgba(0, 0, 0, 0.5)"
                },
                sx: {
                    backgroundColor: "transparent",
                    boxShadow: "none"
                },
                styles: function(theme) {
                    return {
                        header: {
                            display: "none"
                        },
                        body: {
                            display: "flex",
                            justifyContent: "center",
                            // aspectRatio: "1.77",
                            width: "100%"
                        },
                        modal: (0,_define_property/* default */.Z)({}, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                            width: "100%"
                        })
                    };
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contact/* default */.Z, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./common/Layout/index.js
// import { useFetchCategories } from "@/apis/queryFunctions/categoryFunctions";














var Layout_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        main: (0,_define_property/* default */.Z)({
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
            overflow: "hidden"
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {}),
        sidenavWrapper: (0,_define_property/* default */.Z)({
            width: "100%",
            // height: "100px",
            position: "fixed",
            top: "0px",
            left: "0px",
            display: "flex",
            zIndex: 9999
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            minHeight: "50px"
        }),
        section: (0,_define_property/* default */.Z)({
            minHeight: "calc(100vh - 100px)",
            minWidth: "100%",
            flex: 1,
            flexDirection: "column",
            justifyContent: "space-between",
            // marginTop: "100px",
            overflow: "hidden"
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            minHeight: "calc(100vh - 50px)",
            marginTop: "50px"
        }),
        body: (0,_define_property/* default */.Z)({
            minHeight: "calc(100vh - 125px)",
            flex: 1,
            flexDirection: "column"
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            minHeight: "calc(100vh - 85px)"
        })
    };
});
function Layout(param) {
    var children = param.children;
    var reveal = // useFetchCategories();
    function reveal() {
        var reveals = document.querySelectorAll(".reveal");
        for(var i = 0; i < reveals.length; i += 1){
            var windowHeight = window.innerHeight;
            var elementTop = reveals[i].getBoundingClientRect().top;
            var elementVisible = 100;
            if (elementTop < windowHeight - elementVisible) {
                reveals[i].classList.add("active");
            } else {
                reveals[i].classList.remove("active");
            }
        }
    };
    var asPath = (0,router.useRouter)().asPath;
    // console.log('finding', asPath)
    var ref = (0,react.useContext)(cartProvider/* CartContext */.A9), id_afflink = ref.id_afflink, setId_afflink = ref.setId_afflink;
    var getAfflinkValue = function() {
        var queryParams = new URLSearchParams(asPath.split("?")[1]);
        return queryParams.get("afflink");
    };
    var afflinkValue0 = getAfflinkValue();
    (0,react.useEffect)(function() {
        if (afflinkValue0 !== null) {
            setId_afflink(afflinkValue0);
            sessionStorage.setItem("afflinkValue", afflinkValue0);
        }
    }, [
        afflinkValue0,
        setId_afflink
    ]);
    (0,react.useEffect)(function() {
        var storedAfflinkValue = sessionStorage.getItem("afflinkValue");
        if (storedAfflinkValue !== null) {
            setId_afflink(storedAfflinkValue);
        }
    }, [
        setId_afflink
    ]);
    var classes = Layout_useStyles().classes;
    var ref1 = (0,router.useRouter)(), pathname = ref1.pathname, reload = ref1.reload;
    var ref2 = (0,use_resize_observer/* useElementSize */.h)(), headerRef = ref2.ref, headerHeight = ref2.height;
    var ref3 = (0,use_resize_observer/* useElementSize */.h)(), ref4 = ref3.ref, height = ref3.height;
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), visible = ref5[0], setVisible = ref5[1];
    react.useEffect(function() {
        window.addEventListener("scroll", reveal);
        return function() {
            window.removeEventListener("scroll", reveal);
        };
    }, []);
    react.useEffect(function() {
        var init = function init() {
            var section = document.querySelectorAll("section");
            for(var i = 0; i < section.length; i += 1){
                section[i].firstChild.classList.add("reveal");
            }
        };
        init();
        var start = window.setTimeout(reveal, 1000);
        return function() {
            window.clearTimeout(start);
        };
    }, [
        pathname
    ]);
    react.useEffect(function() {
        var needReload = Boolean((0,localStorage/* getFromStorage */.L2)("updateInfo"));
        if (needReload) {
            reload();
            (0,localStorage/* removeStorage */.Li)("updateInfo");
        }
    }, [
        pathname
    ]);
    var isLandingPage = pathname === "/ca-phe-danh-cho-quan" || pathname.startsWith("/ca-phe-danh-cho-quan/");
    var isTablet = (0,useWindowSize/* default */.Z)().isTablet;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "facebook-domain-verification",
                        content: "skgvoi89or42vgqr8jpeib5pdyxuc7"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: classes.main,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Affix/* Affix */.D, {
                        position: {
                            top: "0px",
                            left: "0px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.sidenavWrapper,
                            style: {
                                height: isLandingPage ? isTablet ? "50px" : "80px" : "100px"
                            },
                            ref: headerRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                setOverlay: setVisible
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.section,
                        ref: ref4,
                        style: {
                            marginTop: isLandingPage ? isTablet ? "50px" : "80px" : "100px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.body,
                                children: [
                                    visible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
                                        opacity: 0.6,
                                        color: "#000",
                                        zIndex: 10,
                                        style: {
                                            height: "calc(".concat(height, "px + ").concat(headerHeight, "px)")
                                        }
                                    }),
                                    children
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToTop, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 25926:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var Context = /*#__PURE__*/ (/* unused pure expression or super */ null && (createContext()));
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Context)));


/***/ }),

/***/ 35985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAuth; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _apis_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36203);
/* harmony import */ var _setup_flexbiz_api_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34733);
/* harmony import */ var _utils_localStorage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44061);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* eslint-disable no-underscore-dangle */ /* eslint-disable camelcase */ 







function useAuth() {
    var context = (0,_setup_flexbiz_api_provider__WEBPACK_IMPORTED_MODULE_2__/* .useApiContext */ .Q)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_4__.useState(null), 2), userInput = ref[0], setUserInput = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_4__.useState(null), 2), otpInfo = ref1[0], setOtpInfo = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_4__.useState(false), 2), userInfo = ref2[0], setUserInfo = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_4__.useState(""), 2), myToken = ref3[0], setMyToken = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_4__.useState(null), 2), error1 = ref4[0], setError = ref4[1];
    var signup = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            var rs, ref, ref1;
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setUserInput(data);
                        _ctx.next = 4;
                        return context.apis.asyncSignup(data);
                    case 4:
                        rs = _ctx.sent;
                        return _ctx.abrupt("return", {
                            status: true,
                            message: rs
                        });
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        console.log("Error signup => ", ((ref = _ctx.t0.data) === null || ref === void 0 ? void 0 : ref.message) || _ctx.t0.data || _ctx.t0.message || _ctx.t0.error || _ctx.t0);
                        setError(_ctx.t0);
                        return _ctx.abrupt("return", {
                            status: false,
                            message: ((ref1 = _ctx.t0.data) === null || ref1 === void 0 ? void 0 : ref1.message) || _ctx.t0.data || _ctx.t0.message || _ctx.t0.error || _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function signup(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var sendOtp = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(email) {
            var rs_otpInfo, ref, ref1;
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setUserInput(email);
                        if (email) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: false,
                            message: "Lỗi: Kh\xf4ng t\xecm thấy email hoặc số điện thoại"
                        });
                    case 3:
                        _ctx.prev = 3;
                        _ctx.t0 = JSON;
                        _ctx.next = 7;
                        return context.apis.asyncLoginSms(email);
                    case 7:
                        _ctx.t1 = _ctx.sent;
                        rs_otpInfo = _ctx.t0.parse.call(_ctx.t0, _ctx.t1);
                        setOtpInfo(rs_otpInfo);
                        return _ctx.abrupt("return", {
                            status: true,
                            message: "Đ\xe3 gửi m\xe3 x\xe1c thực đến ".concat(email)
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t2 = _ctx["catch"](3);
                        ;
                        console.log("Error sendOtp => ", ((ref = _ctx.t2.data) === null || ref === void 0 ? void 0 : ref.message) || _ctx.t2.message || _ctx.t2.error || _ctx.t2);
                        setError(_ctx.t2);
                        return _ctx.abrupt("return", {
                            status: false,
                            message: ((ref1 = _ctx.t2.data) === null || ref1 === void 0 ? void 0 : ref1.message) || _ctx.t2.message || _ctx.t2.error || _ctx.t2
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    13
                ]
            ]);
        }));
        return function sendOtp(email) {
            return _ref.apply(this, arguments);
        };
    }();
    var authOtp = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(otpInput) {
            var rs_userInfo, ref, ref1;
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (otpInfo) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: false,
                            message: "Kh\xf4ng c\xf3 m\xe3 x\xe1c thực"
                        });
                    case 2:
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return context.apis.asyncLoginSmsVerify(otpInfo._id, otpInput, {
                            once: true
                        });
                    case 5:
                        rs_userInfo = _ctx.sent;
                        setMyToken(rs_userInfo);
                        setUserInfo(rs_userInfo);
                        return _ctx.abrupt("return", {
                            status: true,
                            message: "X\xe1c thực th\xe0nh c\xf4ng",
                            token: rs_userInfo === null || rs_userInfo === void 0 ? void 0 : rs_userInfo.token
                        });
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](2);
                        ;
                        console.log("Error sendOtp => ", ((ref = _ctx.t0.data) === null || ref === void 0 ? void 0 : ref.message) || _ctx.t0.message || _ctx.t0.error || _ctx.t0);
                        setError(_ctx.t0);
                        return _ctx.abrupt("return", {
                            status: false,
                            message: ((ref1 = _ctx.t0.data) === null || ref1 === void 0 ? void 0 : ref1.message) || _ctx.t0.message || _ctx.t0.error || _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    11
                ]
            ]);
        }));
        return function authOtp(otpInput) {
            return _ref.apply(this, arguments);
        };
    }();
    var resend = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var email, rs_otpInfo, ref, _args = arguments;
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = _args.length > 0 && _args[0] !== void 0 ? _args[0] : userInput;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return sendOtp(email);
                    case 4:
                        rs_otpInfo = _ctx.sent;
                        if (!rs_otpInfo.status) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: true,
                            message: "M\xe3 x\xe1c thực đ\xe3 gửi đến ".concat(email)
                        });
                    case 7:
                        return _ctx.abrupt("return", {
                            status: false,
                            message: "Gửi lại m\xe3 x\xe1c thực kh\xf4ng th\xe0nh c\xf4ng"
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        console.log("Error handleSubmit => ", ((ref = _ctx.t0.data) === null || ref === void 0 ? void 0 : ref.message) || _ctx.t0.message || _ctx.t0.error || _ctx.t0);
                        return _ctx.abrupt("return", {
                            status: false,
                            message: "Gửi lại m\xe3 x\xe1c thực kh\xf4ng th\xe0nh c\xf4ng"
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    10
                ]
            ]);
        }));
        return function resend() {
            return _ref.apply(this, arguments);
        };
    }();
    var login = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(email, password) {
            var rs_login, ref, ref1, ref2;
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return context.apis.asyncLoginAPI(email, password);
                    case 3:
                        rs_login = _ctx.sent;
                        setUserInfo(rs_login);
                        (0,_utils_localStorage__WEBPACK_IMPORTED_MODULE_7__/* .setToStorage */ .Pp)("token", rs_login.token);
                        (0,_utils_localStorage__WEBPACK_IMPORTED_MODULE_7__/* .setToStorage */ .Pp)("updateInfo", true);
                        return _ctx.abrupt("return", {
                            status: true,
                            message: "Đăng nhập th\xe0nh c\xf4ng",
                            require_verify: false
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        console.log("Error login => ", ((ref = _ctx.t0.data) === null || ref === void 0 ? void 0 : ref.message) || _ctx.t0.message || _ctx.t0.error || _ctx.t0);
                        if (!(_ctx.t0 && (((ref1 = _ctx.t0.data) === null || ref1 === void 0 ? void 0 : ref1.require_verify) || _ctx.t0.require_verify))) {
                            _ctx.next = 16;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: false,
                            message: "X\xe1c minh t\xe0i khoản! M\xe3 x\xe1c thực được gửi đến ".concat(email),
                            require_verify: true
                        });
                    case 16:
                        return _ctx.abrupt("return", {
                            status: false,
                            message: ((ref2 = _ctx.t0.data) === null || ref2 === void 0 ? void 0 : ref2.message) || _ctx.t0.message || _ctx.t0.error || _ctx.t0,
                            require_verify: false
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function login(email, password) {
            return _ref.apply(this, arguments);
        };
    }();
    var logout = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token) {
            var i, key, ref;
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return context.apis.asyncGet("".concat("https://api.flexzen.app", "/api/user/logout?access_token=").concat(token));
                    case 3:
                        // clear cache
                        for(i = 0; i < localStorage.length; i++){
                            key = localStorage.key(i);
                            if (key.indexOf("labelinfo") < 0 && key.indexOf("listinfo") < 0 && key.indexOf("reportinfo") < 0) {
                                (0,_utils_localStorage__WEBPACK_IMPORTED_MODULE_7__/* .removeStorage */ .Li)(key);
                            // localStorage.removeItem(key);
                            }
                        }
                        (0,_utils_localStorage__WEBPACK_IMPORTED_MODULE_7__/* .removeStorage */ .Li)("token");
                        // localStorage.removeItem("token");
                        router.reload();
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        console.log("Error logout => ", ((ref = _ctx.t0.data) === null || ref === void 0 ? void 0 : ref.message) || _ctx.t0.message || _ctx.t0.error || _ctx.t0);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function logout(token) {
            return _ref.apply(this, arguments);
        };
    }();
    var resetPassword = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(input) {
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return context.apis.asyncChangePassword(myToken, input);
                    case 3:
                        return _ctx.abrupt("return", {
                            status: true,
                            message: "Thay đổi mật khẩu th\xe0nh c\xf4ng"
                        });
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: false,
                            message: "Thay đổi mật khẩu kh\xf4ng th\xe0nh c\xf4ng"
                        });
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return function resetPassword(input) {
            return _ref.apply(this, arguments);
        };
    }();
    var changePassword = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            var ref;
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return context.apis.asyncChangePassword(context.userInfo.token, data);
                    case 3:
                        return _ctx.abrupt("return", {
                            status: "success",
                            message: "Đổi mật khẩu th\xe0nh c\xf4ng"
                        });
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        console.log("Error changePassword => ", ((ref = _ctx.t0.data) === null || ref === void 0 ? void 0 : ref.message) || _ctx.t0.message || _ctx.t0.error || _ctx.t0);
                        return _ctx.abrupt("return", {
                            status: "error",
                            message: "Đổi mật khẩu kh\xf4ng th\xe0nh c\xf4ng"
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return function changePassword(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var getProfile = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token, email) {
            var profile;
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,_apis_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGet */ .Bt)("".concat("https://api.flexzen.app", "/api/profile?access_token=").concat(token, "&email=").concat(email));
                    case 3:
                        profile = _ctx.sent;
                        return _ctx.abrupt("return", {
                            isLogin: true,
                            userInfo: profile
                        });
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            isLogin: false,
                            userInfo: null
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function getProfile(token, email) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateProfile = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var name, ngay_sinh, gioi_tinh, ref, rs, ref1;
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        name = param.name, ngay_sinh = param.ngay_sinh, gioi_tinh = param.gioi_tinh;
                        _ctx.prev = 1;
                        ;
                        _ctx.next = 5;
                        return (0,_apis_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncPost */ .op)({
                            url: "".concat("https://api.flexzen.app", "/api/updateprofile?access_token=").concat(context === null || context === void 0 ? void 0 : (ref = context.userInfo) === null || ref === void 0 ? void 0 : ref.token),
                            data: {
                                name: name,
                                local: {
                                    exfields: {
                                        ngay_sinh: ngay_sinh,
                                        gioi_tinh: gioi_tinh
                                    }
                                }
                            },
                            method: "POST"
                        });
                    case 5:
                        rs = _ctx.sent;
                        context.userInfo.name = name;
                        context.userInfo.local.exfields.ngay_sinh = ngay_sinh;
                        context.userInfo.local.exfields.gioi_tinh = gioi_tinh;
                        if (!rs) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: "success",
                            message: "Thay đổi th\xf4ng tin th\xe0nh c\xf4ng"
                        });
                    case 11:
                        return _ctx.abrupt("return", {
                            status: "error",
                            message: "Thay đổi th\xf4ng tin kh\xf4ng th\xe0nh c\xf4ng"
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        console.log("Error updateProfile => ", ((ref1 = _ctx.t0.data) === null || ref1 === void 0 ? void 0 : ref1.message) || _ctx.t0.message || _ctx.t0.error || _ctx.t0);
                        return _ctx.abrupt("return", {
                            status: "error",
                            message: "Thay đổi th\xf4ng tin kh\xf4ng th\xe0nh c\xf4ng"
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function updateProfile(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        apis: context.apis,
        signup: signup,
        sendOtp: sendOtp,
        authOtp: authOtp,
        error: error1,
        token: userInfo.token,
        userInfo: userInfo,
        logout: logout,
        login: login,
        resend: resend,
        resetPassword: resetPassword,
        changePassword: changePassword,
        getProfile: getProfile,
        updateProfile: updateProfile
    };
};


/***/ }),

/***/ 26679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useTrans; }
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./public/lang/en.js
/* harmony default export */ var en = ({
    menu: {
        about: {
            title: "About us"
        },
        products: {
            title: "Products"
        },
        promotion: {
            title: "Promotions"
        },
        news: {
            title: "Library"
        },
        contact: {
            title: "Contact"
        },
        search: {
            title: "Search..."
        },
        profile: {
            title: "Profile"
        },
        store: {
            title: "Store"
        }
    },
    miniCart: {
        titleA: "You have",
        titleB: "items in cart",
        statusStock: "Stocking",
        labelTotal: "Total",
        btnCart: "Cart",
        btnPay: "Pay Now"
    },
    profile: {
        manager: {
            home: "Home",
            title: "Account Management",
            info: "Account information",
            info_dcr: "Manage your personal account information",
            address: "Address book",
            address_dcr: "Manage your shipping and billing addresses",
            purchase: "Orders purchased",
            purchase_dcr: "Manage orders that you have purchased or returned",
            liked: "Favorite product",
            liked_dcr: "Manage list of favorite products",
            adjust: "Options",
            logout: "Log out",
            register: "Register",
            login: "Log in"
        },
        layout: {
            home: "Home",
            title: "Account Management",
            info: "Account information",
            address: "Address book",
            purchase: "Orders purchased",
            liked: "Favorite product"
        },
        info: {
            info: "Account information",
            account: "Username",
            name: "Full name",
            date: "Date of birth",
            sex: "Gender",
            male: "Male",
            female: "Female",
            pass: "Password",
            changePass: "Change Password",
            confirm: "Confirm information change",
            currPass: "current password",
            newPass: "A new password",
            conPass: "Confirm new password",
            valPass: "Minimum 6 characters including uppercase, lowercase and number",
            noti: "Update successful",
            notiFail: "Update failed",
            valName: "Please enter your full name"
        },
        address: {
            title: "Address book",
            default: " - Default address",
            addAddress: "Add address",
            creatAddress: "Create a new address book",
            changeAddress: "Edit",
            deleteAddress: "Delete",
            deleteNoti: "Address removed",
            province: "Province",
            district: "District",
            ward: "Ward",
            slProvince: "Choose a province",
            slDistrict: "Choose a district",
            slWard: "Choose a ward",
            setDF: "Set as default address",
            save: "Save address",
            changeNoti: "Information is being updated"
        },
        order: {
            order: "Order Management",
            title: "List of purchased orders",
            date: "Order date",
            datepredict: "Estimated delivery date",
            id: "Code orders",
            product: "Product",
            quantity: "Quantity",
            total: "Total amount",
            orderDetail: "Order details",
            name: "Receiver's  name",
            phone: "Phone number",
            address: "Receiver's address",
            detail: "Detail",
            unitPrice: "Unit price",
            price: "Into money",
            temp: "Provisional",
            ship: "Delivery charges",
            freeship: "Money Free Shipping",
            cancelOrder: "Cancellation",
            cancelReason: "Reason for cancellation",
            cancel_dcr: "The reason for your cancellation is: ",
            confirm: "Confirm",
            cancel: "Cancel",
            pay: "Continue to pay",
            rebuy: "Re-Purchase",
            cancelNoti_suc: "Order canceled",
            cancelNoti_fail: "Cancellation failed",
            cancelNoti_val: "Please enter all characters (>5)",
            rebuyNoti_suc: "Add to cart successfully",
            rebuyNoti_val: "Request is being processed"
        },
        liked: {
            title: "Favorite product",
            noliked: "You don't have a favorite product yet?"
        }
    },
    menuAuth: {
        account: "Account",
        profile: "Profile",
        address: "Address",
        order: "Order",
        liked: "Liked Products",
        option: "Option",
        logout: "Log out"
    },
    homeLiked: {
        title: "Our Products"
    },
    homePromotion: {
        title: "Promotion"
    },
    homeNews: {
        title: "News"
    },
    subscribe: {
        title: "Sign up to receive information from ZeMor coffee",
        placeholder: "Enter your email",
        button: "Register",
        alertSuccess: "Subscribe success",
        alertFailed: "Subscribe failed"
    },
    footer: {
        addressLabel: "Address",
        customerPolicy: "Customer Policy",
        contactInfo: "Contact Info",
        followUs: "Follow Us",
        payments: "Payment methods",
        cod: "COD",
        bankTransfer: "Bank transfer",
        wallet: "Electronic wallet",
        info1: "Business Certificate Number: 0305693542 – Issued on Febuary 22, 2008",
        info2: "By the Department of Planning and Investment of HCM City."
    },
    contact: {
        label: "Chúng t\xf4i sẽ li\xean h\xeạ ngay, xin vui lòng đ\xeả lại th\xf4ng tin",
        taxCodeLabel: "Tax code",
        email: "Email",
        address: "Office",
        form: {
            title: "Contact us",
            fullName: "Full Name",
            email: "Email",
            phone: "Phone",
            address: "Address",
            content: "Content",
            button: "Submit"
        },
        placeholder: {
            fullName: "Your full name",
            email: "Your email",
            phone: "Your phone number",
            content: "Enter content here...",
            address: "Your address"
        },
        placeholder2: {
            fullName: "Your full name",
            email: "Your email",
            phone: "Your phone number",
            content: "Enter content here...",
            address: "Your address"
        },
        map: {
            title: "List of Viet Thien factories"
        }
    },
    collections: {
        filterCategory: "Category",
        filterPrice: "Price",
        remove: "Reset",
        from: "From",
        to: "To",
        establish: "Establish",
        searchResult: "Search results for: ",
        notfound: "No products found",
        notFoundPromotion: "No promotional products available",
        filter: "Filter",
        reset: "Reset",
        apply: "Apply",
        sort: "SORTED BY: "
    },
    login: {
        seoTitle: "Log in - Viet Thien",
        title: "Log in to your account",
        username: "Email or phone number",
        password: "Password",
        forgotPass: "Forgot password?",
        submit: "LOG IN",
        swap: "You are not a member, please",
        or: "OR",
        loginFB: "Login with Facebook",
        signup: "Register",
        placeholder: {
            username: "Enter your email or phone number",
            password: "Minimum 6 characters including uppercase, lowercase and number"
        },
        validate: {
            blank: "Email or phone number cannot be left blank",
            blankPassword: "Password can not be blank"
        }
    },
    forgotPassword: {
        title: "Password recovery",
        username: "Email or phone number (we will send you an OTP to reset your password)",
        submit: "Submit and confirm",
        placeholder: {
            username: "Enter your email or phone number"
        },
        validate: {
            blank: "Username cannot be empty",
            send: "Sending verification code failed"
        }
    },
    resetPassword: {
        newPassword: "New Password",
        reNewPassword: "Retype Password",
        submit: "Change Password",
        placeholder: "Minimum 6 characters including uppercase, lowercase and number"
    },
    otpFrom: {
        title: "Verification codes",
        submit: "Confirm",
        resend: "Resend",
        placeholder: "Enter your code"
    },
    register: {
        seoTitle: "Register - Viet Thien",
        title: "Sign up for an account",
        userName: "Email or phone number",
        fullName: "Full name",
        password: "Password",
        rePassword: "Enter the password",
        role: "I have read and accepted ",
        policy: "rules",
        submit: "Register",
        swap: "You are already a member, please ",
        login: "Log in",
        linkPolicy: "/chinh-sach/privacy-policy",
        placeholder: {
            userName: "Enter your email or phone number",
            fullName: "Enter your first and last name",
            password: "Minimum 6 characters including uppercase, lowercase and number",
            rePassword: "Reconfirm your password"
        },
        alert: {
            sendOtpSuccess: "Verification code sent to",
            sendOtpFailed: "Resend verification code failed",
            success: "Account successfully created! Sign in to shop now"
        },
        validate: {
            email: "Invalid email or phone number",
            blankPassword: "Password can not be blank",
            password: "Password must have at least 6 characters and at least 1 uppercase, 1 lowercase, 1 number",
            password1: "Re-enter password does not match"
        }
    },
    cart: {
        cartInfo: "Order Information",
        temp: "Provisional calculation",
        ship: "Delivery fee",
        freeship: "Free shipping",
        total: "Total estimates",
        pay: "Proceed with payment",
        choose: "Choose now",
        avail: "In stock",
        typeShip: "Select a shipping unit",
        accept: "Accept",
        voucher: "Discount Code",
        chooseVoucher: "Enter your discount code"
    },
    noti: {
        title: "Notify"
    },
    store: {
        title: "Shop system"
    }
});

;// CONCATENATED MODULE: ./public/lang/vi.js
/* harmony default export */ var vi = ({
    menu: {
        about: {
            title: "Giới thiệu"
        },
        products: {
            title: "Sản phẩm"
        },
        promotion: {
            title: "Ưu đ\xe3i"
        },
        news: {
            title: "Thư viện"
        },
        contact: {
            title: "Li\xean hệ"
        },
        search: {
            title: "T\xecm kiếm..."
        },
        profile: {
            title: "Hồ sơ"
        },
        store: {
            title: "Cửa h\xe0ng"
        },
        cafe: {
            title: "Cà ph\xea"
        },
        tea: {
            title: "Trà"
        },
        drink: {
            title: "Nước giải khát"
        },
        agri: {
            title: "N\xf4ng sản"
        }
    },
    miniCart: {
        titleA: "Bạn c\xf3 ",
        titleB: " sản phẩm trong giỏ",
        statusStock: "Đang c\xf3 h\xe0ng",
        labelTotal: "Tổng ước t\xednh",
        btnCart: "Giỏ h\xe0ng",
        btnPay: "Thanh to\xe1n"
    },
    profile: {
        manager: {
            home: "Trang chủ",
            title: "Quản l\xfd t\xe0i khoản",
            info: "Th\xf4ng tin t\xe0i khoản",
            info_dcr: "Quản l\xfd th\xf4ng tin t\xe0i khoản c\xe1 nh\xe2n của bạn",
            address: "Sổ địa chỉ",
            address_dcr: "Quản l\xfd địa chỉ giao h\xe0ng, thanh to\xe1n của bạn",
            purchase: "Đơn h\xe0ng đ\xe3 mua",
            purchase_dcr: "Quản l\xfd c\xe1c đơn h\xe0ng m\xe0 bạn đ\xe3 mua hoặc trả lại",
            liked: "Sản phẩm y\xeau th\xedch",
            liked_dcr: "Quản l\xfd danh s\xe1ch c\xe1c sản phẩm y\xeau th\xedch",
            adjust: "Tuỳ chọn",
            logout: "Đăng xuất",
            register: "Đăng k\xfd",
            login: "Đăng nhập"
        },
        layout: {
            home: "Trang chủ",
            title: "Quản l\xfd t\xe0i khoản",
            info: "Th\xf4ng tin t\xe0i khoản",
            address: "Sổ địa chỉ",
            purchase: "Đơn h\xe0ng đ\xe3 mua",
            liked: "Sản phẩm y\xeau th\xedch"
        },
        info: {
            info: "Th\xf4ng tin t\xe0i khoản",
            account: "T\xean đăng nhập",
            name: "Họ v\xe0 t\xean",
            date: "Ng\xe0y th\xe1ng năm sinh",
            sex: "Giới t\xednh",
            male: "Name",
            female: "Nữ",
            pass: "Mật khẩu",
            changePass: "Đổi mật khẩu",
            confirm: "X\xe1c nhận thay đổi th\xf4ng tin",
            currPass: "Mật khẩu hiện tại",
            newPass: "Mật khẩu mới",
            conPass: "X\xe1c nhận mật khẩu mới",
            valPass: "Tối thiểu 6 k\xfd tự bao gồm chữ hoa, chữ thường v\xe0 số",
            noti: "Cập nhật th\xe0nh c\xf4ng",
            notiFail: "Cập nhật kh\xf4ng th\xe0nh c\xf4ng",
            valName: "Vui l\xf2ng nhập đầy đủ họ v\xe0 t\xean"
        },
        address: {
            title: "Sổ địa chỉ",
            default: " - Địa chỉ mặc định",
            addAddress: "Th\xeam địa chỉ",
            creatAddress: "Tạo mới sổ địa chỉ",
            changeAddress: "Chỉnh sửa",
            deleteAddress: "Xo\xe1",
            deleteNoti: "Đ\xe3 xo\xe1 địa chỉ",
            province: "Tỉnh th\xe0nh phố",
            district: "Quận, huyện",
            ward: "Phường x\xe3",
            slProvince: "Chọn tỉnh th\xe0nh phố",
            slDistrict: "Chọn quận, huyện",
            slWard: "Chọn phường x\xe3",
            setDF: "Đặt l\xe0m địa chỉ mặc định",
            save: "Lưu địa chỉ",
            changeNoti: "Th\xf4ng tin đang được cập nhật"
        },
        order: {
            order: "Quản l\xfd đơn h\xe0ng",
            title: "Danh s\xe1ch đơn h\xe0ng đ\xe3 mua",
            date: "Ng\xe0y đặt h\xe0ng",
            datepredict: "Ng\xe0y giao h\xe0ng dự kiến",
            id: "M\xe3 đơn h\xe0ng",
            product: "Sản phẩm",
            quantity: "Số lượng",
            total: "Tổng tiền",
            orderDetail: "Chi tiết đơn h\xe0ng",
            name: "T\xean người nhận",
            phone: "Số điện thoại",
            address: "Địa chỉ người nhận",
            detail: "Chi tiết",
            unitPrice: "Đơn gi\xe1",
            price: "Th\xe0nh tiền",
            temp: "Tạm t\xednh",
            ship: "Ph\xed giao h\xe0ng",
            freeship: "Tiền miễn ph\xed vận chuyển",
            cancelOrder: "Huỷ đơn",
            cancelReason: "L\xfd do huỷ đơn",
            cancel_dcr: "L\xfd do huỷ đơn của bạn l\xe0: ",
            confirm: "X\xe1c nhận",
            cancel: "Huỷ",
            pay: "Tiếp tục thanh to\xe1n",
            rebuy: "Đặt lại",
            cancelNoti_suc: "Đ\xe3 huỷ đơn",
            cancelNoti_fail: "Huỷ đơn kh\xf4ng th\xe0nh c\xf4ng",
            cancelNoti_val: "Vui l\xf2ng nhập đủ k\xed tự( >5)",
            rebuyNoti_suc: "Th\xeam v\xe0o giỏ h\xe0ng th\xe0nh c\xf4ng",
            rebuyNoti_val: "Y\xeau cầu đang được xử l\xfd"
        },
        liked: {
            title: "Sản phẩm y\xeau th\xedch",
            noliked: "Bạn chưa c\xf3 sản phẩm y\xeau th\xedch"
        }
    },
    menuAuth: {
        account: "T\xe0i khoản",
        profile: "Hồ sơ",
        address: "Sổ địa chỉ",
        order: "Đơn h\xe0ng",
        liked: "Sản phẩm y\xeau th\xedch",
        option: "T\xf9y chọn",
        logout: "Đăng xuất"
    },
    homeLiked: {
        title: "Sản phẩm của ch\xfang t\xf4i"
    },
    homePromotion: {
        title: "Ưu đ\xe3i"
    },
    homeNews: {
        title: "Tin tức mới nhất"
    },
    subscribe: {
        title: "Đăng k\xfd để nhận th\xf4ng tin từ ZeMor Coffee",
        placeholder: "Nhập email của bạn",
        button: "Đăng k\xfd",
        alertSuccess: "Đăng k\xfd nhận tin tức th\xe0nh c\xf4ng",
        alertFailed: "Đăng k\xfd nhận tin tức kh\xf4ng th\xe0nh c\xf4ng"
    },
    footer: {
        addressLabel: "Địa chỉ li\xean hệ",
        customerPolicy: "Ch\xednh s\xe1ch kh\xe1ch h\xe0ng",
        contactInfo: "Th\xf4ng tin li\xean hệ",
        followUs: "Theo d\xf5i ch\xfang t\xf4i",
        payments: "Phương thức thanh to\xe1n",
        cod: "Thanh to\xe1n trực tiếp",
        bankTransfer: "Chuyển khoản",
        wallet: "V\xed điện tử",
        info1: "GIấy CNĐKKD: 0305693542 - Ng\xe0y cấp 22/02/2008",
        info2: "Cơ quan cấp: Sở Kế Hoạch v\xe0 Đầu Tư TP HCM."
    },
    contact: {
        label: "Chúng t\xf4i sẽ li\xean h\xeạ ngay, xin vui lòng đ\xeả lại th\xf4ng tin",
        taxCodeLabel: "M\xe3 số thuế",
        email: "Email",
        address: "Văn ph\xf2ng",
        form: {
            title: "Li\xean hệ với ch\xfang t\xf4i",
            fullName: "Họ v\xe0 t\xean",
            email: "Email",
            phone: "Số điện thoại",
            address: "Địa chỉ",
            content: "Nội dung",
            button: "Gửi th\xf4ng tin"
        },
        placeholder: {
            fullName: "Họ v\xe0 t\xean",
            email: "Địa chỉ email",
            phone: "Số điện thoại của qu\xfd kh\xe1ch",
            content: "Nhập nội dung ở đ\xe2y...",
            address: "Địa chỉ của qu\xfd kh\xe1ch"
        },
        placeholder2: {
            fullName: "Họ v\xe0 t\xean *",
            email: "Email *",
            phone: "Số điện thoại *",
            content: "N\xf4̣i dung",
            address: "Địa chỉ *"
        },
        map: {
            title: "Danh s\xe1ch nh\xe0 m\xe1y ZeMor Coffee"
        }
    },
    collections: {
        filterCategory: "Danh mục",
        filterPrice: "Gi\xe1",
        remove: "X\xf3a",
        from: "Từ",
        to: "Đến",
        establish: "Thiết lập",
        searchResult: "Kết quả t\xecm kiếm cho: ",
        notfound: "Kh\xf4ng t\xecm thấy sản phẩm",
        notFoundPromotion: "Hiện chưa c\xf3 sản phẩm khuyến m\xe3i",
        filter: "Lọc",
        reset: "Đặt lại",
        apply: "\xc1p dụng",
        sort: "SẮP XẾP THEO: "
    },
    login: {
        seoTitle: "Đăng nhập - ZeMor Coffee",
        title: "Đăng nhập t\xe0i khoản",
        username: "Email hoặc số điện thoại",
        password: "Mật khẩu",
        forgotPass: "Qu\xean mật khẩu?",
        submit: "ĐẶNG NHẬP",
        swap: "Bạn chưa phải th\xe0nh vi\xean, vui l\xf2ng ",
        or: "HOẶC",
        loginFB: "Đăng nhập bằng Facebook",
        signup: "Đăng k\xfd",
        placeholder: {
            username: "Nhập email hoặc số điện thoại của bạn",
            password: "Tối thiệu 6 k\xfd tự bao gồm chữ hoa, chữ thường v\xe0 số"
        },
        validate: {
            blank: "Email hoặc số điện thoại kh\xf4ng được để trống",
            blankPassword: "Mật khẩu kh\xf4ng được để trống"
        }
    },
    forgotPassword: {
        title: "Kh\xf4i phục mật khẩu",
        username: "Email hoặc số điện thoại (ch\xfang t\xf4i sẽ gửi cho bạn m\xe3 OTP để đặt lại mật khẩu)",
        submit: "Gửi v\xe0 x\xe1c nhận",
        placeholder: {
            username: "Nhập email hoặc số điện thoại của bạn"
        },
        validate: {
            blank: "T\xe0i khoản kh\xf4ng được để trống",
            send: "Gửi m\xe3 x\xe1c nhận kh\xf4ng th\xe0nh c\xf4ng"
        }
    },
    resetPassword: {
        newPassword: "Mật khẩu mới",
        reNewPassword: "Nhập lại mật khẩu mới",
        submit: "Đổi mật khẩu",
        placeholder: "Tối thiểu 6 k\xfd tự bao gồm chữ hoa, chữ thường v\xe0 số"
    },
    otpFrom: {
        title: "M\xe3 x\xe1c thực",
        submit: "X\xe1c nhận",
        resend: "Gửi lại",
        placeholder: "Nhập m\xe3 của bạn"
    },
    register: {
        seoTitle: "Đăng k\xfd - ZeMor Coffee",
        title: "Đăng k\xfd t\xe0i khoản",
        userName: "Email hoặc số điện thoại",
        fullName: "Họ v\xe0 t\xean",
        password: "Mật khẩu",
        rePassword: "Nhập lại mật khẩu",
        role: "T\xf4i đ\xe3 đọc v\xe0 chấp nhận ",
        policy: "điều khoản",
        submit: "Đăng k\xfd",
        swap: "Bạn đ\xe3 l\xe0 th\xe0nh vi\xean, vui l\xf2ng ",
        login: "Đăng nhập",
        linkPolicy: "/chinh-sach/chinh-sach-bao-mat",
        placeholder: {
            userName: "Nhập email hoặc số điện thoại của bạn",
            fullName: "Nhập họ v\xe0 t\xean của bạn",
            password: "Tối thiểu 6 k\xfd tự bao gồm chữ hoa, chữ thường v\xe0 số",
            rePassword: "X\xe1c nhận lại mật khẩu của bạn"
        },
        alert: {
            sendOtpSuccess: "M\xe3 x\xe1c thực đ\xe3 gửi đến ",
            sendOtpFailed: "Gửi lại m\xe3 x\xe1c thực kh\xf4ng th\xe0nh c\xf4ng",
            success: "Tạo t\xe0i khoản th\xe0nh c\xf4ng! Đăng nhập để mua sắm ngay n\xe0o"
        },
        validate: {
            email: "Email hoặc số điện thoại kh\xf4ng hợp lệ",
            blankPassword: "Mật khẩu kh\xf4ng được để trống",
            password: "Mật khẩu c\xf3 \xedt nhất 6 k\xfd tự v\xe0 \xedt nhất 1 chữ hoa, 1 chữ thường, 1 chữ số",
            password1: "Nhập lại mật khẩu kh\xf4ng tr\xf9ng khớp"
        }
    },
    cart: {
        cartInfo: "Th\xf4ng tin đơn h\xe0ng",
        temp: "Tạm t\xednh",
        ship: "Ph\xed giao h\xe0ng",
        freeship: "Miễn ph\xed giao h\xe0ng",
        total: "Tổng ước t\xednh",
        pay: "Tiến h\xe0nh thanh to\xe1n",
        choose: "Chọn ngay",
        avail: "Đang c\xf3 h\xe0ng",
        typeShip: "Chọn đơn vị vận chuyển",
        accept: "Chấp nhận",
        voucher: "M\xe3 giảm gi\xe1",
        chooseVoucher: "Nhập m\xe3 giảm gi\xe1 của bạn"
    },
    noti: {
        title: "Th\xf4ng b\xe1o"
    },
    store: {
        title: "Hệ thống cửa h\xe0ng"
    }
});

;// CONCATENATED MODULE: ./hooks/useTrans.js



var useTrans = function() {
    var locale = (0,router.useRouter)().locale;
    var trans = locale === "vi" ? vi : en;
    return trans;
};
/* harmony default export */ var hooks_useTrans = (useTrans);


/***/ }),

/***/ 15170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useUserInfo; }
/* harmony export */ });
/* harmony import */ var _setup_flexbiz_api_provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34733);

function useUserInfo() {
    var userInfo = (0,_setup_flexbiz_api_provider__WEBPACK_IMPORTED_MODULE_0__/* .useApiContext */ .Q)().userInfo;
    var isLogin = undefined;
    if (userInfo && userInfo.token) {
        isLogin = true;
    } else {
        isLogin = false;
    }
    return {
        isLogin: isLogin,
        userInfo: userInfo
    };
};


/***/ }),

/***/ 90698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64761);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



// default mantine breakpoint
// xs	576px
// sm	768px
// md	992px
// lg	1200px
// xl	1400px
// Usage
function useWindowSize() {
    var size = useWindowSizes();
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_1__/* .useMantineTheme */ .rZ)();
    //   console.log(size);
    return {
        size: size,
        isMobile: size.width < theme.breakpoints.xs,
        isTablet: size.width < theme.breakpoints.md,
        isLaptop: size.width > theme.breakpoints.lg,
        isDesktop: size.width > theme.breakpoints.xl,
        aboveTablet: size.width > theme.breakpoints.md,
        xs: theme.breakpoints.xs,
        sm: theme.breakpoints.sm,
        md: theme.breakpoints.md
    };
};
// Hook
function useWindowSizes() {
    var handleResize = function handleResize() {
        // Set window width/height to state
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: undefined,
        height: undefined
    }), windowSize = ref[0], setWindowSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // only execute all the code below in client side
        if (true) {
            // Handler to call on window resize
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return function() {
                return window.removeEventListener("resize", handleResize);
            };
        }
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}


/***/ }),

/***/ 71210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        var normalizeLocalePath = (__webpack_require__(78875).normalizeLocalePath);
        var detectDomainLocale = (__webpack_require__(38748).detectDomainLocale);
        var target = locale || normalizeLocalePath(path, locales).detectedLocale;
        var domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            var proto = "http".concat(domain.http ? "" : "s", "://");
            var finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 28045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _head = _interop_require_default(__webpack_require__(5443));
var _imageConfig = __webpack_require__(99309);
var _useIntersection = __webpack_require__(57190);
var _imageConfigContext = __webpack_require__(59977);
var _utils = __webpack_require__(63794);
var _normalizeTrailingSlash = __webpack_require__(82392);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (experimentalUnoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
var ref = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false} || {}, _experimentalRemotePatterns = ref.experimentalRemotePatterns, experimentalRemotePatterns = _experimentalRemotePatterns === void 0 ? [] : _experimentalRemotePatterns, experimentalUnoptimized = ref.experimentalUnoptimized;
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 48418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(45753)["default"]);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _router = __webpack_require__(76273);
var _addLocale = __webpack_require__(22725);
var _routerContext = __webpack_require__(63462);
var _appRouterContext = __webpack_require__(21018);
var _useIntersection = __webpack_require__(57190);
var _getDomainLocale = __webpack_require__(71210);
var _addBasePath = __webpack_require__(98684);
// @ts-ignore useTransition exist
var hasUseTransition = typeof _react.default.useTransition !== "undefined";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, soft, shallow, scroll, locale, startTransition) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an AppRouterInstance, then it'll have `softPush` and
        // `softReplace`.
        if ("softPush" in router && "softReplace" in router) {
            // If we're doing a soft navigation, use the soft variants of
            // replace/push.
            var method = soft ? replace ? "softReplace" : "softPush" : replace ? "replace" : "push";
            router[method](href);
        } else {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        }
    };
    if (startTransition) {
        startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, soft = props.soft, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "soft",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var ref = _slicedToArray(hasUseTransition ? // @ts-ignore useTransition exists
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.default.useTransition() : [], 2), /* isPending */ startTransition = ref[1];
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref1 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref1.href, as = ref1.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref2 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref2[0], isVisible = ref2[1], resetVisible = ref2[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, soft, shallow, scroll, locale, appRouter ? startTransition : undefined);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 78875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
var normalizeLocalePath = function(pathname, locales) {
    if (true) {
        return (__webpack_require__(94317).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname: pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (unobserve.current) {
                unobserve.current();
                unobserve.current = undefined;
            }
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                unobserve.current = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
            }
            return function() {
                unobserve.current == null ? void 0 : unobserve.current();
                unobserve.current = undefined;
            };
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
var observers = new Map();
var idList = [];
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 21018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 77017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./styles/embla.css
var embla = __webpack_require__(88308);
// EXTERNAL MODULE: ./styles/globals.css
var globals = __webpack_require__(40906);
// EXTERNAL MODULE: ./styles/webview.css
var webview = __webpack_require__(59967);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/setimmediate/setImmediate.js
var setImmediate = __webpack_require__(99647);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/tocbot/static/css/tocbot.css
var tocbot = __webpack_require__(72227);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/Layout/index.js + 30 modules
var Layout = __webpack_require__(28964);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./next-seo.config.js
var title = "ZeMor Coffee";
var description = "";
var defaultSEOConfigs = {
    titleTemplate: "%s | Be great & more",
    defaultTitle: title,
    title: title,
    //
    description: description,
    openGraph: {
        type: "website",
        url: "https://zemor.vn/",
        title: title,
        description: description,
        locale: "vi",
        site_name: "ZeMor",
        images: [
            {
                url: "https://api.flexzen.app/api/617029ff29b9fb21e16741bb/file/download/64143197713e21140283a000?size=S&access_token=5d317ff07b8baef29f3230a69fe9d617",
                width: 315,
                height: 160,
                alt: "ZeMor logo"
            }, 
        ]
    }
};
/* harmony default export */ var next_seo_config = (defaultSEOConfigs);

// EXTERNAL MODULE: ./setup/cartProvider/index.js + 2 modules
var cartProvider = __webpack_require__(27104);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(89611);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,setPrototypeOf/* default */.Z)(subClass, superClass);
}
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@mantine/notifications/node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
;// CONCATENATED MODULE: ./node_modules/@mantine/notifications/node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ var TransitionGroupContext = (react.createContext(null));
;// CONCATENATED MODULE: ./node_modules/@mantine/notifications/node_modules/react-transition-group/esm/Transition.js








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
;// CONCATENATED MODULE: ./node_modules/@mantine/notifications/node_modules/react-transition-group/esm/utils/ChildMapping.js

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0,react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0,react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0,react.isValidElement)(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = (0,react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0,react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0,react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
;// CONCATENATED MODULE: ./node_modules/@mantine/notifications/node_modules/react-transition-group/esm/TransitionGroup.js









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind((0,assertThisInitialized/* default */.Z)(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = (0,esm_extends/* default */.Z)({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/react.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/react.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/react.createElement(Component, props, children));
  };

  return TransitionGroup;
}(react.Component);

TransitionGroup.propTypes =  false ? 0 : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ var esm_TransitionGroup = (TransitionGroup);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/utils/get-default-z-index/get-default-z-index.js
var get_default_z_index = __webpack_require__(3594);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Portal/Portal.js
var Portal = __webpack_require__(40254);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-force-update/use-force-update.js


const reducer = (value) => (value + 1) % 1e6;
function useForceUpdate() {
  const [, update] = (0,react.useReducer)(reducer, 0);
  return update;
}


//# sourceMappingURL=use-force-update.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-reduced-motion/use-reduced-motion.js
var use_reduced_motion = __webpack_require__(73678);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-did-update/use-did-update.js
var use_did_update = __webpack_require__(37048);
;// CONCATENATED MODULE: ./node_modules/@mantine/notifications/esm/Notifications.context.js


const NotificationsContext = (0,react.createContext)(null);
NotificationsContext.displayName = "@mantine/notifications/NotificationsContext";


//# sourceMappingURL=Notifications.context.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/notifications/esm/events.js + 1 modules
var events = __webpack_require__(33575);
;// CONCATENATED MODULE: ./node_modules/@mantine/notifications/esm/NotificationsProvider/get-position-styles/get-position-styles.js
function getPositionStyles([vertical, horizontal], spacing) {
  const styles = {};
  vertical === "top" && (styles.top = spacing);
  vertical === "bottom" && (styles.bottom = spacing);
  horizontal === "left" && (styles.left = spacing);
  horizontal === "right" && (styles.right = spacing);
  horizontal === "center" && (styles.left = "50%", styles.transform = "translateX(-50%)");
  return styles;
}

/* harmony default export */ var get_position_styles = (getPositionStyles);
//# sourceMappingURL=get-position-styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/notifications/esm/NotificationsProvider/get-notification-state-styles/get-notification-state-styles.js
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const transforms = {
  left: "translateX(-100%)",
  right: "translateX(100%)",
  "top-center": "translateY(-100%)",
  "bottom-center": "translateY(100%)"
};
const noTransform = {
  left: "translateX(0)",
  right: "translateX(0)",
  "top-center": "translateY(0)",
  "bottom-center": "translateY(0)"
};
function getNotificationStateStyles({
  state,
  maxHeight,
  positioning,
  transitionDuration
}) {
  const [vertical, horizontal] = positioning;
  const property = horizontal === "center" ? `${vertical}-center` : horizontal;
  const commonStyles = {
    opacity: 0,
    maxHeight,
    transform: transforms[property],
    transitionDuration: `${transitionDuration}ms, ${transitionDuration}ms, ${transitionDuration}ms`,
    transitionTimingFunction: "cubic-bezier(.51,.3,0,1.21), cubic-bezier(.51,.3,0,1.21), linear",
    transitionProperty: "opacity, transform, max-height"
  };
  const inState = {
    opacity: 1,
    transform: noTransform[property]
  };
  const outState = {
    opacity: 0,
    maxHeight: 0,
    transform: transforms[property]
  };
  const transitionStyles = {
    entering: inState,
    entered: inState,
    exiting: outState,
    exited: outState
  };
  return __spreadValues(__spreadValues({}, commonStyles), transitionStyles[state]);
}

/* harmony default export */ var get_notification_state_styles = (getNotificationStateStyles);
//# sourceMappingURL=get-notification-state-styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Notification/Notification.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { color, radius, withTitle }, getRef) => {
  const _radius = theme.fn.radius(radius);
  const topBottom = Math.min(Math.max(_radius / 1.2, 4), 30);
  const colors = theme.fn.variant({ variant: "filled", color });
  return {
    closeButton: theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
    }),
    icon: {
      ref: getRef("icon"),
      boxSizing: "border-box",
      marginRight: theme.spacing.md,
      width: 28,
      height: 28,
      borderRadius: 28,
      display: "flex",
      flex: "none",
      alignItems: "center",
      justifyContent: "center",
      color: theme.white
    },
    withIcon: {
      paddingLeft: theme.spacing.xs,
      "&::before": {
        display: "none"
      }
    },
    root: {
      boxSizing: "border-box",
      position: "relative",
      display: "flex",
      alignItems: "center",
      paddingLeft: 22,
      paddingRight: 5,
      paddingTop: theme.spacing.xs,
      paddingBottom: theme.spacing.xs,
      borderRadius: _radius,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
      boxShadow: theme.shadows.lg,
      border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2]}`,
      "&::before": {
        content: '""',
        display: "block",
        position: "absolute",
        width: 6,
        top: topBottom,
        bottom: topBottom,
        left: 4,
        borderRadius: _radius,
        backgroundColor: colors.background
      },
      [`& .${getRef("icon")}`]: {
        backgroundColor: colors.background,
        color: theme.white
      }
    },
    body: {
      flex: 1,
      overflow: "hidden",
      marginRight: 10
    },
    loader: {
      marginRight: theme.spacing.md
    },
    title: {
      lineHeight: 1.4,
      marginBottom: 2,
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: theme.colorScheme === "dark" ? theme.white : theme.colors.gray[9]
    },
    description: {
      color: withTitle ? theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6] : theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      lineHeight: 1.4,
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  };
});

/* harmony default export */ var Notification_styles = (useStyles);
//# sourceMappingURL=Notification.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Loader/Loader.js + 3 modules
var Loader = __webpack_require__(20966);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/CloseButton/CloseButton.js + 1 modules
var CloseButton = __webpack_require__(80971);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Notification/Notification.js








var Notification_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Notification_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Notification_hasOwnProp = Object.prototype.hasOwnProperty;
var Notification_propIsEnum = Object.prototype.propertyIsEnumerable;
var Notification_defNormalProp = (obj, key, value) => key in obj ? Notification_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Notification_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Notification_hasOwnProp.call(b, prop))
      Notification_defNormalProp(a, prop, b[prop]);
  if (Notification_getOwnPropSymbols)
    for (var prop of Notification_getOwnPropSymbols(b)) {
      if (Notification_propIsEnum.call(b, prop))
        Notification_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Notification_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Notification_getOwnPropSymbols)
    for (var prop of Notification_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Notification_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Notification = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Notification", {}, props), {
    className,
    color,
    radius,
    loading,
    disallowClose,
    title,
    icon,
    children,
    onClose,
    closeButtonProps,
    classNames,
    styles,
    unstyled
  } = _a, others = __objRest(_a, [
    "className",
    "color",
    "radius",
    "loading",
    "disallowClose",
    "title",
    "icon",
    "children",
    "onClose",
    "closeButtonProps",
    "classNames",
    "styles",
    "unstyled"
  ]);
  const { classes, cx } = Notification_styles({ color, radius, withTitle: !!title }, { classNames, styles, unstyled, name: "Notification" });
  const withIcon = icon || loading;
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, Notification_spreadValues({
    className: cx(classes.root, { [classes.withIcon]: withIcon }, className),
    role: "alert",
    ref
  }, others), icon && !loading && /* @__PURE__ */ react.createElement("div", {
    className: classes.icon
  }, icon), loading && /* @__PURE__ */ react.createElement(Loader/* Loader */.a, {
    size: 28,
    color,
    className: classes.loader
  }), /* @__PURE__ */ react.createElement("div", {
    className: classes.body
  }, title && /* @__PURE__ */ react.createElement(Text/* Text */.x, {
    className: classes.title,
    size: "sm",
    weight: 500
  }, title), /* @__PURE__ */ react.createElement(Text/* Text */.x, {
    color: "dimmed",
    className: classes.description,
    size: "sm"
  }, children)), !disallowClose && /* @__PURE__ */ react.createElement(CloseButton/* CloseButton */.P, __spreadProps(Notification_spreadValues({
    iconSize: 16,
    color: "gray"
  }, closeButtonProps), {
    onClick: onClose,
    className: classes.closeButton
  })));
});
Notification.displayName = "@mantine/core/Notification";


//# sourceMappingURL=Notification.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/notifications/esm/NotificationContainer/get-auto-close/get-auto-close.js
function getAutoClose(autoClose, notificationAutoClose) {
  if (typeof notificationAutoClose === "number") {
    return notificationAutoClose;
  }
  if (notificationAutoClose === false || autoClose === false) {
    return false;
  }
  return autoClose;
}

/* harmony default export */ var get_auto_close = (getAutoClose);
//# sourceMappingURL=get-auto-close.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/notifications/esm/NotificationContainer/NotificationContainer.js




var NotificationContainer_defProp = Object.defineProperty;
var NotificationContainer_defProps = Object.defineProperties;
var NotificationContainer_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var NotificationContainer_getOwnPropSymbols = Object.getOwnPropertySymbols;
var NotificationContainer_hasOwnProp = Object.prototype.hasOwnProperty;
var NotificationContainer_propIsEnum = Object.prototype.propertyIsEnumerable;
var NotificationContainer_defNormalProp = (obj, key, value) => key in obj ? NotificationContainer_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var NotificationContainer_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (NotificationContainer_hasOwnProp.call(b, prop))
      NotificationContainer_defNormalProp(a, prop, b[prop]);
  if (NotificationContainer_getOwnPropSymbols)
    for (var prop of NotificationContainer_getOwnPropSymbols(b)) {
      if (NotificationContainer_propIsEnum.call(b, prop))
        NotificationContainer_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var NotificationContainer_spreadProps = (a, b) => NotificationContainer_defProps(a, NotificationContainer_getOwnPropDescs(b));
var NotificationContainer_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (NotificationContainer_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && NotificationContainer_getOwnPropSymbols)
    for (var prop of NotificationContainer_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && NotificationContainer_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function NotificationContainer(_a) {
  var _b = _a, {
    notification,
    autoClose,
    onHide,
    innerRef
  } = _b, others = NotificationContainer_objRest(_b, [
    "notification",
    "autoClose",
    "onHide",
    "innerRef"
  ]);
  const _a2 = notification, { autoClose: notificationAutoClose, message } = _a2, notificationProps = NotificationContainer_objRest(_a2, ["autoClose", "message"]);
  const autoCloseTimeout = get_auto_close(autoClose, notificationAutoClose);
  const hideTimeout = (0,react.useRef)();
  const handleHide = () => {
    onHide(notification.id);
    window.clearTimeout(hideTimeout.current);
  };
  const cancelDelayedHide = () => {
    clearTimeout(hideTimeout.current);
  };
  const handleDelayedHide = () => {
    if (typeof autoCloseTimeout === "number") {
      hideTimeout.current = window.setTimeout(handleHide, autoCloseTimeout);
    }
  };
  (0,react.useEffect)(() => {
    if (typeof notification.onOpen === "function") {
      notification.onOpen(notification);
    }
  }, []);
  (0,react.useEffect)(() => {
    handleDelayedHide();
    return cancelDelayedHide;
  }, [autoClose, notification.autoClose]);
  return /* @__PURE__ */ react.createElement(Notification, NotificationContainer_spreadProps(NotificationContainer_spreadValues(NotificationContainer_spreadValues({}, notificationProps), others), {
    onClose: handleHide,
    onMouseEnter: cancelDelayedHide,
    onMouseLeave: handleDelayedHide,
    ref: innerRef
  }), message);
}
NotificationContainer.displayName = "@mantine/notifications/NotificationContainer";

/* harmony default export */ var NotificationContainer_NotificationContainer = (NotificationContainer);
//# sourceMappingURL=NotificationContainer.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/notifications/esm/NotificationsProvider/NotificationsProvider.styles.js


var NotificationsProvider_styles_useStyles = (0,create_styles/* createStyles */.k)((theme, { zIndex }) => ({
  notifications: {
    width: `calc(100% - ${theme.spacing.md * 2}px)`,
    boxSizing: "border-box",
    position: "fixed",
    zIndex
  },
  notification: {
    "&:not(:first-of-type)": {
      marginTop: theme.spacing.sm
    }
  }
}));

/* harmony default export */ var NotificationsProvider_styles = (NotificationsProvider_styles_useStyles);
//# sourceMappingURL=NotificationsProvider.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-queue/use-queue.js


function useQueue({ initialValues = [], limit }) {
  const [{ state, queue }, setState] = (0,react.useState)({
    state: initialValues.slice(0, limit),
    queue: initialValues.slice(limit)
  });
  const add = (...items) => setState((current) => {
    const results = [...current.state, ...current.queue, ...items];
    return {
      state: results.slice(0, limit),
      queue: results.slice(limit)
    };
  });
  const update = (fn) => setState((current) => {
    const results = fn([...current.state, ...current.queue]);
    return {
      state: results.slice(0, limit),
      queue: results.slice(limit)
    };
  });
  const cleanQueue = () => setState((current) => ({ state: current.state, queue: [] }));
  return {
    state,
    queue,
    add,
    update,
    cleanQueue
  };
}


//# sourceMappingURL=use-queue.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/utils/random-id/random-id.js
var random_id = __webpack_require__(89058);
;// CONCATENATED MODULE: ./node_modules/@mantine/notifications/esm/NotificationsProvider/use-notifications-state/use-notifications-state.js


var use_notifications_state_defProp = Object.defineProperty;
var use_notifications_state_defProps = Object.defineProperties;
var use_notifications_state_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var use_notifications_state_getOwnPropSymbols = Object.getOwnPropertySymbols;
var use_notifications_state_hasOwnProp = Object.prototype.hasOwnProperty;
var use_notifications_state_propIsEnum = Object.prototype.propertyIsEnumerable;
var use_notifications_state_defNormalProp = (obj, key, value) => key in obj ? use_notifications_state_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var use_notifications_state_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (use_notifications_state_hasOwnProp.call(b, prop))
      use_notifications_state_defNormalProp(a, prop, b[prop]);
  if (use_notifications_state_getOwnPropSymbols)
    for (var prop of use_notifications_state_getOwnPropSymbols(b)) {
      if (use_notifications_state_propIsEnum.call(b, prop))
        use_notifications_state_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var use_notifications_state_spreadProps = (a, b) => use_notifications_state_defProps(a, use_notifications_state_getOwnPropDescs(b));
function useNotificationsState({ limit }) {
  const { state, queue, update, cleanQueue } = useQueue({
    initialValues: [],
    limit
  });
  const showNotification = (notification) => {
    const id = notification.id || (0,random_id/* randomId */.k)();
    update((notifications) => {
      if (notification.id && notifications.some((n) => n.id === notification.id)) {
        return notifications;
      }
      return [...notifications, use_notifications_state_spreadProps(use_notifications_state_spreadValues({}, notification), { id })];
    });
    return id;
  };
  const updateNotification = (notification) => update((notifications) => {
    const index = notifications.findIndex((n) => n.id === notification.id);
    if (index === -1) {
      return notifications;
    }
    const newNotifications = [...notifications];
    newNotifications[index] = notification;
    return newNotifications;
  });
  const hideNotification = (id) => update((notifications) => notifications.filter((notification) => {
    if (notification.id === id) {
      typeof notification.onClose === "function" && notification.onClose(notification);
      return false;
    }
    return true;
  }));
  const clean = () => update(() => []);
  return {
    notifications: state,
    queue,
    showNotification,
    updateNotification,
    hideNotification,
    cleanQueue,
    clean
  };
}

/* harmony default export */ var use_notifications_state = (useNotificationsState);
//# sourceMappingURL=use-notifications-state.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/notifications/esm/NotificationsProvider/NotificationsProvider.js












var NotificationsProvider_defProp = Object.defineProperty;
var NotificationsProvider_getOwnPropSymbols = Object.getOwnPropertySymbols;
var NotificationsProvider_hasOwnProp = Object.prototype.hasOwnProperty;
var NotificationsProvider_propIsEnum = Object.prototype.propertyIsEnumerable;
var NotificationsProvider_defNormalProp = (obj, key, value) => key in obj ? NotificationsProvider_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var NotificationsProvider_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (NotificationsProvider_hasOwnProp.call(b, prop))
      NotificationsProvider_defNormalProp(a, prop, b[prop]);
  if (NotificationsProvider_getOwnPropSymbols)
    for (var prop of NotificationsProvider_getOwnPropSymbols(b)) {
      if (NotificationsProvider_propIsEnum.call(b, prop))
        NotificationsProvider_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var NotificationsProvider_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (NotificationsProvider_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && NotificationsProvider_getOwnPropSymbols)
    for (var prop of NotificationsProvider_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && NotificationsProvider_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const POSITIONS = [
  "top-left",
  "top-right",
  "top-center",
  "bottom-left",
  "bottom-right",
  "bottom-center"
];
function NotificationsProvider(_a) {
  var _b = _a, {
    className,
    position = "bottom-right",
    autoClose = 4e3,
    transitionDuration = 250,
    containerWidth = 440,
    notificationMaxHeight = 200,
    limit = 5,
    zIndex = (0,get_default_z_index/* getDefaultZIndex */.w)("overlay"),
    style,
    children,
    target
  } = _b, others = NotificationsProvider_objRest(_b, [
    "className",
    "position",
    "autoClose",
    "transitionDuration",
    "containerWidth",
    "notificationMaxHeight",
    "limit",
    "zIndex",
    "style",
    "children",
    "target"
  ]);
  const forceUpdate = useForceUpdate();
  const refs = (0,react.useRef)({});
  const previousLength = (0,react.useRef)(0);
  const {
    notifications,
    queue,
    showNotification,
    updateNotification,
    hideNotification,
    clean,
    cleanQueue
  } = use_notifications_state({ limit });
  const { classes, cx, theme } = NotificationsProvider_styles({ zIndex });
  const shouldReduceMotion = (0,use_reduced_motion/* useReducedMotion */.J)();
  const reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
  const duration = reduceMotion ? 1 : transitionDuration;
  const positioning = (POSITIONS.includes(position) ? position : "bottom-right").split("-");
  (0,use_did_update/* useDidUpdate */.l)(() => {
    if (notifications.length > previousLength.current) {
      setTimeout(() => forceUpdate(), 0);
    }
    previousLength.current = notifications.length;
  }, [notifications]);
  (0,events/* useNotificationsEvents */.Gy)({
    show: showNotification,
    hide: hideNotification,
    update: updateNotification,
    clean,
    cleanQueue
  });
  const items = notifications.map((notification) => /* @__PURE__ */ react.createElement(esm_Transition, {
    key: notification.id,
    timeout: duration,
    onEnter: () => refs.current[notification.id].offsetHeight,
    nodeRef: { current: refs.current[notification.id] }
  }, (state) => /* @__PURE__ */ react.createElement(NotificationContainer_NotificationContainer, {
    innerRef: (node) => {
      refs.current[notification.id] = node;
    },
    notification,
    onHide: hideNotification,
    className: classes.notification,
    autoClose,
    sx: [
      NotificationsProvider_spreadValues({}, get_notification_state_styles({
        state,
        positioning,
        transitionDuration: duration,
        maxHeight: notificationMaxHeight
      })),
      ...Array.isArray(notification.sx) ? notification.sx : [notification.sx]
    ]
  })));
  return /* @__PURE__ */ react.createElement(NotificationsContext.Provider, {
    value: { notifications, queue }
  }, /* @__PURE__ */ react.createElement(Portal/* Portal */.h, {
    target
  }, /* @__PURE__ */ react.createElement(Box/* Box */.x, NotificationsProvider_spreadValues({
    className: cx(classes.notifications, className),
    style,
    sx: NotificationsProvider_spreadValues({
      maxWidth: containerWidth
    }, get_position_styles(positioning, theme.spacing.md))
  }, others), /* @__PURE__ */ react.createElement(esm_TransitionGroup, null, items))), children);
}
NotificationsProvider.displayName = "@mantine/notifications/NotificationsProvider";


//# sourceMappingURL=NotificationsProvider.js.map

;// CONCATENATED MODULE: ./setup/mantine-provider/index.js



function ThemeProvider(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MantineProvider/* MantineProvider */.Me, {
        // withCSSVariables
        withGlobalStyles: true,
        withNormalizeCSS: true,
        theme: {
            // colorScheme: ["light", "dark"], // BUG: override other css accidentally
            primaryShade: 5,
            dateFormat: "DD/MM/YYYY",
            datesLocale: "vi",
            radius: {
                xs: 4,
                sm: 6,
                md: 8,
                lg: 10,
                xl: 12
            },
            colors: {
                main: [
                    "#a2cebd",
                    "#8fc4af",
                    "#7dbaa2",
                    "#6ab195",
                    "#58a787",
                    "#459d7a",
                    "#3e8d6e",
                    "#377e62",
                    "#306e55",
                    "#295e49"
                ],
                // second: [
                //   "#2f2415",
                //   "#463620",
                //   "#544127",
                //   "#624c2d",
                //   "#705733",
                //   "#7e613a",
                //   "#2f2415",
                //   "#9a7647",
                //   "#a8804d",
                //   "#b28b57",
                // ],
                second: [
                    "#424955",
                    "#323842",
                    "#171A1F",
                    "#459D7A",
                    "#DEE1E6",
                    "#EC5A77",
                    "#323842",
                    "#323842",
                    "#323842",
                    "#323842"
                ]
            },
            primaryColor: "main",
            // typo
            fontFamily: "Gotham Rounded Book",
            fontSizes: {
                xs: 12,
                sm: 14,
                md: 16,
                lg: 18,
                xl: 20
            },
            breakpoints: {
                xs: 576,
                sm: 768,
                md: 992,
                lg: 1200,
                xl: 1400
            },
            headings: {
                fontFamily: "Gotham Rounded Book",
                fontWeight: 700,
                sizes: {
                    h1: {
                        fontSize: 40
                    },
                    h2: {
                        fontSize: 34
                    },
                    h3: {
                        fontSize: 30
                    },
                    h4: {
                        fontSize: 24
                    },
                    h5: {
                        fontSize: 20
                    },
                    h6: {
                        fontSize: 16
                    }
                }
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationsProvider, {
            position: "top-right",
            zIndex: 2077,
            limit: 3,
            children: children
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-sync-storage-persister/build/lib/index.mjs
function createSyncStoragePersister({
  storage,
  key = "REACT_QUERY_OFFLINE_CACHE",
  throttleTime = 1000,
  serialize = JSON.stringify,
  deserialize = JSON.parse,
  retry
}) {
  if (typeof storage !== 'undefined') {
    const trySave = persistedClient => {
      try {
        storage.setItem(key, serialize(persistedClient));
        return;
      } catch (error) {
        return error;
      }
    };

    return {
      persistClient: throttle(persistedClient => {
        let client = persistedClient;
        let error = trySave(client);
        let errorCount = 0;

        while (error && client) {
          errorCount++;
          client = retry == null ? void 0 : retry({
            persistedClient: client,
            error,
            errorCount
          });

          if (client) {
            error = trySave(client);
          }
        }
      }, throttleTime),
      restoreClient: () => {
        const cacheString = storage.getItem(key);

        if (!cacheString) {
          return;
        }

        return deserialize(cacheString);
      },
      removeClient: () => {
        storage.removeItem(key);
      }
    };
  }

  return {
    persistClient: lib_noop,
    restoreClient: () => undefined,
    removeClient: lib_noop
  };
}

function throttle(func, wait = 100) {
  let timer = null;
  let params;
  return function (...args) {
    params = args;

    if (timer === null) {
      timer = setTimeout(() => {
        func(...params);
        timer = null;
      }, wait);
    }
  };
} // eslint-disable-next-line @typescript-eslint/no-empty-function


function lib_noop() {}


//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/logger.mjs
var logger = __webpack_require__(30819);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/retryer.mjs
var retryer = __webpack_require__(72379);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/removable.mjs
var removable = __webpack_require__(89643);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/query.mjs






// CLASS
class Query extends removable/* Removable */.F {
  constructor(config) {
    super();
    this.abortSignalConsumed = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.logger = config.logger || logger/* defaultLogger */._;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || getDefaultState(this.options);
    this.state = this.initialState;
  }

  get meta() {
    return this.options.meta;
  }

  setOptions(options) {
    this.options = { ...this.defaultOptions,
      ...options
    };
    this.updateCacheTime(this.options.cacheTime);
  }

  optionalRemove() {
    if (!this.observers.length && this.state.fetchStatus === 'idle') {
      this.cache.remove(this);
    }
  }

  setData(newData, options) {
    const data = (0,utils/* replaceData */.oE)(this.state.data, newData, this.options); // Set data and mark it as cached

    this.dispatch({
      data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt,
      manual: options == null ? void 0 : options.manual
    });
    return data;
  }

  setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state,
      setStateOptions
    });
  }

  cancel(options) {
    var _this$retryer;

    const promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  }

  destroy() {
    super.destroy();
    this.cancel({
      silent: true
    });
  }

  reset() {
    this.destroy();
    this.setState(this.initialState);
  }

  isActive() {
    return this.observers.some(observer => observer.options.enabled !== false);
  }

  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }

  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(observer => observer.getCurrentResult().isStale);
  }

  isStaleByTime(staleTime = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  }

  onFocus() {
    var _this$retryer2;

    const observer = this.observers.find(x => x.shouldFetchOnWindowFocus());

    if (observer) {
      observer.refetch({
        cancelRefetch: false
      });
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  }

  onOnline() {
    var _this$retryer3;

    const observer = this.observers.find(x => x.shouldFetchOnReconnect());

    if (observer) {
      observer.refetch({
        cancelRefetch: false
      });
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  }

  addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer); // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer
      });
    }
  }

  removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(x => x !== observer);

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        this.scheduleGc();
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer
      });
    }
  }

  getObserversCount() {
    return this.observers.length;
  }

  invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  }

  fetch(options, fetchOptions) {
    var _this$options$behavio, _context$fetchOptions;

    if (this.state.fetchStatus !== 'idle') {
      if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      const observer = this.observers.find(x => x.options.queryFn);

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    if (!Array.isArray(this.options.queryKey)) {
      if (false) {}
    }

    const abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    const queryFnContext = {
      queryKey: this.queryKey,
      pageParam: undefined,
      meta: this.meta
    }; // Adds an enumerable signal property to the object that
    // which sets abortSignalConsumed to true when the signal
    // is read.

    const addSignalProperty = object => {
      Object.defineProperty(object, 'signal', {
        enumerable: true,
        get: () => {
          if (abortController) {
            this.abortSignalConsumed = true;
            return abortController.signal;
          }

          return undefined;
        }
      });
    };

    addSignalProperty(queryFnContext); // Create fetch function

    const fetchFn = () => {
      if (!this.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      this.abortSignalConsumed = false;
      return this.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    const context = {
      fetchOptions,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn
    };
    addSignalProperty(context);
    (_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted

    this.revertState = this.state; // Set to fetching state if not already in it

    if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    }

    const onError = error => {
      // Optimistically update state if needed
      if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
        this.dispatch({
          type: 'error',
          error: error
        });
      }

      if (!(0,retryer/* isCancelledError */.DV)(error)) {
        var _this$cache$config$on, _this$cache$config;

        // Notify cache callback
        (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null ? void 0 : _this$cache$config$on.call(_this$cache$config, error, this);

        if (false) {}
      }

      if (!this.isFetchingOptimistic) {
        // Schedule query gc after fetching
        this.scheduleGc();
      }

      this.isFetchingOptimistic = false;
    }; // Try to fetch the data


    this.retryer = (0,retryer/* createRetryer */.Mz)({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
      onSuccess: data => {
        var _this$cache$config$on2, _this$cache$config2;

        if (typeof data === 'undefined') {
          if (false) {}

          onError(new Error('undefined'));
          return;
        }

        this.setData(data); // Notify cache callback

        (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSuccess) == null ? void 0 : _this$cache$config$on2.call(_this$cache$config2, data, this);

        if (!this.isFetchingOptimistic) {
          // Schedule query gc after fetching
          this.scheduleGc();
        }

        this.isFetchingOptimistic = false;
      },
      onError,
      onFail: (failureCount, error) => {
        this.dispatch({
          type: 'failed',
          failureCount,
          error
        });
      },
      onPause: () => {
        this.dispatch({
          type: 'pause'
        });
      },
      onContinue: () => {
        this.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay,
      networkMode: context.options.networkMode
    });
    this.promise = this.retryer.promise;
    return this.promise;
  }

  dispatch(action) {
    const reducer = state => {
      var _action$meta, _action$dataUpdatedAt;

      switch (action.type) {
        case 'failed':
          return { ...state,
            fetchFailureCount: action.failureCount,
            fetchFailureReason: action.error
          };

        case 'pause':
          return { ...state,
            fetchStatus: 'paused'
          };

        case 'continue':
          return { ...state,
            fetchStatus: 'fetching'
          };

        case 'fetch':
          return { ...state,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
            fetchStatus: (0,retryer/* canFetch */.Kw)(this.options.networkMode) ? 'fetching' : 'paused',
            ...(!state.dataUpdatedAt && {
              error: null,
              status: 'loading'
            })
          };

        case 'success':
          return { ...state,
            data: action.data,
            dataUpdateCount: state.dataUpdateCount + 1,
            dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
            error: null,
            isInvalidated: false,
            status: 'success',
            ...(!action.manual && {
              fetchStatus: 'idle',
              fetchFailureCount: 0,
              fetchFailureReason: null
            })
          };

        case 'error':
          const error = action.error;

          if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
            return { ...this.revertState
            };
          }

          return { ...state,
            error: error,
            errorUpdateCount: state.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: state.fetchFailureCount + 1,
            fetchFailureReason: error,
            fetchStatus: 'idle',
            status: 'error'
          };

        case 'invalidate':
          return { ...state,
            isInvalidated: true
          };

        case 'setState':
          return { ...state,
            ...action.state
          };
      }
    };

    this.state = reducer(this.state);
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.observers.forEach(observer => {
        observer.onQueryUpdate(action);
      });
      this.cache.notify({
        query: this,
        type: 'updated',
        action
      });
    });
  }

}

function getDefaultState(options) {
  const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
  const hasData = typeof data !== 'undefined';
  const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
  return {
    data,
    dataUpdateCount: 0,
    dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: false,
    status: hasData ? 'success' : 'loading',
    fetchStatus: 'idle'
  };
}


//# sourceMappingURL=query.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(33989);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/queryCache.mjs





// CLASS
class QueryCache extends subscribable/* Subscribable */.l {
  constructor(config) {
    super();
    this.config = config || {};
    this.queries = [];
    this.queriesMap = {};
  }

  build(client, options, state) {
    var _options$queryHash;

    const queryKey = options.queryKey;
    const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    let query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        logger: client.getLogger(),
        queryKey,
        queryHash,
        options: client.defaultQueryOptions(options),
        state,
        defaultOptions: client.getQueryDefaults(queryKey)
      });
      this.add(query);
    }

    return query;
  }

  add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'added',
        query
      });
    }
  }

  remove(query) {
    const queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(x => x !== query);

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'removed',
        query
      });
    }
  }

  clear() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        this.remove(query);
      });
    });
  }

  get(queryHash) {
    return this.queriesMap[queryHash];
  }

  getAll() {
    return this.queries;
  }

  find(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(query => (0,utils/* matchQuery */._x)(filters, query));
  }

  findAll(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    return Object.keys(filters).length > 0 ? this.queries.filter(query => (0,utils/* matchQuery */._x)(filters, query)) : this.queries;
  }

  notify(event) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.listeners.forEach(listener => {
        listener(event);
      });
    });
  }

  onFocus() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        query.onFocus();
      });
    });
  }

  onOnline() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        query.onOnline();
      });
    });
  }

}


//# sourceMappingURL=queryCache.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/mutation.mjs
var lib_mutation = __webpack_require__(89886);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/mutationCache.mjs





// CLASS
class MutationCache extends subscribable/* Subscribable */.l {
  constructor(config) {
    super();
    this.config = config || {};
    this.mutations = [];
    this.mutationId = 0;
  }

  build(client, options, state) {
    const mutation = new lib_mutation/* Mutation */.m({
      mutationCache: this,
      logger: client.getLogger(),
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
    });
    this.add(mutation);
    return mutation;
  }

  add(mutation) {
    this.mutations.push(mutation);
    this.notify({
      type: 'added',
      mutation
    });
  }

  remove(mutation) {
    this.mutations = this.mutations.filter(x => x !== mutation);
    this.notify({
      type: 'removed',
      mutation
    });
  }

  clear() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.mutations.forEach(mutation => {
        this.remove(mutation);
      });
    });
  }

  getAll() {
    return this.mutations;
  }

  find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(mutation => (0,utils/* matchMutation */.X7)(filters, mutation));
  }

  findAll(filters) {
    return this.mutations.filter(mutation => (0,utils/* matchMutation */.X7)(filters, mutation));
  }

  notify(event) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.listeners.forEach(listener => {
        listener(event);
      });
    });
  }

  resumePausedMutations() {
    const pausedMutations = this.mutations.filter(x => x.state.isPaused);
    return notifyManager/* notifyManager.batch */.V.batch(() => pausedMutations.reduce((promise, mutation) => promise.then(() => mutation.continue().catch(utils/* noop */.ZT)), Promise.resolve()));
  }

}


//# sourceMappingURL=mutationCache.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/focusManager.mjs
var focusManager = __webpack_require__(15761);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/onlineManager.mjs
var onlineManager = __webpack_require__(96474);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
function infiniteQueryBehavior() {
  return {
    onFetch: context => {
      context.fetchFn = () => {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        let newPageParams = oldPageParams;
        let cancelled = false;

        const addSignalProperty = object => {
          Object.defineProperty(object, 'signal', {
            enumerable: true,
            get: () => {
              var _context$signal;

              if ((_context$signal = context.signal) != null && _context$signal.aborted) {
                cancelled = true;
              } else {
                var _context$signal2;

                (_context$signal2 = context.signal) == null ? void 0 : _context$signal2.addEventListener('abort', () => {
                  cancelled = true;
                });
              }

              return context.signal;
            }
          });
        }; // Get query function


        const queryFn = context.options.queryFn || (() => Promise.reject('Missing queryFn'));

        const buildNewPages = (pages, param, page, previous) => {
          newPageParams = previous ? [param, ...newPageParams] : [...newPageParams, param];
          return previous ? [page, ...pages] : [...pages, page];
        }; // Create function to fetch a page


        const fetchPage = (pages, manual, param, previous) => {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          const queryFnContext = {
            queryKey: context.queryKey,
            pageParam: param,
            meta: context.options.meta
          };
          addSignalProperty(queryFnContext);
          const queryFnResult = queryFn(queryFnContext);
          const promise = Promise.resolve(queryFnResult).then(page => buildNewPages(pages, param, page, previous));
          return promise;
        };

        let promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
          const manual = typeof pageParam !== 'undefined';
          const param = manual ? pageParam : getNextPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param);
        } // Fetch previous page?
        else if (isFetchingPreviousPage) {
          const manual = typeof pageParam !== 'undefined';
          const param = manual ? pageParam : getPreviousPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param, true);
        } // Refetch pages
        else {
          newPageParams = [];
          const manual = typeof context.options.getNextPageParam === 'undefined';
          const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

          promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

          for (let i = 1; i < oldPages.length; i++) {
            promise = promise.then(pages => {
              const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

              if (shouldFetchNextPage) {
                const param = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                return fetchPage(pages, manual, param);
              }

              return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
            });
          }
        }

        const finalPromise = promise.then(pages => ({
          pages,
          pageParams: newPageParams
        }));
        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    const nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }

  return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    const previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }

  return;
}


//# sourceMappingURL=infiniteQueryBehavior.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/queryClient.mjs









// CLASS
class QueryClient {
  constructor(config = {}) {
    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.logger = config.logger || logger/* defaultLogger */._;
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
    this.mountCount = 0;

    if (false) {}
  }

  mount() {
    this.mountCount++;
    if (this.mountCount !== 1) return;
    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(() => {
      if (focusManager/* focusManager.isFocused */.j.isFocused()) {
        this.resumePausedMutations();
        this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(() => {
      if (onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        this.resumePausedMutations();
        this.queryCache.onOnline();
      }
    });
  }

  unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    this.mountCount--;
    if (this.mountCount !== 0) return;
    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    this.unsubscribeFocus = undefined;
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
    this.unsubscribeOnline = undefined;
  }

  isFetching(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    filters.fetchStatus = 'fetching';
    return this.queryCache.findAll(filters).length;
  }

  isMutating(filters) {
    return this.mutationCache.findAll({ ...filters,
      fetching: true
    }).length;
  }

  getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  }

  ensureQueryData(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    const cachedData = this.getQueryData(parsedOptions.queryKey);
    return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
  }

  getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(({
      queryKey,
      state
    }) => {
      const data = state.data;
      return [queryKey, data];
    });
  }

  setQueryData(queryKey, updater, options) {
    const query = this.queryCache.find(queryKey);
    const prevData = query == null ? void 0 : query.state.data;
    const data = (0,utils/* functionalUpdate */.SE)(updater, prevData);

    if (typeof data === 'undefined') {
      return undefined;
    }

    const parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    const defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(data, { ...options,
      manual: true
    });
  }

  setQueriesData(queryKeyOrFilters, updater, options) {
    return notifyManager/* notifyManager.batch */.V.batch(() => this.getQueryCache().findAll(queryKeyOrFilters).map(({
      queryKey
    }) => [queryKey, this.setQueryData(queryKey, updater, options)]));
  }

  getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  }

  removeQueries(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    const queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(() => {
      queryCache.findAll(filters).forEach(query => {
        queryCache.remove(query);
      });
    });
  }

  resetQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    const queryCache = this.queryCache;
    const refetchFilters = {
      type: 'active',
      ...filters
    };
    return notifyManager/* notifyManager.batch */.V.batch(() => {
      queryCache.findAll(filters).forEach(query => {
        query.reset();
      });
      return this.refetchQueries(refetchFilters, options);
    });
  }

  cancelQueries(arg1, arg2, arg3) {
    const [filters, cancelOptions = {}] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    const promises = notifyManager/* notifyManager.batch */.V.batch(() => this.queryCache.findAll(filters).map(query => query.cancel(cancelOptions)));
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  invalidateQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    return notifyManager/* notifyManager.batch */.V.batch(() => {
      var _ref, _filters$refetchType;

      this.queryCache.findAll(filters).forEach(query => {
        query.invalidate();
      });

      if (filters.refetchType === 'none') {
        return Promise.resolve();
      }

      const refetchFilters = { ...filters,
        type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
      };
      return this.refetchQueries(refetchFilters, options);
    });
  }

  refetchQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    const promises = notifyManager/* notifyManager.batch */.V.batch(() => this.queryCache.findAll(filters).filter(query => !query.isDisabled()).map(query => {
      var _options$cancelRefetc;

      return query.fetch(undefined, { ...options,
        cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
        meta: {
          refetchPage: filters.refetchPage
        }
      });
    }));
    let promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options != null && options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  }

  fetchQuery(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    const query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  }

  prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  fetchInfiniteQuery(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = infiniteQueryBehavior();
    return this.fetchQuery(parsedOptions);
  }

  prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }

  getQueryCache() {
    return this.queryCache;
  }

  getMutationCache() {
    return this.mutationCache;
  }

  getLogger() {
    return this.logger;
  }

  getDefaultOptions() {
    return this.defaultOptions;
  }

  setDefaultOptions(options) {
    this.defaultOptions = options;
  }

  setQueryDefaults(queryKey, options) {
    const result = this.queryDefaults.find(x => (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey));

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey,
        defaultOptions: options
      });
    }
  }

  getQueryDefaults(queryKey) {
    if (!queryKey) {
      return undefined;
    } // Get the first matching defaults


    const firstMatchingDefaults = this.queryDefaults.find(x => (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey)); // Additional checks and error in dev mode

    if (false) {}

    return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
  }

  setMutationDefaults(mutationKey, options) {
    const result = this.mutationDefaults.find(x => (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey));

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey,
        defaultOptions: options
      });
    }
  }

  getMutationDefaults(mutationKey) {
    if (!mutationKey) {
      return undefined;
    } // Get the first matching defaults


    const firstMatchingDefaults = this.mutationDefaults.find(x => (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode

    if (false) {}

    return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
  }

  defaultQueryOptions(options) {
    if (options != null && options._defaulted) {
      return options;
    }

    const defaultedOptions = { ...this.defaultOptions.queries,
      ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
      ...options,
      _defaulted: true
    };

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    } // dependent default values


    if (typeof defaultedOptions.refetchOnReconnect === 'undefined') {
      defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
    }

    if (typeof defaultedOptions.useErrorBoundary === 'undefined') {
      defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
    }

    return defaultedOptions;
  }

  defaultMutationOptions(options) {
    if (options != null && options._defaulted) {
      return options;
    }

    return { ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
      ...options,
      _defaulted: true
    };
  }

  clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  }

}


//# sourceMappingURL=queryClient.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/hydration.mjs
// TYPES
// FUNCTIONS
function dehydrateMutation(mutation) {
  return {
    mutationKey: mutation.options.mutationKey,
    state: mutation.state
  };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.


function dehydrateQuery(query) {
  return {
    state: query.state,
    queryKey: query.queryKey,
    queryHash: query.queryHash
  };
}

function defaultShouldDehydrateMutation(mutation) {
  return mutation.state.isPaused;
}
function defaultShouldDehydrateQuery(query) {
  return query.state.status === 'success';
}
function dehydrate(client, options = {}) {
  const mutations = [];
  const queries = [];

  if (options.dehydrateMutations !== false) {
    const shouldDehydrateMutation = options.shouldDehydrateMutation || defaultShouldDehydrateMutation;
    client.getMutationCache().getAll().forEach(mutation => {
      if (shouldDehydrateMutation(mutation)) {
        mutations.push(dehydrateMutation(mutation));
      }
    });
  }

  if (options.dehydrateQueries !== false) {
    const shouldDehydrateQuery = options.shouldDehydrateQuery || defaultShouldDehydrateQuery;
    client.getQueryCache().getAll().forEach(query => {
      if (shouldDehydrateQuery(query)) {
        queries.push(dehydrateQuery(query));
      }
    });
  }

  return {
    mutations,
    queries
  };
}
function hydrate(client, dehydratedState, options) {
  if (typeof dehydratedState !== 'object' || dehydratedState === null) {
    return;
  }

  const mutationCache = client.getMutationCache();
  const queryCache = client.getQueryCache(); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

  const mutations = dehydratedState.mutations || []; // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

  const queries = dehydratedState.queries || [];
  mutations.forEach(dehydratedMutation => {
    var _options$defaultOptio;

    mutationCache.build(client, { ...(options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations),
      mutationKey: dehydratedMutation.mutationKey
    }, dehydratedMutation.state);
  });
  queries.forEach(dehydratedQuery => {
    var _options$defaultOptio2;

    const query = queryCache.get(dehydratedQuery.queryHash); // Do not hydrate if an existing query exists with newer data

    if (query) {
      if (query.state.dataUpdatedAt < dehydratedQuery.state.dataUpdatedAt) {
        query.setState(dehydratedQuery.state);
      }

      return;
    } // Restore query


    queryCache.build(client, { ...(options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries),
      queryKey: dehydratedQuery.queryKey,
      queryHash: dehydratedQuery.queryHash
    }, dehydratedQuery.state);
  });
}


//# sourceMappingURL=hydration.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/Hydrate.mjs




function useHydrate(state, options = {}) {
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const optionsRef = react.useRef(options);
  optionsRef.current = options; // Running hydrate again with the same queries is safe,
  // it wont overwrite or initialize existing queries,
  // relying on useMemo here is only a performance optimization.
  // hydrate can and should be run *during* render here for SSR to work properly

  react.useMemo(() => {
    if (state) {
      hydrate(queryClient, state, optionsRef.current);
    }
  }, [queryClient, state]);
}
const Hydrate = ({
  children,
  options,
  state
}) => {
  useHydrate(state, options);
  return children;
};


//# sourceMappingURL=Hydrate.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query-devtools/build/lib/index.mjs


const ReactQueryDevtools =  true ? function () {
  return null;
} : 0;
const ReactQueryDevtoolsPanel = (/* unused pure expression or super */ null && ( true ? function () {
  return null;
} : 0));


//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/query-persist-client-core/build/lib/persist.mjs


/**
 * Restores persisted data to the QueryCache
 *  - data obtained from persister.restoreClient
 *  - data is hydrated using hydrateOptions
 * If data is expired, busted, empty, or throws, it runs persister.removeClient
 */
async function persistQueryClientRestore({
  queryClient,
  persister,
  maxAge = 1000 * 60 * 60 * 24,
  buster = '',
  hydrateOptions
}) {
  try {
    const persistedClient = await persister.restoreClient();

    if (persistedClient) {
      if (persistedClient.timestamp) {
        const expired = Date.now() - persistedClient.timestamp > maxAge;
        const busted = persistedClient.buster !== buster;

        if (expired || busted) {
          persister.removeClient();
        } else {
          hydrate(queryClient, persistedClient.clientState, hydrateOptions);
        }
      } else {
        persister.removeClient();
      }
    }
  } catch (err) {
    if (false) {}

    persister.removeClient();
  }
}
/**
 * Persists data from the QueryCache
 *  - data dehydrated using dehydrateOptions
 *  - data is persisted using persister.persistClient
 */

async function persistQueryClientSave({
  queryClient,
  persister,
  buster = '',
  dehydrateOptions
}) {
  const persistClient = {
    buster,
    timestamp: Date.now(),
    clientState: dehydrate(queryClient, dehydrateOptions)
  };
  await persister.persistClient(persistClient);
}
/**
 * Subscribe to QueryCache and MutationCache updates (for persisting)
 * @returns an unsubscribe function (to discontinue monitoring)
 */

function persistQueryClientSubscribe(props) {
  const unsubscribeQueryCache = props.queryClient.getQueryCache().subscribe(() => {
    persistQueryClientSave(props);
  });
  const unusbscribeMutationCache = props.queryClient.getMutationCache().subscribe(() => {
    persistQueryClientSave(props);
  });
  return () => {
    unsubscribeQueryCache();
    unusbscribeMutationCache();
  };
}
/**
 * Restores persisted data to QueryCache and persists further changes.
 */

function persistQueryClient(props) {
  let hasUnsubscribed = false;
  let persistQueryClientUnsubscribe;

  const unsubscribe = () => {
    hasUnsubscribed = true;
    persistQueryClientUnsubscribe == null ? void 0 : persistQueryClientUnsubscribe();
  }; // Attempt restore


  const restorePromise = persistQueryClientRestore(props).then(() => {
    if (!hasUnsubscribed) {
      // Subscribe to changes in the query cache to trigger the save
      persistQueryClientUnsubscribe = persistQueryClientSubscribe(props);
    }
  });
  return [unsubscribe, restorePromise];
}


//# sourceMappingURL=persist.mjs.map

;// CONCATENATED MODULE: ./setup/react-query/index.js







function ReactQueryProvider(param) {
    var children = param.children, pageProps = param.pageProps;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        return new QueryClient({
            defaultOptions: {
                queries: {
                    cacheTime: 1000 * 60 * 60 * 24
                }
            }
        });
    }), 1), queryClient = ref[0];
    react.useEffect(function() {
        var localStoragePersister = createSyncStoragePersister({
            storage: window.localStorage
        });
        persistQueryClient({
            queryClient: queryClient,
            persister: localStoragePersister
        });
    }, [
        queryClient
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(QueryClientProvider/* QueryClientProvider */.aH, {
        client: queryClient,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hydrate, {
                state: pageProps.dehydratedState,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactQueryDevtools, {
                initialIsOpen: false,
                position: "bottom-left"
            })
        ]
    });
}
/* harmony default export */ var react_query = (ReactQueryProvider);

;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ var esm_TransitionGroupContext = (react.createContext(null));
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/ChildMapping.js

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function ChildMapping_getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0,react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function ChildMapping_mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function ChildMapping_getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function ChildMapping_getInitialChildMapping(props, onExited) {
  return ChildMapping_getChildMapping(props.children, function (child) {
    return (0,react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: ChildMapping_getProp(child, 'appear', props),
      enter: ChildMapping_getProp(child, 'enter', props),
      exit: ChildMapping_getProp(child, 'exit', props)
    });
  });
}
function ChildMapping_getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = ChildMapping_getChildMapping(nextProps.children);
  var children = ChildMapping_mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0,react.isValidElement)(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = (0,react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: ChildMapping_getProp(child, 'exit', nextProps),
        enter: ChildMapping_getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0,react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0,react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: ChildMapping_getProp(child, 'exit', nextProps),
        enter: ChildMapping_getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js









var TransitionGroup_values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var TransitionGroup_defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup_TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind((0,assertThisInitialized/* default */.Z)(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? ChildMapping_getInitialChildMapping(nextProps, handleExited) : ChildMapping_getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = ChildMapping_getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = (0,esm_extends/* default */.Z)({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = TransitionGroup_values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/react.createElement(esm_TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/react.createElement(esm_TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/react.createElement(Component, props, children));
  };

  return TransitionGroup;
}(react.Component);

TransitionGroup_TransitionGroup.propTypes =  false ? 0 : {};
TransitionGroup_TransitionGroup.defaultProps = TransitionGroup_defaultProps;
/* harmony default export */ var react_transition_group_esm_TransitionGroup = (TransitionGroup_TransitionGroup);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var esm_config = ({
  disabled: false
});
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js









var Transition_UNMOUNTED = 'unmounted';
var Transition_EXITED = 'exited';
var Transition_ENTERING = 'entering';
var Transition_ENTERED = 'entered';
var Transition_EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition_Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = Transition_EXITED;
        _this.appearStatus = Transition_ENTERING;
      } else {
        initialStatus = Transition_ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = Transition_UNMOUNTED;
      } else {
        initialStatus = Transition_EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === Transition_UNMOUNTED) {
      return {
        status: Transition_EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== Transition_ENTERING && status !== Transition_ENTERED) {
          nextStatus = Transition_ENTERING;
        }
      } else {
        if (status === Transition_ENTERING || status === Transition_ENTERED) {
          nextStatus = Transition_EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === Transition_ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === Transition_EXITED) {
      this.setState({
        status: Transition_UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || esm_config.disabled) {
      this.safeSetState({
        status: Transition_ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: Transition_ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: Transition_ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || esm_config.disabled) {
      this.safeSetState({
        status: Transition_EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: Transition_EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: Transition_EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === Transition_UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(esm_TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition_Transition.contextType = esm_TransitionGroupContext;
Transition_Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function Transition_noop() {}

Transition_Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: Transition_noop,
  onEntering: Transition_noop,
  onEntered: Transition_noop,
  onExit: Transition_noop,
  onExiting: Transition_noop,
  onExited: Transition_noop
};
Transition_Transition.UNMOUNTED = Transition_UNMOUNTED;
Transition_Transition.EXITED = Transition_EXITED;
Transition_Transition.ENTERING = Transition_ENTERING;
Transition_Transition.ENTERED = Transition_ENTERED;
Transition_Transition.EXITING = Transition_EXITING;
/* harmony default export */ var react_transition_group_esm_Transition = (Transition_Transition);
;// CONCATENATED MODULE: ./common/Layout/Transition.js



var TIMEOUT = 200;
var getTransitionStyles = {
    entering: {
        // position: `absolute`, // BLUG: blinking to ramdom place
        opacity: 0,
        transform: "translateY(50px)"
    },
    entered: {
        transition: "opacity ".concat(TIMEOUT, "ms ease-in-out, transform ").concat(TIMEOUT, "ms ease-in-out"),
        opacity: 1,
        transform: "translateX(0px)",
        animation: "blink .3s linear 2"
    },
    exiting: {
        transition: "opacity ".concat(TIMEOUT, "ms ease-in-out, transform ").concat(TIMEOUT, "ms ease-in-out"),
        opacity: 0,
        transform: "translateY(-50px)"
    }
};
var Layout_Transition_Transition = function(param) {
    var children = param.children, location = param.location;
    var excludedPaths = [
        "mua-hang"
    ];
    var isOnExludedPaths = excludedPaths.some(function(path) {
        return location.includes(path);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_transition_group_esm_TransitionGroup, {
        style: {
            position: "relative"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_transition_group_esm_Transition, {
            timeout: {
                enter: TIMEOUT,
                exit: TIMEOUT
            },
            onEntered: function() {
                return window.scrollTo(0, 0);
            },
            children: function(status) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: isOnExludedPaths ? {} : (0,_object_spread/* default */.Z)({}, getTransitionStyles[status]),
                    children: children
                });
            }
        }, location)
    });
};
/* harmony default export */ var Layout_Transition = (Layout_Transition_Transition);

// EXTERNAL MODULE: ./setup/flexbiz-api-provider/index.js + 4 modules
var flexbiz_api_provider = __webpack_require__(34733);
// EXTERNAL MODULE: ./setup/locale-provider/index.js
var locale_provider = __webpack_require__(59963);
;// CONCATENATED MODULE: ./pages/_app.page.js
// import PluginChatMess from "@/common/components/Chat/PluginChatMess";
// import { PageTransition } from "@/common/Layout/PageTransition";








// import "tocbot/src/scss/tocbot.scss";











function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps, router = param.router;
    var getLayout = Component.getLayout || function(page) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
            children: page
        });
    };
    (0,react.useEffect)(function() {
        __webpack_require__.e(/* import() */ 1767).then(__webpack_require__.t.bind(__webpack_require__, 51767, 23)).then(function(x) {
            return x.default;
        }).then(function(ReactPixel) {
            ReactPixel.init("2475782152521154"); // facebookPixelId
            ReactPixel.pageView();
            router.events.on("routeChangeComplete", function() {
                ReactPixel.pageView();
            });
        });
    }, [
        router.events
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_query, {
        pageProps: pageProps,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(flexbiz_api_provider/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(locale_provider/* LocaleProvider */.I, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(cartProvider/* default */.ZP, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* DefaultSeo */.lX, (0,_object_spread/* default */.Z)({}, next_seo_config)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Transition, {
                                location: router.asPath,
                                children: getLayout(/*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps)))
                            })
                        ]
                    })
                })
            })
        })
    });
}
/* harmony default export */ var _app_page = (MyApp);


/***/ }),

/***/ 13656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Contact; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _apis_queryFunctions_contact__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31670);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26679);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90698);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21017);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18540);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19236);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(80061);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(66137);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67841);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95117);
/* harmony import */ var _mantine_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98903);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48228);









function Contact(param) {
    var bg = param.bg;
    var trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var isTablet = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isTablet;
    var form = (0,_mantine_form__WEBPACK_IMPORTED_MODULE_4__/* .useForm */ .c)({
        initialValues: {
            ho_ten: "",
            dien_thoai: "",
            email: "",
            dia_chi: "",
            noi_dung: ""
        },
        validate: {
            ho_ten: function(value) {
                return value.length > 0 ? null : "Vui l\xf2ng nhập họ t\xean của qu\xfd kh\xe1ch";
            },
            email: function(value) {
                return value.length > 0 ? /^\S+@\S+$/.test(value) ? null : "Email kh\xf4ng hợp lệ" : "Vui l\xf2ng nhập email để cửa h\xe0ng li\xean hệ với qu\xfd kh\xe1ch";
            }
        }
    });
    var contactMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useMutation */ .D)(_apis_queryFunctions_contact__WEBPACK_IMPORTED_MODULE_1__/* .postContact */ .D, {
        onSuccess: function(rs) {
            if (rs._id) {
                appAlert({
                    type: "success",
                    message: "Gửi th\xf4ng tin th\xe0nh c\xf4ng"
                });
            } else {
                appAlert({
                    message: "Gửi th\xf4ng tin kh\xf4ng th\xe0nh c\xf4ng"
                });
            }
            form.reset();
        }
    });
    // const handleSubmit = () => {
    //   contactMutation.mutate({ ...form.values });
    // };
    var handleSubmit = function() {
        // Kiểm tra nếu không có nội dung, gán giá trị mặc định
        var formData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, form.values), {
            noi_dung: form.values.noi_dung.trim() === "" ? "li\xean hệ từ web zemor" : form.values.noi_dung
        });
        contactMutation.mutate(formData);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Card */ .Z, {
        shadow: "sm",
        p: "lg",
        radius: "md",
        withBorder: true,
        bg: bg || "transparent",
        h: "100%",
        w: isTablet ? "90%" : "70%",
        sx: {
            position: "relative",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.15)",
            "&:hover": {
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.2)"
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "30px",
                    height: "30px",
                    borderTop: "4px solid black",
                    borderLeft: "4px solid black"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: "30px",
                    height: "30px",
                    borderTop: "4px solid black",
                    borderRight: "4px solid black"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    width: "30px",
                    height: "30px",
                    borderBottom: "4px solid black",
                    borderRight: "4px solid black"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "30px",
                    height: "30px",
                    borderBottom: "4px solid black",
                    borderLeft: "4px solid black"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .MediaQuery */ .z, {
                smallerThan: "md",
                order: 4,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Title */ .D, {
                    order: 4,
                    align: "center",
                    transform: "uppercase",
                    py: "lg",
                    fz: "md",
                    children: trans === null || trans === void 0 ? void 0 : trans.contact.label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                onSubmit: form.onSubmit(handleSubmit),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                        //   label={trans?.contact.form.fullName}
                        withAsterisk: true,
                        size: isTablet ? "xs" : "md",
                        placeholder: trans === null || trans === void 0 ? void 0 : trans.contact.placeholder2.fullName
                    }, form.getInputProps("ho_ten")), {
                        mb: 10
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                        //   label={trans?.contact.form.address}
                        size: isTablet ? "xs" : "md",
                        placeholder: trans === null || trans === void 0 ? void 0 : trans.contact.placeholder2.address
                    }, form.getInputProps("dia_chi")), {
                        mb: 10
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                        //   label={trans?.contact.form.phone}
                        size: isTablet ? "xs" : "md",
                        placeholder: trans === null || trans === void 0 ? void 0 : trans.contact.placeholder2.phone
                    }, form.getInputProps("dien_thoai")), {
                        mb: 10
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                        //   label={trans?.contact.form.email}
                        withAsterisk: true,
                        size: isTablet ? "xs" : "md",
                        placeholder: trans === null || trans === void 0 ? void 0 : trans.contact.placeholder2.email
                    }, form.getInputProps("email")), {
                        mb: 10
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Group */ .Z, {
                        position: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Button */ .z, {
                            type: "submit",
                            mt: "sm",
                            fullWidth: true,
                            sx: {
                                background: "linear-gradient(to top, #8B0000, #FF0000)",
                                color: "#fff",
                                "&:hover": {
                                    background: "linear-gradient(to top,rgb(180, 39, 39), #FF6347)"
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                                weight: "500",
                                transform: "uppercase",
                                children: trans === null || trans === void 0 ? void 0 : trans.contact.form.button
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 22343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ QuantityInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _setup_cartProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27104);
/* harmony import */ var _setup_flexbiz_api_provider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34733);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56817);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7414);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49834);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14127);
/* harmony import */ var _react_icons_all_files_ai_AiOutlineDelete__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56009);
/* harmony import */ var _react_icons_all_files_fi_FiMinus__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40703);
/* harmony import */ var _react_icons_all_files_fi_FiPlus__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24752);
/* harmony import */ var context_CartContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25926);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);












var useStyles = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .createStyles */ .k)(function(theme) {
    return {
        wrapper: {
            height: "28px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderRadius: theme.radius.sm,
            border: "1px solid ".concat(theme.colorScheme === "dark" ? "transparent" : theme.colors.gray[3]),
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.white,
            "&:focus-within": {
                borderColor: theme.colors[theme.primaryColor][6]
            },
            "@media (max-width: 500px)": {
                justifyContent: "flex-start",
                width: 100,
                marginLeft: 10
            }
        },
        control: {
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
            border: "1px solid ".concat(theme.colorScheme === "dark" ? "transparent" : theme.colors.gray[3]),
            "&:disabled": {
                borderColor: theme.colorScheme === "dark" ? "transparent" : theme.colors.gray[3],
                opacity: 0.8,
                backgroundColor: "transparent"
            }
        },
        input: {
            textAlign: "center",
            paddingRight: "".concat(theme.spacing.xs, "px !important"),
            paddingLeft: "".concat(theme.spacing.xs, "px !important"),
            height: 28,
            flex: 1
        },
        container: {
            display: "flex",
            flex: 2,
            justifyContent: "space-between"
        },
        sectionDelete: {
            justifyContent: "center",
            "@media (min-width: 500px)": {
                display: "none",
                justifyContent: "flex-start",
                paddingLeft: 10
            }
        }
    };
});
function QuantityInput(param) {
    var item = param.item, _min = param.min, min = _min === void 0 ? 0 : _min, _max = param.max, max = _max === void 0 ? (item === null || item === void 0 ? void 0 : item.ton) || 9999 : _max;
    var ref;
    var context = (0,_setup_flexbiz_api_provider__WEBPACK_IMPORTED_MODULE_3__/* .useApiContext */ .Q)();
    var classes = useStyles().classes;
    var handlers = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    // const [alert, setAlert] = useState({ open: false, message: "" });
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), isShowMess = ref1[0], setIsShowMess = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(item === null || item === void 0 ? void 0 : item.sl_xuat), slXuat = ref2[0], setSlXuat = ref2[1];
    // console.log("slXuat", slXuat)
    var ref3 = (0,_setup_cartProvider__WEBPACK_IMPORTED_MODULE_2__/* .useCartContext */ .iQ)(), updateCartMutation = ref3.updateCartMutation, dialogAction = ref3.dialogAction, deleteCart = ref3.deleteCart, updateCart = ref3.updateCart;
    var onOpen = function(mess) {
        context.alert(mess);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        setSlXuat(item === null || item === void 0 ? void 0 : item.sl_xuat);
    // console.log(78787878, item.sl_xuat)
    }, [
        item, 
    ]);
    var discount = item === null || item === void 0 ? void 0 : (ref = item.discount) === null || ref === void 0 ? void 0 : ref.find(function(e) {
        return e.ma_cs === "ecompromotion_flashsales";
    });
    var deleteItemCart = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(item) {
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dialogAction({
                            title: "X\xf3a sản phẩm",
                            message: "Bạn c\xf3 chắc chắn muốn x\xf3a sản phẩm n\xe0y khỏi giỏ h\xe0ng?",
                            onConfirm: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                                return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            // console.log("log item", item);
                                            deleteCart(item);
                                        case 1:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }))
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteItemCart(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var onMinus = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref;
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(item.sl_xuat - 1 === 0)) {
                            _ctx.next = 4;
                            break;
                        }
                        deleteItemCart(item);
                        return _ctx.abrupt("return");
                    case 4:
                        if ((item === null || item === void 0 ? void 0 : item.discount.length) && slXuat <= ((ref = item === null || item === void 0 ? void 0 : item.discount[0]) === null || ref === void 0 ? void 0 : ref.sl_ap_dung) && isShowMess) {
                            setIsShowMess(false);
                        }
                        updateCartMutation.mutate({
                            _id: item._id,
                            sl_xuat: item.sl_xuat - 1
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onMinus() {
            return _ref.apply(this, arguments);
        };
    }();
    var onPlus = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, mess;
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(slXuat >= item.ton && Number(item.ton) > 0)) {
                            _ctx.next = 4;
                            break;
                        }
                        setSlXuat(Number(item.ton));
                        updateCartMutation.mutate({
                            _id: item._id,
                            sl_xuat: Number(item.ton)
                        });
                        return _ctx.abrupt("return");
                    case 4:
                        if (slXuat - (discount === null || discount === void 0 ? void 0 : discount.sl_ap_dung) === 1 && (discount === null || discount === void 0 ? void 0 : discount.sl_ap_dung) != 0) {
                            ;
                            setIsShowMess(true);
                            mess = "Gi\xe1 b\xe1n n\xe0y giới hạn mua tối đa ".concat(item.sl_ap_dung ? item.sl_ap_dung : (ref = item === null || item === void 0 ? void 0 : item.discount[0]) === null || ref === void 0 ? void 0 : ref.sl_den, " sản phẩm, gi\xe1 b\xe1n sẽ thay đổi th\xe0nh ").concat((0,numeral__WEBPACK_IMPORTED_MODULE_5__.Numeral)(item.gia_ban_le).format(), "đ");
                            onOpen(mess);
                        }
                        updateCartMutation.mutate({
                            _id: item._id,
                            sl_xuat: item.sl_xuat + 1
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onPlus() {
            return _ref.apply(this, arguments);
        };
    }();
    var onQuantityChange = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, mess;
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(slXuat > item.ton && Number(item.ton) > 0)) {
                            _ctx.next = 5;
                            break;
                        }
                        context.alert("Số lượng bạn chọn lớn hơn sản phẩm tồn kho");
                        setSlXuat(Number(item.ton));
                        updateCart({
                            _id: item._id,
                            sl_xuat: Number(item.ton)
                        });
                        return _ctx.abrupt("return");
                    case 5:
                        if (!(slXuat === 0)) {
                            _ctx.next = 9;
                            break;
                        }
                        setSlXuat(1);
                        deleteItemCart(item);
                        return _ctx.abrupt("return");
                    case 9:
                        if (slXuat + 1 > item.sl_ap_dung && !isShowMess) {
                            ;
                            setIsShowMess(true);
                            mess = "Gi\xe1 b\xe1n n\xe0y giới hạn mua tối đa ".concat(item.sl_ap_dung ? item.sl_ap_dung : (ref = item === null || item === void 0 ? void 0 : item.discount[0]) === null || ref === void 0 ? void 0 : ref.sl_den, " sản phẩm, gi\xe1 b\xe1n sẽ thay đổi th\xe0nh ").concat((0,numeral__WEBPACK_IMPORTED_MODULE_5__.Numeral)(item.gia_ban_le).format(), "đ");
                            // onOpen(mess);
                            context.alert(mess);
                        }
                        if (item.discount.length && item.discount[0].sl_tu !== 0 && slXuat < item.discount[0].sl_tu && isShowMess) {
                            setIsShowMess(false);
                        }
                        updateCart({
                            _id: item._id,
                            sl_xuat: slXuat
                        });
                        updateCartMutation.mutate({
                            _id: item._id,
                            sl_xuat: item.sl_xuat
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onQuantityChange() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
        className: classes.container,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                className: classes.wrapper,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .ActionIcon */ .A, {
                        size: 28,
                        variant: "transparent",
                        onClick: onMinus,
                        disabled: slXuat === min || updateCartMutation.isLoading,
                        className: classes.control,
                        onMouseDown: function(event) {
                            return event.preventDefault();
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_react_icons_all_files_fi_FiMinus__WEBPACK_IMPORTED_MODULE_11__/* .FiMinus */ .e, {
                            size: 16
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .NumberInput */ .Y, {
                        sx: {
                            width: "fit-content"
                        },
                        variant: "unstyled",
                        min: min,
                        max: max,
                        handlersRef: handlers,
                        value: slXuat,
                        onChange: setSlXuat,
                        classNames: {
                            input: classes.input
                        },
                        onBlur: onQuantityChange,
                        onKeyDown: function(event) {
                            if (event.key === "Enter") {
                                event.preventDefault();
                                onQuantityChange();
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .ActionIcon */ .A, {
                        size: 28,
                        variant: "transparent",
                        onClick: onPlus,
                        disabled: slXuat === max || updateCartMutation.isLoading,
                        className: classes.control,
                        onMouseDown: function(event) {
                            return event.preventDefault();
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_react_icons_all_files_fi_FiPlus__WEBPACK_IMPORTED_MODULE_13__/* .FiPlus */ .O, {
                            size: 16
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                sx: classes.sectionDelete,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .ActionIcon */ .A, {
                    onClick: function() {
                        return deleteCart(item);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_react_icons_all_files_ai_AiOutlineDelete__WEBPACK_IMPORTED_MODULE_14__/* .AiOutlineDelete */ .V, {
                        variant: "transparent",
                        size: 22
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 42580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ axios; }
});

;// CONCATENATED MODULE: ./node_modules/redaxios/dist/redaxios.module.js
/* harmony default export */ var redaxios_module = (function e(t){function n(e,t,r){var a,o={};if(Array.isArray(e))return e.concat(t);for(a in e)o[r?a.toLowerCase():a]=e[a];for(a in t){var i=r?a.toLowerCase():a,u=t[a];o[i]=i in o&&"object"==typeof u?n(o[i],u,"headers"==i):u}return o}function r(e,r,a,o,i){var u="string"!=typeof e?(r=e).url:e,c={config:r},s=n(t,r),f={};o=o||s.data,(s.transformRequest||[]).map(function(e){o=e(o,s.headers)||o}),s.auth&&(f.authorization=s.auth),o&&"object"==typeof o&&"function"!=typeof o.append&&"function"!=typeof o.text&&(o=JSON.stringify(o),f["content-type"]="application/json");try{f[s.xsrfHeaderName]=decodeURIComponent(document.cookie.match(RegExp("(^|; )"+s.xsrfCookieName+"=([^;]*)"))[2])}catch(e){}return s.baseURL&&(u=u.replace(/^(?!.*\/\/)\/?/,s.baseURL+"/")),s.params&&(u+=(~u.indexOf("?")?"&":"?")+(s.paramsSerializer?s.paramsSerializer(s.params):new URLSearchParams(s.params))),(s.fetch||fetch)(u,{method:(a||s.method||"get").toUpperCase(),body:o,headers:n(s.headers,f,!0),credentials:s.withCredentials?"include":i}).then(function(e){for(var t in e)"function"!=typeof e[t]&&(c[t]=e[t]);return"stream"==s.responseType?(c.data=e.body,c):e[s.responseType||"text"]().then(function(e){c.data=e,c.data=JSON.parse(e)}).catch(Object).then(function(){return(s.validateStatus?s.validateStatus(e.status):e.ok)?c:Promise.reject(c)})})}return t=t||{},r.request=r,r.get=function(e,t){return r(e,t,"get")},r.delete=function(e,t){return r(e,t,"delete")},r.head=function(e,t){return r(e,t,"head")},r.options=function(e,t){return r(e,t,"options")},r.post=function(e,t,n){return r(e,n,"post",t)},r.put=function(e,t,n){return r(e,n,"put",t)},r.patch=function(e,t,n){return r(e,n,"patch",t)},r.all=Promise.all.bind(Promise),r.spread=function(e){return e.apply.bind(e,e)},r.CancelToken="function"==typeof AbortController?AbortController:Object,r.defaults=t,r.create=e,r}());
//# sourceMappingURL=redaxios.module.js.map

;// CONCATENATED MODULE: ./setup/axios/index.js

var instance = redaxios_module.create({
    baseURL: "https://api.flexzen.app",
    header: {
        "content-type": "application/json; charset=utf-8",
        "Access-Control-Allow-Credentials": true,
        Accept: "application/json"
    },
    withCredentials: true
});
/* harmony default export */ var axios = (instance);


/***/ }),

/***/ 27104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A9": function() { return /* binding */ CartContext; },
  "vc": function() { return /* binding */ config; },
  "ZP": function() { return /* binding */ cartProvider; },
  "iQ": function() { return /* binding */ useCartContext; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./apis/fetch.js
var fetch = __webpack_require__(36203);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./hooks/useUserInfo.js
var useUserInfo = __webpack_require__(15170);
// EXTERNAL MODULE: ./setup/flexbiz-api-provider/index.js + 4 modules
var flexbiz_api_provider = __webpack_require__(34733);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./apis/queryKeys/index.js + 6 modules
var queryKeys = __webpack_require__(76296);
;// CONCATENATED MODULE: ./apis/queryFunctions/cartFunctions.js











var fetchCart = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var userInfo, token, condition, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    userInfo = param.userInfo;
                    token = userInfo.token, condition = (0,_object_without_properties/* default */.Z)(userInfo, [
                        "token"
                    ]);
                    if (token) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", []);
                case 4:
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return (0,fetch/* asyncGetList */.NE)({
                        access_token: token,
                        collection_name: "cart",
                        options: (0,_object_spread/* default */.Z)({}, condition)
                    });
                case 7:
                    data = _ctx.sent;
                    if (data) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", []);
                case 10:
                    if (!(data && data.length <= 1)) {
                        _ctx.next = 12;
                        break;
                    }
                    return _ctx.abrupt("return", data);
                case 12:
                    return _ctx.abrupt("return", data.sort(function(a, b) {
                        return new Date(a.date_created).getTime() - new Date(b.date_created).getTime();
                    }));
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](4);
                    console.log("\uD83D\uDE80 ~ file: cartFunctions.js ~ line 29 ~ fetchCart ~ error", _ctx.t0);
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                15
            ]
        ]);
    }));
    return function fetchCart(_) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchCart = function() {
    var context = (0,flexbiz_api_provider/* useApiContext */.Q)();
    var isLogin = (0,useUserInfo/* default */.Z)().isLogin;
    var ref = (0,react.useState)({}), info = ref[0], setInfo = ref[1];
    var userInfo = (context || {}).userInfo;
    (0,react.useEffect)(function() {
        setInfo({
            token: isLogin !== false && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.token) ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.token : config.public_token,
            condition: {
                user: isLogin !== false && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.token) ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.email : null
            }
        });
    }, [
        userInfo,
        setInfo,
        isLogin
    ]);
    return (0,useQuery/* useQuery */.a)(queryKeys/* cartKeys.detail */.vM.detail(info === null || info === void 0 ? void 0 : info.token), function() {
        return fetchCart({
            userInfo: info
        });
    }, {
        // staleTime: process.env.DEFAULT_STALE_TIME,
        enabled: !!(info === null || info === void 0 ? void 0 : info.token)
    });
};

// EXTERNAL MODULE: ./apis/queryFunctions/orderFuntions.js
var orderFuntions = __webpack_require__(37677);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Modal/Modal.js + 1 modules
var Modal = __webpack_require__(38090);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./common/components/DialogAction/DialogAction.js






var DialogAction = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var _$ref = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), titleDialog = _$ref[0], setTitleDialog = _$ref[1];
    var _$ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isShow = _$ref1[0], setIsShow = _$ref1[1];
    var _$ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), contentDialog = _$ref2[0], setContentDialog = _$ref2[1];
    var onSubmitRef = (0,react.useRef)();
    var locale = (0,next_router.useRouter)().locale;
    var onCancelRef = (0,react.useRef)();
    (0,react.useImperativeHandle)(ref, function() {
        return {
            handleClick: function(title, message, onConfirm, onCancel) {
                setIsShow(true);
                setTitleDialog(title);
                setContentDialog(message);
                onSubmitRef.current = onConfirm;
                onCancelRef.current = onCancel;
            }
        };
    });
    var hideDialog = function(event) {
        // if (reason && reason == "backdropClick") onCancelRef.current();
        setIsShow(!isShow);
    };
    var onSubmit = function() {
        if (onSubmitRef.current) {
            onSubmitRef.current();
        }
        setIsShow(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
            centered: true,
            // fullWidth={true}
            opened: isShow,
            onClose: hideDialog,
            title: titleDialog || locale === "vi" ? "Th\xf4ng b\xe1o" : "Notify",
            styles: function(theme) {
                return {
                    title: {
                        fontWeight: "bold",
                        fontSize: 20
                    },
                    header: {
                        marginBottom: 10
                    }
                };
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    children: contentDialog
                }),
                typeof (onCancelRef === null || onCancelRef === void 0 ? void 0 : onCancelRef.current) === "function" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    variant: "outlined",
                    onClick: function() {
                        onCancelRef.current();
                        setIsShow(false);
                    },
                    color: "primary",
                    children: "Hủy"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    sx: {
                        flex: 1,
                        justifyContent: "flex-end",
                        display: "flex"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        variant: "contained",
                        onClick: onSubmit,
                        color: "orange",
                        children: "X\xe1c nhận"
                    })
                })
            ]
        })
    });
});
DialogAction.displayName = "DialogAction";
/* harmony default export */ var DialogAction_DialogAction = (DialogAction);
DialogAction.propTypes = {
    isShow: (prop_types_default()).bool,
    setIsShow: (prop_types_default()).func,
    title: (prop_types_default()).string,
    content: (prop_types_default()).string,
    handleCancel: (prop_types_default()).func,
    handleOk: (prop_types_default()).func
};

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./setup/mantine-provider/notifications.js
var notifications = __webpack_require__(97744);
;// CONCATENATED MODULE: ./setup/cartProvider/index.js
/* provided dependency */ var process = __webpack_require__(34406);


















// import CartContext from "../context/CartContext";
var CartContext = /*#__PURE__*/ react.createContext();
var useCartContext = function() {
    var context = (0,react.useContext)(CartContext);
    return context;
};
var config = {
    server_url_report: "https://api.flexzen.app",
    GOOGLE_RECAPTCHA_SITE_KEY: "6Lf25qEUAAAAAFHwh_XZw-YY6HXTdyv2xEp9AHbt",
    id_app: "615fa1791fc31763c7253668",
    group_id: "6340e15b624f2e7c84da50e6",
    trustkey: "APP.FKJSHHHH908KJF",
    system_code: process.env.system_code,
    again_link: "/checkout-alert",
    public_token: "flex.public.token"
};
var id_app = config.id_app;
var public_token = config.public_token;
var server_url = config.server_url_report;
function CartProvider(props) {
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,react.useState)([]), listAddress = ref4[0], setListAddress = ref4[1];
    var ref5 = (0,react.useState)({
        dia_chi: "",
        xa_phuong: "",
        quan_huyen: "",
        tinh_thanh: ""
    }), addressSelected = ref5[0], setAddressSelected = ref5[1];
    var initalUserInfo = {
        ten_nguoi_nhan: "",
        sdt_nguoi_nhan: "",
        email: "",
        tinh_thanh: "",
        quan_huyen: "",
        xa_phuong: ""
    };
    var ref6 = (0,react.useState)(initalUserInfo), userInfo = ref6[0], setUserInfo = ref6[1];
    var ref7 = (0,react.useState)({
        tempPrice: 0,
        totalPrice: 0,
        feeShip: 0
    }), infoOrder = ref7[0], setInfoOrder = ref7[1];
    var ref8 = (0,react.useState)([]), listVouchers = ref8[0], setListVouchers = ref8[1];
    var ref9 = (0,react.useState)(""), pt_thanh_toan = ref9[0], setPt_thanh_toan = ref9[1];
    var ref10 = (0,react.useState)({}), loading = ref10[0], setLoading = ref10[1];
    var ref11 = (0,react.useState)([]), listPromotion = ref11[0], setListPromotion = ref11[1];
    var ref12 = (0,react.useState)({}), voucherFreeShip = ref12[0], setVoucherFreeShip = ref12[1];
    var ref13 = (0,react.useState)([]), listOrderTemp = ref13[0], setListOrderTemp = ref13[1];
    var ref14 = (0,react.useState)(false), orderSuccess = ref14[0], setOrderSuccess = ref14[1];
    var ref15 = (0,react.useState)(false), isVisibleQuantityBtn = ref15[0], setIsVisibleQuantityBtn = ref15[1];
    var ref16 = (0,react.useState)([]), listDVVC = ref16[0], setListDVVC = ref16[1]; // Đơn vị vận chuyển
    var ref17 = (0,react.useState)({}), donViVanChuyen = ref17[0], setDonViVanChuyen = ref17[1];
    // const [wareHouse, setWareHouse] = useState({});
    var ref18 = (0,react.useState)({}), paymentSelected = ref18[0], setPaymentSelected = ref18[1];
    var ref19 = (0,react.useState)([]), listPaymentMethod = ref19[0], setListPaymentMethod = ref19[1];
    var ref20 = (0,react.useState)({}), onSubmitAddress = ref20[0], setOnSubmitAddress = ref20[1];
    var ref21 = (0,react.useState)({}), id_afflink = ref21[0], setId_afflink = ref21[1];
    var dialogRef = react.useRef();
    var context = (0,flexbiz_api_provider/* useApiContext */.Q)();
    var isLogin = (0,useUserInfo/* default */.Z)().isLogin;
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref22 = useFetchCart(), cart = ref22.data;
    var ref23 = (0,orderFuntions/* useFetchOrder */.K)(), info_order = ref23.data;
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = context.userInfo) === null || ref === void 0 ? void 0 : ref.token) {
            queryClient.invalidateQueries([
                "so1"
            ]);
        }
    }, [
        (ref = context.userInfo) === null || ref === void 0 ? void 0 : ref.token
    ]);
    // const fetchSeller = useCallback(async () => {
    //   const seller = await asyncGetList({
    //     collection_name: "ecomsellers",
    //   });
    //   return seller;
    // }, [context.userInfo?.token]);
    var fetchListDVVC = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, listDVVC;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return context.apis.asyncGetList(((ref = context.userInfo) === null || ref === void 0 ? void 0 : ref.token) || public_token, "ecomcarrier_fees", {
                        shared: true
                    });
                case 3:
                    listDVVC = _ctx.sent;
                    return _ctx.abrupt("return", listDVVC);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        (ref1 = context.userInfo) === null || ref1 === void 0 ? void 0 : ref1.token
    ]);
    // const fetchWareHouse = useCallback(async () => {
    //   const listDVVC = await context.apis.asyncGetList(
    //     context.userInfo?.token || public_token,
    //     "ecomseller_warehousies",
    //     {
    //       online: true,
    //     }
    //   );
    //   if (listDVVC.length > 0) {
    //     return listDVVC[0];
    //   }
    // }, [context.userInfo?.token]);
    var fetchListPaymentMethod = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, listPaymentMethod;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return context.apis.asyncGetList(isLogin === false ? public_token : (ref = context.userInfo) === null || ref === void 0 ? void 0 : ref.token, "ptthanhtoan", {
                        condition: {
                            online: true
                        }
                    });
                case 3:
                    listPaymentMethod = _ctx.sent;
                    console.log("\uD83D\uDE80 ~ file: index.js:136 ~ fetchListPaymentMethod ~ listPaymentMethod:", listPaymentMethod);
                    setListPaymentMethod(listPaymentMethod);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        (ref2 = context.userInfo) === null || ref2 === void 0 ? void 0 : ref2.token,
        isLogin,
        public_token
    ]);
    // const timeRef = useRef(0);
    (0,react.useEffect)(function() {
        Promise.all([
            fetchListDVVC()
        ]).then(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), listDVVC = _param[0];
            setListDVVC(listDVVC);
        }).catch(function(err) {
            console.log("\uD83D\uDE80 ~ file: index.js ~ line 86 ~ Promise.all ~ err", err);
        });
    }, [
        fetchListDVVC
    ]);
    (0,react.useEffect)(function() {
        var fetchFeeShip = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, ref1, amountCart, freeShipValue, feeShip1, ref2, ref3, ref4, ref5, conditionFreeShip, ref6, ref7, listFeeShip, ref8, totalFreeShip, totalAmount;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            if (!(!cart || (cart === null || cart === void 0 ? void 0 : cart.length) <= 0)) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 3:
                            amountCart = cart === null || cart === void 0 ? void 0 : cart.reduce(function(pre, cur) {
                                return pre + cur.tien_nt;
                            }, 0);
                            freeShipValue = 0;
                            feeShip1 = 0;
                            if (((ref = cart[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.freeship) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                                ;
                                conditionFreeShip = (ref3 = (ref2 = cart[0]) === null || ref2 === void 0 ? void 0 : ref2.freeship[0]) === null || ref3 === void 0 ? void 0 : ref3.gia_tri_dh;
                                freeShipValue = amountCart >= conditionFreeShip ? ((ref5 = (ref4 = cart[0]) === null || ref4 === void 0 ? void 0 : ref4.freeship[0]) === null || ref5 === void 0 ? void 0 : ref5.phi_van_chuyen) || 0 : 0;
                                if (amountCart >= conditionFreeShip) {
                                    ;
                                    setVoucherFreeShip((ref6 = cart[0]) === null || ref6 === void 0 ? void 0 : ref6.freeship[0]);
                                } else {
                                    setVoucherFreeShip({});
                                }
                            }
                            if (!((info_order === null || info_order === void 0 ? void 0 : info_order._id) && router.pathname === "/checkout")) {
                                _ctx.next = 18;
                                break;
                            }
                            if (!(addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.quan_huyen)) {
                                _ctx.next = 14;
                                break;
                            }
                            ;
                            _ctx.next = 12;
                            return context.apis.asyncGetList(isLogin === false ? public_token : (ref7 = context.userInfo) === null || ref7 === void 0 ? void 0 : ref7.token, "ecomtransportfees", {
                                condition: {
                                    ten_quan_huyen: addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.quan_huyen
                                },
                                shared: true
                            });
                        case 12:
                            listFeeShip = _ctx.sent;
                            if (listFeeShip.length > 0) {
                                ;
                                feeShip1 = (ref8 = listFeeShip[0]) === null || ref8 === void 0 ? void 0 : ref8.tien_phi;
                            } else {
                                feeShip1 = 30000;
                            }
                        case 14:
                            totalFreeShip = Math.min(freeShipValue, feeShip1);
                            totalAmount = (info_order === null || info_order === void 0 ? void 0 : info_order.t_tt_nt) + feeShip1 - totalFreeShip;
                            setInfoOrder({
                                totalPrice: totalAmount,
                                tempPrice: info_order === null || info_order === void 0 ? void 0 : info_order.t_tien_nt,
                                feeShip: feeShip1,
                                voucherValue: info_order === null || info_order === void 0 ? void 0 : info_order.tien_evoucher,
                                freeShipValue: totalFreeShip,
                                tien_phi_vc: feeShip1
                            });
                            return _ctx.abrupt("return");
                        case 18:
                            setInfoOrder({
                                totalPrice: amountCart,
                                tempPrice: amountCart,
                                feeShip: feeShip1
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchFeeShip() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchFeeShip();
    }, [
        cart,
        donViVanChuyen,
        router.pathname,
        addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.quan_huyen,
        info_order, 
    ]);
    var updateCartMutation = (0,useMutation/* useMutation */.D)(function(data) {
        return updateCart(data);
    }, {
        onSuccess: function() {
        // appAlert({ type: "success", message: "Cập nhật giỏ hàng thành công" });
        },
        onSettled: function() {
            queryClient.invalidateQueries(queryKeys/* cartKeys.all */.vM.all);
        }
    });
    var addingCartMutation = (0,useMutation/* useMutation */.D)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var data, url;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = param.data, url = param.url;
                        return _ctx.abrupt("return", context.apis.asyncPost(url, null, data, "POST", "addToCart"));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: function() {
        // appAlert({ type: "success", message: "Thêm vào giỏ hàng thành công" });
        },
        onSettled: function() {
            queryClient.invalidateQueries(queryKeys/* cartKeys.all */.vM.all);
        }
    });
    var deleteCartMutation = (0,useMutation/* useMutation */.D)(function(url) {
        return context.apis.asyncDelete(url, null);
    }, {
        onSuccess: function() {
            (0,notifications/* appAlert */.t)({
                type: "success",
                message: "Cập nhật giỏ h\xe0ng th\xe0nh c\xf4ng"
            });
        },
        onSettled: function() {
            queryClient.invalidateQueries(queryKeys/* cartKeys.all */.vM.all);
        }
    });
    var createOrderMutation = (0,useMutation/* useMutation */.D)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var order, url;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        order = param.order, url = param.url;
                        return _ctx.abrupt("return", context.apis.asyncPost(url, null, order, "POST", "createOrder"));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: function() {
            router.push("/checkout");
        },
        onSettled: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        queryClient.invalidateQueries("so1");
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    });
    (0,react.useEffect)(function() {
        if (!(addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected._id)) {
            updateAddressSelected();
        }
    }, [
        listAddress
    ]);
    var addToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var updatingCartItem;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        updatingCartItem = cart === null || cart === void 0 ? void 0 : cart.find(function(cartItem) {
                            var ref, ref1;
                            return cartItem.ma_vt === data.ma_vt && cartItem.id_app_vt === data.id_app_vt && ((ref = cartItem.thuoc_tinh) === null || ref === void 0 ? void 0 : ref._id) === ((ref1 = data.thuoc_tinh) === null || ref1 === void 0 ? void 0 : ref1._id);
                        });
                        if (!updatingCartItem) {
                            _ctx.next = 5;
                            break;
                        }
                        updatingCartItem.sl_xuat += data.sl_xuat;
                        updateCartMutation.mutate(updatingCartItem, {});
                        return _ctx.abrupt("return");
                    case 5:
                        addNewItemToCart(data);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addToCart(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var addNewItemToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var id_app, token, ref, ref1, ref2, thuoc_tinh, url;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id_app = data === null || data === void 0 ? void 0 : data.id_app;
                        try {
                            ;
                            if (context === null || context === void 0 ? void 0 : context.userInfo) {
                                ;
                                token = (ref = context.userInfo) === null || ref === void 0 ? void 0 : ref.token;
                                data.user = (ref1 = context.userInfo) === null || ref1 === void 0 ? void 0 : ref1.email;
                                data.user_created = (ref2 = context.userInfo) === null || ref2 === void 0 ? void 0 : ref2.email;
                            } else {
                                token = public_token;
                            }
                            thuoc_tinh = data === null || data === void 0 ? void 0 : data.thuoc_tinh;
                            thuoc_tinh = thuoc_tinh && Object.assign(thuoc_tinh, {
                                online: true
                            });
                            data = Object.assign(data, {
                                thuoc_tinh: thuoc_tinh
                            }, {
                                online: true
                            }, {
                                id_app_vt: id_app
                            }, {
                                sl_xuat: data === null || data === void 0 ? void 0 : data.sl_xuat
                            });
                            url = "".concat(server_url, "/api/").concat(id_app, "/cart?access_token=").concat(token);
                            addingCartMutation.mutate({
                                data: data,
                                url: url
                            });
                        } catch (e) {
                            console.error(e);
                            context.alert(e.message || e.error || e);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addNewItemToCart(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var token, ref, ref1, url, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (data._id) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        ;
                        if (context.userInfo) {
                            ;
                            token = (ref = context.userInfo) === null || ref === void 0 ? void 0 : ref.token;
                        } else {
                            token = public_token;
                        }
                        if (context.userInfo) {
                            ;
                            data.user = (ref1 = context.userInfo) === null || ref1 === void 0 ? void 0 : ref1.email;
                        }
                        _ctx.prev = 5;
                        url = "".concat(server_url, "/api/").concat(id_app, "/cart/").concat(data._id, "?access_token=").concat(token);
                        ;
                        _ctx.t0 = JSON;
                        _ctx.next = 11;
                        return context.apis.asyncPost(url, null, data, "PUT", "updateCart");
                    case 11:
                        _ctx.t1 = _ctx.sent;
                        res = _ctx.t0.parse.call(_ctx.t0, _ctx.t1);
                        if (!((res === null || res === void 0 ? void 0 : res.sl_xuat) > (res === null || res === void 0 ? void 0 : res.ton))) {
                            _ctx.next = 17;
                            break;
                        }
                        _ctx.next = 16;
                        return context.apis.asyncPost(url, null, (0,_object_spread/* default */.Z)({}, data, {
                            sl_xuat: res.sl_xuat
                        }), "PUT", "updateCart");
                    case 16:
                        res = _ctx.sent;
                    case 17:
                        _ctx.next = 23;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t2 = _ctx["catch"](5);
                        context.alert(_ctx.t2.message || _ctx.t2.error || _ctx.t2);
                        console.error(_ctx.t2);
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    19
                ]
            ]);
        }));
        return function updateCart(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var token, ref, url;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (context === null || context === void 0 ? void 0 : context.userInfo) {
                            ;
                            token = (ref = context.userInfo) === null || ref === void 0 ? void 0 : ref.token;
                        // data.user = context.userInfo?.email;
                        } else {
                            token = public_token;
                        }
                        _ctx.prev = 2;
                        if (!(data.length > 0)) {
                            _ctx.next = 6;
                            break;
                        }
                        Promise.all(data === null || data === void 0 ? void 0 : data.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
                                var url;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            url = "".concat(server_url, "/api/").concat(id_app, "/cart/").concat(item._id, "?access_token=").concat(token);
                                            _ctx.next = 3;
                                            return context.apis.asyncDelete(url, null);
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(item) {
                                return _ref.apply(this, arguments);
                            };
                        }())).then(function() {
                            queryClient.invalidateQueries("cart");
                        });
                        return _ctx.abrupt("return");
                    case 6:
                        if (data._id) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 8:
                        url = "".concat(server_url, "/api/").concat(id_app, "/cart/").concat(data._id, "?access_token=").concat(token);
                        deleteCartMutation.mutate(url);
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](2);
                        console.error(_ctx.t0);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    12
                ]
            ]);
        }));
        return function deleteCart(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var checkRequired = function() {
        var ref, ref1;
        // console.log("submit valueaddressSelected", onSubmitAddress.values);
        // let addressSelected =
        //   isLogin !== false ? addressSelected : { ...onSubmitAddress.values };
        // const isVNPhoneMobile =
        //   /^(0|\+84)(\s|\.)?((3[1-9])|(5[689])|(7[06-9])|(8[1-689])|(9[0-46-9]))(\d)(\s|\.)?(\d{3})(\s|\.)?(\d{3})$/;
        var isEmail = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
        if ((addressSelected === null || addressSelected === void 0 ? void 0 : (ref = addressSelected.sdt_nguoi_nhan) === null || ref === void 0 ? void 0 : ref.trim().length) < 10) {
            context.alert("Số điện thoại kh\xf4ng hợp lệ");
            return false;
        }
        if ((addressSelected === null || addressSelected === void 0 ? void 0 : (ref1 = addressSelected.email_nguoi_nhan) === null || ref1 === void 0 ? void 0 : ref1.length) && !isEmail.test(addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.email_nguoi_nhan)) {
            context.alert("Email kh\xf4ng hợp lệ");
            return false;
        }
        if (// !addressSelected?.ten_nguoi_nhan ||
        !(addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.dia_chi) || !(addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.tinh_thanh) || !(addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.quan_huyen) || !(addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.xa_phuong)) {
            context.alert("Vui l\xf2ng nhập đầy đủ th\xf4ng tin");
            return false;
        }
        return true;
    // if (!addressSelected?._id) {
    //   appAlert({
    //     type: "error",
    //     message: "Vui lòng chọn địa chỉ giao hàng",
    //   });
    //   return false;
    // }
    // return true;
    };
    var createOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var trang_thai, ref, ref1, ref2, ref3, ref4, ref5, ma_freeship, evouchers, feeShip1, leadTime, freeshipValue, id_app, token, infoDVVC, trang_thai_tt, listOrder, ref6, order, orderPromotion, orderSuccess, url, _id, so_ct, master, ref7, ref8, listLCT;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        trang_thai = param.trang_thai;
                        ;
                        if (!createOrderMutation.isLoading) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(trang_thai === "0")) {
                            _ctx.next = 7;
                            break;
                        }
                        if (checkRequired()) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 7:
                        ma_freeship = voucherFreeShip === null || voucherFreeShip === void 0 ? void 0 : voucherFreeShip.ma_chietkhau;
                        evouchers = voucherFreeShip;
                        feeShip1 = infoOrder.feeShip;
                        ;
                        freeshipValue = infoOrder.freeShipValue;
                        id_app = (ref = cart[0]) === null || ref === void 0 ? void 0 : ref.id_app;
                        token = isLogin !== false ? (ref1 = context.userInfo) === null || ref1 === void 0 ? void 0 : ref1.token : public_token;
                        infoDVVC = {
                            don_vi_vc: donViVanChuyen === null || donViVanChuyen === void 0 ? void 0 : donViVanChuyen.ma_dv_vc,
                            goi_cuoc_vc: donViVanChuyen === null || donViVanChuyen === void 0 ? void 0 : donViVanChuyen.ten_goi_cuoc,
                            thu_ho: (paymentSelected === null || paymentSelected === void 0 ? void 0 : paymentSelected._id) === "62f075b044ceb71181578d03"
                        };
                        trang_thai_tt = (paymentSelected === null || paymentSelected === void 0 ? void 0 : paymentSelected._id) === "62f075b044ceb71181578d03" ? "1" : "0";
                        listOrder = cart;
                        if ((info_order === null || info_order === void 0 ? void 0 : info_order._id) && ((ref2 = info_order.details) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && trang_thai !== "LCT") {
                            listOrder = info_order.details;
                            ;
                            evouchers = (ref6 = info_order === null || info_order === void 0 ? void 0 : info_order.evouchers) !== null && ref6 !== void 0 ? ref6 : [];
                        }
                        order = (0,_object_spread/* default */.Z)({
                            ma_ct: "SO1",
                            id_afflink: id_afflink,
                            ngay_ct: new Date(),
                            ma_kho: "KCTY",
                            ma_nt: "VND",
                            t_tien_hang: listOrder === null || listOrder === void 0 ? void 0 : listOrder.map(function(c) {
                                return c.tien_hang_nt;
                            }).reduce(function(a, b) {
                                return a + b;
                            }, 0),
                            t_tien_ck: listOrder === null || listOrder === void 0 ? void 0 : listOrder.map(function(c) {
                                return c.tien_ck;
                            }).reduce(function(a, b) {
                                return a + b;
                            }, 0),
                            t_cp_cpb: 0,
                            ty_le_ck_hd: 0,
                            tien_ck_hd: 0,
                            tien_freeship: freeshipValue,
                            tien_phi_vc: feeShip1,
                            pt_thanh_toan: paymentSelected === null || paymentSelected === void 0 ? void 0 : paymentSelected._id,
                            again_link: "https://".concat(window.location.href.split("/")[2]).concat(config.again_link),
                            trang_thai: trang_thai,
                            trang_thai_tt: trang_thai_tt,
                            tien_evoucher: evouchers === null || evouchers === void 0 ? void 0 : evouchers.so_tien_giam,
                            evouchers: [].concat(evouchers),
                            ma_freeship: ma_freeship,
                            xa_phuong: addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.xa_phuong,
                            dia_chi_nguoi_nhan: addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.dia_chi,
                            ngay_du_kien_nhan: leadTime ? new Date(leadTime) : new Date(),
                            online: true,
                            ma_kenh: ((ref3 = process.env) === null || ref3 === void 0 ? void 0 : "TMĐT") || "",
                            ma_gian_hang: ((ref4 = process.env) === null || ref4 === void 0 ? void 0 : "ZEMOR") || "",
                            id_app: id_app,
                            shared: true
                        }, infoDVVC, addressSelected);
                        orderPromotion = [];
                        listPromotion === null || listPromotion === void 0 ? void 0 : listPromotion.forEach(function(item) {
                            var index;
                            listOrder === null || listOrder === void 0 ? void 0 : listOrder.forEach(function(element) {
                                var ref;
                                33;
                                index = element === null || element === void 0 ? void 0 : (ref = element.promotion) === null || ref === void 0 ? void 0 : ref.findIndex(function(pro) {
                                    return pro._id === item._id;
                                });
                                if (index >= 0) {
                                    orderPromotion = orderPromotion.concat((0,_object_spread/* default */.Z)({
                                        gia_ban: 0,
                                        sl_xuat: item.sl_km || 1
                                    }, item === null || item === void 0 ? void 0 : item.details_km[0]));
                                }
                            });
                        });
                        order.details = listOrder === null || listOrder === void 0 ? void 0 : listOrder.concat(orderPromotion);
                        order.details = (ref5 = order.details) === null || ref5 === void 0 ? void 0 : ref5.map(function(item) {
                            return (item === null || item === void 0 ? void 0 : item.ma_vt_tt) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                ma_vt: item.ma_vt_tt,
                                ma_tt1: "",
                                exfields_detail: {
                                    picture_tt: item.picture_tt || item.picture
                                }
                            }) : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                ma_tt1: ""
                            });
                        });
                        orderSuccess = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            try {
                                                deleteCart(cart);
                                                setListVouchers([]);
                                                setVoucherFreeShip({});
                                            } catch (error) {
                                                console.log("error handle delete listOrder");
                                            }
                                        case 1:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function orderSuccess() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        url = "".concat(server_url, "/api/").concat(id_app, "/so1?access_token=").concat(token);
                        _ctx.prev = 25;
                        if (!(trang_thai === "0")) {
                            _ctx.next = 38;
                            break;
                        }
                        _id = info_order === null || info_order === void 0 ? void 0 : info_order._id;
                        so_ct = listOrder === null || listOrder === void 0 ? void 0 : listOrder.so_ct;
                        order = Object.assign(order, {
                            _id: _id,
                            so_ct: so_ct,
                            id_app: id_app
                        });
                        _ctx.next = 32;
                        return context.apis.asyncPostList(token, "so1", order, {
                            id_app: id_app
                        });
                    case 32:
                        master = _ctx.sent;
                        _ctx.next = 35;
                        return orderSuccess(listOrder);
                    case 35:
                        if (master.virtual_payment_client_url && (master.trang_thai === "0" || master.trang_thai === "1")) {
                            window.location.href = master.virtual_payment_client_url;
                        } else if (trang_thai === "0") {
                            router.push({
                                pathname: "/checkout-alert",
                                query: {
                                    isSuccess: "true",
                                    amount: master.t_tt_nt,
                                    isCOD: true,
                                    message: "Đặt h\xe0ng th\xe0nh c\xf4ng",
                                    info_order: {},
                                    _id: master === null || master === void 0 ? void 0 : master._id,
                                    email: master === null || master === void 0 ? void 0 : master.email_nguoi_nhan
                                }
                            });
                        }
                        _ctx.next = 45;
                        break;
                    case 38:
                        ;
                        _ctx.next = 41;
                        return context.apis.asyncGetList(token, "so1", {
                            condition: {
                                trang_thai: "LCT",
                                user_created: ((ref7 = context.userInfo) === null || ref7 === void 0 ? void 0 : ref7.email) ? (ref8 = context.userInfo) === null || ref8 === void 0 ? void 0 : ref8.email : "public"
                            }
                        });
                    case 41:
                        listLCT = _ctx.sent;
                        Promise.all(listLCT === null || listLCT === void 0 ? void 0 : listLCT.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return context.apis.asyncDeleteList(token, "so1", item === null || item === void 0 ? void 0 : item._id);
                                        case 2:
                                            return _ctx.abrupt("return", _ctx.sent);
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(item) {
                                return _ref.apply(this, arguments);
                            };
                        }())).catch(function(error) {
                            console.log("\uD83D\uDE80 ~ file: index.js ~ line 487 ~ createOrder ~ error", error);
                        });
                        order = Object.assign(order, {
                            tien_evoucher: 0,
                            evouchers: []
                        });
                        createOrderMutation.mutateAsync({
                            order: order,
                            url: url
                        });
                    case 45:
                        _ctx.next = 50;
                        break;
                    case 47:
                        _ctx.prev = 47;
                        _ctx.t0 = _ctx["catch"](25);
                        console.log("\uD83D\uDE80 ~ file: index.js ~ line 532 ~ createOrder ~ error", _ctx.t0);
                    case 50:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    25,
                    47
                ]
            ]);
        }));
        return function createOrder(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateAddressSelected = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(address) {
            var _$address;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!address) {
                            _ctx.next = 4;
                            break;
                        }
                        {
                            if (!address._id) {
                                setAddressSelected({});
                            }
                            setAddressSelected(address);
                        }
                        _ctx.next = 10;
                        break;
                    case 4:
                        if (!((listAddress === null || listAddress === void 0 ? void 0 : listAddress.length) > 0)) {
                            _ctx.next = 10;
                            break;
                        }
                        _$address = listAddress === null || listAddress === void 0 ? void 0 : listAddress.find(function(item) {
                            return (item === null || item === void 0 ? void 0 : item.ngam_dinh) === true;
                        });
                        if (!(_$address === null || _$address === void 0 ? void 0 : _$address._id)) {
                            _ctx.next = 9;
                            break;
                        }
                        setAddressSelected(_$address);
                        return _ctx.abrupt("return");
                    case 9:
                        setAddressSelected(listAddress[0]);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function updateAddressSelected(address) {
            return _ref.apply(this, arguments);
        };
    }();
    var checkVoucher = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(vouchers) {
            var ref, index, voucher;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        index = listVouchers.findIndex(function(i) {
                            return i.ma === vouchers;
                        });
                        if (!(index >= 0)) {
                            _ctx.next = 5;
                            break;
                        }
                        throw new Error("Bạn đ\xe3 th\xeam m\xe3 giảm gi\xe1 n\xe0y");
                    case 5:
                        _ctx.next = 7;
                        return context.apis.asyncGetList(((ref = context.userInfo) === null || ref === void 0 ? void 0 : ref.token) || public_token, "evoucher", {
                            condition: {
                                ma: vouchers
                            }
                        });
                    case 7:
                        voucher = _ctx.sent;
                        if (!(voucher.length < 1)) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error("M\xe3 giảm gi\xe1 kh\xf4ng tồn tại hoặc hết hạn sử dụng");
                    case 10:
                        return _ctx.abrupt("return", voucher);
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        // context.setProgressStatus(false);
                        context.toast(_ctx.t0.message || _ctx.t0.error || _ctx.t0);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function checkVoucher(vouchers) {
            return _ref.apply(this, arguments);
        };
    }();
    var addVoucher = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(voucher) {
            var isVoucher, listOrder, totalPrice, ref, ref1, ref2, t_tien_hang, tien_ck, tien_evoucher, order, _id, so_ct, id_app, ref3;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (voucher) {
                            _ctx.next = 3;
                            break;
                        }
                        throw new Error("Voucher kh\xf4ng khả dụng");
                    case 3:
                        if (!(listVouchers > 0)) {
                            _ctx.next = 5;
                            break;
                        }
                        throw new Error("Bạn đ\xe3 th\xeam m\xe3 giảm gi\xe1 n\xe0y");
                    case 5:
                        _ctx.next = 7;
                        return checkVoucher(voucher);
                    case 7:
                        isVoucher = _ctx.sent;
                        listOrder = info_order === null || info_order === void 0 ? void 0 : info_order.details;
                        totalPrice = infoOrder === null || infoOrder === void 0 ? void 0 : infoOrder.totalPrice;
                        if (!((isVoucher === null || isVoucher === void 0 ? void 0 : isVoucher.length) > 0)) {
                            _ctx.next = 29;
                            break;
                        }
                        ;
                        if (!(totalPrice >= ((ref = isVoucher[0]) === null || ref === void 0 ? void 0 : ref.gt_don_hang_toi_thieu) || ((ref1 = isVoucher[0]) === null || ref1 === void 0 ? void 0 : ref1.gt_don_hang_toi_thieu) === undefined)) {
                            _ctx.next = 28;
                            break;
                        }
                        ;
                        t_tien_hang = listOrder === null || listOrder === void 0 ? void 0 : listOrder.map(function(c) {
                            return c.tien;
                        }).reduce(function(a, b) {
                            return a + b;
                        }, 0);
                        tien_ck = listOrder === null || listOrder === void 0 ? void 0 : listOrder.map(function(c) {
                            return c.tien_ck;
                        }).reduce(function(a, b) {
                            return a + b;
                        }, 0);
                        tien_evoucher = isVoucher === null || isVoucher === void 0 ? void 0 : isVoucher.map(function(e) {
                            var so_tien = e.ty_le ? Math.roundBy(t_tien_hang * e.ty_le / 100, 0) : e.so_tien;
                            if (e.so_tien_max && so_tien > e.so_tien_max) {
                                so_tien = e.so_tien_max;
                            }
                            e.so_tien_giam = so_tien;
                            return so_tien;
                        }).reduce(function(a, b) {
                            return a + b;
                        }, 0);
                        order = {
                            evouchers: isVoucher,
                            tien_evoucher: tien_evoucher > t_tien_hang - tien_ck ? t_tien_hang - tien_ck : tien_evoucher
                        };
                        _id = info_order === null || info_order === void 0 ? void 0 : info_order._id;
                        so_ct = info_order === null || info_order === void 0 ? void 0 : info_order.so_ct;
                        id_app = info_order === null || info_order === void 0 ? void 0 : info_order.id_app;
                        order = Object.assign(order, {
                            _id: _id,
                            so_ct: so_ct
                        });
                        _ctx.next = 24;
                        return context.apis.asyncPostList(isLogin === false ? public_token : (ref2 = context.userInfo) === null || ref2 === void 0 ? void 0 : ref2.token, "so1", order, {
                            id_app: id_app
                        });
                    case 24:
                        _ctx.next = 26;
                        return queryClient.invalidateQueries("so1");
                    case 26:
                        _ctx.next = 29;
                        break;
                    case 28:
                        throw new Error("Chưa đạt gi\xe1 trị đơn h\xe0ng tối thiểu");
                    case 29:
                        _ctx.next = 35;
                        break;
                    case 31:
                        _ctx.prev = 31;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        // context.setProgressStatus(false);
                        context.alert(_ctx.t0.message || _ctx.t0.error || (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref3 = _ctx.t0.data) === null || ref3 === void 0 ? void 0 : ref3.error));
                    case 35:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    31
                ]
            ]);
        }));
        return function addVoucher(voucher) {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchShipAddress = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, ref1, token, condition, listAddress;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    token = isLogin === false ? public_token : (ref = context.userInfo) === null || ref === void 0 ? void 0 : ref.token;
                    condition = isLogin === false ? {} : {
                        user_created: (ref1 = context.userInfo) === null || ref1 === void 0 ? void 0 : ref1.email
                    };
                    _ctx.prev = 3;
                    _ctx.next = 6;
                    return context.apis.asyncGetList(token, "ecomuser_address", {
                        limit: 10,
                        page: 1,
                        condition: (0,_object_spread/* default */.Z)({}, condition)
                    });
                case 6:
                    listAddress = _ctx.sent;
                    setListAddress(listAddress);
                    _ctx.next = 13;
                    break;
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](3);
                    console.log("log errro fect address ---->", _ctx.t0);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                10
            ]
        ]);
    })), [
        context === null || context === void 0 ? void 0 : (ref3 = context.userInfo) === null || ref3 === void 0 ? void 0 : ref3.token,
        isLogin
    ]);
    var updatePaymentMethodSelected = function(pt_thanh_toan) {
        if (pt_thanh_toan) {
            setPt_thanh_toan(pt_thanh_toan);
        }
    };
    var deleteVoucher = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orderItem) {
            var order, _id, so_ct, ref, res, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        order = {
                            evouchers: [],
                            tien_evoucher: 0
                        };
                        _id = orderItem === null || orderItem === void 0 ? void 0 : orderItem._id;
                        so_ct = orderItem === null || orderItem === void 0 ? void 0 : orderItem.so_ct;
                        order = Object.assign(order, {
                            _id: _id,
                            so_ct: so_ct
                        });
                        console.log("\uD83D\uDE80 ~ file: index.js ~ line 774 ~ deleteVoucher ~ order", order);
                        _ctx.prev = 5;
                        ;
                        _ctx.next = 9;
                        return context.apis.asyncPostList(isLogin === false ? public_token : (ref = context.userInfo) === null || ref === void 0 ? void 0 : ref.token, "so1", order);
                    case 9:
                        res = _ctx.sent;
                        _ctx.next = 12;
                        return queryClient.invalidateQueries("so1");
                    case 12:
                        _ctx.next = 18;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](5);
                        ;
                        // context.setProgressStatus(false);
                        context.alert((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) || (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.error) || (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.data) === null || ref1 === void 0 ? void 0 : ref1.error));
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    14
                ]
            ]);
        }));
        return function deleteVoucher(orderItem) {
            return _ref.apply(this, arguments);
        };
    }();
    var addListPromotion = function(product) {
        var listPromotionClone = (0,_to_consumable_array/* default */.Z)(listPromotion);
        if (product.length > 0) {
            if ((listPromotionClone === null || listPromotionClone === void 0 ? void 0 : listPromotionClone.length) > 0) {
                product.forEach(function(e) {
                    var ref;
                    (ref = e.promotion) === null || ref === void 0 ? void 0 : ref.forEach(function(element) {
                        var details_km = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, e === null || e === void 0 ? void 0 : e.promotion[0].details_km[0]), {
                            id_app: e === null || e === void 0 ? void 0 : e.id_app
                        });
                        element = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, e === null || e === void 0 ? void 0 : e.promotion[0]), {
                            details_km: details_km
                        });
                        if (element) {
                            var index = listPromotionClone.findIndex(function(promotion) {
                                return (promotion === null || promotion === void 0 ? void 0 : promotion.ma_vt) === (element === null || element === void 0 ? void 0 : element.ma_vt);
                            });
                            if (index >= 0) {
                                return;
                            }
                            listPromotionClone = listPromotionClone.concat(element);
                            setListPromotion(listPromotionClone);
                        }
                    });
                });
                return;
            }
            product.forEach(function(e) {
                var ref;
                if (((ref = e.promotion) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                    // e = Object.assign(e, { ...product?.id_app });
                    var details_km = [
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, e === null || e === void 0 ? void 0 : e.promotion[0].details_km[0]), {
                            id_app: e === null || e === void 0 ? void 0 : e.id_app
                        }), 
                    ];
                    var promotion = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, e === null || e === void 0 ? void 0 : e.promotion[0]), {
                        details_km: details_km
                    });
                    listPromotionClone = listPromotionClone.concat(promotion);
                }
            });
            setListPromotion((0,_to_consumable_array/* default */.Z)(listPromotionClone));
            return;
        }
        if (listPromotionClone.length > 0) {
            var index = listPromotionClone.findIndex(function(i) {
                return i.ma_vt === product.ma_vt;
            });
            if (index >= 0) {
                listPromotionClone.fill(product, index, index + 1);
            } else {
                listPromotionClone = listPromotionClone.concat(product);
            }
            setListPromotion(listPromotionClone);
            return;
        }
        listPromotionClone = listPromotionClone.concat(product);
        setListPromotion(listPromotionClone);
    };
    var reOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _id, so_ct, paymentSelected, order, master;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _id = param._id, so_ct = param.so_ct, paymentSelected = param.paymentSelected;
                        order = {
                            _id: _id,
                            so_ct: so_ct,
                            pt_thanh_toan: paymentSelected,
                            virtual_payment_client_url: ""
                        };
                        _ctx.next = 4;
                        return context.apis.asyncPostList(context.userInfo.token, "so1", order);
                    case 4:
                        master = _ctx.sent;
                        if (master.virtual_payment_client_url && (master.trang_thai === "0" || master.trang_thai === "1")) {
                            window.location.href = master.virtual_payment_client_url;
                        } else {
                            setOrderSuccess({
                                isSuccess: "true",
                                amount: order.t_tien_hang,
                                isCOD: true,
                                message: "Đặt h\xe0ng th\xe0nh c\xf4ng"
                            });
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function reOrder(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var addVoucherFreeship = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item, infoOrder) {
            var order, ma_freeship, tien_freeship, _id, so_ct;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        order = {};
                        ma_freeship = (item === null || item === void 0 ? void 0 : item.ma_chietkhau) || "";
                        tien_freeship = (item === null || item === void 0 ? void 0 : item.phi_van_chuyen) ? (feeShip === null || feeShip === void 0 ? void 0 : feeShip.tien_phi) <= (item === null || item === void 0 ? void 0 : item.phi_van_chuyen) ? feeShip === null || feeShip === void 0 ? void 0 : feeShip.tien_phi : item === null || item === void 0 ? void 0 : item.phi_van_chuyen : 0;
                        _id = infoOrder === null || infoOrder === void 0 ? void 0 : infoOrder._id;
                        so_ct = infoOrder === null || infoOrder === void 0 ? void 0 : infoOrder.so_ct;
                        order = Object.assign(order, {
                            _id: _id,
                            so_ct: so_ct,
                            ma_freeship: ma_freeship,
                            tien_freeship: tien_freeship,
                            tien_phi_vc: feeShip === null || feeShip === void 0 ? void 0 : feeShip.tien_phi
                        });
                        _ctx.prev = 6;
                        _ctx.next = 9;
                        return context.apis.asyncPostList(context.userInfo.token, "so1", order, {
                            id_app: infoOrder === null || infoOrder === void 0 ? void 0 : infoOrder.id_app
                        });
                    case 9:
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](6);
                        context.alert(_ctx.t0.message || _ctx.t0.error || _ctx.t0);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    6,
                    11
                ]
            ]);
        }));
        return function addVoucherFreeship(item, infoOrder) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateOrderTemp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(product) {
            var ref, orderTemp, index, listProduct, ref1, master, listOrder;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        orderTemp = listOrderTemp[0];
                        product = (0,_object_spread/* default */.Z)({}, product, {
                            km_yn_for: "so1"
                        });
                        index = orderTemp === null || orderTemp === void 0 ? void 0 : (ref = orderTemp.details) === null || ref === void 0 ? void 0 : ref.findIndex(function(i) {
                            return (i === null || i === void 0 ? void 0 : i._id) === (product === null || product === void 0 ? void 0 : product._id) && (product === null || product === void 0 ? void 0 : product.km_yn_for);
                        });
                        if (product.sl_xuat <= 0 && index >= 0) {
                            listProduct = orderTemp === null || orderTemp === void 0 ? void 0 : orderTemp.details.filter(function(i) {
                                return i._id !== (product === null || product === void 0 ? void 0 : product._id);
                            });
                            orderTemp.details = listProduct;
                        } else if (index >= 0) {
                            orderTemp.details[index] = product;
                        } else {
                            ;
                            orderTemp.details = orderTemp === null || orderTemp === void 0 ? void 0 : (ref1 = orderTemp.details) === null || ref1 === void 0 ? void 0 : ref1.concat(product);
                        }
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return context.apis.asyncPostList(context.userInfo.token, "so1", orderTemp);
                    case 8:
                        master = _ctx.sent;
                        listOrder = (0,_to_consumable_array/* default */.Z)(listOrderTemp);
                        listOrder.fill(master, 0, 1);
                        setListOrderTemp(listOrder);
                        _ctx.next = 17;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](5);
                        context.alert(_ctx.t0.message || _ctx.t0.error || _ctx.t0);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    14
                ]
            ]);
        }));
        return function updateOrderTemp(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchVoucherFreeShip = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
            var voucher;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return context.apis.asyncGetListShared(context.userInfo.token, "ecompromotion_freeships", {
                            condition: {
                                ma_chietkhau: item
                            }
                        });
                    case 2:
                        voucher = _ctx.sent;
                        return _ctx.abrupt("return", voucher);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchVoucherFreeShip(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var dialogAction = function(param) {
        var title = param.title, message = param.message, onConfirm = param.onConfirm, onCancel = param.onCancel;
        dialogRef.current.handleClick(title, message, onConfirm, onCancel);
    };
    var submitAddress = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(infoUser) {
            var id, data, submit, clearDefault, ref, index;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        try {
                            id = addressSelected._id === infoUser._id ? infoUser._id : "";
                            data = (0,_object_spread/* default */.Z)({}, infoUser, {
                                _id: id
                            });
                            submit = function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(token) {
                                    var address;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.next = 2;
                                                return context.apis.asyncPostList(token, "ecomuser_address", isLogin === false ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                                    ngam_dinh: true
                                                }) : data);
                                            case 2:
                                                address = _ctx.sent;
                                                queryClient.invalidateQueries("ecomuser_address");
                                                if (!(address === null || address === void 0 ? void 0 : address._id)) {
                                                    _ctx.next = 9;
                                                    break;
                                                }
                                                _ctx.next = 7;
                                                return fetchShipAddress();
                                            case 7:
                                                _ctx.next = 9;
                                                return updateAddressSelected(address);
                                            case 9:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function submit(token) {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            clearDefault = function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                listAddress && (listAddress === null || listAddress === void 0 ? void 0 : listAddress.map(function() {
                                                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(list2) {
                                                        return runtime_default().wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    list2.ngam_dinh = false;
                                                                    _ctx.prev = 1;
                                                                    _ctx.next = 4;
                                                                    return context.apis.asyncPostList(isLogin === false ? public_token : context.userInfo.token, "ecomuser_address", (0,_object_spread/* default */.Z)({
                                                                        id_app: id_app
                                                                    }, list2));
                                                                case 4:
                                                                    _ctx.next = 9;
                                                                    break;
                                                                case 6:
                                                                    _ctx.prev = 6;
                                                                    _ctx.t0 = _ctx["catch"](1);
                                                                    console.log(_ctx.t0);
                                                                case 9:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee, null, [
                                                            [
                                                                1,
                                                                6
                                                            ]
                                                        ]);
                                                    }));
                                                    return function(list2) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }()));
                                            case 1:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function clearDefault() {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            // const deleteAddress = async () => {
                            //   listAddress?.length > 1 &&
                            //     Promise.all(
                            //       listAddress.map(async (address) => {
                            //         if (
                            //           address.ngam_dinh === true &&
                            //           address._id === addressSelected._id
                            //         ) {
                            //           return;
                            //         }
                            //         await context.apis.asyncDeleteList(
                            //           public_token,
                            //           "ecomuser_address",
                            //           address._id
                            //         );
                            //       })
                            //     );
                            //   queryClient.invalidateQueries("ecomuser_address");
                            // };
                            if (data === null || data === void 0 ? void 0 : data.ngam_dinh) {
                                clearDefault();
                            }
                            if (isLogin === false) {
                                // deleteAddress();
                                submit(public_token);
                            } else {
                                ;
                                index = listAddress === null || listAddress === void 0 ? void 0 : listAddress.findIndex(function(i) {
                                    return i.ngam_dinh === true;
                                }); // check address default
                                if (index === -1) {
                                    data.ngam_dinh = true;
                                }
                                submit((ref = context.userInfo) === null || ref === void 0 ? void 0 : ref.token);
                            }
                        } catch (e) {
                            console.log("\uD83D\uDE80 ~ file: index.js ~ line 1031 ~ submitAddress ~ e", e);
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitAddress(infoUser) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartContext.Provider, {
        value: {
            cart: cart,
            listAddress: listAddress,
            addressSelected: addressSelected,
            listVouchers: listVouchers,
            pt_thanh_toan: pt_thanh_toan,
            loading: loading,
            listPromotion: listPromotion,
            voucherFreeShip: voucherFreeShip,
            listOrderTemp: listOrderTemp,
            orderSuccess: orderSuccess,
            isVisibleQuantityBtn: isVisibleQuantityBtn,
            fetchListDVVC: fetchListDVVC,
            addVoucherFreeship: addVoucherFreeship,
            addToCart: addToCart,
            updateCart: updateCart,
            deleteCart: deleteCart,
            createOrder: createOrder,
            updateAddressSelected: updateAddressSelected,
            checkVoucher: checkVoucher,
            addVoucher: addVoucher,
            fetchShipAddress: fetchShipAddress,
            updatePaymentMethodSelected: updatePaymentMethodSelected,
            setIsVisibleQuantityBtn: setIsVisibleQuantityBtn,
            deleteVoucher: deleteVoucher,
            addListPromotion: addListPromotion,
            reOrder: reOrder,
            updateOrderTemp: updateOrderTemp,
            listDVVC: listDVVC,
            fetchVoucherFreeShip: fetchVoucherFreeShip,
            dialogAction: dialogAction,
            setDonViVanChuyen: setDonViVanChuyen,
            donViVanChuyen: donViVanChuyen,
            infoOrder: infoOrder,
            updateCartMutation: updateCartMutation,
            setUserInfo: setUserInfo,
            fetchListPaymentMethod: fetchListPaymentMethod,
            listPaymentMethod: listPaymentMethod,
            setPaymentSelected: setPaymentSelected,
            userInfo: userInfo,
            info_order: info_order,
            setInfoOrder: setInfoOrder,
            submitAddress: submitAddress,
            isProcessingCart: (addingCartMutation === null || addingCartMutation === void 0 ? void 0 : addingCartMutation.isLoading) || (updateCartMutation === null || updateCartMutation === void 0 ? void 0 : updateCartMutation.isLoading) || (deleteCartMutation === null || deleteCartMutation === void 0 ? void 0 : deleteCartMutation.isLoading),
            isProcessingOrder: createOrderMutation === null || createOrderMutation === void 0 ? void 0 : createOrderMutation.isLoading,
            onSubmitAddress: onSubmitAddress,
            setOnSubmitAddress: setOnSubmitAddress,
            setAddressSelected: setAddressSelected,
            id_afflink: id_afflink,
            setId_afflink: setId_afflink
        },
        children: [
            props.children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogAction_DialogAction, {
                ref: dialogRef
            })
        ]
    });
}
/* harmony default export */ var cartProvider = (CartProvider);


/***/ }),

/***/ 34733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ flexbiz_api_provider; },
  "Q": function() { return /* binding */ useApiContext; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./setup/axios/index.js + 1 modules
var axios = __webpack_require__(42580);
// EXTERNAL MODULE: ./utils/localStorage.js
var utils_localStorage = __webpack_require__(44061);
// EXTERNAL MODULE: ./node_modules/buffer/index.js
var buffer = __webpack_require__(48764);
;// CONCATENATED MODULE: ./setup/flexbiz-api-provider/localStorageDB.js
function localStorageDB() {
    var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
    if (!indexedDB) {
        console.error("indexDB not supported");
        return;
    }
    var db, request = indexedDB.open("flexDB", 1);
    request.onsuccess = function(evt) {
        db = this.result;
    };
    request.onerror = function(event) {
        console.error("indexedDB request error");
        console.log(event);
    };
    request.onupgradeneeded = function(event) {
        db = null;
        var store = event.target.result.createObjectStore("s", {
            keyPath: "k"
        });
        store.transaction.oncomplete = function(e) {
            db = e.target.db;
        };
    };
    function getValue(key, callback) {
        if (!db) {
            setTimeout(function() {
                getValue(key, callback);
            }, 100);
            return;
        }
        db.transaction("s").objectStore("s").get(key).onsuccess = function(event) {
            var result = event.target.result && event.target.result.v || null;
            callback(null, result);
        };
    }
    function setValue(k, v, callback) {
        if (!db) {
            setTimeout(function() {
                setValue(k, v, callback);
            }, 100);
            return;
        }
        var txn = db.transaction("s", "readwrite");
        txn.oncomplete = function(event) {
            if (callback) callback();
        };
        txn.onerror = function(event) {
            console.error("Can't set item", event);
            if (callback) callback("Can't set item");
        };
        txn.objectStore("s").put({
            k: k,
            v: v
        });
        txn.commit();
    }
    function removeValue(k, callback) {
        if (!db) {
            setTimeout(function() {
                removeValue(k, callback);
            }, 100);
            return;
        }
        var txn = db.transaction("s", "readwrite");
        txn.oncomplete = function(event) {
            if (callback) callback();
        };
        txn.onerror = function(event) {
            console.error("Can't remove item", event);
            if (callback) callback("Can't remove item");
        };
        txn.objectStore("s").delete(k);
        txn.commit();
    }
    return {
        getItem: getValue,
        removeItem: removeValue,
        setItem: setValue
    };
};

;// CONCATENATED MODULE: ./setup/flexbiz-api-provider/APIs.js










if (true) {
    if (!(window === null || window === void 0 ? void 0 : window.ldb)) {
        window.ldb = localStorageDB();
    }
}
function getCookie(cname) {
    if (false) {}
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == " "){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            var v = c.substring(name.length, c.length);
            return v;
        }
    }
    return "";
}
function setCookie(cname, cvalue, exdays) {
    if (false) {}
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
var cachedData = {};
var list_not_require_id_app_default = [
    "user",
    "users",
    "notification",
    "message",
    "listinfo",
    "moduleinfo",
    "reportinfo",
    "tableinfo",
    "labelinfo",
    "rptobject",
    "trangthai",
    "app",
    "sysgroup",
    "sysconfig",
    "schedule",
    "templatestore",
    "tinhthanh",
    "quanhuyen",
    "xaphuong",
    "token",
    "importexceltemplate",
    "exportexceltemplate", 
];
var APIs = /*#__PURE__*/ function() {
    "use strict";
    function APIs() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, APIs);
        if (!config.server_url_report) config.server_url_report = config.server_url;
        if (!config.list_not_require_id_app) config.list_not_require_id_app = [];
        this.config = config;
        this.config.get = function(name) {
            return config[name];
        };
        this.labels = null;
        this.lang = "vi";
        this.list_not_require_id_app = (0,_to_consumable_array/* default */.Z)(list_not_require_id_app_default).concat((0,_to_consumable_array/* default */.Z)(config.list_not_require_id_app));
        this.cachedData = cachedData;
        this.get = this.get.bind(this);
        this.getLocal = this.getLocal.bind(this);
        this.asyncGet = this.asyncGet.bind(this);
        this.post = this.post.bind(this);
        this.asyncPost = this.asyncPost.bind(this);
        this.asyncDelete = this.asyncDelete.bind(this);
        this.asyncGetDataById = this.asyncGetDataById.bind(this);
        this.asyncGetData = this.asyncGetData.bind(this);
        this.asyncGetDataShared = this.asyncGetDataShared.bind(this);
        this.asyncGetList = this.asyncGetList.bind(this);
        this.asyncGetDataByIdShared = this.asyncGetDataByIdShared.bind(this);
        this.asyncGetListShared = this.asyncGetListShared.bind(this);
        this.asyncPostList = this.asyncPostList.bind(this);
        this.asyncDeleteList = this.asyncDeleteList.bind(this);
        // this.asyncGetReport = this.asyncGetReport.bind(this);
        this.asyncFiles = this.asyncFiles.bind(this);
        this.asyncGetLogById = this.asyncGetLogById.bind(this);
        this.loginAPI = this.loginAPI.bind(this);
        this.asyncLoginAPI = this.asyncLoginAPI.bind(this);
        this.logoutAPI = this.logoutAPI.bind(this);
        this.asyncLoginSms = this.asyncLoginSms.bind(this);
        this.asyncLoginSmsVerify = this.asyncLoginSmsVerify.bind(this);
        this.asyncLogoutAPI = this.asyncLogoutAPI.bind(this);
        this.asyncSign = this.asyncSign.bind(this);
        this.signup = this.signup.bind(this);
        this.asyncSignup = this.asyncSignup.bind(this);
        this.asyncResetPassword = this.asyncResetPassword.bind(this);
        this.asyncChangePasswordByAdmin = this.asyncChangePasswordByAdmin.bind(this);
        this.asyncChangePassword = this.asyncChangePassword.bind(this);
        this.getUserInfoByToken = this.getUserInfoByToken.bind(this);
        this.asyncGetUserInfoByToken = this.asyncGetUserInfoByToken.bind(this);
        this.asyncGetProfile = this.asyncGetProfile.bind(this);
        this.asyncJoinApp = this.asyncJoinApp.bind(this);
        this.asyncGetAppInfo = this.asyncGetAppInfo.bind(this);
        this.asyncBackup = this.asyncBackup.bind(this);
        this.asyncRestore = this.asyncRestore.bind(this);
        this.getWalletByAddress = this.getWalletByAddress.bind(this);
        this.getLanguage = this.getLanguage.bind(this);
        this.getLabel = this.getLabel.bind(this);
        this.createLabel = this.createLabel.bind(this);
        this.getLabelsList = this.getLabelsList.bind(this);
        this.asyncCountShared = this.asyncCountShared.bind(this);
        this.asyncLoadLang = this.asyncLoadLang.bind(this);
        this.asyncSetLang = this.asyncSetLang.bind(this);
        this.asyncGetCustomerByEmail = this.asyncGetCustomerByEmail.bind(this);
        this.asyncGetPaymentMethods = this.asyncGetPaymentMethods.bind(this);
        // this.downloadFile = this.downloadFile.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        // this.asyncGetMenu = this.asyncGetMenu.bind(this);
        this.asyncUpdateRight = this.asyncUpdateRight.bind(this);
        this.addNotifySchedule = this.addNotifySchedule.bind(this);
        this.deleteNotifySchedule = this.deleteNotifySchedule.bind(this);
        this.addSchedule = this.addSchedule.bind(this);
        this.deleteSchedule = this.deleteSchedule.bind(this);
    }
    _createClass(APIs, [
        {
            key: "convertModel",
            value: function convertModel(model_name) {
                if (model_name === "dmtk") model_name = "account";
                if (model_name === "dmkh") model_name = "customer";
                if (model_name === "dmnt") model_name = "currency";
                return model_name;
            }
        },
        {
            key: "getLocal",
            value: function getLocal(url, headers, callback) {
                var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var _this = this;
                if (false) {}
                window.ldb.getItem(url, function(error, data) {
                    if (data) {
                        //console.log("get from local",options,data);
                        if (options.stringifyData == false && typeof data !== "object") {
                            try {
                                data = JSON.parse(data);
                            } catch (e) {
                                console.error(e, data);
                                data = undefined;
                            }
                        }
                        _this.get(url, headers, function(error, rs) {
                            if (error) {
                                if (data === undefined) {
                                    callback(error);
                                }
                                return console.error(error);
                            }
                            window.setImmediate(function() {
                                window.ldb.setItem(url, typeof rs == "object" ? JSON.stringify(rs) : rs, function(e) {
                                    if (e) {
                                        window.ldb.removeItem(url);
                                        console.error(e);
                                    }
                                });
                                if (data === undefined) {
                                    callback(null, rs);
                                }
                            });
                        }, {
                            cache: true,
                            stringifyData: options.stringifyData
                        });
                        if (data != undefined) {
                            callback(null, data);
                        }
                    } else {
                        _this.get(url, headers, function(error, rs) {
                            if (error) return callback(error);
                            window.setImmediate(function() {
                                window.ldb.setItem(url, typeof rs == "object" ? JSON.stringify(rs) : rs, function(e) {
                                    if (e) {
                                        window.ldb.removeItem(url);
                                        console.error(e);
                                    }
                                });
                            });
                            callback(null, rs);
                        }, {
                            cache: true,
                            stringifyData: options.stringifyData
                        });
                    }
                });
            }
        },
        {
            key: "get",
            value: function get(url, headers, callback) {
                var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
                    cache: false,
                    stringifyData: true
                };
                var trustkey = this.config.get("trustkey");
                if (trustkey) {
                    if (url.indexOf("?") < 0) {
                        url = url + "?trustkey=" + trustkey;
                    } else {
                        url = url + "&trustkey=" + trustkey;
                    }
                }
                if (cachedData[url] && cachedData[url] != "[]" && cachedData[url] != "{}" && options.cache) {
                    var text = cachedData[url];
                    //console.log("get from cache",options,text)
                    if (options.stringifyData === false && typeof text != "object") {
                        try {
                            text = JSON.parse(text);
                        } catch (e) {
                            console.error(e, text);
                        }
                    }
                    return callback(null, text);
                }
                //let _headers ={"Accept-Encoding":"gzip"};
                var _headers = {
                    uid: getCookie("uid")
                };
                if (headers) {
                    _headers = {};
                    if (Array.isArray(headers)) {
                        headers.forEach(function(h) {
                            _headers[h.name] = h.value;
                        });
                    } else {
                        _headers = Object.assign(_headers, headers);
                    }
                }
                axios/* default.get */.Z.get(url, {
                    headers: _headers
                }).then(function(response) {
                    var text = options.stringifyData != false && typeof response.data === "object" ? JSON.stringify(response.data) : response.data;
                    //set cookies
                    var _uid = getCookie("uid");
                    if (!_uid) {
                        if (!_uid) {
                            _uid = response.headers.get("uid");
                        }
                        if (_uid) {
                            setCookie("uid", _uid, 1);
                        }
                    }
                    callback(null, text);
                    if (options.cache) {
                        if (options.stringifyData == false) {
                            cachedData[url] = response.data;
                        } else {
                            cachedData[url] = typeof response.data === "object" ? JSON.stringify(response.data) : response.data;
                        }
                    }
                }).catch(function(e) {
                    var error = (e.response ? e.response.data : e) || e;
                    //console.error("Error get data:",error);
                    callback(error);
                });
            /*fetch(url,{
      method: 'GET',
      headers: _headers
    }).then( response => {
      response.text().then((text)=>{
        if(response.ok) {
          callback(null,text);
          if(options.cache){
            cachedData[url] = text;
            //console.log("cached data",url);
          } 
        }else{
          console.error("error fetch data",text);
          try{
            if(typeof(text)!=="object"){
              if(text.indexOf("{")===0){
                text = JSON.parse(text)
              }else{
                text ={message:text,code:400}
              }
            }
          }catch(e){
            text ={message:text,code:400}
          }
          if(!text.message){
            text.message = text.error || "Đã có lỗi xảy ra"
          }
          callback(text);
        }
      })
    })
    .catch(e=>callback(e))*/ }
        },
        {
            key: "post",
            value: function post(url, headers, data, callback) {
                var method = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "POST", options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
                    stringifyData: true
                };
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var trustkey, _headers;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                trustkey = _this.config.get("trustkey");
                                if (trustkey) {
                                    if (url.indexOf("?") < 0) {
                                        url = url + "?trustkey=" + trustkey;
                                    } else {
                                        url = url + "&trustkey=" + trustkey;
                                    }
                                }
                                _headers = {
                                    uid: getCookie("uid")
                                };
                                _headers["Content-Type"] = "application/json";
                                //_headers['Content-Encoding']= 'deflate';
                                if (headers) {
                                    if (Array.isArray(headers)) {
                                        headers.forEach(function(h) {
                                            _headers[h.name] = h.value;
                                        });
                                    } else {
                                        _headers = Object.assign(_headers, headers);
                                    }
                                }
                                /*if(!cache_module.zipLib){
      const {default:pako} = await import("pako");
      cache_module.zipLib = pako;
    } 
    let zippedData = cache_module.zipLib.deflate(JSON.stringify(data));*/ (0,axios/* default */.Z)({
                                    method: method.toLowerCase(),
                                    url: url,
                                    data: data,
                                    //data: zippedData,
                                    headers: _headers
                                }).then(function(response) {
                                    //console.log(options.stringifyData,response.data);
                                    var text = options.stringifyData != false && typeof response.data === "object" ? JSON.stringify(response.data) : response.data;
                                    //set cookies
                                    var _uid = getCookie("uid");
                                    if (!_uid) {
                                        if (!_uid) {
                                            _uid = response.headers.get("uid");
                                        }
                                        if (_uid) {
                                            setCookie("uid", _uid, 1);
                                        }
                                    }
                                    callback(null, text, response);
                                }).catch(function(e) {
                                    var error = (e.response ? e.response.data : e) || e;
                                    //console.error("Error get data:",error);
                                    callback(error);
                                });
                            case 6:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "deleteRequest",
            value: function deleteRequest(url, headers, callback) {
                var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
                    stringifyData: true
                };
                var trustkey = this.config.get("trustkey");
                if (trustkey) {
                    if (url.indexOf("?") < 0) {
                        url = url + "?trustkey=" + trustkey;
                    } else {
                        url = url + "&trustkey=" + trustkey;
                    }
                }
                var _headers = {
                    uid: getCookie("uid")
                };
                if (headers) {
                    if (Array.isArray(headers)) {
                        headers.forEach(function(h) {
                            _headers[h.name] = h.value;
                        });
                    } else {
                        _headers = Object.assign(_headers, headers);
                    }
                }
                (0,axios/* default */.Z)({
                    method: "delete",
                    url: url,
                    headers: _headers
                }).then(function(response) {
                    var text = options.stringifyData != false && typeof response.data === "object" ? JSON.stringify(response.data) : response.data;
                    //set cookies
                    var _uid = getCookie("uid");
                    if (!_uid) {
                        if (!_uid) {
                            _uid = response.headers.get("uid");
                        }
                        if (_uid) {
                            setCookie("uid", _uid, 1);
                        }
                    }
                    callback(null, text, response);
                }).catch(function(e) {
                    var error = (e.response ? e.response.data : e) || e;
                    //console.error("Error get data:",error);
                    callback(error);
                });
            }
        },
        {
            key: "asyncGet",
            value: function asyncGet(url, headers) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var p;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                p = new Promise(function(resovle, reject) {
                                    if (options.cache_local) {
                                        _this.getLocal(url, headers, function(e, rs) {
                                            if (e) return reject(e);
                                            resovle(rs);
                                        }, options);
                                    } else {
                                        _this.get(url, headers, function(e, rs) {
                                            if (e) return reject(e);
                                            resovle(rs);
                                        }, options);
                                    }
                                });
                                return _ctx.abrupt("return", p);
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncGetList",
            value: function asyncGetList(access_token, model_name) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var _id_app, rs, url, url1, body;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                options.stringifyData = false;
                                model_name = _this.convertModel(model_name);
                                _id_app = _this.list_not_require_id_app.indexOf(model_name) >= 0 ? "" : options.id_app || (options.condition || {}).id_app || _this.config.get("id_app");
                                ;
                                if (!(options.cache || options.cache_local || !_id_app)) {
                                    _ctx.next = 20;
                                    break;
                                }
                                url = "".concat(_this.config.get("server_url_report"), "/api").concat(_id_app ? "/" + _id_app : "", "/").concat(model_name, "?page=").concat(options.page || 1, "&access_token=").concat(access_token);
                                if (options.query_string) url = "".concat(url, "&").concat(options.query_string);
                                if (options.buildUrl) {
                                    url = options.buildUrl(url);
                                }
                                if (options.sort) url = "".concat(url, "&sort=").concat(JSON.stringify(options.sort));
                                if (options.condition && Object.keys(options.condition).length > 0) {
                                    url = "".concat(url, "&q=").concat(JSON.stringify(options.condition));
                                }
                                if (options.fields) url = "".concat(url, "&fields=").concat(options.fields);
                                if (options.limit) url = "".concat(url, "&limit=").concat(options.limit);
                                if (options.notfields) url = "".concat(url, "&notfields=").concat(options.notfields);
                                if (options.count) url = "".concat(url, "&count=1");
                                if (options.log) {
                                    options.log("fetch: " + url);
                                }
                                _ctx.next = 17;
                                return _this.asyncGet(url, null, options);
                            case 17:
                                rs = _ctx.sent;
                                _ctx.next = 36;
                                break;
                            case 20:
                                url1 = "".concat(_this.config.get("server_url_report"), "/api/search/").concat(_id_app, "/").concat(model_name, "?access_token=").concat(access_token);
                                if (options.query_string) url1 = "".concat(url1, "&").concat(options.query_string);
                                if (options.buildUrl) {
                                    url1 = options.buildUrl(url1);
                                }
                                if (options.log) {
                                    options.log("fetch: " + url1);
                                }
                                body = (0,_object_spread/* default */.Z)({}, options);
                                if (options.condition) body.q = body.condition;
                                delete body.condition;
                                if (!options.count) body.page = body.page || 1;
                                else {
                                    delete body.fields;
                                    delete body.notfields;
                                    delete body.page;
                                    body.count = 1;
                                }
                                delete body.query_string;
                                delete body.buildUrl;
                                delete body.log;
                                delete body.cache_local;
                                delete body.cache;
                                _ctx.next = 35;
                                return _this.asyncPost(url1, null, body, "POST", "GETLIST", false, {
                                    stringifyData: false
                                });
                            case 35:
                                //console.log(url,body);
                                rs = _ctx.sent;
                            case 36:
                                if (rs) {
                                    _ctx.next = 38;
                                    break;
                                }
                                return _ctx.abrupt("return", []);
                            case 38:
                                _ctx.prev = 38;
                                if (!options.fields && !options.count) {
                                    rs.forEach(function(r) {
                                        r.is_full_data = true;
                                    });
                                }
                                return _ctx.abrupt("return", rs);
                            case 43:
                                _ctx.prev = 43;
                                _ctx.t0 = _ctx["catch"](38);
                                console.error(_ctx.t0);
                                throw _ctx.t0;
                            case 47:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            38,
                            43
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "asyncPost",
            value: function asyncPost(url, headers, data) {
                var method = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "POST", action = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "POST", require_recaptcha = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : true, options = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {};
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var config, post;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                config = _this.config;
                                post = _this.post;
                                return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                                    if (config.get("GOOGLE_RECAPTCHA_SITE_KEY") && typeof grecaptcha !== "undefined" && require_recaptcha) {
                                        grecaptcha.ready(function() {
                                            grecaptcha.execute(config.get("GOOGLE_RECAPTCHA_SITE_KEY"), {
                                                action: action
                                            }).then(function(token) {
                                                data["g-recaptcha-response"] = token;
                                                post(url, headers, data, function(e, rs) {
                                                    if (e) return reject(e);
                                                    resolve(rs);
                                                }, method, options);
                                            }, function(e) {
                                                reject({
                                                    message: e || "Lỗi khi tải google recaptcha",
                                                    code: 400
                                                });
                                            });
                                        });
                                    } else {
                                        //console.time(`${method}: ${url}`);
                                        post(url, headers, data, function(e, rs) {
                                            if (e) return reject(e);
                                            //console.timeEnd(`${method}: ${url}`);
                                            resolve(rs);
                                        }, method, options);
                                    }
                                }));
                            case 3:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncPostList",
            value: function asyncPostList(access_token, model_name, data) {
                var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var _id_app, url, method;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                options.stringifyData = false;
                                model_name = _this.convertModel(model_name);
                                _id_app = _this.list_not_require_id_app.indexOf(model_name) >= 0 ? "" : options.id_app || data.id_app || _this.config.get("id_app");
                                url = "".concat(_this.config.get("server_url_report"), "/api").concat(_id_app ? "/" + _id_app : "", "/").concat(model_name);
                                method = "POST";
                                if (data._id) {
                                    url = "".concat(url, "/").concat(data._id);
                                    method = "PUT";
                                } else {
                                    delete data._id;
                                }
                                url = "".concat(url, "?access_token=").concat(access_token);
                                _ctx.next = 9;
                                return _this.asyncPost(url, null, data, method, method, false, options);
                            case 9:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 10:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncDeleteList",
            value: function asyncDeleteList(access_token, model_name, _id) {
                var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var _id_app, url;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                // setImmediate(() => {
                                //   for (let key in cachedData) {
                                //     if (key.indexOf(model_name) >= 0) delete cachedData[key];
                                //   }
                                // });
                                model_name = _this.convertModel(model_name);
                                _id_app = _this.list_not_require_id_app.indexOf(model_name) >= 0 ? "" : options.id_app || _this.config.get("id_app");
                                url = "".concat(_this.config.get("server_url_report"), "/api").concat(_id_app ? "/" + _id_app : "", "/").concat(model_name, "/").concat(_id);
                                url = "".concat(url, "?access_token=").concat(access_token);
                                if (options.otp_id) url = "".concat(url, "&otp-id=").concat(options.otp_id);
                                if (options.otp_code) url = "".concat(url, "&otp-code=").concat(options.otp_code);
                                _ctx.next = 8;
                                return _this.asyncDelete(url);
                            case 8:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 9:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncGetListShared",
            value: function asyncGetListShared(access_token, model_name) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url, rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                options.stringifyData = false;
                                model_name = _this.convertModel(model_name);
                                url = "".concat(_this.config.get("server_url_report"), "/api/").concat(model_name, "/shared?page=").concat(options.page || 1, "&access_token=").concat(access_token);
                                if (options.sort) url = "".concat(url, "&sort=").concat(JSON.stringify(options.sort));
                                if (options.condition && Object.keys(options.condition).length > 0) url = "".concat(url, "&q=").concat(JSON.stringify(options.condition));
                                if (options.limit) url = "".concat(url, "&limit=").concat(options.limit);
                                if (options.fields) url = "".concat(url, "&fields=").concat(options.fields);
                                if (options.notfields) url = "".concat(url, "&notfields=").concat(options.notfields);
                                if (options.count) url = "".concat(url, "&count=1");
                                if (options.log) {
                                    options.log("fetch: " + url);
                                }
                                _ctx.next = 12;
                                return _this.asyncGet(url, null, options);
                            case 12:
                                rs = _ctx.sent;
                                return _ctx.abrupt("return", rs);
                            case 14:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncGetDataById",
            value: function asyncGetDataById(access_token, model_name, id, _id_app) {
                var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url, rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                options.stringifyData = false;
                                if (!_id_app) _id_app = _this.config.get("id_app");
                                model_name = _this.convertModel(model_name);
                                _id_app = _this.list_not_require_id_app.indexOf(model_name) >= 0 ? "" : _id_app + "/";
                                url = "".concat(_this.config.get("server_url_report"), "/api/").concat(_id_app).concat(model_name, "/").concat(id, "?access_token=").concat(access_token);
                                _ctx.next = 7;
                                return _this.asyncGet(url, undefined, options);
                            case 7:
                                rs = _ctx.sent;
                                return _ctx.abrupt("return", rs);
                            case 9:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncGetDataByIdShared",
            value: function asyncGetDataByIdShared(access_token, model_name, id) {
                var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url, rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                options.stringifyData = false;
                                model_name = _this.convertModel(model_name);
                                url = "".concat(_this.config.get("server_url_report"), "/api/").concat(model_name, "/shared/").concat(id, "?access_token=").concat(access_token);
                                _ctx.next = 5;
                                return _this.asyncGet(url, undefined, options);
                            case 5:
                                rs = _ctx.sent;
                                return _ctx.abrupt("return", rs);
                            case 7:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncGetData",
            value: function asyncGetData(access_token, model_name, condition, field) {
                var cache = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, cache_local = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, options = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {};
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return _this.asyncGetList(access_token, model_name, {
                                    id_app: options.id_app || (condition || {}).id_app,
                                    condition: condition,
                                    fields: field,
                                    cache: cache,
                                    cache_local: cache_local,
                                    notfields: "__v"
                                });
                            case 2:
                                rs = _ctx.sent;
                                if (!(rs.length > 0)) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", field ? rs[0][field] : rs[0]);
                            case 7:
                                return _ctx.abrupt("return", null);
                            case 8:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncGetDataShared",
            value: function asyncGetDataShared(access_token, model_name, condition) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return _this.asyncGetListShared(access_token, model_name, {
                                    condition: condition
                                });
                            case 2:
                                rs = _ctx.sent;
                                if (!(rs.length > 0)) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", rs[0]);
                            case 7:
                                return _ctx.abrupt("return", null);
                            case 8:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncGetLogById",
            value: function asyncGetLogById(access_token, model_name, id, _id_app) {
                var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url, rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                options.stringifyData = false;
                                if (!_id_app) _id_app = _this.config.get("id_app");
                                model_name = _this.convertModel(model_name);
                                _id_app = _this.list_not_require_id_app.indexOf(model_name) >= 0 ? "" : _id_app + "/";
                                url = "".concat(_this.config.get("server_url_report"), "/api/").concat(_id_app).concat(model_name, "/g/history/").concat(id, "?access_token=").concat(access_token);
                                _ctx.next = 7;
                                return _this.asyncGet(url, undefined, options);
                            case 7:
                                rs = _ctx.sent;
                                return _ctx.abrupt("return", rs);
                            case 9:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncDelete",
            value: function asyncDelete(url, headers) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var p;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                p = new Promise(function(resovle, reject) {
                                    _this.deleteRequest(url, headers, function(e, rs) {
                                        if (e) return reject(e);
                                        resovle(rs);
                                    });
                                });
                                return _ctx.abrupt("return", p);
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncFiles",
            value: function asyncFiles(access_token, id_link) {
                var _id_app = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", _condition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, limit = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var condition, url, files;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                condition = {
                                    id_link: id_link
                                };
                                condition = Object.assign(condition, _condition);
                                if (!_id_app) _id_app = _this.config.get("id_app");
                                url = "".concat(_this.config.get("server_url_report"), "/api/").concat(_id_app, "/file?q=").concat(JSON.stringify(condition), "&access_token=").concat(access_token);
                                if (limit) url = url + "&limit=" + limit.toString();
                                _ctx.next = 7;
                                return _this.asyncGet(url, null, {
                                    cache: true,
                                    stringifyData: false
                                });
                            case 7:
                                files = _ctx.sent;
                                return _ctx.abrupt("return", files);
                            case 9:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "getLabelsList",
            value: //labels management
            function getLabelsList() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var public_token, condition, url, _rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                console.time("load label list");
                                public_token = _this.config.get("public_token");
                                if (!public_token) public_token = _this.config.get("token");
                                if (public_token) {
                                    _ctx.next = 6;
                                    break;
                                }
                                _this.labels = {};
                                return _ctx.abrupt("return");
                            case 6:
                                condition = {
                                    labelid: _this.config.get("app_code")
                                };
                                url = "".concat(_this.config.get("server_url_report"), "/api/labelinfo?access_token=").concat(public_token, "&q=").concat(JSON.stringify(condition));
                                _ctx.prev = 8;
                                _ctx.next = 11;
                                return _this.asyncGet(url, null, {
                                    cache_local: true,
                                    stringifyData: false
                                });
                            case 11:
                                _rs = _ctx.sent;
                                _this.labels = {};
                                _rs.forEach(function(r) {
                                    _this.labels[r.textid] = r;
                                });
                                console.timeEnd("load label list");
                                _ctx.next = 20;
                                break;
                            case 17:
                                _ctx.prev = 17;
                                _ctx.t0 = _ctx["catch"](8);
                                console.log("can't get labels list", _ctx.t0);
                            case 20:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            8,
                            17
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "createLabel",
            value: function createLabel(condition) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var token, url;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                if (_this.labels) {
                                    _ctx.next = 2;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 2:
                                token = _this.config.get("token");
                                if (token) {
                                    _ctx.next = 5;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 5:
                                url = "".concat(_this.config.get("server_url_report"), "/api/labelinfo?access_token=").concat(token);
                                _ctx.prev = 6;
                                _ctx.next = 9;
                                return _this.asyncPost(url, null, condition, "POST", "createLabel");
                            case 9:
                                _this.labels[condition.textid] = condition;
                                _ctx.next = 14;
                                break;
                            case 12:
                                _ctx.prev = 12;
                                _ctx.t0 = _ctx["catch"](6);
                            case 14:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            6,
                            12
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "asyncLoadLang",
            value: function asyncLoadLang() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                try {
                                    _this.lang = localStorage.getItem("lang");
                                } catch (e) {
                                    _this.lang = "vi";
                                }
                                try {
                                    if (!_this.lang) _this.lang = "vi";
                                } catch (e1) {
                                    _this.lang = "vi";
                                }
                                return _ctx.abrupt("return", _this.lang);
                            case 3:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncSetLang",
            value: function asyncSetLang(_lang) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _this.lang = _lang;
                                try {
                                    (0,utils_localStorage/* setToStorage */.Pp)("lang", _lang);
                                } catch (e) {
                                    if (e) console.error(e);
                                }
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "getLanguage",
            value: function getLanguage() {
                return this.lang;
            }
        },
        {
            key: "getLabel",
            value: function getLabel(textid) {
                var defaultv = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", defaulte = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", lang = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
                if (!textid) return "";
                var _default, field;
                if (!lang) lang = this.getLanguage();
                if (lang === "vi") {
                    _default = defaultv || defaulte || textid;
                    field = "textv";
                } else {
                    _default = defaulte || defaultv || textid;
                    field = "texte";
                }
                try {
                    var _label;
                    if (this.labels && this.labels[textid.toUpperCase()]) {
                        _label = this.labels[textid.toUpperCase()][field];
                    }
                    if (!_label) {
                        _label = _default || textid;
                        //create label default
                        var condition = {
                            labelid: this.config.get("app_code"),
                            textid: textid.toUpperCase()
                        };
                        condition.texte = defaulte || defaultv || textid;
                        condition.textv = defaultv || defaulte || textid;
                    // setImmediate(() => {
                    //   this.createLabel(condition);
                    // });
                    }
                    return _label || "";
                } catch (e) {
                    console.log("error get label", e);
                    return _default || textid || "";
                }
            }
        },
        {
            key: "asyncCountShared",
            value: function asyncCountShared(access_token, condition, model_name) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var countFloor;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                _ctx.next = 3;
                                return _this.asyncGetListShared(access_token, model_name, {
                                    condition: condition,
                                    count: 1
                                });
                            case 3:
                                countFloor = _ctx.sent;
                                countFloor.condition = condition;
                                return _ctx.abrupt("return", countFloor);
                            case 8:
                                _ctx.prev = 8;
                                _ctx.t0 = _ctx["catch"](0);
                                _ctx.t0.condition = condition;
                                return _ctx.abrupt("return", _ctx.t0);
                            case 12:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            8
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "getUserInfoByToken",
            value: function getUserInfoByToken(token, callback) {
                var url = this.config.get("server_url_report") + "/api/user?access_token=" + token;
                this.get(url, null, function(error, rs) {
                    if (error) return callback(error);
                    var userInfo = JSON.parse(rs);
                    //get app info
                    callback(null, userInfo);
                }, {
                    cache_local: true
                });
            }
        },
        {
            key: "asyncGetUserInfoByToken",
            value: function asyncGetUserInfoByToken(token) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url, rs, userInfo;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                if (token) {
                                    _ctx.next = 10;
                                    break;
                                }
                                _ctx.prev = 1;
                                _ctx.next = 4;
                                return localStorage.getItem("token");
                            case 4:
                                token = _ctx.sent;
                                _ctx.next = 10;
                                break;
                            case 7:
                                _ctx.prev = 7;
                                _ctx.t0 = _ctx["catch"](1);
                                if (_ctx.t0) console.error(_ctx.t0);
                            case 10:
                                if (token) {
                                    _ctx.next = 12;
                                    break;
                                }
                                return _ctx.abrupt("return", null);
                            case 12:
                                url = _this.config.server_url_report + "/api/user?access_token=" + token;
                                _ctx.next = 15;
                                return _this.asyncGet(url, null, {
                                    cache: true,
                                    cache_local: true
                                });
                            case 15:
                                rs = _ctx.sent;
                                userInfo = JSON.parse(rs);
                                return _ctx.abrupt("return", userInfo);
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            7
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "asyncGetProfile",
            value: function asyncGetProfile(token, userName) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
                    cache: true,
                    cache_local: true
                };
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url, rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                options.stringifyData = false;
                                url = _this.config.server_url_report + "/api/profile?access_token=" + token + "&email=" + userName;
                                _ctx.next = 4;
                                return _this.asyncGet(url, null, options);
                            case 4:
                                rs = _ctx.sent;
                                return _ctx.abrupt("return", rs);
                            case 6:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncGetAppInfo",
            value: function asyncGetAppInfo(token) {
                var _id_app = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", fields = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
                    cache: true,
                    cache_local: true
                };
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url, rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                // if (!_id_app) _id_app = this.config.get("id_app");
                                options.stringifyData = false;
                                url = _this.config.server_url_report + "/api/app/" + _id_app + "?access_token=" + token;
                                _ctx.next = 4;
                                return _this.asyncGet(url, null, options);
                            case 4:
                                rs = _ctx.sent;
                                return _ctx.abrupt("return", rs);
                            case 6:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            // async asyncGetReport(
            //   token,
            //   report,
            //   condition = {},
            //   options = { cache: true }
            // ) {
            //   const { default: moment } = await import("moment");
            //   const id_app = this.config.get("id_app");
            //   let url =
            //     this.config.get("server_url_report") +
            //     "/api/" +
            //     id_app +
            //     "/" +
            //     report +
            //     "?access_token=" +
            //     token;
            //   for (let key in condition) {
            //     if (condition[key]) {
            //       let c = condition[key];
            //       if (c.getTime) {
            //         c = moment(c).format("YYYY-MM-DD");
            //       }
            //       url = `${url}&${key}=${c}`;
            //     }
            //   }
            //   options.stringifyData = false;
            //   let rs = await this.asyncGet(url, null, options);
            //   return rs;
            // }
            key: "loginAPI",
            value: function loginAPI(username, password, callback) {
                var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var _this = this;
                if (!options.id_app) options.id_app = this.config.get("id_app");
                if (!options.group_id) options.group_id = this.config.get("group_id");
                var url = this.config.get("server_url_report") + "/auth/local";
                if (options.id_app && options.group_id) {
                    url = "".concat(url, "?id_app=").concat(options.id_app, "&group_id=").concat(options.group_id);
                }
                if (options.once) {
                    url = "".concat(url, "&once=1");
                }
                var Authorization = "Basic " + buffer/* Buffer.from */.lW.from(username + ":" + password).toString("base64");
                this.get(url, [
                    {
                        name: "Authorization",
                        value: Authorization
                    }
                ], function(error, token) {
                    if (error) {
                        console.log(error);
                        try {
                            error = JSON.parse(error);
                            return callback(error);
                        } catch (e) {
                            return callback(error);
                        }
                    }
                    try {
                        token = JSON.parse(token);
                        token = token.token;
                    } catch (e1) {
                        token = JSON.parse(token);
                    }
                    if (!options.once) {
                        _this.getUserInfoByToken(token, function(error, userInfo) {
                            if (error) {
                                return callback(error);
                            }
                            userInfo.token = token;
                            callback(null, userInfo);
                        });
                    } else {
                        callback(null, {
                            token: token
                        });
                    }
                });
            }
        },
        {
            key: "asyncLoginAPI",
            value: function asyncLoginAPI(username, password, options) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                                    _this.loginAPI(username, password, function(e, rs) {
                                        if (e) return reject(e);
                                        resolve(rs);
                                    }, options);
                                }));
                            case 1:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncLoginSms",
            value: function asyncLoginSms(phone) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url, self;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                url = _this.config.get("server_url_report") + "/send-otp/".concat(phone);
                                self = _this;
                                return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                                    grecaptcha.ready(function() {
                                        grecaptcha.execute(self.config.get("GOOGLE_RECAPTCHA_SITE_KEY"), {
                                            action: "SENDOTP"
                                        }).then(function(token) {
                                            url = "".concat(url, "?g-recaptcha-response=").concat(token);
                                            self.asyncGet(url).then(function(rs) {
                                                resolve(rs);
                                            }).catch(function(e) {
                                                reject(e);
                                            });
                                        }, function(e) {
                                            reject({
                                                message: e || "Lỗi khi tải google recaptcha",
                                                code: 400
                                            });
                                        });
                                    });
                                }));
                            case 3:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncLoginSmsVerify",
            value: function asyncLoginSmsVerify(id, otp) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url, token;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                url = _this.config.get("server_url_report") + "/verify-otp/".concat(id, "/").concat(otp);
                                if (!options.id_app) options.id_app = _this.config.get("id_app");
                                if (!options.group_id) options.group_id = _this.config.get("group_id");
                                if (options.id_app && options.group_id) {
                                    url = "".concat(url, "?id_app=").concat(options.id_app, "&group_id=").concat(options.group_id);
                                }
                                if (options.once) {
                                    url = "".concat(url, "&once=1");
                                }
                                _ctx.next = 7;
                                return _this.asyncGet(url);
                            case 7:
                                token = _ctx.sent;
                                try {
                                    token = JSON.parse(token);
                                    token = token.token;
                                } catch (e) {
                                    token = JSON.parse(token);
                                }
                                return _ctx.abrupt("return", token);
                            case 10:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                // let userInfo = {};
                // if (!options.once) {
                //   userInfo = await this.asyncGetUserInfoByToken(token);
                // }
                // userInfo.token = token;
                // return userInfo;
                }))();
            }
        },
        {
            key: "asyncSign",
            value: function asyncSign(username, password, data) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url, Authorization;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                url = _this.config.get("server_url_report") + "/auth/sign";
                                Authorization = "Basic " + buffer/* Buffer.from */.lW.from(username + ":" + password).toString("base64");
                                _ctx.next = 4;
                                return _this.asyncPost(url, [
                                    {
                                        name: "Authorization",
                                        value: Authorization
                                    }
                                ], data, "POST", "POST", false);
                            case 4:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 5:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "removeEndpoint",
            value: function removeEndpoint(userInfo, callback) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                if (endpoint) {
                                    url = _this.config.get("server_url_report") + "/api/remove-endpoint?access_token=" + userInfo.token + "&ep=" + endpoint;
                                    _this.get(url, null, function(error) {
                                        callback(error);
                                    });
                                } else {
                                    callback();
                                }
                            case 1:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "logoutAPI",
            value: function logoutAPI(userInfo, callback) {
                var _this = this;
                this.removeEndpoint(userInfo, function(error) {
                    if (error) return callback(error);
                    var url = _this.config.get("server_url_report") + "/api/user/logout?access_token=" + userInfo.token;
                    if (endpoint) url = url + "&ep=" + endpoint;
                    _this.get(url, null, function(error, rs) {
                        if (error) return callback(error);
                        //clear cache
                        for(var i = 0; i < localStorage.length; i++){
                            var key = localStorage.key(i);
                            if (key.indexOf("labelinfo") < 0 && key.indexOf("listinfo") < 0 && key.indexOf("reportinfo") < 0) {
                                localStorage.removeItem(key);
                            }
                        }
                        callback(null, rs);
                    });
                });
            }
        },
        {
            key: "asyncLogoutAPI",
            value: function asyncLogoutAPI(userInfo) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                                    _this.logoutAPI(userInfo, function(e, rs) {
                                        if (e) return reject(e);
                                        resolve(rs);
                                    });
                                }));
                            case 1:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "signup",
            value: function signup(data, callback, _id_app) {
                var _this = this;
                var config = this.config;
                if (!_id_app) _id_app = config.get("id_app");
                var group_id = this.config.get("group_id");
                if (config.get("GOOGLE_RECAPTCHA_SITE_KEY") && typeof grecaptcha !== "undefined") {
                    grecaptcha.ready(function() {
                        grecaptcha.execute(config.get("GOOGLE_RECAPTCHA_SITE_KEY"), {
                            action: "signup"
                        }).then(function(token) {
                            var url = config.get("server_url_report") + "/signup";
                            data.group_id = group_id;
                            data.id_app = _id_app;
                            data["g-recaptcha-response"] = token;
                            _this.post(url, null, data, function(e, rs) {
                                if (e) return callback(e);
                                callback(null, rs);
                            });
                        }, function(error) {
                            //console.error("google recaptcha",error,GOOGLE_RECAPTCHA_SITE_KEY);
                            callback({
                                message: error || "Lỗi khi tải google recaptcha",
                                code: 400
                            });
                        });
                    });
                } else {
                    var url = config.get("server_url_report") + "/signup";
                    data.group_id = group_id;
                    data.id_app = _id_app;
                    _this.post(url, null, data, function(e, rs) {
                        if (e) return callback(e);
                        callback(null, rs);
                    });
                }
            }
        },
        {
            key: "asyncSignup",
            value: function asyncSignup(data) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var _this1;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _this1 = _this;
                                return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                                    _this1.signup(data, function(e, rs) {
                                        if (e) {
                                            return reject(e);
                                        }
                                        resolve(rs);
                                    });
                                }));
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncResetPassword",
            value: function asyncResetPassword(email) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var config, asyncGet, url, rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                config = _this.config;
                                asyncGet = _this.asyncGet;
                                if (!(config.get("GOOGLE_RECAPTCHA_SITE_KEY") && typeof grecaptcha !== "undefined")) {
                                    _ctx.next = 8;
                                    break;
                                }
                                _ctx.next = 5;
                                return new Promise(function(resolve, reject) {
                                    grecaptcha.ready(function() {
                                        grecaptcha.execute(config.get("GOOGLE_RECAPTCHA_SITE_KEY"), {
                                            action: "resetPassword"
                                        }).then(function() {
                                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_token_captcha) {
                                                var url, rs;
                                                return runtime_default().wrap(function _callee$(_ctx) {
                                                    while(1)switch(_ctx.prev = _ctx.next){
                                                        case 0:
                                                            url = "".concat(config.get("server_url_report"), "/resetpassword?email=").concat(email, "&g-recaptcha-response=").concat(_token_captcha);
                                                            _ctx.next = 3;
                                                            return asyncGet(url);
                                                        case 3:
                                                            rs = _ctx.sent;
                                                            resolve(rs);
                                                        case 5:
                                                        case "end":
                                                            return _ctx.stop();
                                                    }
                                                }, _callee);
                                            }));
                                            return function(_token_captcha) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }(), function(error) {
                                            //console.error("google recaptcha",error,GOOGLE_RECAPTCHA_SITE_KEY);
                                            reject({
                                                message: error || "Lỗi khi tải google recaptcha",
                                                code: 400
                                            });
                                        });
                                    });
                                });
                            case 5:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 8:
                                url = "".concat(config.get("server_url_report"), "/resetpassword?email=").concat(email);
                                _ctx.next = 11;
                                return asyncGet(url);
                            case 11:
                                rs = _ctx.sent;
                                return _ctx.abrupt("return", rs);
                            case 13:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncChangePasswordByAdmin",
            value: function asyncChangePasswordByAdmin(token, passwords) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url, rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                url = "".concat(_this.config.get("server_url_report"), "/api/changepasswordByAdmin?access_token=").concat(token);
                                _ctx.next = 3;
                                return _this.asyncPost(url, null, passwords, "POST", "changePasswordByAdmin");
                            case 3:
                                rs = _ctx.sent;
                                return _ctx.abrupt("return", rs);
                            case 5:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncChangePassword",
            value: function asyncChangePassword(token, passwords) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url, rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                url = "".concat(_this.config.get("server_url_report"), "/api/changepassword?access_token=").concat(token);
                                _ctx.next = 3;
                                return _this.asyncPost(url, null, passwords, "POST", "changePassword");
                            case 3:
                                rs = _ctx.sent;
                                return _ctx.abrupt("return", rs);
                            case 5:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncGetCustomerByEmail",
            value: function asyncGetCustomerByEmail(access_token, email, fields, _id_app) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var condition, url, rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                if (!_id_app) _id_app = _this.config.get("id_app");
                                condition = {
                                    of_user: email
                                };
                                url = "".concat(_this.config.get("server_url_report"), "/api/").concat(_id_app, "/customer?q=").concat(JSON.stringify(condition), "&access_token=").concat(access_token);
                                if (fields) {
                                    url = url + "&fields=" + fields;
                                }
                                _ctx.next = 6;
                                return _this.asyncGet(url);
                            case 6:
                                rs = _ctx.sent;
                                rs = JSON.parse(rs);
                                if (!(rs.length > 0)) {
                                    _ctx.next = 12;
                                    break;
                                }
                                return _ctx.abrupt("return", rs[0]);
                            case 12:
                                throw new Error("Not found customer for user ".concat(email));
                            case 13:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncGetPaymentMethods",
            value: function asyncGetPaymentMethods(access_token, _id_app) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var condition, url, rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                if (!_id_app) _id_app = _this.config.get("id_app");
                                condition = {
                                    status: true,
                                    hinh_thuc: {
                                        $in: [
                                            1,
                                            2,
                                            undefined
                                        ]
                                    }
                                };
                                url = "".concat(_this.config.get("server_url_report"), "/api/").concat(_id_app, "/ptthanhtoan?access_token=").concat(access_token, "&q=").concat(JSON.stringify(condition));
                                _ctx.next = 5;
                                return _this.asyncGet(url);
                            case 5:
                                rs = _ctx.sent;
                                return _ctx.abrupt("return", JSON.parse(rs).map(function(r) {
                                    r.key = r._id;
                                    return r;
                                }));
                            case 7:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "getWalletByAddress",
            value: function getWalletByAddress(address, access_token) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var condition, url, rs;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                condition = {
                                    address: address
                                };
                                url = "".concat(_this.config.get("server_url_report"), "/api/asskey?q=").concat(JSON.stringify(condition), "&access_token=").concat(access_token);
                                _ctx.t0 = JSON;
                                _ctx.next = 5;
                                return _this.asyncGet(url);
                            case 5:
                                _ctx.t1 = _ctx.sent;
                                rs = _ctx.t0.parse.call(_ctx.t0, _ctx.t1);
                                if (!(rs.length === 1)) {
                                    _ctx.next = 9;
                                    break;
                                }
                                return _ctx.abrupt("return", rs[0]);
                            case 9:
                                return _ctx.abrupt("return", null);
                            case 10:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            // downloadFile(url, name, callback) {
            //   let trustkey = this.config.get("trustkey");
            //   if (trustkey) {
            //     if (url.indexOf("?") < 0) {
            //       url = url + "?trustkey=" + trustkey;
            //     } else {
            //       url = url + "&trustkey=" + trustkey;
            //     }
            //   }
            //   const req = new XMLHttpRequest();
            //   req.open("GET", url, true);
            //   req.responseType = "arraybuffer";
            //   req.onload = function () {
            //     const resp = req.response;
            //     if (resp) {
            //       if (req.status === 200) {
            //         const blob = new Blob([resp]);
            //         if (!name) name = "file";
            //         saveAs(blob, name);
            //         if (callback) callback();
            //       } else {
            //         if (callback) {
            //           let error = new TextDecoder("utf-8").decode(resp);
            //           if (error.indexOf("{") >= 0 && error.indexOf("}") >= 0) {
            //             try {
            //               error = JSON.parse(error);
            //             } catch (e) {}
            //           }
            //           callback(
            //             error || { error: "Không thể kết nối với máy chủ. Hãy thử lại." }
            //           );
            //         }
            //       }
            //     }
            //   };
            //   req.send(null);
            // }
            key: "uploadFile",
            value: function uploadFile(url, fileRaw) {
                var callback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {}, data = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var trustkey = this.config.get("trustkey");
                if (trustkey) {
                    if (url.indexOf("?") < 0) {
                        url = url + "?trustkey=" + trustkey;
                    } else {
                        url = url + "&trustkey=" + trustkey;
                    }
                }
                data.return = "JSON";
                data[data.name || "fileupload"] = fileRaw;
                var formData = new FormData();
                for(var key in data){
                    formData.append(key, data[key]);
                }
                (0,axios/* default */.Z)({
                    method: "post",
                    url: url,
                    data: formData,
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "uid": getCookie("uid")
                    }
                }).then(function(response) {
                    var text = typeof response.data == "object" ? JSON.stringify(response.data) : response.data;
                    //set cookies
                    var _uid = getCookie("uid");
                    if (!_uid) {
                        if (!_uid) {
                            _uid = response.headers.get("uid");
                        }
                        if (_uid) {
                            setCookie("uid", _uid, 1);
                        }
                    }
                    callback(null, text, response);
                }).catch(function(e) {
                    var error = (e.response ? e.response.data : e) || e;
                    //console.error("Error get data:",error);
                    callback(error);
                });
            /*fetch(url, {method: "POST", body: formData}).then( response => {
      response.text().then((text)=>{
        if(response.ok) {
          callback(null,text);
        }else{
          try{
            if(typeof(text)!=="object"){
              if(text.indexOf("{")===0){
                text = JSON.parse(text)
              }else{
                text ={message:text,code:400}
              }
            }
          }catch(e){
            text ={message:text,code:400}
          }
          if(text.error && !text.message){
            text.message = text.error;
          }
          callback(text);
        }
      })
    })
    .catch(e=>callback(e))*/ }
        },
        {
            key: "asyncUpdateRight",
            value: // async asyncGetMenu(userInfo, group, id_app, log = () => {}, cache = true) {
            //   if (!id_app) id_app = this.config.get("id_app");
            //   let system_code = this.config.get("system_code");
            //   const menu = this.config.get("menu");
            //   let token;
            //   if (isObject(userInfo)) {
            //     token = userInfo.token;
            //   } else {
            //     token = userInfo;
            //   }
            //   if (!token) return [];
            //   let extra_funcs = [];
            //   //get menu on server
            //   if (system_code && !this.config.get("only_use_menu_local")) {
            //     log("Get module info:" + system_code);
            //     let condition = { app: system_code };
            //     let modules = await this.asyncGetList(token, "moduleinfo", {
            //       condition: condition,
            //       cache: cache,
            //       cache_local: cache,
            //     });
            //     modules = modules.filter((m) => {
            //       if (
            //         m.only_for_companies &&
            //         m.only_for_companies.length > 0 &&
            //         m.only_for_companies.indexOf(id_app) < 0
            //       ) {
            //         return false;
            //       }
            //       if (
            //         m.not_for_companies &&
            //         m.not_for_companies.length > 0 &&
            //         m.not_for_companies.indexOf(id_app) >= 0
            //       ) {
            //         return false;
            //       }
            //       return true;
            //     });
            //     extra_funcs = modules
            //       .map((m) => {
            //         return (m.items || []).map((item) => {
            //           delete item._id;
            //           item.group = m.title;
            //           item.group_code = item.active_require ? item.code : "";
            //           item.stt_module = m.stt;
            //           item.mother_module = m.mother_module;
            //           item.name_mother_module = m.name_mother_module;
            //           if (
            //             item.type &&
            //             !item.path &&
            //             !item.url &&
            //             item.type.toLowerCase() !== "other"
            //           ) {
            //             item.path = "/" + item.type.toLowerCase() + "/" + item.code;
            //           }
            //           return item;
            //         });
            //       })
            //       .reduce((a, b) => a.concat(b), []);
            //   }
            //   let _menu = cloneDeep(menu).filter((item) => {
            //     return !extra_funcs.find(
            //       (i) => i.code === item.code && i.group === item.group
            //     );
            //   });
            //   _menu.forEach((item) => {
            //     item.stt_module = item.stt_module || 9999;
            //     item.stt = item.stt || 0;
            //   });
            //   _menu = [...extra_funcs, ..._menu];
            //   _menu = _menu.sort((a, b) => a.stt_module - b.stt_module);
            //   //get api_code
            //   log("Get custom list apis");
            //   let listinfos = await this.asyncGetList(token, "listinfo", {
            //     cache: cache,
            //     cache_local: cache,
            //     condition: {
            //       create_model: true,
            //       api_code: { $nin: ["", null, undefined] },
            //     },
            //     fields: "code,api_code",
            //   });
            //   log("Get custom report apis");
            //   let reportInfos = await this.asyncGetList(token, "reportinfo", {
            //     cache: cache,
            //     cache_local: cache,
            //     condition: { api_code: { $nin: ["", null, undefined] } },
            //     fields: "code,api_code",
            //   });
            //   log("handle api code");
            //   _menu.forEach((item) => {
            //     let linfo = listinfos.find((l) => {
            //       return l.code === item.code;
            //     });
            //     if (!linfo) {
            //       linfo = reportInfos.find((l) => {
            //         return l.code === item.code;
            //       });
            //     }
            //     if (linfo) {
            //       item.api_code = linfo.api_code || item.code;
            //     } else {
            //       item.api_code = item.code;
            //     }
            //   });
            //   //
            //   if (!group) {
            //     if (!userInfo.email) {
            //       log("get user info");
            //       userInfo = await this.asyncGetUserInfoByToken(token);
            //     }
            //     log("get app info");
            //     const p = await this.asyncGetAppInfo(token, id_app, "name");
            //     if (!p) {
            //       console.error("company is not exists");
            //       return [];
            //     }
            //     if (p.appAdmin) {
            //       return (_menu || []).map((item) => {
            //         let _item = { ...item };
            //         _item.view = true;
            //         _item.viewOfOther = true;
            //         _item.add = true;
            //         _item.update = true;
            //         _item.delete = true;
            //         return _item;
            //       });
            //     } else {
            //       group = p.group_id;
            //     }
            //   }
            //   if (!group) return [];
            //   log("get rights");
            //   const rights = await this.asyncGetList(token, "right", {
            //     cache: cache,
            //     cache_local: cache,
            //     condition: { email: group },
            //     limit: 90000,
            //   });
            //   return (_menu || []).map((item) => {
            //     let _item = { ...item };
            //     let _right = rights.filter(
            //       (r) => r.module === _item.api_code.toLowerCase()
            //     );
            //     if (_right.length > 0) {
            //       if (_right.length > 1)
            //         console.log("error multi record", _item.api_code, _right);
            //       _item = { ..._item, ..._right[0] };
            //     } else {
            //       _item.view = false;
            //       _item.viewOfOther = false;
            //       _item.add = false;
            //       _item.update = false;
            //       _item.delete = false;
            //     }
            //     return _item;
            //   });
            // }
            function asyncUpdateRight(token, value) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var data;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                data = Object.assign({}, value);
                                return _ctx.abrupt("return", _this.asyncPostList(token, "right", data));
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncJoinApp",
            value: function asyncJoinApp(token, id_app, group_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                url = "".concat(_this.config.get("server_url_report"), "/api/app/join/").concat(id_app, "/").concat(group_id, "?access_token=").concat(token);
                                return _ctx.abrupt("return", _this.asyncGet(url));
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncBackup",
            value: /***
   * Backup data of a company
   */ function asyncBackup(token, id_app, callback) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                url = "".concat(_this.config.get("server_url_report"), "/api/app/backup/").concat(id_app, "?access_token=").concat(token);
                                _this.downloadFile(url, "backup.zip", callback);
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "asyncRestore",
            value: /***
   * restore data of a company
   */ function asyncRestore(token, id_app, fileRaw) {
                var callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {}, data = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url, formData, key;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                url = "".concat(_this.config.get("server_url_report"), "/api/app/restore/").concat(id_app, "?access_token=").concat(token);
                                data.return = "JSON";
                                data["backup"] = fileRaw;
                                formData = new FormData();
                                for(key in data){
                                    formData.append(key, data[key]);
                                }
                                (0,axios/* default */.Z)({
                                    method: "post",
                                    url: url,
                                    data: formData,
                                    headers: {
                                        "Content-Type": "multipart/form-data",
                                        "uid": getCookie("uid")
                                    }
                                }).then(function(response) {
                                    var text = typeof response.data == "object" ? JSON.stringify(response.data) : response.data;
                                    //set cookies
                                    var _uid = getCookie("uid");
                                    if (!_uid) {
                                        if (!_uid) {
                                            _uid = response.headers.get("uid");
                                        }
                                        if (_uid) {
                                            setCookie("uid", _uid, 1);
                                        }
                                    }
                                    callback(null, text, response);
                                }).catch(function(e) {
                                    var error = (e.response ? e.response.data : e) || e;
                                    //console.error("Error get data:",error);
                                    callback(error);
                                });
                            case 6:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                /*fetch(url, {method: "POST", body: formData}).then( response => {
      response.text().then((text)=>{
        if(response.ok) {
          callback(null,text);
        }else{
          try{
            if(typeof(text)!=="object"){
              if(text.indexOf("{")===0){
                text = JSON.parse(text)
              }else{
                text ={message:text,code:400}
              }
            }
          }catch(e){
            text ={message:text,code:400}
          }
          if(text.error && !text.message){
            text.message = text.error;
          }
          callback(text);
        }
      })
    })
    .catch(e=>callback(e))*/ }))();
            }
        },
        {
            key: "addNotifySchedule",
            value: /***
   * data require fields:_id,code,time_run,users_will_receive,title,repeat(option),finish_run(option)
   */ function addNotifySchedule(token, data) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                data.id_app = _this.config.get("id_app");
                                url = "".concat(_this.config.get("server_url_report"), "/api/schedule/add/notify?access_token=").concat(token);
                                return _ctx.abrupt("return", _this.asyncPost(url, null, data, "POST", "POST", false));
                            case 3:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "deleteNotifySchedule",
            value: function deleteNotifySchedule(token, id_link) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                url = "".concat(_this.config.get("server_url_report"), "/api/schedule/delete/").concat(id_link, "?access_token=").concat(token);
                                return _ctx.abrupt("return", _this.asyncGet(url));
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "addSchedule",
            value: /***
   * data require fields:time_run,data._id,data.id_app,data.module
   */ function addSchedule(type, token, data) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                data.id_app = _this.config.get("id_app");
                                url = "".concat(_this.config.get("server_url_report"), "/api/schedule/add/").concat(type, "?access_token=").concat(token);
                                return _ctx.abrupt("return", _this.asyncPost(url, null, data, "POST", "POST", false));
                            case 3:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "deleteSchedule",
            value: function deleteSchedule(token, id_link) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var url;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                url = "".concat(_this.config.get("server_url_report"), "/api/schedule/delete/").concat(id_link, "?access_token=").concat(token);
                                return _ctx.abrupt("return", _this.asyncGet(url));
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        }
    ]);
    return APIs;
}();


// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-set-state/use-set-state.js
var use_set_state = __webpack_require__(73946);
// EXTERNAL MODULE: ./setup/mantine-provider/notifications.js
var notifications = __webpack_require__(97744);
;// CONCATENATED MODULE: ./setup/flexbiz-api-provider/index.js
/* provided dependency */ var process = __webpack_require__(34406);






// import openSocket from "socket.io-client";




// import { EmitEvents } from "./utils";
// let socket;
var APIContext = /*#__PURE__*/ react.createContext();
var useApiContext = function() {
    return react.useContext(APIContext);
};
var loaded_configs = {
    server_url_report: "https://api.flexzen.app",
    server_url: "https://api.flexzen.app",
    GOOGLE_RECAPTCHA_SITE_KEY: "6Lf25qEUAAAAAFHwh_XZw-YY6HXTdyv2xEp9AHbt",
    id_app: "615fa1791fc31763c7253668",
    group_id: "6340e15b624f2e7c84da50e6",
    trustkey: "APP.FKJSHHHH908KJF",
    system_code: process.env.system_code,
    public_token: "flex.public.token",
    app_code: "Zemor_Website",
    again_link: "/#/checkout-alert"
};
var APIProvider = function(param) {
    var children = param.children;
    var initSocket = function initSocket(user) {
    // socket = EmitEvents.socket.socket;
    // if (socket) {
    //   try {
    //     socket.close();
    //   } catch (e) {
    //     console.error(e.message);
    //   }
    // }
    // if (!user) return;
    // console.log("socket connecting");
    // EmitEvents.socket.socket = socket = openSocket(config.server_url);
    // socket.on("connect", function () {
    //   console.log("socket Connected");
    //   socket.emit("login", {
    //     token: user.token,
    //     email: user.email,
    //   });
    // });
    // socket.io.on("reconnect", function () {
    //   console.log("socket reconnected");
    //   socket.emit("login", {
    //     token: user.token,
    //     email: user.email,
    //   });
    // });
    // socket.io.on("reconnect_error", function () {
    //   console.error("socket reconnect error");
    // });
    // socket.io.on("reconnect_failed", function () {
    //   console.error("socket reconnect failed");
    // });
    // socket.on("disconnect", function () {
    //   console.error("socket disconnected");
    // });
    // socket.on("connect_error", function () {
    //   console.error("socket connect error");
    // });
    // socket.on("connect_timeout", (timeout) => {
    //   console.error("socket connect timeout", timeout);
    // });
    // socket.on("login", () => {
    //   console.log("Socket logined");
    // });
    // socket.on("notify:count", function (data) {
    //   EmitEvents.dispatch("notify:count", data);
    // });
    // socket.on("notify:new", function (data) {
    //   EmitEvents.dispatch("notify:new", data);
    // });
    };
    var setProgressStatus = // eslint-disable-next-line no-unused-vars
    // function registerSocketEvents(socket, user) {
    //   //pbl event
    //   socket.on("pbl:payment", function (data) {
    //     //console.log("event pbl:payment",data)
    //     EmitEvents.dispatch("pbl:payment", data);
    //   });
    //   socket.on("pbl:update", function (data) {
    //     //console.log("event pbl:update",data)
    //     EmitEvents.dispatch("pbl:update", data);
    //   });
    //   socket.on("pbl:new", function (data) {
    //     //console.log("event pbl:new",data)
    //     EmitEvents.dispatch("pbl:new", data);
    //   });
    //   socket.on("pbl:delete", function (data) {
    //     //console.log("event so1:new",data)
    //     EmitEvents.dispatch("so1:delete", data);
    //   });
    // }
    // async function registerEndpoint(user) {
    //   let endpoint = endpoint;
    //   // eslint-disable-next-line no-undef
    //   if (!endpoint) return;
    //   //console.log("register endpoint for user",user?user.email:'public',"...");
    //   let url = `${config.server_url}/api/register-endpoint?access_token=${
    //     user ? user.token : config.public_token
    //     // eslint-disable-next-line no-undef
    //   }&ep=${encodeURIComponent(endpoint)}`;
    //   try {
    //     await apis.asyncGet(url);
    //   } catch (e) {
    //     console.log(e);
    //   }
    // }
    function setProgressStatus(status, callback, title) {
    // setState({ progressStatus: status });
    };
    var alert = function alert(message, callback) {
        var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "info";
        (0,notifications/* appAlert */.t)({
            type: "info",
            message: message,
            onClose: callback
        });
    };
    var prompt = function prompt(title, default_value, callback, options) {};
    var toast = function toast(message) {
        (0,notifications/* appAlert */.t)({
            type: "info",
            message: message
        });
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_set_state/* useSetState */.v)({
        userInfo: null,
        appInfo: null,
        config: loaded_configs || {},
        apis: new APIs(loaded_configs) || {},
        token: null,
        progressStatus: false
    }), 2), ref1 = ref[0], userInfo = ref1.userInfo, appInfo = ref1.appInfo, config = ref1.config, apis = ref1.apis, token = ref1.token, setState = ref[1];
    (0,react.useEffect)(function() {
        var token;
        // const params = queryString.parse(window.location.search);
        // token = params.access_token;
        (0,utils_localStorage/* setToStorage */.Pp)("id_app", config === null || config === void 0 ? void 0 : config.id_app);
        if (!token) {
            token = (0,utils_localStorage/* getFromStorage */.L2)("token");
            setState({
                token: token
            });
        } else {
        // setToStorage("token", token);
        // setState({ token });
        }
    }, []);
    react.useEffect(function() {
        function getAppInfo() {
            return _getAppInfo.apply(this, arguments);
        }
        function _getAppInfo() {
            _getAppInfo = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var appInfo;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return apis.asyncGetAppInfo("flex.public.token", "615fa1791fc31763c7253668");
                        case 2:
                            appInfo = _ctx.sent;
                            (0,utils_localStorage/* setToStorage */.Pp)("appInfo", appInfo);
                            setState({
                                appInfo: appInfo
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getAppInfo.apply(this, arguments);
        }
        getAppInfo();
    }, []);
    react.useEffect(function() {
        function verifyUserToken() {
            return _verifyUserToken.apply(this, arguments);
        }
        function _verifyUserToken() {
            _verifyUserToken = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var userInfo;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(!token || !config.id_app)) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return apis.asyncGetUserInfoByToken(token);
                        case 5:
                            userInfo = _ctx.sent;
                            userInfo.token = token;
                            setState({
                                userInfo: userInfo
                            });
                            (0,utils_localStorage/* setToStorage */.Pp)("userInfo", userInfo);
                            _ctx.next = 14;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](2);
                            (0,utils_localStorage/* setToStorage */.Pp)("token", null);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        11
                    ]
                ]);
            }));
            return _verifyUserToken.apply(this, arguments);
        }
        verifyUserToken();
    }, [
        token,
        config.id_app
    ]);
    react.useEffect(function() {
        if (!userInfo || !appInfo) return;
    //socket
    // initSocket(userInfo);
    //register endpoint
    // registerEndpoint(userInfo);
    }, [
        userInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(APIContext.Provider, {
        value: {
            userInfo: userInfo,
            appInfo: appInfo,
            config: config,
            apis: apis,
            token: token,
            toast: toast,
            alert: alert,
            setProgressStatus: setProgressStatus,
            prompt: prompt
        },
        children: children
    });
};
APIProvider.propTypes = {
    children: (prop_types_default()).any,
    handleSocketEvents: (prop_types_default()).func
};
/* harmony default export */ var flexbiz_api_provider = (APIProvider);


/***/ }),

/***/ 59963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ LocaleProvider; },
/* harmony export */   "u": function() { return /* binding */ useLocalContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _apis_fetch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36203);
/* harmony import */ var _utils_lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59926);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




// import { useFetchLabels } from "@/apis/labels";

// import compareVietnameseString from "@/utils/compareVietnameseString";
// import slugify from "@/utils/slugifyString";
// import { useMutation, useQueryClient } from "@tanstack/react-query";
// import { useRouter } from "next/router";

var LocaleContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createContext();
var useLocalContext = function() {
    var context = react__WEBPACK_IMPORTED_MODULE_3__.useContext(LocaleContext);
    return context;
};
// function localeReducer(state, { type, payload }) {
//   switch (type) {
//     case "SET_LABELS": {
//       return { ...state, labels: payload };
//     }
//     case "UPDATE_LABEL": {
//       return { ...state, labels: [...state.labels, payload] };
//     }
//     default: {
//       throw new Error(`Unhandled action type: ${type}`);
//     }
//   }
// }
function LocaleProvider(param) {
    var children = param.children;
    // const queryClient = useQueryClient();
    // const [state, dispatch] = React.useReducer(localeReducer, { labels: {} });
    // const { mutate, isLoading, isError, isSuccess } = useMutation(createLabel, {
    //   retry: 0,
    //   onMutate: (variables) => {
    //     return {
    //       variables,
    //     };
    //   },
    //   onSuccess: (data, variables, context) => {
    //     queryClient.setQueriesData(["labels"], (old) => [...old, variables]);
    //   },
    // });
    var server_url_report = "https://api.flexzen.app";
    var public_token = "flex.public.token";
    var trustkey = "APP.FKJSHHHH908KJF";
    // const app_code = process.env.app_code;
    // const { locale } = useRouter();
    // const { data: fetchedLabels } = useFetchLabels();
    var fetchedLabels = [];
    function createLabel(postData) {
        return _createLabel.apply(this, arguments);
    }
    function _createLabel() {
        _createLabel = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(postData) {
            var url;
            return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        url = "".concat(server_url_report, "/api/labelinfo?access_token=").concat(public_token, "&trustkey=").concat(trustkey);
                        return _ctx.abrupt("return", (0,_apis_fetch__WEBPACK_IMPORTED_MODULE_2__/* .asyncPost */ .op)({
                            url: url,
                            data: postData,
                            method: "POST"
                        }));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _createLabel.apply(this, arguments);
    }
    var retrieveLocaleItem = function(textid) {
        return fetchedLabels.find(function(el) {
            return el.textid === textid;
        });
    };
    // console.log("isLoading", isLoading);
    // console.log("isError", isError);
    // console.log("isSuccess", isSuccess);
    var getLabel = function(_label) {
        var defaultVi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", defaultEn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", lang = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "vi";
        if (!fetchedLabels || (0,_utils_lodash__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(fetchedLabels) || !_label) return _label;
        // console.log("1", 1);
        var label = _label.normalize("NFD");
        return label;
    // const textid = label.toUpperCase();
    // const labelObj = retrieveLocaleItem(textid);
    // if (isLoading || isError) return label;
    // // console.log("2", 2);
    // if (!labelObj) {
    //   // console.log("3", 3);
    //   const postData = {
    //     labelid: app_code,
    //     textid,
    //     texte: defaultEn || defaultVi || label,
    //     textv: defaultVi || defaultEn || label,
    //   };
    //   // create in the server
    //   mutate(postData);
    //   return label;
    // }
    // if (locale === "en") {
    //   // console.log("4", 4);
    //   return labelObj?.texte;
    // }
    // // console.log("5", 5);
    // return labelObj?.textv;
    };
    var value = {
        // state,
        // dispatch,
        getLabel: getLabel
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LocaleContext.Provider, {
        value: value,
        children: children
    });
}



/***/ }),

/***/ 97744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ appAlert; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mantine_notifications__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33575);
/* harmony import */ var _react_icons_all_files_fi_FiAlertCircle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87088);
/* harmony import */ var _react_icons_all_files_fi_FiBell__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38750);
/* harmony import */ var _react_icons_all_files_fi_FiCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(137);
/* harmony import */ var _react_icons_all_files_fi_FiX__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29707);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26679);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);











var defaultSettings = {
    disallowClose: false,
    autoClose: 3000
};
var defaultTheme = function(theme) {
    return {
        root: {
            backgroundColor: theme.white,
            borderColor: theme.gray,
            "&::before": {
                backgroundColor: theme.white
            }
        },
        title: {
            color: theme.black
        },
        description: {
            color: theme.black
        },
        closeButton: {
            color: theme.black,
            "&:hover": {
                backgroundColor: theme.colors.main[1]
            }
        }
    };
};
var availableAlertTypes = [
    "success",
    "error",
    "warning",
    "info"
];
var alertTypeStyles = {
    success: {
        color: "green",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiCheck__WEBPACK_IMPORTED_MODULE_2__/* .FiCheck */ .U, {})
    },
    error: {
        color: "red",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiX__WEBPACK_IMPORTED_MODULE_3__/* .FiX */ .q, {})
    },
    warning: {
        color: "orange",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiAlertCircle__WEBPACK_IMPORTED_MODULE_4__/* .FiAlertCircle */ .b, {})
    },
    info: {
        color: "blue",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiBell__WEBPACK_IMPORTED_MODULE_5__/* .FiBell */ .v, {})
    }
};
function appAlert(_param) {
    var _type = _param.type, type = _type === void 0 ? "info" : _type, id = _param.id, _onClose = _param.onClose, onClose = _onClose === void 0 ? function() {} : _onClose, // onOpen = () => {},
    message = _param.message, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "type",
        "id",
        "onClose",
        "message"
    ]);
    if (!availableAlertTypes.includes(type)) {
        type = "info";
    }
    // const trans = useTrans();
    (0,_mantine_notifications__WEBPACK_IMPORTED_MODULE_7__/* .showNotification */ .c0)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, defaultSettings), {
        title: type.toUpperCase(),
        id: id,
        onClose: onClose,
        // onOpen,
        message: message,
        color: alertTypeStyles[type].color,
        icon: alertTypeStyles[type].icon,
        loading: false,
        styles: function(theme) {
            return defaultTheme(theme);
        }
    }), props));
}
appAlert.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_10___default().oneOf(availableAlertTypes)
};


/***/ }),

/***/ 22312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ appendImageUrlFromAPI; }
/* harmony export */ });
/* harmony import */ var public_logo_png__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13476);

function appendImageUrlFromAPI(param) {
    var src = param.src, size = param.size;
    var IMAGE_SIZES = [
        "x",
        "s",
        "m",
        "l",
        "2K",
        "xl"
    ];
    var _src = src;
    if (!src) return public_logo_png__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
    if (size && !IMAGE_SIZES.includes(size === null || size === void 0 ? void 0 : size.toString().toLowerCase())) {
        alert("size: ".concat(size, " provided is invalid"));
    }
    if (src && String(src).indexOf("http") < 0) {
        _src = "".concat("https://api.flexzen.app").concat(src, "?access_token=").concat("flex.public.token", "&trustkey=").concat("APP.FKJSHHHH908KJF").concat(size ? "&size=".concat(size) : "");
    }
    return _src;
};


/***/ }),

/***/ 44061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L2": function() { return /* binding */ getFromStorage; },
/* harmony export */   "Li": function() { return /* binding */ removeStorage; },
/* harmony export */   "Pp": function() { return /* binding */ setToStorage; }
/* harmony export */ });
function isValidJsonString(jsonString) {
    if (!(jsonString && typeof jsonString === "string")) {
        return false;
    }
    try {
        JSON.parse(jsonString);
        return true;
    } catch (error) {
        return false;
    }
}
/* eslint-disable no-undef */ var getFromStorage = function(key) {
    if (true) {
        var data = localStorage.getItem(key);
        if (isValidJsonString(data)) {
            data = JSON.parse(data);
        }
        return data;
    }
};
var setToStorage = function(key, value) {
    if (true) {
        return localStorage.setItem(key, JSON.stringify(value));
    }
};
var removeStorage = function(key) {
    if (true) {
        return localStorage.removeItem(key);
    }
};


/***/ }),

/***/ 59926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nO": function() { return /* binding */ flattenObj; },
/* harmony export */   "xb": function() { return /* binding */ isEmpty; }
/* harmony export */ });
/* unused harmony export uniqify */
//https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_isempty
var isEmpty = function(obj) {
    return [
        Object,
        Array
    ].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
};
//https://www.geeksforgeeks.org/flatten-javascript-objects-into-a-single-depth-object/#:~:text=We%20make%20a%20function%20called,the%20value%20in%20the%20result.
var flattenObj = function(ob) {
    var result = {};
    for(var i in ob){
        if (typeof ob[i] === "object" && !Array.isArray(ob[i])) {
            var temp = flattenObj(ob[i]);
            for(var j in temp){
                result[i + "." + j] = temp[j];
            // result[j] = temp[j];
            }
        } else {
            result[i] = ob[i];
        }
    }
    return result;
};
var uniqify = function(array, key) {
    if (!array || array.length === 0 || !key) return [];
    return array === null || array === void 0 ? void 0 : array.reduce(function(prev, curr) {
        return prev.find(function(a) {
            return a[key] === curr[key];
        }) ? prev : prev.push(curr) && prev;
    }, []);
};


/***/ }),

/***/ 2559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sanitizeDOMData; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.js
var html_react_parser = __webpack_require__(30488);
;// CONCATENATED MODULE: ./node_modules/html-react-parser/index.mjs


var domToReact = html_react_parser.domToReact;
var htmlToDOM = html_react_parser.htmlToDOM;
var attributesToProps = html_react_parser.attributesToProps;

// domhandler
var Comment = html_react_parser.Comment;
var Element = html_react_parser.Element;
var ProcessingInstruction = html_react_parser.ProcessingInstruction;
var Text = html_react_parser.Text;

/* harmony default export */ var node_modules_html_react_parser = (html_react_parser);

// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./utils/sanitizeDOMData.js





var parseOptions = {
    replace: function(param) {
        var attribs = param.attribs, children = param.children;
        if (!attribs) {
            return;
        }
        if (attribs.dir === "ltr") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: domToReact(children)
            });
        }
    }
};
function sanitizeDOMData(htmlString) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        replace: parseOptions.replace
    };
    var cleanString = browser_default().sanitize(htmlString, {
        USE_PROFILES: {
            html: true
        }
    });
    var html = node_modules_html_react_parser(cleanString, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
        trim: true
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "webview",
        children: html
    });
};


/***/ }),

/***/ 98745:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 98322:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 72227:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 88308:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 40906:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 59967:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 99647:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(34406);
(function(){var e={66:function(){(function(e,t){"use strict";if(e.setImmediate){return}var n=1;var a={};var s=false;var i=e.document;var r;function setImmediate(e){if(typeof e!=="function"){e=new Function(""+e)}var t=new Array(arguments.length-1);for(var s=0;s<t.length;s++){t[s]=arguments[s+1]}var i={callback:e,args:t};a[n]=i;r(n);return n++}function clearImmediate(e){delete a[e]}function run(e){var n=e.callback;var a=e.args;switch(a.length){case 0:n();break;case 1:n(a[0]);break;case 2:n(a[0],a[1]);break;case 3:n(a[0],a[1],a[2]);break;default:n.apply(t,a);break}}function runIfPresent(e){if(s){setTimeout(runIfPresent,0,e)}else{var t=a[e];if(t){s=true;try{run(t)}finally{clearImmediate(e);s=false}}}}function installNextTickImplementation(){r=function(e){process.nextTick((function(){runIfPresent(e)}))}}function canUsePostMessage(){if(e.postMessage&&!e.importScripts){var t=true;var n=e.onmessage;e.onmessage=function(){t=false};e.postMessage("","*");e.onmessage=n;return t}}function installPostMessageImplementation(){var t="setImmediate$"+Math.random()+"$";var onGlobalMessage=function(n){if(n.source===e&&typeof n.data==="string"&&n.data.indexOf(t)===0){runIfPresent(+n.data.slice(t.length))}};if(e.addEventListener){e.addEventListener("message",onGlobalMessage,false)}else{e.attachEvent("onmessage",onGlobalMessage)}r=function(n){e.postMessage(t+n,"*")}}function installMessageChannelImplementation(){var e=new MessageChannel;e.port1.onmessage=function(e){var t=e.data;runIfPresent(t)};r=function(t){e.port2.postMessage(t)}}function installReadyStateChangeImplementation(){var e=i.documentElement;r=function(t){var n=i.createElement("script");n.onreadystatechange=function(){runIfPresent(t);n.onreadystatechange=null;e.removeChild(n);n=null};e.appendChild(n)}}function installSetTimeoutImplementation(){r=function(e){setTimeout(runIfPresent,0,e)}}var o=Object.getPrototypeOf&&Object.getPrototypeOf(e);o=o&&o.setTimeout?o:e;if({}.toString.call(e.process)==="[object process]"){installNextTickImplementation()}else if(canUsePostMessage()){installPostMessageImplementation()}else if(e.MessageChannel){installMessageChannelImplementation()}else if(i&&"onreadystatechange"in i.createElement("script")){installReadyStateChangeImplementation()}else{installSetTimeoutImplementation()}o.setImmediate=setImmediate;o.clearImmediate=clearImmediate})(typeof self==="undefined"?typeof __webpack_require__.g==="undefined"?this:__webpack_require__.g:self)}};if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t={};e[66]();module.exports=t})();

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(28045)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48418)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 92077:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 25726:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
var RESERVED = 0; // A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.

var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.

var BOOLEANISH_STRING = 2; // A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.

var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.

var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.

var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.

var POSITIVE_NUMERIC = 6;
function getPropertyInfo(name) {
  return properties.hasOwnProperty(name) ? properties[name] : null;
}

function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
  this.attributeName = attributeName;
  this.attributeNamespace = attributeNamespace;
  this.mustUseProperty = mustUseProperty;
  this.propertyName = name;
  this.type = type;
  this.sanitizeURL = sanitizeURL;
  this.removeEmptyString = removeEmptyString;
} // When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.


var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

var reservedProps = ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
// elements (not just inputs). Now that ReactDOMInput assigns to the
// defaultValue property -- do we need this?
'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
reservedProps.forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.

[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      attributeName = _ref2[1];

  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).

['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.

['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML boolean attributes.

['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
// on the client side because the browsers are inconsistent. Instead we call focus().
'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
'itemScope'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.

['checked', // Note: `option.selected` is not updated if `select.multiple` is
// disabled with `removeAttribute`. We have special logic for handling this.
'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.

['capture', 'download' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be positive numbers.

['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be numbers.

['rowSpan', 'start'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
});
var CAMELIZE = /[\-\:]([a-z])/g;

var capitalize = function capitalize(token) {
  return token[1].toUpperCase();
}; // This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.


['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // String SVG attributes with the xlink namespace.

['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/1999/xlink', false, // sanitizeURL
  false);
}); // String SVG attributes with the xml namespace.

['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/XML/1998/namespace', false, // sanitizeURL
  false);
}); // These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.

['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.

var xlinkHref = 'xlinkHref';
properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, // mustUseProperty
'xlink:href', 'http://www.w3.org/1999/xlink', true, // sanitizeURL
false);
['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  true, // sanitizeURL
  true);
});

var _require = __webpack_require__(78229),
    CAMELCASE = _require.CAMELCASE,
    SAME = _require.SAME,
    possibleStandardNamesOptimized = _require.possibleStandardNames;

var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
/**
 * Checks whether a property name is a custom attribute.
 *
 * @see {@link https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25}
 *
 * @param {string}
 * @return {boolean}
 */

var isCustomAttribute = RegExp.prototype.test.bind( // eslint-disable-next-line no-misleading-character-class
new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
var possibleStandardNames = Object.keys(possibleStandardNamesOptimized).reduce(function (accumulator, standardName) {
  var propName = possibleStandardNamesOptimized[standardName];

  if (propName === SAME) {
    accumulator[standardName] = standardName;
  } else if (propName === CAMELCASE) {
    accumulator[standardName.toLowerCase()] = standardName;
  } else {
    accumulator[standardName] = propName;
  }

  return accumulator;
}, {});

exports.BOOLEAN = BOOLEAN;
exports.BOOLEANISH_STRING = BOOLEANISH_STRING;
exports.NUMERIC = NUMERIC;
exports.OVERLOADED_BOOLEAN = OVERLOADED_BOOLEAN;
exports.POSITIVE_NUMERIC = POSITIVE_NUMERIC;
exports.RESERVED = RESERVED;
exports.STRING = STRING;
exports.getPropertyInfo = getPropertyInfo;
exports.isCustomAttribute = isCustomAttribute;
exports.possibleStandardNames = possibleStandardNames;


/***/ }),

/***/ 78229:
/***/ (function(__unused_webpack_module, exports) {

// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var SAME = 0;
exports.SAME = SAME;

// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var CAMELCASE = 1;
exports.CAMELCASE = CAMELCASE;

exports.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  'accept-charset': 'acceptCharset',
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: 'className',
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: 'htmlFor',
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  'http-equiv': 'httpEquiv',
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  'accent-height': 'accentHeight',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  'alignment-baseline': 'alignmentBaseline',
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  'arabic-form': 'arabicForm',
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  'baseline-shift': 'baselineShift',
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  'cap-height': 'capHeight',
  clip: 0,
  clipPath: 1,
  'clip-path': 'clipPath',
  clipPathUnits: 1,
  clipRule: 1,
  'clip-rule': 'clipRule',
  color: 0,
  colorInterpolation: 1,
  'color-interpolation': 'colorInterpolation',
  colorInterpolationFilters: 1,
  'color-interpolation-filters': 'colorInterpolationFilters',
  colorProfile: 1,
  'color-profile': 'colorProfile',
  colorRendering: 1,
  'color-rendering': 'colorRendering',
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  'dominant-baseline': 'dominantBaseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  'enable-background': 'enableBackground',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  'fill-opacity': 'fillOpacity',
  fillRule: 1,
  'fill-rule': 'fillRule',
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  'flood-opacity': 'floodOpacity',
  floodColor: 1,
  'flood-color': 'floodColor',
  focusable: 0,
  fontFamily: 1,
  'font-family': 'fontFamily',
  fontSize: 1,
  'font-size': 'fontSize',
  fontSizeAdjust: 1,
  'font-size-adjust': 'fontSizeAdjust',
  fontStretch: 1,
  'font-stretch': 'fontStretch',
  fontStyle: 1,
  'font-style': 'fontStyle',
  fontVariant: 1,
  'font-variant': 'fontVariant',
  fontWeight: 1,
  'font-weight': 'fontWeight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  'glyph-name': 'glyphName',
  glyphOrientationHorizontal: 1,
  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
  glyphOrientationVertical: 1,
  'glyph-orientation-vertical': 'glyphOrientationVertical',
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  'horiz-adv-x': 'horizAdvX',
  horizOriginX: 1,
  'horiz-origin-x': 'horizOriginX',
  ideographic: 0,
  imageRendering: 1,
  'image-rendering': 'imageRendering',
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  'letter-spacing': 'letterSpacing',
  lightingColor: 1,
  'lighting-color': 'lightingColor',
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  'marker-end': 'markerEnd',
  markerHeight: 1,
  markerMid: 1,
  'marker-mid': 'markerMid',
  markerStart: 1,
  'marker-start': 'markerStart',
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  'overline-position': 'overlinePosition',
  overlineThickness: 1,
  'overline-thickness': 'overlineThickness',
  paintOrder: 1,
  'paint-order': 'paintOrder',
  panose1: 0,
  'panose-1': 'panose1',
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  'pointer-events': 'pointerEvents',
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  'rendering-intent': 'renderingIntent',
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  'shape-rendering': 'shapeRendering',
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  'stop-color': 'stopColor',
  stopOpacity: 1,
  'stop-opacity': 'stopOpacity',
  strikethroughPosition: 1,
  'strikethrough-position': 'strikethroughPosition',
  strikethroughThickness: 1,
  'strikethrough-thickness': 'strikethroughThickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  'stroke-dasharray': 'strokeDasharray',
  strokeDashoffset: 1,
  'stroke-dashoffset': 'strokeDashoffset',
  strokeLinecap: 1,
  'stroke-linecap': 'strokeLinecap',
  strokeLinejoin: 1,
  'stroke-linejoin': 'strokeLinejoin',
  strokeMiterlimit: 1,
  'stroke-miterlimit': 'strokeMiterlimit',
  strokeWidth: 1,
  'stroke-width': 'strokeWidth',
  strokeOpacity: 1,
  'stroke-opacity': 'strokeOpacity',
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  'text-anchor': 'textAnchor',
  textDecoration: 1,
  'text-decoration': 'textDecoration',
  textLength: 1,
  textRendering: 1,
  'text-rendering': 'textRendering',
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  'underline-position': 'underlinePosition',
  underlineThickness: 1,
  'underline-thickness': 'underlineThickness',
  unicode: 0,
  unicodeBidi: 1,
  'unicode-bidi': 'unicodeBidi',
  unicodeRange: 1,
  'unicode-range': 'unicodeRange',
  unitsPerEm: 1,
  'units-per-em': 'unitsPerEm',
  unselectable: 0,
  vAlphabetic: 1,
  'v-alphabetic': 'vAlphabetic',
  values: 0,
  vectorEffect: 1,
  'vector-effect': 'vectorEffect',
  version: 0,
  vertAdvY: 1,
  'vert-adv-y': 'vertAdvY',
  vertOriginX: 1,
  'vert-origin-x': 'vertOriginX',
  vertOriginY: 1,
  'vert-origin-y': 'vertOriginY',
  vHanging: 1,
  'v-hanging': 'vHanging',
  vIdeographic: 1,
  'v-ideographic': 'vIdeographic',
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  'v-mathematical': 'vMathematical',
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  'word-spacing': 'wordSpacing',
  writingMode: 1,
  'writing-mode': 'writingMode',
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  'x-height': 'xHeight',
  xlinkActuate: 1,
  'xlink:actuate': 'xlinkActuate',
  xlinkArcrole: 1,
  'xlink:arcrole': 'xlinkArcrole',
  xlinkHref: 1,
  'xlink:href': 'xlinkHref',
  xlinkRole: 1,
  'xlink:role': 'xlinkRole',
  xlinkShow: 1,
  'xlink:show': 'xlinkShow',
  xlinkTitle: 1,
  'xlink:title': 'xlinkTitle',
  xlinkType: 1,
  'xlink:type': 'xlinkType',
  xmlBase: 1,
  'xml:base': 'xmlBase',
  xmlLang: 1,
  'xml:lang': 'xmlLang',
  xmlns: 0,
  'xml:space': 'xmlSpace',
  xmlnsXlink: 1,
  'xmlns:xlink': 'xmlnsXlink',
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};


/***/ }),

/***/ 41476:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var style_to_object_1 = __importDefault(__webpack_require__(57848));
var utilities_1 = __webpack_require__(26678);
function StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') {
        return output;
    }
    (0, style_to_object_1["default"])(style, function (property, value) {
        if (property && value) {
            output[(0, utilities_1.camelCase)(property, options)] = value;
        }
    });
    return output;
}
exports["default"] = StyleToJS;


/***/ }),

/***/ 26678:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.__esModule = true;
exports.camelCase = void 0;
var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
var HYPHEN_REGEX = /-([a-z])/g;
var NO_HYPHEN_REGEX = /^[^-]+$/;
var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
var skipCamelCase = function (property) {
    return !property ||
        NO_HYPHEN_REGEX.test(property) ||
        CUSTOM_PROPERTY_REGEX.test(property);
};
var capitalize = function (match, character) {
    return character.toUpperCase();
};
var trimHyphen = function (match, prefix) { return "".concat(prefix, "-"); };
var camelCase = function (property, options) {
    if (options === void 0) { options = {}; }
    if (skipCamelCase(property)) {
        return property;
    }
    property = property.toLowerCase();
    if (options.reactCompat) {
        property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
    }
    else {
        property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
    }
    return property.replace(HYPHEN_REGEX, capitalize);
};
exports.camelCase = camelCase;


/***/ }),

/***/ 57848:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18139);

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = parse(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

module.exports = StyleToObject;
module.exports["default"] = StyleToObject; // ESM support


/***/ }),

/***/ 53250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(67294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(53250);
} else {}


/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 88301:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JB": function() { return /* binding */ l; },
/* harmony export */   "Qo": function() { return /* binding */ T; },
/* harmony export */   "RR": function() { return /* binding */ b; },
/* harmony export */   "cv": function() { return /* binding */ O; },
/* harmony export */   "dp": function() { return /* binding */ k; },
/* harmony export */   "dr": function() { return /* binding */ L; },
/* harmony export */   "oo": function() { return /* binding */ r; },
/* harmony export */   "uY": function() { return /* binding */ E; },
/* harmony export */   "x7": function() { return /* binding */ m; }
/* harmony export */ });
/* unused harmony exports autoPlacement, detectOverflow, hide */
function t(t){return t.split("-")[1]}function e(t){return"y"===t?"height":"width"}function n(t){return t.split("-")[0]}function o(t){return["top","bottom"].includes(n(t))?"x":"y"}function i(i,r,a){let{reference:l,floating:s}=i;const c=l.x+l.width/2-s.width/2,f=l.y+l.height/2-s.height/2,u=o(r),m=e(u),g=l[m]/2-s[m]/2,d="x"===u;let p;switch(n(r)){case"top":p={x:c,y:l.y-s.height};break;case"bottom":p={x:c,y:l.y+l.height};break;case"right":p={x:l.x+l.width,y:f};break;case"left":p={x:l.x-s.width,y:f};break;default:p={x:l.x,y:l.y}}switch(t(r)){case"start":p[u]-=g*(a&&d?-1:1);break;case"end":p[u]+=g*(a&&d?-1:1)}return p}const r=async(t,e,n)=>{const{placement:o="bottom",strategy:r="absolute",middleware:a=[],platform:l}=n,s=a.filter(Boolean),c=await(null==l.isRTL?void 0:l.isRTL(e));let f=await l.getElementRects({reference:t,floating:e,strategy:r}),{x:u,y:m}=i(f,o,c),g=o,d={},p=0;for(let n=0;n<s.length;n++){const{name:a,fn:h}=s[n],{x:y,y:x,data:w,reset:v}=await h({x:u,y:m,initialPlacement:o,placement:g,strategy:r,middlewareData:d,rects:f,platform:l,elements:{reference:t,floating:e}});u=null!=y?y:u,m=null!=x?x:m,d={...d,[a]:{...d[a],...w}},v&&p<=50&&(p++,"object"==typeof v&&(v.placement&&(g=v.placement),v.rects&&(f=!0===v.rects?await l.getElementRects({reference:t,floating:e,strategy:r}):v.rects),({x:u,y:m}=i(f,g,c))),n=-1)}return{x:u,y:m,placement:g,strategy:r,middlewareData:d}};function a(t){return"number"!=typeof t?function(t){return{top:0,right:0,bottom:0,left:0,...t}}(t):{top:t,right:t,bottom:t,left:t}}function l(t){return{...t,top:t.y,left:t.x,right:t.x+t.width,bottom:t.y+t.height}}async function s(t,e){var n;void 0===e&&(e={});const{x:o,y:i,platform:r,rects:s,elements:c,strategy:f}=t,{boundary:u="clippingAncestors",rootBoundary:m="viewport",elementContext:g="floating",altBoundary:d=!1,padding:p=0}=e,h=a(p),y=c[d?"floating"===g?"reference":"floating":g],x=l(await r.getClippingRect({element:null==(n=await(null==r.isElement?void 0:r.isElement(y)))||n?y:y.contextElement||await(null==r.getDocumentElement?void 0:r.getDocumentElement(c.floating)),boundary:u,rootBoundary:m,strategy:f})),w="floating"===g?{...s.floating,x:o,y:i}:s.reference,v=await(null==r.getOffsetParent?void 0:r.getOffsetParent(c.floating)),b=await(null==r.isElement?void 0:r.isElement(v))&&await(null==r.getScale?void 0:r.getScale(v))||{x:1,y:1},R=l(r.convertOffsetParentRelativeRectToViewportRelativeRect?await r.convertOffsetParentRelativeRectToViewportRelativeRect({rect:w,offsetParent:v,strategy:f}):w);return{top:(x.top-R.top+h.top)/b.y,bottom:(R.bottom-x.bottom+h.bottom)/b.y,left:(x.left-R.left+h.left)/b.x,right:(R.right-x.right+h.right)/b.x}}const c=Math.min,f=Math.max;function u(t,e,n){return f(t,c(e,n))}const m=n=>({name:"arrow",options:n,async fn(i){const{element:r,padding:l=0}=n||{},{x:s,y:c,placement:f,rects:m,platform:g}=i;if(null==r)return{};const d=a(l),p={x:s,y:c},h=o(f),y=e(h),x=await g.getDimensions(r),w="y"===h?"top":"left",v="y"===h?"bottom":"right",b=m.reference[y]+m.reference[h]-p[h]-m.floating[y],R=p[h]-m.reference[h],A=await(null==g.getOffsetParent?void 0:g.getOffsetParent(r));let P=A?"y"===h?A.clientHeight||0:A.clientWidth||0:0;0===P&&(P=m.floating[y]);const T=b/2-R/2,O=d[w],D=P-x[y]-d[v],E=P/2-x[y]/2+T,L=u(O,E,D),k=null!=t(f)&&E!=L&&m.reference[y]/2-(E<O?d[w]:d[v])-x[y]/2<0;return{[h]:p[h]-(k?E<O?O-E:D-E:0),data:{[h]:L,centerOffset:E-L}}}}),g=["top","right","bottom","left"],d=g.reduce(((t,e)=>t.concat(e,e+"-start",e+"-end")),[]),p={left:"right",right:"left",bottom:"top",top:"bottom"};function h(t){return t.replace(/left|right|bottom|top/g,(t=>p[t]))}function y(n,i,r){void 0===r&&(r=!1);const a=t(n),l=o(n),s=e(l);let c="x"===l?a===(r?"end":"start")?"right":"left":"start"===a?"bottom":"top";return i.reference[s]>i.floating[s]&&(c=h(c)),{main:c,cross:h(c)}}const x={start:"end",end:"start"};function w(t){return t.replace(/start|end/g,(t=>x[t]))}const v=function(e){return void 0===e&&(e={}),{name:"autoPlacement",options:e,async fn(o){var i,r,a;const{rects:l,middlewareData:c,placement:f,platform:u,elements:m}=o,{alignment:g,allowedPlacements:p=d,autoAlignment:h=!0,...x}=e,v=void 0!==g||p===d?function(e,o,i){return(e?[...i.filter((n=>t(n)===e)),...i.filter((n=>t(n)!==e))]:i.filter((t=>n(t)===t))).filter((n=>!e||t(n)===e||!!o&&w(n)!==n))}(g||null,h,p):p,b=await s(o,x),R=(null==(i=c.autoPlacement)?void 0:i.index)||0,A=v[R];if(null==A)return{};const{main:P,cross:T}=y(A,l,await(null==u.isRTL?void 0:u.isRTL(m.floating)));if(f!==A)return{reset:{placement:v[0]}};const O=[b[n(A)],b[P],b[T]],D=[...(null==(r=c.autoPlacement)?void 0:r.overflows)||[],{placement:A,overflows:O}],E=v[R+1];if(E)return{data:{index:R+1,overflows:D},reset:{placement:E}};const L=D.slice().sort(((t,e)=>t.overflows[0]-e.overflows[0])),k=null==(a=L.find((t=>{let{overflows:e}=t;return e.every((t=>t<=0))})))?void 0:a.placement,B=k||L[0].placement;return B!==f?{data:{index:R+1,overflows:D},reset:{placement:B}}:{}}}};const b=function(e){return void 0===e&&(e={}),{name:"flip",options:e,async fn(o){var i;const{placement:r,middlewareData:a,rects:l,initialPlacement:c,platform:f,elements:u}=o,{mainAxis:m=!0,crossAxis:g=!0,fallbackPlacements:d,fallbackStrategy:p="bestFit",fallbackAxisSideDirection:x="none",flipAlignment:v=!0,...b}=e,R=n(r),A=n(c)===c,P=await(null==f.isRTL?void 0:f.isRTL(u.floating)),T=d||(A||!v?[h(c)]:function(t){const e=h(t);return[w(t),e,w(e)]}(c));d||"none"===x||T.push(...function(e,o,i,r){const a=t(e);let l=function(t,e,n){const o=["left","right"],i=["right","left"],r=["top","bottom"],a=["bottom","top"];switch(t){case"top":case"bottom":return n?e?i:o:e?o:i;case"left":case"right":return e?r:a;default:return[]}}(n(e),"start"===i,r);return a&&(l=l.map((t=>t+"-"+a)),o&&(l=l.concat(l.map(w)))),l}(c,v,x,P));const O=[c,...T],D=await s(o,b),E=[];let L=(null==(i=a.flip)?void 0:i.overflows)||[];if(m&&E.push(D[R]),g){const{main:t,cross:e}=y(r,l,P);E.push(D[t],D[e])}if(L=[...L,{placement:r,overflows:E}],!E.every((t=>t<=0))){var k;const t=((null==(k=a.flip)?void 0:k.index)||0)+1,e=O[t];if(e)return{data:{index:t,overflows:L},reset:{placement:e}};let n="bottom";switch(p){case"bestFit":{var B;const t=null==(B=L.map((t=>[t,t.overflows.filter((t=>t>0)).reduce(((t,e)=>t+e),0)])).sort(((t,e)=>t[1]-e[1]))[0])?void 0:B[0].placement;t&&(n=t);break}case"initialPlacement":n=c}if(r!==n)return{reset:{placement:n}}}return{}}}};function R(t,e){return{top:t.top-e.height,right:t.right-e.width,bottom:t.bottom-e.height,left:t.left-e.width}}function A(t){return g.some((e=>t[e]>=0))}const P=function(t){return void 0===t&&(t={}),{name:"hide",options:t,async fn(e){const{strategy:n="referenceHidden",...o}=t,{rects:i}=e;switch(n){case"referenceHidden":{const t=R(await s(e,{...o,elementContext:"reference"}),i.reference);return{data:{referenceHiddenOffsets:t,referenceHidden:A(t)}}}case"escaped":{const t=R(await s(e,{...o,altBoundary:!0}),i.floating);return{data:{escapedOffsets:t,escaped:A(t)}}}default:return{}}}}},T=function(t){return void 0===t&&(t={}),{name:"inline",options:t,async fn(e){const{placement:i,elements:r,rects:s,platform:u,strategy:m}=e,{padding:g=2,x:d,y:p}=t,h=l(u.convertOffsetParentRelativeRectToViewportRelativeRect?await u.convertOffsetParentRelativeRectToViewportRelativeRect({rect:s.reference,offsetParent:await(null==u.getOffsetParent?void 0:u.getOffsetParent(r.floating)),strategy:m}):s.reference),y=await(null==u.getClientRects?void 0:u.getClientRects(r.reference))||[],x=a(g);const w=await u.getElementRects({reference:{getBoundingClientRect:function(){if(2===y.length&&y[0].left>y[1].right&&null!=d&&null!=p)return y.find((t=>d>t.left-x.left&&d<t.right+x.right&&p>t.top-x.top&&p<t.bottom+x.bottom))||h;if(y.length>=2){if("x"===o(i)){const t=y[0],e=y[y.length-1],o="top"===n(i),r=t.top,a=e.bottom,l=o?t.left:e.left,s=o?t.right:e.right;return{top:r,bottom:a,left:l,right:s,width:s-l,height:a-r,x:l,y:r}}const t="left"===n(i),e=f(...y.map((t=>t.right))),r=c(...y.map((t=>t.left))),a=y.filter((n=>t?n.left===r:n.right===e)),l=a[0].top,s=a[a.length-1].bottom;return{top:l,bottom:s,left:r,right:e,width:e-r,height:s-l,x:r,y:l}}return h}},floating:r.floating,strategy:m});return s.reference.x!==w.reference.x||s.reference.y!==w.reference.y||s.reference.width!==w.reference.width||s.reference.height!==w.reference.height?{reset:{rects:w}}:{}}}};const O=function(e){return void 0===e&&(e=0),{name:"offset",options:e,async fn(i){const{x:r,y:a}=i,l=await async function(e,i){const{placement:r,platform:a,elements:l}=e,s=await(null==a.isRTL?void 0:a.isRTL(l.floating)),c=n(r),f=t(r),u="x"===o(r),m=["left","top"].includes(c)?-1:1,g=s&&u?-1:1,d="function"==typeof i?i(e):i;let{mainAxis:p,crossAxis:h,alignmentAxis:y}="number"==typeof d?{mainAxis:d,crossAxis:0,alignmentAxis:null}:{mainAxis:0,crossAxis:0,alignmentAxis:null,...d};return f&&"number"==typeof y&&(h="end"===f?-1*y:y),u?{x:h*g,y:p*m}:{x:p*m,y:h*g}}(i,e);return{x:r+l.x,y:a+l.y,data:l}}}};function D(t){return"x"===t?"y":"x"}const E=function(t){return void 0===t&&(t={}),{name:"shift",options:t,async fn(e){const{x:i,y:r,placement:a}=e,{mainAxis:l=!0,crossAxis:c=!1,limiter:f={fn:t=>{let{x:e,y:n}=t;return{x:e,y:n}}},...m}=t,g={x:i,y:r},d=await s(e,m),p=o(n(a)),h=D(p);let y=g[p],x=g[h];if(l){const t="y"===p?"bottom":"right";y=u(y+d["y"===p?"top":"left"],y,y-d[t])}if(c){const t="y"===h?"bottom":"right";x=u(x+d["y"===h?"top":"left"],x,x-d[t])}const w=f.fn({...e,[p]:y,[h]:x});return{...w,data:{x:w.x-i,y:w.y-r}}}}},L=function(t){return void 0===t&&(t={}),{options:t,fn(e){const{x:i,y:r,placement:a,rects:l,middlewareData:s}=e,{offset:c=0,mainAxis:f=!0,crossAxis:u=!0}=t,m={x:i,y:r},g=o(a),d=D(g);let p=m[g],h=m[d];const y="function"==typeof c?c(e):c,x="number"==typeof y?{mainAxis:y,crossAxis:0}:{mainAxis:0,crossAxis:0,...y};if(f){const t="y"===g?"height":"width",e=l.reference[g]-l.floating[t]+x.mainAxis,n=l.reference[g]+l.reference[t]-x.mainAxis;p<e?p=e:p>n&&(p=n)}if(u){var w,v;const t="y"===g?"width":"height",e=["top","left"].includes(n(a)),o=l.reference[d]-l.floating[t]+(e&&(null==(w=s.offset)?void 0:w[d])||0)+(e?0:x.crossAxis),i=l.reference[d]+l.reference[t]+(e?0:(null==(v=s.offset)?void 0:v[d])||0)-(e?x.crossAxis:0);h<o?h=o:h>i&&(h=i)}return{[g]:p,[d]:h}}}},k=function(e){return void 0===e&&(e={}),{name:"size",options:e,async fn(o){const{placement:i,rects:r,platform:a,elements:l}=o,{apply:c=(()=>{}),...u}=e,m=await s(o,u),g=n(i),d=t(i);let p,h;"top"===g||"bottom"===g?(p=g,h=d===(await(null==a.isRTL?void 0:a.isRTL(l.floating))?"start":"end")?"left":"right"):(h=g,p="end"===d?"top":"bottom");const y=f(m.left,0),x=f(m.right,0),w=f(m.top,0),v=f(m.bottom,0),b={availableHeight:r.floating.height-(["left","right"].includes(i)?2*(0!==w||0!==v?w+v:f(m.top,m.bottom)):m[p]),availableWidth:r.floating.width-(["top","bottom"].includes(i)?2*(0!==y||0!==x?y+x:f(m.left,m.right)):m[h])};await c({...o,...b});const R=await a.getDimensions(l.floating);return r.floating.width!==R.width||r.floating.height!==R.height?{reset:{rects:!0}}:{}}}};


/***/ }),

/***/ 55863:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kx": function() { return /* binding */ H; },
/* harmony export */   "Me": function() { return /* binding */ z; },
/* harmony export */   "oo": function() { return /* binding */ V; }
/* harmony export */ });
/* unused harmony export platform */
/* harmony import */ var _floating_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88301);
function n(t){var e;return(null==(e=t.ownerDocument)?void 0:e.defaultView)||window}function o(t){return n(t).getComputedStyle(t)}function i(t){return f(t)?(t.nodeName||"").toLowerCase():""}let r;function l(){if(r)return r;const t=navigator.userAgentData;return t&&Array.isArray(t.brands)?(r=t.brands.map((t=>t.brand+"/"+t.version)).join(" "),r):navigator.userAgent}function c(t){return t instanceof n(t).HTMLElement}function s(t){return t instanceof n(t).Element}function f(t){return t instanceof n(t).Node}function u(t){if("undefined"==typeof ShadowRoot)return!1;return t instanceof n(t).ShadowRoot||t instanceof ShadowRoot}function a(t){const{overflow:e,overflowX:n,overflowY:i,display:r}=o(t);return/auto|scroll|overlay|hidden|clip/.test(e+i+n)&&!["inline","contents"].includes(r)}function d(t){return["table","td","th"].includes(i(t))}function h(t){const e=/firefox/i.test(l()),n=o(t),i=n.backdropFilter||n.WebkitBackdropFilter;return"none"!==n.transform||"none"!==n.perspective||!!i&&"none"!==i||e&&"filter"===n.willChange||e&&!!n.filter&&"none"!==n.filter||["transform","perspective"].some((t=>n.willChange.includes(t)))||["paint","layout","strict","content"].some((t=>{const e=n.contain;return null!=e&&e.includes(t)}))}function p(){return!/^((?!chrome|android).)*safari/i.test(l())}function g(t){return["html","body","#document"].includes(i(t))}const m=Math.min,y=Math.max,x=Math.round;function w(t){const e=o(t);let n=parseFloat(e.width),i=parseFloat(e.height);const r=t.offsetWidth,l=t.offsetHeight,c=x(n)!==r||x(i)!==l;return c&&(n=r,i=l),{width:n,height:i,fallback:c}}function v(t){return s(t)?t:t.contextElement}const b={x:1,y:1};function L(t){const e=v(t);if(!c(e))return b;const n=e.getBoundingClientRect(),{width:o,height:i,fallback:r}=w(e);let l=(r?x(n.width):n.width)/o,s=(r?x(n.height):n.height)/i;return l&&Number.isFinite(l)||(l=1),s&&Number.isFinite(s)||(s=1),{x:l,y:s}}function E(t,e,o,i){var r,l;void 0===e&&(e=!1),void 0===o&&(o=!1);const c=t.getBoundingClientRect(),f=v(t);let u=b;e&&(i?s(i)&&(u=L(i)):u=L(t));const a=f?n(f):window,d=!p()&&o;let h=(c.left+(d&&(null==(r=a.visualViewport)?void 0:r.offsetLeft)||0))/u.x,g=(c.top+(d&&(null==(l=a.visualViewport)?void 0:l.offsetTop)||0))/u.y,m=c.width/u.x,y=c.height/u.y;if(f){const t=n(f),e=i&&s(i)?n(i):i;let o=t.frameElement;for(;o&&i&&e!==t;){const t=L(o),e=o.getBoundingClientRect(),i=getComputedStyle(o);e.x+=(o.clientLeft+parseFloat(i.paddingLeft))*t.x,e.y+=(o.clientTop+parseFloat(i.paddingTop))*t.y,h*=t.x,g*=t.y,m*=t.x,y*=t.y,h+=e.x,g+=e.y,o=n(o).frameElement}}return{width:m,height:y,top:g,right:h+m,bottom:g+y,left:h,x:h,y:g}}function R(t){return((f(t)?t.ownerDocument:t.document)||window.document).documentElement}function T(t){return s(t)?{scrollLeft:t.scrollLeft,scrollTop:t.scrollTop}:{scrollLeft:t.pageXOffset,scrollTop:t.pageYOffset}}function C(t){return E(R(t)).left+T(t).scrollLeft}function F(t,e,n){const o=c(e),r=R(e),l=E(t,!0,"fixed"===n,e);let s={scrollLeft:0,scrollTop:0};const f={x:0,y:0};if(o||!o&&"fixed"!==n)if(("body"!==i(e)||a(r))&&(s=T(e)),c(e)){const t=E(e,!0);f.x=t.x+e.clientLeft,f.y=t.y+e.clientTop}else r&&(f.x=C(r));return{x:l.left+s.scrollLeft-f.x,y:l.top+s.scrollTop-f.y,width:l.width,height:l.height}}function W(t){if("html"===i(t))return t;const e=t.assignedSlot||t.parentNode||(u(t)?t.host:null)||R(t);return u(e)?e.host:e}function D(t){return c(t)&&"fixed"!==o(t).position?t.offsetParent:null}function S(t){const e=n(t);let r=D(t);for(;r&&d(r)&&"static"===o(r).position;)r=D(r);return r&&("html"===i(r)||"body"===i(r)&&"static"===o(r).position&&!h(r))?e:r||function(t){let e=W(t);for(;c(e)&&!g(e);){if(h(e))return e;e=W(e)}return null}(t)||e}function A(t){const e=W(t);return g(e)?t.ownerDocument.body:c(e)&&a(e)?e:A(e)}function H(t,e){var o;void 0===e&&(e=[]);const i=A(t),r=i===(null==(o=t.ownerDocument)?void 0:o.body),l=n(i);return r?e.concat(l,l.visualViewport||[],a(i)?i:[]):e.concat(i,H(i))}function O(e,i,r){return"viewport"===i?(0,_floating_ui_core__WEBPACK_IMPORTED_MODULE_0__/* .rectToClientRect */ .JB)(function(t,e){const o=n(t),i=R(t),r=o.visualViewport;let l=i.clientWidth,c=i.clientHeight,s=0,f=0;if(r){l=r.width,c=r.height;const t=p();(t||!t&&"fixed"===e)&&(s=r.offsetLeft,f=r.offsetTop)}return{width:l,height:c,x:s,y:f}}(e,r)):s(i)?function(t,e){const n=E(t,!0,"fixed"===e),o=n.top+t.clientTop,i=n.left+t.clientLeft,r=c(t)?L(t):{x:1,y:1},l=t.clientWidth*r.x,s=t.clientHeight*r.y,f=i*r.x,u=o*r.y;return{top:u,left:f,right:f+l,bottom:u+s,x:f,y:u,width:l,height:s}}(i,r):(0,_floating_ui_core__WEBPACK_IMPORTED_MODULE_0__/* .rectToClientRect */ .JB)(function(t){var e;const n=R(t),i=T(t),r=null==(e=t.ownerDocument)?void 0:e.body,l=y(n.scrollWidth,n.clientWidth,r?r.scrollWidth:0,r?r.clientWidth:0),c=y(n.scrollHeight,n.clientHeight,r?r.scrollHeight:0,r?r.clientHeight:0);let s=-i.scrollLeft+C(t);const f=-i.scrollTop;return"rtl"===o(r||n).direction&&(s+=y(n.clientWidth,r?r.clientWidth:0)-l),{width:l,height:c,x:s,y:f}}(R(e)))}const P={getClippingRect:function(t){let{element:e,boundary:n,rootBoundary:r,strategy:l}=t;const c="clippingAncestors"===n?function(t,e){const n=e.get(t);if(n)return n;let r=H(t).filter((t=>s(t)&&"body"!==i(t))),l=null;const c="fixed"===o(t).position;let f=c?W(t):t;for(;s(f)&&!g(f);){const t=o(f),e=h(f);(c?e||l:e||"static"!==t.position||!l||!["absolute","fixed"].includes(l.position))?l=t:r=r.filter((t=>t!==f)),f=W(f)}return e.set(t,r),r}(e,this._c):[].concat(n),f=[...c,r],u=f[0],a=f.reduce(((t,n)=>{const o=O(e,n,l);return t.top=y(o.top,t.top),t.right=m(o.right,t.right),t.bottom=m(o.bottom,t.bottom),t.left=y(o.left,t.left),t}),O(e,u,l));return{width:a.right-a.left,height:a.bottom-a.top,x:a.left,y:a.top}},convertOffsetParentRelativeRectToViewportRelativeRect:function(t){let{rect:e,offsetParent:n,strategy:o}=t;const r=c(n),l=R(n);if(n===l)return e;let s={scrollLeft:0,scrollTop:0},f={x:1,y:1};const u={x:0,y:0};if((r||!r&&"fixed"!==o)&&(("body"!==i(n)||a(l))&&(s=T(n)),c(n))){const t=E(n);f=L(n),u.x=t.x+n.clientLeft,u.y=t.y+n.clientTop}return{width:e.width*f.x,height:e.height*f.y,x:e.x*f.x-s.scrollLeft*f.x+u.x,y:e.y*f.y-s.scrollTop*f.y+u.y}},isElement:s,getDimensions:function(t){return w(t)},getOffsetParent:S,getDocumentElement:R,getScale:L,async getElementRects(t){let{reference:e,floating:n,strategy:o}=t;const i=this.getOffsetParent||S,r=this.getDimensions;return{reference:F(e,await i(n),o),floating:{x:0,y:0,...await r(n)}}},getClientRects:t=>Array.from(t.getClientRects()),isRTL:t=>"rtl"===o(t).direction};function z(t,e,n,o){void 0===o&&(o={});const{ancestorScroll:i=!0,ancestorResize:r=!0,elementResize:l=!0,animationFrame:c=!1}=o,f=i&&!c,u=f||r?[...s(t)?H(t):t.contextElement?H(t.contextElement):[],...H(e)]:[];u.forEach((t=>{f&&t.addEventListener("scroll",n,{passive:!0}),r&&t.addEventListener("resize",n)}));let a,d=null;if(l){let o=!0;d=new ResizeObserver((()=>{o||n(),o=!1})),s(t)&&!c&&d.observe(t),s(t)||!t.contextElement||c||d.observe(t.contextElement),d.observe(e)}let h=c?E(t):null;return c&&function e(){const o=E(t);!h||o.x===h.x&&o.y===h.y&&o.width===h.width&&o.height===h.height||n();h=o,a=requestAnimationFrame(e)}(),n(),()=>{var t;u.forEach((t=>{f&&t.removeEventListener("scroll",n),r&&t.removeEventListener("resize",n)})),null==(t=d)||t.disconnect(),d=null,c&&cancelAnimationFrame(a)}}const V=(t,n,o)=>{const i=new Map,r={platform:P,...o},l={...r.platform,_c:i};return (0,_floating_ui_core__WEBPACK_IMPORTED_MODULE_0__/* .computePosition */ .oo)(t,n,{...r,platform:l})};


/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 15761:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33989);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32161);



class FocusManager extends _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Subscribable */ .l {
  constructor() {
    super();

    this.setup = onFocus => {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && window.addEventListener) {
        const listener = () => onFocus(); // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return () => {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }

      return;
    };
  }

  onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  }

  setEventListener(setup) {
    var _this$cleanup2;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(focused => {
      if (typeof focused === 'boolean') {
        this.setFocused(focused);
      } else {
        this.onFocus();
      }
    });
  }

  setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  }

  onFocus() {
    this.listeners.forEach(listener => {
      listener();
    });
  }

  isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  }

}
const focusManager = new FocusManager();


//# sourceMappingURL=focusManager.mjs.map


/***/ }),

/***/ 30819:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ defaultLogger; }
/* harmony export */ });
const defaultLogger = console;


//# sourceMappingURL=logger.mjs.map


/***/ }),

/***/ 89886:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getDefaultState; },
/* harmony export */   "m": function() { return /* binding */ Mutation; }
/* harmony export */ });
/* harmony import */ var _logger_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30819);
/* harmony import */ var _notifyManager_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30081);
/* harmony import */ var _removable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89643);
/* harmony import */ var _retryer_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72379);





// CLASS
class Mutation extends _removable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Removable */ .F {
  constructor(config) {
    super();
    this.options = { ...config.defaultOptions,
      ...config.options
    };
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.logger = config.logger || _logger_mjs__WEBPACK_IMPORTED_MODULE_1__/* .defaultLogger */ ._;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.updateCacheTime(this.options.cacheTime);
    this.scheduleGc();
  }

  get meta() {
    return this.options.meta;
  }

  setState(state) {
    this.dispatch({
      type: 'setState',
      state
    });
  }

  addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer); // Stop the mutation from being garbage collected

      this.clearGcTimeout();
      this.mutationCache.notify({
        type: 'observerAdded',
        mutation: this,
        observer
      });
    }
  }

  removeObserver(observer) {
    this.observers = this.observers.filter(x => x !== observer);
    this.scheduleGc();
    this.mutationCache.notify({
      type: 'observerRemoved',
      mutation: this,
      observer
    });
  }

  optionalRemove() {
    if (!this.observers.length) {
      if (this.state.status === 'loading') {
        this.scheduleGc();
      } else {
        this.mutationCache.remove(this);
      }
    }
  }

  continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  }

  async execute() {
    const executeMutation = () => {
      var _this$options$retry;

      this.retryer = (0,_retryer_mjs__WEBPACK_IMPORTED_MODULE_2__/* .createRetryer */ .Mz)({
        fn: () => {
          if (!this.options.mutationFn) {
            return Promise.reject('No mutationFn found');
          }

          return this.options.mutationFn(this.state.variables);
        },
        onFail: (failureCount, error) => {
          this.dispatch({
            type: 'failed',
            failureCount,
            error
          });
        },
        onPause: () => {
          this.dispatch({
            type: 'pause'
          });
        },
        onContinue: () => {
          this.dispatch({
            type: 'continue'
          });
        },
        retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      });
      return this.retryer.promise;
    };

    const restored = this.state.status === 'loading';

    try {
      var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$options$onSettl, _this$options3;

      if (!restored) {
        var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;

        this.dispatch({
          type: 'loading',
          variables: this.options.variables
        }); // Notify cache callback

        await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
        const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));

        if (context !== this.state.context) {
          this.dispatch({
            type: 'loading',
            context,
            variables: this.state.variables
          });
        }
      }

      const data = await executeMutation(); // Notify cache callback

      await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
      await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context));
      await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
      this.dispatch({
        type: 'success',
        data
      });
      return data;
    } catch (error) {
      try {
        var _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onError, _this$options4, _this$options$onSettl2, _this$options5;

        // Notify cache callback
        await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, error, this.state.variables, this.state.context, this));

        if (false) {}

        await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context));
        await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
        throw error;
      } finally {
        this.dispatch({
          type: 'error',
          error: error
        });
      }
    }
  }

  dispatch(action) {
    const reducer = state => {
      switch (action.type) {
        case 'failed':
          return { ...state,
            failureCount: action.failureCount,
            failureReason: action.error
          };

        case 'pause':
          return { ...state,
            isPaused: true
          };

        case 'continue':
          return { ...state,
            isPaused: false
          };

        case 'loading':
          return { ...state,
            context: action.context,
            data: undefined,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !(0,_retryer_mjs__WEBPACK_IMPORTED_MODULE_2__/* .canFetch */ .Kw)(this.options.networkMode),
            status: 'loading',
            variables: action.variables
          };

        case 'success':
          return { ...state,
            data: action.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: 'success',
            isPaused: false
          };

        case 'error':
          return { ...state,
            data: undefined,
            error: action.error,
            failureCount: state.failureCount + 1,
            failureReason: action.error,
            isPaused: false,
            status: 'error'
          };

        case 'setState':
          return { ...state,
            ...action.state
          };
      }
    };

    this.state = reducer(this.state);
    _notifyManager_mjs__WEBPACK_IMPORTED_MODULE_3__/* .notifyManager.batch */ .V.batch(() => {
      this.observers.forEach(observer => {
        observer.onMutationUpdate(action);
      });
      this.mutationCache.notify({
        mutation: this,
        type: 'updated',
        action
      });
    });
  }

}
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}


//# sourceMappingURL=mutation.mjs.map


/***/ }),

/***/ 30081:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export createNotifyManager */
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32161);


function createNotifyManager() {
  let queue = [];
  let transactions = 0;

  let notifyFn = callback => {
    callback();
  };

  let batchNotifyFn = callback => {
    callback();
  };

  const batch = callback => {
    let result;
    transactions++;

    try {
      result = callback();
    } finally {
      transactions--;

      if (!transactions) {
        flush();
      }
    }

    return result;
  };

  const schedule = callback => {
    if (transactions) {
      queue.push(callback);
    } else {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(() => {
        notifyFn(callback);
      });
    }
  };
  /**
   * All calls to the wrapped function will be batched.
   */


  const batchCalls = callback => {
    return (...args) => {
      schedule(() => {
        callback(...args);
      });
    };
  };

  const flush = () => {
    const originalQueue = queue;
    queue = [];

    if (originalQueue.length) {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(() => {
        batchNotifyFn(() => {
          originalQueue.forEach(callback => {
            notifyFn(callback);
          });
        });
      });
    }
  };
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */


  const setNotifyFunction = fn => {
    notifyFn = fn;
  };
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */


  const setBatchNotifyFunction = fn => {
    batchNotifyFn = fn;
  };

  return {
    batch,
    batchCalls,
    schedule,
    setNotifyFunction,
    setBatchNotifyFunction
  };
} // SINGLETON

const notifyManager = createNotifyManager();


//# sourceMappingURL=notifyManager.mjs.map


/***/ }),

/***/ 96474:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33989);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32161);



class OnlineManager extends _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Subscribable */ .l {
  constructor() {
    super();

    this.setup = onOnline => {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && window.addEventListener) {
        const listener = () => onOnline(); // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return () => {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }

      return;
    };
  }

  onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  }

  setEventListener(setup) {
    var _this$cleanup2;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(online => {
      if (typeof online === 'boolean') {
        this.setOnline(online);
      } else {
        this.onOnline();
      }
    });
  }

  setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  }

  onOnline() {
    this.listeners.forEach(listener => {
      listener();
    });
  }

  isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  }

}
const onlineManager = new OnlineManager();


//# sourceMappingURL=onlineManager.mjs.map


/***/ }),

/***/ 89643:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Removable; }
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32161);


class Removable {
  destroy() {
    this.clearGcTimeout();
  }

  scheduleGc() {
    this.clearGcTimeout();

    if ((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isValidTimeout */ .PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(() => {
        this.optionalRemove();
      }, this.cacheTime);
    }
  }

  updateCacheTime(newCacheTime) {
    // Default to 5 minutes (Infinity for server-side) if no cache time is set
    this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : _utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk ? Infinity : 5 * 60 * 1000);
  }

  clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  }

}


//# sourceMappingURL=removable.mjs.map


/***/ }),

/***/ 72379:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "Kw": function() { return /* binding */ canFetch; },
/* harmony export */   "Mz": function() { return /* binding */ createRetryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15761);
/* harmony import */ var _onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96474);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32161);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * 2 ** failureCount, 30000);
}

function canFetch(networkMode) {
  return (networkMode != null ? networkMode : 'online') === 'online' ? _onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__/* .onlineManager.isOnline */ .N.isOnline() : true;
}
class CancelledError {
  constructor(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
  }

}
function isCancelledError(value) {
  return value instanceof CancelledError;
}
function createRetryer(config) {
  let isRetryCancelled = false;
  let failureCount = 0;
  let isResolved = false;
  let continueFn;
  let promiseResolve;
  let promiseReject;
  const promise = new Promise((outerResolve, outerReject) => {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  const cancel = cancelOptions => {
    if (!isResolved) {
      reject(new CancelledError(cancelOptions));
      config.abort == null ? void 0 : config.abort();
    }
  };

  const cancelRetry = () => {
    isRetryCancelled = true;
  };

  const continueRetry = () => {
    isRetryCancelled = false;
  };

  const shouldPause = () => !_focusManager_mjs__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || config.networkMode !== 'always' && !_onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__/* .onlineManager.isOnline */ .N.isOnline();

  const resolve = value => {
    if (!isResolved) {
      isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  const reject = value => {
    if (!isResolved) {
      isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  const pause = () => {
    return new Promise(continueResolve => {
      continueFn = value => {
        if (isResolved || !shouldPause()) {
          return continueResolve(value);
        }
      };

      config.onPause == null ? void 0 : config.onPause();
    }).then(() => {
      continueFn = undefined;

      if (!isResolved) {
        config.onContinue == null ? void 0 : config.onContinue();
      }
    });
  }; // Create loop function


  const run = () => {
    // Do nothing if already resolved
    if (isResolved) {
      return;
    }

    let promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    }

    Promise.resolve(promiseOrValue).then(resolve).catch(error => {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (isResolved) {
        return;
      } // Do we need to retry the request?


      const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
      const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);

      if (isRetryCancelled || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(failureCount, error); // Delay

      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(() => {
        if (shouldPause()) {
          return pause();
        }

        return;
      }).then(() => {
        if (isRetryCancelled) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  if (canFetch(config.networkMode)) {
    run();
  } else {
    pause().then(run);
  }

  return {
    promise,
    cancel,
    continue: () => {
      continueFn == null ? void 0 : continueFn();
    },
    cancelRetry,
    continueRetry
  };
}


//# sourceMappingURL=retryer.mjs.map


/***/ }),

/***/ 33989:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
class Subscribable {
  constructor() {
    this.listeners = [];
    this.subscribe = this.subscribe.bind(this);
  }

  subscribe(listener) {
    this.listeners.push(listener);
    this.onSubscribe();
    return () => {
      this.listeners = this.listeners.filter(x => x !== listener);
      this.onUnsubscribe();
    };
  }

  hasListeners() {
    return this.listeners.length > 0;
  }

  onSubscribe() {// Do nothing
  }

  onUnsubscribe() {// Do nothing
  }

}


//# sourceMappingURL=subscribable.mjs.map


/***/ }),

/***/ 32161:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "lV": function() { return /* binding */ parseMutationArgs; },
/* harmony export */   "oE": function() { return /* binding */ replaceData; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports difference, isError, isPlainArray, isPlainObject, isQueryKey, parseMutationFilterArgs, partialDeepEqual, replaceAt, replaceEqualDeep */
// TYPES
// UTILS
const isServer = typeof window === 'undefined' || 'Deno' in window;
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function difference(array1, array2) {
  return array1.filter(x => array2.indexOf(x) === -1);
}
function replaceAt(array, index, value) {
  const copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return { ...arg3,
      queryKey: arg1,
      queryFn: arg2
    };
  }

  return { ...arg2,
    queryKey: arg1
  };
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return { ...arg3,
        mutationKey: arg1,
        mutationFn: arg2
      };
    }

    return { ...arg2,
      mutationKey: arg1
    };
  }

  if (typeof arg1 === 'function') {
    return { ...arg2,
      mutationFn: arg1
    };
  }

  return { ...arg1
  };
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [{ ...arg2,
    queryKey: arg1
  }, arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [{ ...arg2,
    mutationKey: arg1
  }, arg3] : [arg1 || {}, arg2];
}
function matchQuery(filters, query) {
  const {
    type = 'all',
    exact,
    fetchStatus,
    predicate,
    queryKey,
    stale
  } = filters;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  if (type !== 'all') {
    const isActive = query.isActive();

    if (type === 'active' && !isActive) {
      return false;
    }

    if (type === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  const {
    exact,
    fetching,
    predicate,
    mutationKey
  } = filters;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */

function hashQueryKey(queryKey) {
  return JSON.stringify(queryKey, (_, val) => isPlainObject(val) ? Object.keys(val).sort().reduce((result, key) => {
    result[key] = val[key];
    return result;
  }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(key => !partialDeepEqual(a[key], b[key]));
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  const array = isPlainArray(a) && isPlainArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    const aSize = array ? a.length : Object.keys(a).length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? [] : {};
    let equalItems = 0;

    for (let i = 0; i < bSize; i++) {
      const key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (const key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}
function isPlainArray(value) {
  return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  const ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  const prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(resolve => {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  sleep(0).then(callback);
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }

  return;
}
function replaceData(prevData, data, options) {
  // Use prev data if an isDataEqual function is defined and returns `true`
  if (options.isDataEqual != null && options.isDataEqual(prevData, data)) {
    return prevData;
  } else if (typeof options.structuralSharing === 'function') {
    return options.structuralSharing(prevData, data);
  } else if (options.structuralSharing !== false) {
    // Structurally share data between prev and new data if needed
    return replaceEqualDeep(prevData, data);
  }

  return data;
}


//# sourceMappingURL=utils.mjs.map


/***/ }),

/***/ 85945:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NL": function() { return /* binding */ useQueryClient; },
/* harmony export */   "aH": function() { return /* binding */ QueryClientProvider; }
/* harmony export */ });
/* unused harmony export defaultContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


const defaultContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
const QueryClientSharingContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(context, contextSharing) {
  if (context) {
    return context;
  }

  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

const useQueryClient = ({
  context
} = {}) => {
  const queryClient = react__WEBPACK_IMPORTED_MODULE_0__.useContext(getQueryClientContext(context, react__WEBPACK_IMPORTED_MODULE_0__.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
const QueryClientProvider = ({
  client,
  children,
  context,
  contextSharing = false
}) => {
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    client.mount();
    return () => {
      client.unmount();
    };
  }, [client]);

  if (false) {}

  const Context = getQueryClientContext(context, contextSharing);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(QueryClientSharingContext.Provider, {
    value: !context && contextSharing
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context.Provider, {
    value: client
  }, children));
};


//# sourceMappingURL=QueryClientProvider.mjs.map


/***/ }),

/***/ 48228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ useMutation; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useSyncExternalStore.mjs
var useSyncExternalStore = __webpack_require__(464);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/mutation.mjs
var mutation = __webpack_require__(89886);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(33989);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/mutationObserver.mjs





// CLASS
class MutationObserver extends subscribable/* Subscribable */.l {
  constructor(client, options) {
    super();
    this.client = client;
    this.setOptions(options);
    this.bindMethods();
    this.updateResult();
  }

  bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  }

  setOptions(options) {
    const prevOptions = this.options;
    this.options = this.client.defaultMutationOptions(options);

    if (!(0,utils/* shallowEqualObjects */.VS)(prevOptions, this.options)) {
      this.client.getMutationCache().notify({
        type: 'observerOptionsUpdated',
        mutation: this.currentMutation,
        observer: this
      });
    }
  }

  onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;

      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
    }
  }

  onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    const notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  }

  getCurrentResult() {
    return this.currentResult;
  }

  reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  }

  mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, { ...this.options,
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    });
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  }

  updateResult() {
    const state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();
    const result = { ...state,
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    };
    this.currentResult = result;
  }

  notify(options) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      // First trigger the mutate callbacks
      if (this.mutateOptions) {
        if (options.onSuccess) {
          var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;

          (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null ? void 0 : _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
        } else if (options.onError) {
          var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;

          (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null ? void 0 : _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        this.listeners.forEach(listener => {
          listener(this.currentResult);
        });
      }
    });
  }

}


//# sourceMappingURL=mutationObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/utils.mjs
var lib_utils = __webpack_require__(24798);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs






function useMutation(arg1, arg2, arg3) {
  const options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const [observer] = react.useState(() => new MutationObserver(queryClient, options));
  react.useEffect(() => {
    observer.setOptions(options);
  }, [observer, options]);
  const result = (0,useSyncExternalStore/* useSyncExternalStore */.$)(react.useCallback(onStoreChange => observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)), [observer]), () => observer.getCurrentResult(), () => observer.getCurrentResult());
  const mutate = react.useCallback((variables, mutateOptions) => {
    observer.mutate(variables, mutateOptions).catch(noop);
  }, [observer]);

  if (result.error && (0,lib_utils/* shouldThrowError */.L)(observer.options.useErrorBoundary, [result.error])) {
    throw result.error;
  }

  return { ...result,
    mutate,
    mutateAsync: result.mutate
  };
} // eslint-disable-next-line @typescript-eslint/no-empty-function

function noop() {}


//# sourceMappingURL=useMutation.mjs.map


/***/ }),

/***/ 67848:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ useQuery; }
});

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/focusManager.mjs
var focusManager = __webpack_require__(15761);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(33989);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/retryer.mjs
var retryer = __webpack_require__(72379);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/queryObserver.mjs






class QueryObserver extends subscribable/* Subscribable */.l {
  constructor(client, options) {
    super();
    this.client = client;
    this.options = options;
    this.trackedProps = new Set();
    this.selectError = null;
    this.bindMethods();
    this.setOptions(options);
  }

  bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  }

  onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  }

  onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  }

  shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }

  shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }

  destroy() {
    this.listeners = [];
    this.clearStaleTimeout();
    this.clearRefetchInterval();
    this.currentQuery.removeObserver(this);
  }

  setOptions(options, notifyOptions) {
    const prevOptions = this.options;
    const prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryOptions(options);

    if (false) {}

    if (!(0,utils/* shallowEqualObjects */.VS)(prevOptions, this.options)) {
      this.client.getQueryCache().notify({
        type: 'observerOptionsUpdated',
        query: this.currentQuery,
        observer: this
      });
    }

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    const mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  }

  getOptimisticResult(options) {
    const query = this.client.getQueryCache().build(this.client, options);
    return this.createResult(query, options);
  }

  getCurrentResult() {
    return this.currentResult;
  }

  trackResult(result) {
    const trackedResult = {};
    Object.keys(result).forEach(key => {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: () => {
          this.trackedProps.add(key);
          return result[key];
        }
      });
    });
    return trackedResult;
  }

  getCurrentQuery() {
    return this.currentQuery;
  }

  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }

  refetch({
    refetchPage,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        refetchPage
      }
    });
  }

  fetchOptimistic(options) {
    const defaultedOptions = this.client.defaultQueryOptions(options);
    const query = this.client.getQueryCache().build(this.client, defaultedOptions);
    query.isFetchingOptimistic = true;
    return query.fetch().then(() => this.createResult(query, defaultedOptions));
  }

  fetch(fetchOptions) {
    var _fetchOptions$cancelR;

    return this.executeFetch({ ...fetchOptions,
      cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
    }).then(() => {
      this.updateResult();
      return this.currentResult;
    });
  }

  executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    let promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions != null && fetchOptions.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  }

  updateStaleTimeout() {
    this.clearStaleTimeout();

    if (utils/* isServer */.sk || this.currentResult.isStale || !(0,utils/* isValidTimeout */.PN)(this.options.staleTime)) {
      return;
    }

    const time = (0,utils/* timeUntilStale */.Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    const timeout = time + 1;
    this.staleTimeoutId = setTimeout(() => {
      if (!this.currentResult.isStale) {
        this.updateResult();
      }
    }, timeout);
  }

  computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  }

  updateRefetchInterval(nextInterval) {
    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (utils/* isServer */.sk || this.options.enabled === false || !(0,utils/* isValidTimeout */.PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(() => {
      if (this.options.refetchIntervalInBackground || focusManager/* focusManager.isFocused */.j.isFocused()) {
        this.executeFetch();
      }
    }, this.currentRefetchInterval);
  }

  updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  }

  clearStaleTimeout() {
    if (this.staleTimeoutId) {
      clearTimeout(this.staleTimeoutId);
      this.staleTimeoutId = undefined;
    }
  }

  clearRefetchInterval() {
    if (this.refetchIntervalId) {
      clearInterval(this.refetchIntervalId);
      this.refetchIntervalId = undefined;
    }
  }

  createResult(query, options) {
    const prevQuery = this.currentQuery;
    const prevOptions = this.options;
    const prevResult = this.currentResult;
    const prevResultState = this.currentResultState;
    const prevResultOptions = this.currentResultOptions;
    const queryChange = query !== prevQuery;
    const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    const {
      state
    } = query;
    let {
      dataUpdatedAt,
      error,
      errorUpdatedAt,
      fetchStatus,
      status
    } = state;
    let isPreviousData = false;
    let isPlaceholderData = false;
    let data; // Optimistically set result in fetching state if needed

    if (options._optimisticResults) {
      const mounted = this.hasListeners();
      const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        fetchStatus = (0,retryer/* canFetch */.Kw)(query.options.networkMode) ? 'fetching' : 'paused';

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }

      if (options._optimisticResults === 'isRestoring') {
        fetchStatus = 'idle';
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
      // Memoize select result
      if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
        data = this.selectResult;
      } else {
        try {
          this.selectFn = options.select;
          data = options.select(state.data);
          data = (0,utils/* replaceData */.oE)(prevResult == null ? void 0 : prevResult.data, data, options);
          this.selectResult = data;
          this.selectError = null;
        } catch (selectError) {
          if (false) {}

          this.selectError = selectError;
        }
      }
    } // Use query data
    else {
      data = state.data;
    } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
      let placeholderData; // Memoize placeholder data

      if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);
            this.selectError = null;
          } catch (selectError) {
            if (false) {}

            this.selectError = selectError;
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = (0,utils/* replaceData */.oE)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
        isPlaceholderData = true;
      }
    }

    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }

    const isFetching = fetchStatus === 'fetching';
    const isLoading = status === 'loading';
    const isError = status === 'error';
    const result = {
      status,
      fetchStatus,
      isLoading,
      isSuccess: status === 'success',
      isError,
      isInitialLoading: isLoading && isFetching,
      data,
      dataUpdatedAt,
      error,
      errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      failureReason: state.fetchFailureReason,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching,
      isRefetching: isFetching && !isLoading,
      isLoadingError: isError && state.dataUpdatedAt === 0,
      isPaused: fetchStatus === 'paused',
      isPlaceholderData,
      isPreviousData,
      isRefetchError: isError && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  }

  updateResult(notifyOptions) {
    const prevResult = this.currentResult;
    const nextResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify and update result if something has changed

    if ((0,utils/* shallowEqualObjects */.VS)(nextResult, prevResult)) {
      return;
    }

    this.currentResult = nextResult; // Determine which callbacks to trigger

    const defaultNotifyOptions = {
      cache: true
    };

    const shouldNotifyListeners = () => {
      if (!prevResult) {
        return true;
      }

      const {
        notifyOnChangeProps
      } = this.options;

      if (notifyOnChangeProps === 'all' || !notifyOnChangeProps && !this.trackedProps.size) {
        return true;
      }

      const includedProps = new Set(notifyOnChangeProps != null ? notifyOnChangeProps : this.trackedProps);

      if (this.options.useErrorBoundary) {
        includedProps.add('error');
      }

      return Object.keys(this.currentResult).some(key => {
        const typedKey = key;
        const changed = this.currentResult[typedKey] !== prevResult[typedKey];
        return changed && includedProps.has(typedKey);
      });
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify({ ...defaultNotifyOptions,
      ...notifyOptions
    });
  }

  updateQuery() {
    const query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    const prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  }

  onQueryUpdate(action) {
    const notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = !action.manual;
    } else if (action.type === 'error' && !(0,retryer/* isCancelledError */.DV)(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  }

  notify(notifyOptions) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;

        (_this$options$onSucce = (_this$options = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options, this.currentResult.data);
        (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
      } else if (notifyOptions.onError) {
        var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;

        (_this$options$onError = (_this$options3 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options3, this.currentResult.error);
        (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        this.listeners.forEach(listener => {
          listener(this.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        this.client.getQueryCache().notify({
          query: this.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  }

}

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    const value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}


//# sourceMappingURL=queryObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useSyncExternalStore.mjs
var useSyncExternalStore = __webpack_require__(464);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryErrorResetBoundary.mjs


function createValue() {
  let isReset = false;
  return {
    clearReset: () => {
      isReset = false;
    },
    reset: () => {
      isReset = true;
    },
    isReset: () => {
      return isReset;
    }
  };
}

const QueryErrorResetBoundaryContext = /*#__PURE__*/react.createContext(createValue()); // HOOK

const useQueryErrorResetBoundary = () => react.useContext(QueryErrorResetBoundaryContext); // COMPONENT

const QueryErrorResetBoundary = ({
  children
}) => {
  const [value] = React.useState(() => createValue());
  return /*#__PURE__*/React.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};


//# sourceMappingURL=QueryErrorResetBoundary.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/isRestoring.mjs


const IsRestoringContext = /*#__PURE__*/react.createContext(false);
const useIsRestoring = () => react.useContext(IsRestoringContext);
const IsRestoringProvider = IsRestoringContext.Provider;


//# sourceMappingURL=isRestoring.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/utils.mjs
var lib_utils = __webpack_require__(24798);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/errorBoundaryUtils.mjs



const ensurePreventErrorBoundaryRetry = (options, errorResetBoundary) => {
  if (options.suspense || options.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      options.retryOnMount = false;
    }
  }
};
const useClearResetErrorBoundary = errorResetBoundary => {
  react.useEffect(() => {
    errorResetBoundary.clearReset();
  }, [errorResetBoundary]);
};
const getHasError = ({
  result,
  errorResetBoundary,
  useErrorBoundary,
  query
}) => {
  return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0,lib_utils/* shouldThrowError */.L)(useErrorBoundary, [result.error, query]);
};


//# sourceMappingURL=errorBoundaryUtils.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/suspense.mjs
const ensureStaleTime = defaultedOptions => {
  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    }
  }
};
const willFetch = (result, isRestoring) => result.isLoading && result.isFetching && !isRestoring;
const shouldSuspend = (defaultedOptions, result, isRestoring) => (defaultedOptions == null ? void 0 : defaultedOptions.suspense) && willFetch(result, isRestoring);
const fetchOptimistic = (defaultedOptions, observer, errorResetBoundary) => observer.fetchOptimistic(defaultedOptions).then(({
  data
}) => {
  defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
  defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
}).catch(error => {
  errorResetBoundary.clearReset();
  defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
  defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
});


//# sourceMappingURL=suspense.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs









function useBaseQuery(options, Observer) {
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const isRestoring = useIsRestoring();
  const errorResetBoundary = useQueryErrorResetBoundary();
  const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }

  ensureStaleTime(defaultedOptions);
  ensurePreventErrorBoundaryRetry(defaultedOptions, errorResetBoundary);
  useClearResetErrorBoundary(errorResetBoundary);
  const [observer] = react.useState(() => new Observer(queryClient, defaultedOptions));
  const result = observer.getOptimisticResult(defaultedOptions);
  (0,useSyncExternalStore/* useSyncExternalStore */.$)(react.useCallback(onStoreChange => isRestoring ? () => undefined : observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)), [observer, isRestoring]), () => observer.getCurrentResult(), () => observer.getCurrentResult());
  react.useEffect(() => {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (shouldSuspend(defaultedOptions, result, isRestoring)) {
    throw fetchOptimistic(defaultedOptions, observer, errorResetBoundary);
  } // Handle error boundary


  if (getHasError({
    result,
    errorResetBoundary,
    useErrorBoundary: defaultedOptions.useErrorBoundary,
    query: observer.getCurrentQuery()
  })) {
    throw result.error;
  } // Handle result property usage tracking


  return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


//# sourceMappingURL=useBaseQuery.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs



function useQuery(arg1, arg2, arg3) {
  const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}


//# sourceMappingURL=useQuery.mjs.map


/***/ }),

/***/ 464:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useSyncExternalStore; }
/* harmony export */ });
/* harmony import */ var use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61688);


// Temporary workaround due to an issue with react-native uSES - https://github.com/TanStack/query/pull/3601
const useSyncExternalStore = use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore;


//# sourceMappingURL=useSyncExternalStore.mjs.map


/***/ }),

/***/ 24798:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ shouldThrowError; }
/* harmony export */ });
function shouldThrowError(_useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary(...params);
  }

  return !!_useErrorBoundary;
}


//# sourceMappingURL=utils.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(59266), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);